/*
* picasso.js v2.8.2
* Copyright (c) 2025 QlikTech International AB
* Released under the MIT license.
*/


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

var extend$1 = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

var about = {
  version: '2.8.2'
};

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

/* global navigator */
function detectTouchSupport(e) {
  if ('ontouchstart' in e && 'ontouchend' in e || navigator.maxTouchPoints > 1) {
    return true;
  }
  return false;
}
function isTouchEvent(e) {
  return !!e.changedTouches;
}
function isValidTapEvent(e, eventInfo) {
  const isTouch = isTouchEvent(e);
  const ee = isTouch ? e.changedTouches[0] : e;
  const dt = Date.now() - eventInfo.time;
  const dx = isNaN(eventInfo.x) ? 0 : Math.abs(ee.clientX - eventInfo.x);
  const dy = isNaN(eventInfo.y) ? 0 : Math.abs(ee.clientY - eventInfo.y);
  return (e.button === 0 || isTouch) && !eventInfo.multiTouch && dx <= 12 && dy <= 12 && dt <= 300;
}

function isNumber(v) {
  return typeof v === 'number' && !isNaN(v);
}
function notNumber(value) {
  return typeof value !== 'number' || isNaN(value);
}

function getMinMax$1(points) {
  const num = points.length;
  let xMin = NaN;
  let xMax = NaN;
  let yMin = NaN;
  let yMax = NaN;
  for (let i = 0; i < num; i++) {
    xMin = isNaN(xMin) ? points[i].x : Math.min(xMin, points[i].x);
    xMax = isNaN(xMax) ? points[i].x : Math.max(xMax, points[i].x);
    yMin = isNaN(yMin) ? points[i].y : Math.min(yMin, points[i].y);
    yMax = isNaN(yMax) ? points[i].y : Math.max(yMax, points[i].y);
  }
  return [xMin, yMin, xMax, yMax];
}

/**
 * @ignore
 * @param {oject} line
 * @returns {Point[]} Array of points
 */
function lineToPoints(line) {
  const x1 = line.x1 || 0;
  const y1 = line.y1 || 0;
  const x2 = line.x2 || 0;
  const y2 = line.y2 || 0;
  return [{
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  }];
}

/**
 * @ignore
 * @param {oject} rect
 * @returns {Point[]} Array of points
 */
function rectToPoints(rect) {
  return [{
    x: rect.x,
    y: rect.y
  }, {
    x: rect.x + rect.width,
    y: rect.y
  }, {
    x: rect.x + rect.width,
    y: rect.y + rect.height
  }, {
    x: rect.x,
    y: rect.y + rect.height
  }];
}
function pointsToRect(points) {
  const [xMin, yMin, xMax, yMax] = getMinMax$1(points);
  return {
    x: xMin,
    y: yMin,
    width: xMax - xMin,
    height: yMax - yMin
  };
}
function pointsToCircle(points, r) {
  return {
    cx: points[0].x,
    cy: points[0].y,
    r
  };
}
function pointsToLine(points) {
  return {
    x1: points[0].x,
    y1: points[0].y,
    x2: points[1].x,
    y2: points[1].y
  };
}

/**
 * @ignore
 * @param {oject}
 * @returns {string} Type of geometry
 */
function getShapeType(shape) {
  const {
    x,
    y,
    // Point
    width,
    height,
    // Rect
    x1,
    x2,
    y1,
    y2,
    // Line
    cx,
    cy,
    r,
    // Circle
    vertices // Polygon or GeoPolygon
  } = shape || {};
  if (isNumber(cx) && isNumber(cy) && isNumber(r)) {
    return 'circle';
  }
  if (isNumber(x1) && isNumber(x2) && isNumber(y1) && isNumber(y2)) {
    return 'line';
  }
  if (isNumber(x) && isNumber(y) && isNumber(width) && isNumber(height)) {
    return 'rect';
  }
  if (isNumber(x) && isNumber(y)) {
    return 'point';
  }
  if (Array.isArray(vertices)) {
    return vertices.every(item => Array.isArray(item)) ? 'geopolygon' : 'polygon';
  }
  return null;
}
function expandRect(size, rect) {
  return {
    x: rect.x - size,
    y: rect.y - size,
    width: rect.width + size,
    height: rect.height + size
  };
}

// import types from './types';

/**
 * @ignore
 * @param {Array<DataSource>} dataSources
 * @param {any} { logger }
 * @returns {function}
 */
function datasets(dataSources, _ref) {
  let {
    types,
    logger
  } = _ref;
  const data = {};
  const sets = [];
  if (!Array.isArray(dataSources)) {
    logger.warn('Deprecated: "data-source" configuration"');
    sets.push(dataSources);
  } else {
    sets.push(...dataSources);
  }
  sets.forEach((d, i) => {
    let datasetFactory = types(d.type);
    if (datasetFactory) {
      let key = d.key;
      if (typeof d.key === 'undefined') {
        logger.warn("Missing key for dataset. Using index '".concat(i, "' as key."));
        key = i;
      }
      let dataset = datasetFactory({
        key,
        data: d.data,
        config: d.config
      });
      data[key] = dataset;
    }
  });

  /**
   * Returns the `dataset` which has `key` as identifier
   * @ignore
   * @param {string} key - The dataset identifier
   * @returns {Dataset}
   */
  const fn = key => {
    if (key) {
      return data[key];
    }
    return data[Object.keys(data)[0]];
  };
  return fn;
}

/**
 * @typedef {object} DataSource
 * @property {string=} key - Unique identifier for this data source
 * @property {string} type - The dataset type
 * @property {any} data - Data
 */

var pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon$1 = 1e-6,
    tauEpsilon = tau$1 - epsilon$1;

function Path$1() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path$1;
}

Path$1.prototype = path.prototype = {
  constructor: Path$1,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$1 + tau$1;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function constant$2(x) {
  return function constant() {
    return x;
  };
}

var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$2(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x$1(p) {
  return p[0];
}

function y$1(p) {
  return p[1];
}

function line$2() {
  var x = x$1,
      y = y$1,
      defined = constant$2(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$2(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$2(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function area() {
  var x0 = x$1,
      x1 = null,
      y0 = constant$2(0),
      y1 = y$1,
      defined = constant$2(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line$2().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

function descending$1(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function identity$2(d) {
  return d;
}

function pie$1() {
  var value = identity$2,
      sortValues = descending$1,
      sort = null,
      startAngle = constant$2(0),
      endAngle = constant$2(tau),
      padAngle = constant$2(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : padAngle;
  };

  return pie;
}

var slice = Array.prototype.slice;

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$3(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function curveBasis(context) {
  return new Basis(context);
}

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$2(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCardinal = (function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function point$1(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$1(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCatmullRom = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

function curveNatural(context) {
  return new Natural(context);
}

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

function curveStep(context) {
  return new Step(context, 0.5);
}

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

function stackOffsetNone(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function stackOrderNone(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stack() {
  var keys = constant$2([]),
      order = stackOrderNone,
      offset = stackOffsetNone,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$2(slice.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? stackOrderNone : typeof _ === "function" ? _ : constant$2(slice.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? stackOffsetNone : _, stack) : offset;
  };

  return stack;
}

function stackOffsetExpand(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  stackOffsetNone(series, order);
}

function stackOffsetDiverging(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
}

function stackOffsetSilhouette(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  stackOffsetNone(series, order);
}

function stackOffsetWiggle(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  stackOffsetNone(series, order);
}

function appearance(series) {
  var peaks = series.map(peak);
  return stackOrderNone(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
}

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}

function stackOrderAscending(series) {
  var sums = series.map(sum);
  return stackOrderNone(series).sort(function(a, b) { return sums[a] - sums[b]; });
}

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

function stackOrderInsideOut(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum),
      order = appearance(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
}

function stackOrderReverse(series) {
  return stackOrderNone(series).reverse();
}

function registryFactory(parentRegistry) {
  let registerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unspecified';
  let logger = arguments.length > 2 ? arguments[2] : undefined;
  let defaultValue;
  const reg = {};
  const parent = parentRegistry || {
    get: () => undefined,
    has: () => false,
    default: () => undefined
  };
  defaultValue = parent.default();

  /**
   * @private
   * @param {string} key
   * @param {any} value
   * @throws {TypeError} Key must be a non-empty string
   * @returns {boolean} False if the given key already exists, true otherwise
   * @example
   * var r = registry();
   * r.add( "marker", function(args) {
   *   return new markers[args.type](args);
   * });
   *
   */
  function add(key, value) {
    if (!key || typeof key !== 'string') {
      throw new TypeError('Invalid argument: key must be a non-empty string');
    }
    if (key in reg) {
      return false;
    }
    reg[key] = value;
    return true;
  }
  function get(key) {
    return reg[key] || parent.get(key);
  }
  function has(key) {
    return !!reg[key] || parent.has(key);
  }
  function remove(key) {
    const d = reg[key];
    delete reg[key];
    return d;
  }
  function getKeys() {
    return Object.keys(reg);
  }
  function getValues() {
    return Object.keys(reg).map(key => reg[key]);
  }
  function deflt(d) {
    if (typeof d !== 'undefined') {
      defaultValue = d;
    }
    return defaultValue;
  }

  /**
   * Register a `value` with the given `key`. If `value` is omitted, returns the `value` of `key`.
   * @alias registry
   * @param {string} key Name of the type to register
   * @param {any} [value] Value to store in the registry.
   * @returns {any} Registered value
   */
  function registry(key, value) {
    if (typeof value !== 'undefined') {
      return add(key, value);
    }
    const ret = get(key);
    if (logger && typeof ret === 'undefined') {
      logger.warn("".concat(key, " does not exist in ").concat(registerName, " registry"));
    }
    return ret || get(defaultValue);
  }
  registry.add = add;
  registry.get = get;
  registry.has = has;
  registry.remove = remove;
  registry.getKeys = getKeys;
  registry.getValues = getValues;
  registry.default = deflt;
  registry.register = add; // deprecated

  return registry;
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity$1(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale$1(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$1 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$1 : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;
var format;
var formatPrefix;

defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = formatLocale$1(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function formatter$1(pattern, thousand, decimal) {
  let locale, d3format;

  /**
   * Format a value according to the specified pattern created at construct
   * @private
   *
   * @param  {Number} value   The number to be formatted
   * @return {String}         [description]
   */
  function format(value) {
    return d3format(value);
  }

  /**
   * Set the locale for the formatter
   *
   * @param  {Object} args   Locale object for formatting
   * @return {Undefined}      Returns nothing
   */
  format.locale = function localeFn(settings) {
    locale = formatLocale$1(settings);
    d3format = locale.format(pattern);
    return this;
  };

  /**
   * Resets the formatter using format.locale
   * @ignore
   */
  function reset() {
    format.locale({
      decimal: decimal || '.',
      thousands: thousand || ',',
      grouping: [3],
      currency: ['$', '']
    });
  }
  reset();

  /**
   * Format a value according to a specific pattern
   * that is not the one specified in the constructor
   *
   * @param  {String} p   Pattern
   * @param  {Number} v   Value
   * @param  {String} t   Thousand
   * @param  {String} d   Decimal
   * @return {String}     Formatted value
   */
  format.format = function formatFn(p, v, t, d) {
    if (t || d) {
      thousand = t;
      decimal = d;
      reset();
    }
    return locale.format(p)(v);
  };

  /**
   * Change the pattern on existing formatter
   *
   * @param  {String} p     Pattern (optional)
   * @return {String}       Returns the pattern
   */
  format.pattern = function patternFn(p) {
    if (p) {
      pattern = p;
      d3format = locale.format(p);
    }
    return pattern;
  };
  return format;
}

const t0 = new Date, t1 = new Date;

function timeInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = (date) => {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = (date) => {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = (date) => {
    const d0 = interval(date), d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = (date, step) => {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = (start, stop, step) => {
    const range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    let previous;
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = (test) => {
    return timeInterval((date) => {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, (date, step) => {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = (start, end) => {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? (d) => field(d) % step === 0
              : (d) => interval.count(0, d) % step === 0);
    };
  }

  return interval;
}

const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;

const timeDay = timeInterval(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  date => date.getDate() - 1
);

timeDay.range;

const utcDay = timeInterval((date) => {
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCDate(date.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date) => {
  return date.getUTCDate() - 1;
});

utcDay.range;

const unixDay = timeInterval((date) => {
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCDate(date.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date) => {
  return Math.floor(date / durationDay);
});

unixDay.range;

function timeWeekday(i) {
  return timeInterval((date) => {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setDate(date.getDate() + step * 7);
  }, (start, end) => {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);

timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;

function utcWeekday(i) {
  return timeInterval((date) => {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, (start, end) => {
    return (end - start) / durationWeek;
  });
}

const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);

utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

const timeYear = timeInterval((date) => {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, (date, step) => {
  date.setFullYear(date.getFullYear() + step);
}, (start, end) => {
  return end.getFullYear() - start.getFullYear();
}, (date) => {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
timeYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date) => {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

timeYear.range;

const utcYear = timeInterval((date) => {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end) => {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, (date) => {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date) => {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

utcYear.range;

function ascending(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function descending(a, b) {
  return a == null || b == null ? NaN
    : b < a ? -1
    : b > a ? 1
    : b >= a ? 0
    : NaN;
}

function bisector(f) {
  let compare1, compare2, delta;

  // If an accessor is specified, promote it to a comparator. In this case we
  // can test whether the search value is (self-) comparable. We can’t do this
  // for a comparator (except for specific, known comparators) because we can’t
  // tell if the comparator is symmetric, and an asymmetric comparator can’t be
  // used to test whether a single value is comparable.
  if (f.length !== 2) {
    compare1 = ascending;
    compare2 = (d, x) => ascending(f(d), x);
    delta = (d, x) => f(d) - x;
  } else {
    compare1 = f === ascending || f === descending ? f : zero$1;
    compare2 = f;
    delta = f;
  }

  function left(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }

  function right(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }

  function center(a, x, lo = 0, hi = a.length) {
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function zero$1() {
  return 0;
}

function number$2(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$2).center;
var bisect = bisectRight;

class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, {_intern: {value: new Map()}, _key: {value: key}});
    if (entries != null) for (const [key, value] of entries) this.set(key, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}

function intern_get({_intern, _key}, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}

function intern_set({_intern, _key}, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}

function intern_delete({_intern, _key}, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}

function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

const e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function tickSpec(start, stop, count) {
  const step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log10(step)),
      error = step / Math.pow(10, power),
      factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i2 / inc > stop) --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i2 * inc > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
  return [i1, i2, inc];
}

function ticks(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  if (!(count > 0)) return [];
  if (start === stop) return [start];
  const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
  if (!(i2 >= i1)) return [];
  const n = i2 - i1 + 1, ticks = new Array(n);
  if (reverse) {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) / -inc;
    else for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) * inc;
  } else {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) / -inc;
    else for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) * inc;
  }
  return ticks;
}

function tickIncrement(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  return tickSpec(start, stop, count)[2];
}

function tickStep(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

function range(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad$2(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad$2(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad$2(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad$2(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad$2(1 + timeDay.count(timeYear(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad$2(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad$2(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad$2(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad$2(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad$2(timeSunday.count(timeYear(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? timeThursday(d) : timeThursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad$2(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad$2(timeMonday.count(timeYear(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad$2(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad$2(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad$2(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? timeThursday(d) : timeThursday.ceil(d);
  return pad$2(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad$2(z / 60 | 0, "0", 2)
      + pad$2(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad$2(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad$2(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad$2(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad$2(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad$2(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad$2(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad$2(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad$2(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad$2(utcSunday.count(utcYear(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad$2(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad$2(utcMonday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad$2(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad$2(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

function formatter(pattern) {
  // eslint-disable-line import/prefer-default-export
  let locale = formatLocale({
    dateTime: '%x, %X',
    date: '%-m/%-d/%Y',
    time: '%-I:%M:%S %p',
    periods: ['AM', 'PM'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  });
  let d3format = locale.format(pattern);

  /**
   * Format a value according to the specified pattern created at construct
   *
   * @param  {Date} value   The number to be formatted
   * @return {String}         [description]
   * @private
   */
  function format(value) {
    return d3format(value);
  }

  /**
   * Format a value according to a specific pattern
   * that is not the one specified in the constructor
   *
   * @param  {String} p   Pattern
   * @param  {Date} v   Value
   * @return {String}     Formatted value
   */
  format.format = function formatFn(p, v) {
    return locale.format(p)(v);
  };

  /**
   * Set the locale for the formatter
   *
   * @param  {Object} args   Locale object for formatting
   * @return {Undefined}      Returns nothing
   */
  format.locale = function localeFn() {
    locale = formatLocale(...arguments);
    d3format = locale.format(pattern);
    return this;
  };

  /**
   * Parse a string to a date according to a pattern
   *
   * @param  {String} p   Pattern
   * @param  {String} v   Value
   * @return {Date}     Date
   */
  format.parse = function parse(p, v) {
    return locale.parse(p)(v);
  };

  /**
   * Returns a parser that parses strings to date according to the pattern
   *
   * @param  {String} p   Pattern
   * @return {Function}   Parser
   */
  format.parsePattern = function parsePattern(p) {
    return locale.parse(p);
  };
  return format;
}

/**
 * @typedef {function} formatter
 * @returns {any} Returns a formatted value
 */

/**
 * @typedef {object} FormatterDefinition
 * @property {string} [formatter] Name of the formatter
 * @property {string} [type] Type of formatter
 * @property {string} [format] Format string
 * @property {DataExtraction|DataFieldExtraction} [data] The data to create formatter from
 */

const formatterRegistry = registryFactory();
formatterRegistry('d3-number', formatter$1);
formatterRegistry('d3-time', formatter);

/* eslint no-return-assign: 0 */

// TODO - decide whether usage of .call() is appropriate when invoking accessors, if yes then arrow functions are not allowed!

const getFormatter$1 = data => {
  if (typeof data.formatter === 'function') {
    return data.formatter();
  }
  const f = data.formatter || {};
  return formatterRegistry(f.type || 'd3-number')(f.format || '');
};
const accessors = {
  id: data => "".concat(data.source, "/").concat(data.key || data.title),
  key: data => String(data.key || data.title),
  tags: data => data.tags,
  min: data => data.min,
  max: data => data.max,
  type: data => data.type,
  title: data => String(data.title),
  values: data => data.values,
  value: v => v,
  label: v => v,
  formatter: data => getFormatter$1(data)
};

/**
 * Create a new field with default settings
 * @ignore
 * @return {Field} Data field
 */
function field(data) {
  let {
    id = accessors.id,
    key = accessors.key,
    min = accessors.min,
    max = accessors.max,
    type = accessors.type,
    tags = accessors.tags,
    title = accessors.title,
    values = accessors.values,
    value = accessors.value,
    label = accessors.label,
    formatter = accessors.formatter
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  /**
   * @alias Field
   */
  const f = {
    /**
     * Returns this field's id
     * @returns {string}
     */
    id: () => id(data),
    /**
     * Returns this field's key
     * @returns {string}
     */
    key: () => key(data),
    /**
     * Returns the input data
     * @returns {any}
     */
    raw: () => data,
    /**
     * Returns the tags.
     * @return {Array<string>}
     */
    tags: () => tags(data),
    /**
     * Returns this field's type: 'dimension' or 'measure'.
     * @return {string}
     */
    type: () => type(data),
    /**
     * Returns the min value of this field.
     * @return {number}
     */
    min: () => min(data),
    /**
     * Returns the max value of this field.
     * @return {number}
     */
    max: () => max(data),
    /**
     * Returns this field's title.
     * @return {string}
     */
    title: () => title(data),
    /**
     * Returns the values of this field.
     * @return {Array<DatumExtract>}
     */
    items: () => values(data),
    /**
     * Returns a formatter adapted to the content of this field.
     */
    formatter: () => formatter(data),
    value,
    label
  };
  return f;
}

function findField(query, _ref) {
  let {
    cache
  } = _ref;
  if (typeof query === 'number') {
    return cache.fields[query];
  }

  // Find by key first
  for (let i = 0; i < cache.fields.length; i++) {
    if (cache.fields[i].key() === query) {
      return cache.fields[i];
    }
  }
  // find by title
  for (let i = 0; i < cache.fields.length; i++) {
    if (cache.fields[i].title() === query) {
      return cache.fields[i];
    }
  }
  return null;
}
const filters$1 = {
  numeric: values => values.filter(v => typeof v === 'number' && !isNaN(v))
};
const unfilteredReducers = {
  sum: values => values.reduce((a, b) => a + b, 0)
};

// function isPrimitive(x) {
//   const type = typeof x;
//   return (type !== 'object' && type !== 'function');
// }

/**
 * [reducers description]
 * @type {Object}
 * @private
 */
const reducers = {
  first: values => values[0],
  last: values => values[values.length - 1],
  min: values => {
    const filtered = filters$1.numeric(values);
    return !filtered.length ? NaN : Math.min.apply(null, filtered);
  },
  max: values => {
    const filtered = filters$1.numeric(values);
    return !filtered.length ? NaN : Math.max.apply(null, filtered);
  },
  sum: values => {
    const filtered = filters$1.numeric(values);
    return !filtered.length ? NaN : filtered.reduce((a, b) => a + b, 0);
  },
  avg: values => {
    const filtered = filters$1.numeric(values);
    const len = filtered.length;
    return !len ? NaN : unfilteredReducers.sum(filtered) / len;
  }
};
function normalizeProperties(cfg, dataset, dataProperties, main) {
  // console.log('======', cfg, main, dataset);
  const props = {};
  const mainField = main.field || (typeof cfg.field !== 'undefined' ? dataset.field(cfg.field) : null);
  Object.keys(dataProperties).forEach(key => {
    const pConfig = dataProperties[key];
    const prop = props[key] = {};
    if (['number', 'string', 'boolean'].indexOf(typeof pConfig) !== -1) {
      prop.type = 'primitive';
      prop.value = pConfig;
    } else if (typeof pConfig === 'function') {
      prop.type = 'function';
      prop.value = pConfig;
      prop.label = pConfig;
      prop.field = mainField;
    } else if (typeof pConfig === 'object') {
      if (pConfig.fields) {
        prop.fields = pConfig.fields.map(ff => normalizeProperties(cfg, dataset, {
          main: ff
        }, main).main);
      } else if (typeof pConfig.field !== 'undefined') {
        prop.type = 'field';
        prop.field = dataset.field(pConfig.field);
        prop.value = prop.field.value;
        prop.label = prop.field.label;
      } else if (mainField) {
        prop.value = mainField.value;
        prop.label = mainField.label;
        prop.field = mainField;
      }
      if (typeof pConfig.filter === 'function') {
        prop.filter = pConfig.filter;
      }
      if (typeof pConfig.value !== 'undefined') {
        prop.value = pConfig.value;
      }
      if (typeof pConfig.label !== 'undefined') {
        prop.label = pConfig.label;
      }
      if (typeof pConfig.reduce === 'function') {
        prop.reduce = pConfig.reduce;
      } else if (pConfig.reduce) {
        prop.reduce = reducers[pConfig.reduce];
      } else if (prop.field && prop.field.reduce) {
        prop.reduce = typeof prop.field.reduce === 'string' ? reducers[prop.field.reduce] : prop.field.reduce;
      }
      if (typeof pConfig.reduceLabel === 'function') {
        prop.reduceLabel = pConfig.reduceLabel;
      } else if (pConfig.reduceLabel) {
        prop.reduceLabel = reducers[pConfig.reduceLabel];
      } else if (prop.field && prop.field.reduceLabel) {
        prop.reduceLabel = typeof prop.field.reduceLabel === 'string' ? reducers[prop.field.reduceLabel] : prop.field.reduceLabel;
      }
    }
  });
  return props;
}

/*
example of configuration input
cfg = {
  field: 'State', // the 'top level' values are extracted from field state
  value: d => d.qText, // the value of the output
  props: { // additional data properties ammended to each item
    a: 3, // constant value
    b: d => d.qElemNumber, // function will receive the original field value
    c: {
      field: 'Country', // reference to another field
      value: d => d.qText // extract the qText value from the referenced field
    },
    d: {
      value: d => d.qRow //  extract qRow from field 'State'
    }
  }
}

// output
[{
  value: 'CA', source: { field: 'State' },
  a: { value: 3 },
  b: { value: 26, source: 'State' },
  c: { value: 'USA', source: 'Country' },
  d: { value: 131, source: 'State' }
},
...]
*/
function getPropsInfo(cfg, dataset) {
  // console.log('222', cfg);
  const {
    main
  } = normalizeProperties(cfg, dataset, {
    main: {
      value: cfg.value,
      label: cfg.label,
      reduce: cfg.reduce,
      filter: cfg.filter
    }
  }, {});
  const props = normalizeProperties(cfg, dataset, cfg.props || {}, main);
  return {
    props,
    main
  };
}
function collectItems(items, cfg, formatter, prop) {
  const values = Array(items.length);
  const labels = Array(items.length);
  let it;
  for (let i = 0; i < items.length; i++) {
    it = prop ? items[i][prop] : items[i];
    values[i] = it.value;
    labels[i] = it.label;
  }
  const reduce = cfg.reduce;
  const reduceLabel = cfg.reduceLabel;
  const v = reduce ? reduce(values) : values;
  const b = reduceLabel ? reduceLabel(labels, v) : formatter ? formatter(v) : String(v); // eslint-disable-line no-nested-ternary

  // // ret[prop].label = String(propsFormatters[prop](ret[prop].value));

  const ret = {
    value: v,
    label: b
  };
  if (prop && items[0][prop].source) {
    ret.source = items[0][prop].source;
    return ret;
  }
  if (!prop && items[0].source) {
    ret.source = items[0].source;
    return ret;
  }
  return ret;
}

// collect items that have been grouped and reduce per group and property
function collect(trackedItems, _ref2) {
  let {
    main,
    propsArr,
    props
  } = _ref2;
  let dataItems = [];
  const mainFormatter = main.field.formatter(); // || (v => v);
  const propsFormatters = {};
  propsArr.forEach(prop => {
    propsFormatters[prop] = props[prop].field ? props[prop].field.formatter() : v => v;
  });
  dataItems.push(...trackedItems.map(t => {
    const ret = collectItems(t.items, main, mainFormatter);
    propsArr.forEach(prop => {
      ret[prop] = collectItems(t.items, props[prop], propsFormatters[prop], prop);
    });
    return ret;
  }));
  return dataItems;
}
function track(_ref3) {
  let {
    cfg,
    itemData,
    obj,
    target,
    tracker,
    trackType
  } = _ref3;
  const trackId = trackType === 'function' ? cfg.trackBy(itemData) : itemData[cfg.trackBy];
  let trackedItem = tracker[trackId];
  if (!trackedItem) {
    trackedItem = tracker[trackId] = {
      items: [],
      id: trackId
    };
    target.push(trackedItem);
  }
  trackedItem.items.push(obj);
}
const ARRAY_MAX_SIZE = 10000;
function getMax(values) {
  if (values.length < ARRAY_MAX_SIZE) {
    return Math.max(...values);
  }
  let max = -Infinity;
  const len = values.length;
  for (let i = 0; i < len; i++) {
    if (max < values[i]) {
      max = values[i];
    }
  }
  return max;
}
function getMin(values) {
  if (values.length < ARRAY_MAX_SIZE) {
    return Math.min(...values);
  }
  let min = Infinity;
  const len = values.length;
  for (let i = 0; i < len; i++) {
    if (min > values[i]) {
      min = values[i];
    }
  }
  return min;
}

const OFFSETS = {
  diverging: stackOffsetDiverging,
  none: stackOffsetNone,
  silhouette: stackOffsetSilhouette,
  expand: stackOffsetExpand,
  wiggle: stackOffsetWiggle
};
const ORDERS = {
  ascending: stackOrderAscending,
  insideout: stackOrderInsideOut,
  none: stackOrderNone,
  reverse: stackOrderReverse
};
function stacked(data, config, ds) {
  const stackIds = {};
  const stackFn = config.stackKey;
  const valueFn = config.value;
  const startProp = config.startProp || 'start';
  const endProp = config.endProp || 'end';
  const offset = config.offset || 'none';
  const order = config.order || 'none';
  const valueRef = config.valueRef || '';
  let maxStackCount = 0;
  let valueFields = {};
  for (let i = 0; i < data.items.length; i++) {
    let p = data.items[i];
    let sourceField = valueRef ? p[valueRef] : null;
    if (sourceField && sourceField.source) {
      let ff = "".concat(sourceField.source.key || '', "/").concat(sourceField.source.field);
      if (!valueFields[ff]) {
        valueFields[ff] = sourceField.source;
      }
    }
    let sid = stackFn(p);
    stackIds[sid] = stackIds[sid] || {
      items: []
    };
    stackIds[sid].items.push(p);
    maxStackCount = Math.max(maxStackCount, stackIds[sid].items.length);
  }
  const keys = Array.apply(null, {
    length: maxStackCount
  }).map(Number.call, Number); // eslint-disable-line
  const matrix = Object.keys(stackIds).map(sid => stackIds[sid].items);
  const d3Stack = stack().keys(keys).value((s, key) => s[key] ? valueFn(s[key]) : 0).order(ORDERS[order]).offset(OFFSETS[offset]);
  let series = d3Stack(matrix);
  let values = [];
  for (let i = 0; i < series.length; i++) {
    let serie = series[i];
    for (let s = 0; s < serie.length; s++) {
      let range = serie[s];
      let item = serie[s].data[serie.key];
      if (!item) {
        continue;
      }
      item[startProp] = {
        value: range[0]
      };
      item[endProp] = {
        value: range[1]
      };
      values.push(range[0], range[1]);
    }
  }
  let stackedFields = Object.keys(valueFields).map(f => {
    let dSource = ds(valueFields[f].key);
    return dSource ? dSource.field(valueFields[f].field) : null;
  }).filter(f => !!f);
  const field$1 = field({
    title: stackedFields.map(f => f.title()).join(', '),
    min: getMin(values),
    max: getMax(values),
    type: 'measure',
    formatter: stackedFields[0] ? stackedFields[0].formatter : undefined
  });
  data.fields.push(field$1);
}

function extract$1(dataConfig) {
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let extracted = {
    // items: [],
    // fields: [],
    // source: null,
    // value: null,
    // label: null,
    // children: null,
    // root: null,
    // graph: null
  };
  const logger = opts.logger;
  if (Array.isArray(dataConfig)) {
    // if data is an array, assume it's manual data input -> normalize
    extracted.items = dataConfig.map(v => ({
      value: v,
      label: String(v)
    }));
  } else if (dataConfig) {
    if ('collection' in dataConfig) {
      extracted = _objectSpread2({}, data.collection(dataConfig.collection));
    } else {
      const source = data.dataset ? data.dataset(dataConfig.source) : null;
      let valueFn = dataConfig.value || (d => d);
      let labelFn = dataConfig.label || (d => d);
      if (dataConfig.groupBy || dataConfig.mapTo) {
        // DEPRECATION
        logger.warn('Deprecated "data" configuration', dataConfig);
        extracted.items = [];
      } else if (dataConfig.hierarchy) {
        extracted.root = source.hierarchy ? source.hierarchy(dataConfig.hierarchy) : null;
        extracted.fields = source.fields();
      } else if (dataConfig.items) {
        extracted.items = dataConfig.skipNormalize ? dataConfig.items : dataConfig.items.map(v => ({
          value: valueFn(v),
          label: String(labelFn(v))
        }));
      } else if (dataConfig.extract) {
        const extractionsConfigs = Array.isArray(dataConfig.extract) ? dataConfig.extract : [dataConfig.extract];
        extracted.items = [];
        const sourceFields = [];
        extractionsConfigs.forEach(cfg => {
          const s = cfg.source ? data.dataset(cfg.source) : source;
          if (!s) {
            return;
          }
          extracted.items = [...extracted.items, ...s.extract(cfg)];
          if (typeof cfg.field !== 'undefined') {
            sourceFields.push(s.field(cfg.field));
          }
        });
        if (sourceFields.length) {
          extracted.fields = sourceFields;
        }
        if (dataConfig.amend && Array.isArray(dataConfig.amend)) {
          extracted.items = [...extracted.items, ...dataConfig.amend];
        }
      } else if (typeof dataConfig.field !== 'undefined' && source) {
        const f = source.field(dataConfig.field);
        if (f) {
          if (!extracted.fields) {
            extracted.fields = [];
          }
          extracted.fields.push(f);
          if (!('value' in dataConfig)) {
            valueFn = f.value || (v => v);
            labelFn = f.label || (v => v);
            extracted.value = valueFn;
          }
          extracted.items = f.items().map(v => ({
            value: valueFn(v),
            label: String(labelFn(v)),
            source: {
              field: dataConfig.field
            }
          }));
          // TODO - add source: { key: dataConfig.source, field: dataConfig.field, data: v }
        }
      } else if (dataConfig.fields) {
        dataConfig.fields.forEach(obj => {
          const s = typeof obj === 'object' && obj.source ? data.dataset(obj.source) : source;
          if (!s) {
            return;
          }
          let f;
          if (typeof obj === 'object' && typeof obj.field !== 'undefined') {
            f = s.field(obj.field);
          } else {
            f = s.field(obj);
          }
          if (f) {
            if (!extracted.fields) {
              extracted.fields = [];
            }
            extracted.fields.push(f);
          }
        });
      }
      if (extracted.items && dataConfig.map) {
        extracted.items = extracted.items.map(dataConfig.map);
      }
    }
    if (dataConfig && dataConfig.stack) {
      stacked(extracted, dataConfig.stack, data.dataset);
    }
  }
  if (dataConfig && !Array.isArray(dataConfig) && typeof dataConfig.filter === 'function' && extracted.items) {
    extracted.items = extracted.items.filter(dataConfig.filter);
  }
  if (dataConfig && !Array.isArray(dataConfig) && typeof dataConfig.sort === 'function' && extracted.items) {
    extracted.items = extracted.items.sort(dataConfig.sort);
  }
  return extracted;
}

/**
 * @interface CollectionSettings
 * @property {string} key Unique key for the collection
 * @property {DataExtraction} data Data configuration
 * @example
 * {
    key: 'my-collection',
    data: {
      extract: [{
        source: 'Products',
        field: 'Product',
        value: d => d.name,
        label: d => `<${d.name}>`
        props: {
          year: { field: 'Year' }
          num: { field: 'Sales' }
        }
      }],
      filter: d => d.label !== 'Sneakers', // extract everything except Sneakers
      sort: (a, b) => a.label > b.label ? -1 : 1, // sort descending
    }
 * }
 */

function create$p(config, d, opts) {
  let extractor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : extract$1;
  const collections = {};
  (config || []).forEach(cfg => {
    if (!cfg.key) {
      throw new Error('Data collection is missing "key" property');
    }
    if (typeof cfg.data === 'object' && 'collection' in cfg.data) {
      throw new Error('Data config for collections may not reference other collections');
    }
    collections[cfg.key] = () => extractor(cfg.data, d, opts);
  });
  const fn = key => {
    let k;
    let cfg;
    if (typeof key === 'string') {
      k = key;
    } else if (typeof key === 'object') {
      k = key.key;
      cfg = key;
    }
    if (!(k in collections)) {
      throw new Error("Unknown data collection: ".concat(k));
    }
    if (typeof collections[k] === 'function') {
      collections[k] = collections[k]();
    }
    let coll = collections[k];
    if (cfg) {
      if (cfg.fields && cfg.fields.filter) {
        let filtered = coll.fields.filter(cfg.fields.filter);
        if (coll.fields.length !== filtered.length) {
          coll = extend$1(coll, {
            fields: filtered
          });
        }
      }
    }
    return coll;
  };
  return fn;
}

function create$o(options, data, deps) {
  let extractor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : extract$1;
  if (options.data) {
    const d = extractor(options.data, data, deps);
    if (d && d.fields && d.fields[0]) {
      // TODO Have some magic to handle and merge formatters from multiple sources
      return d.fields[0].formatter();
    }
  }
  let formatterType;
  if (options.formatter) {
    formatterType = "".concat(options.formatter, "-").concat(options.type || 'number');
  } else {
    formatterType = options.type || 'd3-number';
  }
  if (deps.formatter.has(formatterType)) {
    const f = deps.formatter.get(formatterType)(options.format || '');
    return f;
  }
  throw new Error("Formatter of type '".concat(formatterType, "' was not found"));
}
function collection$1(formattersConfig, data, deps) {
  let fn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : create$o;
  const formatters = {};
  return {
    get(def) {
      let key;
      if (typeof def === 'string' && formattersConfig[def]) {
        key = def;
      } else if (typeof def === 'object' && 'formatter' in def && formattersConfig[def.formatter]) {
        key = def.formatter;
      } else if (typeof def === 'object' && 'type' in def && formattersConfig[def.type]) {
        key = def.type;
      }
      if (key) {
        formatters[key] = formatters[key] || fn(formattersConfig[key], data, deps);
        return formatters[key];
      }
      return fn(def || {}, data, deps);
    },
    all() {
      Object.keys(formattersConfig).forEach(this.get);
      return formatters;
    }
  };
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

const implicit = Symbol("implicit");

function ordinal$1() {
  var index = new InternMap(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    let i = index.get(d);
    if (i === undefined) {
      if (unknown !== implicit) return unknown;
      index.set(d, i = domain.push(d) - 1);
    }
    return range[i % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new InternMap();
    for (const value of _) {
      if (index.has(value)) continue;
      index.set(value, domain.push(value) - 1);
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal$1(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal$1().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = range(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), [r0, r1])
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`),
    reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`),
    reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`),
    reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`),
    reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`),
    reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHex8() {
  return this.rgb().formatHex8();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb$1, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}

function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}

function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}

function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}

function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}

function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));

function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}

function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant$1 = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$1(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$1(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray$1(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray$1(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolate$1(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function number$1(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object$1(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate$1(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: number$1(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate$1(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$1(b)
      : (t === "number" ? number$1
      : t === "string" ? ((c = color(b)) ? (b = c, rgb) : string)
      : b instanceof color ? rgb
      : b instanceof Date ? date
      : isNumberArray$1(b) ? numberArray
      : Array.isArray(b) ? genericArray$1
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object$1
      : number$1)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function constants(x) {
  return function() {
    return x;
  };
}

function number(x) {
  return +x;
}

var unit = [0, 1];

function identity(x) {
  return x;
}

function normalize$1(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize$1(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize$1(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize$1(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = interpolate$1,
      transform,
      untransform,
      unknown,
      clamp = identity,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), number$1)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer()(identity, identity);
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

function applyFormat(formatter) {
  return typeof formatter === 'undefined' ? t => t : t => formatter(t);
}
function clamp$1(val) {
  return Math.max(0, Math.min(1, val));
}
function isObject(obj) {
  return typeof obj === 'object';
}
function minorTicksGenerator(count, start, end) {
  const r = Math.abs(start - end);
  const interval = r / (count + 1);
  const ticks = [];
  for (let i = 1; i <= count; i++) {
    const v = i * interval;
    ticks.push(start < end ? start + v : start - v);
  }
  return ticks;
}
function appendMinorTicks(majorTicks, minorCount, scale) {
  if (majorTicks.length === 1) {
    return majorTicks;
  }
  const ticks = majorTicks.concat([]);
  for (let i = 0; i < majorTicks.length; i++) {
    let start = majorTicks[i];
    let end = majorTicks[i + 1];
    if (i === 0 && start !== scale.start()) {
      // Before and after first major tick
      ticks.push(...minorTicksGenerator(minorCount, start, end));
      start -= end - start;
      end = majorTicks[i];
      ticks.push(...minorTicksGenerator(minorCount, start, end));
    } else if (i === majorTicks.length - 1 && end !== scale.end()) {
      // After last major tick
      end = start + (start - majorTicks[i - 1]);
      ticks.push(...minorTicksGenerator(minorCount, start, end));
    } else {
      ticks.push(...minorTicksGenerator(minorCount, start, end));
    }
  }
  return ticks.filter(t => t >= scale.min() && t <= scale.max());
}

/**
 * Generate ticks based on a distance, for each 100th unit, one additional tick may be added
 * @private
 * @param  {Number} distance       Distance between each tick
 * @param  {Number} scale         The scale instance
 * @param  {Number} [minorCount=0]     Number of tick added between each distance
 * @param  {Number} [unitDivider=100]   Number to divide distance with
 * @return {Array}               Array of ticks
 */
function looseDistanceBasedGenerator(_ref) {
  let {
    distance,
    scale,
    minorCount = 0,
    unitDivider = 100,
    formatter = undefined
  } = _ref;
  const step = !notNumber(unitDivider) && !notNumber(distance) ? Math.max(distance / unitDivider, 2) : 2;
  const count = Math.min(1000, Math.round(step)); // safe guard against huge numbers
  let majorTicks = scale.ticks(count);
  if (majorTicks.length <= 1) {
    majorTicks = scale.ticks(count + 1);
  }
  const ticks = minorCount > 0 ? appendMinorTicks(majorTicks, minorCount, scale) : majorTicks;
  ticks.sort((a, b) => a - b);
  const ticksFormatted = ticks.map(applyFormat(formatter));
  return ticks.map((tick, i) => {
    const position = scale(tick);
    return {
      position,
      start: position,
      end: position,
      label: ticksFormatted[i],
      value: tick,
      isMinor: majorTicks.indexOf(tick) === -1
    };
  });
}

/**
 * Generate ticks based on a distance, for each 100th unit, one additional tick may be added.
 * Will attempt to round the bounds of domain to even values and generate ticks hitting the domain bounds.
 * @private
 * @param  {Number} distance       Distance between each tick
 * @param  {Number} scale         The scale instance
 * @param  {Number} [minorCount=0]     Number of tick added between each distance
 * @param  {Number} [unitDivider=100]   Number to divide distance with
 * @return {Array}               Array of ticks
 */
function tightDistanceBasedGenerator(_ref2) {
  let {
    distance,
    scale,
    minorCount = 0,
    unitDivider = 100,
    formatter = undefined
  } = _ref2;
  const step = !notNumber(unitDivider) && !notNumber(distance) ? Math.max(distance / unitDivider, 2) : 2;
  const count = Math.min(1000, Math.round(step)); // safe guard against huge numbers
  const n = count > 10 ? 10 : count;
  scale.nice(n);
  const majorTicks = scale.ticks(count);
  const ticks = minorCount > 0 ? appendMinorTicks(majorTicks, minorCount, scale) : majorTicks;
  ticks.sort((a, b) => a - b);
  const ticksFormatted = ticks.map(applyFormat(formatter));
  return ticks.map((tick, i) => {
    const position = scale(tick);
    return {
      position,
      start: position,
      end: position,
      label: ticksFormatted[i],
      value: tick,
      isMinor: majorTicks.indexOf(tick) === -1
    };
  });
}
function ticksByCount(_ref3) {
  let {
    count,
    minorCount,
    scale,
    formatter
  } = _ref3;
  return scale.ticks((count - 1) * minorCount + count).map((tick, i) => {
    const position = scale(tick);
    return {
      position,
      start: position,
      end: position,
      label: formatter(tick),
      isMinor: i % (minorCount + 1) !== 0,
      value: tick
    };
  });
}
function ticksByValue(_ref4) {
  let {
    values,
    scale,
    formatter = v => v
  } = _ref4;
  return values.sort((a, b) => (isObject(a) ? a.value : a) - (isObject(b) ? b.value : b)).filter((v, i, ary) => {
    const val = isObject(v) ? v.value : v;
    return val <= scale.max() && val >= scale.min() && ary.indexOf(v) === i;
  }).map(v => {
    const isObj = isObject(v);
    const value = isObj ? v.value : v;
    const position = scale(value);
    return {
      position,
      value,
      label: isObj && typeof v.label !== 'undefined' ? v.label : formatter(value),
      isMinor: isObj ? !!v.isMinor : false,
      start: isObj && !isNaN(v.start) ? clamp$1(scale(v.start)) : position,
      // TODOHandle end < start?
      end: isObj && !isNaN(v.end) ? clamp$1(scale(v.end)) : position // TODO Handle start > end?
    };
  });
}
function forceTicksAtBounds(ticks, scale, formatter) {
  const ticksP = ticks.map(t => t.position);
  const range = scale.range();
  if (ticksP.indexOf(range[0]) === -1) {
    ticks.splice(0, 0, {
      position: range[0],
      start: range[0],
      end: range[0],
      label: formatter(scale.start()),
      isMinor: false,
      value: scale.start()
    });
  } else if (ticks[0] && ticks[0].isMinor) {
    ticks[0].isMinor = false; // Convert to major tick
  }
  const lastTick = ticks[ticks.length - 1];
  if (ticksP.indexOf(range[1]) === -1) {
    ticks.push({
      position: range[1],
      start: range[1],
      end: range[1],
      label: formatter(scale.end()),
      isMinor: false,
      value: scale.end()
    });
  } else if (lastTick && lastTick.isMinor) {
    lastTick.isMinor = false; // Convert to major tick
  }
}
function generateContinuousTicks(_ref5) {
  let {
    settings,
    scale,
    distance,
    formatter = val => val
  } = _ref5;
  let ticks;
  const minorCount = settings.minorTicks && !notNumber(settings.minorTicks.count) ? Math.min(100, settings.minorTicks.count) : 0;
  if (Array.isArray(settings.ticks.values)) {
    const values = settings.ticks.values.filter(v => typeof v === 'object' ? !notNumber(v.value) : !notNumber(v));
    ticks = ticksByValue({
      values,
      scale: scale.copy(),
      formatter
    });
  } else if (!notNumber(settings.ticks.count)) {
    const count = Math.min(1000, settings.ticks.count);
    ticks = ticksByCount({
      count,
      minorCount,
      scale: scale.copy(),
      formatter
    });
  } else {
    const tickGen = settings.ticks.tight ? tightDistanceBasedGenerator : looseDistanceBasedGenerator;
    ticks = tickGen({
      distance,
      minorCount,
      unitDivider: settings.ticks.distance,
      scale,
      formatter
    });
    if (settings.ticks.forceBounds) {
      forceTicksAtBounds(ticks, scale, formatter);
    }
  }
  return ticks;
}
function generateDiscreteTicks(_ref6) {
  let {
    scale
  } = _ref6;
  const domain = scale.domain();
  const values = domain;
  const dataItems = scale.data().items;
  const labels = scale.labels ? scale.labels() : values;
  const bandwidth = scale.bandwidth();
  return values.map((d, i) => {
    const start = scale(d);
    return {
      position: start + bandwidth / 2,
      label: "".concat(labels[i]),
      data: dataItems ? dataItems[i] : undefined,
      start,
      end: start + bandwidth
    };
  });
}

function resolveSettings$2() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let defaultSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const stngs = {};
  Object.keys(defaultSettings).forEach(key => {
    const type = typeof settings[key];
    if (type === 'function') {
      stngs[key] = settings[key](context);
    } else if (type === 'undefined') {
      stngs[key] = defaultSettings[key];
    } else {
      stngs[key] = settings[key];
    }
  });
  return stngs;
}

const DEFAULT_SETTINGS$8 = {
  min: NaN,
  max: NaN,
  expand: NaN,
  include: [],
  invert: false
};
const DEFAULT_TICKS_SETTINGS$1 = {
  tight: false,
  forceBounds: false,
  values: undefined,
  count: NaN,
  distance: 100
};
const DEFAULT_MINORTICKS_SETTINGS = {
  count: NaN
};

/**
 * @typedef {object} ScaleLinear
 * @property {string} [type='linear']
 * @property {number} [expand] - Expand the output range
 * @property {boolean} [invert=false] - Invert the output range
 * @property {number[]} [include] - Include specified numbers in the output range
 * @property {object} [ticks]
 * @property {boolean} [ticks.tight = false]
 * @property {boolean} [ticks.forceBounds = false]
 * @property {number} [ticks.distance = 100]  - Approximate distance between each tick
 * @property {number[]|object[]} [ticks.values] - If set, ticks are no longer generated but instead equal to this set
 * @property {number} [ticks.count]
 * @property {object} [minorTicks]
 * @property {number} [minorTicks.count = 3]
 * @property {number} [min] - Set an explicit minimum value
 * @property {number} [max] - Set an explicit maximum value
 */

function getMinMax(settings, fields) {
  const min = +settings.min;
  const max = +settings.max;
  let fieldMin = 0;
  let fieldMax = 1;
  if (fields && fields[0]) {
    const minValues = fields.map(m => m.min()).filter(v => !isNaN(v));
    const maxValues = fields.map(m => m.max()).filter(v => !isNaN(v));
    fieldMin = minValues.length ? Math.min(...minValues) : Number.NaN;
    fieldMax = maxValues.length ? Math.max(...maxValues) : Number.NaN;
    if (isNaN(fieldMin) || isNaN(fieldMax)) {
      fieldMin = -1;
      fieldMax = 1;
    } else if (fieldMin === fieldMax && fieldMin === 0) {
      fieldMin = -1;
      fieldMax = 1;
    } else if (fieldMin === fieldMax && fieldMin) {
      fieldMin -= Math.abs(fieldMin * 0.1);
      fieldMax += Math.abs(fieldMax * 0.1);
    } else if (!isNaN(settings.expand)) {
      const range = fieldMax - fieldMin;
      fieldMin -= range * settings.expand;
      fieldMax += range * settings.expand;
    }
    if (Array.isArray(settings.include)) {
      const i = settings.include.filter(n => !isNaN(n));
      fieldMin = Math.min(...i, fieldMin);
      fieldMax = Math.max(...i, fieldMax);
    }
  }
  return {
    mini: !isNaN(min) ? min : fieldMin,
    maxi: !isNaN(max) ? max : fieldMax
  };
}
function initNormScale(normScale, scale) {
  if (normScale.instance) {
    return;
  }
  normScale.instance = scale.copy();
  normScale.instance.domain([scale.start(), scale.end()]);
  normScale.instance.clamp(true);
  normScale.instance.range(normScale.invert ? [1, 0] : [0, 1]);
}
/**
 * @alias scaleLinear
 * @private
 * @param { object } settings
 * @param { field[] } [fields]
 * @return { linear }
 */

function scaleLinear() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let resources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const d3Scale = linear();
  const normScale = {
    instance: null,
    invert: false
  };
  const ctx = {
    data,
    resources
  };
  const stgns = resolveSettings$2(settings, DEFAULT_SETTINGS$8, ctx);
  stgns.ticks = resolveSettings$2(settings.ticks, DEFAULT_TICKS_SETTINGS$1, ctx);
  stgns.minorTicks = resolveSettings$2(settings.minorTicks, DEFAULT_MINORTICKS_SETTINGS, ctx);
  let tickCache;

  /**
   * @alias linear
   * @private
   * @param { Object } value
   * @return { number }
   */
  function fn(v) {
    if (notNumber(v)) {
      return NaN;
    }
    return d3Scale(v);
  }
  fn.data = () => data;

  /**
   * {@link https://github.com/d3/d3-scale#continuous_invert }
   * @param { number } value The inverted value
   * @return { number } The inverted scaled value
   */
  fn.invert = function invert(value) {
    return d3Scale.invert(value);
  };

  /**
   * {@link https://github.com/d3/d3-scale#continuous_rangeRound }
   * @param { number[] } values Range values
   * @return { linear } The instance this method was called on
   */
  fn.rangeRound = function rangeRound(values) {
    d3Scale.rangeRound(values);
    return fn;
  };

  /**
   * {@link https://github.com/d3/d3-scale#continuous_clamp }
   * @param { boolean } [ value=true ] TRUE if clamping should be enabled
   * @return { linear } The instance this method was called on
   */
  fn.clamp = function clamp() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    d3Scale.clamp(value);
    return fn;
  };

  /**
   * Get cached ticks (if any)
   * @return { number | undefined }
   */
  fn.cachedTicks = function fnCachedTicks() {
    return tickCache;
  };

  /**
   * Clear the tick cache
   * @return {number | undefined}
   */
  fn.clearTicksCache = function fnClearTicks() {
    tickCache = undefined;
    return this;
  };

  /**
   * {@link https://github.com/d3/d3-scale#continuous_ticks }
   * @param { Object } input Number of ticks to generate or an object passed to tick generator
   * @return { number[] | Object } Array of ticks or any type the custom tick generator returns
   */
  fn.ticks = function ticks(input) {
    if (input !== null && typeof input === 'object') {
      input.settings = input.settings || {};
      // TODO Discontinue support for custom ticks settings as argument
      input.settings = extend$1(true, {}, stgns, input.settings);
      input.scale = fn;
      tickCache = generateContinuousTicks(input);
      return tickCache;
    }
    tickCache = d3Scale.ticks(input);
    return tickCache;
  };

  /**
   * {@link https://github.com/d3/d3-scale#continuous_nice }
   * @param { number } count
   * @return { linear } The instance this method was called on
   */
  fn.nice = function nice(count) {
    d3Scale.nice(count);
    return fn;
  };

  // TODO Support this?
  fn.tickFormat = function tickFormat(count, format) {
    return d3Scale.tickFormat(count, format);
  };

  // TODO Support this?
  fn.interpolate = function interpolate(func) {
    d3Scale.interpolate(func);
    return fn;
  };

  /**
   * @param { number[] } [values] Set or Get domain values
   * @return { linear | Number[] } The instance this method was called on if a parameter is provided, otherwise the current domain is returned
   */
  fn.domain = function domain(values) {
    if (arguments.length) {
      d3Scale.domain(values);
      if (normScale.instance) {
        normScale.instance.domain([fn.start(), fn.end()]);
      }
      return fn;
    }
    return d3Scale.domain();
  };

  /**
   * @param { number[] } [values] Set or Get range values
   * @return { linear | number[] } The instance this method was called on if a parameter is provided, otherwise the current range is returned
   */
  fn.range = function range(values) {
    if (arguments.length) {
      d3Scale.range(values);
      return fn;
    }
    return d3Scale.range();
  };

  /**
   * Get the first value of the domain
   * @return { number }
   */
  fn.start = function start() {
    return fn.domain()[0];
  };

  /**
   * Get the last value of the domain
   * @return { number }
   */
  fn.end = function end() {
    return fn.domain()[this.domain().length - 1];
  };

  /**
   * Get the minimum value of the domain
   * @return { number }
   */
  fn.min = function min() {
    return Math.min(this.start(), this.end());
  };

  /**
   * Get the maximum value of the domain
   * @return { number }
   */
  fn.max = function max() {
    return Math.max(this.start(), this.end());
  };

  /**
   * Divides the domain and range into uniform segments, based on start and end value
   * @param  { number } segments The number of segments
   * @return { function } The instance this method was called on
   * @example
   * let s = linear();
   * s.domain([0, 10]);
   * s.range([0, 1]);
   * s.classify( 2 );
   * s.domain(); // [10, 5, 5, 0]
   * s.range(); // [0.75, 0.75, 0.25, 0.25]
   */
  fn.classify = function classify(segments) {
    let valueRange = (fn.start() - fn.end()) / segments,
      domain = [fn.end()],
      range = [],
      samplePos = valueRange / 2;
    for (let i = 0; i < segments; i++) {
      let lastVal = domain[domain.length - 1] || 0,
        calIntervalPos = lastVal + valueRange,
        calSamplePos = lastVal + samplePos,
        sampleColValue = fn(calSamplePos);
      domain.push(...[calIntervalPos, calIntervalPos]);
      range.push(...[sampleColValue, sampleColValue]);
    }
    domain.pop();
    fn.domain(domain);
    fn.range(range);
    return fn;
  };
  fn.copy = function copy() {
    const cop = scaleLinear(settings, data, resources);
    cop.domain(fn.domain());
    cop.range(fn.range());
    cop.clamp(d3Scale.clamp());
    return cop;
  };

  /**
   * @param {number} d - A domain value
   * @return {number} A normalized range output given in range 0-1
   * @example
   * const scale = scaleLinear().domain([0, 10]).range([0, 10000]);
   * scale.norm(5); // Returns 0.5
   * scale(5); // Returns 5000
   *
   * scale.domain([0, 2, 10]);
   * scale.norm(5); // Returns 0.5
   */
  fn.norm = function norm(d) {
    initNormScale(normScale, fn);
    return normScale.instance(d);
  };

  /**
   * @param {number} d - A normalized value in range 0-1
   * @return {number} A corresponding domain value
   * @example
   * const scale = scaleLinear().domain([0, 10]).range([0, 10000]);
   * scale.normInvert(0.5); // Returns 5
   * scale.invert(5000); // Returns 5
   */
  fn.normInvert = function norm(t) {
    initNormScale(normScale, fn);
    return normScale.instance.invert(t);
  };
  const {
    mini,
    maxi
  } = getMinMax(stgns, data ? data.fields : []);
  fn.domain([mini, maxi]);
  fn.range(stgns.invert ? [1, 0] : [0, 1]);
  normScale.invert = stgns.invert;
  return fn;
}

const DEFAULT_SETTINGS$7 = {
  padding: 0,
  paddingInner: NaN,
  paddingOuter: NaN,
  align: 0.5,
  invert: false,
  maxPxStep: NaN,
  range: [0, 1]
};

/**
 * @typedef {object} ScaleBand
 * @property {string} [type='band']
 * @property {number} [padding=0] - Sets both inner and outer padding to the same value
 * @property {number} [paddingInner=0] - Inner padding
 * @property {number} [paddingOuter=0] - Outer padding
 * @property {number} [align=0.5] -  Control how the outer padding should be distributed, where 0.5 would distribute the padding equally on both sides
 * @property {boolean} [invert=false] - Invert the output range
 * @property {number} [maxPxStep] - Explicitly limit the bandwidth to a pixel value
 * @property {function} [label] - Callback label function, applied on each datum
 * @property {function} [value] - Callback value function, applied on each datum
 * @property {number[]|function} [range=[0, 1]] - Set range explicitly (ignored when maxPxStep takes effect)
 */

/**
 * @alias scaleBand
 * @memberof picasso
 * @private
 * @param { Object } settings
 * @param { fields[] } [fields]
 * @param { dataset } [dataset]
 * @return { band }
 */

function scaleBand() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let resources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const ctx = {
    data,
    resources
  };
  const stgns = resolveSettings$2(settings, DEFAULT_SETTINGS$7, ctx);
  const items = data.items || [];
  const domainToDataMapping = {};
  const values = [];
  const labels = [];

  // I would like to define this outside of scaleBand but it cause the documentation to be in the wrong order
  function augmentScaleBand(band, fsettings) {
    band.data = () => data;
    band.datum = domainValue => items[domainToDataMapping[domainValue]];

    /**
     * Get the first value of the domain
     * @return { number }
     */
    band.start = function start() {
      return band.domain()[0];
    };

    /**
     * Get the last value of the domain
     * @return { number }
     */
    band.end = function end() {
      return band.domain()[band.domain().length - 1];
    };
    band.labels = () => labels;

    /**
     * Generate discrete ticks
     * @return {Object[]} Array of ticks
     */
    band.ticks = function ticks() {
      let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      input.scale = band;
      return generateDiscreteTicks(input, fsettings.trackBy || 'label');
    };
  }
  /**
   * An augmented {@link https://github.com/d3/d3-scale#_band|d3 band scale}
   * @alias band
   * @private
   * @kind function
   * @param { Object } value
   * @return { number }
   */
  const band$1 = band();
  augmentScaleBand(band$1, settings);

  /**
   * if required creates a new scale with a restricted range
   * so that step size is at most maxPxStep
   * otherwise it returns itself
   * @param { number } size
   * @return { band }
   */
  band$1.pxScale = function pxScale(size) {
    const max = stgns.maxPxStep;
    if (isNaN(max)) {
      return band$1;
    }
    const n = band$1.domain().length;
    const sizeRelativeToStep = Math.max(1, n - band$1.paddingInner() + 2 * band$1.paddingOuter());
    if (sizeRelativeToStep * max >= size) {
      return band$1;
    }
    const newBand = band$1.copy();
    newBand.type = band$1.type;
    augmentScaleBand(newBand, settings);
    const t = sizeRelativeToStep * max / size;
    const offset = (1 - t) * band$1.align();
    newBand.range(stgns.invert ? [t + offset, offset] : [offset, t + offset]);
    return newBand;
  };
  const valueFn = typeof settings.value === 'function' ? settings.value : d => d.datum.value;
  const labelFn = typeof settings.label === 'function' ? settings.label : d => d.datum.label;
  for (let i = 0; i < items.length; i++) {
    const arg = extend$1({
      datum: items[i]
    }, ctx);
    const v = valueFn(arg, i);
    if (values.indexOf(v) === -1) {
      values.push(v);
      labels.push(labelFn(arg, i));
      domainToDataMapping[v] = i;
    }
  }
  band$1.domain(values);
  band$1.range(stgns.invert ? stgns.range.slice().reverse() : stgns.range);
  band$1.padding(isNaN(stgns.padding) ? 0 : stgns.padding);
  if (!isNaN(stgns.paddingInner)) {
    band$1.paddingInner(stgns.paddingInner);
  }
  if (!isNaN(stgns.paddingOuter)) {
    band$1.paddingOuter(stgns.paddingOuter);
  }
  band$1.align(isNaN(stgns.align) ? 0.5 : stgns.align);
  return band$1;
}

const DEFAULT_TICKS_SETTINGS = {
  depth: 0
};
function keyGen(node, valueFn, ctx) {
  return node.ancestors().map(a => valueFn(extend$1({
    datum: a.data
  }, ctx))).reverse().slice(1) // Delete root node
  .toString();
}
function flattenTree(rootNode, settings, ctx) {
  const ticksDepth = settings.ticks.depth;
  const valueFn = settings.value;
  const labelFn = settings.label;
  const values = [];
  const labels = [];
  const items = {};
  const ticks = [];
  let expando = 0;
  if (!rootNode) {
    return {
      values,
      labels,
      items,
      ticks
    };
  }
  rootNode.eachAfter(node => {
    if (node.depth > 0) {
      const key = keyGen(node, valueFn, ctx);
      const leaves = node.leaves() || [node]; // If leaf node returns itself
      const value = valueFn(extend$1({
        datum: node.data
      }, ctx));
      const label = labelFn(extend$1({
        datum: node.data
      }, ctx));
      const isBranch = Array.isArray(node.children);
      const item = {
        key,
        count: leaves.length,
        value,
        label,
        leftEdge: keyGen(leaves[0], valueFn, ctx),
        rightEdge: keyGen(leaves[Math.max(leaves.length - 1, 0)], valueFn, ctx),
        node
        // isTick: ticksDepth === null ? !isBranch : node.depth === ticksDepth
      };
      if (isBranch) {
        values.push("SPACER_".concat(expando, "_SPACER"));
        expando++;
      } else {
        values.push(key);
        labels.push(label);
      }
      if (ticksDepth <= 0 && !isBranch || node.depth === ticksDepth) {
        ticks.push(item);
      }
      items[key] = item;
    }
  });
  const spill = rootNode.height - 1;
  if (spill > 0) {
    values.splice(-spill);
  }
  return {
    values,
    labels,
    items,
    ticks
  };
}

/**
 * @typedef {object} scale-hBand.settings
 * @private
 * @property {number} [padding=0] - Exposes {@link https://github.com/d3/d3-scale#band_padding}
 * @property {boolean} [paddingOuter=0] - Exposes {@link https://github.com/d3/d3-scale#band_paddingOuter}
 * @property {number[]} [paddingInner=0] - Exposes {@link https://github.com/d3/d3-scale#band_paddingInner}
 * @property {object} [align=0.5] - Exposes {@link https://github.com/d3/d3-scale#band_align}
 * @property {boolean} [invert=false] - Invert the output range
 */

/**
 * Hierarchical band scale, that is an augmented band scale, that takes hierarchical data as input
 * @alias scaleHierarchicalBand
 * @private
 * @param { Object } settings
 * @param { fields[] } [fields]
 * @param { dataset } [dataset] - With a root property that is an instance of D3.js Hierarchy
 * @return { h-band }
 */

function scaleHierarchicalBand() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let resources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const ctx = {
    data,
    resources
  };
  const stgns = resolveSettings$2(settings, DEFAULT_SETTINGS$7, ctx);
  stgns.ticks = resolveSettings$2(settings.ticks, DEFAULT_TICKS_SETTINGS, ctx);
  stgns.value = typeof settings.value === 'function' ? settings.value : d => d.datum.value;
  stgns.label = typeof settings.label === 'function' ? settings.label : d => d.datum.value;
  let bandInstance = scaleBand(stgns);
  const {
    values,
    labels,
    items,
    ticks
  } = flattenTree(data.root, stgns, ctx);

  /**
   * @alias h-band
   * @private
   * @kind function
   * @param { Object[] } value - Array where each value is a reference to a node, going from depth 1 to n.
   * @return { number }
   */
  const hBand = function fn(val) {
    const strVal = String(val);
    const item = items[strVal];
    if (item) {
      return bandInstance(stgns.invert ? item.rightEdge : item.leftEdge);
    }
    return bandInstance(strVal);
  };
  extend$1(true, hBand, bandInstance);

  /**
   * Wrapped {@link https://github.com/d3/d3-scale#band_bandwidth}
   * @param { Object[] } [val] - Array where each value is a reference to a node, going from depth 1 to n. If omitted, bandwidth for the leaf nodes is return.
   * @return { number }
   */

  hBand.bandwidth = function bandwidth(val) {
    const item = items[String(val)];
    const bw = bandInstance.bandwidth();
    if (item && !item.isLeaf) {
      const left = hBand(item.leftEdge);
      const right = hBand(item.rightEdge);
      return Math.abs(left - right) + bw;
    }
    return bw;
  };

  /**
   * Wrapped {@link https://github.com/d3/d3-scale#band_step}
   * @param { Object[] } [val] - Array where each value is a reference to a node, going from depth 1 to n. If omitted, step size for the leaf nodes is return.
   * @return { number }
   */
  hBand.step = function step(val) {
    const item = items[String(val)];
    const leafCount = item ? item.count : 1;
    let stepSize = bandInstance.step();
    stepSize *= leafCount;
    return stepSize;
  };

  /**
   * @return { dataset }
   */
  hBand.data = () => data;

  /**
   * Return datum for a given node
   * @param { Object[] } val - Array where each value is a reference to a node, going from depth 1 to n.
   * @return { Object } The datum
   */
  hBand.datum = val => {
    const item = items[String(val)];
    if (item) {
      return item.node.data;
    }
    return null;
  };
  hBand.copy = () => scaleHierarchicalBand(settings, data, resources);

  /**
   * @return { Object[] } Labels for each leaf node
   */
  hBand.labels = () => labels;

  /**
   * Generate discrete ticks
   * @return { Object[] } Ticks for each leaf node
   */
  hBand.ticks = () =>
  // eslint-disable-line arrow-body-style
  ticks.map(item => {
    const start = hBand(item.key);
    const bandwidth = hBand.bandwidth(item.key);
    return {
      position: start + bandwidth / 2,
      label: item.label,
      data: item.node.data,
      start,
      end: start + bandwidth
    };
  });
  const orgPxScale = bandInstance.pxScale;
  hBand.pxScale = function pxScale(size) {
    bandInstance = orgPxScale(size);
    return hBand;
  };
  hBand.domain(values);
  return hBand;
}

const minAccessor = v => v.min();
const maxAccessor = v => v.max();

/**
 * Calculate the min/max value based on various inputs.
 *
 * Provided min/max setting takes presedence over all other inputs. If not provided, the respective values are calculated
 * from the given arr input, where each item in the array is expected to have a min/max accessor.
 *
 * @private
 * @param {object} [settings]
 * @param {number} [settings.min] The minimum value. Defaults to 0 if not provided.
 * @param {number} [settings.max] The maximum value. Defaults to 1 if not provided.
 * @param {object} [arr]
 * @returns { object[] } An array containing the min and max values.
 *
 * @example
 * minmax(); // [0, 1]
 *
 * minmax({}, [
 * { min: () => 13, max: () => 15 },
 * { min: () => NaN, max: () => 17 },
 * ]); // [13, 17]
 *
 * minmax({ min: -5, max: 4 }, [
 * { min: () => -20, max: () => 15 },
 * ]); // [-5, 4]
 */
function minmax(settings, arr) {
  // const definedMin = settings && typeof settings.min !== 'undefined';
  // const definedMax = settings && typeof settings.max !== 'undefined';
  const definedMin = settings && !isNaN(settings.min);
  const definedMax = settings && !isNaN(settings.max);
  let min = definedMin ? +settings.min : 0;
  let max = definedMax ? +settings.max : 1;
  if (arr && arr.length) {
    if (!definedMin) {
      const arrMin = arr.map(minAccessor).filter(isNumber);
      min = arrMin.length ? Math.min(...arrMin) : min;
    }
    if (!definedMax) {
      const arrMax = arr.map(maxAccessor).filter(isNumber);
      max = arrMax.length ? Math.max(...arrMax) : max;
    }
  }
  return [min, max];
}

const DEFAULT_SETTINGS$6 = {
  domain: [],
  range: [],
  invert: false,
  min: NaN,
  max: NaN
};
function generateDomain$1(range, min, max) {
  const len = range.length;
  if (len === 2) {
    return [min, max];
  }
  const domain = [];
  const part = (max - min) / (len - 1);
  domain.push(min);
  for (let i = 1; i < len - 1; i++) {
    domain.push(min + part * i);
  }
  domain.push(max);
  return domain;
}

/**
 * @typedef {object} ScaleSequentialColor
 * @property {string} [type='sequential-color']
 * @property {string[]} [range] - CSS color values of the output range
 * @property {boolean} [invert=false] - Invert range
 * @property {number} [min] - Set an explicit minimum value
 * @property {number} [max] - Set an explicit maximum value
 */

/**
 * @alias scaleSequentialColor
 * @private
 * @param { Object } [settings] Settings for this scale. If both range and domain are specified, they have to fulfill range.length === domain.length, otherwise they will be overriden.
 * @param { number[] } [settings.domain] Numeric values indicating stop limits between start and end values.
 * @param { color[] } [settings.range] CSS color values indicating stop colors between start and end values.
 * @param { field[] } [fields] Fields to dynamically calculate the domain extent.
 * @return { sequentialColor }
 *
 * @example
 * picasso.scaleSequentialColor({
 *  range: ['red', '#fc6', 'green'],
 *  domain: [-40, 0, 100]
 * });
 */

function scaleSequentialColor() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let resources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const s = scaleLinear(settings, data, resources).clamp(true).interpolate(rgb);
  const stgns = resolveSettings$2(settings, DEFAULT_SETTINGS$6, {
    data,
    resources
  });
  const isDomain = Array.isArray(stgns.domain) && stgns.domain.length;
  const isRange = Array.isArray(stgns.range) && stgns.range.length;

  /**
   * @alias sequentialColor
   * @private
   * @kind function
   * @param { Object } v Object containing a 'value' property
   * @return { string } The blended color
   */
  const fn = s;
  extend$1(true, fn, s);
  const [min, max] = minmax(stgns, data ? data.fields : []);
  const num = isDomain ? stgns.domain.length : -1;
  const DEFAULT_COLORS = resources.theme ? resources.theme.palette('sequential', num > 0 ? num : 2) : [];
  const range = isRange ? stgns.range : DEFAULT_COLORS;
  fn.range(stgns.invert ? range.slice().reverse() : range.slice());
  fn.domain(isDomain ? stgns.domain : generateDomain$1(fn.range(), min, max));
  return fn;
}

// const DEFAULT_COLORS = ['rgb(180,221,212)', 'rgb(34, 83, 90)'];

const DEFAULT_SETTINGS$5 = {
  domain: [],
  range: [],
  invert: false,
  min: NaN,
  max: NaN,
  nice: false
};
function generateDomain(range, min, max) {
  const len = range.length;
  if (len === 2) {
    return [min + (max - min) / 2];
  }
  const domain = [];
  const part = (max - min) / len;
  for (let i = 1; i < len; i++) {
    domain.push(min + part * i);
  }
  return domain;
}
function getBreaks(domain) {
  const ret = [];
  for (let i = 0; i < domain.length - 1; i++) {
    ret.push((domain[i] + domain[i + 1]) / 2);
  }
  return ret;
}
function generateRange(domain, colors, min, max) {
  min = domain[0];
  max = domain && domain.length >= 2 ? domain[domain.length - 1] : max;
  const seq = scaleSequentialColor().domain([min, max]).range(colors);
  const values = [min, ...getBreaks(domain), max];
  return values.map(v => seq(v));
}
function generateNiceDomain(range, min, max) {
  const numPoints = range.length === 2 ? 10 : Math.max(1, range.length);
  const lin = linear().domain([min, max]).nice(numPoints);
  const domain = lin.ticks(numPoints);
  if (!range || !range.length) {
    return domain;
  }

  // remove values from endpoints
  const num = Math.max(0, range.length - 1);
  while (domain.length > num) {
    if (domain[0] - min <= max - domain[domain.length - 1]) {
      domain.shift();
    } else {
      domain.pop();
    }
  }
  return domain;
}

/**
 * @typedef {object} ScaleThresholdColor
 * @property {string} [type='threshold-color']
 * @property {number[]} [domain] Values defining the thresholds
 * @property {string[]} [range] - CSS color values of the output range
 * @property {boolean} [invert=false] - Invert range
 * @property {number} [min] - Set an explicit minimum value
 * @property {number} [max] - Set an explicit maximum value
 * @property {boolean} [nice=false] If set to true, will generate 'nice' domain values. Ignored if domain is set.
 */

/**
 * @alias scaleThresholdColor
 * @private
 * @param { object } [settings] Settings for this scale. If both domain and range are specified, they have to fulfill domain.length === range.length + 1,  otherwise they will be overriden.
 * @param { number[] } [settings.domain] Values defining the thresholds.
 * @param { color[] } [settings.range] CSS color values of the output range.
 * @param { boolean } [settings.nice=false] If set to true, will generate 'nice' domain values. Ignored if domain is set.
 * @param { number } [settings.min] Minimum value to generate domain extent from. Ignored if domain is set.
 * @param { number } [settings.max] Maximum value to generate domain extend from. Ignored if domain is set.
 * @param { field[] } [fields] Fields to dynamically calculate the domain extent from. Ignored if min/max are set.
 * @return { thresholdColor }
 *
 * @example
 * let t = threshold({
 *   range: ['black', 'white'],
 *   domain: [25,50,75],
 *   max: 100,
 *   min: 0
 * });
 * t.domain(); // [25,50,75]
 * t.range(); // Generates from colors and domain: ['rgb(0,0,0)','rgb(85,85,85)','rgb(170,170,170)','rgb(255,255,255)']
 */

function scaleThresholdColor() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let resources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const d3Scale = threshold();
  const stgns = resolveSettings$2(settings, DEFAULT_SETTINGS$5, {
    data,
    resources
  });
  const isDomain = Array.isArray(stgns.domain) && stgns.domain.length;
  const isRange = Array.isArray(stgns.range) && stgns.range.length;

  /**
   * @alias thresholdColor
   * @private
   * @param { object } v Object literal containing a 'value' property.
   * @return { string } A CSS color from the scale's range.
   */
  function fn(v) {
    if (notNumber(v)) {
      return NaN;
    }
    return d3Scale(v);
  }
  Object.keys(d3Scale).forEach(key => fn[key] = d3Scale[key]);
  const fields = data.fields;
  const [min, max] = minmax(stgns, fields);
  const num = isDomain ? stgns.domain.length : -1;
  const DEFAULT_COLORS = resources.theme ? resources.theme.palette('sequential', num > 0 ? num : 2) : [];
  let range = isRange ? stgns.range : DEFAULT_COLORS;
  let domain = [];
  if (isDomain) {
    domain = stgns.domain;
  } else if (stgns.nice) {
    domain = generateNiceDomain(range, min, max);
  } else {
    domain = [min + (max - min) / 2];
  }
  if (range.length > domain.length + 1) {
    // Generate limits from range
    domain = generateDomain(range, min, max);
  } else if (range.length < domain.length + 1) {
    // Generate additional colors
    range = generateRange(domain, range, min, max);
  }
  fn.data = () => data;
  fn.range(stgns.invert ? range.slice().reverse() : range);
  fn.domain(domain);
  return fn;
}

const DEFAULT_SETTINGS$4 = {
  domain: [],
  range: []
};

/**
 * @alias scaleOrdinal
 * @private
 * @param { Object } settings
 * @param { field[] } [fields]
 * @param { dataset } data
 * @return { ordinal }
 */
function ordinal() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let resources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  /**
   * An augmented {@link https://github.com/d3/d3-scale#_ordinal|d3 ordinal scale}
   * @private
   * @alias ordinal
   * @param { Object }
   * @return { number }
   */
  const fn = ordinal$1();
  const ctx = {
    data,
    resources
  };
  const stgns = resolveSettings$2(settings, DEFAULT_SETTINGS$4, ctx);
  const valueFn = typeof settings.value === 'function' ? settings.value : d => d.datum.value;
  const labelFn = typeof settings.label === 'function' ? settings.label : d => d.datum.label;
  const items = data.items || [];
  const domainToDataMapping = {};
  const values = [];
  const labels = [];
  for (let i = 0; i < items.length; i++) {
    const arg = extend$1({
      datum: items[i]
    }, ctx);
    const v = valueFn(arg, i);
    if (values.indexOf(v) === -1) {
      values.push(v);
      labels.push(labelFn(arg, i));
      domainToDataMapping[v] = i;
    }
  }
  fn.data = () => data;
  fn.labels = () => labels;
  fn.label = domainValue => labels[values.indexOf(domainValue)];
  fn.datum = domainValue => items[domainToDataMapping[domainValue]];
  fn.range(stgns.range);
  if (Array.isArray(stgns.domain) && stgns.domain.length) {
    fn.domain(stgns.domain);
  } else {
    fn.domain(values);
  }
  return fn;
}

const DEFAULT_SETTINGS$3 = {
  domain: [],
  range: [],
  unknown: undefined
};
const DEFAULT_EXPLICIT_SETTINGS = {
  domain: [],
  range: [],
  override: false
};

/**
 * @typedef {object} ScaleCategoricalColor
 * @property {string} [type='categorical-color']
 * @property {string[]} [range=false] - CSS color values of the output range
 * @property {string} [unknown] - Value to return when input value is unknown
 * @property {object} [explicit] - Explicitly bind values to an output
 * @property {object[]} [explicit.domain[]] - Values to bind
 * @property {string[]} [explicit.range[]] - Output range
 */

/**
 * An ordinal scale with the output range set to default colors, as defined by *scaleCategorical.range*
 * @alias scaleCategorical
 * @private
 * @param { Object } settings
 * @param { field[] } [fields]
 * @param { dataset } [dataset]
 * @return { ordinal }
 */
function scaleCategorical() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let resources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const s = ordinal(settings, data, resources);
  const theme = resources.theme;
  const stgns = resolveSettings$2(settings, DEFAULT_SETTINGS$3, {
    data,
    resources
  });
  stgns.explicit = resolveSettings$2(settings.explicit, DEFAULT_EXPLICIT_SETTINGS, {
    data,
    resources
  });
  let range;
  if (!Array.isArray(stgns.range) || stgns.range.length === 0) {
    range = theme ? theme.palette('categorical', s.domain().length).slice() : [];
  } else {
    range = stgns.range.slice();
  }
  if (stgns.unknown) {
    s.unknown(stgns.unknown);
  } else if (theme && theme.palette('unknown')) {
    let un = theme.palette('unknown');
    s.unknown(un[0]);
  }
  if (Array.isArray(stgns.explicit.domain) && stgns.explicit.domain.length) {
    const domain = s.domain().slice();
    const explicitDomain = stgns.explicit.domain;
    const explicitRange = Array.isArray(stgns.explicit.range) ? stgns.explicit.range : [];

    // duplicate range values to cover entire domain
    const numCopies = Math.floor(domain.length / range.length);
    for (let i = 1; i < numCopies + 1; i *= 2) {
      range = range.concat(range);
    }
    if (stgns.explicit.override) {
      for (let i = 0; i < explicitDomain.length; i++) {
        const index = domain.indexOf(explicitDomain[i]);
        if (index > -1) {
          range[index] = explicitRange[i];
        }
      }
    } else {
      // inject explicit colors
      const order = explicitDomain.map((d, i) => [domain.indexOf(d), d, explicitRange[i]]).sort((a, b) => a[0] - b[0]);
      order.forEach(v => {
        const idx = domain.indexOf(v[1]);
        if (idx !== -1) {
          range.splice(idx, 0, v[2]);
        }
      });
    }

    // cutoff excess range values
    range.length = domain.length;
  }
  s.range(range);
  return s;
}

/**
 * Definition for creating a scale. Additional properties, specific for a type of scale, can be added as key/value pairs
 * @typedef {object} ScaleDefinition
 * @property {string} [type] Type of scale
 * @property {DataExtraction|DataFieldExtraction} [data] Data configuration
 */

/**
 * Scale instance
 * @typedef {object} Scale
 * @interface
 * @property {string} type Type of scale
 */

const scaleRegistry = registryFactory();
scaleRegistry('linear', scaleLinear);
scaleRegistry('band', scaleBand);
scaleRegistry('h-band', scaleHierarchicalBand);
scaleRegistry('sequential-color', scaleSequentialColor);
scaleRegistry('threshold-color', scaleThresholdColor);
scaleRegistry('categorical-color', scaleCategorical);
function getTypeFromMeta(fields) {
  const types = fields.map(field => field.type() === 'dimension' ? 'band' : 'linear');
  return types.indexOf('linear') !== -1 ? 'linear' : 'band';
}
function deduceScaleTypeFromData(data) {
  if (data.root) {
    return 'h-band';
  }
  if (data.fields && data.fields[0]) {
    return getTypeFromMeta(data.fields);
  }
  return 'linear';
}
function create$n(options, d, deps) {
  let dataSourceConfig = options.data;
  if (options.source) {
    // DEPRECATION
    deps.logger.warn('Deprecated: Scale data source configuration');
    dataSourceConfig = {
      extract: []
    };
    (Array.isArray(options.source) ? options.source : [options.source]).forEach(source => {
      dataSourceConfig.extract.push({
        field: source
      });
    });
  }
  const data = extract$1(dataSourceConfig, d, deps);
  let type = options.type || deduceScaleTypeFromData(data);
  let s;
  if (type === 'color') {
    if (data.fields && data.fields[0] && data.fields[0].type() === 'dimension') {
      type = 'categorical-color';
    } else {
      type = 'sequential-color';
    }
  }
  if (deps.scale.has(type)) {
    s = deps.scale.get(type);
    s = s(options, data, {
      theme: deps.theme,
      logger: deps.logger
    });
    s.type = type;
  }
  return s;
}
function collection(scalesConfig, data, deps) {
  let fn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : create$n;
  const scales = {};
  return {
    get(def) {
      let key;
      if (typeof def === 'string' && scalesConfig[def]) {
        key = def;
      } else if (typeof def === 'object' && 'scale' in def && scalesConfig[def.scale]) {
        key = def.scale;
      }
      if (key) {
        scales[key] = scales[key] || fn(scalesConfig[key], data, deps);
        return scales[key];
      }
      return fn(def, data, deps);
    },
    all() {
      Object.keys(scalesConfig).forEach(this.get);
      return scales;
    }
  };
}

/**
 * Utility functions
 */

var util = {};

util.isObject = function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
};

util.isNumber = function isNumber(arg) {
  return typeof arg === 'number';
};

util.isUndefined = function isUndefined(arg) {
  return arg === void 0;
};

util.isFunction = function isFunction(arg){
  return typeof arg === 'function';
};


/**
 * EventEmitter class
 */

function EventEmitter$1() {
  EventEmitter$1.init.call(this);
}
var nodeEventEmitter = EventEmitter$1;

// Backwards-compat with node 0.10.x
EventEmitter$1.EventEmitter = EventEmitter$1;

EventEmitter$1.prototype._events = undefined;
EventEmitter$1.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter$1.defaultMaxListeners = 10;

EventEmitter$1.init = function() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter$1.prototype.setMaxListeners = function(n) {
  if (!util.isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter$1.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error' && !this._events.error) {
    er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      throw Error('Uncaught, unspecified "error" event.');
    }
  }

  handler = this._events[type];

  if (util.isUndefined(handler))
    return false;

  if (util.isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        len = arguments.length;
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        handler.apply(this, args);
    }
  } else if (util.isObject(handler)) {
    len = arguments.length;
    args = new Array(len - 1);
    for (i = 1; i < len; i++)
      args[i - 1] = arguments[i];

    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter$1.prototype.addListener = function(type, listener) {
  var m;

  if (!util.isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              util.isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (util.isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (util.isObject(this._events[type]) && !this._events[type].warned) {
    var m;
    if (!util.isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter$1.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;

      if (util.isFunction(console.error)) {
        console.error('(node) warning: possible EventEmitter memory ' +
                      'leak detected. %d listeners added. ' +
                      'Use emitter.setMaxListeners() to increase limit.',
                      this._events[type].length);
      }
      if (util.isFunction(console.trace))
        console.trace();
    }
  }

  return this;
};

EventEmitter$1.prototype.on = EventEmitter$1.prototype.addListener;

EventEmitter$1.prototype.once = function(type, listener) {
  if (!util.isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter$1.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!util.isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (util.isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (util.isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter$1.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (util.isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (Array.isArray(listeners)) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter$1.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (util.isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter$1.listenerCount = function(emitter, type) {
  var ret;
  if (!emitter._events || !emitter._events[type])
    ret = 0;
  else if (util.isFunction(emitter._events[type]))
    ret = 1;
  else
    ret = emitter._events[type].length;
  return ret;
};

var EventEmitter = {
  /**
   * Function used to add event handling to objects passed in.
   * @private
   * @param {Object} obj Object instance that will get event handling.
   */
  mixin(obj) {
    Object.keys(nodeEventEmitter.prototype).forEach(key => {
      obj[key] = nodeEventEmitter.prototype[key];
    });
    nodeEventEmitter.init(obj);
    return obj;
  }
};

function scrollApi() {
  let min = 0;
  let max = 0;
  let start = 0;
  let viewSize = 0;
  start = start || min;

  /**
   * The scroll api
   * @private
   * @alias scroll
   */
  const s = {
    /**
     * Move the current scroll
     * @param {number} value
     * @emits update
     */
    move(value) {
      this.moveTo(start + value);
    },
    /**
     * Change the current scroll to a specific value
     * @param {number} value
     * @emits update
     */
    moveTo(value) {
      const newStart = Math.max(min, Math.min(max - viewSize, value));
      if (start !== newStart) {
        start = newStart;
        s.emit('update');
      }
    },
    /**
     * Update scroll settings
     * @param {number} [settings.min]
     * @param {number} [settings.max]
     * @param {number} [settings.viewSize]
     * @emits update
     */
    update(settings) {
      let triggerUpdate = false;
      ({
        min = min,
        max = max
      } = settings);
      if (settings.viewSize !== undefined && settings.viewSize !== viewSize) {
        viewSize = settings.viewSize;
        triggerUpdate = true;
      }

      // update scroll to be within the new bounds
      const newStart = Math.max(min, Math.min(max - viewSize, start));
      if (start !== newStart) {
        start = newStart;
        triggerUpdate = true;
      }
      if (triggerUpdate) {
        s.emit('update');
      }
    },
    /**
     * Get the current scroll state
     * @return {object} with min, max, start & viewSize
     */
    getState() {
      return {
        min,
        max,
        start,
        viewSize
      };
    }
  };
  EventEmitter.mixin(s);
  return s;
}

function createOrUpdate(options, oldApi) {
  const min = options.min || 0;
  const max = options.max || 0;
  const viewSize = options.viewSize || 0;
  const s = oldApi || scrollApi();
  s.update({
    min,
    max,
    viewSize
  });
  return s;
}
function builder(obj, oldScrollApis) {
  const scrollApis = {};
  for (const n in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, n)) {
      scrollApis[n] = createOrUpdate(obj[n], oldScrollApis ? oldScrollApis[n] : null);
    }
  }
  return scrollApis;
}
function getOrCreateScrollApi(v, scrollApis) {
  if (!scrollApis[v]) {
    scrollApis[v] = scrollApi();
  }
  return scrollApis[v];
}

function lessThanOrEqual(value, limit) {
  return value <= limit;
}
function lessThan(value, limit) {
  return value < limit;
}
function index(boundaries, point, after) {
  let i = 0;
  while (i < boundaries.length && point > boundaries[i]) {
    ++i;
  }
  if (boundaries[i] === point && after) {
    ++i;
  }
  return i;
}
function contains(boundaries, point, minCondition, maxCondition) {
  const len = boundaries.length;
  for (let i = 1; i < len; i += 2) {
    if (minCondition(boundaries[i - 1], point) && maxCondition(point, boundaries[i])) {
      return true;
    }
  }
  return false;
}
function rangeCollection() {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let maxCondition;
  let minCondition;
  let boundaries = [];
  function fn() {}
  fn.configure = function () {
    let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      includeMax = true,
      includeMin = true
    } = c;
    maxCondition = includeMax ? lessThanOrEqual : lessThan;
    minCondition = includeMin ? lessThanOrEqual : lessThan;
  };
  fn.add = _ref => {
    let {
      min,
      max
    } = _ref;
    const i0 = index(boundaries, min);
    const i1 = index(boundaries, max, true);
    const args = [i0, i1 - i0];
    if (i0 % 2 === 0) {
      args.push(min);
    }
    if (i1 % 2 === 0) {
      args.push(max);
    }
    const before = boundaries.join(',');
    boundaries.splice(...args);
    const after = boundaries.join(',');
    return before !== after;
  };
  fn.remove = _ref2 => {
    let {
      min,
      max
    } = _ref2;
    const i0 = index(boundaries, min);
    const i1 = index(boundaries, max, true);
    const args = [i0, i1 - i0];
    if (i0 % 2 === 1) {
      args.push(min);
    }
    if (i1 % 2 === 1) {
      args.push(max);
    }
    const before = boundaries.join(',');
    boundaries.splice(...args);
    const after = boundaries.join(',');
    return before !== after;
  };
  fn.set = range => {
    const before = boundaries.join(',');
    boundaries = [];
    if (Array.isArray(range)) {
      range.forEach(fn.add);
    } else {
      fn.add(range);
    }
    const after = boundaries.join(',');
    return before !== after;
  };
  fn.clear = () => {
    const before = boundaries.length > 0;
    boundaries = [];
    return before;
  };
  fn.containsValue = value => contains(boundaries, value, minCondition, maxCondition);
  fn.containsRange = _ref3 => {
    let {
      min,
      max
    } = _ref3;
    const i0 = index(boundaries, min, true);
    const i1 = index(boundaries, max);
    return i0 === i1 && i1 % 2 === 1;
  };
  fn.toggle = range => {
    if (fn.containsRange(range)) {
      return fn.remove(range);
    }
    return fn.add(range);
  };
  fn.ranges = () => {
    const collection = [];
    for (let i = 1; i < boundaries.length; i += 2) {
      collection.push({
        min: boundaries[i - 1],
        max: boundaries[i]
      });
    }
    return collection;
  };
  fn.configure(config);
  return fn;
}

function valueCollection() {
  let values = [];
  function vc() {}
  vc.add = value => {
    if (values.indexOf(value) === -1) {
      values.push(value);
      return true;
    }
    return false;
  };
  vc.remove = value => {
    const idx = values.indexOf(value);
    if (idx !== -1) {
      values.splice(idx, 1);
      return true;
    }
    return false;
  };
  vc.contains = value => values.indexOf(value) !== -1;
  vc.values = () => values.slice();
  vc.clear = () => values = [];
  vc.toString = () => values.join(';');
  return vc;
}

/**
 * @typedef {object} BrushConfig
 * @property {Array<BrushConfig~Ranges>} [ranges] - Range configurations
 */

/**
 * @typedef {object}
 * @alias BrushConfig~Ranges
 */
const DEFAULT_RANGE_CONFIG = {
  /**
   * An identifier that represents the data source of the value
   * @type {string=}
   */
  key: undefined,
  /**
   * Whether or not the minimum value of a range should be included when determining if a value is brushed.
   * @type {boolean=} */
  includeMin: true,
  /**
   * Whether or not the maximum value of a range should be included when determining if a value is brushed.
   * @type {boolean=} */
  includeMax: true
};
function add$1(_ref) {
  let {
    items,
    collection,
    vc
  } = _ref;
  const changedMap = {};
  const changed = [];
  let key;
  let values;
  for (let i = 0, num = items.length; i < num; i++) {
    key = items[i].key;
    if (!collection[key]) {
      collection[key] = vc();
    }
    values = items[i].values || [items[i].value];
    for (let vi = 0; vi < values.length; vi++) {
      if (collection[key].add(values[vi])) {
        changedMap[key] = changedMap[key] || [];
        changedMap[key].push(values[vi]);
      }
    }
  }
  const keys = Object.keys(changedMap);
  for (let i = 0, num = keys.length; i < num; i++) {
    key = keys[i];
    changed.push({
      id: key,
      values: changedMap[key]
    });
  }
  return changed;
}
function remove$1(_ref2) {
  let {
    items,
    collection
  } = _ref2;
  const changedMap = {};
  const changed = [];
  let key;
  let values;
  for (let i = 0, num = items.length; i < num; i++) {
    key = items[i].key;
    if (!collection[key]) {
      continue;
    }
    values = items[i].values || [items[i].value];
    for (let vi = 0; vi < values.length; vi++) {
      if (collection[key].remove(values[vi])) {
        changedMap[key] = changedMap[key] || [];
        changedMap[key].push(values[vi]);
      }
    }
  }
  const keys = Object.keys(changedMap);
  for (let i = 0, num = keys.length; i < num; i++) {
    key = keys[i];
    changed.push({
      id: key,
      values: changedMap[key]
    });
  }
  return changed;
}
function collectUnique(items) {
  const filteredSet = {};
  let key;
  let values;
  for (let i = 0, num = items.length; i < num; i++) {
    key = items[i].key;
    values = items[i].values || [items[i].value];
    if (!filteredSet[key]) {
      filteredSet[key] = [];
    }
    for (let vi = 0; vi < values.length; vi++) {
      const idx = filteredSet[key].indexOf(values[vi]);
      if (idx === -1) {
        filteredSet[key].push(values[vi]);
      }
    }
  }
  return filteredSet;
}
function createValueCollection(_ref3) {
  let {
    key,
    collection,
    obj,
    fn,
    value
  } = _ref3;
  if (!collection[key]) {
    collection[key] = fn();
  }
  obj[key] = obj[key] || [];
  obj[key].push(value);
  collection[key].add(value);
}
function toggle(_ref4) {
  let {
    items,
    values,
    vc
  } = _ref4;
  const addedMap = {};
  const removedMap = {};
  const added = [];
  const removed = [];
  const filteredSet = collectUnique(items);
  let key;
  let value;
  let fs;
  const setKeys = Object.keys(filteredSet);
  for (let i = 0, num = setKeys.length; i < num; i++) {
    key = setKeys[i];
    fs = filteredSet[key];
    for (let k = 0, len = fs.length; k < len; k++) {
      value = fs[k];
      if (!values[key] || !values[key].contains(value)) {
        createValueCollection({
          key,
          value,
          collection: values,
          obj: addedMap,
          fn: vc
        });
      } else if (values[key] && values[key].contains(value)) {
        removedMap[key] = removedMap[key] || [];
        removedMap[key].push(value);
        values[key].remove(value);
      }
    }
  }
  const addedKeys = Object.keys(addedMap);
  for (let i = 0, num = addedKeys.length; i < num; i++) {
    key = addedKeys[i];
    added.push({
      id: key,
      values: addedMap[key]
    });
  }
  const removedKeys = Object.keys(removedMap);
  for (let i = 0, num = removedKeys.length; i < num; i++) {
    key = removedKeys[i];
    removed.push({
      id: key,
      values: removedMap[key]
    });
  }
  return [added, removed];
}
function diff$1(old, current) {
  const changed = [];
  const keys = Object.keys(old);
  let key;
  let changedValues;
  const filterFn = v => current[key].indexOf(v) === -1;
  for (let i = 0, num = keys.length; i < num; i++) {
    key = keys[i];
    if (!current[key]) {
      changed.push({
        id: key,
        values: old[key]
      });
    } else {
      changedValues = old[key].filter(filterFn);
      if (changedValues.length) {
        changed.push({
          id: key,
          values: changedValues
        });
      }
    }
  }
  return changed;
}
function set(_ref5) {
  let {
    items,
    vCollection,
    vc
  } = _ref5;
  const addedMap = {};
  const filteredSet = collectUnique(items);
  let added = [];
  let removed = [];
  let key;
  const oldMap = {};
  const vcKeys = Object.keys(vCollection);
  for (let i = 0, num = vcKeys.length; i < num; i++) {
    key = vcKeys[i];
    oldMap[key] = vCollection[key].values().slice();
    delete vCollection[key];
  }
  const createValueCollectionFn = value => {
    if (!vCollection[key] || !vCollection[key].contains(value)) {
      createValueCollection({
        key,
        value,
        collection: vCollection,
        obj: addedMap,
        fn: vc
      });
    }
  };
  const fsKeys = Object.keys(filteredSet);
  for (let i = 0, num = fsKeys.length; i < num; i++) {
    key = fsKeys[i];
    filteredSet[key].forEach(createValueCollectionFn);
  }
  removed = diff$1(oldMap, addedMap);
  added = diff$1(addedMap, oldMap);
  return [added, removed];
}
function applyAliases(items, aliases) {
  if (!Object.keys(aliases).length) {
    return items;
  }
  const len = items.length;
  const its = Array(len);
  for (let i = 0; i < len; i++) {
    its[i] = items[i].key in aliases ? extend$1({}, items[i], {
      key: aliases[items[i].key]
    }) : items[i];
  }
  return its;
}
function intercept(handlers, items, aliases) {
  const its = applyAliases(items, aliases);
  return handlers && handlers.length ? handlers.reduce((value, interceptor) => interceptor(value), its) : its;
}
function toCamelCase(s) {
  return s.replace(/(-[a-z])/g, $1 => $1.toUpperCase().replace('-', ''));
}
function toSnakeCase(s) {
  return s.replace(/([A-Z])/g, $1 => "-".concat($1.toLowerCase()));
}
function updateRange(items, action, _ref6) {
  let {
    ranges,
    interceptors,
    rc,
    aliases,
    rangeConfig
  } = _ref6;
  const inter = "".concat(action, "Ranges");
  const its = intercept(interceptors[inter], items, aliases);
  let changed = false;
  its.forEach(item => {
    const key = item.key;
    if (!ranges[key]) {
      ranges[key] = rc(rangeConfig.sources[key] || rangeConfig.default);
    }
    if (action === 'set') {
      changed = ranges[key][action](item.ranges || item.range) || changed;
    } else {
      const rangeValues = item.ranges || [item.range];
      for (let i = 0; i < rangeValues.length; i++) {
        changed = ranges[key][action](rangeValues[i]) || changed;
      }
    }
  });
  return changed;
}
function brush() {
  let {
    vc = valueCollection,
    rc = rangeCollection
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let activated = false;
  let ranges = {};
  let values = {};
  let aliases = {};
  let rangeConfig = {
    sources: {},
    default: extend$1({}, DEFAULT_RANGE_CONFIG)
  };
  const interceptors = {
    addValues: [],
    removeValues: [],
    toggleValues: [],
    setValues: [],
    addRanges: [],
    setRanges: [],
    removeRanges: [],
    toggleRanges: []
  };
  const getState = () => {
    const state = {
      values: {},
      ranges: {}
    };
    Object.keys(values).forEach(key => {
      state.values[key] = values[key].values();
    });
    Object.keys(ranges).forEach(key => {
      state.ranges[key] = ranges[key].ranges();
    });
    return state;
  };
  const links = {
    ls: [],
    clear() {
      this.ls.forEach(b => b.clear());
    },
    start() {
      this.ls.forEach(b => b.start());
    },
    end() {
      this.ls.forEach(b => b.end());
    },
    update() {
      const s = getState();
      this.ls.forEach(b => b._state(s));
    },
    updateValues() {
      const s = getState();
      this.ls.forEach(b => b._state({
        values: s.values
      }));
    },
    updateRanges() {
      const s = getState();
      this.ls.forEach(b => b._state({
        ranges: s.ranges
      }));
    }
  };

  /**
   * A brush context
   * @alias Brush
   * @interface
   */
  const fn = {};

  /**
   * Triggered when this brush is activated
   * @event Brush#start
   * @type {string}
   */

  /**
   * Triggered when this brush is updated
   * @event Brush#update
   * @type {string}
   * @param {Array<object>} added - The added items
   * @param {Array<object>} removed - The removed items
   */

  /**
   * Triggered when this brush is deactivated
   * @event Brush#end
   * @type {string}
   */

  /**
   * Configure the brush instance.
   *
   * @param {BrushConfig} config
   * @example
   * brushInstance.configure({
   *   ranges: [
   *     { key: 'some key', includeMax: false },
   *     { includeMax: true, includeMin: true },
   *   ]
   * })
   */
  fn.configure = function () {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (Array.isArray(config.ranges) && config.ranges.length) {
      rangeConfig = {
        sources: {},
        default: extend$1({}, DEFAULT_RANGE_CONFIG)
      };
      config.ranges.forEach(cfg => {
        const c = {};
        Object.keys(DEFAULT_RANGE_CONFIG).filter(attr => attr !== 'key').forEach(attr => {
          c[attr] = typeof cfg[attr] !== 'undefined' ? cfg[attr] : DEFAULT_RANGE_CONFIG[attr];
        });
        if (typeof cfg.key !== 'undefined') {
          rangeConfig.sources[cfg.key] = c;
        } else {
          rangeConfig.default = c;
        }
      });
      Object.keys(ranges).forEach(key => ranges[key].configure(rangeConfig.sources[key] || rangeConfig.default));

      // TODO only emit update if config has changed
      fn.emit('update', [], []);
    }
  };

  /**
   * Link this brush to another brush instance.
   *
   * When linked, the `target` will receive updates whenever this brush changes.
   * @param {Brush} target - The brush instance to link to
   */
  fn.link = target => {
    if (fn === target) {
      throw new Error("Can't link to self");
    }
    links.ls.push(target);
    target._state(getState());
  };
  fn._state = s => {
    if (!s) {
      return getState();
    }
    if (s.values) {
      const arr = [];
      Object.keys(s.values).forEach(key => {
        if (!values[key] || s.values[key].join(';') !== values[key].toString()) {
          arr.push({
            key,
            values: s.values[key]
          });
        }
      });
      Object.keys(values).forEach(key => {
        if (!s.values[key]) {
          arr.push({
            key,
            values: []
          });
        }
      });
      if (arr.length) {
        fn.setValues(arr);
      }
    }
    if (s.ranges) {
      const arr = [];
      Object.keys(s.ranges).forEach(key => {
        if (!ranges[key] || s.ranges[key].join(';') !== ranges[key].toString()) {
          arr.push({
            key,
            ranges: s.ranges[key]
          });
        }
      });
      Object.keys(ranges).forEach(key => {
        if (!s.ranges[key]) {
          arr.push({
            key,
            ranges: []
          });
        }
      });
      if (arr.length) {
        fn.setRanges(arr);
      }
    }
    return undefined;
  };

  /**
   * Starts this brush context
   *
   * Starts this brush context and emits a 'start' event if it is not already started.
   * @param {...any} args - arguments to be passed to 'start' listeners
   * @emits Brush#start
   */
  fn.start = function () {
    if (!activated) {
      activated = true;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      fn.emit('start', ...args);
      links.start();
    }
  };

  /**
   * Ends this brush context
   *
   * Ends this brush context and emits an 'end' event if it is not already ended.
   * @param {...any} args - arguments to be passed to 'end' listeners
   * @emits Brush#end
   */
  fn.end = function () {
    if (!activated) {
      return;
    }
    activated = false;
    ranges = {};
    values = {};
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    fn.emit('end', ...args);
    links.end();
  };

  /**
   * Checks if this brush is activated
   *
   * Returns true if started, false otherwise
   * @return {boolean}
   */
  fn.isActive = () => activated;

  /**
   * Clears this brush context
   */
  fn.clear = () => {
    const removed = fn.brushes().filter(b => b.type === 'value' && b.brush.values().length).map(b => ({
      id: b.id,
      values: b.brush.values()
    }));
    const hasChanged = Object.keys(ranges).length > 0 || removed.length;
    ranges = {};
    values = {};
    if (hasChanged) {
      fn.emit('update', [], removed); // TODO - do not emit update if state hasn't changed
      links.clear();
    }
  };

  /**
   * Returns all brushes within this context
   * @return {object}
   */
  fn.brushes = () => {
    let result = [];
    result = result.concat(Object.keys(ranges).map(key => ({
      type: 'range',
      id: key,
      brush: ranges[key]
    })));
    result = result.concat(Object.keys(values).map(key => ({
      type: 'value',
      id: key,
      brush: values[key]
    })));
    return result;
  };

  /**
   * Adds a primitive value to this brush context
   *
   * If this brush context is not started, a 'start' event is emitted.
   * If the state of the brush changes, ie. if the added value does not already exist, an 'update' event is emitted.
   *
   * @param {string} key  An identifier that represents the data source of the value
   * @param {string|number} value The value to add
   * @emits Brush#start
   * @emits Brush#update
   * @example
   * brush.addValue('countries', 'Sweden');
   * brush.addValue('/qHyperCube/qDimensionInfo/0', 3);
   */
  fn.addValue = (key, value) => {
    fn.addValues([{
      key,
      value
    }]);
  };

  /**
   * @param {object[]} items Items to add
   */
  fn.addValues = items => {
    const its = intercept(interceptors.addValues, items, aliases);
    const added = add$1({
      vc,
      collection: values,
      items: its
    });
    fn.emit('add-values', its);
    if (added.length) {
      if (!activated) {
        activated = true;
        fn.emit('start');
      }
      fn.emit('update', added, []);
      links.updateValues();
    }
  };

  /**
   * @param {object[]} items Items to set
   */
  fn.setValues = items => {
    const its = intercept(interceptors.setValues, items, aliases);
    const changed = set({
      items: its,
      vCollection: values,
      vc
    });
    fn.emit('set-values', its);
    if (changed[0].length > 0 || changed[1].length > 0) {
      if (!activated) {
        activated = true;
        fn.emit('start');
      }
      fn.emit('update', changed[0], changed[1]);
      links.updateValues();
    }
  };

  /**
   * Removes a primitive values from this brush context
   *
   * If the state of the brush changes, ie. if the removed value does exist, an 'update' event is emitted.
   *
   * @param  {string} key  An identifier that represents the data source of the value
   * @param  {string|number} value The value to remove
   * @example
   * brush.removeValue('countries', 'Sweden');
   */
  fn.removeValue = (key, value) => {
    fn.removeValues([{
      key,
      value
    }]);
  };

  /**
   * @param {object[]} items Items to remove
   */
  fn.removeValues = items => {
    const its = intercept(interceptors.removeValues, items, aliases);
    const removed = remove$1({
      collection: values,
      items: its
    });
    fn.emit('remove-values', its);
    if (removed.length) {
      fn.emit('update', [], removed);
      links.updateValues();
      // TODO - emit 'end' event if there are no remaining active brushes
    }
  };

  /**
   * Add and remove values in a single operation
   * almost the same as calling addValues and removeValues but only triggers one 'update' event
   *
   * If the state of the brush changes, an 'update' event is emitted.
   *
   * @param {object[]} addItems Items to add
   * @param {object[]} removeItems Items to remove
   */
  fn.addAndRemoveValues = (addItems, removeItems) => {
    const addIts = intercept(interceptors.addValues, addItems, aliases);
    const removeIts = intercept(interceptors.removeValues, removeItems, aliases);
    const added = add$1({
      vc,
      collection: values,
      items: addIts
    });
    const removed = remove$1({
      collection: values,
      items: removeIts
    });
    fn.emit('add-values', addIts);
    fn.emit('remove-values', removeIts);
    if (added.length || removed.length) {
      if (!activated) {
        activated = true;
        fn.emit('start');
      }
      fn.emit('update', added, removed);
      links.updateValues();
    }
  };

  /**
   * Toggles a primitive value in this brush context
   *
   * If the given value exists in this brush context, it will be removed. If it does not exist it will be added.
   *
   * @param  {string} key  An identifier that represents the data source of the value
   * @param  {string|number} value The value to toggle
   * @example
   * brush.toggleValue('countries', 'Sweden');
   */
  fn.toggleValue = (key, value) => {
    fn.toggleValues([{
      key,
      value
    }]);
  };

  /**
   * @param {object[]} items Items to toggle
   */
  fn.toggleValues = items => {
    const its = intercept(interceptors.toggleValues, items, aliases);
    const toggled = toggle({
      items: its,
      values,
      vc
    });
    fn.emit('toggle-values', its);
    if (toggled[0].length > 0 || toggled[1].length > 0) {
      if (!activated) {
        activated = true;
        fn.emit('start');
      }
      fn.emit('update', toggled[0], toggled[1]);
      links.updateValues();
    }
  };

  /**
   * Checks if a certain value exists in this brush context
   *
   * Returns true if the values exists for the provided key, returns false otherwise.
   *
   * @param  {string} key  An identifier that represents the data source of the value
   * @param  {string|number} value The value to check for
   * @return {boolean}
   * @example
   * brush.addValue('countries', 'Sweden');
   * brush.containsValue('countries', 'Sweden'); // true
   * brush.toggleValue('countries', 'Sweden'); // remove 'Sweden'
   * brush.containsValue('countries', 'Sweden'); // false
   */
  fn.containsValue = (key, value) => {
    let k = aliases[key] || key;
    if (!values[k]) {
      return false;
    }
    return values[k].contains(value);
  };

  /**
   * Adds a numeric range to this brush context
   *
   * @param {string} key - An identifier that represents the data source of the range
   * @param {object} range - The range to add to this brush
   * @param {number} range.min - Min value of the range
   * @param {number} range.max - Max value of the range
   * @example
   * brush.addRange('Sales', { min: 20, max: 50 });
   */
  fn.addRange = (key, range) => {
    fn.addRanges([{
      key,
      range
    }]);
  };

  /**
   * @see {brush.addRange}
   * @param {object[]} items - Items containing the ranges to remove
   * @param {string} items[].key
   * @param {object} items[].range
   */
  fn.addRanges = items => {
    const changed = updateRange(items, 'add', {
      ranges,
      rc,
      interceptors,
      aliases,
      rangeConfig
    });
    if (!changed) {
      return;
    }
    if (!activated) {
      activated = true;
      fn.emit('start');
    }
    fn.emit('update', [], []);
    links.updateRanges();
  };

  /**
   * Removes a numeric range from this brush context
   *
   * @param {string} key - An identifier that represents the data source of the range
   * @param {object} range - The range to remove from this brush
   * @param {number} range.min - Min value of the range
   * @param {number} range.max - Max value of the range
   */
  fn.removeRange = (key, range) => {
    fn.removeRanges([{
      key,
      range
    }]);
  };

  /**
   * @see {brush.removeRange}
   * @param {object[]} items - Items containing the ranges to remove
   */
  fn.removeRanges = items => {
    const changed = updateRange(items, 'remove', {
      ranges,
      rc,
      interceptors,
      aliases,
      rangeConfig
    });
    if (!changed) {
      return;
    }
    if (!activated) {
      activated = true;
      fn.emit('start');
    }
    fn.emit('update', [], []);
    links.updateRanges();
  };

  /**
   * Sets a numeric range to this brush context
   *
   * Overwrites any active ranges identified by `key`
   *
   * @param {string} key - An identifier that represents the data source of the range
   * @param {object} range - The range to set on this brush
   * @param {number} range.min - Min value of the range
   * @param {number} range.max - Max value of the range
   */
  fn.setRange = (key, range) => {
    fn.setRanges([{
      key,
      range
    }]);
  };

  /**
   * @see {brush.setRange}
   * @param {object[]} items - Items containing the ranges to set
   */
  fn.setRanges = items => {
    const changed = updateRange(items, 'set', {
      ranges,
      rc,
      interceptors,
      aliases,
      rangeConfig
    });
    if (!changed) {
      return;
    }
    if (!activated) {
      activated = true;
      fn.emit('start');
    }
    fn.emit('update', [], []);
    links.updateRanges();
  };

  /**
   * Toggles a numeric range in this brush context
   *
   * Removes the range if it's already contained within the given identifier,
   * otherwise the given range is added to the brush.
   *
   * @param {string} key - An identifier that represents the data source of the range
   * @param {object} range - The range to toggle in this brush
   * @param {number} range.min - Min value of the range
   * @param {number} range.max - Max value of the range
   */
  fn.toggleRange = (key, range) => {
    fn.toggleRanges([{
      key,
      range
    }]);
  };

  /**
   * @see {brush.toggleRange}
   * @param {object[]} items - Items containing the ranges to toggle
   */
  fn.toggleRanges = items => {
    const changed = updateRange(items, 'toggle', {
      ranges,
      rc,
      interceptors,
      aliases,
      rangeConfig
    });
    if (!changed) {
      return;
    }
    if (!activated) {
      activated = true;
      fn.emit('start');
    }
    fn.emit('update', [], []);
    links.updateRanges();
  };

  /**
   * Checks if a value is contained within a range in this brush context
   *
   * Returns true if the values exists for the provided key, returns false otherwise.
   *
   * @param  {string} key - An identifier that represents the data source of the value
   * @param  {number} value - The value to check for
   * @return {boolean}
   * @example
   * brush.addRange('Sales', { min: 10, max: 50 });
   * brush.containsRangeValue('Sales', 30); // true
   * brush.containsRangeValue('Sales', 5); // false
   */
  fn.containsRangeValue = (key, value) => {
    let k = aliases[key] || key;
    if (!ranges[k]) {
      return false;
    }
    return ranges[k].containsValue(value);
  };

  /**
   * Checks if a range segment is contained within this brush context
   *
   * Returns true if the range segment exists for the provided key, returns false otherwise.
   *
   * @param {string} key - An identifier that represents the data source of the value
   * @param {object} range - The range to check for
   * @param {number} range.min - Min value of the range
   * @param {number} range.max - Max value of the range
   * @return {boolean}
   * @example
   * brush.addRange('Sales', { min: 10, max: 50 });
   * brush.containsRange('Sales', { min: 15, max: 20 }); // true - the range segment is fully contained within [10, 50]
   * brush.containsRange('Sales', { min: 5, max: 20 }); // false - part of the range segment is outside [10, 50]
   * brush.containsRange('Sales', { min: 30, max: 80 }); // false - part of the range segment is outside [10, 50]
   */
  fn.containsRange = (key, range) => {
    let k = aliases[key] || key;
    if (!ranges[k]) {
      return false;
    }
    return ranges[k].containsRange(range);
  };
  fn.containsMappedData = (d, props, mode) => {
    let status = [];
    const keys = Object.keys(d);
    let key;
    let item;
    let source;
    let value;
    for (let i = 0, num = keys.length; i < num; i++) {
      key = keys[i];
      if (key === 'value') {
        item = d;
        status[i] = {
          key: '',
          i,
          bool: false
        };
      } else if (key === 'source') {
        continue;
      } else {
        item = d[key];
        status[i] = {
          key,
          i,
          bool: false
        };
      }
      source = item.source && item.source.field;
      if (typeof source === 'undefined') {
        continue;
      }
      if (typeof item.source.key !== 'undefined') {
        source = "".concat(item.source.key, "/").concat(source);
      }
      if (source in aliases) {
        source = aliases[source];
      }
      value = item.value;
      if (ranges[source]) {
        status[i].bool = Array.isArray(value) ? ranges[source].containsRange({
          min: value[0],
          max: value[1]
        }) : ranges[source].containsValue(value);
      } else if (values[source] && values[source].contains(value)) {
        status[i].bool = true;
      }
    }
    if (props) {
      status = status.filter(b => props.indexOf(b.key) !== -1);
      if (mode === 'and') {
        return !!status.length && !status.some(s => s.bool === false);
      }
      if (mode === 'xor') {
        return !!status.length && status.some(s => s.bool) && status.some(s => s.bool === false);
      }
      // !mode || mode === 'or'
      return status.some(s => s.bool);
    }
    return status.some(s => s.bool);
  };

  /**
   * Adds an event interceptor
   *
   * @param {string} name Name of the event to intercept
   * @param {function} ic Handler to call before event is triggered
   * @example
   * brush.intercept('add-values', items => {
   *  console.log('about to add the following items', items);
   *  return items;
   * });
   */
  fn.intercept = (name, ic) => {
    const s = toCamelCase(name);
    if (!interceptors[s]) {
      return;
    }
    interceptors[s].push(ic);
  };

  /**
   * Removes an interceptor
   *
   * @param {string} name Name of the event to intercept
   * @param {function} ic Handler to remove
   */
  fn.removeInterceptor = (name, ic) => {
    const s = toCamelCase(name);
    if (!interceptors[s]) {
      return;
    }
    const idx = interceptors[s].indexOf(ic);
    if (idx !== -1) {
      interceptors[s].splice(idx, 1);
    }
  };

  /**
   * Removes all interceptors
   *
   * @param {string} [name] Name of the event to remove interceptors for. If not provided, removes all interceptors.
   */
  fn.removeAllInterceptors = name => {
    const toRemove = [];
    if (name) {
      const s = toCamelCase(name);
      if (interceptors[s] && interceptors[s].length) {
        toRemove.push({
          name,
          handlers: interceptors[s]
        });
      }
    } else {
      Object.keys(interceptors).forEach(n => {
        if (interceptors[n].length) {
          toRemove.push({
            name: toSnakeCase(n),
            handlers: interceptors[n]
          });
        }
      });
    }
    toRemove.forEach(ic => {
      const interceptorHandlers = ic.handlers.slice();
      interceptorHandlers.forEach(handler => fn.removeInterceptor(ic.name, handler));
    });
  };

  /**
   * Adds an alias to the given key
   *
   * @param {string} key - Value to be replaced
   * @param {string} alias - Value to replace key with
   * @example
   * brush.addKeyAlias('BadFieldName', 'Region');
   * brush.addValue('BadFieldName', 'Sweden'); // 'BadFieldName' will be stored as 'Region'
   * brush.containsValue('Region', 'Sweden'); // true
   * brush.containsValue('BadFieldName', 'Sweden'); // true
   */
  fn.addKeyAlias = (key, alias) => {
    aliases[key] = alias;
  };

  /**
   * Removes an alias
   *
   * This will only remove the key to alias mapping for new manipulations of the brush,
   * no changes will be made to the current state of this brush.
   *
   * @param {string} key - Value to remove as alias
   * @example
   * brush.removeKeyAlias('BadFieldName');
   */
  fn.removeKeyAlias = key => {
    delete aliases[key];
  };
  EventEmitter.mixin(fn);
  return fn;
}

registryFactory();

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

/* eslint-disable no-cond-assign */
const colorKeys = ['stroke', 'fill', 'color', 'backgroundColor', 'thumbColor'];
function constant(x) {
  return () => x;
}
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
function genericArray(a, b) {
  const nb = b ? b.length : 0;
  const na = a ? Math.min(nb, a.length) : 0;
  const x = new Array(na);
  const c = new Array(nb);
  let i;
  for (i = 0; i < na; ++i) {
    x[i] = value(a[i], b[i]);
  }
  for (; i < nb; ++i) {
    c[i] = b[i];
  }
  return function interplolate(t) {
    for (i = 0; i < na; ++i) {
      c[i] = x[i](t);
    }
    return c;
  };
}
function value(a, b, k) {
  const t = typeof b;
  let c;
  return b == null || t === 'boolean' ? constant(b) : (t === 'number' ? number$1 : t === 'string' ? (c = color(b)) && colorKeys.includes(k) ? (b = c, rgb) : string : b instanceof color ? rgb : b instanceof Date ? date : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== 'function' && typeof b.toString !== 'function' || isNaN(b) ? object : number$1)(a, b);
}
function object(a, b) {
  const i = {};
  const c = {};
  let k;
  if (a === null || typeof a !== 'object') {
    a = {};
  }
  if (b === null || typeof b !== 'object') {
    b = {};
  }
  for (k in b) {
    if (k in a) {
      i[k] = value(a[k], b[k], k);
    } else {
      c[k] = b[k];
    }
  }
  return function interplolate(t) {
    // eslint-disable-next-line guard-for-in
    for (k in i) {
      c[k] = i[k](t);
    }
    return c;
  };
}

/* globals window */

function nodeId(node, i) {
  if (node.data) {
    return node.data.value;
  }
  if (node.type === 'text') {
    return node.text;
  }
  return i;
}
function findCommonPointsFromTwoLines(oldLine, currentLine) {
  const oldPoints = oldLine.points.filter(point => !point.dummy);
  const currentPoints = currentLine.points.filter(point => !point.dummy);
  const currentPointsValues = currentPoints.map(point => point.data.major.value);
  const commonPointsValues = oldPoints.filter(point => currentPointsValues.includes(point.data.major.value)).map(point => point.data.major.value);
  const oldCommonPoints = oldPoints.filter(point => commonPointsValues.includes(point.data.major.value));
  const currentCommonPoints = currentPoints.filter(point => commonPointsValues.includes(point.data.major.value));
  return {
    old: oldCommonPoints,
    current: currentCommonPoints
  };
}
function tween(_ref, _ref2, config, chartStorage) {
  let {
    old,
    current
  } = _ref;
  let {
    renderer
  } = _ref2;
  let ticker;
  let toBeUpdated = [];
  let entered = {
    nodes: [],
    ips: []
  };
  let exited = {
    nodes: [],
    ips: []
  };
  let updated = {
    nodes: [],
    ips: []
  };
  let stages = [];
  let targetScene = null;
  const trackBy = config.trackBy || nodeId;
  const tweener = {
    start() {
      let ids = {};
      old.forEach((node, i) => {
        let id = trackBy(node, i);
        ids[id] = node;
      });
      current.forEach((node, i) => {
        let id = trackBy(node, i);
        if (ids[id]) {
          if (node.type === 'path' && node.points && node.points.length > 0 && node.data.source.key !== 'trend') {
            const common = findCommonPointsFromTwoLines(ids[id], node);
            updated.ips.push(object(extend$1({}, ids[id], {
              points: common.old
            }), extend$1({}, node, {
              points: common.current
            })));
            toBeUpdated.push(extend$1({}, ids[id], {
              commonPoints: common.old
            }));
          } else {
            updated.ips.push(object(ids[id], node));
            toBeUpdated.push(ids[id]);
          }
          updated.nodes.push(node);
          ids[id] = false;
        } else {
          entered.nodes.push(node);
          entered.ips.push(object(extend$1({}, node, {
            r: 0.001,
            opacity: 0
          }), node));
        }
      });
      Object.keys(ids).forEach(key => {
        if (ids[key]) {
          exited.nodes.push(ids[key]);
          exited.ips.push(object(ids[key], extend$1({}, ids[key], {
            r: 0.0001,
            opacity: 0
          })));
        }
      });
      // Obsolete nodes exiting
      stages.push({
        name: 'exiting',
        easing: cubicIn,
        duration: 200,
        tweens: exited.ips,
        nodes: [...toBeUpdated]
      });
      // Existing nodes updating
      stages.push({
        name: 'updating',
        easing: cubicInOut,
        duration: 400,
        tweens: updated.ips,
        nodes: []
      });
      // New nodes entering
      stages.push({
        name: 'entering',
        easing: cubicOut,
        duration: 200,
        tweens: entered.ips,
        nodes: [...updated.nodes]
      });
      if (config.isMainComponent) {
        var _config$isMainCompone;
        const filterFn = (_config$isMainCompone = config.isMainComponent) === null || _config$isMainCompone === void 0 ? void 0 : _config$isMainCompone.filterFn;
        const nUpdatingNodes = filterFn ? toBeUpdated.filter(filterFn).length : toBeUpdated.length;
        const {
          isInit,
          shouldBeRemoved
        } = chartStorage.getValue('animations.updatingStageMeta');
        if (isInit === false) {
          chartStorage.setValue('animations.updatingStageMeta.shouldBeRemoved', nUpdatingNodes === 0);
          chartStorage.setValue('animations.updatingStageMeta.isInit', true);
        } else {
          chartStorage.setValue('animations.updatingStageMeta.shouldBeRemoved', shouldBeRemoved && nUpdatingNodes === 0);
        }
      }
      // console.log(stages);
      if (stages.length) {
        targetScene = renderer.getScene(current);
        stages[0].started = Date.now();
        if (typeof window !== 'undefined') {
          ticker = window.requestAnimationFrame(tweener.tick);
        }
      }
    },
    tick() {
      let currentStage = stages[0];
      if (!currentStage) {
        tweener.stop();
      }
      if (!currentStage.started) {
        currentStage.started = Date.now();
      }
      let t = (Date.now() - currentStage.started) / currentStage.duration;
      let currentNodes = [];
      let tweenedNodes = currentStage.tweens.map(ip => ip(currentStage.easing(Math.min(1, t))));
      const {
        adjustTweenedNodes
      } = config;
      if (adjustTweenedNodes) {
        adjustTweenedNodes(tweenedNodes);
      }
      currentNodes.push(...tweenedNodes);
      currentNodes.push(...currentStage.nodes);
      renderer.render(currentNodes);
      if (t >= 1) {
        stages.shift();
        const {
          isInit,
          shouldBeRemoved
        } = chartStorage.getValue('animations.updatingStageMeta');
        if (!stages.length) {
          if (isInit === true) {
            chartStorage.setValue('animations.updatingStageMeta.isInit', false);
          }
          tweener.stop();
        } else if (stages[0].name === 'updating' && shouldBeRemoved) {
          stages.shift();
        }
      }
      if (ticker) {
        ticker = window.requestAnimationFrame(tweener.tick);
      }
    },
    stop() {
      if (ticker) {
        window.cancelAnimationFrame(ticker);
        ticker = false;
      }
    },
    inProgress() {
      return !!ticker;
    },
    get targetScene() {
      return targetScene;
    }
  };
  return tweener;
}

const GLOBAL_DEFAULTS = {
  fontFamily: 'Arial',
  fontSize: '13px',
  color: '#595959',
  backgroundColor: '#ffffff',
  stroke: '#000000',
  strokeWidth: 0,
  $fill: '#333333'
};
const REF_RX = /^\$/;
function isPrimitive(x) {
  const type = typeof x;
  return type !== 'object' && type !== 'function' && type !== 'undefined';
}

/**
 * Callback function
 * @callback datumAccessor
 * @param {DatumExtract} d datum
 * @example
 * (d) => Math.min(0, d.value);
 */

/**
 * @typedef {object} DatumConfig
 * @property {string} [scale] - Name of a scale
 * @property {datumAccessor} [fn]
 * @property {string} [ref] - A reference to a DatumExtract property
 * @example
 * // Implicitly resolve the datum by passing a referenced data through the scale
 * {
 *  scale: '<name-of-scale>',
 *  ref: '<data-property>'
 * }
 *
 * // or explicitly resolve the datum using callback function
 * {
 *  fn: (d) => Math.min(0, d.datum.x.value);
 * }
 */

/**
 * Custom type that is either a string, DatumConfig or a datumAccessor
 * @typedef {string|DatumConfig|datumAccessor} DatumString
 */

/**
 * Custom type that is either a number, DatumConfig or a datumAccessor
 * @typedef {number|DatumConfig|datumAccessor} DatumNumber
 */

/**
 * Custom type that is either a boolean, DatumConfig or a datumAccessor
 * @typedef {boolean|DatumConfig|datumAccessor} DatumBoolean
 */

/**
 * Normalizes property settings
 *
 * @ignore
 * @export
 * @param {any} settings
 * @param {any} defaults
 * @param {any} chart
 * @returns {any}
 */
function normalizeSettings(settings, defaults, chart) {
  const composition = extend$1({}, settings);
  const defs = extend$1({}, defaults);
  Object.keys(composition).forEach(key => {
    defs[key] = {};
    const v = composition[key];
    const vType = typeof v;
    if (typeof v === 'function') {
      defs[key].fn = v;
    } else if (isPrimitive(v)) {
      let defaultValue = defaults[key];
      if (typeof defaultValue === 'string' && REF_RX.test(defaultValue)) {
        defaultValue = GLOBAL_DEFAULTS[defaultValue];
      }
      const defaultType = typeof defaultValue;
      if (defaultType === 'undefined') {
        // if property has no default, assign provided value
        defs[key] = v;
      } else {
        // assign provided value if it's of same type as default, otherwise use default
        defs[key] = defaultType === vType ? v : defaultValue;
      }
    } else if (v && typeof v === 'object') {
      if (typeof v.fn === 'function') {
        defs[key].fn = v.fn;
      }
      if (typeof v.scale !== 'undefined') {
        defs[key].scale = chart.scale(v.scale);
      }
      if (typeof v.ref === 'string') {
        defs[key].ref = v.ref;
      }
    }
  });
  Object.keys(defaults).forEach(key => {
    if (key in composition) {
      // don't process same props again
      return;
    }
    const v = defaults[key];
    const defaultType = typeof v;
    if (defaultType === 'string' && REF_RX.test(v)) {
      defs[key] = GLOBAL_DEFAULTS[v];
    } else {
      defs[key] = v;
    }
  });
  return defs;
}
function resolveForItem(context, normalized, idx) {
  const ret = {};
  const keys = Object.keys(normalized);
  const len = keys.length;
  const fallbackData = context.datum;
  const datum = context.datum;
  for (let i = 0; i < len; i++) {
    const key = keys[i];
    const normalizedProp = normalized[key];
    const exists = typeof datum === 'object' && typeof normalizedProp !== 'undefined';
    const hasExplicitDataProp = exists && typeof normalizedProp.ref === 'string';
    const hasImplicitDataProp = exists && key in datum;
    const propData = hasExplicitDataProp ? datum[normalizedProp.ref] : hasImplicitDataProp ? datum[key] : fallbackData; // eslint-disable-line
    if (isPrimitive(normalizedProp)) {
      ret[key] = normalizedProp;
    } else if (exists && normalizedProp.fn) {
      // callback function
      if (normalizedProp.scale) {
        context.scale = normalizedProp.scale;
      }
      ret[key] = normalizedProp.fn.call(null, context, idx);
    } else if (exists && normalizedProp.scale && propData) {
      ret[key] = normalizedProp.scale(propData.value);
      if (normalizedProp.scale.bandwidth) {
        ret[key] += normalizedProp.scale.bandwidth() / 2;
      }
    } else if (hasExplicitDataProp && propData) {
      ret[key] = propData.value;
    } else if (normalizedProp.fn) {
      ret[key] = normalizedProp.fn.call(null, context, idx);
    } else {
      ret[key] = normalizedProp;
    }
  }
  return ret;
}

function updateScaleSize(object, path, size) {
  const o = object[path];
  if (o && o.scale && o.scale.pxScale) {
    o.scale = o.scale.pxScale(size);
  } else if (o && o.pxScale) {
    object[path] = o.pxScale(size);
  }
}
function scaleWithSize(scale, size) {
  return scale.pxScale ? scale.pxScale(size) : scale;
}

const externals = {
  normalizeSettings,
  resolveForItem,
  updateScaleSize
};
function settingsResolver(resources) {
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : externals;
  let cache = {};
  function resolve(_ref) {
    let {
      data,
      settings,
      defaults = {},
      scaled
    } = _ref;
    const norm = cache.norm = deps.normalizeSettings(settings, defaults, resources.chart);
    const res = {
      scale: resources.chart.scale,
      formatter: resources.chart.formatter
    };
    if (scaled) {
      Object.keys(scaled).forEach(key => {
        if (norm[key]) {
          deps.updateScaleSize(norm, key, scaled[key]);
        }
      });
    }
    const resolved = [];
    if (data && Array.isArray(data.items)) {
      let context;
      for (let i = 0, len = data.items.length; i < len; i++) {
        context = {
          datum: data.items[i],
          data,
          resources: res
        };
        let obj = deps.resolveForItem(context, cache.norm, i);
        obj.data = data.items[i];
        resolved.push(obj);
      }
    } else {
      const context = {
        data,
        resources: res
      };
      let obj = deps.resolveForItem(context, cache.norm, -1);
      return {
        settings: cache.norm,
        item: obj
      };
    }
    return {
      settings: cache.norm,
      items: resolved
    };
  }
  return {
    resolve
  };
}

/**
 * Flatten the array of nodes by removing any containers as they do not support styling, thus unable to brush them.
 * @param {array} nodes
 * @ignore
 */
function reduceToLeafNodes() {
  let nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return nodes.reduce((ary, node) => {
    if (Array.isArray(node.children)) {
      ary.push(...reduceToLeafNodes(node.children));
      return ary;
    }
    ary.push(node);
    return ary;
  }, []);
}
function styler(obj, _ref) {
  let {
    context,
    data,
    style,
    filter,
    mode
  } = _ref;
  const brusher = obj.chart.brush(context);
  const dataProps = data;
  const active = style.active || {};
  const inactive = style.inactive || {};
  const styleProps = [];
  Object.keys(active).forEach(key => {
    styleProps.push(key);
  });
  Object.keys(inactive).forEach(key => {
    if (styleProps.indexOf(key) === -1) {
      styleProps.push(key);
    }
  });
  const activeNodes = [];
  let globalActivation = false; // track when we need to loop through all nodes, not just the active ones

  const getNodes = () => {
    let nodes = reduceToLeafNodes(obj.nodes);
    if (typeof filter === 'function') {
      nodes = nodes.filter(filter);
    }
    return nodes;
  };
  const update = () => {
    // TODO - render nodes only once, i.e. don't render for each brush, update nodes for all brushes and then render
    const nodes = getNodes();
    const len = nodes.length;
    let nodeData;
    let globalChanged = false;
    const evaluatedDataProps = typeof dataProps === 'function' ? dataProps({
      brush: brusher
    }) : dataProps;

    // To calculate active nodes
    for (let i = 0; i < len; i++) {
      // TODO - update only added and removed nodes
      nodeData = nodes[i].data;
      if (!nodeData) {
        continue;
      }
      if (!nodes[i].__style) {
        nodes[i].__style = {};
        styleProps.forEach(s => {
          nodes[i].__style[s] = nodes[i][s]; // store original value
        });
      }
      const isActive = brusher.containsMappedData(nodeData, evaluatedDataProps, mode);
      const activeIdx = activeNodes.indexOf(nodes[i]);
      let changed = false;
      if (isActive && activeIdx === -1) {
        // activated
        activeNodes.push(nodes[i]);
        changed = true;
      } else if (!isActive && activeIdx !== -1) {
        // was active
        activeNodes.splice(activeIdx, 1);
        changed = true;
      }
      nodes[i].needToUpdate = changed || globalActivation;
      nodes[i].isActive = isActive;
    }

    // To calculate style
    for (let i = 0; i < len; i++) {
      // TODO - update only added and removed nodes
      nodeData = nodes[i].data;
      if (!nodeData) {
        continue;
      }
      if (nodes[i].needToUpdate) {
        const original = extend$1({}, nodes[i], nodes[i].__style);
        const isActive = nodes[i].isActive;
        styleProps.forEach(s => {
          if (isActive && s in active) {
            nodes[i][s] = typeof active[s] === 'function' ? active[s].call(null, original, activeNodes) : active[s];
          } else if (!isActive && s in inactive) {
            nodes[i][s] = typeof inactive[s] === 'function' ? inactive[s].call(null, original, activeNodes) : inactive[s];
          } else {
            nodes[i][s] = nodes[i].__style[s];
          }
        });
        globalChanged = true;
      }
      delete nodes[i].needToUpdate;
    }
    globalActivation = false;
    return globalChanged;
  };
  const onStart = function () {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      suppressRender: false
    };
    const {
      suppressRender
    } = opts;
    const nodes = getNodes();
    const len = nodes.length;
    for (let i = 0; i < len; i++) {
      if (!nodes[i].data) {
        continue;
      }
      nodes[i].__style = nodes[i].__style || {};
      styleProps.forEach(s => {
        nodes[i].__style[s] = nodes[i][s]; // store original value
        if (s in inactive) {
          nodes[i][s] = typeof inactive[s] === 'function' ? inactive[s].call(null, nodes[i]) : inactive[s];
        }
      });
    }
    globalActivation = true;
    activeNodes.length = 0;
    if (!suppressRender) {
      obj.renderer.render(obj.nodes);
    }
  };
  const onEnd = function () {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      suppressRender: false
    };
    const {
      suppressRender
    } = opts;
    const nodes = getNodes();
    const len = nodes.length;
    for (let i = 0; i < len; i++) {
      if (nodes[i].__style) {
        Object.keys(nodes[i].__style).forEach(s => {
          nodes[i][s] = nodes[i].__style[s];
        });
        nodes[i].__style = undefined;
      }
    }
    activeNodes.length = 0;
    if (!suppressRender) {
      obj.renderer.render(obj.nodes);
    }
  };
  const onUpdate = () => {
    const changed = update();
    if (changed) {
      const renderedNodes = typeof obj.config.sortNodes === 'function' ? obj.config.sortNodes(obj) : obj.nodes;
      if (typeof obj.config.customRender === 'function') {
        obj.config.customRender({
          render: obj.renderer.render,
          nodes: renderedNodes
        });
      } else {
        obj.renderer.render(renderedNodes);
      }
    }
  };
  const externalUpdate = () => {
    activeNodes.length = 0;
    globalActivation = true;
    update();
  };
  brusher.on('start', onStart);
  brusher.on('end', onEnd);
  brusher.on('update', onUpdate);
  function cleanUp() {
    brusher.removeListener('start', onStart);
    brusher.removeListener('end', onEnd);
    brusher.removeListener('update', onUpdate);
  }
  return {
    isActive() {
      return brusher.isActive();
    },
    update: externalUpdate,
    cleanUp
  };
}
function brushDataPoints(_ref2) {
  let {
    dataPoints,
    action,
    chart,
    trigger
  } = _ref2;
  if (!trigger) {
    return;
  }
  const dataProps = trigger.data || [''];
  let rangeBrush = {
    items: [],
    actionFn: 'toggleRanges'
  };
  let valueBrush = {
    items: [],
    actionFn: 'toggleValues'
  };
  if (['add', 'remove', 'set', 'toggle'].indexOf(action) !== -1) {
    rangeBrush.actionFn = "".concat(action, "Ranges");
    valueBrush.actionFn = "".concat(action, "Values");
  }
  for (let i = 0; i < dataPoints.length; i++) {
    const dataPoint = dataPoints[i];
    if (!dataPoint) {
      continue;
    }
    dataProps.forEach(p => {
      let d = dataPoint && !p ? dataPoint : dataPoint[p];
      if (d) {
        let it = {
          key: d.source.field
        };
        if (typeof d.source.key !== 'undefined') {
          it.key = "".concat(d.source.key, "/").concat(d.source.field);
        }
        if (Array.isArray(d.value)) {
          it.range = {
            min: d.value[0],
            max: d.value[1]
          };
          rangeBrush.items.push(it);
        } else {
          it.value = d.value;
          valueBrush.items.push(it);
        }
      }
    });
  }
  trigger.contexts.forEach(c => {
    if (rangeBrush.items.length) {
      chart.brush(c)[rangeBrush.actionFn](rangeBrush.items);
    } else {
      chart.brush(c)[valueBrush.actionFn](valueBrush.items); // call action even if there are items to potentially clear what is currently in the brush
    }
  });
}
function brushFromSceneNodes(_ref3) {
  let {
    nodes,
    action,
    chart,
    trigger
  } = _ref3;
  const dataPoints = [];
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    let nodeData = node.data;
    if (nodeData !== null) {
      dataPoints.push(nodeData);
    }
  }
  brushDataPoints({
    dataPoints,
    action,
    chart,
    trigger
  });
}
function resolveEvent(_ref4) {
  let {
    collisions,
    t,
    config,
    action
  } = _ref4;
  let brushCollisions = [];
  let resolved = false;
  if (collisions.length > 0) {
    brushCollisions = collisions;
    resolved = true;
    if (t.propagation === 'stop') {
      brushCollisions = [collisions[collisions.length - 1]];
    }
  }
  const nodes = brushCollisions.map(c => c.node);
  brushFromSceneNodes({
    nodes,
    action,
    chart: config.chart,
    data: config.data,
    trigger: t
  });
  return resolved;
}
function touchSingleContactPoint(e, rect) {
  if (e.changedTouches.length !== 1) {
    return null;
  }
  return {
    x: e.changedTouches[0].clientX - rect.left,
    y: e.changedTouches[0].clientY - rect.top
  };
}
function singleContactPoint(e, rect) {
  return {
    x: e.clientX - rect.left,
    y: e.clientY - rect.top
  };
}
function resolveCollisions(e, t, renderer) {
  const rect = renderer.element().getBoundingClientRect();
  let p = isTouchEvent(e) ? touchSingleContactPoint(e, rect) : singleContactPoint(e, rect);
  if (p === null || p.x < 0 || p.y < 0 || p.x > rect.width || p.y > rect.height) {
    // TODO include radius in this check?
    return [];
  }
  if (t.touchRadius > 0 && isTouchEvent(e)) {
    p = {
      cx: p.x,
      cy: p.y,
      r: t.touchRadius // TODO Use touch event radius/width value (Need to handle dpi scaling as well)
    };
  } else if (t.mouseRadius > 0 && !isTouchEvent(e)) {
    p = {
      cx: p.x,
      cy: p.y,
      r: t.mouseRadius
    };
  }
  return renderer.itemsAt(p);
}
function resolveAction(action, e, def) {
  if (action) {
    if (typeof action === 'function') {
      return action(e);
    }
    return action;
  }
  return def;
}
function resolveTapEvent(_ref5) {
  let {
    e,
    t,
    config
  } = _ref5;
  const collisions = resolveCollisions(e, t, config.renderer);
  return resolveEvent({
    collisions,
    t,
    config,
    action: resolveAction(t.action, e, 'toggle')
  });
}
function resolveOverEvent(_ref6) {
  let {
    e,
    t,
    config
  } = _ref6;
  const collisions = resolveCollisions(e, t, config.renderer);
  return resolveEvent({
    collisions,
    t,
    config,
    action: resolveAction(t.action, e, 'set')
  });
}

/**
 * A list of supported attributes in lower camelCase notation mapped to corresponding kebab-case notation.
 * The kebab-case notations are a sub-set of SVG attributes (https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute).
 * @ignore
 * @private
 */
const mappedAttributes = {
  fill: 'fill',
  stroke: 'stroke',
  opacity: 'opacity',
  strokeWidth: 'stroke-width',
  strokeLinejoin: 'stroke-linejoin',
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontStyle: 'font-style',
  textDecoration: 'text-decoration',
  fontWeight: 'font-weight',
  baseline: 'dominant-baseline',
  // Special case where we have defined our own attribute name
  dominantBaseline: 'dominant-baseline',
  anchor: 'text-anchor',
  // Special case where we have defined our own attribute name
  textAnchor: 'text-anchor',
  maxWidth: 'maxWidth',
  transform: 'transform',
  strokeDasharray: 'stroke-dasharray',
  id: 'id'
};

/**
 * Takes a target object and assign each supported attribute from a source object to that target.
 * Each supported attributes is converted to a mapped kebab-case notation.
 * @ignore
 * @private
 * @param {object} target - Target object on which to assign mapped attribute values
 * @param {object} source - Source object
 */
function assignMappedAttribute(target, source) {
  Object.keys(mappedAttributes).forEach(key => {
    const sourceValue = source[key];
    if (typeof sourceValue !== 'undefined') {
      const mappedKey = mappedAttributes[key];
      target[mappedKey] = sourceValue;
    }
  });
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolCircle
 */
function circle(options) {
  return {
    type: 'circle',
    fill: 'black',
    cx: options.x,
    cy: options.y,
    r: options.size / 2
  };
}

function pointsToPath(points) {
  let close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let d = '';
  for (let i = 0; i < points.length; i++) {
    const p = points[i];
    if (i === 0) {
      d += "M".concat(p.x, " ").concat(p.y);
    } else {
      d += "L".concat(p.x, " ").concat(p.y);
    }
    d += ' ';
  }
  if (close) {
    d += 'Z';
  }
  return d;
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolDiamond
 */
function diamond(options) {
  const size = options.size;
  const left = options.x - size / 2;
  const top = options.y - size / 2;
  const points = [{
    x: left,
    y: top + size / 2
  }, {
    x: left + size / 2,
    y: top
  }, {
    x: left + size,
    y: top + size / 2
  }, {
    x: left + size / 2,
    y: top + size
  }, {
    x: left,
    y: top + size / 2
  }];
  return {
    type: 'path',
    fill: 'black',
    d: pointsToPath(points)
  };
}

function generateCrossPoints(x, y, size, barWidth) {
  const r = size / 2;
  const innerLeft = x - barWidth / 2;
  const innerTop = y - barWidth / 2;
  const left = x - r;
  const top = y - r;
  return [{
    x: innerLeft,
    y: innerTop
  },
  // Top
  {
    x: innerLeft,
    y: top
  }, {
    x: innerLeft + barWidth,
    y: top
  }, {
    x: innerLeft + barWidth,
    y: innerTop
  },
  // Right
  {
    x: left + size,
    y: innerTop
  }, {
    x: left + size,
    y: innerTop + barWidth
  }, {
    x: innerLeft + barWidth,
    y: innerTop + barWidth
  },
  // Bottom
  {
    x: innerLeft + barWidth,
    y: top + size
  }, {
    x: innerLeft,
    y: top + size
  }, {
    x: innerLeft,
    y: innerTop + barWidth
  },
  // Left
  {
    x: left,
    y: innerTop + barWidth
  }, {
    x: left,
    y: innerTop
  }];
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolCross
 * @property {number} [width] - Width of the diagonals
 */
function cross(options) {
  const x = options.x;
  const y = options.y;
  const r = options.size / 2;
  const width = isNaN(options.width) ? r / 2 : options.width;
  const barWidth = Math.min(width, r);
  const points = generateCrossPoints(x, y, options.size, barWidth);
  return {
    type: 'path',
    fill: 'black',
    d: pointsToPath(points)
  };
}

/**
 * Get x1, y1, x2, y2 point from angle
 * Source: {@link https://codepen.io/NV/pen/jcnmK}
 * @private
 *
 * @param  {number} angle Radians
 * @return {object}       Point with x1, y2, x2, y2.
 */
function angleToPoints(angle) {
  let segment = Math.floor(angle / Math.PI * 2) + 2;
  let diagonal = (0.5 * segment + 0.25) * Math.PI;
  let op = Math.cos(Math.abs(diagonal - angle)) * Math.sqrt(2);
  let x = op * Math.cos(angle);
  let y = op * Math.sin(angle);
  return {
    x1: x < 0 ? 1 : 0,
    y1: y < 0 ? 1 : 0,
    x2: x >= 0 ? x : x + 1,
    y2: y >= 0 ? y : y + 1
  };
}

/**
 * Turns degrees into radians
 * @private
 *
 * @param  {number} degrees Degrees
 * @return {number}         Radians
 */
function toRadians(d) {
  return -d / 180 * Math.PI;
}

/**
 * Get x1, y1, x2, y2 point from degree
 * @private
 *
 * @param  {number} d Degree
 * @return {object}   Point with x1, y2, x2, y2.
 */
function degreesToPoints(d) {
  return angleToPoints(toRadians(d));
}

function add(v1, v2) {
  return {
    x: v1.x + v2.x,
    y: v1.y + v2.y
  };
}
function sub(v1, v2) {
  return {
    x: v1.x - v2.x,
    y: v1.y - v2.y
  };
}
function scalarMultiply(v, s) {
  return {
    x: v.x * s,
    y: v.y * s
  };
}
function distanceX(v1, v2) {
  return v1.x - v2.x;
}
function distanceY(v1, v2) {
  return v1.y - v2.y;
}
function sqrDistance(v1, v2) {
  return distanceX(v1, v2) ** 2 + distanceY(v1, v2) ** 2;
}
function distance(v1, v2) {
  return Math.sqrt(sqrDistance(v1, v2));
}
function dot(v1, v2) {
  return v1.x * v2.x + v1.y * v2.y;
}
function projectOnto(v1, v2) {
  const m = dot(v1, v2) / dot(v2, v2) || 1;
  return {
    x: v2.x * m,
    y: v2.y * m
  };
}
function rotate(v, radians) {
  let origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    x: 0,
    y: 0
  };
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const t1 = sub(v, origin);
  const t2 = {
    x: cos * t1.x - sin * t1.y,
    y: sin * t1.x + cos * t1.y
  };
  return add(t2, origin);
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolSaltire
 * @property {number} [width] - Width of the diagonals
 */
function saltire(options) {
  const radians = toRadians(45);
  const r = options.size / 2;
  const width = isNaN(options.width) ? r / 2 : options.width;
  const barWidth = Math.min(width, r);
  let adjustedSize = options.size;

  // Adjust for the barwidth and rotation angle, so that the visual part is always inside the symbol area
  const h = Math.sin(Math.asin(-radians)) * (barWidth / 2);
  const c = r / Math.sin(-radians);
  adjustedSize += (c - r) * 2;
  adjustedSize -= h * 2;
  const centroid = {
    x: options.x,
    y: options.y
  };
  const points = generateCrossPoints(options.x, options.y, adjustedSize, barWidth).map(p => rotate(p, radians, centroid));
  return {
    type: 'path',
    fill: 'black',
    d: pointsToPath(points)
  };
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolSquare
 */
function square(options) {
  const size = options.size;
  return {
    type: 'rect',
    fill: 'black',
    x: options.x - size / 2,
    y: options.y - size / 2,
    width: size,
    height: size
  };
}

const DIRECTION_TO_ANGLE = {
  up: 0,
  down: 180,
  left: 90,
  right: -90
};

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolTriangle
 * @property {string} [direction='up'] - Direction of the triangle ('up'|'down'|'left'|'right')
 */
function triangle(options) {
  const size = options.size;
  const p = {
    x: options.x,
    y: options.y
  };
  const directionAngle = DIRECTION_TO_ANGLE[options.direction] || 0;
  const halfSize = size / 2;
  const left = options.x - halfSize;
  const top = options.y - halfSize;
  let points = [{
    x: left,
    y: top + size
  }, {
    x: left + halfSize,
    y: top
  }, {
    x: left + size,
    y: top + size
  }, {
    x: left,
    y: top + size
  }];
  const radians = toRadians(directionAngle);
  points = points.map(pp => rotate(pp, radians, p));
  return {
    type: 'path',
    fill: 'black',
    d: pointsToPath(points)
  };
}

function createRectCollider(_ref) {
  let {
    x,
    y,
    size
  } = _ref;
  const r = size / 2;
  return {
    type: 'rect',
    x: x - r,
    y: y - r,
    width: size,
    height: size
  };
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolLine
 * @property {string} [direction='horizontal'] - Direction of line ('horizontal'|'vertical').
 */
function line$1(options) {
  const isVertical = options.direction === 'vertical';
  const r = options.size / 2;
  const x = options.x;
  const y = options.y;
  return {
    type: 'line',
    stroke: 'black',
    strokeWidth: 1,
    x1: x - (isVertical ? 0 : r),
    y1: y - (isVertical ? r : 0),
    x2: x + (isVertical ? 0 : r),
    y2: y + (isVertical ? r : 0),
    collider: createRectCollider(options) // TODO Use visual collider?
  };
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolStar
 * @property {number} [points=5] - Number of points on the star
 * @property {number} [startAngle=90] - Start drawing angle
 * @property {number} [innerRadius=size/2] - Size of the star core. My not exceed size of symbol.
 */
function star(options) {
  const size = options.size;
  const points = [];
  const outerRadius = size / 2;
  const drawPoints = options.points || 5;
  const innerRadius = Math.min(options.innerRadius || size / 2, size) / 2;
  const startAngle = isNaN(options.startAngle) ? 90 : options.startAngle;
  const angle = 360 / drawPoints;
  for (let i = 1; i <= drawPoints; i++) {
    const pAngle = angle * i + startAngle;
    const radians = toRadians(pAngle);
    const innerRadians = toRadians(pAngle + angle / 2);
    const y = Math.sin(radians);
    const x = Math.cos(radians);
    const iy = Math.sin(innerRadians);
    const ix = Math.cos(innerRadians);
    points.push({
      x: options.x + x * outerRadius,
      y: options.y + y * outerRadius
    });
    points.push({
      x: options.x + ix * innerRadius,
      y: options.y + iy * innerRadius
    });
  }
  return {
    type: 'path',
    fill: 'black',
    d: pointsToPath(points)
  };
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolPolygon
 * @property {object} [sides=6] - Number of sides on the regular polygon
 * @property {object} [startAngle=0] - Start drawing angle
 */
function nPolygon(options) {
  const points = [];
  const radius = options.size / 2;
  const drawPoints = Math.max(isNaN(options.sides) ? 6 : options.sides, 3);
  const angle = 360 / drawPoints;
  const startAngle = isNaN(options.startAngle) ? 0 : options.startAngle;
  for (let i = 1; i <= drawPoints; i++) {
    const radians = toRadians(angle * i + startAngle);
    const y = Math.sin(radians);
    const x = Math.cos(radians);
    points.push({
      x: options.x + x * radius,
      y: options.y + y * radius
    });
  }
  return {
    type: 'path',
    fill: 'black',
    d: pointsToPath(points)
  };
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolBar
 * @property {string} [direction='horizontal'] - Direction of bar ('horizontal'|'vertical').
 */
function bar(options) {
  const p = {
    x: options.x,
    y: options.y
  };
  const isVertical = options.direction === 'vertical';
  const r = options.size / 2;
  const width = r / 2;
  const halfWidth = width / 2;
  let points = [{
    x: p.x - r,
    y: p.y + halfWidth
  }, {
    x: p.x - r,
    y: p.y - halfWidth
  }, {
    x: p.x + r,
    y: p.y - halfWidth
  }, {
    x: p.x + r,
    y: p.y + halfWidth
  }];
  if (isVertical) {
    const radians = toRadians(90);
    points = points.map(pp => rotate(pp, radians, p));
  }
  const rect = pointsToRect(points);
  rect.type = 'rect';
  rect.fill = 'black';
  return rect;
}

/**
 * @private
 * @extends Symbol
 * @typedef {object} SymbolRect
 */
function rect(options) {
  const {
    x,
    y,
    size
  } = options;
  const width = typeof options.width === 'undefined' ? size : options.width;
  const height = typeof options.height === 'undefined' ? size : options.height;
  return {
    type: 'rect',
    fill: 'black',
    x: x - width / 2,
    y: y - height / 2,
    width,
    height
  };
}

const parentReg = registryFactory();
parentReg.add('circle', circle);
parentReg.add('diamond', diamond);
parentReg.add('saltire', saltire);
parentReg.add('square', square);
parentReg.add('triangle', triangle);
parentReg.add('line', line$1);
parentReg.add('star', star);
parentReg.add('n-polygon', nPolygon);
parentReg.add('cross', cross);
parentReg.add('bar', bar);
parentReg.add('rect', rect);
function applyOpts(obj) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(opts).forEach(key => {
    if (typeof mappedAttributes[key] !== 'undefined' && key !== 'transform') {
      obj[key] = opts[key];
    }
  });
}

/**
 * Factory function for symbols.
 * Options object is passed to symbols function.
 * @private
 * @param {SymbolRect|SymbolBar|SymbolCircle|SymbolCross|SymbolDiamond|SymbolLine|SymbolPolygon|SymbolSaltire|SymbolSquare|SymbolStar|SymbolTriangle} options - Options definition may contain any of the supported display-object attributes
 * @returns {object} A node definition
 */
const create$m = function () {
  let reg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : parentReg;
  return function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO handle reserverd properties x, y, size, data, etc..
    const fn = reg.get(options.type);
    if (fn) {
      const s = fn(options);
      applyOpts(s, options);
      if (typeof options.data !== 'undefined') {
        s.data = options.data;
      }
      return s;
    }
    return fn;
  };
};

/**
 * Mandatory symbol config
 * @private
 * @typedef {object} Symbol
 * @property {object} options - Options definition may contain any of the supported display-object attributes
 * @property {string} options.type - Type of symbol
 * @property {number} options.x - x-coordinate
 * @property {number} options.y - y-coordinate
 * @property {number} options.size
 * @property {object} [options.data]
 */

/**
 * Initilize a new dock configuration
 * @private
 * @param {object} [settings] - Settings object
 * @returns {object} A dock configuration instance
 * @example
 * let instance = create({
 *  dock: 'left',
 *  displayOrder: 2,
 *  prioOrder: 1,
 *  preferredSize: 33,
 *  minimumLayoutMode: 'L',
 *  show: true
 * });
 */
function create$l() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let callbackContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let {
    dock = 'center',
    displayOrder = 0,
    prioOrder = 0,
    preferredSize = 0,
    minimumLayoutMode,
    show = true
  } = settings;

  // avoid empty string dock
  dock = dock || 'center';

  /**
   * @private
   * @alias dockConfig
   * @interface
   */
  const dockConfig = {
    /**
     * Returns the preferred size of a component.
     * The return value of the function can either be a number representing the required size in the dock direction
     * or an object with a `size` and `edgeBleed` property.
     * @param {object} [inner]
     * @param {object} [outer]
     * @returns {number|object} Returns the computed preferred size
     * @example
     * dockConfig.computePreferredSize(() => 150); // Require a size of 150 in the dock direction
     *
     * dockConfig.computePreferredSize(() => ({
     *  size: 150,
     *  edgeBleed: {
     *    left: 50,
     *    right: 50
     *  }
     * })); // Require a size of 150 in the dock direction and a bleed size of 50 to the left and right dock direction
     */
    computePreferredSize(_ref) {
      let {
        inner,
        outer,
        children
      } = _ref;
      if (typeof preferredSize === 'function') {
        return preferredSize({
          inner,
          outer,
          children,
          dock: this.dock()
        }, callbackContext);
      }
      return preferredSize;
    },
    /**
     * Set the dock direction, supported values are left | right | top | bottom. Any other value will be interpreted as center dock.
     * @param {string} [val=''] - Dock direction
     * @returns {this} The current context
     * @example
     * dockConfig.dock('left');
     */
    dock(val) {
      if (typeof val !== 'undefined') {
        dock = val;
        return this;
      }
      return typeof dock === 'function' ? dock(callbackContext) : dock;
    },
    /**
     * The `displayOrder` property is used by the layout engine to lay out components.
     * Components are interpreted in the ascending order of the `displayOrder` value. The layout engine apply the value in two ways,
     * the first is the order in which components are rendererd. The second is the area components are laid out in
     * when they have a direction, i.e. docked to either top, bottom, left or right.
     *
     * If docked at the same area, the component with a higher `displayOrder` will be rendered
     * on top of the component with a lower `displayOrder`. It can be seen as defining a z-index.
     * A lower `displayOrder` also means that a component will be laid out first in a given direction,
     * i.e. laid out closer to the central area (non-directional area) then a component with a higher `displayOrder`.
     * It can in this case be seen as the x-index or y-index.
     * @param {number} [val=0] - The display order
     * @returns {this|number} The current context or display order
     * @example
     * dockConfig.displayOrder(99);
     */
    displayOrder(val) {
      if (typeof val !== 'undefined') {
        displayOrder = val;
        return this;
      }
      return typeof displayOrder === 'function' ? displayOrder(callbackContext) : displayOrder;
    },
    /**
     * The `prioOrder` property is used to define the order in which components are added to the layout engine,
     * this is done before any components are laid out. When there is not enough space to add any more components
     * to a given area, all components not all ready added, are then discarded. The `prioOrder` is interpreted
     * in the ascending order. Such that a lower value is added to the layout engine first.
     * @param {number} [val=0] - The prio order
     * @returns {this|number} The current context or prio order
     * @example
     * dockConfig.prioOrder(-1);
     */
    prioOrder(val) {
      if (typeof val !== 'undefined') {
        prioOrder = val;
        return this;
      }
      return typeof prioOrder === 'function' ? prioOrder(callbackContext) : prioOrder;
    },
    /**
     * Ger or set the minimumLayoutMode
     * @param {string|object} [val] - The minimum layout mode
     * @returns {string|object|this} If no parameter is passed the current context is returned, else the current layout mode.
     * @example
     * dockConfig.minimumLayoutMode('L');
     * dockConfig.minimumLayoutMode({ width: 'S', height: 'L' });
     */
    minimumLayoutMode(val) {
      if (typeof val !== 'undefined') {
        minimumLayoutMode = val;
        return this;
      }
      return typeof minimumLayoutMode === 'function' ? minimumLayoutMode(callbackContext) : minimumLayoutMode;
    },
    /**
     * Set the component visibility. If false the component is not added to the layout engine.
     * @param {boolean} [val=true] - Toggle visibility
     * @returns {this|boolean} The current context or show
     */
    show(val) {
      if (typeof val !== 'undefined') {
        show = val;
        return this;
      }
      return typeof show === 'function' ? show(callbackContext) : show;
    }
  };
  return dockConfig;
}

const isReservedProperty = prop => ['on', 'preferredSize', 'created', 'beforeMount', 'mounted', 'resize', 'beforeUpdate', 'updated', 'beforeRender', 'render', 'beforeUnmount', 'beforeDestroy', 'destroyed', 'defaultSettings', 'data', 'settings', 'formatter', 'scale', 'chart', 'dockConfig', 'mediator', 'style', 'resolver', 'registries', '_DO_NOT_USE_getInfo', 'symbol', 'isVisible'].some(name => name === prop);
function prepareContext(ctx, definition, opts) {
  const {
    require = []
  } = definition;
  const mediatorSettings = definition.mediator || {};
  const {
    settings,
    formatter,
    scale,
    data,
    renderer,
    chart,
    dockConfig,
    mediator,
    instance,
    rect,
    style,
    registries,
    resolver,
    update,
    _DO_NOT_USE_getInfo,
    symbol,
    isVisible
  } = opts;
  ctx.emit = () => {};
  if (isVisible) {
    ctx.isVisible = isVisible;
  }

  // TODO add setters and log warnings / errors to console
  Object.defineProperty(ctx, 'settings', {
    get: settings
  });
  Object.defineProperty(ctx, 'data', {
    get: data
  });
  Object.defineProperty(ctx, 'formatter', {
    get: formatter
  });
  Object.defineProperty(ctx, 'scale', {
    get: scale
  });
  Object.defineProperty(ctx, 'mediator', {
    get: mediator
  });
  Object.defineProperty(ctx, 'style', {
    get: style
  });
  Object.defineProperty(ctx, 'registries', {
    get: registries
  });
  if (rect) {
    Object.defineProperty(ctx, 'rect', {
      get: rect
    });
  }

  // TODO _DO_NOT_USE_getInfo is a temporary solution to expose info from a component
  // It should replace ASAP with a proper solution.
  // The only component activaly in need of it is the legend-cat
  if (_DO_NOT_USE_getInfo) {
    ctx._DO_NOT_USE_getInfo = _DO_NOT_USE_getInfo;
  }
  Object.keys(definition).forEach(key => {
    if (!isReservedProperty(key)) {
      // Add non-lifecycle methods to the context
      if (typeof definition[key] === 'function') {
        ctx[key] = definition[key].bind(ctx);
      } else {
        ctx[key] = definition[key];
      }
    }
  });

  // Add properties to context
  require.forEach(req => {
    if (req === 'renderer') {
      Object.defineProperty(ctx, 'renderer', {
        get: renderer
      });
    } else if (req === 'chart') {
      Object.defineProperty(ctx, 'chart', {
        get: chart
      });
    } else if (req === 'dockConfig') {
      Object.defineProperty(ctx, 'dockConfig', {
        get: dockConfig
      });
    } else if (req === 'instance') {
      Object.defineProperty(ctx, 'instance', {
        get: instance
      });
    } else if (req === 'update' && update) {
      Object.defineProperty(ctx, 'update', {
        get: update
      });
    } else if (req === 'resolver') {
      Object.defineProperty(ctx, 'resolver', {
        get: resolver
      });
    } else if (req === 'symbol') {
      Object.defineProperty(ctx, 'symbol', {
        get: symbol
      });
    }
  });
  Object.keys(mediatorSettings).forEach(eventName => {
    ctx.mediator.on(eventName, mediatorSettings[eventName].bind(ctx));
  });
}
function createDockDefinition(settings, preferredSize, logger) {
  const getLayoutProperty = propName => {
    if (settings[propName]) {
      logger.warn("Deprecation Warning the ".concat(propName, " property should be moved into layout: {} property")); // eslint-disable-line no-console
      return settings[propName];
    }
    return settings.layout ? settings.layout[propName] : undefined;
  };
  const def = {};
  def.displayOrder = getLayoutProperty('displayOrder');
  def.dock = getLayoutProperty('dock');
  def.prioOrder = getLayoutProperty('prioOrder');
  def.minimumLayoutMode = getLayoutProperty('minimumLayoutMode');

  // move layout properties to layout object
  settings.layout = settings.layout || {};
  settings.layout.displayOrder = typeof def.displayOrder !== 'undefined' ? def.displayOrder : settings.layout.displayOrder;
  settings.layout.prioOrder = typeof def.prioOrder !== 'undefined' ? def.prioOrder : settings.layout.prioOrder;
  settings.layout.dock = def.dock || settings.layout.dock;
  settings.layout.minimumLayoutMode = def.minimumLayoutMode || settings.layout.minimumLayoutMode;

  // not directly a dock layout property
  def.show = settings.show;
  def.preferredSize = preferredSize;
  return def;
}
function setUpEmitter(ctx, emitter, settings) {
  // Object.defineProperty(ctx, 'emitter', )
  Object.keys(settings.on || {}).forEach(event => {
    ctx.eventListeners = ctx.eventListeners || [];
    const listener = settings.on[event].bind(ctx);
    ctx.eventListeners.push({
      event,
      listener
    });
    emitter.on(event, listener);
  });
  ctx.emit = function (name) {
    for (var _len = arguments.length, event = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      event[_key - 1] = arguments[_key];
    }
    return emitter.emit(name, ...event);
  };
}
function tearDownEmitter(ctx, emitter) {
  if (ctx.eventListeners) {
    ctx.eventListeners.forEach(_ref => {
      let {
        event,
        listener
      } = _ref;
      emitter.removeListener(event, listener);
    });
    ctx.eventListeners.length = 0;
  }
  ctx.emit = () => {};
}

// First render
// preferredSize -> resize -> beforeRender -> render -> mounted

// Normal update
// beforeUpdate -> preferredSize -> resize -> beforeRender -> render -> updated

// Update without relayout
// beforeUpdate -> beforeRender -> render -> updated

// TODO support es6 classes
function componentFactory(definition) {
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    defaultSettings = {},
    _DO_NOT_USE_getInfo = () => ({})
  } = definition;
  const {
    chart,
    container,
    mediator,
    registries,
    theme,
    renderer // Used by tests
  } = context;
  const emitter = EventEmitter.mixin({});
  let config = context.settings || {};
  let settings = extend$1(true, {}, defaultSettings, config);
  let data = [];
  let scale;
  let formatter;
  let element;
  let size;
  let style;
  let resolver = settingsResolver({
    chart
  });
  let isVisible = false;
  const brushArgs = {
    nodes: [],
    chart,
    config: settings.brush || {},
    renderer: null
  };
  const brushTriggers = {
    tap: [],
    over: []
  };
  const brushStylers = [];
  const definitionContext = {};
  const instanceContext = extend$1({}, config);

  // Create a callback that calls lifecycle functions in the definition and config (if they exist).
  function createCallback(method) {
    let defaultMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    let canBeValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function cb() {
      const inDefinition = typeof definition[method] !== 'undefined';
      const inConfig = typeof config[method] !== 'undefined';
      let returnValue;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (inDefinition) {
        if (typeof definition[method] === 'function') {
          returnValue = definition[method].call(definitionContext, ...args);
        } else if (canBeValue) {
          returnValue = definition[method];
        }
      }
      if (inConfig) {
        if (typeof config[method] === 'function') {
          returnValue = config[method].call(instanceContext, ...args);
        } else if (canBeValue) {
          returnValue = config[method];
        }
      }
      if (!inDefinition && !inConfig) {
        returnValue = defaultMethod.call(definitionContext, ...args);
      }
      return returnValue;
    };
  }
  const preferredSize = createCallback('preferredSize', () => 0, true);
  const resize = createCallback('resize', _ref2 => {
    let {
      inner
    } = _ref2;
    return inner;
  });
  const created = createCallback('created');
  const beforeMount = createCallback('beforeMount');
  const mounted = createCallback('mounted');
  const beforeUnmount = createCallback('beforeUnmount');
  const beforeUpdate = createCallback('beforeUpdate');
  const updated = createCallback('updated');
  const beforeRender = createCallback('beforeRender');
  const beforeDestroy = createCallback('beforeDestroy');
  const destroyed = createCallback('destroyed');
  const render = definition.render; // Do not allow overriding of this function

  const addBrushStylers = () => {
    if (settings.brush) {
      (settings.brush.consume || []).forEach(b => {
        if (b.context && b.style) {
          brushStylers.push(styler(brushArgs, b));
        }
      });
    }
  };
  const addBrushTriggers = () => {
    if (settings.brush) {
      (settings.brush.trigger || []).forEach(t => {
        if (t.on === 'over') {
          brushTriggers.over.push(t);
        } else {
          brushTriggers.tap.push(t);
        }
      });
    }
  };
  Object.defineProperty(brushArgs, 'data', {
    get: () => data
  });
  const rendString = settings.renderer || definition.renderer;
  const rend = rendString ? renderer || registries.renderer(rendString)() : renderer || registries.renderer()();
  if (typeof rend.settings === 'function') {
    rend.settings(settings.rendererSettings);
  }
  brushArgs.renderer = rend;
  const dockConfigCallbackContext = {
    resources: chart.logger ? {
      logger: chart.logger()
    } : {}
  };
  let dockConfig = create$l(createDockDefinition(settings, preferredSize, chart.logger()), dockConfigCallbackContext);
  const appendComponentMeta = node => {
    node.key = settings.key;
    node.element = rend.element();
  };
  const fn = () => {};
  fn.dockConfig = () => dockConfig;

  // Set new settings - will trigger mapping of data and creation of scale / formatter.
  fn.set = function () {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (opts.settings) {
      config = opts.settings;
      settings = extend$1(true, {}, defaultSettings, opts.settings);
      dockConfig = create$l(createDockDefinition(settings, preferredSize, chart.logger()), dockConfigCallbackContext);
      brushArgs.config = settings.brush || {};
    }
    if (settings.scale) {
      scale = chart.scale(settings.scale);
    }
    if (settings.data) {
      const {
        rendererSettings
      } = settings;
      const progressive = typeof (rendererSettings === null || rendererSettings === void 0 ? void 0 : rendererSettings.progressive) === 'function' && rendererSettings.progressive();
      const extracted = extract$1(settings.data, {
        dataset: chart.dataset,
        collection: chart.dataCollection
      }, {
        logger: chart.logger()
      }, chart.dataCollection);
      if (!progressive) {
        data = extracted;
      } else if (progressive.isFirst) {
        data = extracted;
        if (data.items) {
          data.items = [...extracted.items];
        }
      } else if (data.items) {
        data.items = [...data.items, ...(extracted.items || [])];
      }
    } else if (scale) {
      data = scale.data();
    } else {
      data = [];
    }
    if (typeof settings.formatter === 'string') {
      formatter = chart.formatter(settings.formatter);
    } else if (typeof settings.formatter === 'object') {
      formatter = chart.formatter(settings.formatter);
    } else if (scale && scale.data().fields) {
      formatter = scale.data().fields[0].formatter();
    }
    style = theme.style(settings.style || {});
  };
  fn.resize = function () {
    let inner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let outer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const newSize = resize({
      inner,
      outer
    });
    if (newSize) {
      size = rend.size(newSize);
    } else {
      size = rend.size(inner);
    }
    instanceContext.rect = extend$1(true, {
      computedPhysical: size.computedPhysical,
      computedOuter: outer.computed || outer,
      computedInner: inner.computed || inner
    }, inner);
    size = extend$1(true, {
      computedOuter: outer.computed || outer,
      computedInner: inner.computed || inner
    }, size);
  };
  fn.getRect = () => instanceContext.rect;
  const getRenderArgs = () => {
    const renderArgs = rend.renderArgs ? rend.renderArgs.slice(0) : [];
    const {
      rendererSettings
    } = settings;
    let d = data;
    const progressive = typeof (rendererSettings === null || rendererSettings === void 0 ? void 0 : rendererSettings.progressive) === 'function' && rendererSettings.progressive();
    if (data.items && progressive) {
      d = _objectSpread2(_objectSpread2({}, data), {}, {
        items: data.items.slice(progressive.start, progressive.end)
      });
    }
    renderArgs.push({
      data: d
    });
    return renderArgs;
  };
  fn.beforeMount = beforeMount;
  fn.beforeRender = () => {
    beforeRender({
      size
    });
  };
  let currentNodes;
  let preComputedRect;
  function updateBrushNodes(nodes) {
    const {
      rendererSettings
    } = settings;
    const progressive = typeof (rendererSettings === null || rendererSettings === void 0 ? void 0 : rendererSettings.progressive) === 'function' && rendererSettings.progressive();
    if (!progressive) {
      brushArgs.nodes = nodes;
    } else if (progressive.isFirst) {
      brushArgs.nodes = [...(nodes || [])];
    } else if (brushArgs.nodes) {
      brushArgs.nodes = [...brushArgs.nodes, ...(nodes || [])];
    }
  }
  fn.render = () => {
    const nodes = render.call(definitionContext, ...getRenderArgs());
    updateBrushNodes(nodes);
    rend.render(nodes);
    currentNodes = nodes;
    preComputedRect = instanceContext.rect.computed;
  };
  fn.hide = () => {
    fn.unmount();
    rend.size({
      x: 0,
      y: 0,
      width: 0,
      height: 0
    });
    rend.clear();
  };
  fn.beforeUpdate = () => {
    beforeUpdate({
      settings,
      data
    });
  };
  let currentTween;
  fn.update = () => {
    if (currentTween) {
      currentTween.stop();
    }
    const {
      rendererSettings,
      brush,
      animations
    } = settings;
    if (typeof (rendererSettings === null || rendererSettings === void 0 ? void 0 : rendererSettings.transform) === 'function' && rendererSettings.transform()) {
      rend.render();
      currentNodes = null;
      return;
    }
    const nodes = render.call(definitionContext, ...getRenderArgs());
    updateBrushNodes(nodes);

    // Reset brush stylers and triggers
    brushStylers.forEach(b => b.cleanUp());
    brushStylers.length = 0;
    brushTriggers.tap = [];
    brushTriggers.over = [];
    if (brush) {
      addBrushStylers();
      addBrushTriggers();
    }
    brushStylers.forEach(bs => {
      if (bs.isActive()) {
        bs.update();
      }
    });
    if (currentNodes && animations && (typeof animations.enabled === 'function' ? animations.enabled() : animations.enabled)) {
      /* The issue: as soon as animation begins, the layout changes immediately to a new layout while the displaying nodes' positions are still calculated relative to the old layout.
      This makes the nodes "jump" at the beginning of the animations. To fix this, we can compesate for the layout changes by adjusting the relative positions of the displaying nodes.
      For example, if the new layout of the point component (the central area) jumps 10px to the left compared to the old layout, we shift the points 10px to the right, making the absolute positions of the points stay the same. */
      if (animations.compensateForLayoutChanges) {
        animations.compensateForLayoutChanges({
          currentNodes,
          currentRect: instanceContext.rect.computed,
          previousRect: preComputedRect
        });
      }
      currentTween = tween({
        old: currentNodes,
        current: nodes
      }, {
        renderer: rend
      }, animations, chart.storage);
      currentTween.start();
    } else {
      rend.render(nodes);
    }
    currentNodes = nodes;
    preComputedRect = instanceContext.rect.computed;
    if (rend.setKey && typeof config.key === 'string') {
      rend.setKey(config.key);
    }
  };
  fn.updated = updated;
  fn.destroy = () => {
    fn.unmount();
    beforeDestroy(element);
    rend.destroy();
    destroyed();
    element = null;
  };

  /**
   * Update active nodes. For now this can be used as a way update and apply brushing on nodes.
   * Ex: if a component have changed the nodes since its initial render.
   * @param {Nodes[]} nodes
   * @deprecated
   * @ignore
   */
  const updateNodes = nodes => {
    brushArgs.nodes = nodes;
    brushStylers.forEach(bs => {
      if (bs.isActive()) {
        bs.update();
      }
    });
    rend.render(nodes);
  };

  // Set contexts, note that the definition and instance need different contexts (for example if they have different 'require' props)
  prepareContext(definitionContext, definition, {
    settings: () => settings,
    data: () => data,
    scale: () => scale,
    formatter: () => formatter,
    renderer: () => rend,
    chart: () => chart,
    dockConfig: () => dockConfig,
    mediator: () => mediator,
    instance: () => instanceContext,
    rect: () => instanceContext.rect,
    style: () => style,
    update: () => updateNodes,
    registries: () => registries,
    resolver: () => resolver,
    symbol: () => create$m(registries.symbol)
  });

  /**
   * Component instance
   * @typedef {object} Component
   * @property {string} type Type of component
   * @property {string} key Key of the component
   */
  prepareContext(instanceContext, config, {
    settings: () => settings,
    data: () => data,
    scale: () => scale,
    formatter: () => formatter,
    renderer: () => rend,
    chart: () => chart,
    dockConfig: () => dockConfig,
    mediator: () => mediator,
    style: () => style,
    _DO_NOT_USE_getInfo: _DO_NOT_USE_getInfo.bind(definitionContext),
    isVisible: () => isVisible
  });
  fn.getBrushedShapes = function getBrushedShapes(brushCtx, mode, props) {
    const shapes = [];
    if (settings.brush && settings.brush.consume) {
      const brusher = chart.brush(brushCtx);
      const sceneNodes = rend.findShapes('*');
      settings.brush.consume.filter(t => t.context === brushCtx).forEach(consume => {
        for (let i = 0; i < sceneNodes.length; i++) {
          const node = sceneNodes[i];
          if (node.data && brusher.containsMappedData(node.data, props || consume.data, mode)) {
            appendComponentMeta(node);
            shapes.push(node);
            sceneNodes.splice(i, 1);
            i--;
          }
        }
      });
    }
    return shapes;
  };
  fn.findShapes = selector => {
    var _currentTween;
    const shapes = ((_currentTween = currentTween) !== null && _currentTween !== void 0 && _currentTween.inProgress() ? currentTween.targetScene : rend).findShapes(selector);
    for (let i = 0, num = shapes.length; i < num; i++) {
      appendComponentMeta(shapes[i]);
    }
    return shapes;
  };
  fn.shapesAt = function (shape) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const items = rend.itemsAt(shape);
    let shapes;
    if (opts && opts.propagation === 'stop' && items.length > 0) {
      shapes = [items.pop().node];
    } else {
      shapes = items.map(i => i.node);
    }
    for (let i = 0, num = shapes.length; i < num; i++) {
      appendComponentMeta(shapes[i]);
    }
    return shapes;
  };
  fn.brushFromShapes = function (shapes) {
    let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    trigger.contexts = Array.isArray(trigger.contexts) ? trigger.contexts : [];
    const action = trigger.action || 'toggle';
    brushFromSceneNodes({
      nodes: shapes,
      action,
      trigger,
      chart,
      data: brushArgs.data
    });
  };
  fn.mount = () => {
    element = rend.element && rend.element() ? element : rend.appendTo(container);
    if (rend.setKey && typeof config.key === 'string') {
      rend.setKey(config.key);
    }
    if (settings.brush) {
      addBrushStylers();
      addBrushTriggers();
    }
    setUpEmitter(instanceContext, emitter, config);
    setUpEmitter(definitionContext, emitter, definition);
    isVisible = true;
  };
  fn.mounted = () => mounted(element);
  fn.unmount = () => {
    [instanceContext, definitionContext].forEach(ctx => {
      tearDownEmitter(ctx, emitter);
    });
    brushTriggers.tap = [];
    brushTriggers.over = [];
    brushStylers.forEach(bs => {
      bs.cleanUp();
    });
    brushStylers.length = 0;
    beforeUnmount();
    isVisible = false;
  };
  fn.onBrushTap = e => {
    brushTriggers.tap.forEach(t => {
      if (resolveTapEvent({
        e,
        t,
        config: brushArgs
      }) && t.globalPropagation === 'stop') {
        chart.toggleBrushing(true);
      }
    });
  };
  fn.onBrushOver = e => {
    brushTriggers.over.forEach(t => {
      if (resolveOverEvent({
        e,
        t,
        config: brushArgs
      }) && t.globalPropagation === 'stop') {
        chart.toggleBrushing(true);
      }
    });
  };

  /**
   * Expose definition on instance
   * @private
   * @experimental
   */
  fn.def = definitionContext;

  /**
   * Expose instanceCtx on "instance"
   * @private
   * @experimental
   */
  fn.ctx = instanceContext;
  fn.renderer = () => rend;
  fn.set({
    settings: config
  });
  created();
  return fn;
}

function mediator() {
  const instance = {};
  EventEmitter.mixin(instance);
  return instance;
}

// getValue({ person: { name: 'John Doe' } }, 'person.name');
// => 'John Doe'
//  getValue({ person: { name: undefined } }, 'person.name', 'John Doe');
// => 'John Doe'

function getValue(object, path, fallback) {
  if (object === undefined || path === undefined) {
    return fallback;
  }
  const steps = path.split('.');
  let scoped = object;
  for (let i = 0; i < steps.length; ++i) {
    const step = steps[i];
    if (scoped[step] === undefined) {
      return fallback;
    }
    scoped = scoped[step];
  }
  return scoped;
}

// const object = { person: { name: undefined };
// setValue(object, 'person.name', 'John Doe');
// console.log(object.person.name);
// => 'John Doe'

function setValue(object, path, value) {
  if (object === undefined || path === undefined) {
    return;
  }
  const steps = path.split('.');
  const propertyName = steps[steps.length - 1];
  let scoped = object;
  for (let i = 0; i < steps.length - 1; ++i) {
    const step = steps[i];
    if (scoped[step] === undefined) {
      scoped[step] = Number.isNaN(+steps[i + 1]) ? {} : [];
    }
    scoped = scoped[step];
  }
  if (value === undefined) {
    delete scoped[propertyName];
    return;
  }
  scoped[propertyName] = value;
}

function createStorage(source) {
  const content = extend$1(true, {}, source);
  const api = {
    getAll: () => content,
    getValue: (reference, fallback) => getValue(content, reference, fallback),
    setValue: (reference, value) => setValue(content, reference, value)
  };
  return api;
}

const EPSILON$3 = 1e-12;
function closestPointToLine(start, end, p) {
  const startToPoint = sub(p, start);
  const startToEnd = sub(end, start);
  const pointOnLine = add(projectOnto(startToPoint, startToEnd), start);
  return pointOnLine;
}
function isPointOnLine(start, end, p) {
  return distance(start, p) + distance(end, p) - distance(start, end) < EPSILON$3;
}

/**
 * Check if rectangle a is located inside rectangle b or if they are the same rectangle.
 * @param {Rect} a - An rect containing (x,y) coordinates, width and height. The origin is assumed to be top left.
 * @param {Rect} b - An rect containing (x,y) coordinates, width and height. The origin is assumed to be top left.
 * @ignore
 */
function rectContainsRect(a, b) {
  return a.x >= b.x && a.x + a.width <= b.x + b.width && a.y >= b.y && a.y + a.height <= b.y + b.height;
}

/* eslint no-use-before-define: ["error", { "functions": false }] */
function lineHasNoLength(line) {
  return line.x1 === line.x2 && line.y1 === line.y2;
}
function rectHasNoSize(rect) {
  return rect.width <= 0 || rect.height <= 0;
}
function circleHasNoSize(circle) {
  return circle.r <= 0;
}
function toFewEdges(polygon) {
  return polygon.edges.length <= 2;
}

// Only when the polygon1's bounds is not inside the polygon2's bounds
function testPolygonPolygonSubCase(polygon1, polygon2) {
  let intersects = false;
  for (let i = 0, len = polygon2.edges.length; i < len; i++) {
    intersects = testPolygonLine(polygon1, pointsToLine(polygon2.edges[i]));
    if (intersects === true) {
      return true;
    }
  }
  return false;
}

// Only when the geopolygon's bounds is not inside the polygon's bounds
function testGeoPolygonPolygonCase1(geopolygon, polygon) {
  let intersects = false;
  for (let i = 0, len = polygon.edges.length; i < len; i++) {
    intersects = testGeoPolygonLine(geopolygon, pointsToLine(polygon.edges[i]));
    if (intersects === true) {
      return true;
    }
  }
  return false;
}

// Only when the geopolygon's bounds is inside the polygon's bounds
function testGeoPolygonPolygonCase2(geopolygon, polygon) {
  let intersects = false;
  const {
    numPolygons,
    polygons
  } = geopolygon;
  for (let n = 0; n < numPolygons; n++) {
    intersects = testPolygonPolygon(polygon, polygons[n]);
    if (intersects === true) {
      return true;
    }
  }
  return false;
}

// Only when the geopolygon1's bounds is not inside the geopolygon2's bounds
function testGeoPolygonGeoPolygonSubCase(geopolygon1, geopolygon2) {
  let intersects = false;
  const {
    numPolygons,
    polygons
  } = geopolygon2;
  for (let n = 0; n < numPolygons; n++) {
    let polygon = polygons[n];
    intersects = testGeoPolygonPolygon(geopolygon1, polygon);
    if (intersects === true) {
      return true;
    }
  }
  return false;
}

/**
 * Test if a Circle contains a point. If so, returns true and false otherwise.
 * Circle muse have a radius greater then 0.
 * @private
 * @param {object} circle
 * @param {number} circle.cx - center x-coordinate
 * @param {number} circle.cy - center y-coordinate
 * @param {number} circle.r - circle radius
 * @param {object} point
 * @param {number} point.x - x-coordinate
 * @param {number} point.y - y-coordinate
 * @return {boolean} true if circle contains point
 */
function testCirclePoint(circle, point) {
  if (circleHasNoSize(circle)) {
    return false;
  }
  const center = {
    x: circle.cx,
    y: circle.cy
  };
  const sqrDist = sqrDistance(center, point);
  if (sqrDist <= circle.r ** 2) {
    return true;
  }
  return false;
}

/**
 * Test if a Circle collide with a rectangle. If so, returns true and false otherwise.
 * Circle muse have a radius greater then 0.
 * Rectangle must have a width and height greather then 0.
 * @private
 * @param {object} circle
 * @param {number} circle.cx - center x-coordinate
 * @param {number} circle.cy - center y-coordinate
 * @param {number} circle.r - circle radius
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @return {boolean} true if circle collide with rectangle
 */
function testCircleRect(circle, rect) {
  if (rectHasNoSize(rect) || circleHasNoSize(circle)) {
    return false;
  }
  const rX = rect.width / 2;
  const rY = rect.height / 2;
  const rcX = rect.x + rX;
  const rcY = rect.y + rY;
  const r = circle.r;
  const cx = circle.cx;
  const cy = circle.cy;
  const dX = Math.abs(cx - rcX);
  const dY = Math.abs(cy - rcY);
  if (dX > rX + r || dY > rY + r) {
    return false;
  }
  if (dX <= rX || dY <= rY) {
    return true;
  }
  const sqrDist = (dX - rX) ** 2 + (dY - rY) ** 2;
  return sqrDist <= r ** 2;
}

/**
 * Test if a Circle collide with a line segment. If so, returns true and false otherwise.
 * Circle muse have a radius greater then 0.
 * Line must have a length greater then 0.
 * @private
 * @param {object} circle
 * @param {number} circle.cx - center x-coordinate
 * @param {number} circle.cy - center y-coordinate
 * @param {number} circle.r - circle radius
 * @param {object} line
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @return {boolean} true if circle collide with line
 */
function testCircleLine(circle, line) {
  if (circleHasNoSize(circle) || lineHasNoLength(line)) {
    return false;
  }
  const [p1, p2] = lineToPoints(line);
  if (testCirclePoint(circle, p1) || testCirclePoint(circle, p2)) {
    return true;
  }
  const center = {
    x: circle.cx,
    y: circle.cy
  };
  const pointOnLine = closestPointToLine(p1, p2, center);
  const dist = sqrDistance(pointOnLine, center);
  return dist <= circle.r ** 2 && isPointOnLine(p1, p2, pointOnLine);
}

/**
 * Test if a Circle collide with another Circle. If so, returns true and false otherwise.
 * Both circles muse have a radius greater then 0.
 * @private
 * @param {object} circle
 * @param {number} circle.cx - center x-coordinate
 * @param {number} circle.cy - center y-coordinate
 * @param {number} circle.r - circle radius
 * @param {object} circle
 * @param {number} circle.cx - center x-coordinate
 * @param {number} circle.cy - center y-coordinate
 * @param {number} circle.r - circle radius
 * @return {boolean} true if circle collide with circle
 */
function testCircleCircle(circle1, circle2) {
  if (circleHasNoSize(circle1) || circleHasNoSize(circle2)) {
    return false;
  }
  const dx = circle1.cx - circle2.cx;
  const dy = circle1.cy - circle2.cy;
  const sqrDist = dx ** 2 + dy ** 2;
  if (sqrDist <= (circle1.r + circle2.r) ** 2) {
    return true;
  }
  return false;
}

/**
 * Test if a Circle collide with Polygon. If so, returns true and false otherwise.
 * Circle muse have a radius greater then 0.
 * Polygon must contain at least 2 vertices
 * @private
 * @param {object} circle
 * @param {number} circle.cx - center x-coordinate
 * @param {number} circle.cy - center y-coordinate
 * @param {number} circle.r - circle radius
 * @param {object} polygon
 * @param {Array} polygon.vertices - Array of vertices
 * @param {object} polygon.vertices.vertex
 * @param {number} polygon.vertices.vertex.x - x-coordinate
 * @param {number} polygon.vertices.vertex.y - y-coordinate
 * @param {Array} polygon.edges - Array of edges
 * @param {Array} polygon.edges.edge - Array of points
 * @param {object} polygon.edges.edge.point
 * @param {number} polygon.edges.edge.point.x - x-coordinate
 * @param {number} polygon.edges.edge.point.y - y-coordinate
 * @return {boolean} true if circle collide with polygon
 */
function testCirclePolygon(circle, polygon) {
  // TODO handle polygon that is a straight line, current impl will interrept it is a true, if radius is extended onto any of the edges
  if (toFewEdges(polygon) || circleHasNoSize(circle)) {
    return false;
  }
  const center = {
    x: circle.cx,
    y: circle.cy
  };
  if (testPolygonPoint(polygon, center)) {
    return true;
  }
  const num = polygon.edges.length;
  for (let i = 0; i < num; i++) {
    const edge = pointsToLine(polygon.edges[i]);
    if (testCircleLine(circle, edge)) {
      return true;
    }
  }
  return false;
}

/**
 * Test if a Polygon contains a Point. If so, returns true and false otherwise.
 * Polygon must contain at least 2 vertices
 * @private
 * @param {object} polygon
 * @param {Array} polygon.vertices - Array of vertices
 * @param {object} polygon.vertices.vertex
 * @param {number} polygon.vertices.vertex.x - x-coordinate
 * @param {number} polygon.vertices.vertex.y - y-coordinate
 * @param {Array} polygon.edges - Array of edges
 * @param {Array} polygon.edges.edge - Array of points
 * @param {object} polygon.edges.edge.point
 * @param {number} polygon.edges.edge.point.x - x-coordinate
 * @param {number} polygon.edges.edge.point.y - y-coordinate
 * @param {object} point
 * @param {number} point.x - x-coordinate
 * @param {number} point.y - y-coordinate
 * @return {boolean} true if polygon conatins point
 */
function testPolygonPoint(polygon, point) {
  // TODO handle polygon that is a straight line, current impl gives a non-deterministic output, that is depending on number of vertices
  if (toFewEdges(polygon) || !testRectPoint(polygon.boundingRect(), point)) {
    return false;
  }
  const {
    x,
    y
  } = point;
  const vertices = polygon.vertices;
  let inside;
  let l;
  let j;
  let i;
  let tx;
  for (inside = false, i = -1, l = vertices.length, j = l - 1; ++i < l; j = i) {
    if (vertices[i].x === x && vertices[i].y === y) {
      // polygon vertice
      return true;
    }
    if (vertices[i].y === vertices[j].y && vertices[i].y === y && (x - vertices[i].x) * (x - vertices[j].x) <= 0) {
      // on horizontal edge of polygon
      return true;
    }
    if (vertices[i].y < y && y <= vertices[j].y || vertices[j].y < y && y <= vertices[i].y) {
      tx = (vertices[j].x - vertices[i].x) * (y - vertices[i].y) / (vertices[j].y - vertices[i].y) + vertices[i].x;
      if (x === tx) {
        // on polygon edge
        return true;
      }
      if (x < tx) {
        inside = !inside;
      }
    }
  }
  return inside;
}

/**
 * Test if a Polygon collider with a line. If so, returns true and false otherwise.
 * Polygon must contain at least 3 edges.
 * Line must have length greater then 0.
 * @private
 * @param {object} polygon
 * @param {Array} polygon.vertices - Array of vertices
 * @param {object} polygon.vertices.vertex
 * @param {number} polygon.vertices.vertex.x - x-coordinate
 * @param {number} polygon.vertices.vertex.y - y-coordinate
 * @param {Array} polygon.edges - Array of edges
 * @param {Array} polygon.edges.edge - Array of points
 * @param {object} polygon.edges.edge.point
 * @param {number} polygon.edges.edge.point.x - x-coordinate
 * @param {number} polygon.edges.edge.point.y - y-coordinate
 * @param {object} line
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @return {boolean} true if polygon collider with line
 */
function testPolygonLine(polygon, line) {
  // TODO handle polygon that is a straight line, current impl gives a non-deterministic output, that is depending on number of vertices
  if (toFewEdges(polygon)) {
    return false;
  }
  for (let i = 0, num = polygon.edges.length; i < num; i++) {
    const edge = pointsToLine(polygon.edges[i]);
    if (testLineLine(line, edge)) {
      return true;
    }
  }
  const [p1, p2] = lineToPoints(line);
  return testPolygonPoint(polygon, p1) || testPolygonPoint(polygon, p2);
}

/**
 * Test if a Polygon collider with a rectangle. If so, returns true and false otherwise.
 * Polygon must contain at least 3 edges.
 * Rectangle must width and height greater then 0.
 * @private
 * @param {object} polygon
 * @param {Array} polygon.vertices - Array of vertices
 * @param {object} polygon.vertices.vertex
 * @param {number} polygon.vertices.vertex.x - x-coordinate
 * @param {number} polygon.vertices.vertex.y - y-coordinate
 * @param {Array} polygon.edges - Array of edges
 * @param {Array} polygon.edges.edge - Array of points
 * @param {object} polygon.edges.edge.point
 * @param {number} polygon.edges.edge.point.x - x-coordinate
 * @param {number} polygon.edges.edge.point.y - y-coordinate
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @return {boolean} true if polygon collider with rect
 */
function testPolygonRect(polygon, rect) {
  // TODO handle polygon that is a straight line, current impl gives a non-deterministic output, that is depending on number of vertices
  if (toFewEdges(polygon)) {
    return false;
  }
  for (let i = 0, num = polygon.edges.length; i < num; i++) {
    const edge = pointsToLine(polygon.edges[i]);
    if (testRectLine(rect, edge)) {
      return true;
    }
  }
  const [p1, p2, p3, p4] = rectToPoints(rect);
  return testPolygonPoint(polygon, p1) || testPolygonPoint(polygon, p2) || testPolygonPoint(polygon, p3) || testPolygonPoint(polygon, p4);
}

/**
 * Test if a Rectangle collide with another rectangle. If so, returns true and false otherwise.
 * Both rectangles must have a width and height greather then 0.
 * @private
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @return {boolean} true if rectangle collide with rectangle
 */
function testRectRect(rect1, rect2) {
  if (rectHasNoSize(rect1) || rectHasNoSize(rect2)) {
    return false;
  }
  return rect1.x <= rect2.x + rect2.width && rect2.x <= rect1.x + rect1.width && rect1.y <= rect2.y + rect2.height && rect2.y <= rect1.y + rect1.height;
}

/**
 * Test if a rectangle contains  another rectangle. If so, returns true and false otherwise.
 * Both rectangles must have a width and height greather then 0.
 * @private
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @return {boolean} true if rectangle collide with rectangle
 */
function testRectContainsRect(rect1, rect2) {
  if (rectHasNoSize(rect1) || rectHasNoSize(rect2)) {
    return false;
  }
  const points = [{
    x: rect2.x,
    y: rect2.y
  }, {
    x: rect2.x + rect2.width,
    y: rect2.y
  }, {
    x: rect2.x + rect2.width,
    y: rect2.y + rect2.height
  }, {
    x: rect2.x,
    y: rect2.y + rect2.height
  }];
  return points.every(p => testRectPoint(rect1, p));
}

/**
 * Test if a Rectangle contains a Point. If so, returns true and false otherwise.
 * Rectangle must have a width and height greather then 0.
 * @private
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @param {object} point
 * @param {number} point.x - x-coordinate
 * @param {number} point.y - y-coordinate
 * @return {boolean} true if rectangle contains point
 */
function testRectPoint(rect, point) {
  if (rectHasNoSize(rect)) {
    return false;
  }
  return point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height;
}

/**
 * Test if a Rectangle collider with a line. If so, returns true and false otherwise.
 * Rectangle must have a width and height greather then 0.
 * Line must have length greater then 0.
 * @private
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @param {object} line
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @return {boolean} true if rectangle collide with line
 */
function testRectLine(rect, line) {
  if (lineHasNoLength(line) || rectHasNoSize(rect)) {
    return false;
  }
  const [p1, p2] = lineToPoints(line);
  if (testRectPoint(rect, p1) || testRectPoint(rect, p2)) {
    return true;
  }
  const rectEdges = rectToPoints(rect);
  let num = rectEdges.length;
  for (let i = 0; i < num; i++) {
    const edge = pointsToLine([rectEdges[i], rectEdges[i !== 3 ? i + 1 : 0]]);
    if (testLineLine(edge, line)) {
      return true;
    }
  }
  return false;
}

/**
 * Test if a Line collider with another line. If so, returns true and false otherwise.
 * Both lines must have length greater then 0.
 * @private
 * @param {object} line
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {object} line
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @return {boolean} true if line collide with line
 */
function testLineLine(line1, line2) {
  const [p1, p2] = lineToPoints(line1);
  const [p3, p4] = lineToPoints(line2);
  const dx1 = distanceX(p2, p1);
  const dy1 = distanceY(p2, p1);
  const dx2 = distanceX(p4, p3);
  const dy2 = distanceY(p4, p3);
  const dx3 = distanceX(p1, p3);
  const dy3 = distanceY(p1, p3);
  let ub = dy2 * dx1 - dx2 * dy1;
  const uat = dx2 * dy3 - dy2 * dx3;
  const ubt = dx1 * dy3 - dy1 * dx3;
  let t1;
  let t2;
  if (dx1 === 0 && dy1 === 0) {
    // Line segment has no length
    return false;
  }
  if (dx2 === 0 && dy2 === 0) {
    // Line segment has no length
    return false;
  }
  if (ub === 0) {
    if (uat === 0 && ubt === 0) {
      // COINCIDENT;
      if (dx1 === 0) {
        if (dy1 === 0) {
          // p1 = p2
          return p1.x === p2.x && p1.y === p2.y;
        }
        t1 = distanceY(p3, p1) / dy1;
        t2 = distanceY(p4, p1) / dy1;
      } else {
        t1 = (p3.x - p1.x) / dx1;
        t2 = (p4.x - p1.x) / dx1;
      }
      if (t1 < 0 && t2 < 0 || t1 > 1 && t2 > 1) {
        return false;
      }
      return true;
    }
    return false; // PARALLEL;
  }
  const ua = uat / ub;
  ub = ubt / ub;
  if (ua >= 0.0 && ua <= 1.0 && ub >= 0.0 && ub <= 1.0) {
    return true;
  }
  return false;
}

/**
 * Test if a Line contains a Point. If so, returns true and false otherwise.
 * Line must have length greater then 0.
 * @private
 * @param {object} line
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {object} point
 * @param {number} point.x - x-coordinate
 * @param {number} point.y - y-coordinate
 * @return {boolean} true if line contains point
 */
function testLinePoint(line, point) {
  if (lineHasNoLength(line)) {
    return false;
  }
  const [p1, p2] = lineToPoints(line);
  return isPointOnLine(p1, p2, point);
}

/**
 * Test if a polygon intersects another polygon.
 * Supports convex, concave and self-intersecting polygons (filled area).
 * @private
 * @param {object} polygon
 * @param {object} polygon
 * @returns {boolean} True if there is an intersection, false otherwise
 */
function testPolygonPolygon(polygon1, polygon2) {
  const rect1 = polygon1.boundingRect();
  const rect2 = polygon2.boundingRect();
  if (!testRectRect(rect1, rect2)) {
    return false;
  }
  if (testRectContainsRect(rect1, rect2)) {
    return testPolygonPolygonSubCase(polygon1, polygon2);
  }
  return testPolygonPolygonSubCase(polygon2, polygon1);
}

/**
 * Test if a geopolygon intersects a polygon.
 * @private
 * @param {object} geopolygon
 * @param {object} polygon
 * @returns {boolean} True if there is an intersection, false otherwise
 */
function testGeoPolygonPolygon(geopolygon, polygon) {
  const rect1 = geopolygon.boundingRect();
  const rect2 = polygon.boundingRect();
  if (!testRectRect(rect1, rect2)) {
    return false;
  }
  if (testRectContainsRect(rect2, rect1)) {
    return testGeoPolygonPolygonCase2(geopolygon, polygon);
  }
  return testGeoPolygonPolygonCase1(geopolygon, polygon);
}

/**
 * Test if a geopolygon intersects another geopolygon.
 * @private
 * @param {object} geopolygon
 * @param {object} geopolygon
 * @returns {boolean} True if there is an intersection, false otherwise
 */
function testGeoPolygonGeoPolygon(geopolygon1, geopolygon2) {
  const rect1 = geopolygon1.boundingRect();
  const rect2 = geopolygon2.boundingRect();
  if (!testRectRect(rect1, rect2)) {
    return false;
  }
  if (testRectContainsRect(rect2, rect1)) {
    return testGeoPolygonGeoPolygonSubCase(geopolygon2, geopolygon1);
  }
  return testGeoPolygonGeoPolygonSubCase(geopolygon1, geopolygon2);
}

/**
 * Test if a Circle collide with GeoPolygon. If so, returns true and false otherwise.
 * Circle muse have a radius greater then 0.
 * @private
 * @param {object} circle
 * @param {number} circle.cx - center x-coordinate
 * @param {number} circle.cy - center y-coordinate
 * @param {number} circle.r - circle radius
 * @param {object} geopolygon
 * @param {Array} geopolygon.polygons - Array of polygons
 * @return {boolean} true if circle collide with polygon
 */
function testCircleGeoPolygon(circle, geopolygon) {
  if (circleHasNoSize(circle)) {
    return false;
  }
  const center = {
    x: circle.cx,
    y: circle.cy
  };
  if (testGeoPolygonPoint(geopolygon, center)) {
    return true;
  }
  const {
    numPolygons,
    polygons
  } = geopolygon;
  for (let n = 0; n < numPolygons; n++) {
    const polygon = polygons[n];
    const num = polygon.edges.length;
    for (let i = 0; i < num; i++) {
      const edge = pointsToLine(polygon.edges[i]);
      if (testCircleLine(circle, edge)) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Test if a GeoPolygon contains a Point. If so, returns true and false otherwise.
 * @private
 * @param {object} geopolygon
 * @param {Array} geopolygon.vertices - Array of of arrays of vertices
 * @param {object} point
 * @param {number} point.x - x-coordinate
 * @param {number} point.y - y-coordinate
 * @return {boolean} true if polygon conatins point
 */
function testGeoPolygonPoint(geopolygon, point) {
  if (!testRectPoint(geopolygon.boundingRect(), point)) {
    return false;
  }
  const {
    x,
    y
  } = point;
  const numPolygons = geopolygon.numPolygons;
  let inside = false;
  let vertices;
  let n;
  let l;
  let j;
  let i;
  let tx;
  for (n = 0; n < numPolygons; n++) {
    vertices = geopolygon.vertices[n];
    for (i = -1, l = vertices.length, j = l - 1; ++i < l; j = i) {
      if (vertices[i].x === x && vertices[i].y === y) {
        // polygon vertice
        return true;
      }
      if (vertices[i].y === vertices[j].y && vertices[i].y === y && (x - vertices[i].x) * (x - vertices[j].x) <= 0) {
        // on horizontal edge of polygon
        return true;
      }
      if (vertices[i].y < y && y <= vertices[j].y || vertices[j].y < y && y <= vertices[i].y) {
        tx = (vertices[j].x - vertices[i].x) * (y - vertices[i].y) / (vertices[j].y - vertices[i].y) + vertices[i].x;
        if (x === tx) {
          // on polygon edge
          return true;
        }
        if (x < tx) {
          inside = !inside;
        }
      }
    }
  }
  return inside;
}

/**
 * Test if a GeoPolygon collider with a line. If so, returns true and false otherwise.
 * Line must have length greater then 0.
 * @private
 * @param {object} geopolygon
 * @param {Array} geopolygon.polygons - Array of polygons
 * @param {object} line
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @param {number} line.x1 - x-coordinate
 * @param {number} line.y1 - y-coordinate
 * @return {boolean} true if polygon collider with line
 */
function testGeoPolygonLine(geopolygon, line) {
  const [p1, p2] = lineToPoints(line);
  if (testGeoPolygonPoint(geopolygon, p1) || testGeoPolygonPoint(geopolygon, p2)) {
    return true;
  }
  const {
    numPolygons,
    polygons
  } = geopolygon;
  for (let n = 0; n < numPolygons; n++) {
    const polygon = polygons[n];
    for (let i = 0, num = polygon.edges.length; i < num; i++) {
      const edge = pointsToLine(polygon.edges[i]);
      if (testLineLine(line, edge)) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Test if a GeoPolygon collider with a rectangle. If so, returns true and false otherwise.
 * Rectangle must have width and height greater than 0.
 * @private
 * @param {object} geopolygon
 * @param {Array} geopolygon.polygons - Array of polygons
 * @param {object} rect
 * @param {number} rect.x - x-coordinate
 * @param {number} rect.y - y-coordinate
 * @param {number} rect.width - width
 * @param {number} rect.height - height
 * @return {boolean} true if polygon collider with rect
 */
function testGeoPolygonRect(geopolygon, rect) {
  const [p1, p2, p3, p4] = rectToPoints(rect);
  if (testGeoPolygonPoint(geopolygon, p1) || testGeoPolygonPoint(geopolygon, p2) || testGeoPolygonPoint(geopolygon, p3) || testGeoPolygonPoint(geopolygon, p4)) {
    return true;
  }
  const {
    numPolygons,
    polygons
  } = geopolygon;
  for (let n = 0; n < numPolygons; n++) {
    const polygon = polygons[n];
    for (let i = 0, num = polygon.edges.length; i < num; i++) {
      const edge = pointsToLine(polygon.edges[i]);
      if (testRectLine(rect, edge)) {
        return true;
      }
    }
  }
  return false;
}

const VARIABLE_RX = /^\$/;
const EXTEND = '@extend';
function throwCyclical(s) {
  throw new Error("Cyclical reference for \"".concat(s, "\""));
}
function res(style, references, path) {
  if (typeof style === 'string') {
    let value = references[style];
    if (path.indexOf(style) !== -1) {
      throwCyclical(style);
    }
    if (VARIABLE_RX.test(value)) {
      path.push(style);
      return res(value, references, path);
    }
    return value;
  }
  let computed = style;
  const refs = extend$1(true, {}, references, style);
  const s = {};
  if (style[EXTEND]) {
    const extendFrom = style[EXTEND];
    if (path.indexOf(extendFrom) !== -1) {
      throwCyclical(extendFrom);
    }
    let pext = path.slice();
    pext.push(extendFrom);
    computed = extend$1(true, {}, res(refs[extendFrom], references, pext), style);
  }
  Object.keys(computed).forEach(key => {
    let p = path.slice();
    if (key === EXTEND || VARIABLE_RX.test(key)) {
      return;
    }
    s[key] = computed[key];
    let value = s[key];
    if (VARIABLE_RX.test(value) && value in refs) {
      if (path.indexOf(value) !== -1) {
        throwCyclical(value);
      }
      p.push(value);
      value = refs[value];
      if (typeof value === 'object') {
        s[key] = res(value, refs, p);
      } else if (VARIABLE_RX.test(value) && value in refs) {
        s[key] = res(value, refs, p);
      } else {
        s[key] = value;
      }
    } else if (typeof value === 'object') {
      s[key] = res(value, refs, p);
    }
  });
  return s;
}

/**
 * Resolve style references
 * @private
 * @param {style-object} style
 * @param {style-object} references
 * @returns {object} The resolved style
 * @example
 * resolve({
 *   label: '$label--big'
 * }, {
 *   '$size--m': '12px',
 *   '$label--big': {
 *     fontFamily: 'Arial',
 *     fontSize: '$size--m'
 *   }
 * }); // { label: { fontFamily: 'Arial', fontSize: '12px' } }
 */
function resolve$1(style, references) {
  return res(style, references, []);
}

function themeFn() {
  let style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let palettes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let pals = {};
  let internalStyle = style;
  const setPalettes = p => {
    p.forEach(palette => {
      const pal = Array.isArray(palette.colors[0]) ? palette.colors : [palette.colors];
      pals[palette.key] = {
        colors: pal,
        sizes: pal.map(colors => colors ? colors.length : 0)
      };
    });
  };
  const getPalette = (key, num) => {
    const palette = pals[key];
    if (!palette) {
      return [];
    }
    const sizes = palette.sizes;
    // find the first color set containing at least 'num' colors
    for (let i = 0; i < sizes.length; i++) {
      if (num <= sizes[i]) {
        return palette.colors[i];
      }
    }
    return palette.colors[sizes.length - 1];
  };

  /**
   * Theme API
   * @private
   * @experimental
   */
  const theme = {
    /**
     * Get an array of colors
     * @param {string} name - Name of the color palette
     * @param {number} [num] - The minimum number of colors to get from the palette
     */
    palette: (name, num) => getPalette(name, num),
    setPalettes,
    /**
     * Resolve style references
     * @param {style-object} s - Object containing style
     */
    style: s => resolve$1(s, internalStyle),
    /**
     * Set custom style
     * @param {style-object} s - Object containing style
     */
    setStyle: s => {
      internalStyle = extend$1({}, style, s);
    }
  };
  setPalettes(palettes);
  return theme;
}

function roundRect(rect) {
  rect.x = Math.floor(rect.x);
  rect.y = Math.floor(rect.y);
  rect.width = Math.floor(rect.width);
  rect.height = Math.floor(rect.height);
}
function resolveContainerRects(rect, settings) {
  const containerRect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  const logicalContainerRect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };

  // Check input object for size
  containerRect.width = rect.width || 0;
  containerRect.height = rect.height || 0;
  if (typeof settings.size !== 'undefined') {
    containerRect.width = isNaN(settings.size.width) ? containerRect.width : settings.size.width;
    containerRect.height = isNaN(settings.size.height) ? containerRect.height : settings.size.height;
  }
  if (typeof settings.logicalSize !== 'undefined') {
    logicalContainerRect.width = isNaN(settings.logicalSize.width) ? containerRect.width : settings.logicalSize.width;
    logicalContainerRect.height = isNaN(settings.logicalSize.height) ? containerRect.height : settings.logicalSize.height;
    logicalContainerRect.align = isNaN(settings.logicalSize.align) ? 0.5 : Math.min(Math.max(settings.logicalSize.align, 0), 1);
    logicalContainerRect.preserveAspectRatio = settings.logicalSize.preserveAspectRatio;
  } else {
    logicalContainerRect.width = containerRect.width;
    logicalContainerRect.height = containerRect.height;
    logicalContainerRect.preserveAspectRatio = false;
  }
  roundRect(logicalContainerRect);
  roundRect(containerRect);
  return {
    logicalContainerRect,
    containerRect
  };
}
function resolveSettings$1(s) {
  const settings = {
    center: {
      minWidthRatio: 0.5,
      minHeightRatio: 0.5,
      minWidth: 0,
      minHeight: 0
    }
  };
  extend$1(true, settings, s);
  settings.center.minWidthRatio = Math.min(Math.max(settings.center.minWidthRatio, 0), 1); // Only accept value between 0-1
  settings.center.minHeightRatio = Math.min(Math.max(settings.center.minHeightRatio, 0), 1); // Only accept value between 0-1
  settings.center.minWidth = Math.max(settings.center.minWidth, 0); // Consider <= 0 to be falsy and fallback to ratio
  settings.center.minHeight = Math.max(settings.center.minHeight, 0); // Consider <= 0 to be falsy and fallback to ratio

  return settings;
}

function createRect(x, y, width, height, margin) {
  return {
    x: isNaN(x) ? 0 : x,
    y: isNaN(x) ? 0 : y,
    width: isNaN(x) ? 0 : width,
    height: isNaN(x) ? 0 : height,
    margin: isNaN(margin) ? 0 : margin
  };
}

function cacheSize(c, reducedRect, layoutRect) {
  if (typeof c.cachedSize === 'undefined') {
    const dock = c.config.dock();
    let size = c.comp.preferredSize({
      inner: reducedRect,
      outer: layoutRect,
      dock
    });
    // backwards compatibility
    if (!isNaN(size)) {
      size = {
        width: size,
        height: size
      };
    } else if (size && !isNaN(size.size)) {
      size.width = size.size;
      size.height = size.size;
    }
    let relevantSize;
    if (dock === 'top' || dock === 'bottom') {
      relevantSize = size.height;
    } else if (dock === 'right' || dock === 'left') {
      relevantSize = size.width;
    } else {
      relevantSize = Math.max(size.width, size.height);
    }
    c.cachedSize = Math.ceil(relevantSize);
    c.edgeBleed = size.edgeBleed || 0;
  }
  return c.cachedSize;
}
function validateReduceRect(rect, reducedRect, settings) {
  // Absolute value for width/height should have predence over relative value
  const minReduceWidth = Math.min(settings.center.minWidth, rect.width) || Math.max(rect.width * settings.center.minWidthRatio, 1);
  const minReduceHeight = Math.min(settings.center.minHeight, rect.height) || Math.max(rect.height * settings.center.minHeightRatio, 1);
  return reducedRect.width >= minReduceWidth && reducedRect.height >= minReduceHeight;
}
function reduceDocRect(reducedRect, c) {
  switch (c.config.dock()) {
    case 'top':
      reducedRect.y += c.cachedSize;
      reducedRect.height -= c.cachedSize;
      break;
    case 'bottom':
      reducedRect.height -= c.cachedSize;
      break;
    case 'left':
      reducedRect.x += c.cachedSize;
      reducedRect.width -= c.cachedSize;
      break;
    case 'right':
      reducedRect.width -= c.cachedSize;
      break;
  }
}
function addEdgeBleed(currentEdgeBleed, c) {
  const edgeBleed = c.edgeBleed;
  if (!edgeBleed) {
    return;
  }
  currentEdgeBleed.left = Math.max(currentEdgeBleed.left, edgeBleed.left || 0);
  currentEdgeBleed.right = Math.max(currentEdgeBleed.right, edgeBleed.right || 0);
  currentEdgeBleed.top = Math.max(currentEdgeBleed.top, edgeBleed.top || 0);
  currentEdgeBleed.bottom = Math.max(currentEdgeBleed.bottom, edgeBleed.bottom || 0);
}
function reduceEdgeBleed(layoutRect, reducedRect, edgeBleed) {
  if (reducedRect.x < edgeBleed.left) {
    reducedRect.width -= edgeBleed.left - reducedRect.x;
    reducedRect.x = edgeBleed.left;
  }
  const reducedRectRightBoundary = layoutRect.width - (reducedRect.x + reducedRect.width);
  if (reducedRectRightBoundary < edgeBleed.right) {
    reducedRect.width -= edgeBleed.right - reducedRectRightBoundary;
  }
  if (reducedRect.y < edgeBleed.top) {
    reducedRect.height -= edgeBleed.top - reducedRect.y;
    reducedRect.y = edgeBleed.top;
  }
  const reducedRectBottomBoundary = layoutRect.height - (reducedRect.y + reducedRect.height);
  if (reducedRectBottomBoundary < edgeBleed.bottom) {
    reducedRect.height -= edgeBleed.bottom - reducedRectBottomBoundary;
  }
}
function reduceSingleLayoutRect(layoutRect, reducedRect, edgeBleed, c, settings) {
  const newReduceRect = extend$1({}, reducedRect);
  const newEdgeBleed = extend$1({}, edgeBleed);
  reduceDocRect(newReduceRect, c);
  addEdgeBleed(newEdgeBleed, c);
  reduceEdgeBleed(layoutRect, newReduceRect, newEdgeBleed);
  const isValid = validateReduceRect(layoutRect, newReduceRect, settings);
  if (!isValid) {
    return false;
  }
  reduceDocRect(reducedRect, c);
  addEdgeBleed(edgeBleed, c);
  return true;
}

/**
 * Updates the visible and hidden components based on components that are docked to other components.
 * For example, assume a component called myRect:
 * {
 *  key: 'myRect',
 *  type: 'rect',
 *  dock: 'bottom'
 * }
 * and a component called myLine:
 * {
 *  key: 'myLine',
 *  type: 'line',
 *  dock: '@myRect'
 * }
 * if the layout engine decides to hide myRect, then myLine should be hidden as well.
 * @param {Array} visible - Components to be decided if they should be hidden or not.
 * @param {Array} hidden - Components that are already hidden.
 * @returns {Object} containing the new visible components and additional components to be hidden.
 * @ignore
 */
function filterReferencedDocks(visible, hidden) {
  if (hidden.length === 0) {
    return;
  }
  for (let i = 0; i < visible.length; ++i) {
    let v = visible[i];
    if (v.referencedDocks.length) {
      const isAllHidden = v.referencedDocks.every(refDock => hidden.some(h => h.key === refDock));
      if (isAllHidden) {
        hidden.push(visible.splice(i, 1)[0]);
      }
    }
  }
}
function reduceLayoutRect(_ref) {
  let {
    layoutRect,
    visible,
    hidden,
    settings
  } = _ref;
  const reducedRect = createRect(layoutRect.x, layoutRect.y, layoutRect.width, layoutRect.height);
  const edgeBleed = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
  const sortedComponents = visible.slice();
  sortedComponents.sort((a, b) => a.config.prioOrder() - b.config.prioOrder()); // lower prioOrder will have higher prio

  for (let i = 0; i < sortedComponents.length; ++i) {
    const c = sortedComponents[i];
    cacheSize(c, reducedRect, layoutRect);
    if (!reduceSingleLayoutRect(layoutRect, reducedRect, edgeBleed, c, settings)) {
      hidden.push(sortedComponents.splice(i, 1)[0]);
      --i;
    }
  }
  filterReferencedDocks(visible, hidden);
  const filteredUnsortedComps = visible.filter(c => sortedComponents.indexOf(c) !== -1);
  visible.length = 0;
  visible.push(...filteredUnsortedComps);
  reduceEdgeBleed(layoutRect, reducedRect, edgeBleed);
  return reducedRect;
}
function computeRect(rect) {
  return {
    x: rect.margin.left + rect.x * rect.scaleRatio.x,
    y: rect.margin.top + rect.y * rect.scaleRatio.y,
    width: rect.width * rect.scaleRatio.x,
    height: rect.height * rect.scaleRatio.y
  };
}
function appendScaleRatio(rect, outerRect, layoutRect, containerRect) {
  const scaleRatio = {
    x: containerRect.width / layoutRect.width,
    y: containerRect.height / layoutRect.height
  };
  const margin = {
    left: 0,
    top: 0
  };
  if (layoutRect.preserveAspectRatio) {
    const xLessThenY = scaleRatio.x < scaleRatio.y;
    // To preserve the aspect ratio, take the smallest ratio and apply in both directions to "meet" the size of the container
    const minRatio = Math.min(scaleRatio.x, scaleRatio.y);
    scaleRatio.x = minRatio;
    scaleRatio.y = minRatio;
    const area = xLessThenY ? 'height' : 'width';
    const spread = (containerRect[area] - layoutRect[area] * scaleRatio.x) * layoutRect.align;
    margin.left = xLessThenY ? 0 : spread;
    margin.top = xLessThenY ? spread : 0;
  }
  rect.scaleRatio = scaleRatio;
  rect.margin = margin;
  outerRect.scaleRatio = scaleRatio;
  outerRect.margin = margin;
  layoutRect.scaleRatio = scaleRatio;
  layoutRect.margin = margin;
}
function boundingBox(rects) {
  const points = [].concat(...rects.map(rectToPoints));
  return pointsToRect(points);
}
function positionComponents(_ref2) {
  let {
    visible,
    layoutRect,
    reducedRect,
    containerRect,
    translation
  } = _ref2;
  const vRect = createRect(reducedRect.x, reducedRect.y, reducedRect.width, reducedRect.height);
  const hRect = createRect(reducedRect.x, reducedRect.y, reducedRect.width, reducedRect.height);
  const referencedComponents = {};
  const referenceArray = visible.slice();
  const elementOrder = referenceArray.slice().sort((a, b) => a.config.displayOrder() - b.config.displayOrder());
  visible.sort((a, b) => {
    if (a.referencedDocks.length > 0 && b.referencedDocks.length > 0) {
      return 0;
    }
    if (b.referencedDocks.length > 0) {
      return -1;
    }
    if (a.referencedDocks.length > 0) {
      return 1;
    }
    const diff = a.config.displayOrder() - b.config.displayOrder();
    if (diff === 0) {
      return referenceArray.indexOf(a) - referenceArray.indexOf(b);
    }
    return diff;
  }).forEach(c => {
    let outerRect = {};
    let rect = {};
    const d = c.config.dock();
    switch (d) {
      case 'top':
        outerRect.height = rect.height = c.cachedSize;
        outerRect.width = layoutRect.width;
        rect.width = vRect.width;
        outerRect.x = layoutRect.x;
        rect.x = vRect.x;
        outerRect.y = rect.y = vRect.y - c.cachedSize;
        vRect.y -= c.cachedSize;
        vRect.height += c.cachedSize;
        break;
      case 'bottom':
        outerRect.x = layoutRect.x;
        rect.x = vRect.x;
        outerRect.y = rect.y = vRect.y + vRect.height;
        outerRect.width = layoutRect.width;
        rect.width = vRect.width;
        outerRect.height = rect.height = c.cachedSize;
        vRect.height += c.cachedSize;
        break;
      case 'left':
        outerRect.x = rect.x = hRect.x - c.cachedSize;
        outerRect.y = layoutRect.y;
        rect.y = hRect.y;
        outerRect.width = rect.width = c.cachedSize;
        outerRect.height = layoutRect.height;
        rect.height = hRect.height;
        hRect.x -= c.cachedSize;
        hRect.width += c.cachedSize;
        break;
      case 'right':
        outerRect.x = rect.x = hRect.x + hRect.width;
        outerRect.y = layoutRect.y;
        rect.y = hRect.y;
        outerRect.width = rect.width = c.cachedSize;
        outerRect.height = layoutRect.height;
        rect.height = hRect.height;
        hRect.width += c.cachedSize;
        break;
      case 'center':
        outerRect.x = rect.x = reducedRect.x;
        outerRect.y = rect.y = reducedRect.y;
        outerRect.width = rect.width = reducedRect.width;
        outerRect.height = rect.height = reducedRect.height;
        break;
      default:
        if (c.referencedDocks.length > 0) {
          const refs = c.referencedDocks.map(ref => referencedComponents[ref]).filter(ref => !!ref);
          if (refs.length > 0) {
            outerRect = boundingBox(refs.map(ref => ref.outerRect));
            rect = boundingBox(refs.map(ref => ref.r));
          }
        }
        break;
    }
    if (c.key) {
      referencedComponents[c.key] = {
        // store the size of this component
        r: rect,
        outerRect
      };
    }
    appendScaleRatio(rect, outerRect, layoutRect, containerRect);
    rect.edgeBleed = c.edgeBleed;
    rect.computed = computeRect(rect);
    outerRect.edgeBleed = c.edgeBleed;
    outerRect.computed = computeRect(outerRect);
    rect.x += translation.x;
    rect.y += translation.y;
    outerRect.x += translation.x;
    outerRect.y += translation.y;
    c.comp.resize(rect, outerRect);
    c.cachedSize = undefined;
    c.edgeBleed = undefined;
  });
  return elementOrder;
}
function checkShowSettings(strategySettings, dockSettings, logicalContainerRect) {
  const layoutModes = strategySettings.layoutModes || {};
  const minimumLayoutMode = dockSettings.minimumLayoutMode();
  let show = dockSettings.show();
  if (show && typeof minimumLayoutMode === 'object') {
    show = layoutModes[minimumLayoutMode.width] && layoutModes[minimumLayoutMode.height] && logicalContainerRect.width >= layoutModes[minimumLayoutMode.width].width && logicalContainerRect.height >= layoutModes[minimumLayoutMode.height].height;
  } else if (show && minimumLayoutMode !== undefined) {
    show = layoutModes[minimumLayoutMode] && logicalContainerRect.width >= layoutModes[minimumLayoutMode].width && logicalContainerRect.height >= layoutModes[minimumLayoutMode].height;
  }
  return show;
}
function validateComponent(component) {
  if (!component.resize || typeof component.resize !== 'function') {
    throw new Error('Component is missing resize function');
  }
  if (!component.dockConfig && !component.preferredSize) {
    throw new Error('Component is missing preferredSize function');
  }
}
function filterComponents(components, settings, rect) {
  const visible = [];
  const hidden = [];
  // check show settings
  for (let i = 0; i < components.length; ++i) {
    const comp = components[i];
    validateComponent(comp);
    // backwards compatibility
    let config = comp.dockConfig;
    const key = comp.key;
    const d = config.dock();
    const referencedDocks = /@/.test(d) ? d.split(',').map(s => s.replace(/^\s*@/, '')) : [];
    if (checkShowSettings(settings, config, rect)) {
      visible.push({
        comp,
        key,
        config,
        referencedDocks
      });
    } else {
      hidden.push({
        comp,
        key,
        config,
        referencedDocks
      });
    }
  }
  return [visible, hidden];
}

/**
 * Dock layout settings
 * @typedef {object} DockLayoutSettings
 * @property {object} [logicalSize] - Logical size
 * @property {number} [logicalSize.width] - Width in pixels
 * @property {number} [logicalSize.height] - Height in pixels
 * @property {boolean} [logicalSize.preserveAspectRatio=false] - If true, takes the smallest ratio of width/height between logical and physical size ( physical / logical )
 * @property {number} [logicalSize.align=0.5] - Normalized value between 0-1. Defines how the space around the scaled axis is spread in the container, with 0.5 meaning the spread is equal on both sides. Only applicable if preserveAspectRatio is set to true
 * @property {object} [center] - Define how much space the center dock area requires
 * @property {number} [center.minWidthRatio=0.5] - Value between 0 and 1
 * @property {number} [center.minHeightRatio=0.5] - Value between 0 and 1
 * @property {number} [center.minWidth] - Width in pixels
 * @property {number} [center.minHeight] - Height in pixels
 * @property {object<string, DockLayoutSettings~LayoutMode>} [layoutModes] Dictionary with named sizes
 * @property {object} [size] - Size is equal to that of the container (element) of the chart by default. It's possible to overwrite it by explicitly setting width or height
 * @property {number} [size.width] - Width in pixels
 * @property {number} [size.height] - Height in pixels
 */

/**
 * @typedef {object} DockLayoutSettings~LayoutMode
 * @property {number} width
 * @property {number} height
 */

function dockLayout(initialSettings) {
  let settings = resolveSettings$1(initialSettings);
  const docker = {};
  docker.layout = function layout(rect) {
    let components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!rect || isNaN(rect.x) || isNaN(rect.y) || isNaN(rect.width) || isNaN(rect.height)) {
      throw new Error('Invalid rect');
    }
    if (!components.length) {
      return {
        visible: [],
        hidden: [],
        ordered: []
      };
    }
    const {
      logicalContainerRect,
      containerRect
    } = resolveContainerRects(rect, settings);
    const [visible, hidden] = filterComponents(components, settings, logicalContainerRect);
    const reducedRect = reduceLayoutRect({
      layoutRect: logicalContainerRect,
      visible,
      hidden,
      settings
    });
    const translation = {
      x: rect.x,
      y: rect.y
    };
    const ordered = positionComponents({
      visible,
      layoutRect: logicalContainerRect,
      reducedRect,
      containerRect,
      translation
    });
    hidden.forEach(c => {
      c.comp.visible = false;
      // set empty rects on hidden components
      const r = createRect();
      c.comp.resize(r, r);
    });
    return {
      visible: visible.map(v => v.comp),
      hidden: hidden.map(h => h.comp),
      ordered: ordered.map(h => h.comp)
    };
  };
  docker.settings = function settingsFn(s) {
    settings = resolveSettings$1(s);
  };
  return docker;
}

const findComponentByKeyInList = (list, key) => {
  for (let i = 0; i < list.length; i++) {
    const currComp = list[i];
    if (currComp.hasKey && currComp.key === key) {
      return list[i];
    }
  }
  return null;
};
const wrapChildren = children => children === null || children === void 0 ? void 0 : children.map(c => {
  const dockConfig = c.instance.dockConfig();
  return {
    preferredSize(opts) {
      return dockConfig.computePreferredSize(_objectSpread2(_objectSpread2({}, opts), {}, {
        children: wrapChildren(c.children)
      }));
    }
  };
});
const hideAll = (rect, components) => ({
  visible: [],
  hidden: components,
  ordered: []
});
const customLayout = fn => (rect, components) => {
  var _fn;
  const vcomponents = components.map((c, i) => {
    const dockConfig = c.instance.dockConfig();
    return {
      index: i,
      key: c.key,
      dockConfig,
      resize: c.instance.resize,
      preferredSize(opts) {
        return dockConfig.computePreferredSize(_objectSpread2(_objectSpread2({}, opts), {}, {
          children: wrapChildren(c.children)
        }));
      }
    };
  });
  const mapBack = c => components[c.index];
  const {
    visible = vcomponents,
    hidden = [],
    ordered = visible
  } = (_fn = fn(rect, vcomponents)) !== null && _fn !== void 0 ? _fn : {};
  return {
    visible: visible.map(mapBack),
    hidden: hidden.map(mapBack),
    ordered: ordered.map(mapBack)
  };
};
const normalLayout = layoutSettings => {
  const dockLayout$1 = dockLayout(layoutSettings);
  return customLayout((rect, vcomponents) => dockLayout$1.layout(rect, vcomponents));
};
const getLayoutFn = strategy => typeof strategy === 'function' ? customLayout(strategy) : normalLayout(strategy);
function collectionFn(_ref) {
  let {
    createComponent
  } = _ref;
  const instance = {};
  let allComponents = [];
  let topComponents = [];
  const createComp = compSettings => {
    const component = createComponent(compSettings);
    if (component) {
      allComponents.push(component);
      if (compSettings.components) {
        component.children = compSettings.components.map(childSettings => createComp(childSettings)).filter(c => !!c);
      }
    }
    return component;
  };
  const removeFromAllComponents = component => {
    const index = allComponents.indexOf(component);
    if (index !== -1) {
      allComponents.splice(index, 1);
    }
  };
  const removeDeleted = (compList, settingsList) => {
    for (let i = compList.length - 1; i >= 0; i--) {
      const currComp = compList[i];
      // TODO warn when there is no key
      const currSettings = settingsList.find(c => currComp.hasKey && currComp.key === c.key);
      if (!currSettings) {
        // Component is removed
        compList.splice(i, 1);
        removeFromAllComponents(currComp);
        if (currComp.children) {
          removeDeleted(currComp.children, []);
        }
        currComp.instance.destroy();
      } else if (currComp.children && currSettings.components) {
        removeDeleted(currComp.children, currSettings.components);
      }
    }
  };
  const addAndUpdate = _ref2 => {
    let {
      compList,
      data,
      excludeFromUpdate,
      formatters,
      scales,
      settingsList
    } = _ref2;
    return (
      // Let the "components" array determine order of components
      settingsList.map(comp => {
        const component = findComponentByKeyInList(compList, comp.key);

        // Component should not be updated
        if (excludeFromUpdate.indexOf(comp.key) > -1) {
          // TODO: decide if to skip children
          delete component.updateWith;
          return component;
        }
        if (!component) {
          // Component is added
          return createComp(comp);
        }
        if (comp.rendererSettings && typeof component.instance.renderer().settings === 'function') {
          component.instance.renderer().settings(comp.rendererSettings);
        }
        // Only apply transform, no need for an update
        if (comp.rendererSettings && typeof comp.rendererSettings.transform === 'function' && comp.rendererSettings.transform()) {
          component.applyTransform = true;
          return component;
        }

        // Component is (potentially) updated
        component.updateWith = {
          formatters,
          scales,
          data,
          settings: comp
        };
        if (comp.components) {
          component.children = addAndUpdate({
            compList: component.children || [],
            data,
            excludeFromUpdate,
            formatters,
            scales,
            settingsList: comp.components
          });
        }
        return component;
      }).filter(c => !!c)
    );
  };
  const recLayout = _ref3 => {
    let {
      components,
      hidden,
      layoutFn,
      ordered,
      rect,
      visible
    } = _ref3;
    const {
      visible: v,
      hidden: h,
      ordered: o
    } = layoutFn(rect, components);
    visible.push(...v);
    hidden.push(...h);
    ordered.push(...o);
    v.forEach(c => {
      if (c.children) {
        var _c$settings$strategy, _c$settings;
        const lFn = getLayoutFn((_c$settings$strategy = (_c$settings = c.settings) === null || _c$settings === void 0 ? void 0 : _c$settings.strategy) !== null && _c$settings$strategy !== void 0 ? _c$settings$strategy : {});
        recLayout({
          components: c.children,
          hidden,
          layoutFn: lFn,
          ordered,
          rect: c.instance.getRect(),
          visible
        });
      }
    });
    h.forEach(c => {
      if (c.children) {
        recLayout({
          components: c.children,
          hidden,
          layoutFn: hideAll,
          ordered,
          rect: null,
          visible
        });
      }
    });
  };
  instance.destroy = () => {
    allComponents.forEach(comp => comp.instance.destroy());
    allComponents = [];
    topComponents = [];
  };
  instance.findComponentByKey = key => findComponentByKeyInList(allComponents, key);
  instance.forEach = fn => {
    allComponents.forEach(fn);
  };
  instance.layout = _ref4 => {
    let {
      layoutSettings,
      rect
    } = _ref4;
    const visible = [];
    const hidden = [];
    const ordered = [];
    const layoutFn = getLayoutFn(layoutSettings);
    recLayout({
      components: topComponents,
      hidden,
      layoutFn,
      ordered,
      rect,
      visible
    });
    return {
      visible,
      hidden,
      ordered
    };
  };
  instance.set = _ref5 => {
    let {
      components
    } = _ref5;
    topComponents = components.map(compSettings => createComp(compSettings)).filter(c => !!c);
  };
  instance.update = _ref6 => {
    let {
      components,
      data,
      excludeFromUpdate,
      formatters,
      scales
    } = _ref6;
    // remove deleted
    removeDeleted(topComponents, components);

    // Update and add new
    topComponents = addAndUpdate({
      compList: topComponents,
      data,
      excludeFromUpdate,
      formatters,
      scales,
      settingsList: components
    });
  };
  return instance;
}

/**
 * @callback customLayoutFunction
 * @param {Rect} rect
 * @param {object[]} components
 * @param {string} components[].key
 * @param {object} components[].dockConfig
 * @param {function} components[].resize
 * @param {function} components[].preferredSize
 */

/**
 * Called when the chart has been created
 * @callback ChartDefinition~created
 */

/**
 * Called before the chart has been mounted
 * @callback ChartDefinition~beforeMount
 */

/**
 * Called after the chart has been mounted
 * @callback ChartDefinition~mounted
 * @param {HTMLElement} element The element the chart been mounted to
 */

/**
 * Called before the chart has been rendered
 * @callback ChartDefinition~beforeRender
 */

/**
 * Called before the chart has been updated
 * @callback ChartDefinition~beforeUpdate
 */

/**
 * Called after the chart has been updated
 * @callback ChartDefinition~updated
 */

/**
 * Called before the chart has been destroyed
 * @callback ChartDefinition~beforeDestroy
 */

/**
 * Called after the chart has been destroyed
 * @callback ChartDefinition~destroyed
 */

/**
 * @typedef {ComponentAxis | ComponentBox | ComponentBrushArea | ComponentBrushAreaDir | ComponentBrushLasso | ComponentBrushRange | ComponentContainer | ComponentGridLine | ComponentLabels | ComponentLegendCat | ComponentLegendSeq | ComponentLine | ComponentPie | ComponentPoint | ComponentRefLine | ComponentText | ComponentTooltip} ComponentTypes
 */

/**
 * @typedef {object} ChartSettings
 * @property {ComponentTypes[]} [components] Components
 * @property {object.<string, ScaleDefinition>} [scales] Dictionary with scale definitions
 * @property {object.<string, FormatterDefinition>} [formatters] Dictionary with formatter definitions
 * @property {DockLayoutSettings} [strategy] Dock layout strategy
 * @property {InteractionSettings[]} [interactions] Interaction handlers
 * @property {CollectionSettings[]} [collections] Collections
 */

/**
 * Generic settings available to all components
 * @interface ComponentSettings
 * @property {string} type - Component type (ex: axis, point, ...)
 * @property {function} [preferredSize] - Function returning the preferred size
 * @property {function} [created] Called when the component has been created
 * @property {function} [beforeMount] Called before the component has been mounted
 * @property {function} [mounted] Called after the component has been mounted
 * @property {function} [beforeUpdate] Called before the component has been updated
 * @property {function} [updated] Called after the component has been updated
 * @property {function} [beforeRender] Called before the component has been rendered
 * @property {function} [beforeDestroy] Called before the component has been destroyed
 * @property {function} [destroyed] Called after the component has been destroyed
 * @property {object} [brush] Brush settings
 * @property {BrushTriggerSettings[]} [brush.trigger] Trigger settings
 * @property {BrushConsumeSettings[]} [brush.consume] Consume settings
 * @property {function} [brush.sortNodes] Sorting function for nodes. Should return sorted nodes.
 * @property {object} [layout] Layout settings
 * @property {number} [layout.displayOrder = 0]
 * @property {number} [layout.prioOrder = 0]
 * @property {string | {width: string, height: string}} [layout.minimumLayoutMode] Refer to layout sizes defined by layoutModes in `strategy`
 * @property {string} [layout.dock] left, right, top or bottom
 * @property {boolean} [show = true] If the component should be rendered
 * @property {string} [scale] Named scale. Will be provided to the component if it asks for it.
 * @property {string} [formatter] Named formatter. Fallback to create formatter from scale. Will be provided to the component if it asks for it.
 * @property {ComponentSettings[]} [components] Optional list of child components
 * @property {DockLayoutSettings|customLayoutFunction} [strategy] Layout strategy used for child components.
 * @property {DataExtraction|DataFieldExtraction} [data] Extracted data that should be available to the component
 * @property {RendererSettings} [rendererSettings] Settings for the renderer used to render the component
 * @property {string} [key] Component key
 */

// mark strategy as experimental
/**
 * @type {DockLayoutSettings|customLayoutFunction}
 * @name strategy
 * @memberof ComponentSettings
 * @experimental
 */

// mark components as experimental
/**
 * @type {ComponentSettings[]}
 * @name components
 * @memberof ComponentSettings
 * @experimental
 */

/**
 * @typedef {object} BrushTriggerSettings
 * @property {string} [on] Type of interaction to trigger brush on
 * @property {string} [action] Type of interaction to respond with
 * @property {string[]} [contexts] Name of the brushing contexts to affect
 * @property {string[]} [data] The mapped data properties to add to the brush
 * @property {string} [propagation] Control the event propagation when multiple shapes are tapped. Disabled by default
 * @property {string} [globalPropagation] Control the event propagation between components. Disabled by default
 * @property {number} [touchRadius] Extend contact area for touch events. Disabled by default
 * @property {number} [mouseRadius] Extend contact area for regular mouse events. Disabled by default
 * @example
 * {
 *    on: 'tap',
 *    action: 'toggle',
 *    contexts: ['selection', 'tooltip'],
 *    data: ['x'],
 *    propagation: 'stop', // 'stop' => prevent trigger from propagating further than the first shape
 *    globalPropagation: 'stop', // 'stop' => prevent trigger of same type to be triggered on other components
 *    touchRadius: 24,
 *    mouseRadius: 10
 *  }
 */

/**
 * @typedef {object} BrushConsumeSettings
 * @property {string} [context] Name of the brush context to observe
 * @property {string[]} [data] The mapped data properties to observe
 * @property {string} [mode] Data properties operator: and, or, xor.
 * @property {function} [filter] Filtering function
 * @property {object} [style] The style to apply to the shapes of the component
 * @property {object.<string, any>} [style.active] The style of active data points
 * @property {object.<string, any>} [style.inactive] The style of inactive data points
 * @example
 * {
 *    context: 'selection',
 *    data: ['x'],
 *    filter: (shape) => shape.type === 'circle',
 *    style: {
 *      active: {
 *        fill: 'red',
 *        stroke: '#333',
 *        strokeWidth: (shape) => shape.strokeWidth * 2,
 *      },
 *      inactive: {},
 *    },
 * }
 */

/**
 * @typedef {object} RendererSettings
 * @property {RendererSettings~TransformFunction} [transform] Setting for applying transform without re-rendering the whole component completely.
 * @property {RendererSettings~CanvasBufferSize} [canvasBufferSize] Specifies the size of buffer canvas (used together with transform setting).
 * @property {RendererSettings~Progressive} [progressive] Setting for applying progressive rendering to a canvas renderer
 * @property {boolean} [disableScreenReader = false] Setting to disable the screen reader for the component. If set to true, screen reader support will be disabled. This setting is not relevant when using the canvas renderer.
 * @experimental
 */

/**
 * Should return a transform object if transformation should be applied, otherwise undefined or a falsy value.
 * Transforms can be applied with the canvas, svg and dom renderer.
 * Transform is applied when running chart.update, see example.
 * !Important: When a transform is applied to a component, the underlaying node representations are not updated with the new positions/sizes, which
 * can cause problems for operations that relies on the positioning of the shapes/nodes (such as tooltips, selections etc). An extra chart update
 * without a transform is therefore needed to make sure the node position information is in sync with the visual representation again.
 * @typedef {function} RendererSettings~TransformFunction
 * @returns {TransformObject}
 * @experimental
 * @example
 * const pointComponentDef = {
 *   type: 'point',
 *   rendererSettings: {
 *     tranform() {
 *       if(shouldApplyTransform) {
 *         return {
 *           horizontalScaling: 1,
 *           horizontalSkewing: 0,
 *           verticalSkewing: 0,
 *           verticalScaling: 1,
 *           horizontalMoving: x,
 *           verticalMoving: y
 *         };
 *       }
 *     }
 *   }
 *   data: {
 * // ............
 *
 * chart.update({ partialData: true });
 */

/**
 * An object containing width and height of the canvas buffer or a function returning an object on that format.
 * Gets a rect object as input parameter.
 * @typedef {function|object} RendererSettings~CanvasBufferSize
 * @experimental
 */

/**
 * A format to represent a transformation.
 * @typedef {object} TransformObject
 * @property {number} horizontalScaling
 * @property {number} horizontalSkewing
 * @property {number} verticalSkewing
 * @property {number} verticalScaling
 * @property {number} horizontalMoving
 * @property {number} verticalMoving
 */

/**
 * A function which returns either (1) false (to specify no progressive rendering used) or an object specifing the data chunk rendered.
 *  This is only applied to a canvas renderer.
 * @typedef {function} RendererSettings~Progressive
 * @returns {ProgressiveObject|boolean}
 * @experimental
 */

/**
 * A format to represent a data chunk to be rendered.
 * @typedef {object} ProgressiveObject
 * @property {number} start - Start index of a data chunk.
 * @property {number} end - End index of a data chunk.
 * @property {boolean} isFirst - If it is the first data chunk rendered. This helps to clear a canvas before rendering.
 * @property {boolean} isLast - If it is the last data chunk rendered. This helps to update other components depending on a component with progressive rendering.
 * @experimental
 */

/**
 * @typedef {object} BrushTargetConfig
 * @property {string} key - Component key
 * @property {string[]} [contexts] - Name of the brushing contexts to affect
 * @property {string[]} [data] - The mapped data properties to add to the brush
 * @property {string} [action='set'] - Type of action to respond with
 */

function addComponentDelta(shape, containerBounds, componentBounds) {
  const dx = containerBounds.left - componentBounds.left;
  const dy = containerBounds.top - componentBounds.top;
  const type = getShapeType(shape);
  const deltaShape = extend$1(true, {}, shape);
  switch (type) {
    case 'circle':
      deltaShape.cx += dx;
      deltaShape.cy += dy;
      break;
    case 'polygon':
      for (let i = 0, num = deltaShape.vertices.length; i < num; i++) {
        const v = deltaShape.vertices[i];
        v.x += dx;
        v.y += dy;
      }
      break;
    case 'geopolygon':
      // vertices is 2D array
      for (let n = 0; n < deltaShape.vertices.length; n++) {
        const vertices = deltaShape.vertices[n];
        for (let i = 0, num = vertices.length; i < num; i++) {
          const v = vertices[i];
          v.x += dx;
          v.y += dy;
        }
      }
      break;
    case 'line':
      deltaShape.x1 += dx;
      deltaShape.y1 += dy;
      deltaShape.x2 += dx;
      deltaShape.y2 += dy;
      break;
    case 'point':
    case 'rect':
      deltaShape.x += dx;
      deltaShape.y += dy;
      break;
  }
  return deltaShape;
}
const moveToPosition = (element, comp, index) => {
  const el = comp.instance.renderer().element();
  if (isNaN(index) || !el || !element || !element.children) {
    return;
  }
  const nodes = element.children;
  const i = Math.max(0, index);
  const node = nodes[i];
  if (el === node) {
    return;
  }
  const additionalEl = comp.instance.def.additionalElements && comp.instance.def.additionalElements().filter(Boolean);
  if (element.insertBefore && typeof node !== 'undefined') {
    element.insertBefore(el, node);
    if (additionalEl) {
      additionalEl.forEach(ae => {
        element.insertBefore(ae, el);
      });
    }
  } else {
    if (additionalEl) {
      additionalEl.forEach(ae => {
        element.appendChild(ae, el);
      });
    }
    element.appendChild(el);
  }
};
function orderComponents(element, ordered) {
  const elToIdx = [];
  let numElements = 0;
  ordered.forEach(comp => {
    elToIdx.push(numElements);

    // assume each component has at least one element
    numElements++;

    // check additional elements
    const additionalEl = comp.instance.def.additionalElements && comp.instance.def.additionalElements();
    if (additionalEl) {
      numElements += additionalEl.length;
    }
  });
  ordered.forEach((comp, i) => moveToPosition(element, comp, elToIdx[i]));
}
function chartFn(definition, context) {
  /**
   * @typedef {object} ChartDefinition
   * @property {ChartDefinition~beforeDestroy} [beforeDestroy]
   * @property {ChartDefinition~beforeMount} [beforeMount]
   * @property {ChartDefinition~beforeRender} [beforeRender]
   * @property {ChartDefinition~beforeUpdate} [beforeUpdate]
   * @property {ChartDefinition~created} [created]
   * @property {ChartDefinition~destroyed} [destroyed]
   * @property {ChartDefinition~mounted} [mounted]
   * @property {ChartDefinition~updated} [updated]
   */
  let {
    /**
     * Element to attach chart to
     * @type {HTMLElement}
     * @memberof ChartDefinition
     */
    element,
    /**
     * Chart data
     * @type {Array<DataSource>|DataSource}
     * @memberof ChartDefinition
     */
    data = [],
    /**
     * Chart settings
     * @type {ChartSettings}
     * @memberof ChartDefinition
     */
    settings = {},
    on = {}
  } = definition;
  const registries = context.registries;
  const logger = context.logger;
  const theme = themeFn(context.style, context.palettes);
  const listeners = [];
  /**
   * Chart instance
   * @alias Chart
   * @interface
   */
  const instance = extend$1({}, definition);
  const mediator$1 = mediator();
  let visibleComponents = [];
  let currentScales = null; // Built scales
  let currentFormatters = null; // Built formatters
  let currentScrollApis = null; // Build scroll apis
  let currentInteractions = [];
  let dataset = () => {};
  let dataCollection = () => {};
  const brushes = {};
  let stopBrushing = false;
  const createComponent = compSettings => {
    if (!registries.component.has(compSettings.type)) {
      logger.warn("Unknown component: ".concat(compSettings.type));
      return false;
    }
    const componentDefinition = registries.component(compSettings.type);
    const compInstance = componentFactory(componentDefinition, {
      settings: compSettings,
      chart: instance,
      mediator: mediator$1,
      registries,
      theme,
      container: element
    });
    return {
      instance: compInstance,
      settings: extend$1(true, {}, compSettings),
      key: compSettings.key,
      hasKey: typeof compSettings.key !== 'undefined'
    };
  };
  const componentsC = collectionFn({
    createComponent
  });

  // Create a callback that calls lifecycle functions in the definition and config (if they exist).
  function createCallback(method) {
    let defaultMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    return function cb() {
      const inDefinition = typeof definition[method] === 'function';
      let returnValue;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (inDefinition) {
        returnValue = definition[method].call(instance, ...args);
      } else {
        returnValue = defaultMethod.call(instance, ...args);
      }
      return returnValue;
    };
  }
  function getElementRect(el) {
    if (typeof el.getBoundingClientRect === 'function') {
      const {
        width,
        height
      } = el.getBoundingClientRect();
      return {
        x: 0,
        y: 0,
        width,
        height
      };
    }
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
  const layout = () => {
    let layoutSettings;
    if (settings.dockLayout) {
      logger.warn('Deprecation Warning: "dockLayout" property should be renamed to "strategy"');
      layoutSettings = settings.dockLayout;
    } else {
      layoutSettings = settings.strategy;
    }
    const rect = getElementRect(element);
    return componentsC.layout({
      layoutSettings,
      rect
    });
  };
  const created = createCallback('created');
  const beforeMount = createCallback('beforeMount');
  const mounted = createCallback('mounted');
  const beforeUpdate = createCallback('beforeUpdate');
  const updated = createCallback('updated');
  const beforeRender = createCallback('beforeRender');
  const beforeDestroy = createCallback('beforeDestroy');
  const destroyed = createCallback('destroyed');
  const set = function (_data, _settings) {
    let {
      partialData
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const {
      formatters = {},
      scales = {},
      scroll = {}
    } = _settings;
    dataset = datasets(_data, {
      logger,
      types: registries.data
    });
    if (!partialData) {
      Object.keys(brushes).forEach(b => brushes[b].clear());
    }
    if (_settings.palettes) {
      theme.setPalettes(_settings.palettes);
    }
    if (_settings.style) {
      theme.setStyle(_settings.style);
    }
    dataCollection = create$p(_settings.collections, {
      dataset
    }, {
      logger
    });
    const deps = {
      theme,
      logger
    };
    currentScales = collection(scales, {
      dataset,
      collection: dataCollection
    }, _objectSpread2(_objectSpread2({}, deps), {}, {
      scale: registries.scale
    }));
    currentFormatters = collection$1(formatters, {
      dataset,
      collection: dataCollection
    }, _objectSpread2(_objectSpread2({}, deps), {}, {
      formatter: registries.formatter
    }));
    currentScrollApis = builder(scroll, currentScrollApis);
  };
  const render = () => {
    const {
      components = []
    } = settings;
    beforeRender();
    set(data, settings);
    componentsC.set({
      components
    });
    const {
      visible,
      hidden,
      ordered
    } = layout();
    visibleComponents = visible;
    hidden.forEach(comp => {
      comp.instance.hide();
      comp.visible = false;
    });
    visible.forEach(comp => comp.instance.beforeMount());
    visible.forEach(comp => comp.instance.mount());
    visible.forEach(comp => comp.instance.beforeRender());
    visible.forEach(comp => comp.instance.render());
    visible.forEach(comp => comp.instance.mounted());
    visible.forEach(comp => {
      comp.visible = true;
    });
    orderComponents(element, ordered);
  };
  function setInteractions() {
    let interactions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const current = {};
    const newKeys = interactions.filter(it => !!it.key).map(it => it.key);
    currentInteractions.forEach(cit => {
      if (cit.key && newKeys.indexOf(cit.key) !== -1) {
        // keep old instance
        current[cit.key] = cit;
      } else {
        cit.destroy();
      }
    });
    currentInteractions = interactions.map(intSettings => {
      const intDefinition = intSettings.key && current[intSettings.key] ? current[intSettings.key] : registries.interaction(intSettings.type)(instance, mediator$1, element);
      intDefinition.set(intSettings);
      return intDefinition;
    });
  }
  const componentsFromPoint = p => {
    const br = element.getBoundingClientRect();
    const x = 'clientX' in p ? p.clientX : p.x;
    const y = 'clientY' in p ? p.clientY : p.y;
    const tp = {
      x: x - br.left,
      y: y - br.top
    };
    const ret = [];
    visibleComponents.forEach(c => {
      const r = c.instance.getRect();
      // Do test on physical rect and use computed rect if available, otherwise fallback to computing a new rect for legacy support
      if (testRectPoint(r.computedPhysical ? r.computedPhysical : {
        x: r.margin.left + r.x * r.scaleRatio.x,
        y: r.margin.top + r.y * r.scaleRatio.y,
        width: r.width * r.scaleRatio.x,
        height: r.height * r.scaleRatio.y
      }, tp)) {
        ret.push(c);
      }
    });
    return ret;
  };
  const addDefaultEventListeners = () => {
    if (listeners.length || !element) {
      return;
    }
    Object.keys(on).forEach(key => {
      const listener = on[key].bind(instance);
      element.addEventListener(key, listener);
      listeners.push({
        key,
        listener
      });
    });
    const eventInfo = {};
    const onTapDown = e => {
      if (e.touches) {
        eventInfo.x = e.touches[0].clientX;
        eventInfo.y = e.touches[0].clientY;
        eventInfo.multiTouch = e.touches.length > 1;
      } else {
        eventInfo.x = e.clientX;
        eventInfo.y = e.clientY;
        eventInfo.multiTouch = false;
      }
      eventInfo.time = Date.now();
      eventInfo.comps = componentsFromPoint(eventInfo);
    };
    const onBrushTap = e => {
      const comps = eventInfo.comps || componentsFromPoint(e);
      if (comps.every(c => c.instance.def.disableTriggers)) {
        return;
      }
      if (e.type === 'touchend') {
        e.preventDefault();
      }
      if (!isValidTapEvent(e, eventInfo)) {
        return;
      }
      for (let i = comps.length - 1; i >= 0; i--) {
        const comp = comps[i];
        comp.instance.onBrushTap(e);
        if (stopBrushing) {
          stopBrushing = false;
          break;
        }
      }
    };
    const onBrushOver = e => {
      const comps = componentsFromPoint(e);
      for (let i = comps.length - 1; i >= 0; i--) {
        const comp = comps[i];
        comp.instance.onBrushOver(e);
        if (stopBrushing) {
          stopBrushing = false;
          break;
        }
      }
    };
    const brushEventList = [];
    brushEventList.push({
      key: 'mousedown',
      listener: onTapDown
    });
    brushEventList.push({
      key: 'mouseup',
      listener: onBrushTap
    });
    if (detectTouchSupport(element)) {
      brushEventList.push({
        key: 'touchstart',
        listener: onTapDown
      });
      brushEventList.push({
        key: 'touchend',
        listener: onBrushTap
      });
    }
    brushEventList.push({
      key: 'mousemove',
      listener: onBrushOver
    });
    brushEventList.forEach(event => {
      element.addEventListener(event.key, event.listener);
      listeners.push(event);
    });
  };
  const removeDefaultEventListeners = () => {
    listeners.forEach(_ref => {
      let {
        key,
        listener
      } = _ref;
      return element.removeEventListener(key, listener);
    });
    listeners.length = 0;
  };

  // Browser only
  const mount = () => {
    element.innerHTML = '';
    render();
    addDefaultEventListeners();
    setInteractions(settings.interactions);
  };
  const unmount = () => {
    removeDefaultEventListeners();
    setInteractions();
  };

  /**
   * Layout the chart with new settings and / or data
   * @param {object} [def] - New chart definition
   * @param {Array<DataSource>|DataSource} [def.data] Chart data
   * @param {ChartSettings} [def.settings] Chart settings
   * @param {string[]} [def.excludeFromUpdate=[]] Keys of components to not include in the layout
   * @experimental
   */
  instance.layoutComponents = function () {
    let newProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      excludeFromUpdate = []
    } = newProps;
    if (newProps.data) {
      data = newProps.data;
    }
    if (newProps.settings) {
      settings = newProps.settings;
      setInteractions(newProps.settings.interactions);
    }
    beforeUpdate();
    set(data, settings);
    const {
      formatters,
      scales,
      components = []
    } = settings;
    componentsC.update({
      components,
      data,
      excludeFromUpdate,
      formatters,
      scales
    });
    componentsC.forEach(comp => {
      if (comp.updateWith) {
        comp.instance.set(comp.updateWith);
      }
    });
    componentsC.forEach(comp => {
      if (comp.updateWith) {
        comp.instance.beforeUpdate();
      }
    });
    layout(); // Relayout
  };

  /**
   * Update the chart with new settings and / or data
   * @param {object} [def] - New chart definition
   * @param {Array<DataSource>|DataSource} [def.data] Chart data
   * @param {ChartSettings} [def.settings] Chart settings
   * @param {boolean} [def.partialData=false] If set to true, will trigger a data update only. Meaning the layout will not be updated
   * @param {string[]} [def.excludeFromUpdate=[]] Keys of components to not include in the update
   */
  instance.update = function () {
    let newProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      partialData,
      excludeFromUpdate = []
    } = newProps;
    let visibleOrdered;
    if (newProps.data) {
      data = newProps.data;
    }
    if (newProps.settings) {
      settings = newProps.settings;
      setInteractions(newProps.settings.interactions);
    }
    beforeUpdate();
    set(data, settings, {
      partialData
    });
    const {
      formatters,
      scales,
      components = []
    } = settings;
    componentsC.update({
      components,
      data,
      excludeFromUpdate,
      formatters,
      scales
    });
    componentsC.forEach(comp => {
      if (comp.updateWith) {
        comp.instance.set(comp.updateWith);
      }
    });
    componentsC.forEach(comp => {
      if (comp.updateWith) {
        comp.instance.beforeUpdate();
      }
    });
    const toUpdate = [];
    const toRender = [];
    let toRenderOrUpdate;
    if (partialData) {
      componentsC.forEach(comp => {
        if ((comp.updateWith || comp.applyTransform) && comp.visible) {
          toUpdate.push(comp);
        }
      });
      toRenderOrUpdate = toUpdate;
    } else {
      const {
        visible,
        hidden,
        ordered
      } = layout(); // Relayout
      visibleComponents = visible;
      toRenderOrUpdate = visible;
      visibleOrdered = ordered;
      visible.forEach(comp => {
        if (comp.updateWith && comp.visible) {
          toUpdate.push(comp);
        } else {
          toRender.push(comp);
        }
      });
      hidden.forEach(comp => {
        comp.instance.hide();
        comp.visible = false;
        delete comp.updateWith;
        comp.applyTransform = false;
      });
    }
    toRender.forEach(comp => comp.instance.beforeMount());
    toRender.forEach(comp => comp.instance.mount());
    toRenderOrUpdate.forEach(comp => comp.instance.beforeRender());
    toRenderOrUpdate.forEach(comp => {
      if ((comp.updateWith || comp.applyTransform) && comp.visible) {
        comp.instance.update();
      } else {
        comp.instance.render();
      }
    });

    // Ensure that displayOrder is keept, only do so on re-layout update.
    // Which is only the case if partialData is false.
    if (!partialData) {
      orderComponents(element, visibleOrdered);
    }
    toRender.forEach(comp => comp.instance.mounted());
    toUpdate.forEach(comp => comp.instance.updated());
    visibleComponents.forEach(comp => {
      delete comp.updateWith;
      comp.visible = true;
      comp.applyTransform = false;
    });
    updated();
  };

  /**
   * Destroy the chart instance.
   */
  instance.destroy = () => {
    beforeDestroy();
    componentsC.destroy();
    unmount();
    delete instance.update;
    delete instance.destroy;
    destroyed();
  };

  /**
   * Get all shapes associated with the provided context
   * @param {string} context The brush context
   * @param {string} mode Property comparison mode.
   * @param {Array<string>} props Which specific data properties to compare
   * @param {string} key Which component to get shapes from. Default gives shapes from all components.
   * @return {Array<object>} Array of objects containing shape and parent element
   */
  instance.getAffectedShapes = function (ctx) {
    let mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
    let props = arguments.length > 2 ? arguments[2] : undefined;
    let key = arguments.length > 3 ? arguments[3] : undefined;
    let shapes = [];
    visibleComponents.filter(comp => key === undefined || key === null || comp.key === key).forEach(comp => {
      const brushedShapes = comp.instance.getBrushedShapes(ctx, mode, props);
      shapes = [...shapes, ...brushedShapes];
    });
    return shapes;
  };

  /**
   * Get all nodes matching the provided selector
   * @param {string} selector CSS selector [type, attribute, universal, class]
   * @returns {Array<SceneNode>} Array of objects containing matching nodes
   *
   * @example
   * chart.findShapes('Circle') // [<CircleNode>, <CircleNode>]
   * chart.findShapes('Circle[fill="red"][stroke!="black"]') // [CircleNode, CircleNode]
   * chart.findShapes('Container Rect') // [Rect, Rect]
   */
  instance.findShapes = selector => {
    let shapes = [];
    visibleComponents.forEach(c => {
      const matchedShapes = c.instance.findShapes(selector);
      shapes = [...shapes, ...matchedShapes];
    });
    return shapes;
  };

  /**
   * Get components overlapping a point.
   * @param {Point} p - Point with x- and y-coordinate. The coordinate is relative to the browser viewport.
   * @returns {Array<Component>} Array of component contexts
   */
  instance.componentsFromPoint = p => componentsFromPoint(p).map(comp => comp.instance.ctx);

  /**
   * Get all nodes colliding with a geometrical shape (circle, line, rectangle, point, polygon, geopolygon).
   *
   * The input shape is identified based on the geometrical attributes in the following order: circle => line => rectangle => point => polygon => geopolygon.
   * Note that not all nodes on a scene have collision detection enabled.
   * @param {Line|Rect|Point|Circle} shape - A geometrical shape. Coordinates are relative to the top-left corner of the chart instance container.
   * @param {object} opts - Options
   * @param {object[]} [opts.components] - Array of components to include in the lookup. If no components are specified, all components will be included.
   * @param {string} [opts.components[].component.key] - Component key
   * @param {string} [opts.components[].component.propagation] - if set to `stop`, will start lookup on top visible shape and propagate downwards until a shape is found.
   * @param {string} [opts.propagation] - if set to `stop`, will start lookup on top visible component and propagate downwards until a component has at least a match.
   * @returns {Array<SceneNode>} Array of objects containing colliding nodes
   *
   * @example
   * chart.shapesAt(
   *  {
   *    x: 0,
   *    y: 0,
   *    width: 100,
   *    height: 100
   *  },
   *  {
   *    components: [
   *      { key: 'key1', propagation: 'stop' },
   *      { key: 'key2' }
   *    ],
   *    propagation: 'stop'
   *  }
   * );
   */
  instance.shapesAt = function (shape) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let result = [];
    const containerBounds = element.getBoundingClientRect();
    let comps = visibleComponents; // Assume that visibleComponents is ordererd according to displayOrder

    if (Array.isArray(opts.components) && opts.components.length > 0) {
      const compKeys = opts.components.map(c => c.key);
      comps = visibleComponents.filter(c => compKeys.indexOf(c.key) !== -1).map(c => ({
        instance: c.instance,
        opts: opts.components[compKeys.indexOf(c.key)]
      }));
    }
    for (let i = comps.length - 1; i >= 0; i--) {
      const c = comps[i];
      const componentBounds = c.instance.renderer().element().getBoundingClientRect();
      const deltaShape = addComponentDelta(shape, containerBounds, componentBounds);
      const shapes = c.instance.shapesAt(deltaShape, c.opts);
      const stopPropagation = shapes.length > 0 && opts.propagation === 'stop';
      result = [...result, ...shapes];
      if (result.length > 0 && stopPropagation) {
        return result;
      }
    }
    return result;
  };

  /**
   * Brush data by providing a collection of data bound shapes.
   * @param {SceneNode[]} shapes - An array of data bound shapes.
   * @param {object} config - Options
   * @param {BrushTargetConfig[]} config.components - Array of components to include in the lookup
   *
   * @example
   * const shapes = chartInstance.shapesAt(...);
   * const config = {
   *  components:[
   *    {
   *      key: 'key1',
   *      contexts: ['myContext'],
   *      data: [''],
   *      action: 'add'
   *    }
   *  ]
   * };
   * chartInstance.brushFromShapes(shapes, config);
   */
  instance.brushFromShapes = function (shapes) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      components: []
    };
    for (let i = 0; i < config.components.length; i++) {
      const iKey = config.components[i].key;
      visibleComponents.filter(c => iKey === c.key).forEach(c => {
        let compShapes = shapes.filter(shape => shape.key === c.key);
        c.instance.brushFromShapes(compShapes, config.components[i]);
      });
    }
  };

  /**
   * @private
   * @param {string} name - Name of scroll api
   * @returns {object}
   */
  instance.scroll = function scroll() {
    let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
    return getOrCreateScrollApi(name, currentScrollApis);
  };

  /**
   * Get
   * @param {string} key - Get the dataset identified by `key`
   * @returns {Dataset}
   */
  instance.dataset = key => dataset(key);
  instance.dataCollection = key => dataCollection(key);

  /**
   * Get all registered scales
   * @returns {Object<string,Scale>}
   */
  instance.scales = function scales() {
    return currentScales.all();
  };

  /**
   * Get all registered formatters
   * @returns {Object<string,formatter>}
   */
  instance.formatters = function formatters() {
    return currentFormatters.all();
  };

  /**
   * Get or create brush context for this chart
   * @param {string} name - Name of the brush context. If no match is found, a new brush context is created and returned.
   * @returns {Brush}
   */
  instance.brush = function brushFn() {
    let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
    if (!brushes[name]) {
      brushes[name] = brush();
    }
    return brushes[name];
  };

  /**
   * Get or create a scale for this chart
   * @param {string|object} v - Scale reference or scale options
   * @returns {Scale}
   * @example
   * instance.scale('nameOfMyScale'); // Fetch an existing scale by name
   * instance.scale({ scale: 'nameOfMyScale' }); // Fetch an existing scale by name
   * instance.scale({ source: '0/1', type: 'linear' }); // Create a new scale
   */
  instance.scale = function scale(v) {
    return currentScales.get(v);
  };

  /**
   * Get or create a formatter for this chart
   * @param {string|object} v - Formatter reference or formatter options
   * @returns {formatter}
   * @example
   * instance.formatter('nameOfMyFormatter'); // Fetch an existing formatter by name
   * instance.formatter({ formatter: 'nameOfMyFormatter' }); // Fetch an existing formatter by name
   * instance.formatter({ type: 'q' }); // Fetch an existing formatter by type
   * instance.formatter({
   *  formatter: 'd3',
   *  type: 'number',
   *  format: '1.0.%'
   * }); // Create a new formatter
   */
  instance.formatter = function formatter(v) {
    return currentFormatters.get(v);
  };

  /**
   * @param {boolean} [val] - Toggle brushing on or off. If value is omitted, a toggle action is applied to the current state.
   */
  instance.toggleBrushing = function toggleBrushing(val) {
    if (typeof val !== 'undefined') {
      stopBrushing = val;
    } else {
      stopBrushing = !stopBrushing;
    }
  };

  /**
   * Get a component context
   * @param {string} key - Component key
   * @returns {Component} Component context
   */
  instance.component = key => {
    const component = componentsC.findComponentByKey(key);
    return component === null || component === void 0 ? void 0 : component.instance.ctx;
  };
  instance.logger = () => logger;
  instance.theme = () => theme;
  instance.storage = createStorage({
    animations: {
      updatingStageMeta: {
        isInit: false,
        shouldBeRemoved: false
      }
    }
  });

  /**
   * Interaction instance
   * @typedef {object} Interaction
   * @property {function} on Enable interaction
   * @property {function} off Disable interaction
   * @property {function} destroy Destroy interaction
   * @property {string} key Interaction identifier
   */

  /**
   * Get all interaction instances
   * @name Chart.interactions
   * @type {object}
   * @example
   * chart.interactions.instances; // Array of all interaction instances
   * chart.interactions.on(); // Toggle on all interactions instances
   * chart.interactions.off(); // Toggle off all interactions instances
   */
  Object.defineProperty(instance, 'interactions', {
    get() {
      return /** @lends Chart.interactions */{
        /** @type Array<Interaction> */
        instances: currentInteractions,
        /** Enable all interaction instances */
        on() {
          addDefaultEventListeners();
          currentInteractions.forEach(i => i.on());
        },
        /** Disable all interaction instances */
        off() {
          removeDefaultEventListeners();
          currentInteractions.forEach(i => i.off());
        }
      };
    }
  });
  created();
  if (element) {
    beforeMount();
    mount();
    mounted(element);
    instance.element = element;
  }
  return instance;
}

const rendererRegistry = reg => {
  let f = registryFactory(reg);
  f.prio = p => p ? f.default(p[0]) : [f.default()];
  f.types = () => f.getKeys();
  return f;
};

var componentRegistry = registryFactory();

function datumExtract(propCfg, cell, _ref) {
  let {
    key
  } = _ref;
  const datum = {
    value: typeof propCfg.value === 'function' // eslint-disable-line no-nested-ternary
    ? propCfg.value(cell) : typeof propCfg.value !== 'undefined' ? propCfg.value : cell
  };
  datum.label = typeof propCfg.label === 'function' // eslint-disable-line no-nested-ternary
  ? propCfg.label(cell) : typeof propCfg.label !== 'undefined' ? String(propCfg.label) : String(datum.value);
  if (propCfg.field) {
    datum.source = {
      key,
      field: propCfg.field.key()
    };
  }
  return datum;
}
function extract(config, dataset) {
  const cfgs = Array.isArray(config) ? config : [config];
  let dataItems = [];
  cfgs.forEach(cfg => {
    if (typeof cfg.field !== 'undefined') {
      const f = dataset.field(cfg.field);
      const sourceKey = dataset.key();
      if (!f) {
        throw Error("Field '".concat(cfg.field, "' not found"));
      }
      const {
        props,
        main
      } = getPropsInfo(cfg, dataset);
      const propsArr = Object.keys(props);
      const track$1 = !!cfg.trackBy;
      const trackType = typeof cfg.trackBy;
      const tracker = {};
      const trackedItems = [];
      const items = f.items();
      const mapped = [];
      for (let idx = 0; idx < items.length; idx++) {
        const mainCell = items[idx];
        const exclude = main.filter && !main.filter(mainCell);
        if (exclude) {
          continue;
        }
        const ret = datumExtract(main, mainCell, {
          key: sourceKey
        });

        // loop through all props that need to be mapped and
        // assign 'value' and 'source' to each property
        propsArr.forEach(prop => {
          const p = props[prop];
          let propCell = p.field ? p.field.items()[idx] : mainCell;
          ret[prop] = datumExtract(p, propCell, {
            key: sourceKey
          });
        });

        // collect items based on the trackBy value
        // items with the same trackBy value are placed in an array and reduced later
        if (track$1) {
          track({
            cfg,
            itemData: mainCell,
            obj: ret,
            target: trackedItems,
            tracker,
            trackType
          });
        }
        mapped.push(ret);
      }

      // reduce if items have been grouped
      if (track$1) {
        dataItems = [...dataItems, ...collect(trackedItems, {
          main,
          propsArr,
          props
        })];
      } else {
        dataItems = [...dataItems, ...mapped];
      }
    }
  });
  return dataItems;
}

const filters = {
  numeric: values => values.filter(v => typeof v === 'number' && !isNaN(v))
};
function createFields(_ref) {
  let {
    source,
    data,
    cache,
    config
  } = _ref;
  let headers;
  let content = data;
  const parse = config && config.parse;
  if (Array.isArray(data[0])) {
    // assume 2d matrix of data
    if (parse && parse.headers === false) {
      headers = data[0].map((v, i) => i);
    } else {
      headers = data[0];
      content = data.slice(1);
    }
  } else {
    headers = Object.keys(data[0]);
  }
  const rowFn = !!parse && typeof parse.row === 'function' && parse.row;
  let flds = headers;
  if (parse && typeof parse.fields === 'function') {
    flds = parse.fields(flds.slice());
  } else {
    flds = headers.map(h => ({
      key: h,
      title: h
    }));
  }
  let fieldValues;
  if (Array.isArray(data[0])) {
    fieldValues = flds.map(() => []);
  } else {
    fieldValues = {};
    flds.forEach(f => {
      fieldValues[f.key] = [];
    });
  }
  for (let r = 0; r < content.length; r++) {
    const row = rowFn ? rowFn(content[r], r, flds) : content[r];
    if (!row) {
      continue;
    }
    if (Array.isArray(row)) {
      for (let c = 0; c < flds.length; c++) {
        fieldValues[c].push(row[c]);
      }
    } else {
      for (let c = 0; c < flds.length; c++) {
        fieldValues[flds[c].key].push(row[flds[c].key]);
      }
    }
  }
  const fv = Array.isArray(fieldValues) ? i => fieldValues[i] : i => fieldValues[flds[i].key];
  for (let c = 0; c < flds.length; c++) {
    const values = fv(c);
    const numericValues = filters.numeric(values);
    const isMeasure = numericValues.length > 0;
    const type = isMeasure ? 'measure' : 'dimension';
    const min = isMeasure ? Math.min(...numericValues) : NaN;
    const max = isMeasure ? Math.max(...numericValues) : NaN;
    cache.fields.push(field(extend$1({
      source,
      key: c,
      title: flds[c].title,
      values,
      min,
      max,
      type
    }, flds[c]), {
      value: flds[c].value,
      label: flds[c].label
    }));
  }
}
const dsv = _ref2 => {
  let {
    data,
    config
  } = _ref2;
  const rows = data.split('\n');
  const row0 = rows[0];
  const row1 = rows[1];
  let delimiter = ',';
  if (config && config.parse && config.parse.delimiter) {
    delimiter = config.parse.delimiter;
  } else if (row0) {
    // guess delimiter
    const guesses = [/,/, /\t/, /;/];
    for (let i = 0; i < guesses.length; i++) {
      const d = guesses[i];
      if (row0 && row1) {
        if (d.test(row0) && d.test(row1) && row0.split(d).length === row1.split(d).length) {
          delimiter = d;
          break;
        }
      } else if (d.test(row0)) {
        delimiter = d;
      }
    }
  }
  return rows.map(row => row.split(delimiter));
};
const parseData = _ref3 => {
  let {
    key,
    data,
    cache,
    config
  } = _ref3;
  if (!data) {
    return;
  }
  let dd = data;
  if (typeof dd === 'string') {
    // assume dsv
    dd = dsv({
      data,
      config
    });
  }
  if (!Array.isArray(dd)) {
    return; // warn?
  }
  createFields({
    data: dd,
    cache,
    source: key,
    config
  });
};

/**
 * Create a new dataset with default settings
 * @private
 * @return {Dataset}
 */
function ds() {
  let {
    key,
    data,
    config
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const cache = {
    fields: []
  };

  /**
   * @alias Dataset
   * @interface
   */
  const dataset = {
    /**
     * Get the key identifying this dataset
     * @returns {string}
     */
    key: () => key,
    /**
     * Get the raw data
     * @returns {any}
     */
    raw: () => data,
    /**
     * Find a field within this dataset
     * @param {string} query - The field to find
     * @returns {Field}
     */
    field: query => findField(query, {
      cache,
      matrix: data
    }),
    /**
     * Get all fields within this dataset
     * @returns {Array<Field>}
     */
    fields: () => cache.fields.slice(),
    /**
     * Extract data items from this dataset
     * @param {DataExtraction~Extract|DataFieldExtraction} config
     * @returns {Array<DatumExtract>}
     */
    extract: cfg => extract(cfg, dataset),
    /**
     * @returns {null}
     */
    hierarchy: () => null
  };
  parseData({
    key,
    data,
    config,
    cache
  });
  return dataset;
}
ds.util = {
  normalizeConfig: getPropsInfo,
  collect,
  track
};

/**
 * Callback function. Should return the key to stack by
 * @callback
 * @typedef {function} DataExtraction~StackKeyCallback
 * @param {DatumExtract} datum The extracted datum
 * @returns {any} The data value to stack by
 */

/**
 * Callback function. Should return the data value to stack with
 * @callback
 * @typedef {function} DataExtraction~StackValueCallback
 * @param {DatumExtract} datum The extracted datum
 * @returns {any} The data value to stack with
 */

/**
 * Callback function to filter the extracted data items
 * @callback
 * @typedef {function} DataExtraction~FilterCallback
 * @param {DatumExtract} datum The extracted datum
 * @returns {boolean} Return true if the datum should be included in the final data set
 */

/**
 * Callback function to sort the extracted data items
 * @callback
 * @typedef {function} DataExtraction~SortCallback
 * @param {DatumExtract} a The extracted datum
 * @param {DatumExtract} b The extracted datum
 * @returns {number} If less than 0, sort a before b. If greater than 0, sort b before a
 */

/**
 * Used to extract data from a `DataSource`
 * @typedef {object} DataExtraction
 * @property {DataExtraction~Extract|DataExtraction~Extract[]} extract Extract definition
 * @property {object} [stack] If provided, defines how the data should be stacked
 * @property {DataExtraction~StackKeyCallback} stack.stackKey Callback function. Should return the key to stack by
 * @property {DataExtraction~StackValueCallback} stack.value Callback function. Should return the data value to stack with
 * @property {DataExtraction~FilterCallback} [filter] Callback function to filter the extracted data items
 * @property {DataExtraction~SortCallback} [sort] Callback function to sort the extracted data items
 * @example
{
  extract: [{
    source: 'Products',
    field: 'Product',
    value: d => d.name,
    label: d => `<${d.name}>`
    props: {
      year: { field: 'Year' }
      num: { field: 'Sales' }
    }
  }],
  filter: d => d.label !== 'Sneakers', // extract everything except Sneakers
  sort: (a, b) => a.label > b.label ? -1 : 1, // sort descending
}
 */

/**
 * @typedef {object} DataFieldExtraction
 * @property {string} source - Which data source to extract from
 * @property {string} field - The field to extract data from
 * @property {DataExtraction~Extract~ValueFn|string|number|boolean} [value] - The field value accessor
 * @property {DataExtraction~Extract~LabelFn|string|number|boolean} [label] - The field label accessor
 * @example
 * {
 *  source: 'Products',
 *  field: 'Sales',
 *  value: (val) => Math.round(val),
 *  label: (val) => `<${val}>`
 * }
 */

/**
 * Data extraction definition. Define how and what kind of data should be extracted from a `DataSource`.
 * @typedef {object} DataExtraction~Extract
 * @property {string} source - Which data source to extract from
 * @property {string} field - The field to extract data from
 * @property {DataExtraction~Extract~ValueFn|string|number|boolean} [value] - The field value accessor
 * @property {DataExtraction~Extract~LabelFn|string|number|boolean} [label] - The field label accessor
 * @property {DataExtraction~Extract~TrackByFn} [trackBy] - Track by value accessor
 * @property {DataExtraction~Extract~ReduceFn|string} [reduce] - Reducer function
 * @property {DataExtraction~Extract~ReduceLabelFn|string} [reduceLabel] - Label reducer function
 * @property {DataExtraction~Extract~FilterFn} [filter] - Filter function
 * @property {object.<string, DataExtraction~Extract~Props>} [props] - Additional properties to add to the extracted item
 * @example
 * {
    source: 'Products',
    field: 'Product',
    value: (val) => val,
    label: (val) => `<${val}>`
    props: {
      year: { field: 'Year' }
      num: { field: 'Sales' }
    }
  }
 */

/**
 * @typedef {object} DataExtraction~Extract~Props
 * @property {string} field - The field to extract data from
 * @property {DataExtraction~Extract~ValueFn|string|number|boolean} [value] - The field value accessor
 * @property {DataExtraction~Extract~LabelFn|string|number|boolean} [label] - The field label accessor
 * @example
 * {
 *  field: 'Sales',
 *  value: (val) => Math.round(val),
 *  label: (val) => `<${val}>`
 * }
 */

/**
 * Value callback function
 * @callback DataExtraction~Extract~ValueFn
 * @param {any} cell The field cell
 * @returns {any}
 */

/**
 * Label callback function
 * @callback DataExtraction~Extract~LabelFn
 * @param {any} cell The field cell
 * @returns {string}
 */

/**
 * Filter callback function
 * @callback DataExtraction~Extract~FilterFn
 * @param {any} cell The field cell
 * @returns {boolean}
 */

/**
 * TrackBy callback function
 * @callback DataExtraction~Extract~TrackByFn
 * @param {any} cell The field cell
 * @returns {any}
 */

/**
 * Reduce callback function
 * @callback DataExtraction~Extract~ReduceFn
 * @param {any[]} values The collected values to reduce
 * @returns {any}
 */

/**
 * ReduceLabel callback function
 * @callback DataExtraction~Extract~ReduceLabelFn
 * @param {any[]} labels The collected labels to reduce
 * @param {any} value Reduced value
 * @returns {string}
 */

/**
 * @typedef {object} DatumExtract
 * @property {any} value - The extracted value
 * @property {string} label - The extracted value as a string
 * @property {object} source - The data source of the extracted data
 * @property {string} source.key - The data-source key
 * @property {string} source.field - The source field
 */

const dataRegistry = registryFactory();
dataRegistry.default('matrix');
dataRegistry('matrix', ds);
dataRegistry('default', ds); // deprecated

/**
 * Manages event handlers for native events
 * @private
 */
function native(chart, mediator, element) {
  let instance = {
    chart,
    mediator,
    element
  };
  let nativeEvents = [];
  let settings;
  let itKey;
  let isOn = true;

  /**
   * Set default settings
   * @private
   */
  function setDefaultSettings(newSettings) {
    itKey = newSettings.key;
    settings = newSettings;
    settings.events = settings.events || [];
    if (settings.enable === undefined) {
      settings.enable = true;
    }
  }

  /**
   * Add native events based on settings
   * @private
   */
  function addEvents() {
    if (typeof settings.enable === 'function') {
      settings.enable = settings.enable.bind(instance)();
    }
    if (!settings.enable) {
      return; // interaction is disabled
    }
    Object.keys(settings.events).forEach(key => {
      const listener = settings.events[key].bind(instance);
      element.addEventListener(key, listener);
      nativeEvents.push({
        key,
        listener
      });
    });
  }

  /**
   * Removes all added native events
   * @private
   */
  function removeAddedEvents() {
    // remove added native events
    nativeEvents.forEach(_ref => {
      let {
        key,
        listener
      } = _ref;
      element.removeEventListener(key, listener);
    });
    nativeEvents = [];
  }
  return {
    /**
     * Getter for the key.
     * @private
     */
    get key() {
      return itKey;
    },
    /**
     * Updates this with new settings
     * @private
     * @param {object} newSettings
     * @param {string} [newSettings.type] - The interaction type. Is 'native' for this component
     * @param {boolean|function} [newSettings.enable=true] - Should the interactions defined here be enabled or not.
     * This is only run when adding event handlers. In effect at startup, update or during on/off.
     * It does not run during every event loop.
     * @param {array} [newSettings.gestures] - The keys in this object is the names of native events
     * that should be added to the chart element and they should all point to function which
     * will be the corresponding event handler.
     */
    set(newSettings) {
      setDefaultSettings(newSettings);
      removeAddedEvents();
      if (isOn) {
        addEvents();
      }
    },
    /**
     * Turns off interactions
     * @private
     */
    off() {
      isOn = false;
      removeAddedEvents();
    },
    /**
     * Turns off interactions
     * @private
     */
    on() {
      isOn = true;
      if (nativeEvents.length === 0) {
        addEvents();
      }
    },
    /**
     * Destroys and unbinds all event handlers
     * @private
     */
    destroy() {
      removeAddedEvents();
      instance = null;
      settings = null;
    }
  };
}

/**
 * @interface InteractionSettings
 * @property {string} type Type of interaction handler
 * @property {string} [key] Unique key identifying the handler
 * @property {function|boolean} enable Enable or disable the interaction handler. If a callback function is provided, it must return either true or false
 * @example
 * {
 *  type: 'native',
 *  key: 'nativeHandler',
 *  enable: () => true,
 *  events: { // "events" is a property specific to the native handler
 *    mousemove: (e) => console.log('mousemove', e),
 *  }
 * }
 */

const reg$3 = registryFactory();
reg$3('native', native);

/**
 * Short-hand for max(min())
 *
 * @param {number} min Minimum allowed value
 * @param {number} max Maximum allowed value
 * @param {number} value The actual value to cap
 * @ignore
 */
function cap(min, max, value) {
  return Math.max(min, Math.min(max, value));
}

/**
 * Resolve a diff, i.e. resolveDiff(0.2, 0.6, 1, 100) = 20
 *
 * @param {object} params parameters
 * @param {number} params.start Normalized start value
 * @param {number} params.end Normalized end value
 * @param {number} params.minPx The minimum number of pixels
 * @param {number} params.maxPx Maximum number of pixels, i.e. the width or height
 * @ignore
 */
function resolveDiff(_ref) {
  let {
    start,
    end,
    minPx = 0.1,
    maxPx = 1
  } = _ref;
  const high = Math.max(start, end);
  const low = Math.min(start, end);
  const highModified = cap(-0.1, 1.2, high);
  const lowModified = cap(-0.1, 1.2, low);
  const wantedDiff = highModified * maxPx - lowModified * maxPx;
  const actualDiff = Math.max(minPx, wantedDiff);
  const startModifier = (actualDiff - wantedDiff) / 2;
  const actualLow = lowModified * maxPx - startModifier;
  return {
    actualDiff,
    startModifier,
    actualLow
  };
}

/**
 * Out of bounds shape
 * @param {object} params parameters
 * @param {object} params.item Resolved styling item from box component with item.major
 * @param {number} params.value 0 or 1 depending on where to render the oob shape
 * @param {number} params.boxWidth Un-calculated box width in relative/normalized format
 * @param {number} params.boxPadding Un-calculated box padding in relative/normalized format
 * @param {number} params.rendWidth The pixel width of the area to render upon
 * @param {number} params.rendHeight The pixel height of the area to render upon
 * @param {boolean} params.flipXY Wether or not to flip X and Y coordinates together with Width and Height
 * @param {function} params.symbol Symbol library function from component
 * @ignore
 */
function oob(_ref) {
  let {
    item,
    value,
    boxCenter,
    rendWidth,
    rendHeight,
    flipXY,
    symbol
  } = _ref;
  let x = 'x';
  let y = 'y';
  let calcwidth = rendWidth;
  let calcheight = rendHeight;
  let startAngle = value < 0.5 ? 90 : -90;
  if (flipXY) {
    x = 'y';
    y = 'x';
    calcwidth = rendHeight;
    calcheight = rendWidth;
    startAngle = value < 0.5 ? 180 : 0;
  }
  return symbol(extend$1({}, item.oob, {
    [x]: boxCenter * calcwidth,
    [y]: Math.max(item.oob.size / 2, Math.min(value * calcheight, calcheight - item.oob.size / 2)),
    startAngle
  }));
}

/**
 * Box shape calculation function
 * @param {object} params parameters
 * @param {object} params.item Resolved styling item from box component with item.major
 * @param {number} params.boxWidth Un-calculated box width in relative/normalized format
 * @param {number} params.boxPadding Un-calculated box padding in relative/normalized format
 * @param {number} params.rendWidth The pixel width of the area to render upon
 * @param {number} params.rendHeight The pixel height of the area to render upon
 * @param {boolean} params.flipXY wether or not to flip X and Y coordinates together with Width and Height
 * @ignore
 */
function box$1(_ref2) {
  let {
    item,
    boxWidth,
    boxPadding,
    rendWidth,
    rendHeight,
    flipXY
  } = _ref2;
  let x = 'x';
  let y = 'y';
  let width = 'width';
  let height = 'height';
  let calcwidth = rendWidth;
  let calcheight = rendHeight;
  if (flipXY) {
    x = 'y';
    y = 'x';
    width = 'height';
    height = 'width';
    calcwidth = rendHeight;
    calcheight = rendWidth;
  }
  const {
    actualDiff,
    actualLow
  } = resolveDiff({
    start: item.start,
    end: item.end,
    minPx: item.box.minHeightPx,
    maxPx: calcheight
  });
  return extend$1({}, item.box, {
    type: 'rect',
    [x]: (boxPadding + item.major) * calcwidth,
    [y]: actualLow,
    [height]: actualDiff,
    [width]: boxWidth * calcwidth,
    data: item.data || {},
    collider: {
      type: null
    }
  });
}

/**
 * A vertical line shape (for start - min, end - max values)
 * @param {object} params parameters
 * @param {object} params.item Resolved styling item from box component with item.major
 * @param {number} params.from Normalized from value
 * @param {number} params.to Normalized to value
 * @param {number} params.boxCenter Center coordinate for the box
 * @param {number} params.rendWidth The pixel width of the area to render upon
 * @param {number} params.rendHeight The pixel height of the area to render upon
 * @param {boolean} params.flipXY wether or not to flip X and Y coordinates together with Width and Height
 * @ignore
 */
function verticalLine(_ref3) {
  let {
    item,
    from,
    to,
    boxCenter,
    rendWidth,
    rendHeight,
    flipXY
  } = _ref3;
  let x1 = 'x1';
  let y1 = 'y1';
  let x2 = 'x2';
  let y2 = 'y2';
  let calcwidth = rendWidth;
  let calcheight = rendHeight;
  if (flipXY) {
    x1 = 'y1';
    y1 = 'x1';
    x2 = 'y2';
    y2 = 'x2';
    calcwidth = rendHeight;
    calcheight = rendWidth;
  }
  return extend$1({}, item.line, {
    type: 'line',
    [y2]: Math.floor(from * calcheight),
    [x1]: boxCenter * calcwidth,
    [y1]: Math.floor(to * calcheight),
    [x2]: boxCenter * calcwidth,
    data: item.data || {},
    collider: {
      type: null
    }
  });
}

/**
 * A horizontal line shape (for median and whiskers)
 * @param {object} params parameters
 * @param {object} params.item Resolved styling item from box component with item.major
 * @param {string} params.key Which key to use as style base in the item object
 * @param {number} params.position At which "height" (X) to position the horizontal line
 * @param {number} params.width Width of the horizontal line (i.e. box width or a multiple of it)
 * @param {number} params.boxCenter Center coordinate for the box
 * @param {number} params.rendWidth The pixel width of the area to render upon
 * @param {number} params.rendHeight The pixel height of the area to render upon
 * @param {boolean} params.flipXY wether or not to flip X and Y coordinates together with Width and Height
 * @ignore
 */
function horizontalLine(_ref4) {
  let {
    item,
    key,
    position,
    width,
    boxCenter,
    rendWidth,
    rendHeight,
    flipXY
  } = _ref4;
  let x1 = 'x1';
  let y1 = 'y1';
  let x2 = 'x2';
  let y2 = 'y2';
  let calcwidth = rendWidth;
  let calcheight = rendHeight;
  if (flipXY) {
    x1 = 'y1';
    y1 = 'x1';
    x2 = 'y2';
    y2 = 'x2';
    calcwidth = rendHeight;
    calcheight = rendWidth;
  }
  const halfWidth = width / 2;
  return extend$1({
    type: 'line'
  }, item[key], {
    [y1]: Math.floor(position * calcheight),
    [x1]: (boxCenter - halfWidth) * calcwidth,
    [y2]: Math.floor(position * calcheight),
    [x2]: (boxCenter + halfWidth) * calcwidth,
    r: halfWidth * calcwidth,
    cx: boxCenter * calcwidth,
    cy: position * calcheight,
    width: width * calcwidth,
    data: item.data || {},
    collider: {
      type: null
    }
  });
}

/**
 * A horizontal line shape (for median and whiskers)
 * @param {number} bandwidth The current bandwidth for this item
 * @param {object} item A resolved style item to render with major and box width variables, minWidthPx and maxWidthPx
 * @param {number} maxMajorWidth The actual maximum major width
 * @ignore
 */
function getBoxWidth(bandwidth, item, maxMajorWidth) {
  const {
    width,
    maxWidthPx,
    minWidthPx
  } = item.box;
  const sign = bandwidth >= 0 ? 1 : -1;
  let boxWidth = Math.min(sign * bandwidth * width, isNaN(maxWidthPx) ? maxMajorWidth : maxWidthPx / maxMajorWidth);
  boxWidth = isNaN(minWidthPx) ? boxWidth : Math.max(minWidthPx / maxMajorWidth, boxWidth);
  return boxWidth * sign;
}

function buildShapes(_ref) {
  let {
    width,
    height,
    flipXY,
    resolved,
    keys,
    symbol
  } = _ref;
  // if (!settings || !settings.major || !settings.major.scale || !settings.minor || !settings.minor.scale) {
  //   return [];
  // }

  const output = [];
  const majorItems = resolved.major.items;
  if (!majorItems.length) {
    return output;
  }
  const rendWidth = width;
  const rendHeight = height;
  const maxMajorWidth = flipXY ? height : width;
  const majorSettings = resolved.major.settings;
  const minorProps = ['start', 'end', 'min', 'max', 'med'].filter(prop => typeof resolved.minor.settings[prop] !== 'undefined');
  const numMinorProps = minorProps.length;
  const nonOobKeys = keys.filter(key => key !== 'oob');
  let children;
  let major;
  let minorItem;
  let boxWidth;
  let boxPadding;
  let boxCenter;
  let isLowerOutOfBounds;
  let isHigherOutOfBounds;
  let isOutOfBounds;
  const numKeys = keys ? keys.length : 0;
  const numNonOobKeys = nonOobKeys ? nonOobKeys.length : 0;
  function addBox() {
    /* THE BOX */
    if (minorItem.box && isNumber(minorItem.start) && isNumber(minorItem.end)) {
      children.push(box$1({
        item: minorItem,
        boxWidth,
        boxPadding,
        rendWidth,
        rendHeight,
        flipXY
      }));
    }
  }
  function addLine() {
    /* LINES MIN - START, END - MAX */
    if (isNumber(minorItem.min) && isNumber(minorItem.start)) {
      children.push(verticalLine({
        item: minorItem,
        from: minorItem.min,
        to: minorItem.start,
        boxCenter,
        rendWidth,
        rendHeight,
        flipXY
      }));
    }
    if (isNumber(minorItem.max) && isNumber(minorItem.end)) {
      children.push(verticalLine({
        item: minorItem,
        from: minorItem.max,
        to: minorItem.end,
        boxCenter,
        rendWidth,
        rendHeight,
        flipXY
      }));
    }
  }
  function addMedian() {
    /* MEDIAN */
    if (minorItem.median && isNumber(minorItem.med)) {
      children.push(horizontalLine({
        item: minorItem,
        key: 'median',
        position: minorItem.med,
        width: boxWidth,
        boxCenter,
        rendWidth,
        rendHeight,
        flipXY
      }));
    }
  }
  function addWhisker() {
    /* WHISKERS */
    if (minorItem.whisker) {
      const whiskerWidth = boxWidth * minorItem.whisker.width;
      if (isNumber(minorItem.min)) {
        children.push(horizontalLine({
          item: minorItem,
          key: 'whisker',
          position: minorItem.min,
          width: whiskerWidth,
          boxCenter,
          rendWidth,
          rendHeight,
          flipXY
        }));
      }
      if (isNumber(minorItem.max)) {
        children.push(horizontalLine({
          item: minorItem,
          key: 'whisker',
          position: minorItem.max,
          width: whiskerWidth,
          boxCenter,
          rendWidth,
          rendHeight,
          flipXY
        }));
      }
    }
  }
  function addOutOfBounds() {
    /* OUT OF BOUNDS */
    if (isLowerOutOfBounds) {
      children.push(oob({
        item: minorItem,
        value: 0,
        boxCenter,
        rendWidth,
        rendHeight,
        flipXY,
        symbol
      }));
    } else if (isHigherOutOfBounds) {
      children.push(oob({
        item: minorItem,
        value: 1,
        boxCenter,
        rendWidth,
        rendHeight,
        flipXY,
        symbol
      }));
    }
  }
  const addMarkerList = {
    box: addBox,
    line: addLine,
    median: addMedian,
    whisker: addWhisker
  };
  function checkOutOfBounds() {
    let value;
    let max = -Number.MAX_VALUE;
    let min = Number.MAX_VALUE;
    for (let n = 0; n < numMinorProps; n++) {
      value = minorItem[minorProps[n]];
      if (isNumber(value)) {
        if (max < value) {
          max = value;
        }
        if (min > value) {
          min = value;
        }
      }
    }
    isLowerOutOfBounds = max < 0 && max !== -Number.MAX_VALUE;
    isHigherOutOfBounds = min > 1 && min !== Number.MAX_VALUE;
    isOutOfBounds = isLowerOutOfBounds || isHigherOutOfBounds;
  }
  for (let i = 0, len = majorItems.length; i < len; i++) {
    children = [];
    major = null;
    const majorItem = majorItems[i];
    const d = majorItem.data;
    let majorVal = null;
    let majorEndVal = null;
    if (typeof majorSettings.binStart !== 'undefined') {
      // if start and end is defined
      majorVal = majorItem.binStart;
      majorEndVal = majorItem.binEnd;
      major = majorSettings.binStart.scale;
    } else {
      major = majorSettings.major.scale;
      majorVal = major ? majorItem.major : 0;
    }
    let bandwidth = 0;
    if (!major) {
      bandwidth = 1;
    } else if (major.bandwidth) {
      bandwidth = major.bandwidth();
      majorVal -= bandwidth / 2;
    } else {
      bandwidth = majorEndVal - majorVal;
    }
    minorItem = extend$1({}, {
      major: majorVal,
      majorEnd: majorEndVal
    }, resolved.minor.items[i]);
    for (let j = 0; j < numKeys; j++) {
      minorItem[keys[j]] = resolved[keys[j]].items[i];
    }
    boxWidth = getBoxWidth(bandwidth, minorItem, maxMajorWidth);
    boxPadding = (bandwidth - boxWidth) / 2;
    boxCenter = boxPadding + minorItem.major + boxWidth / 2;
    checkOutOfBounds();
    if (!isOutOfBounds) {
      for (let k = 0; k < numNonOobKeys; k++) {
        if (minorItem[nonOobKeys[k]] && minorItem[nonOobKeys[k]].show === false) {
          continue;
        }
        addMarkerList[nonOobKeys[k]]();
      }
    } else if (minorItem.oob) {
      addOutOfBounds();
    }
    const container = {
      type: 'container',
      data: d,
      collider: {
        type: 'bounds'
      },
      children
    };
    output.push(container);
  }
  return output;
}

/**
 * Resolve a complex object using the built-in resolver from this.resolver in component
 * @ignore
 */
function complexResolver(_ref) {
  let {
    keys,
    data,
    defaultSettings,
    style,
    settings,
    width,
    height,
    resolver
  } = _ref;
  const defaults = extend$1(true, {}, defaultSettings || {}, style || {});
  const scaled = {
    major: settings.orientation === 'horizontal' ? height : width,
    minor: settings.orientation === 'horizontal' ? width : height
  };
  const majorSettings = settings.major;
  let majorResolved;
  if (typeof majorSettings === 'object' && typeof majorSettings.ref === 'object' && typeof majorSettings.ref.start !== 'undefined' && typeof majorSettings.ref.end !== 'undefined') {
    // temporary backwards compatibility
    majorResolved = resolver.resolve({
      data,
      defaults: {
        start: 0,
        end: 1
      },
      scaled,
      settings: extend$1(true, {}, {
        binStart: {
          scale: settings.major.scale,
          ref: settings.major.ref.start
        },
        binEnd: {
          scale: settings.major.scale,
          ref: settings.major.ref.end
        }
      })
    });
  } else if (typeof majorSettings === 'object' && typeof majorSettings.binStart !== 'undefined' && typeof majorSettings.binEnd !== 'undefined') {
    majorResolved = resolver.resolve({
      data,
      defaults: {
        start: 0,
        end: 1
      },
      scaled,
      settings: extend$1(true, {}, {
        binStart: {
          scale: settings.major.scale,
          ref: 'binStart'
        },
        binEnd: {
          scale: settings.major.scale,
          ref: 'binEnd'
        }
      }, settings.major)
    });
  } else {
    majorResolved = resolver.resolve({
      data,
      scaled,
      defaults: {
        major: 0.5
      },
      settings: {
        major: settings.major
      }
    });
  }
  const minorSettings = settings.minor || {};
  const defaultMinorSettings = {};
  ['start', 'end', 'min', 'max', 'med'].forEach(prop => {
    if (minorSettings[prop] || data.items && data.items.length && data.items[0][prop]) {
      defaultMinorSettings[prop] = {
        scale: minorSettings.scale,
        ref: prop
      };
    }
  });
  const minorResolved = resolver.resolve({
    data,
    defaults: {
      start: 0,
      end: 1
    },
    scaled,
    settings: extend$1(true, {}, defaultMinorSettings, minorSettings)
  });
  let key;
  let ext = {
    major: majorResolved,
    minor: minorResolved
  };
  for (let ki = 0, len = keys.length; ki < len; ki++) {
    if (!settings[key] || settings[key].show !== false) {
      key = keys[ki];
      ext[key] = resolver.resolve({
        data,
        defaults: defaults[key],
        settings: settings[key],
        scaled
      });
    }
  }
  return ext;
}

const DEFAULT_DATA_SETTINGS$2 = {
  oob: {
    show: true,
    type: 'n-polygon',
    fill: '#999',
    stroke: '#000',
    strokeWidth: 0,
    size: 10,
    sides: 3,
    startAngle: -90
  },
  box: {
    show: true,
    fill: '#fff',
    stroke: '#000',
    strokeWidth: 1,
    strokeLinejoin: 'miter',
    width: 1,
    maxWidthPx: undefined,
    minWidthPx: 1,
    minHeightPx: 1
  },
  line: {
    show: true,
    stroke: '#000',
    strokeWidth: 1
  },
  median: {
    show: true,
    stroke: '#000',
    strokeWidth: 1
  },
  whisker: {
    show: true,
    stroke: '#000',
    strokeWidth: 1,
    fill: '',
    type: 'line',
    width: 1
  }
};
const dataKeys = Object.keys(DEFAULT_DATA_SETTINGS$2);
const component$3 = {
  require: ['chart', 'resolver', 'symbol'],
  defaultSettings: {
    settings: {},
    data: {},
    style: {
      box: '$shape',
      line: '$shape-guide',
      whisker: '$shape-guide',
      median: '$shape-guide--inverted'
    }
  },
  created() {
    this.state = {};
  },
  render(_ref) {
    let {
      data
    } = _ref;
    const {
      width,
      height
    } = this.rect;
    const flipXY = this.settings.settings.orientation === 'horizontal';
    const {
      style,
      resolver,
      symbol
    } = this;
    const keys = dataKeys.filter(key => !this.settings.settings[key] || this.settings.settings[key].show !== false);
    const defaultSettings = {};
    keys.forEach(key => defaultSettings[key] = DEFAULT_DATA_SETTINGS$2[key]);
    const resolved = complexResolver({
      keys,
      data,
      defaultSettings,
      style,
      settings: this.settings.settings,
      width,
      height,
      resolver
    });
    const {
      settings,
      items
    } = resolved;
    const shapes = buildShapes({
      items,
      settings,
      width,
      height,
      flipXY,
      resolved,
      keys,
      symbol
    });
    return shapes;
  }
};

function box(picasso) {
  picasso.component('box', component$3);
  picasso.component('box-marker', component$3); // temporary backwards compatibility - DEPRECATED
}

/**
 * @typedef {object} ComponentBox
 * @extends ComponentSettings
 * @property {'box'} type component type
 * @example
 * {
 *   type: "box",
 *   data: {
 *    mapTo: {
 *      min: { source: "/qHyperCube/qMeasureInfo/0" },
 *      start: { source: "/qHyperCube/qMeasureInfo/1" },
 *      med: { source: "/qHyperCube/qMeasureInfo/2" },
 *      end: { source: "/qHyperCube/qMeasureInfo/3" },
 *      max: { source: "/qHyperCube/qMeasureInfo/4" },
 *    },
 *    groupBy: {
 *      source: "/qHyperCube/qDimensionInfo/0"
 *    }
 *  },
 *  settings: {
 *    major: {
 *      scale: { source: "/qHyperCube/qDimensionInfo/0" }
 *    },
 *    minor: {
 *      scale: { source: ["/qHyperCube/qMeasureInfo/0",
 *               "/qHyperCube/qMeasureInfo/1",
 *               "/qHyperCube/qMeasureInfo/2",
 *               "/qHyperCube/qMeasureInfo/3",
 *               "/qHyperCube/qMeasureInfo/4"] }
 *    }
 *  }
 * }
 */

/**
 * @typedef {object} ComponentBox.settings
 * @property {object} major
 * @property {string} major.scale The scale to use along the major (dimension) axis
 * @property {string|ComponentBox~MajorReference} [major.ref='self'] Reference to the data property along the major axis
 * @property {object} minor
 * @property {string} minor.scale The scale to use along the minor (measure) axis
 * @property {string} [orientation='vertical'] Which orientation to use (vertical or horizontal)
 * @property {object} [box] Visual properties for the box shape in the box marker
 * @property {boolean} [box.show=true] Boolean for showing the box shape
 * @property {string} [box.fill='#fff']
 * @property {string} [box.stroke='#000']
 * @property {number} [box.strokeWidth=1]
 * @property {string} [box.strokeLinejoin='miter']
 * @property {number} [box.width=1]
 * @property {number} [box.maxWidthPx=100] Maximum width of the box in pixels (not applicable when using major start and end)
 * @property {number} [box.minWidthPx=1] Minimum width of the box in pixels (not applicable when using major start and end)
 * @property {number} [box.minHeightPx=1] Minimum height of the box shape
 * @property {object} [line] Visual properties for lines between min-start, end-max.
 * @property {boolean} [line.show=true]
 * @property {string} [line.stroke='#000']
 * @property {number} [line.strokeWidth=1]
 * @property {object} [whisker] All the visual properties for whiskers at min and max.
 * @property {boolean} [whisker.show=true]
 * @property {string} [whisker.stroke='#000']
 * @property {number} [whisker.strokeWidth=1]
 * @property {number} [whisker.width=1]
 * @property {object} [median] Visual properties for the median
 * @property {boolean} [median.show=true]
 * @property {string} [median.stroke='#000']
 * @property {number} [median.strokeWidth=1]
 * @property {object} [oob] EXPERIMENTAL: Out of bounds symbol utilizing the symbol API
 * @property {boolean} [oob.show=true]
 * @property {string} [oob.type='n-polygon'] Type of the symbol to be used
 * @property {string} [oob.fill='#999'] Fill color of the symbol
 * @property {string} [oob.stroke='#000'] Stroke color
 * @property {number} [oob.strokeWidth=0] Stroke width
 * @property {number} [oob.size=10] Size/width of the symbol in pixels
 * @property {number} [oob.sides=3] Number of sides for a n-polygon (3 for triangle)
 */

/**
 * @typedef {object} ComponentBox~MajorReference
 * @property {string} start Reference to the data property of the start value along the major axis
 * @property {string} end Reference to the data property of the end value along the major axis
 */

/**
 * @typedef {object} ComponentBox.data
 * @property {number} [min] Min
 * @property {number} [max] Max
 * @property {number} [start] Start of box
 * @property {number} [end] End of box
 * @property {number} [med] Median
 */

const DEFAULT_ERROR_SETTINGS = {
  errorShape: {
    shape: 'saltire',
    width: 2,
    size: 0.5,
    fill: '#333',
    stroke: '#333',
    strokeWidth: 0
  }
};
const PX_RX = /px$/;

/**
 * Component settings
 * @typedef {object=}
 * @alias ComponentPoint.settings
 */
const DEFAULT_DATA_SETTINGS$1 = {
  /** Type of shape
   * @type {DatumString=} */
  shape: 'circle',
  /** Label
   * @type {DatumString=} */
  label: '',
  /** Fill color
   * @type {DatumString=} */
  fill: '#333',
  /** Stroke color
   * @type {DatumString=} */
  stroke: '#ccc',
  /** Stroke dash array
   * @type {DatumString=} */
  strokeDasharray: '',
  /** Stroke width
   * @type {DatumNumber=} */
  strokeWidth: 0,
  /** Stroke line join
   * @type {DatumString=} */
  strokeLinejoin: 'miter',
  /** Opacity of shape
   * @type {DatumNumber=} */
  opacity: 1,
  /** Normalized x coordinate
   * @type {DatumNumber=} */
  x: 0.5,
  /** Normalized y coordinate
   * @type {DatumNumber=} */
  y: 0.5,
  /** Normalized size of shape
   * @type {DatumNumber=} */
  size: 1,
  /** Whether or not to show the point
   * @type {DatumBoolean=} */
  show: true
};

/**
 * @typedef {object=}
 * @alias ComponentPoint.settings.sizeLimits
 */
const SIZE_LIMITS = {
  /** Maximum size of shape, in pixels
   * @type {number=} */
  maxPx: 10000,
  /** Minimum size of shape, in pixels
   * @type {number=} */
  minPx: 1,
  /** Maximum size relative linear scale extent
   * @type {number=} */
  maxRelExtent: 0.1,
  /** Minimum size relative linear scale extent
   * @type {number=} */
  minRelExtent: 0.01,
  /** Maximum size relative discrete scale banwidth
   * @type {number=} */
  maxRelDiscrete: 1,
  /** Minimum size relative discrete scale banwidth
   * @type {number=} */
  minRelDiscrete: 0.1
};
function getPxSpaceFromScale(s, space) {
  if (s && typeof s.bandwidth === 'function') {
    // some kind of ordinal scale
    return {
      isBandwidth: true,
      value: Math.max(1, s.bandwidth() * space)
    };
  }
  return {
    isBandwidth: false,
    value: Math.max(1, space)
  };
}
function getPointSizeLimits(x, y, width, height, limits) {
  const xSpacePx = getPxSpaceFromScale(x ? x.scale : undefined, width);
  const ySpacePx = getPxSpaceFromScale(y ? y.scale : undefined, height);
  let maxSizePx = Math.min(xSpacePx.value * limits[xSpacePx.isBandwidth ? 'maxRelDiscrete' : 'maxRelExtent'], ySpacePx.value * limits[ySpacePx.isBandwidth ? 'maxRelDiscrete' : 'maxRelExtent']);
  let minSizePx = Math.min(xSpacePx.value * limits[xSpacePx.isBandwidth ? 'minRelDiscrete' : 'minRelExtent'], ySpacePx.value * limits[ySpacePx.isBandwidth ? 'minRelDiscrete' : 'minRelExtent']);
  const min = Math.max(1, Math.floor(minSizePx));
  const max = Math.max(1, Math.floor(maxSizePx));
  return {
    min,
    max,
    maxGlobal: limits.maxPx,
    minGlobal: limits.minPx
  };
}
function getType(s) {
  let type = DEFAULT_DATA_SETTINGS$1.shape;
  let props = {};
  if (typeof s.shape === 'object' && typeof s.shape.type === 'string') {
    type = s.shape.type;
    props = s.shape;
  } else if (typeof s.shape === 'string') {
    type = s.shape;
  }
  return [type, props];
}
function createDisplayPoints(dataPoints, _ref, pointSize, shapeFn) {
  let {
    width,
    height
  } = _ref;
  return dataPoints.filter(p => p.show !== false && !isNaN(p.x + p.y)).map(p => {
    let s = p;
    let size = PX_RX.test(p.size) ? parseInt(p.size, 10) : pointSize.min + s.size * (pointSize.max - pointSize.min);
    if (notNumber(size)) {
      s = DEFAULT_ERROR_SETTINGS.errorShape;
      size = pointSize.min + s.size * (pointSize.max - pointSize.min);
    }
    const [type, typeProps] = getType(s);
    const shapeSpec = _objectSpread2(_objectSpread2({}, typeProps), {}, {
      type,
      label: p.label,
      x: p.x * width,
      y: p.y * height,
      fill: s.fill,
      size: Math.min(pointSize.maxGlobal, Math.max(pointSize.minGlobal, size)),
      stroke: s.stroke,
      strokeWidth: s.strokeWidth,
      strokeDasharray: s.strokeDasharray,
      opacity: s.opacity
    });
    if (s === p.errorShape) {
      shapeSpec.width = s.width;
    }
    const shape = shapeFn(shapeSpec);
    shape.data = p.data;
    return shape;
  });
}
const component$2 = {
  require: ['chart', 'resolver', 'symbol'],
  defaultSettings: {
    settings: {},
    data: {},
    animations: {
      enabled: false,
      trackBy: node => node.data.value
    },
    style: {
      item: '$shape'
    }
  },
  render(_ref2) {
    let {
      data
    } = _ref2;
    const resolved = this.resolver.resolve({
      data,
      defaults: extend$1({}, DEFAULT_DATA_SETTINGS$1, this.style.item),
      settings: this.settings.settings,
      scaled: {
        x: this.rect.width,
        y: this.rect.height
      }
    });
    const {
      width,
      height
    } = this.rect;
    const limits = extend$1({}, SIZE_LIMITS, this.settings.settings.sizeLimits);
    const points = resolved.items;
    const pointSize = getPointSizeLimits(resolved.settings.x, resolved.settings.y, width, height, limits);
    return createDisplayPoints(points, this.rect, pointSize, this.settings.shapeFn || this.symbol);
  }
};

/**
 * @typedef {object} ComponentPoint
 * @property {'point'} type component type
 * @extends ComponentSettings
 * @example
{
  type: 'point',
  data: {
    extract: {
      field: 'Month',
      props: {
        x: { field: 'Margin' },
        y: { field: 'Year' }
      }
    }
  },
  settings: {
    x: { scale: 'm' },
    y: { scale: 'y' },
  }
}
 */

const type$3 = 'point';
function pointMarker(picasso) {
  picasso.component(type$3, component$2);
  picasso.component('point-marker', component$2); // temporary backwards compatibility - DEPRECATED
}

/**
 * Component settings
 * @typedef {object}
 * @alias ComponentPie.settings
 */
const DEFAULT_DATA_SETTINGS = {
  /** Start angle of the pie, in radians
   * @type {number=} */
  startAngle: 0,
  /** End angle of the pie, in radians
   * @type {number=} */
  endAngle: 2 * Math.PI,
  /**
   * @typedef {object}
   */
  slice: {
    label: '',
    /** Absolute value of the slice's arc length
     * @type {number=} */
    arc: 1,
    /** Visibility of the slice
     * @type {boolean=} */
    show: true,
    /** Fill color of the slice
     * @type {string=} */
    fill: '#333',
    /** Stroke color of the slice
     * @type {string=} */
    stroke: '#ccc',
    /** Stroke width of the slice
     * @type {number=} */
    strokeWidth: 1,
    /** Stroke line join
     * @type {string=} */
    strokeLinejoin: 'round',
    /** Opacity of the slice
     * @type {number=} */
    opacity: 1,
    /** Inner radius of the slice
     * @type {number=} */
    innerRadius: 0,
    /** Outer radius of the slice
     * @type {number=} */
    outerRadius: 0.8,
    /** Corner radius of the slice, in pixels
     * @type {number=} */
    cornerRadius: 0,
    /** Radial offset of the slice
     * @type {number=} */
    offset: 0
  }
};

/**
 * @typedef {object} ComponentPie
 * @extends ComponentSettings
 * @property {'pie'} type component type
 * @example
 * {
 *   type: 'pie',
 *   data: {
 *     extract: {
 *       field: 'Region',
 *       props: {
 *         num: { field: 'Population' }
 *       }
 *     }
 *   },
 *   settings: {
 *     startAngle: Math.PI / 2,
 *     endAngle: -Math.PI / 2,
 *     slice: {
 *       arc: { ref: 'num' },
 *       fill: 'green',
 *       stroke: 'red',
 *       strokeWidth: 2,
 *       strokeLinejoin: 'round',
 *       innerRadius: 0.6,
 *       outerRadius 0.8,
 *       opacity: 0.8,
 *       offset: 0.2
 *     }
 *   }
 * }
 */

function offsetSlice(centroid, offset, outerRadius, innerRadius) {
  let [vx, vy] = centroid;
  const vlen = Math.sqrt(vx * vx + vy * vy);
  vx /= vlen;
  vy /= vlen;
  const diff = outerRadius - innerRadius;
  return {
    x: vx * offset * diff,
    y: vy * offset * diff
  };
}
function createDisplayPies(arcData, _ref, slices, sum) {
  let {
    x,
    y,
    width,
    height
  } = _ref;
  const arcGen = arc();
  const center = {
    x: x + width / 2,
    y: y + height / 2
  };
  const innerRadius = Math.min(width, height) / 2;
  const outerRadius = Math.min(width, height) / 2;
  const cornerRadius = outerRadius / 100;
  return arcData.map((a, i) => {
    const slice = slices[i];
    slice.type = 'path';
    const or = outerRadius * slice.outerRadius;
    const ir = innerRadius * slice.innerRadius;
    const cr = cornerRadius * slice.cornerRadius;
    arcGen.innerRadius(ir);
    arcGen.outerRadius(or);
    arcGen.cornerRadius(cr);
    slice.arcDatum = a;
    const centroid = arcGen.centroid(a);
    const offset = slice.offset ? offsetSlice(centroid, slice.offset, or, ir) : {
      x: 0,
      y: 0
    };
    slice.transform = "translate(".concat(offset.x, ", ").concat(offset.y, ") translate(").concat(center.x, ", ").concat(center.y, ")");
    slice.desc = {
      share: a.value / sum,
      slice: {
        start: a.startAngle,
        end: a.endAngle,
        innerRadius: ir,
        outerRadius: or,
        cornerRadius: cr,
        offset: {
          x: center.x + offset.x,
          y: center.y + offset.y
        }
      }
    };
    return slice;
  });
}
function arcValue(stngs, item) {
  if (stngs.slice && 'arc' in stngs.slice) {
    return item.arc;
  }
  return item.data.value;
}
const pieComponent = {
  require: ['chart', 'resolver'],
  defaultSettings: {
    settings: {
      startAngle: 0,
      endAngle: 2 * Math.PI,
      padAngle: 0,
      slice: {}
    },
    style: {
      slice: '$shape'
    },
    data: {}
  },
  render(_ref2) {
    let {
      data
    } = _ref2;
    const arcValues = [];
    const slices = [];
    const stngs = this.settings.settings;
    const {
      items
    } = this.resolver.resolve({
      data,
      defaults: extend$1({}, DEFAULT_DATA_SETTINGS.slice, this.style.slice),
      settings: stngs.slice
    });
    let sum = 0;
    for (let i = 0, len = items.length; i < len; i++) {
      const val = arcValue(stngs, items[i]);
      if (val > 0 && items[i].outerRadius >= items[i].innerRadius) {
        arcValues.push(val);
        slices.push(items[i]);
        sum += val;
      }
    }
    const pieGen = pie$1().sortValues(null);
    pieGen.startAngle(stngs.startAngle);
    pieGen.endAngle(stngs.endAngle);
    pieGen.padAngle(stngs.padAngle);
    const arcData = pieGen(arcValues);
    return createDisplayPies(arcData, extend$1({}, this.rect, {
      x: 0,
      y: 0
    }), slices, sum);
  }
};

function pie(picasso) {
  picasso.component('pie', pieComponent);
}

/**
 * Create a crispifier
 * @ignore
 *
 * @param  {Object} [crispMap] Optional crispmap if you need custom crisping.
 * @return {Function}          crispItem function
 *
 * @example
 * import { crispifierFactory } from "core/crispifier";
 *
 * let crispify = crispifierFactory(customCrispMap);
 *
 * // For a single item
 * crispify(myItem);
 *
 * // For multiple items
 * crispify.multiple(myArrayOfItems);
 */
function crispifierFactory(crispMap) {
  // Define the crispMap
  if (crispMap === undefined) {
    crispMap = {};
    crispMap.line = {
      append: ['x1', 'x2', 'y1', 'y2'],
      round: [],
      condition: item => item.x1 === item.x2 || item.y1 === item.y2,
      conditionAppend: item => item.strokeWidth % 2 !== 0
    };
    crispMap.rect = {
      append: ['x', 'y'],
      round: ['width', 'height'],
      condition: () => true,
      conditionAppend: item => item.strokeWidth % 2 !== 0
    };
  }

  // Re-map the crispmap
  Object.keys(crispMap).forEach(type => {
    const self = crispMap[type];
    self.items = [];
    self.append.forEach(toAppend => {
      self.items.push({
        key: toAppend,
        type: 'append'
      });
    });
    self.round.forEach(toAppend => {
      self.items.push({
        key: toAppend,
        type: 'round'
      });
    });
  });

  /**
   * Crispify a single item
   * @ignore
   * @param  {Object} item  Item with renderer variables such as X, Y, and type.
   * @return {Undefined}    Returns nothing, modifies the original item instead
   */
  function crispItem(item) {
    if (crispMap[item.type] && crispMap[item.type].condition(item)) {
      const self = crispMap[item.type];
      const doAppend = self.conditionAppend === undefined || self.conditionAppend(item);
      self.items.forEach(i => {
        const rounded = Math.round(item[i.key]);
        const diff = item[i.key] - rounded;
        item[i.key] = rounded;
        if (doAppend && i.type === 'append') {
          if (diff > 0) {
            item[i.key] += 0.5;
          } else {
            item[i.key] -= 0.5;
          }
        }
      });
    }
  }

  /**
   * Crispify multiple items
   * @ignore
   *
   * @param  {Array} items  Array of objects to crispify
   * @return {Undefined}    Returns nothing, modifies the original item instead
   */
  crispItem.multiple = items => items.forEach(item => crispItem(item));
  return crispItem;
}
const crispifier = crispifierFactory();

class Transposer {
  /**
   * @private
   */
  constructor() {
    this.reset();
    this.push(...arguments);
  }

  /**
   * Evaluate a key for a transposed coordinate
   *
   * @param  {String} key   Key
   * @return {String}         Actual key
   */
  static evaluateKey(key, flipXY) {
    if (flipXY) {
      const firstChar = key.substring(0, 1);
      const rest = key.substring(1);
      if (firstChar === 'x') {
        return "y".concat(rest);
      }
      if (firstChar === 'y') {
        return "x".concat(rest);
      }
      if (key === 'cx') {
        return 'cy';
      }
      if (key === 'cy') {
        return 'cx';
      }
      if (key === 'width') {
        return 'height';
      }
      if (key === 'height') {
        return 'width';
      }
    }
    return key;
  }

  /**
   * Transpose a coordinate according to this.flipXY and
   * the available rendering area
   *
   * @param  {String} key        The key of the coordinate to transpose
   * @param  {Number} coordinate The coordinate
   * @return {Number}            The actual location of the coordinate
   */
  transposeCoordinate(key, coordinate, flipXY) {
    if (typeof coordinate === 'number' && isFinite(coordinate)) {
      const firstChar = key.substring(0, 1);
      if (firstChar === 'x' || key === 'cx') {
        return coordinate * this.width;
      }
      if (key === 'width') {
        return coordinate * this.width;
      }
      if (key === 'r') {
        return coordinate * (!flipXY ? this.width : this.height);
      }
      if (firstChar === 'y' || key === 'cy') {
        return coordinate * this.height;
      }
      if (key === 'height') {
        return coordinate * this.height;
      }
    }
    return coordinate;
  }

  /**
   * Push an item into the storage of the transposer
   *
   * @param  {Object} items An item to be drawed
   * @return {Object}       Can be chained
   */
  push() {
    this.storage.push(...arguments);
    return this;
  }
  processItem(item) {
    let newItem = {};
    const flipXY = typeof item.flipXY !== 'undefined' ? item.flipXY : this.flipXY;
    const crisp = typeof item.crisp !== 'undefined' ? item.crisp : this.crisp;
    if (item.fn && typeof item.fn === 'function') {
      let width = flipXY ? this.height : this.width;
      let height = flipXY ? this.width : this.height;
      item = item.fn({
        width,
        height,
        flipXY
      });
      const objectKeys = Object.keys(item);
      for (let ki = 0, kl = objectKeys.length; ki < kl; ki++) {
        let key = objectKeys[ki];
        const nkey = Transposer.evaluateKey(key, flipXY);
        newItem[nkey] = item[key];
      }
    } else {
      const objectKeys = Object.keys(item);
      for (let ki = 0, kl = objectKeys.length; ki < kl; ki++) {
        let key = objectKeys[ki];
        const nkey = Transposer.evaluateKey(key, flipXY);
        const nval = this.transposeCoordinate(nkey, item[key], flipXY);
        newItem[nkey] = nval;
      }
    }
    if (crisp) {
      crispifier(newItem);
    }
    return newItem;
  }

  /**
   * Get the output of the transposer
   *
   * @return {Array}   Array of objects
   */
  output() {
    let items = [];
    for (let i = 0, l = this.storage.length; i < l; i++) {
      let newItem = this.processItem(this.storage[i]);
      items.push(newItem);
    }
    return items;
  }

  /**
   * Reset the transposer
   *
   * @return {Undefined}  Does not return anything
   */
  reset() {
    this.storage = [];
    this.flipXY = false;
    this.crisp = false;
    this.width = 0;
    this.height = 0;
  }
}
function transposer() {
  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }
  return new Transposer(...items);
}

/**
 * Generate array of lines (ticks) from scale
 *
 * @param {object} scale - A scale supplied by the chart
 * @param {object} settings - The settings object from the grid line component
 * @param {object} rect - The rect containing width and height to renderer in
 * @returns {array} - Returns an array of ticks
 * @ignore
 */
function lineGen(scale, distance) {
  if (!scale || !distance) {
    return [];
  }
  return scale.cachedTicks && scale.cachedTicks() || scale.ticks({
    distance
  });
}
const gridLineComponent = {
  created() {},
  require: ['chart', 'renderer', 'resolver'],
  defaultSettings: {
    layout: {
      displayOrder: 0
    },
    style: {
      // Theming style
      ticks: '$guide-line',
      minorTicks: '$guide-line--minor'
    }
  },
  beforeRender() {
    this.blueprint = transposer();
    this.blueprint.width = this.rect.width;
    this.blueprint.height = this.rect.height;
    this.blueprint.x = this.rect.x;
    this.blueprint.y = this.rect.y;
    this.blueprint.crisp = true;
  },
  render() {
    // Setup scales
    this.x = this.settings.x ? this.chart.scale(this.settings.x) : null;
    this.y = this.settings.y ? this.chart.scale(this.settings.y) : null;
    updateScaleSize(this, 'x', this.rect.width);
    updateScaleSize(this, 'y', this.rect.height);

    // Return an empty array to abort rendering when no scales are available to renderer
    if (!this.x && !this.y) {
      return [];
    }
    this.settings.ticks = extend$1({
      show: true
    }, this.style.ticks, this.settings.ticks || {});
    this.settings.minorTicks = extend$1({
      show: false
    }, this.style.minorTicks, this.settings.minorTicks || {});

    // Setup lines for X and Y
    this.lines = {
      x: [],
      y: []
    };

    // Use the lineGen function to generate appropriate ticks
    this.lines.x = lineGen(this.x, this.rect.width);
    this.lines.y = lineGen(this.y, this.rect.height);

    // Set all Y lines to flipXY by default
    // This makes the transposer flip them individually
    this.lines.y = this.lines.y.map(i => extend$1(i, {
      flipXY: true
    }));
    let addTicks = _ref => {
      let {
        dir,
        isMinor
      } = _ref;
      let items = this.lines[dir].filter(tick => !!tick.isMinor === isMinor);
      let settings = isMinor ? this.settings.minorTicks : this.settings.ticks;
      let ticks = this.resolver.resolve({
        settings,
        data: {
          items,
          dir
        }
      }).items;
      ticks.forEach(style => {
        let p = style.data;

        // If the style's show is falsy, don't renderer this item (to respect axis settings).
        if (style.show) {
          var _p$value, _p$data;
          // Use the transposer to handle actual positioning
          this.blueprint.push({
            type: 'line',
            x1: p.position,
            y1: 0,
            x2: p.position,
            y2: 1,
            stroke: style.stroke || 'black',
            strokeWidth: typeof style.strokeWidth !== 'undefined' ? style.strokeWidth : 1,
            strokeDasharray: typeof style.strokeDasharray !== 'undefined' ? style.strokeDasharray : undefined,
            flipXY: p.flipXY || false,
            // This flips individual points (Y-lines)
            value: (_p$value = p.value) !== null && _p$value !== void 0 ? _p$value : (_p$data = p.data) === null || _p$data === void 0 ? void 0 : _p$data.value,
            dir
          });
        }
      });
    };
    addTicks({
      dir: 'x',
      isMinor: false
    });
    addTicks({
      dir: 'x',
      isMinor: true
    });
    addTicks({
      dir: 'y',
      isMinor: false
    });
    addTicks({
      dir: 'y',
      isMinor: true
    });
    return this.blueprint.output();
  }
};

/**
 * @typedef {object} ComponentGridLine
 * @extends ComponentSettings
 * @property {'grid-line'} type component type
 * @example
 * {
 *  type: 'grid-line',
 *  settings: {
 *    x: {
 *      scale: '<name-of-scale>',
 *    },
 *    y: {
 *      scale: '<name-of-scale>',
 *    },
 *  },
 * }
 */

/**
 * Component settings
 * @typedef {object} ComponentGridLine.settings
 * @property {object} x
 * @property {string} x.scale - The scale to use along x
 * @property {object} y
 * @property {string} y.scale - The scale to use along y
 * @property {object} [ticks]
 * @property {boolean} [ticks.show=true]
 * @property {string} [ticks.stroke='black']
 * @property {number} [ticks.strokeWidth='1']
 * @property {string} [ticks.strokeDasharray]
 * @property {object} [minorTicks]
 * @property {boolean} [minorTicks.show=true]
 * @property {string} [minorTicks.stroke='black']
 * @property {number} [minorTicks.strokeWidth='1']
 * @property {string} [minorTicks.strokeDasharray]
 */

function gridLine(picasso) {
  picasso.component('grid-line', gridLineComponent);
}

/**
 * Return a D property for a SVG path to get a direction marker
 *
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} r - Radius
 * @param {string} [d='bottom'] - Direction
 * @returns {string} - Finished D property
 * @ignore
 */
function directionMarker(x, y, r) {
  let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'bottom';
  r *= 0.8;
  if (d === 'left' || d === 'right') {
    let right = d === 'right';
    return "\n      M ".concat(x, " ").concat(y - r, "\n      A ").concat(r * 1.25, " ").concat(r * 1.25, ", 0, 1, ").concat(right ? 0 : 1, ", ").concat(x, " ").concat(y + r, "\n      L ").concat(right ? x + r : x - r, " ").concat(y, " Z\n    ");
  }
  let bottom = d === 'bottom';
  return "\n    M ".concat(x - r, " ").concat(y, "\n    A ").concat(r * 1.25, " ").concat(r * 1.25, ", 0, 1, ").concat(bottom ? 1 : 0, ", ").concat(x + r, " ").concat(y, "\n    L ").concat(x, " ").concat(bottom ? y + r : y - r, " Z\n  ");
}
function directionTriangle(x, y, r) {
  let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'bottom';
  r *= 0.75;
  if (d === 'left' || d === 'right') {
    let right = d === 'right';
    x += right ? r * 1.5 : -(r * 1.5);
    return "\n      M ".concat(x, " ").concat(y - r, "\n      L ").concat(x, " ").concat(y + r, "\n      L ").concat(right ? x + r : x - r, " ").concat(y, " Z\n    ");
  }
  let bottom = d === 'bottom';
  y += bottom ? r * 1.5 : -(r * 1.5);
  return "\n    M ".concat(x - r, " ").concat(y, "\n    L ").concat(x + r, " ").concat(y, "\n    L ").concat(x, " ").concat(bottom ? y + r : y - r, " Z\n  ");
}

/**
 * Handle out of bound shapes
 * Does not return anything, modifies "items" property instead (should be re-considered)
 *
 * @param {object} oob - Out of bounds object from parent
 * @param {object} settings - Settings object from parent
 * @param {object[]} items - Array of all items (for collision detection)
 * @ignore
 */
function oobManager(_ref) {
  let {
    blueprint,
    oob,
    settings,
    items
  } = _ref;
  const oobKeys = Object.keys(oob);
  let style = settings.style.oob || {};
  for (let i = 0, len = oobKeys.length; i < len; i++) {
    const key = oobKeys[i];
    const value = oob[key];
    if (value.length > 0) {
      let position = key.charAt(1);
      let flipXY = key.charAt(0) === 'y';
      let xPadding = style.padding.x + style.width;
      let yPadding = style.padding.y + style.width;
      let direction = 'bottom';
      if (flipXY) {
        direction = position === '1' ? 'bottom' : 'top';
      } else {
        direction = position === '1' ? 'right' : 'left';
      }
      let indicator = blueprint.processItem({
        fn: _ref2 => {
          let {
            width,
            height
          } = _ref2;
          /* eslint no-loop-func: 0 */
          let x = position * width + (position === '1' ? -xPadding : xPadding);
          let y = flipXY ? yPadding : height - yPadding;
          if (style.type === 'arc') {
            return {
              type: 'path',
              d: directionMarker(flipXY ? y : x, flipXY ? x : y, style.width, direction),
              x,
              y,
              stroke: style.stroke,
              fill: style.fill,
              strokeWidth: style.strokeWidth || 0
            };
          }
          return {
            type: 'circle',
            cx: x,
            cy: y,
            r: style.width,
            stroke: style.stroke,
            fill: style.fill,
            strokeWidth: style.strokeWidth || 0,
            opacity: style.opacity,
            data: value
          };
        },
        flipXY
      });
      let x = indicator.cx || indicator.x;
      let y = indicator.cy || indicator.y;
      const tooltips = value.map(v => v.label ? "".concat(v.label, " (").concat(v.value, ")") : "(".concat(v.value, ")"));
      const title = tooltips.reduce((text, current, index) => index === 0 ? current : "".concat(text, "\n\n").concat(current), '');
      let text = {
        type: 'text',
        text: value.length || '',
        title,
        x: x - style.width * 0.4,
        y: y + style.width * 0.4,
        fontFamily: style.text.fontFamily,
        fontSize: "".concat(style.width * 1.3, "px"),
        stroke: style.text.stroke,
        fill: style.text.fill,
        strokeWidth: style.text.strokeWidth || 0,
        opacity: style.text.opacity
      };
      let triangle = {
        type: 'path',
        d: directionTriangle(x, y, style.width, direction),
        x,
        y,
        stroke: style.triangle.stroke,
        fill: style.triangle.fill,
        strokeWidth: style.triangle.strokeWidth || 0,
        opacity: style.triangle.opacity
      };
      items.push(indicator, text, triangle);
    }
  }
}
function isOob(value, min, max) {
  return value < min || value > max;
}

const DOCK_CORNER = 0.8;
function refLabelDefaultSettings() {
  return {
    fill: '#000',
    fontFamily: 'Arial',
    fontSize: '12px',
    opacity: 1,
    maxWidth: 1,
    maxWidthPx: 9999,
    padding: 5,
    background: {
      fill: '#fff',
      stroke: 'transparent',
      strokeWidth: 0,
      opacity: 0.5
    }
  };
}
function isMaxY(chart, slope, value) {
  // when maxY exceeds the shown scale
  const scaleX = chart.scale({
    scale: 'x'
  });
  const scaleY = chart.scale({
    scale: 'y'
  });
  if (slope > 0) {
    const maxY = scaleX.max() * slope + value;
    if (maxY >= scaleY.max()) {
      return true;
    }
  } else if (slope < 0) {
    const minY = scaleX.min() * slope + value;
    if (minY >= scaleY.max()) {
      return true;
    }
  }
  return false;
}
function getMaxXPosition(chart, slope, value) {
  // if maxY then get maxX position available on the scale
  const scaleX = chart.scale({
    scale: 'x'
  });
  const scaleY = chart.scale({
    scale: 'y'
  });
  // For negative slopes
  if (slope < 0) {
    return scaleX((scaleY.max() - value) / slope);
  }
  // For positive slopes
  return scaleX((scaleY.max() - value) / slope);
}
function getFormatter(p, chart) {
  if (typeof p.formatter === 'string') {
    return chart.formatter(p.formatter);
  }
  if (typeof p.formatter === 'object') {
    return chart.formatter(p.formatter);
  }
  if (typeof p.scale !== 'undefined' && p.scale.data) {
    // TODO - Add support for array as source into formatter
    const scaleData = p.scale.data() && p.scale.data().fields;
    return scaleData && scaleData[0] ? scaleData[0].formatter() : null;
  }
  return null;
}
function isColliding(items, slopeValue, measured, xPadding, yPadding) {
  for (let i = 0, len = items.length; i < len; i++) {
    const curItem = items[i];
    if ((curItem === null || curItem === void 0 ? void 0 : curItem.type) === 'text') {
      if (Math.abs(curItem.x - slopeValue.x) < Math.max(curItem.width + xPadding, slopeValue.width + xPadding) && Math.abs(curItem.y - slopeValue.y) < measured.height + yPadding) {
        return true;
      }
    }
  }
  return false;
}
function calculateX(slopeLine, line, maxX, measured, blueprint, slopeStyle) {
  let neededPadding = 0;
  // calculate x for the various scenarios possible
  if (maxX !== undefined) {
    // docking at top
    if (maxX < DOCK_CORNER) {
      neededPadding = slopeLine.slope < 0 || slopeLine.isRtl ? slopeStyle.padding * 3 : slopeStyle.padding * 2;
      return slopeLine.isRtl ? maxX * blueprint.width + neededPadding : maxX * blueprint.width + neededPadding;
    }
    if (maxX === 1) {
      // dock at the corner of the data area top and right
      return slopeLine.isRtl ? maxX * blueprint.width - (measured.width + slopeStyle.padding * 3) : maxX * blueprint.width - (measured.width + slopeStyle.padding * 6);
    }
    if (maxX > DOCK_CORNER) {
      // very close to the corner when width doesn't fit
      return slopeLine.isRtl ? maxX * blueprint.width - (measured.width + slopeStyle.padding * 3) : maxX * blueprint.width - (measured.width + slopeStyle.padding * 6);
    }
  } else if (slopeLine.slope > 0) {
    // dock at right
    return line.x2 - (measured.width + slopeStyle.padding * 2);
  }
  //  Negative slope dock on left
  return slopeLine.isRtl ? line.x1 - (measured.width + slopeStyle.padding * 2) : line.x1;
}

/**
 * Converts a numerical OR string value to a normalized value
 *
 * @param {string|number} align -Description how to align (Numerical from 0-1 or 'top', 'left', 'center', 'middle', 'bottom' or 'right')
 * @returns {number} - Normalized value 0...1
 * @ignore
 */
function alignmentToNumber(align) {
  if (typeof align === 'undefined') {
    return 0;
  }
  if (typeof align === 'number' && isFinite(align)) {
    return align;
  }
  if (typeof align === 'string') {
    switch (align) {
      case 'center':
      case 'middle':
        return 0.5;
      case 'bottom':
      case 'right':
        return 1;
      case 'top':
      case 'left':
      default:
        return 0;
    }
  }
  return 0;
}

/**
 * Create line and label (if applicable)
 * Does not return anything, modifies "items" property instead (should be re-considered)
 *
 * @param {object} p - Current point
 * @param {object} style - Applicable line styling
 * @param {object} settings - Settings object derived from parent
 * @param {object[]} items - Array of all items (for collision detection)
 * @ignore
 */
function createLineWithLabel(_ref) {
  var _slopeLine$label, _slopeLine$label2;
  let {
    chart,
    blueprint,
    renderer,
    p,
    settings,
    items,
    slopeLine
  } = _ref;
  let doesNotCollide = true;
  let line = false;
  let rect = false;
  let label = false;
  let value = false;
  let style = extend$1(true, {}, settings.style.line, p.line || {});
  let slopeStyle = extend$1(true, refLabelDefaultSettings(), settings.style.label || {}, {
    fill: style.stroke
  });

  // Use the transposer to handle actual positioning
  if (slopeLine) {
    line = blueprint.processItem({
      type: 'line',
      x1: slopeLine.x1,
      y1: slopeLine.y1,
      x2: slopeLine.x2,
      y2: slopeLine.y2,
      stroke: style.stroke || 'black',
      strokeWidth: style.strokeWidth || 1,
      strokeDasharray: style.strokeDasharray,
      flipXY: false,
      value: p.valueInfo ? p.valueInfo.id : p.value
    });
  } else {
    line = blueprint.processItem({
      type: 'line',
      x1: p.position,
      y1: 0,
      x2: p.position,
      y2: 1,
      stroke: style.stroke || 'black',
      strokeWidth: style.strokeWidth || 1,
      strokeDasharray: style.strokeDasharray,
      flipXY: p.flipXY || false,
      // This flips individual points (Y-lines)
      value: p.valueInfo ? p.valueInfo.id : p.value
    });
  }
  if (p.label && p.label.show !== false && !(slopeLine !== null && slopeLine !== void 0 && slopeLine.slope && slopeLine.slope !== 0)) {
    const item = extend$1(true, refLabelDefaultSettings(), settings.style.label || {}, {
      fill: style.stroke
    }, p.label);
    let formatter;
    let measuredValue = {
      width: 0,
      height: 0
    };
    let valueString = '';
    formatter = getFormatter(p, chart);
    if (p.label.showValue !== false) {
      if (formatter) {
        valueString = " (".concat(formatter(p.value), ")");
      } else if (p.scale) {
        valueString = " (".concat(p.value, ")");
      }
    }
    if (valueString) {
      measuredValue = renderer.measureText({
        text: valueString,
        fontFamily: item.fontFamily,
        fontSize: item.fontSize
      });
    }

    // Measure the label text
    let measuredLabel = renderer.measureText({
      text: item.text || '',
      fontFamily: item.fontFamily,
      fontSize: item.fontSize
    });
    let measured = {
      width: measuredLabel.width + measuredValue.width,
      height: Math.max(measuredLabel.height, measuredValue.height)
    };
    let labelPadding = item.padding;

    // let anchor = item.anchor === 'end' ? 'end' : 'start';

    let align = alignmentToNumber(p.flipXY ? item.vAlign : item.align);
    let vAlign = alignmentToNumber(p.flipXY ? item.align : item.vAlign);
    let calcWidth = Math.min(1 + measured.width + labelPadding * 2, item.maxWidth * blueprint.width, item.maxWidthPx);
    let calcHeight = measured.height + labelPadding * 2;
    let rectWidth = p.flipXY ? calcHeight : calcWidth;
    let rectHeight = p.flipXY ? calcWidth : calcHeight;
    rect = blueprint.processItem({
      fn: _ref2 => {
        let {
          width,
          height
        } = _ref2;
        let x = p.position * width - (p.flipXY ? calcHeight : calcWidth) * (1 - align);
        x = p.flipXY ? x : Math.max(x, 0);
        const y = Math.max(Math.abs(vAlign * height - rectHeight * vAlign), 0);
        return {
          type: 'rect',
          x,
          y,
          width: p.flipXY ? rectWidth : Math.min(rectWidth, blueprint.width - x),
          height: rectHeight,
          stroke: item.background.stroke,
          strokeWidth: item.background.strokeWidth,
          fill: item.background.fill,
          opacity: item.background.opacity
        };
      },
      flipXY: p.flipXY || false // This flips individual points (Y-lines)
    });
    if (rect.x < -1 || rect.x + rect.width > blueprint.width + 1 || rect.y < -1 || rect.y + rect.height > blueprint.height + 1) {
      // do not create labels if out of bounds
      rect = undefined;
    } else {
      // Labels are just basic objects attached to a corner of a rect,
      // and this rect needs to already be processed
      // so there is no blueprint.processItem required here
      label = {
        type: 'text',
        text: item.text || '',
        fill: item.fill,
        opacity: item.opacity,
        fontFamily: item.fontFamily,
        fontSize: item.fontSize,
        x: rect.x + labelPadding,
        y: rect.y + rect.height / 2 + measured.height / 3,
        maxWidth: rect.width - labelPadding * 2 - measuredValue.width,
        anchor: 'start'
      };
      if (valueString) {
        value = {
          type: 'text',
          text: valueString || '',
          fill: item.fill,
          opacity: item.opacity,
          fontFamily: item.fontFamily,
          fontSize: item.fontSize,
          x: label.x + 3 + (rect.width - (measuredValue.width + labelPadding * 2)),
          y: label.y
        };
      }

      // Detect collisions with other labels/rects or lines
      for (let i = 0, len = items.length; i < len; i++) {
        let curItem = items[i];
        if (curItem.type === 'rect') {
          // We only detect rects here, since rects are always behind labels,
          // and we wouldn't want to measure text one more time
          if (testRectRect(rect, curItem)) {
            doesNotCollide = false;
          }
        } else if (curItem.type === 'line') {
          // This will only collide when flipXY are the same for both objects,
          // So it only collides on objects on the same "axis"
          if (p.flipXY === curItem.flipXY && testRectLine(rect, curItem)) {
            doesNotCollide = false;
          }
        }
      }
    }
  }

  // Always push the line,
  // but this is done after collision detection,
  // because otherwise it would collide with it's own line
  // check for slopeline if the points are almost on the blueprints edge
  if (line) {
    items.push(line);
  }
  if (slopeLine && slopeLine.slope !== 0 && (((_slopeLine$label = slopeLine.label) === null || _slopeLine$label === void 0 ? void 0 : _slopeLine$label.show) !== false || ((_slopeLine$label2 = slopeLine.label) === null || _slopeLine$label2 === void 0 ? void 0 : _slopeLine$label2.showValue) !== false)) {
    var _slopeLine$label3, _slopeLine$label4, _slopeLine$label5;
    // create data area labels for slope line
    let valueString;
    let labelBackground;
    const maxLabelWidth = 120;
    let slopeLabelText = ((_slopeLine$label3 = slopeLine.label) === null || _slopeLine$label3 === void 0 ? void 0 : _slopeLine$label3.show) !== false ? (_slopeLine$label4 = slopeLine.label) === null || _slopeLine$label4 === void 0 ? void 0 : _slopeLine$label4.text : '';
    if (((_slopeLine$label5 = slopeLine.label) === null || _slopeLine$label5 === void 0 ? void 0 : _slopeLine$label5.showValue) !== false) {
      var _slopeLine$label6;
      const formatter = getFormatter(p, chart);
      const formattedValue = formatter ? formatter(slopeLine.value) : slopeLine.value;
      valueString = "(".concat(slopeLine.slope, "x + ").concat(formattedValue, ")");
      slopeLabelText += (_slopeLine$label6 = slopeLine.label) !== null && _slopeLine$label6 !== void 0 && _slopeLine$label6.text ? " ".concat(valueString) : valueString;
    }
    if (slopeLabelText.length > 1) {
      var _slopeLine$label7, _slopeLine$label$stro, _slopeLine$label8;
      // Measure the label text
      const measured = renderer.measureText({
        text: slopeLabelText,
        fontFamily: slopeStyle.fontFamily,
        fontSize: slopeStyle.fontSize
      });
      measured.width = measured.width > maxLabelWidth ? maxLabelWidth : measured.width;
      const maxX = isMaxY(chart, slopeLine.slope, slopeLine.value) ? getMaxXPosition(chart, slopeLine.slope, slopeLine.value) : undefined;
      const xPadding = maxX !== undefined && !slopeLine.isRtl ? slopeStyle.padding * 3 : slopeStyle.padding;
      const yPadding = maxX !== undefined || slopeLine.slope > 0 ? slopeStyle.padding * 3 : slopeStyle.padding;
      const x = calculateX(slopeLine, line, maxX, measured, blueprint, slopeStyle);
      const y = Math.min(line.y1, line.y2);
      // if coloredBackground is true make a rect
      if ((_slopeLine$label7 = slopeLine.label) !== null && _slopeLine$label7 !== void 0 && _slopeLine$label7.stroke) {
        labelBackground = {
          type: 'rect',
          x: slopeLine.isRtl ? Math.max(x, xPadding) - 2 : Math.max(x, xPadding) + 2,
          y: Math.abs(Math.max(y, yPadding) - measured.height),
          rx: 3,
          ry: 3,
          width: measured.width + slopeStyle.padding,
          height: measured.height - 2,
          stroke: style.stroke,
          fill: style.stroke
        };
      }
      const slopeLabel = {
        type: 'text',
        text: slopeLabelText,
        fill: (_slopeLine$label$stro = (_slopeLine$label8 = slopeLine.label) === null || _slopeLine$label8 === void 0 ? void 0 : _slopeLine$label8.stroke) !== null && _slopeLine$label$stro !== void 0 ? _slopeLine$label$stro : style.stroke,
        opacity: slopeStyle.opacity,
        fontFamily: slopeStyle.fontFamily,
        fontSize: slopeStyle.fontSize,
        x: labelBackground ? labelBackground.x + 2 : Math.max(x, xPadding) + 2,
        y: labelBackground ? labelBackground.y + measured.height - slopeStyle.padding : Math.abs(Math.max(y, yPadding) - slopeStyle.padding / 2),
        anchor: 'start',
        title: slopeLabelText,
        maxWidth: maxLabelWidth,
        width: measured.width
      };
      if (!isColliding(items, slopeLabel, measured, xPadding, yPadding)) {
        if (labelBackground) {
          items.push(labelBackground);
        }
        items.push(slopeLabel);
      }
    }
  }
  // Only push rect & label if we haven't collided and both are defined
  if (doesNotCollide && rect && label) {
    items.push(rect, label);
    if (value) {
      items.push(value);
    }
  }
}

function createOobData(line) {
  const data = {
    value: line.value
  };
  if (line.label) {
    data.label = line.label.text;
  }
  return data;
}
function filterUndefinedValue(line) {
  const value = typeof line.value === 'function' ? line.value() : line.value;
  return typeof value !== 'undefined';
}
function isInvert(scale) {
  const range = scale.range();
  return (range === null || range === void 0 ? void 0 : range.length) === 2 && range[0] > range[1];
}
function getPosition(scale, value) {
  const min = scale.min();
  const max = scale.max();
  if (min === max) {
    const invert = isInvert(scale);
    if (value < min) {
      return invert ? 2 : -1;
    }
    if (value > min) {
      return invert ? -1 : 2;
    }
  }
  return scale(value);
}
const EPSILON$2 = 1e-15;
function isIdentical(p1, p2) {
  return p1 && p2 && Math.abs(p1.x - p2.x) < EPSILON$2 && Math.abs(p1.y - p2.y) < EPSILON$2;
}
function removeDuplication(intersections) {
  if (isIdentical(intersections[0], intersections[1])) {
    intersections[1] = undefined;
  }
  if (isIdentical(intersections[1], intersections[2])) {
    intersections[2] = undefined;
  }
  if (isIdentical(intersections[2], intersections[3])) {
    intersections[3] = undefined;
  }
  if (isIdentical(intersections[3], intersections[0])) {
    intersections[3] = undefined;
  }
}

/**
 * Component settings
 * @typedef {object} ComponentRefLine.settings
 * @property {object} lines - X & Y Lines
 * @property {ComponentRefLine~Line[]} [lines.x=[]] - Reference lines along X axis
 * @property {ComponentRefLine~Line[]} [lines.y=[]] - Reference lines along Y axis
 */

/**
 * @private
 * @typedef {object} ComponentRefLine.style
 * @property {refline-oob-style} [oob=ComponentRefLine.style.oob] - Style for out of bounds object (oob)
 * @property {ComponentRefLine~Line} [line=ComponentRefLine~Line] - Generic style for lines
 * @property {ComponentRefLine~LineLabel} [label=ComponentRefLine~LineLabel] - Generic style for labels
 */

/**
 * @typedef {object} ComponentRefLine.style.oob
 * @property {boolean} [show=true] - Show out of bounds items
 * @property {string} [type=undefined] - EXPERIMENTAL:  Set this to 'arc' for an experimental out of bounds shape (only works with SVG)
 * @property {number} [width=10] - Width of the out of bounds object
 * @property {string} [fill='#1A1A1A'] - Fill color of the OOB object
 * @property {string} [stroke='transparent'] - Stroke of the OOB object
 * @property {number} [strokeWidth=0] - Stroke width of the OOB object
 * @property {number} [opacity=1] - Opacity of the OOB object
 * @property {ComponentRefLine~GenericText} [text=ComponentRefLine~GenericText] - Text configuration for out of bounds
 * @property {ComponentRefLine~GenericObject} [triangle=ComponentRefLine~GenericObject] - The triangle in OOB
 * @property {object} [padding] - Padding on X
 * @property {number} [padding.x=28] - Padding on X
 * @property {number} [padding.y=5] - Padding on X
 */

/**
 * @typedef {object} ComponentRefLine~GenericText
 * @property {string} [text=''] - Text (if applicable)
 * @property {string} [fontSize='12px'] - Font size (if applicable)
 * @property {string} [fontFamily='Arial'] - Font family
 * @property {string} [fill='#fff'] - Fill color
 * @property {string} [stroke='transparent'] - Stroke
 * @property {number} [strokeWidth=0] - Stroke width
 * @property {string} [strokeDasharray] - Stroke dash array
 * @property {number} [opacity=1] - Opacity
 */

/**
 * @typedef {object} ComponentRefLine~Line
 * @property {number|function} value - The value of the reference line. If a scale is specified, it is applied.
 * @property {string} [scale] - Scale to use (if undefined will use normalized value 0-1)
 * @property {ComponentRefLine~GenericObject} [line=ComponentRefLine~GenericObject] - The style of the line
 * @property {ComponentRefLine~LineLabel} [label=ComponentRefLine~LineLabel] - The label style of the line
 * @property {number} [slope=0] - The slope for the reference line
 */

/**
 * @typedef {object} ComponentRefLine~LineLabel
 * @property {number} padding=5 - Padding inside the label
 * @property {string} [text=''] - Text
 * @property {string} [fontSize='12px'] - Font size
 * @property {string} [fontFamily='Arial'] - Font family
 * @property {string} [stroke='transparent'] - Stroke
 * @property {number} [strokeWidth=0] - Stroke width
 * @property {number} [opacity=1] - Opacity
 * @property {number|string} [align=0] - Alignment property left to right (0 = left, 1 = right). Also supports string ('left', 'center', 'middle', 'right')
 * @property {number|string} [vAlign=0] - Alignment property top to bottom (0 = top, 1 = bottom). Also supports string ('top', 'center', 'middle', 'bottom')
 * @property {number} [maxWidth=1] - The maximum relative width to the width of the rendering area (see maxWidthPx as well)
 * @property {number} [maxWidthPx=9999] - The maximum width in pixels. Labels will be rendered with the maximum size of the smallest value of maxWidth and maxWidthPx size, so you may specify maxWidth 0.8 but maxWidthPx 100 and will never be over 100px and never over 80% of the renderable area
 * @property {ComponentRefLine~LineLabelBackground} [background=ComponentRefLine~LineLabelBackground] - The background style (rect behind text)
 * @property {boolean} [show=true] - Show label
 * @property {boolean} [showValue=true] - Show value label
 */

/**
 * @typedef {object} ComponentRefLine~LineLabelBackground
 * @property {string} [fill='#fff'] - Fill color
 * @property {string} [stroke='transparent'] - Stroke
 * @property {number} [strokeWidth=0] - Stroke width
 * @property {number} [opacity=0.5] - Opacity
 */

/**
 * @typedef {object} ComponentRefLine~GenericObject
 * @property {string} [fill='#fff'] - Fill color
 * @property {string} [stroke='transparent'] - Stroke
 * @property {number} [strokeWidth=0] - Stroke width
 * @property {number} [opacity=1] - Opacity
 */

const refLineComponent = {
  require: ['chart', 'renderer'],
  defaultSettings: {
    layout: {
      displayOrder: 0
    },
    style: {
      oob: {
        show: true,
        width: 10,
        fill: '#1A1A1A',
        stroke: 'transparent',
        strokeWidth: 0,
        opacity: 1,
        text: {
          fontFamily: 'Arial',
          stroke: 'transparent',
          fill: '#fff',
          strokeWidth: 0,
          opacity: 1
        },
        triangle: {
          fill: '#4D4D4D',
          stroke: 'transparent',
          strokeWidth: 0,
          opacity: 1
        },
        padding: {
          x: 28,
          y: 5
        }
      },
      line: {
        stroke: '#000'
      },
      label: {
        strokeWidth: 0
      }
    }
  },
  preferredSize() {
    return 30;
  },
  beforeRender() {
    this.blueprint = transposer();
    this.blueprint.width = this.rect.width;
    this.blueprint.height = this.rect.height;
    this.blueprint.x = this.rect.x;
    this.blueprint.y = this.rect.y;
    this.blueprint.crisp = true;
  },
  render() {
    let settings = this.settings;

    // Setup lines for X and Y
    this.lines = {
      x: [],
      y: []
    };
    this.lines.x = settings.lines && settings.lines.x || [];
    this.lines.y = settings.lines && settings.lines.y || [];
    if (this.lines.x.length === 0 && this.lines.y.length === 0) {
      return [];
    }
    const oob = {
      x0: [],
      x1: [],
      y0: [],
      y1: []
    };

    // Convert a value to an actual position using the scale
    this.lines.x = this.lines.x.filter(filterUndefinedValue).map(line => {
      if (typeof line.value === 'function') {
        line.value = line.value();
      }
      if (line.scale) {
        let scale = this.chart.scale(line.scale);
        const position = getPosition(scale, line.value);
        return extend$1(line, {
          scale,
          position
        });
      }
      return extend$1(line, {
        position: line.value
      });
    });
    // Set all Y lines to flipXY by default
    // This makes the transposer flip them individually
    this.lines.y = this.lines.y.filter(filterUndefinedValue).map(line => {
      if (typeof line.value === 'function') {
        line.value = line.value();
      }
      if (line.scale) {
        let scale = this.chart.scale(line.scale);
        const position = getPosition(scale, line.value);
        return extend$1(line, {
          scale,
          position,
          flipXY: true
        });
      }
      return extend$1(line, {
        position: line.value,
        flipXY: true
      });
    });

    // Move out of bounds lines (OOB) to separate rendering
    this.lines.x = this.lines.x.filter(line => {
      if (line.position < 0 || line.position > 1) {
        oob["x".concat(line.position > 1 ? 1 : 0)].push(createOobData(line));
        return false;
      }
      return true;
    });
    this.lines.y = this.lines.y.filter(line => {
      if (line.slope && line.slope !== 0) {
        return true;
      }
      if (line.position < 0 || line.position > 1) {
        oob["y".concat(line.position > 1 ? 1 : 0)].push(createOobData(line));
        return false;
      }
      return true;
    });
    let items = [];

    // Loop through all X and Y lines
    [...this.lines.x, ...this.lines.y].forEach(p => {
      let show = p.show === true || typeof p.show === 'undefined';
      if (show) {
        // Create slope line with labels
        let slopeLine;
        if (p.slope && p.slope !== 0) {
          const scaleX = this.chart.scale({
            scale: 'x'
          });
          const scaleY = this.chart.scale({
            scale: 'y'
          });
          const minX = scaleX.min();
          const maxX = scaleX.max();
          const minY = scaleY.min();
          const maxY = scaleY.max();
          slopeLine = _objectSpread2(_objectSpread2({}, p), {}, {
            x1: undefined,
            y1: undefined,
            x2: undefined,
            y2: undefined
          });
          const y1 = minX * p.slope + p.value;
          const y2 = maxX * p.slope + p.value;
          const x1 = (minY - p.value) / p.slope;
          const x2 = (maxY - p.value) / p.slope;
          let intersections = [];
          if (!isOob(y1, minY, maxY)) {
            intersections[0] = {
              x: getPosition(scaleX, minX),
              y: getPosition(scaleY, y1)
            };
          }
          if (!isOob(x1, minX, maxX)) {
            intersections[1] = {
              x: getPosition(scaleX, x1),
              y: 1
            };
          }
          if (!isOob(y2, minY, maxY)) {
            intersections[2] = {
              x: getPosition(scaleX, maxX),
              y: getPosition(scaleY, y2)
            };
          }
          if (!isOob(x2, minX, maxX)) {
            intersections[3] = {
              x: getPosition(scaleX, x2),
              y: 0
            };
          }
          const numIntersections = intersections.filter(i => !!i).length;
          if (numIntersections > 2) {
            removeDuplication(intersections);
          }
          intersections = intersections.filter(i => !!i);
          if (intersections.length < 2) {
            oob["y".concat(y1 > maxY ? 0 : 1)].push(createOobData(p));
            return;
          }
          slopeLine.x1 = intersections[0].x;
          slopeLine.y1 = intersections[0].y;
          slopeLine.x2 = intersections[1].x;
          slopeLine.y2 = intersections[1].y;
        } else {
          slopeLine = undefined;
        }
        // Create line with labels
        createLineWithLabel({
          chart: this.chart,
          blueprint: this.blueprint,
          renderer: this.renderer,
          p,
          settings,
          items,
          slopeLine
        });
      }
    });

    // Handle out of bounds
    if (settings.style.oob.show) {
      oobManager({
        blueprint: this.blueprint,
        oob,
        settings,
        items
      });
    }
    return items;
  }
};

/**
 * @typedef {object} ComponentRefLine
 * @extends ComponentSettings
 * @property {'ref-line'} type component type
 * @example
 * {
 *  type: 'ref-line',
 *  lines: {
 *    y: [{
 *      scale: 'y',
 *      value: 5000,
 *      label: {
 *        text: 'value label'
 *      }
 *      slope: 0.5,
 *    }]
 *  }
 * }
 */

function refLine(picasso) {
  picasso.component('ref-line', refLineComponent);
}

function appendStyle$5(struct, buildOpts) {
  extend$1(struct, buildOpts.style);
}
function buildLine$1(buildOpts) {
  const struct = {
    type: 'line',
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0,
    collider: {
      type: null
    }
  };
  if (buildOpts.align === 'top' || buildOpts.align === 'bottom') {
    struct.x1 = buildOpts.innerRect.x - buildOpts.outerRect.x;
    struct.x2 = struct.x1 + buildOpts.innerRect.width;
    struct.y1 = struct.y2 = buildOpts.align === 'top' ? buildOpts.innerRect.height - buildOpts.padding : buildOpts.padding;
  } else {
    struct.x1 = struct.x2 = buildOpts.align === 'left' ? buildOpts.innerRect.width - buildOpts.padding : buildOpts.padding;
    struct.y1 = buildOpts.innerRect.y - buildOpts.outerRect.y;
    struct.y2 = struct.y1 + buildOpts.innerRect.height;
  }
  appendStyle$5(struct, buildOpts);
  return struct;
}

function checkText$1(text) {
  return typeof text === 'string' || typeof text === 'number' ? text : '-';
}
function appendStyle$4(struct, buildOpts) {
  ['fill', 'fontSize', 'fontFamily'].forEach(style => {
    struct[style] = buildOpts.style[style];
  });
}
function clampEnds(struct, buildOpts) {
  if (buildOpts.tilted || buildOpts.stepSize) {
    return;
  }
  if (buildOpts.align === 'top' || buildOpts.align === 'bottom') {
    const leftBoundary = 0;
    const rightBoundary = buildOpts.outerRect.width;
    const textWidth = Math.min(buildOpts.maxWidth / 2, buildOpts.textRect.width / 2);
    const leftTextBoundary = struct.x - textWidth;
    const rightTextBoundary = struct.x + textWidth;
    if (leftTextBoundary < leftBoundary) {
      struct.anchor = 'start';
      struct.x = buildOpts.innerRect.x - buildOpts.outerRect.x;
    } else if (rightTextBoundary > rightBoundary) {
      struct.anchor = 'end';
      struct.x = buildOpts.innerRect.width + buildOpts.innerRect.x;
    }
  } else {
    const topBoundary = 0;
    const bottomBoundary = buildOpts.outerRect.height;
    const textHeight = buildOpts.maxHeight / 2;
    const topTextBoundary = struct.y - textHeight;
    const bottomTextBoundary = struct.y + textHeight;
    if (topTextBoundary < topBoundary) {
      struct.y = buildOpts.innerRect.y - buildOpts.outerRect.y;
      struct.baseline = 'text-before-edge';
    } else if (bottomTextBoundary > bottomBoundary) {
      struct.y = buildOpts.innerRect.height + (buildOpts.innerRect.y - buildOpts.outerRect.y);
      struct.baseline = 'text-after-edge';
    }
  }
}
function appendPadding$1(struct, buildOpts) {
  if (buildOpts.align === 'top') {
    struct.y -= buildOpts.padding;
  } else if (buildOpts.align === 'bottom') {
    struct.y += buildOpts.padding + buildOpts.maxHeight;
  } else if (buildOpts.align === 'left') {
    struct.x -= buildOpts.padding;
  } else if (buildOpts.align === 'right') {
    struct.x += buildOpts.padding;
  }
}
function appendTilting(struct, buildOpts) {
  if (buildOpts.tilted) {
    const r = -buildOpts.angle;
    const radians = r * (Math.PI / 180);
    if (buildOpts.align === 'bottom') {
      struct.x -= buildOpts.maxHeight * Math.sin(radians) / 2;
      struct.y -= buildOpts.maxHeight;
      struct.y += buildOpts.maxHeight * Math.cos(radians) / 2;
    } else {
      struct.x -= buildOpts.maxHeight * Math.sin(radians) / 3;
    }
    struct.transform = "rotate(".concat(r, ", ").concat(struct.x, ", ").concat(struct.y, ")");
    struct.anchor = buildOpts.align === 'bottom' === buildOpts.angle < 0 ? 'start' : 'end';

    // adjustForEnds
    const textWidth = Math.cos(radians) * buildOpts.maxWidth;
    if (buildOpts.align === 'bottom' === buildOpts.angle < 0) {
      // right
      const rightBoundary = buildOpts.outerRect.width - buildOpts.paddingEnd;
      const rightTextBoundary = struct.x + textWidth;
      if (rightTextBoundary > rightBoundary) {
        struct.maxWidth = (rightBoundary - struct.x - 10) / Math.cos(radians);
      }
    } else {
      // left
      const leftBoundary = buildOpts.paddingEnd;
      const leftTextBoundary = struct.x - textWidth;
      if (leftTextBoundary < leftBoundary) {
        struct.maxWidth = (struct.x - leftBoundary - 10) / Math.cos(radians);
      }
    }
  }
}
function bandwidthCollider(tick, struct, buildOpts) {
  if (buildOpts.align === 'bottom' || buildOpts.align === 'top') {
    const tickCenter = tick.position * buildOpts.innerRect.width;
    const leftBoundary = tickCenter + (buildOpts.innerRect.x - buildOpts.outerRect.x - buildOpts.stepSize / 2);
    struct.collider = {
      type: 'rect',
      x: leftBoundary,
      y: 0,
      width: leftBoundary < 0 ? buildOpts.stepSize + leftBoundary : buildOpts.stepSize,
      // Adjust collider so that it doesnt extend onto neighbor collider
      height: buildOpts.innerRect.height
    };
  } else {
    const tickCenter = tick.position * buildOpts.innerRect.height;
    const topBoundary = tickCenter + (buildOpts.innerRect.y - buildOpts.outerRect.y - buildOpts.stepSize / 2);
    struct.collider = {
      type: 'rect',
      x: 0,
      y: topBoundary,
      width: buildOpts.innerRect.width,
      height: topBoundary < 0 ? buildOpts.stepSize + topBoundary : buildOpts.stepSize // Adjust collider so that it doesnt extend onto neighbor collider
    };
  }

  // Clip edges of the collider, should not extend beyoned the outerRect
  const collider = struct.collider;
  collider.x = Math.max(collider.x, 0);
  collider.y = Math.max(collider.y, 0);
  const widthClip = collider.x + collider.width - (buildOpts.outerRect.x + buildOpts.outerRect.width);
  collider.width = widthClip > 0 ? collider.width - widthClip : collider.width;
  const heightClip = collider.y + collider.height - (buildOpts.outerRect.y + buildOpts.outerRect.height);
  collider.height = heightClip > 0 ? collider.height - heightClip : collider.height;
}
function boundsCollider(tick, struct) {
  struct.collider = {
    type: 'polygon',
    vertices: [{
      x: struct.boundingRect.x,
      y: struct.boundingRect.y
    }, {
      x: struct.boundingRect.x + struct.boundingRect.width,
      y: struct.boundingRect.y
    }, {
      x: struct.boundingRect.x + struct.boundingRect.width,
      y: struct.boundingRect.y + struct.boundingRect.height
    }, {
      x: struct.boundingRect.x,
      y: struct.boundingRect.y + struct.boundingRect.height
    }]
  };
}
function tiltedCollider(tick, struct, buildOpts) {
  const radians = buildOpts.angle * (Math.PI / 180);
  const halfWidth = Math.max(buildOpts.stepSize / 2, struct.boundingRect.height / 2); // Handle if bandwidth is zero
  const startAnchor = struct.anchor === 'start';
  const em = struct.anchor === 'end' && radians < 0;
  const sp = struct.anchor === 'start' && radians >= 0;
  const y = struct.boundingRect.y + (sp || em ? struct.boundingRect.height : 0);
  // Generate starting points at bandwidth boundaries
  const points = [{
    x: struct.x - halfWidth,
    y
  }, {
    x: struct.x + halfWidth,
    y
  }].map(p => rotate(p, radians, {
    x: struct.x,
    y: struct.y
  })); // Rotate around center point to counteract labels rotation

  // Append points to wrap polygon around label
  const margin = 10; // extend slightly to handle single char labels better
  const leftPoint = {
    x: startAnchor ? struct.boundingRect.x + struct.boundingRect.width + margin : struct.boundingRect.x - margin,
    y: struct.boundingRect.y + struct.boundingRect.height
  };
  const rightPoint = {
    x: startAnchor ? struct.boundingRect.x + struct.boundingRect.width + margin : struct.boundingRect.x - margin,
    y: struct.boundingRect.y
  };
  const orderedPoints = radians >= 0 ? [leftPoint, rightPoint] : [rightPoint, leftPoint];
  points.push(...orderedPoints);
  struct.collider = {
    type: 'polygon',
    vertices: points
  };
}
function appendCollider(tick, struct, buildOpts) {
  if (buildOpts.layered || !buildOpts.stepSize) {
    boundsCollider(tick, struct);
  } else if (buildOpts.tilted) {
    tiltedCollider(tick, struct, buildOpts);
  } else {
    bandwidthCollider(tick, struct, buildOpts);
  }
}
function appendBounds$1(struct, buildOpts) {
  struct.boundingRect = buildOpts.textBounds(struct);
}
function wiggle(buildOpts, isVertical) {
  const a = isNaN(buildOpts.style.align) ? 0.5 : Math.min(Math.max(buildOpts.style.align, 0), 1);
  let w = 0;
  if (buildOpts.tilted) {
    w = buildOpts.stepSize * a;
  } else {
    const size = isVertical ? buildOpts.textRect.height : buildOpts.textRect.width;
    w = Math.max(0, buildOpts.stepSize - size) * a;
  }
  return w;
}
function buildNode$1(tick, buildOpts) {
  var _tick$value, _tick$data;
  const struct = {
    type: 'text',
    text: checkText$1(tick.label),
    x: 0,
    y: 0,
    maxWidth: buildOpts.maxWidth,
    maxHeight: buildOpts.maxHeight,
    tickValue: (_tick$value = tick.value) !== null && _tick$value !== void 0 ? _tick$value : (_tick$data = tick.data) === null || _tick$data === void 0 ? void 0 : _tick$data.value
  };
  if (buildOpts.align === 'top' || buildOpts.align === 'bottom') {
    struct.x = tick.start * buildOpts.innerRect.width + (buildOpts.innerRect.x - buildOpts.outerRect.x) + wiggle(buildOpts, false);
    struct.y = buildOpts.align === 'top' ? buildOpts.innerRect.height : 0;
    struct.anchor = buildOpts.stepSize ? 'start' : 'middle';
    struct.x += isNaN(buildOpts.style.offset) ? 0 : +buildOpts.style.offset;
  } else {
    struct.y = tick.start * buildOpts.innerRect.height + (buildOpts.innerRect.y - buildOpts.outerRect.y) + wiggle(buildOpts, true);
    struct.x = buildOpts.align === 'left' ? buildOpts.innerRect.width : 0;
    struct.anchor = buildOpts.align === 'left' ? 'end' : 'start';
    struct.baseline = buildOpts.stepSize ? 'text-before-edge' : 'central';
    struct.y += isNaN(buildOpts.style.offset) ? 0 : +buildOpts.style.offset;
  }
  appendStyle$4(struct, buildOpts);
  clampEnds(struct, buildOpts);
  appendPadding$1(struct, buildOpts);
  appendTilting(struct, buildOpts);
  appendBounds$1(struct, buildOpts);
  appendCollider(tick, struct, buildOpts);
  return struct;
}

function appendStyle$3(struct, buildOpts) {
  extend$1(struct, buildOpts.style);
}
function appendPadding(struct, buildOpts) {
  if (buildOpts.align === 'top') {
    struct.y1 -= buildOpts.padding;
    struct.y2 -= buildOpts.padding;
  } else if (buildOpts.align === 'bottom') {
    struct.y1 += buildOpts.padding;
    struct.y2 += buildOpts.padding;
  } else if (buildOpts.align === 'left') {
    struct.x1 -= buildOpts.padding;
    struct.x2 -= buildOpts.padding;
  } else if (buildOpts.align === 'right') {
    struct.x1 += buildOpts.padding;
    struct.x2 += buildOpts.padding;
  }
}
function adjustForEnds(struct, buildOpts) {
  const halfWidth = struct.strokeWidth / 2;
  if (struct.x1 === buildOpts.innerRect.width) {
    // outer end tick
    struct.x1 -= halfWidth;
    struct.x2 -= halfWidth;
  } else if (struct.x1 === 0) {
    // outer start tick
    struct.x1 += halfWidth;
    struct.x2 += halfWidth;
  } else if (struct.y1 === buildOpts.innerRect.height) {
    struct.y1 -= halfWidth;
    struct.y2 -= halfWidth;
  } else if (struct.y1 === 0) {
    struct.y1 += halfWidth;
    struct.y2 += halfWidth;
  }
}
function buildNode(tick, buildOpts) {
  const struct = {
    type: 'line',
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0,
    collider: {
      type: null
    },
    tickValue: tick.value
  };
  if (buildOpts.align === 'top' || buildOpts.align === 'bottom') {
    struct.x1 = struct.x2 = tick.position * buildOpts.innerRect.width + (buildOpts.innerRect.x - buildOpts.outerRect.x);
    struct.y1 = buildOpts.align === 'top' ? buildOpts.innerRect.height : 0;
    struct.y2 = buildOpts.align === 'top' ? struct.y1 - buildOpts.tickSize : struct.y1 + buildOpts.tickSize;
  } else {
    struct.y1 = struct.y2 = tick.position * buildOpts.innerRect.height + (buildOpts.innerRect.y - buildOpts.outerRect.y);
    struct.x1 = buildOpts.align === 'left' ? buildOpts.innerRect.width : 0;
    struct.x2 = buildOpts.align === 'left' ? struct.x1 - buildOpts.tickSize : struct.x1 + buildOpts.tickSize;
  }
  appendStyle$3(struct, buildOpts);
  appendPadding(struct, buildOpts);
  adjustForEnds(struct, buildOpts);
  return struct;
}

function isMajorTick(tick) {
  return !tick.isMinor && tick.position >= 0 && tick.position <= 1;
}
function isVerticalLabelOverlapping(_ref) {
  let {
    majorTicks,
    measureText,
    rect
  } = _ref;
  const size = rect.height;
  const textHeight = measureText('M').height;
  if (majorTicks.length < 2) {
    return false;
  }
  const d = size * Math.abs(majorTicks[0].position - majorTicks[1].position);
  if (d < textHeight) {
    return true;
  }
  return false;
}
function isHorizontalLabelOverlapping(_ref2) {
  let {
    majorTicks,
    measureText,
    rect,
    state
  } = _ref2;
  /*
   * Currently isn't any good way of doing a accurate measurement on size available (bandWidth * width) for labels.
   * It's a lifecycle limitation as components docked either left or right can affect the width available after the calculation is done.
   * <number of components docked left/right> * <width of components> => Less accurate ===> Can result in only ellips char rendered as labels.
   */
  const m = state.labels.activeMode === 'layered' ? 2 : 1;
  const size = rect.width;
  const tickSize = majorTicks.map(tick => tick.label).map(l => "".concat(l.slice(0, 1)).concat(l.length > 1 ? '…' : '')) // Measure the size of 1 chars + the ellips char.
  .map(measureText).map(r => r.width);
  for (let i = 0; i < majorTicks.length; ++i) {
    const tick = majorTicks[i];
    const d1 = m * size * Math.abs(tick.start - tick.end);
    const d2 = tickSize[i];
    if (d1 < d2) {
      return true;
    }
  }
  return false;
}
function shouldAutoTilt(_ref3) {
  let {
    majorTicks,
    measure,
    rect,
    state,
    settings
  } = _ref3;
  const glyphCount = settings.labels.maxGlyphCount;
  const m = state.labels.activeMode === 'layered' ? 2 : 1;
  const magicSizeRatioMultipler = settings.labels.tiltThreshold ? settings.labels.tiltThreshold : 0.7; // So that if less the 70% of labels are visible, toggle on tilt or use variable tiltThreshold
  const ellipsCharSize = measure('…').width; // include ellipsed char in calc as it's generally large then the char it replaces
  const size = rect.width;
  let maxLabelWidth = 0;
  let d1 = 0;
  if (!isNaN(glyphCount)) {
    const minBandwidth = majorTicks.reduce((prev, curr) => Math.min(Math.abs(curr.start - curr.end), prev), Infinity);
    d1 = m * size * minBandwidth;
    maxLabelWidth = measure('M').width * magicSizeRatioMultipler * glyphCount;
    if (maxLabelWidth + ellipsCharSize > d1) {
      return true;
    }
  } else {
    for (let i = 0; i < majorTicks.length; i++) {
      const tick = majorTicks[i];
      const label = tick.label;
      const width = measure(label).width * (label.length > 1 ? magicSizeRatioMultipler : 1);
      d1 = m * size * Math.abs(tick.start - tick.end);
      if (width + ellipsCharSize > d1) {
        return true;
      }
    }
  }
  return false;
}
function isTiltedLabelOverlapping(_ref4) {
  let {
    majorTicks,
    measureText,
    rect,
    bleedSize,
    angle
  } = _ref4;
  if (majorTicks.length < 2) {
    return false;
  }
  if (angle === 0) {
    return true; // TODO 0 angle should be considered non-tilted
  }
  const absAngle = Math.abs(angle);
  const size = Math.min(rect.outer.width - bleedSize, rect.inner.width);
  const stepSize = size * Math.abs(majorTicks[0].position - majorTicks[1].position);
  const textHeight = measureText('M').height;
  const reciprocal = 1 / stepSize; // 1 === Math.sin(90 * (Math.PI / 180))
  const distanceBetweenLabels = Math.sin(absAngle * (Math.PI / 180)) / reciprocal;
  return textHeight > distanceBetweenLabels;
}
function isToLarge(_ref5) {
  let {
    rect,
    state,
    majorTicks,
    measure,
    horizontal
  } = _ref5;
  if (horizontal) {
    return isHorizontalLabelOverlapping({
      majorTicks,
      measureText: measure,
      rect,
      state
    });
  }
  return isVerticalLabelOverlapping({
    majorTicks,
    measureText: measure,
    rect,
    state
  });
}
function getClampedValue(_ref6) {
  let {
    value,
    maxValue,
    minValue,
    range,
    modifier
  } = _ref6;
  if (!isNaN(range) && !isNaN(modifier)) {
    value = range * modifier;
  }
  if (value > maxValue) {
    value = maxValue;
  }
  if (value < minValue) {
    value = minValue;
  }
  return value;
}
function getSize(_ref7) {
  let {
    isDiscrete,
    rect,
    formatter,
    measureText,
    scale,
    settings,
    state
  } = _ref7;
  let size = 0;
  const edgeBleed = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  };
  const {
    maxLengthPx: maxValue,
    minLengthPx: minValue
  } = settings.labels;
  if (settings.labels.show) {
    const align = settings.align;
    const horizontal = align === 'top' || align === 'bottom';
    const distance = horizontal ? rect.inner.width : rect.inner.height;
    const majorTicks = scale.ticks({
      settings,
      distance,
      formatter
    }).filter(isMajorTick);
    const measure = text => {
      const m = measureText({
        text,
        fontSize: settings.labels.fontSize,
        fontFamily: settings.labels.fontFamily
      });
      m.width = getClampedValue({
        value: m.width,
        maxValue,
        minValue
      });
      return m;
    };
    if (isDiscrete && horizontal && settings.labels.mode === 'auto') {
      if (shouldAutoTilt({
        majorTicks,
        measure,
        rect: rect.inner,
        state,
        settings
      })) {
        state.labels.activeMode = 'tilted';
      } else {
        state.labels.activeMode = 'horizontal';
      }
    }
    if (!settings.labels.filterOverlapping && state.labels.activeMode !== 'tilted' && isToLarge({
      rect: rect.inner,
      state,
      majorTicks,
      measure,
      horizontal
    })) {
      const toLargeSize = Math.max(rect.outer.width, rect.outer.height); // used to hide the axis
      return {
        size: toLargeSize,
        isToLarge: true
      };
    }
    let sizeFromTextRect;
    if (state.labels.activeMode === 'tilted') {
      const radians = Math.abs(settings.labels.tiltAngle) * (Math.PI / 180); // angle in radians
      sizeFromTextRect = r => getClampedValue({
        value: r.width,
        maxValue,
        minValue
      }) * Math.sin(radians) + r.height * Math.cos(radians);
    } else if (horizontal) {
      sizeFromTextRect = r => r.height;
    } else {
      sizeFromTextRect = r => getClampedValue({
        value: r.width,
        maxValue,
        minValue
      });
    }
    let labels;
    if (horizontal && state.labels.activeMode !== 'tilted') {
      labels = ['M'];
    } else if (!isNaN(settings.labels.maxGlyphCount)) {
      let label = '';
      for (let i = 0; i < settings.labels.maxGlyphCount; i++) {
        label += 'M';
      }
      labels = [label];
    } else {
      labels = majorTicks.map(tick => tick.label);
    }
    const tickMeasures = labels.map(measure);
    const labelSizes = tickMeasures.map(sizeFromTextRect);
    const textSize = Math.max(...labelSizes, 0);
    size += textSize;
    size += settings.labels.margin;
    if (state.labels.activeMode === 'layered') {
      size *= 2;
    }
    if (state.labels.activeMode === 'tilted') {
      const extendLeft = settings.align === 'bottom' === settings.labels.tiltAngle >= 0;
      const radians = Math.abs(settings.labels.tiltAngle) * (Math.PI / 180); // angle in radians
      const h = measure('M').height;
      const maxWidth = (textSize - h * Math.cos(radians)) / Math.sin(radians);
      const labelWidth = r => Math.min(maxWidth, r.width) * Math.cos(radians) + r.height;
      const adjustByPosition = (s, i) => {
        const pos = majorTicks[i] ? majorTicks[i].position : 0;
        if (extendLeft) {
          return s - pos * rect.inner.width;
        }
        return s - (1 - pos) * rect.inner.width;
      };
      const bleedSize = Math.min(settings.labels.maxEdgeBleed, Math.max(...tickMeasures.map(labelWidth).map(adjustByPosition), 0)) + settings.paddingEnd;
      const bleedDir = extendLeft ? 'left' : 'right';
      edgeBleed[bleedDir] = bleedSize;
      if (!settings.labels.filterOverlapping && isTiltedLabelOverlapping({
        majorTicks,
        measureText: measure,
        rect,
        bleedSize,
        angle: settings.labels.tiltAngle
      })) {
        const toLargeSize = Math.max(rect.outer.width, rect.outer.height); // used to hide the axis
        return {
          size: toLargeSize,
          isToLarge: true
        };
      }
    }
  }
  return {
    size,
    edgeBleed
  };
}

const PADDING$1 = 2;
const tickDistance = (rect, start, end) => rect.width * Math.abs(start.position - end.position);
const getLeftEdgeWidth = _ref => {
  let {
    innerRect,
    outerRect,
    tick,
    nextWidth
  } = _ref;
  const leftEdgeBleed = innerRect.x - outerRect.x;
  const left = innerRect.width * tick.position + leftEdgeBleed;
  const minDubble = Math.min(nextWidth, left) * 2;
  const minWidth = tick.position === 0 ? innerRect.width / 2 - PADDING$1 : 0;
  return Math.max(nextWidth, minDubble, minWidth);
};
const getRightEdgeWidth = _ref2 => {
  let {
    innerRect,
    outerRect,
    tick,
    prevWidth
  } = _ref2;
  const leftEdgeBleed = innerRect.x - outerRect.x;
  const rightEdgeBleed = outerRect.width - innerRect.width - leftEdgeBleed;
  const right = innerRect.width - innerRect.width * tick.position + rightEdgeBleed;
  const minDubble = Math.min(prevWidth, right) * 2;
  const minWidth = tick.position === 1 ? innerRect.width / 2 - PADDING$1 : 0;
  return Math.max(prevWidth, minDubble, minWidth);
};
function getHorizontalWidth(_ref3) {
  let {
    layered,
    major,
    innerRect,
    outerRect,
    tick,
    index
  } = _ref3;
  const step = layered ? 2 : 1;
  const prev = major[index - step];
  const next = major[index + step];
  const prevWidth = prev ? tickDistance(innerRect, tick, prev) / 2 - PADDING$1 : Infinity;
  const nextWidth = next ? tickDistance(innerRect, tick, next) / 2 - PADDING$1 : Infinity;
  if (major.length < 2) {
    return innerRect.width;
  }
  if (!prev) {
    return getLeftEdgeWidth({
      innerRect,
      outerRect,
      tick,
      nextWidth
    });
  }
  if (!next) {
    return getRightEdgeWidth({
      innerRect,
      outerRect,
      tick,
      prevWidth
    });
  }
  return Math.min(prevWidth, nextWidth) * 2;
}

function appendStyle$2(struct, buildOpts) {
  extend$1(struct, buildOpts.style);
}
function buildArcLine(buildOpts) {
  const rect = buildOpts.innerRect;
  const centerPoint = {
    cx: rect.width / 2,
    cy: rect.height / 2
  };
  const halfPlotSize = Math.min(rect.height, rect.width) / 2;
  const innerRadius = halfPlotSize * buildOpts.radius;
  const outerRadius = innerRadius + buildOpts.style.strokeWidth;
  const startAngle = buildOpts.startAngle;
  const endAngle = buildOpts.endAngle;
  const struct = {
    visible: true,
    type: 'path',
    arcDatum: {
      startAngle,
      endAngle
    },
    transform: "translate(0, 0) translate(".concat(centerPoint.cx, ", ").concat(centerPoint.cy, ")"),
    desc: {
      share: 1,
      slice: {
        cornerRadius: 0,
        innerRadius,
        outerRadius
      }
    },
    ticks: []
  };
  appendStyle$2(struct, buildOpts);
  return struct;
}

function appendStyle$1(struct, buildOpts) {
  const styleClone = _objectSpread2({}, buildOpts.style); // Shallow clone
  extend$1(struct, styleClone);
}
function polarToCartesian$1(centerX, centerY, radius, angle) {
  return {
    x: centerX + radius * Math.cos(angle),
    y: centerY + radius * Math.sin(angle)
  };
}
function buildArcTicks(tick, buildOpts) {
  const rect = buildOpts.innerRect;
  const centerPoint = {
    cx: rect.width / 2,
    cy: rect.height / 2
  };
  const halfPlotSize = Math.min(rect.height, rect.width) / 2;
  const innerRadius = halfPlotSize * buildOpts.radius;
  const outerRadius = innerRadius + buildOpts.padding;
  const startAngle = buildOpts.startAngle;
  const endAngle = buildOpts.endAngle;
  const tickLength = buildOpts.tickSize;
  const angleRange = endAngle - startAngle;
  let angle = endAngle - tick.position * angleRange;
  angle -= Math.PI / 2;
  const innerPos = polarToCartesian$1(centerPoint.cx, centerPoint.cy, outerRadius + tickLength, angle);
  const outerPos = polarToCartesian$1(centerPoint.cx, centerPoint.cy, outerRadius, angle);
  const struct = {
    type: 'line',
    x1: innerPos.x,
    y1: innerPos.y,
    x2: outerPos.x,
    y2: outerPos.y,
    value: tick.value
  };
  appendStyle$1(struct, buildOpts);
  return struct;
}

function appendStyle(struct, buildOpts) {
  ['fill', 'fontSize', 'fontFamily'].forEach(style => {
    struct[style] = buildOpts.style[style];
  });
}
function polarToCartesian(centerX, centerY, radius, angle) {
  return {
    x: centerX + radius * Math.cos(angle),
    y: centerY + radius * Math.sin(angle)
  };
}
function checkText(text) {
  return typeof text === 'string' || typeof text === 'number' ? text : '-';
}
function calculateMaxWidth(buildOpts, side, innerPos) {
  let maxWidth;
  if (side === 'left') {
    maxWidth = innerPos.x;
  } else if (side === 'right') {
    maxWidth = buildOpts.outerRect.width - innerPos.x;
  } else {
    maxWidth = Math.max(innerPos.x, buildOpts.outerRect.width - innerPos.x);
  }
  return maxWidth;
}
function checkRadialOutOfBounds(buildOpts, innerPos, struct) {
  let maxHeightTop;
  let maxHeightBottom;
  const textHeight = parseFloat(struct.fontSize) || 0;
  maxHeightTop = innerPos.y - textHeight / 2;
  maxHeightBottom = buildOpts.innerRect.height - (innerPos.y + textHeight / 2);
  if (maxHeightTop < 0 || maxHeightBottom < 0) {
    struct.text = '';
  }
  return maxHeightBottom;
}
function appendBounds(struct, buildOpts) {
  struct.boundingRect = buildOpts.textBounds(struct);
}
function buildArcLabels(tick, buildOpts) {
  const rect = buildOpts.innerRect;
  const centerPoint = {
    cx: rect.width / 2,
    cy: rect.height / 2
  };
  const halfPlotSize = Math.min(rect.height, rect.width) / 2;
  const innerRadius = halfPlotSize * buildOpts.radius;
  const outerRadius = innerRadius + buildOpts.padding;
  const startAngle = buildOpts.startAngle;
  const endAngle = buildOpts.endAngle;
  const tickLength = buildOpts.tickSize;
  const angleRange = endAngle - startAngle;
  const centerOffset = 0.2;
  let angle;
  let side;
  if (buildOpts.align === 'top' || buildOpts.align === 'bottom') {
    angle = endAngle - tick.position * angleRange;
  } else {
    angle = startAngle + tick.position * angleRange;
  }
  if (angle < 0 - centerOffset && angle > -Math.PI + centerOffset) {
    side = 'left';
  } else if (angle > 0 + centerOffset && angle < Math.PI - centerOffset) {
    side = 'right';
  } else {
    side = 'center';
  }
  angle -= Math.PI / 2;
  const padding = 6;
  const innerPos = polarToCartesian(centerPoint.cx, centerPoint.cy, outerRadius + tickLength + padding, angle);
  let textAnchor;
  if (side === 'left') {
    textAnchor = 'end'; // Align text to the right of the x-coordinate
  } else if (side === 'right') {
    textAnchor = 'start'; // Align text to the left of the x-coordinate
  } else {
    textAnchor = 'middle'; // Center align the text
  }
  const struct = {
    type: 'text',
    text: checkText(tick.label),
    align: side,
    x: innerPos.x,
    y: innerPos.y,
    maxHeight: buildOpts.maxHeight,
    maxWidth: calculateMaxWidth(buildOpts, side, innerPos),
    anchor: textAnchor,
    baseline: 'middle'
  };
  appendStyle(struct, buildOpts);
  appendBounds(struct, buildOpts);
  checkRadialOutOfBounds(buildOpts, innerPos, struct);
  return struct;
}

function tickSpacing(settings) {
  let spacing = 0;
  spacing += settings.paddingStart;
  spacing += settings.line.show ? settings.line.strokeWidth / 2 : 0;
  spacing += settings.ticks.show ? settings.ticks.margin : 0;
  return spacing;
}
function arcTickSpacing(settings) {
  let spacing = 0;
  spacing += settings.line.show ? settings.line.strokeWidth / 2 : 0;
  spacing += settings.ticks.show ? settings.ticks.margin : 0;
  return spacing;
}
function tickMinorSpacing(settings) {
  return settings.line.strokeWidth + settings.minorTicks.margin;
}
function labelsSpacing(settings) {
  let spacing = 0;
  spacing += settings.ticks.show ? settings.ticks.tickSize : 0;
  spacing += tickSpacing(settings) + settings.labels.margin;
  return spacing;
}
function arcLabelSpacing(settings) {
  let spacing = 0;
  spacing += settings.ticks.show ? settings.ticks.tickSize : 0;
  spacing += arcTickSpacing(settings) + settings.labels.margin;
  return spacing;
}
function calcActualTextRect(_ref) {
  let {
    style,
    measureText,
    tick
  } = _ref;
  return measureText({
    text: tick.label,
    fontSize: style.fontSize,
    fontFamily: style.fontFamily
  });
}
function majorTicks(ticks) {
  return ticks.filter(t => !t.isMinor);
}
function minorTicks(ticks) {
  return ticks.filter(t => t.isMinor);
}
function tickBuilder(ticks, buildOpts) {
  return ticks.map(tick => buildNode(tick, buildOpts));
}
function arcTickBuilder(ticks, buildOpts) {
  return ticks.map(tick => buildArcTicks(tick, buildOpts));
}
function tickBandwidth(scale, tick) {
  return tick ? Math.abs(tick.end - tick.start) : scale.bandwidth();
}
function labelBuilder(ticks, buildOpts, resolveTickOpts) {
  return ticks.map((tick, idx) => {
    resolveTickOpts(tick, idx);
    const label = buildNode$1(tick, buildOpts);
    label.data = tick.data;
    return label;
  });
}
function arcLabelBuilder(ticks, buildOpts, resolveTickOpts) {
  return ticks.map((tick, idx) => {
    resolveTickOpts(tick, idx);
    const label = buildArcLabels(tick, buildOpts);
    label.data = tick.data;
    return label;
  });
}
function layeredLabelBuilder(ticks, buildOpts, settings, resolveTickOpts) {
  const padding = buildOpts.padding;
  const spacing = labelsSpacing(settings);
  return ticks.map((tick, idx) => {
    resolveTickOpts(tick, idx);
    const padding2 = spacing + buildOpts.maxHeight + settings.labels.margin;
    buildOpts.layer = idx % 2;
    buildOpts.padding = idx % 2 === 0 ? padding : padding2;
    const label = buildNode$1(tick, buildOpts);
    label.data = tick.data;
    return label;
  });
}
function filterOverlappingLabels$1(labels, ticks, buildOpts) {
  let isOverlapping = (i, k) => {
    const rect1 = expandRect(1, labels[i].boundingRect);
    const rect2 = expandRect(1, labels[k].boundingRect);
    return testRectRect(rect1, rect2);
  };
  if (buildOpts && buildOpts.tilted) {
    const absAngle = Math.abs(buildOpts.angle);
    isOverlapping = (i, k) => {
      const stepSize = Math.abs(labels[i].x - labels[k].x);
      const reciprocal = 1 / stepSize;
      const distanceBetweenLabels = Math.sin(absAngle * (Math.PI / 180)) / reciprocal;
      return labels[i].boundingRect.height > distanceBetweenLabels;
    };
  }
  for (let i = 0; i <= labels.length - 1; i++) {
    for (let k = i + 1; k <= Math.min(i + 5, i + (labels.length - 1)); k++) {
      // TODO Find a better way to handle exteme/layered labels then to iterare over ~5 next labels
      if (labels[i] && labels[k] && isOverlapping(i, k)) {
        if (k === labels.length - 1) {
          // On collition with last label, remove current label instead
          labels.splice(i, 1);
          if (ticks) {
            ticks.splice(i, 1);
          }
        } else {
          labels.splice(k, 1);
          if (ticks) {
            ticks.splice(k, 1);
          }
        }
        k--;
        i--;
      }
    }
  }
}
function discreteCalcMaxTextRect(_ref2) {
  let {
    textMetrics,
    settings,
    innerRect,
    scale,
    tilted,
    layered,
    tick
  } = _ref2;
  const h = textMetrics.height;
  const bandwidth = tickBandwidth(scale, tick);
  const textRect = {
    width: 0,
    height: h
  };
  if (settings.align === 'left' || settings.align === 'right') {
    textRect.width = innerRect.width - labelsSpacing(settings) - settings.paddingEnd;
  } else if (layered) {
    textRect.width = bandwidth * innerRect.width * 2;
  } else if (tilted) {
    const radians = Math.abs(settings.labels.tiltAngle) * (Math.PI / 180);
    textRect.width = (innerRect.height - labelsSpacing(settings) - settings.paddingEnd - h * Math.cos(radians)) / Math.sin(radians);
  } else {
    textRect.width = bandwidth * innerRect.width;
  }
  textRect.width = getClampedValue({
    value: textRect.width,
    maxValue: settings.labels.maxLengthPx,
    minValue: settings.labels.minLengthPx
  });
  return textRect;
}
function continuousCalcMaxTextRect(_ref3) {
  let {
    textMetrics,
    settings,
    innerRect,
    outerRect,
    tilted,
    layered,
    tick,
    index,
    major
  } = _ref3;
  const h = textMetrics.height;
  const textRect = {
    width: 0,
    height: h
  };
  if (settings.align === 'left' || settings.align === 'right') {
    textRect.width = innerRect.width - labelsSpacing(settings) - settings.paddingEnd;
  } else if (tilted) {
    const radians = Math.abs(settings.labels.tiltAngle) * (Math.PI / 180);
    textRect.width = (innerRect.height - labelsSpacing(settings) - settings.paddingEnd - h * Math.cos(radians)) / Math.sin(radians);
  } else {
    textRect.width = getHorizontalWidth({
      layered,
      major,
      innerRect,
      outerRect,
      tick,
      index
    });
  }
  textRect.width = getClampedValue({
    value: textRect.width,
    maxValue: settings.labels.maxLengthPx,
    minValue: settings.labels.minLengthPx
  });
  return textRect;
}
function getStepSizeFn(_ref4) {
  let {
    innerRect,
    scale,
    settings,
    tick
  } = _ref4;
  const size = settings.align === 'top' || settings.align === 'bottom' ? innerRect.width : innerRect.height;
  const bandwidth = tickBandwidth(scale, tick);
  return size * bandwidth;
}
function nodeBuilder(isDiscrete) {
  let resolveLabelRect;
  function continuous() {
    resolveLabelRect = continuousCalcMaxTextRect;
    return continuous;
  }
  function discrete() {
    resolveLabelRect = discreteCalcMaxTextRect;
    return discrete;
  }
  function build(_ref5) {
    let {
      settings,
      scale,
      innerRect,
      outerRect,
      measureText,
      ticks,
      state,
      textBounds
    } = _ref5;
    const nodes = [];
    const major = majorTicks(ticks);
    const minor = minorTicks(ticks);
    const buildOpts = {
      innerRect,
      align: settings.align,
      outerRect
    };
    const tilted = state.labels.activeMode === 'tilted';
    const layered = state.labels.activeMode === 'layered';
    let majorTickNodes;
    if (settings.arc) {
      buildOpts.startAngle = settings.arc.startAngle;
      buildOpts.endAngle = settings.arc.endAngle;
      buildOpts.radius = settings.arc.radius;
    }
    if (settings.line.show) {
      buildOpts.style = settings.line;
      buildOpts.padding = settings.paddingStart;
      if (settings.arc) {
        nodes.push(buildArcLine(buildOpts));
      } else {
        nodes.push(buildLine$1(buildOpts));
      }
    }
    if (settings.ticks.show) {
      buildOpts.style = settings.ticks;
      buildOpts.tickSize = settings.ticks.tickSize;
      buildOpts.padding = tickSpacing(settings);
      if (settings.arc) {
        buildOpts.padding = arcTickSpacing(settings);
        majorTickNodes = arcTickBuilder(major, buildOpts);
      } else {
        majorTickNodes = tickBuilder(major, buildOpts);
      }
    }
    if (settings.labels.show) {
      const padding = labelsSpacing(settings);
      buildOpts.style = settings.labels;
      buildOpts.padding = padding;
      buildOpts.tilted = tilted;
      buildOpts.layered = layered;
      buildOpts.angle = settings.labels.tiltAngle;
      buildOpts.paddingEnd = settings.paddingEnd;
      buildOpts.textBounds = textBounds;
      const resolveTickOpts = (tick, index) => {
        buildOpts.textRect = calcActualTextRect({
          tick,
          measureText,
          style: buildOpts.style
        });
        const maxSize = resolveLabelRect({
          textMetrics: buildOpts.textRect,
          settings,
          innerRect,
          outerRect,
          scale,
          tilted,
          layered,
          tick,
          major,
          index
        });
        buildOpts.maxWidth = maxSize.width;
        buildOpts.maxHeight = maxSize.height;
        buildOpts.stepSize = getStepSizeFn({
          innerRect,
          scale,
          ticks,
          settings,
          tick
        });
      };
      let labelNodes = [];
      if (settings.arc) {
        buildOpts.padding = arcLabelSpacing(settings);
        labelNodes = arcLabelBuilder(major, buildOpts, resolveTickOpts);
      } else if (layered && (settings.align === 'top' || settings.align === 'bottom')) {
        labelNodes = layeredLabelBuilder(major, buildOpts, settings, resolveTickOpts);
      } else {
        labelNodes = labelBuilder(major, buildOpts, resolveTickOpts);
      }

      // Remove labels (and paired tick) that are overlapping
      if (settings.labels.filterOverlapping) {
        filterOverlappingLabels$1(labelNodes, majorTickNodes, buildOpts);
      }
      nodes.push(...labelNodes);
    }
    if (settings.minorTicks && settings.minorTicks.show && minor.length > 0) {
      buildOpts.style = settings.minorTicks;
      buildOpts.tickSize = settings.minorTicks.tickSize;
      buildOpts.padding = tickMinorSpacing(settings);
      nodes.push(...tickBuilder(minor, buildOpts));
    }
    if (majorTickNodes) {
      nodes.push(...majorTickNodes);
    }
    return nodes;
  }
  continuous.build = build;
  discrete.build = build;
  return isDiscrete ? discrete() : continuous();
}

// const DEFAULT_LAYOUT_SETTINGS = { // TODO create dis and con specific settings
//   anchor: 'auto', // TODO re-name from align..
//   // orientation: 'auto', // TODO impl. v/h/auto
//   // direction: 'auto', // TODO impl. left/right/top/bottom/auto
//   padding: { // TODO use dock layout margin instead..
//     start: 0,
//     end: 10
//   },
//   maxGlyphCount: NaN,
//   maxEdgeBleed: Infinity
//   // labelMode: 'auto' // TODO move here? auto, horizontal, layered
// };

/**
 * @typedef {object} ComponentAxis
 * @extends ComponentSettings
 * @property {'axis'} type component type
 * @property {string} scale reference to band or linear scale
 * @property {ComponentAxis~DiscreteSettings|ComponentAxis~ContinuousSettings} [settings] discrete or continuous axis settings
 * @example
 * {
 *  type: 'axis',
 *  scale: '<name-of-scale>'
 * }
 */

/**
 * Discrete axis settings
 * @typedef {object}
 * @alias ComponentAxis~DiscreteSettings
 * @example
 * {
 *  type: 'axis',
 *  scale: '<name-of-band-scale>',
 *  settings: {
 *    labels: {
 *      mode: 'tilted',
 *      tiltAngle: 40,
 *    },
 *  },
 * }
 */
const DEFAULT_DISCRETE_SETTINGS = {
  /**
   * @typedef {object}
   */
  labels: {
    /** Toggle labels on/off
     * @type {boolean=} */
    show: true,
    /** Tilting angle in degrees. Capped between -90 and 90. Only applicable when labels are in `tilted` mode.
     * @type {number=} */
    tiltAngle: 40,
    /** Threshold for toggle of tilted labels. Capped between 0 and 1. For example, if it is set to 0.7, then tilted labels will be toggled if less than 70% of the labels are visible.
     * @type {number=} */
    tiltThreshold: 0.7,
    /** Control the amount of space (in pixels) that labes can occupy outside their docking area. Only applicable when labels are in `tilted` mode.
     * @type {number=} */
    maxEdgeBleed: Infinity,
    /** Space in pixels between the tick and label.
     * @type {number=} */
    margin: 4,
    /** Max length of labels in pixels
     * @type {number=} */
    maxLengthPx: 150,
    /** Min length of labels in pixels. Labels will always at least require this much space
     * @type {number=} */
    minLengthPx: 0,
    /** Control how labels arrange themself. Availabe modes are `auto`, `horizontal`, `layered` and `tilted`. When set to `auto` the axis determines the best possible layout in the current context.
     * @type {string=} */
    mode: 'auto',
    /** When only a sub-set of data is available, ex. when paging. This property can be used to let the axis estimate how much space the labels will consume, allowing it to give a consistent space estimate over the entire dataset when paging.
     * @type {number=} */
    maxGlyphCount: NaN,
    /** Align act as a slider for the text bounding rect over the item bandwidth, given that the item have a bandwidth. Except when labels are tilted, then the align is a pure align that shifts the position of the label anchoring point.
     * @type {number=} */
    align: 0.5,
    /** Offset in pixels along the axis direction.
     * @type {number=} */
    offset: 0,
    /**
     * Toggle whether labels should be filtered if they are overlapping. Filtering may be applied in a non-sequential order.
     * If labels are overlapping and this setting is toggled off, the axis will automatically hide.
     * @type {boolean=}
     */
    filterOverlapping: false
  },
  /**
   * @typedef {object}
   */
  ticks: {
    /** Toggle ticks on/off
     * @type {boolean=} */
    show: false,
    /** Space in pixels between the ticks and the line.
     * @type {number=} */
    margin: 0,
    /** Size of the ticks in pixels.
     * @type {number=} */
    tickSize: 4
  },
  /**
   * @typedef {object}
   */
  line: {
    /** Toggle line on/off
     * @type {boolean=} */
    show: false
  },
  /** Padding in direction perpendicular to the axis
   * @type {number=} */
  paddingStart: 0,
  /** Padding in direction perpendicular to the axis
   * @type {number=} */
  paddingEnd: 10,
  /** Set the anchoring point of the axis. Available options are `auto/left/right/bottom/top`. In `auto` the axis determines the best option. The options are restricted based on the axis orientation, a vertical axis may only anchor on `left` or `right`
   * @type {string=} */
  align: 'auto'
};

/**
 * @typedef {object} ArcSettings
 * @property {number} startAngle - Start of arc line, in radians
 * @property {number} endAngle - End of arc line, in radians
 * @property {number} radius - Radius of arc line
 */

/**
 * Continuous axis settings
 * @typedef {object}
 * @alias ComponentAxis~ContinuousSettings
 * @property {ArcSettings=} arc - Optional arc settings
 * @example
 * {
 *  type: 'axis',
 *  scale: '<name-of-linear-scale>',
 *  settings: {
 *    minorTicks: {
 *      show: false,
 *    },
 *  },
 * }
 */
const DEFAULT_CONTINUOUS_SETTINGS = {
  /**
   * @typedef {object}
   */
  labels: {
    /** Toggle labels on/off
     * @type {boolean=} */
    show: true,
    /** Space in pixels between the tick and label.
     * @type {number=} */
    margin: 4,
    /** Max length of labels in pixels
     * @type {number=} */
    maxLengthPx: 150,
    /** Min length of labels in pixels. Labels will always at least require this much space
     * @type {number=} */
    minLengthPx: 0,
    /** Align act as a slider for the text bounding rect over the item bandwidth, given that the item have a bandwidth.
     * @type {number=} */
    align: 0.5,
    /** Offset in pixels along the axis direction.
     * @type {number=} */
    offset: 0,
    /**
     * Toggle whether labels should be filtered if they are overlapping. Filtering may be applied in a non-sequential order.
     * If labels are overlapping and this setting is toggled off, the axis will automatically hide.
     * @type {boolean=}
     */
    filterOverlapping: true
  },
  /**
   * @typedef {object}
   */
  ticks: {
    /** Toggle ticks on/off
     * @type {boolean=} */
    show: true,
    /** Space in pixels between the ticks and the line.
     * @type {number=} */
    margin: 0,
    /** Size of the ticks in pixels.
     * @type {number=} */
    tickSize: 8
  },
  /**
   * @typedef {object}
   */
  minorTicks: {
    /** Toggle minor-ticks on/off
     * @type {boolean=} */
    show: false,
    /** Size of the ticks in pixels.
     * @type {number=} */
    tickSize: 3,
    /** Space in pixels between the ticks and the line.
     * @type {number=} */
    margin: 0
  },
  /**
   * @typedef {object}
   */
  line: {
    /** Toggle line on/off
     * @type {boolean=} */
    show: true
  },
  /** Padding in direction perpendicular to the axis
   * @type {number=} */
  paddingStart: 0,
  /** Padding in direction perpendicular to the axis
   * @type {number=} */
  paddingEnd: 10,
  /** Set the anchoring point of the axis. Available options are `auto/left/right/bottom/top`. In `auto` the axis determines the best option. The options are restricted based on the axis orientation, a vertical axis may only anchor on `left` or `right`
   * @type {string=} */
  align: 'auto'
};

function oppositeAlign(align) {
  switch (align) {
    case 'top':
      return 'bottom';
    case 'bottom':
      return 'top';
    case 'left':
      return 'right';
    case 'right':
      return 'left';
    default:
      return align;
  }
}
function calcRequiredSize(_ref) {
  let {
    isDiscrete,
    rect,
    formatter,
    measureText,
    scale,
    settings,
    state
  } = _ref;
  let size = 0;
  const {
    size: labelSize,
    edgeBleed,
    isToLarge
  } = getSize({
    isDiscrete,
    rect,
    formatter,
    measureText,
    scale,
    settings,
    state
  });
  size += labelSize;
  if (isToLarge) {
    return {
      size
    };
  }
  if (settings.ticks.show) {
    size += settings.ticks.margin;
    size += settings.ticks.tickSize;
  }
  if (settings.minorTicks && settings.minorTicks.show) {
    const minorTicksSize = settings.minorTicks.margin + settings.minorTicks.tickSize;
    if (minorTicksSize > size) {
      size = minorTicksSize;
    }
  }
  if (settings.line.show) {
    const halfWidth = settings.line.strokeWidth / 2;
    size += halfWidth;
    edgeBleed[oppositeAlign(settings.align)] = Math.ceil(halfWidth);
  }
  size += settings.paddingStart;
  size += settings.paddingEnd;
  return {
    size,
    edgeBleed
  };
}

function alignTransform(_ref) {
  let {
    align,
    inner
  } = _ref;
  if (align === 'left') {
    return {
      x: inner.width + inner.x
    };
  }
  if (align === 'right' || align === 'bottom') {
    return inner;
  }
  return {
    y: inner.y + inner.height
  };
}
function resolveAlign(align, dock) {
  const horizontal = ['top', 'bottom'];
  const vertical = ['left', 'right'];
  if (horizontal.indexOf(align) !== -1 && vertical.indexOf(dock) === -1) {
    return align;
  }
  if (vertical.indexOf(align) !== -1 && horizontal.indexOf(dock) === -1) {
    return align;
  }
  return dock; // Invalid align, return current dock as default
}

/**
 * @ignore
 * @param {object} context - The component context
 */
function resolveLocalSettings(_ref2) {
  let {
    state,
    style,
    settings
  } = _ref2;
  const defaultStgns = extend$1(true, {}, state.isDiscrete ? DEFAULT_DISCRETE_SETTINGS : DEFAULT_CONTINUOUS_SETTINGS, style);
  const localStgns = extend$1(true, {}, defaultStgns, settings.settings);
  const dock = settings.layout.dock || state.defaultDock;
  localStgns.dock = dock;
  localStgns.align = resolveAlign(settings.settings.align, dock);
  localStgns.labels.tiltAngle = Math.max(-90, Math.min(localStgns.labels.tiltAngle, 90));
  const {
    paddingStart,
    paddingEnd
  } = localStgns;
  localStgns.paddingStart = typeof paddingStart === 'function' ? paddingStart.call(null) : paddingStart;
  localStgns.paddingEnd = typeof paddingEnd === 'function' ? paddingEnd.call(null) : paddingEnd;
  return localStgns;
}
function updateActiveMode(state, settings, isDiscrete) {
  const mode = settings.labels.mode;
  if (!isDiscrete || !state.isHorizontal) {
    return 'horizontal';
  }
  if (mode === 'auto') {
    return state.labels.activeMode;
  }
  if (['layered', 'tilted'].indexOf(settings.labels.mode) !== -1 && ['top', 'bottom'].indexOf(settings.dock) !== -1) {
    return mode;
  }
  return 'horizontal';
}
const axisComponent = {
  require: ['chart', 'renderer', 'dockConfig'],
  defaultSettings: {
    layout: {
      displayOrder: 0,
      prioOrder: 0
    },
    settings: {},
    style: {
      labels: '$label',
      ticks: '$guide-line',
      minorTicks: '$guide-line--minor',
      line: '$guide-line'
    }
  },
  created() {
    // State is a representation of properties that are private to this component defintion and may be modified by only in this context.
    this.state = {
      isDiscrete: !!this.scale.bandwidth,
      isHorizontal: false,
      labels: {
        activeMode: 'horizontal'
      },
      ticks: [],
      innerRect: {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      },
      outerRect: {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      },
      defaultDock: undefined,
      concreteNodeBuilder: undefined,
      settings: undefined
    };
    if (this.state.isDiscrete) {
      this.state.defaultDock = 'bottom';
    } else {
      this.state.defaultDock = 'left';
    }
    this.setState(this.settings);
  },
  setState() {
    this.state.isDiscrete = !!this.scale.bandwidth;
    this.state.settings = resolveLocalSettings(this);
    this.state.concreteNodeBuilder = nodeBuilder(this.state.isDiscrete);
    this.dockConfig.dock(this.state.settings.dock); // Override the dock setting (TODO should be removed)

    this.state.isHorizontal = this.state.settings.align === 'top' || this.state.settings.align === 'bottom';
    this.state.labels.activeMode = updateActiveMode(this.state, this.state.settings, this.state.isDiscrete);
  },
  preferredSize(opts) {
    const {
      formatter,
      state,
      scale
    } = this;
    const distance = this.state.isHorizontal ? opts.inner.width : opts.inner.height;
    this.state.pxScale = scaleWithSize(scale, distance);
    const reqSize = calcRequiredSize({
      isDiscrete: this.state.isDiscrete,
      rect: {
        inner: opts.inner,
        outer: opts.outer
      },
      formatter,
      measureText: this.renderer.measureText,
      scale: this.state.pxScale,
      settings: this.state.settings,
      state
    });
    return reqSize;
  },
  beforeUpdate() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      settings
    } = opts;
    this.setState(settings);
  },
  resize(opts) {
    const {
      inner,
      outer
    } = opts;
    const extendedInner = extend$1({}, inner, alignTransform({
      align: this.state.settings.align,
      inner
    }));
    const finalOuter = outer || extendedInner;
    extend$1(this.state.innerRect, extendedInner);
    extend$1(this.state.outerRect, finalOuter);
    return outer;
  },
  beforeRender() {
    const {
      scale,
      formatter
    } = this;
    const distance = this.state.isHorizontal ? this.state.innerRect.width : this.state.innerRect.height;
    this.state.pxScale = scaleWithSize(scale, distance);
    this.state.ticks = this.state.pxScale.ticks({
      distance,
      formatter
    }).filter(t => t.position >= 0 && t.position <= 1);
  },
  render() {
    const {
      state
    } = this;
    const nodes = [];
    nodes.push(...this.state.concreteNodeBuilder.build({
      settings: this.state.settings,
      scale: this.state.pxScale,
      innerRect: this.state.innerRect,
      outerRect: this.state.outerRect,
      measureText: this.renderer.measureText,
      textBounds: this.renderer.textBounds,
      ticks: this.state.ticks,
      state
    }));
    crispifier.multiple(nodes);
    return nodes;
  }
};

const type$2 = 'axis';
function axis(picasso) {
  picasso.component(type$2, axisComponent);
}

/**
 * @typedef {object} ComponentContainer
 * @experimental
 * @extends ComponentSettings
 * @property {'container'} type component type
 * @example
 * {
 *  type: 'container',
 *  preferredSize: ({ inner, outer, dock, children }) => {
 *    const sizes = children.map(c => c.preferredSize({ inner, outer }));
 *    return Math.max(...sizes);
 *  },
 *  strategy: (rect, components) => {
 *    const height = rect.height / components.length;
 *    components.forEach((c, i) => {
 *      c.resize({ ...rect, height, y: rect.y + i * height })
 *    });
 *    return { visible: components, hidden: [], order: components };
 *  },
 *  components: [
 *     ...
 *  ],
 * }
 */

const containerComponent = {
  render() {
    return [];
  }
};

function container(picasso) {
  picasso.component('container', containerComponent);
}

function parseTitle(text, join, scale) {
  let title = '';
  if (typeof text === 'function') {
    title = text();
  } else if (typeof text === 'string') {
    title = text;
  } else if (scale) {
    let data = scale.data();
    const titles = (data.fields || []).map(field => field.title());
    title = titles.join(join);
  }
  return title;
}
function getTextAnchor(dock, anchor) {
  let val = 'middle';
  if (dock === 'left') {
    if (anchor === 'top') {
      val = 'end';
    } else if (anchor === 'bottom') {
      val = 'start';
    }
  } else if (dock === 'right') {
    if (anchor === 'top') {
      val = 'start';
    } else if (anchor === 'bottom') {
      val = 'end';
    }
  } else if (anchor === 'left') {
    val = 'start';
  } else if (anchor === 'right') {
    val = 'end';
  }
  return val;
}
function generateTitle(_ref) {
  let {
    title,
    definitionSettings,
    dock,
    rect,
    measureText,
    style
  } = _ref;
  const struct = {
    type: 'text',
    text: title,
    x: 0,
    y: 0,
    dx: 0,
    dy: 0,
    anchor: getTextAnchor(dock, definitionSettings.anchor),
    baseline: 'alphabetical',
    stroke: 'transparent',
    strokeWidth: 0,
    fontWeight: 'normal'
  };
  extend$1(struct, style.text);
  const textRect = measureText(struct);
  if (dock === 'top' || dock === 'bottom') {
    let x = rect.width / 2;
    if (definitionSettings.anchor === 'left') {
      x = definitionSettings.paddingLeft || 0;
    } else if (definitionSettings.anchor === 'right') {
      x = rect.width - (definitionSettings.paddingRight || 0);
    }
    struct.x = x;
    struct.y = dock === 'top' ? rect.height - definitionSettings.paddingStart : definitionSettings.paddingStart + textRect.height;
    struct.dy = dock === 'top' ? -(textRect.height / 6) : -(textRect.height / 3);
    struct.maxWidth = rect.width * 0.8;
  } else {
    let y = rect.height / 2;
    if (definitionSettings.anchor === 'top') {
      y = definitionSettings.paddingStart;
    } else if (definitionSettings.anchor === 'bottom') {
      y = rect.height - definitionSettings.paddingStart;
    }
    struct.y = y;
    struct.x = dock === 'left' ? rect.width - definitionSettings.paddingStart : definitionSettings.paddingStart;
    struct.dx = dock === 'left' ? -(textRect.height / 3) : textRect.height / 3;
    const rotation = dock === 'left' ? 270 : 90;
    struct.transform = "rotate(".concat(rotation, ", ").concat(struct.x + struct.dx, ", ").concat(struct.y + struct.dy, ")");
    struct.maxWidth = rect.height * 0.8;
  }
  if (!isNaN(definitionSettings.maxLengthPx)) {
    struct.maxWidth = Math.min(struct.maxWidth, definitionSettings.maxLengthPx);
  }
  return struct;
}

/**
 * @typedef {object} ComponentText
 * @extends ComponentSettings
 * @property {'text'} type component type
 * @property {string|function} text Text to display
 * @example
 * {
 *  type: 'text',
 *  text: 'my title',
 *  dock: 'left',
 *  settings: {
 *    anchor: 'left',
 *  }
 * }
 */

/**
 * @typedef {object} ComponentText.settings
 * @property {number} [paddingStart=5] - Start padding in pixels
 * @property {number} [paddingEnd=5] - End padding in pixels
 * @property {number} [paddingLeft=0] - Left padding in pixels
 * @property {number} [paddingRight=0] - Right padding in pixels
 * @property {string} [anchor='center'] - Where to v- or h-align the text. Supports `left`, `right`, `top`, `bottom` and `center`
 * @property {string} [join=', '] - String to add when joining titles from multiple sources
 * @property {number} [maxLengthPx] - Limit the text length
 */

/**
 * @typedef {object} ComponentText.style
 * @property {object} [text]
 */

/**
 * @typedef {object} ComponentText.style.text
 * @property {string} [fontSize='12px'] - Font size of text
 * @property {string} [fontFamily='Source Sans Pro'] - Font family of text
 * @property {string} [fontWeight='normal'] - Font weight of text
 * @property {string} [fill='#ffffff'] - Fill color of text
 * @property {string} [stroke='transparent'] - Stroke of text
 * @property {number} [strokeWidth=0] - Stroke width of text
 * @property {number} [opacity=1] - Opacity of text
 */
const textComponent = {
  require: ['renderer', 'chart'],
  defaultSettings: {
    layout: {
      dock: 'bottom',
      displayOrder: 0,
      prioOrder: 0
    },
    settings: {
      paddingStart: 5,
      paddingEnd: 5,
      paddingLeft: 0,
      paddingRight: 0,
      anchor: 'center',
      join: ', ',
      maxLengthPx: NaN
    },
    style: {
      text: '$title'
    }
  },
  created() {
    this.definitionSettings = this.settings.settings;
    const text = this.settings.text;
    const join = this.definitionSettings.join;
    this.title = parseTitle(text, join, this.scale);
  },
  preferredSize() {
    const height = this.renderer.measureText({
      text: this.title,
      fontSize: this.style.text.fontSize,
      fontFamily: this.style.text.fontFamily
    }).height;
    return height + this.definitionSettings.paddingStart + this.definitionSettings.paddingEnd;
  },
  render() {
    const {
      title,
      definitionSettings,
      rect
    } = this;
    const nodes = [];
    nodes.push(generateTitle({
      title,
      dock: this.settings.layout.dock,
      definitionSettings,
      rect,
      measureText: this.renderer.measureText,
      style: this.style
    }));
    return nodes;
  },
  beforeUpdate(opts) {
    if (opts.settings) {
      extend$1(this.settings, opts.settings);
      this.definitionSettings = opts.settings.settings;
    }
    const text = this.settings.text;
    const join = this.definitionSettings.join;
    this.title = parseTitle(text, join, this.scale);
  }
};

function text(picasso) {
  picasso.component('text', textComponent);
}

/**
 * @typedef {object} ComponentScrollbar
 * @extends ComponentSettings
 * @private
 */

/**
 * @typedef {object} ComponentScrollbar.settings
 * @property {boolean} [backgroundColor = '#eee']
 * @property {boolean} [thumbColor = '#ccc']
 * @property {boolean} [width = 16]
 */

function start$1(_scrollbar, pos) {
  const dock = _scrollbar.settings.layout.dock;
  const invert = _scrollbar.settings.settings.invert;
  const horizontal = dock === 'top' || dock === 'bottom';
  const lengthAttr = horizontal ? 'width' : 'height';
  const length = _scrollbar.rect[lengthAttr];
  const scroll = _scrollbar.chart.scroll(_scrollbar.settings.scroll);
  let currentMove;
  {
    // local scope to allow reuse of variable names later
    let offset = pos[horizontal ? 'x' : 'y'];
    if (invert) {
      offset = length - offset;
    }
    const scrollState = scroll.getState();
    currentMove = {
      startOffset: offset,
      startScroll: scrollState.start,
      swipe: false
    };

    // Detect swipe start outsize the thumb & change startScroll to jump the scroll there.
    const scrollPoint = offset / length * (scrollState.max - scrollState.min) + scrollState.min;
    if (scrollPoint < scrollState.start) {
      currentMove.startScroll = scrollPoint;
    } else if (scrollPoint > scrollState.start + scrollState.viewSize) {
      currentMove.startScroll = scrollPoint - scrollState.viewSize;
    }
  }
  const update = p => {
    let offset = p[horizontal ? 'x' : 'y'];
    if (invert) {
      offset = length - offset;
    }
    if (!currentMove.swipe) {
      if (Math.abs(currentMove.startOffset - offset) <= 1) {
        return;
      }
      currentMove.swipe = true;
    }
    const scrollState = scroll.getState();
    const scrollMove = (offset - currentMove.startOffset) / length * (scrollState.max - scrollState.min);
    const scrollStart = currentMove.startScroll + scrollMove;
    scroll.moveTo(scrollStart);
  };
  const end = p => {
    let offset = p[horizontal ? 'x' : 'y'];
    if (invert) {
      offset = length - offset;
    }
    const scrollState = scroll.getState();
    if (currentMove.swipe) {
      const scrollMove = (offset - currentMove.startOffset) / length * (scrollState.max - scrollState.min);
      const scrollStart = currentMove.startScroll + scrollMove;
      scroll.moveTo(scrollStart);
    } else {
      const scrollCenter = offset / length * (scrollState.max - scrollState.min) + scrollState.min;
      const scrollStart = scrollCenter - scrollState.viewSize / 2;
      scroll.moveTo(scrollStart);
    }
  };
  return {
    update,
    end
  };
}
function getLocalPos(event, renderer) {
  const containerRect = renderer.element().getBoundingClientRect();
  return {
    x: event.center.x - containerRect.left,
    y: event.center.y - containerRect.top
  };
}
const scrollbarComponent = {
  require: ['chart', 'renderer'],
  on: {
    panStart(event) {
      const pos = getLocalPos(event, this.renderer);
      const startPos = {
        x: pos.x - event.deltaX,
        y: pos.y - event.deltaY
      };
      this.currentMove = start$1(this, startPos);
      this.currentMove.update(pos);
    },
    panMove(event) {
      if (!this.currentMove) {
        return;
      }
      const pos = getLocalPos(event, this.renderer);
      this.currentMove.update(pos);
    },
    panEnd(event) {
      if (!this.currentMove) {
        return;
      }
      const pos = getLocalPos(event, this.renderer);
      this.currentMove.end(pos);
      this.currentMove = null;
    },
    panCancel() {
      this.currentMove = null;
    },
    tap(event) {
      const pos = getLocalPos(event, this.renderer);
      const move = start$1(this, pos);
      move.end(pos);
    }
  },
  defaultSettings: {
    settings: {
      backgroundColor: '#eee',
      thumbColor: '#ccc',
      width: 16 // 32 for touch
    }
  },
  preferredSize: function preferredSize(rect) {
    const scrollState = this.chart.scroll(this.settings.scroll).getState();
    // hide the scrollbar if it is not possible to scroll
    if (scrollState.viewSize >= scrollState.max - scrollState.min) {
      const toLargeSize = Math.max(rect.width, rect.height);
      return toLargeSize;
    }
    return this.settings.settings.width;
  },
  render: function render(h) {
    const dock = this.settings.layout.dock;
    const invert = this.settings.settings.invert;
    const horizontal = dock === 'top' || dock === 'bottom';
    const lengthAttr = horizontal ? 'width' : 'height';
    const _rect = this.rect;
    const length = _rect[lengthAttr];
    const scrollState = this.chart.scroll(this.settings.scroll).getState();
    let thumbStart = length * (scrollState.start - scrollState.min) / (scrollState.max - scrollState.min);
    const thumbRange = length * scrollState.viewSize / (scrollState.max - scrollState.min);
    if (invert) {
      thumbStart = length - thumbStart - thumbRange;
    }
    return h('div', {
      style: {
        position: 'relative',
        width: '100%',
        height: '100%',
        background: this.settings.settings.backgroundColor,
        pointerEvents: 'auto'
      }
    }, [].concat(h('div', {
      class: 'scroller',
      style: {
        position: 'absolute',
        [horizontal ? 'left' : 'top']: "".concat(thumbStart, "px"),
        [horizontal ? 'top' : 'left']: '25%',
        [horizontal ? 'height' : 'width']: '50%',
        // ${width}px
        [lengthAttr]: "".concat(Math.max(1, thumbRange), "px"),
        background: this.settings.settings.thumbColor
      }
    })));
  },
  renderer: 'dom'
};
function scrollbar(picasso) {
  picasso.component('scrollbar', scrollbarComponent);
}

const TARGET_SIZE = 5;
const VERTICAL = 0;
const HORIZONTAL = 1;

function buildLine(_ref) {
  let {
    h,
    isVertical,
    value,
    pos,
    align,
    borderHit,
    state,
    idx
  } = _ref;
  const isAlignStart = align !== 'end';
  const alignStart = {
    left: '0',
    top: '0'
  };
  const alignEnd = {
    right: '0',
    bottom: '0'
  };
  const alignStyle = isAlignStart ? alignStart : alignEnd;
  let start = 0;
  let width = '100%';
  let height = '100%';
  if (state.targetRect && state.settings.bubbles.align === 'start') {
    width = "".concat(state.targetRect.x + state.targetRect.width, "px");
    height = "".concat(state.targetRect.y + state.targetRect.height, "px");
  } else if (state.targetRect && state.settings.bubbles.align === 'end') {
    start = isVertical ? state.targetRect.x : state.targetRect.y;
    width = "".concat(state.rect.width - start, "px");
    height = "".concat(state.rect.height - start, "px");
  }
  if (!isAlignStart) {
    pos -= borderHit;
  }

  // edge
  return h('div', {
    onmouseover(e) {
      e.srcElement.children[0].style.backgroundColor = '#000';
      e.srcElement.children[0].style[isVertical ? 'height' : 'width'] = '2px';
    },
    onmouseout(e) {
      e.srcElement.children[0].style.backgroundColor = state.style.line.stroke;
      e.srcElement.children[0].style[isVertical ? 'height' : 'width'] = '1px';
    },
    'data-value': value,
    'data-key': [state.key, 'edge', idx].join('-'),
    style: {
      cursor: isVertical ? 'ns-resize' : 'ew-resize',
      position: 'absolute',
      left: isVertical ? "".concat(start, "px") : "".concat(pos, "px"),
      top: isVertical ? "".concat(pos, "px") : "".concat(start, "px"),
      height: isVertical ? "".concat(borderHit, "px") : height,
      width: isVertical ? width : "".concat(borderHit, "px"),
      pointerEvents: 'auto'
    }
  }, [
  // line
  h('div', {
    style: extend$1({
      backgroundColor: state.style.line.stroke,
      position: 'absolute',
      height: isVertical ? "".concat(1, "px") : '100%',
      width: isVertical ? '100%' : "".concat(1, "px"),
      pointerEvents: 'none'
    }, alignStyle)
  })]);
}
function buildBubble(_ref2) {
  let {
    h,
    isVertical,
    label,
    otherValue,
    rangeIdx,
    idx,
    pos,
    align,
    state,
    value
  } = _ref2;
  const isAlignStart = align !== 'end';
  const isOutside = state.settings.bubbles.placement === 'outside';
  let outside = 'none';
  let bubbleDock;
  if (isVertical) {
    bubbleDock = isAlignStart ? 'left' : 'right';
    if (isOutside) {
      outside = isAlignStart ? 'translate(-100%,  0px)' : 'translate(100%,  0px)';
    }
  } else {
    bubbleDock = isAlignStart ? 'top' : 'bottom';
    if (isOutside) {
      outside = isAlignStart ? 'translate(0px, -100%)' : 'translate(0px,  100%)';
    }
  }
  let inEdit = state.edit && state.edit.rangeIdx === rangeIdx && state.edit.bubbleIdx === idx;
  const bubbleStyle = {
    position: 'relative',
    borderRadius: "".concat(state.style.bubble.borderRadius, "px"),
    border: "".concat(state.style.bubble.strokeWidth, "px solid ").concat(state.style.bubble.stroke),
    backgroundColor: state.style.bubble.fill,
    color: state.style.bubble.color,
    fontFamily: state.style.bubble.fontFamily,
    fontSize: state.style.bubble.fontSize,
    padding: '4px 8px',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '150px',
    minWidth: '50px',
    minHeight: '1em',
    pointerEvents: 'auto',
    transform: isVertical ? 'translate(0,-50%)' : 'translate(-50%,0)',
    cursor: isVertical ? 'ns-resize' : 'ew-resize'
  };
  let currentBorderColor = state.style.bubble.stroke;
  const bubble = inEdit ? h('input', {
    type: 'text',
    value,
    style: _objectSpread2(_objectSpread2({}, bubbleStyle), {}, {
      textAlign: 'start',
      textOverflow: '',
      fontSize: '13px' // TODO - make it styleable
    }),
    onkeyup(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        const newValue = parseFloat(e.target.value);
        if (isNaN(newValue)) {
          currentBorderColor = 'rgba(230, 78, 78, 0.6)';
          e.target.style.border = "".concat(state.style.bubble.strokeWidth, "px solid ").concat(currentBorderColor);
        } else {
          state.onEditConfirmed(rangeIdx, newValue, otherValue);
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        state.onEditCanceled();
      }
    }
  }) : h('div', {
    'data-key': [state.key, 'bubble', rangeIdx, idx].join('-'),
    'data-other-value': otherValue,
    'data-idx': rangeIdx,
    'data-bidx': idx,
    style: bubbleStyle
  }, [label]);

  // bubble wrapper
  return h('div', {
    style: {
      position: 'absolute',
      [bubbleDock]: '0',
      [isVertical ? 'top' : 'left']: "".concat(pos, "px"),
      transform: outside
    }
  }, [
  // bubble
  bubble]);
}
function buildArea(_ref3) {
  let {
    h,
    isVertical,
    top,
    height,
    color,
    on,
    opacity
  } = _ref3;
  return h('div', extend$1({
    style: {
      backgroundColor: color,
      opacity,
      position: 'absolute',
      left: isVertical ? 0 : "".concat(top, "px"),
      top: isVertical ? "".concat(top, "px") : 0,
      height: isVertical ? "".concat(height, "px") : '100%',
      width: isVertical ? '100%' : "".concat(height, "px"),
      pointerEvents: 'auto'
    }
  }, on), []);
}
function buildRange(_ref4) {
  let {
    borderHit,
    els,
    isVertical,
    state,
    vStart,
    vEnd,
    idx
  } = _ref4;
  let targetOffset = 0;
  if (state.targetRect) {
    targetOffset = isVertical ? state.targetRect.y : state.targetRect.x;
  }
  const hasScale = !!state.scale;
  const start = hasScale ? state.scale.norm(vStart) * state.size : vStart;
  const end = hasScale ? state.scale.norm(vEnd) * state.size : vEnd;
  const height = Math.abs(start - end);
  const top = Math.min(start, end) + targetOffset;
  const bottom = top + height;
  if (state.targetRect) {
    const target = state.targetFillRect || state.targetRect;
    const targetSize = isVertical ? target.height : target.width;
    const targetStart = hasScale ? state.scale.norm(vStart) * targetSize : vStart;
    const targetEnd = hasScale ? state.scale.norm(vEnd) * targetSize : vEnd;
    const targetHeight = Math.abs(targetStart - targetEnd);
    const targetTop = Math.min(targetStart, targetEnd);
    const targetArea = {
      h: state.h,
      isVertical,
      top: targetTop,
      height: targetHeight,
      color: state.style.target.fill,
      opacity: state.style.target.opacity
    };
    if (state.style.target.opacity < 0.8) {
      targetArea.on = {
        onmouseover(e) {
          e.srcElement.style.opacity = state.style.target.opacity + 0.1;
        },
        onmouseout(e) {
          e.srcElement.style.opacity = state.style.target.opacity;
        }
      };
    }
    els.push(state.h('div', {
      style: {
        position: 'absolute',
        left: "".concat(target.x, "px"),
        top: "".concat(target.y, "px"),
        height: "".concat(target.height, "px"),
        width: "".concat(target.width, "px")
      }
    }, [buildArea(targetArea)]));
  }

  // active range area
  // els.push(buildArea({
  //   h: state.h,
  //   isVertical,
  //   top,
  //   height,
  //   color: state.settings.fill
  // }));

  const valStart = start < end ? vStart : vEnd;
  const valEnd = start < end ? vEnd : vStart;
  const [min, max] = hasScale ? state.scale.domain() : [Math.min(vStart, vEnd), Math.max(vStart, vEnd)];
  const isStartVisible = valStart + 1e-5 >= min && valStart - 1e-5 <= max; // accept minor floating point difference
  const isEndVisible = valEnd - 1e-5 <= max && valEnd + 1e-5 >= min;
  if (isStartVisible) {
    els.push(buildLine({
      h: state.h,
      isVertical,
      borderHit,
      value: valStart,
      pos: top,
      align: 'start',
      state,
      idx
    }));
  }
  if (isEndVisible) {
    els.push(buildLine({
      h: state.h,
      isVertical,
      borderHit,
      value: valEnd,
      pos: bottom,
      align: 'end',
      state,
      idx
    }));
  }
  const bubbles = state.settings.bubbles;
  if (bubbles && bubbles.show) {
    const fontSize = bubbles.fontSize;
    const fontFamily = bubbles.fontFamily;
    const fill = bubbles.fill;
    const style = {
      fontSize,
      fontFamily,
      color: fill
    };
    const range = [vStart, vEnd];
    if (isStartVisible) {
      els.push(buildBubble({
        h: state.h,
        isVertical,
        align: bubbles.align,
        style,
        rangeIdx: idx,
        idx: 0,
        otherValue: valEnd,
        value: valStart,
        label: "".concat(state.format(valStart, range)),
        pos: top,
        state
      }));
    }
    if (isEndVisible) {
      els.push(buildBubble({
        h: state.h,
        isVertical,
        align: bubbles.align,
        style,
        rangeIdx: idx,
        idx: 1,
        otherValue: valStart,
        value: valEnd,
        label: "".concat(state.format(valEnd, range)),
        pos: bottom,
        state
      }));
    }
  }
}
function getMoveDelta(state) {
  const posDelta = state.active.limitHigh - state.active.end;
  const negDelta = state.active.limitLow - state.active.start;
  let delta = state.current - state.start;
  if (delta < 0) {
    delta = Math.max(delta, negDelta);
  } else {
    delta = Math.min(delta, posDelta);
  }
  return delta;
}
function nodes(state) {
  let els = [];
  const isVertical = state.direction === VERTICAL;
  if (Array.isArray(state.ranges)) {
    // add all other ranges
    state.ranges.forEach((r, i) => {
      if (!state.active || i !== state.active.idx) {
        buildRange({
          borderHit: TARGET_SIZE,
          els,
          isVertical,
          state,
          vStart: Math.min(r.min, r.max),
          vEnd: Math.max(r.min, r.max),
          idx: i
        });
      }
    });
  }
  if (state.active) {
    // add active range
    let vStart = state.start;
    let vEnd = state.current;
    if (state.active.idx !== -1) {
      if (state.active.mode === 'foo') {
        vStart = Math.min(state.active.start, state.active.end);
        vEnd = Math.max(state.active.start, state.active.end);
      } else if (state.active.mode === 'modify') {
        vStart = Math.min(state.start, state.current);
        vEnd = Math.max(state.start, state.current);
      } else {
        const delta = getMoveDelta(state);
        vStart = state.active.start + delta;
        vEnd = state.active.end + delta;
      }
    }
    buildRange({
      borderHit: TARGET_SIZE,
      els,
      isVertical,
      state,
      vStart,
      vEnd,
      idx: state.active.idx
    });
  }
  return els;
}

function rangelimits(state) {
  return {
    min: state.scale.min(),
    max: state.scale.max()
  };
}
function areaLimits(state) {
  return {
    min: 0,
    max: state.direction ? state.rect.width : state.rect.height
  };
}
function findActive(state, value, limits) {
  let rs = state.ranges;
  let i;
  let activeIdx = -1;
  for (i = 0; i < rs.length; i++) {
    if (rs[i].min <= value && value <= rs[i].max) {
      activeIdx = i;
      limits.min = i ? rs[i - 1].max : limits.min;
      limits.max = i + 1 < rs.length ? rs[i + 1].min : limits.max;
      break;
    } else if (value < rs[i].min) {
      limits.max = rs[i].min;
      limits.min = i ? rs[i - 1].max : limits.min;
      break;
    }
  }
  if (activeIdx === -1 && rs.length && i >= rs.length) {
    limits.min = rs[rs.length - 1].max;
  }
  let activeRange;
  if (activeIdx !== -1) {
    activeRange = {
      idx: activeIdx,
      start: rs[activeIdx].min,
      end: rs[activeIdx].max,
      limitLow: limits.min,
      limitHigh: limits.max,
      mode: 'foo'
    };
  }
  state.active = activeRange;
}
function startArea(_ref) {
  let {
    state,
    e,
    renderer,
    ranges,
    targetSize
  } = _ref;
  if (state.started) {
    return;
  }
  const x = e.center.x - e.deltaX;
  const y = e.center.y - e.deltaY;
  let target = document.elementFromPoint(x, y);
  if (!renderer.element().contains(target)) {
    target = null;
  }
  const tempState = {
    started: true
  };
  state.offset = renderer.element().getBoundingClientRect();
  state.ranges = ranges(state);
  const relX = x - state.offset.left; // coordinate relative renderer
  const relY = y - state.offset.top;
  const startPoint = e.center[state.cssCoord.coord] - e[state.cssCoord.pos] - state.offset[state.cssCoord.offset];
  const relStart = e.center[state.cssCoord.coord] - state.offset[state.cssCoord.offset];
  let v = relStart;
  let vStart = startPoint;
  tempState.start = startPoint;
  tempState.current = relStart;
  let rs = state.ranges;
  const limits = areaLimits(state);
  let i;
  let activeIdx = -1;
  if (target && target.hasAttribute('data-idx')) {
    activeIdx = parseInt(target.getAttribute('data-idx'), 10);
    limits.min = activeIdx > 0 ? rs[activeIdx - 1].max : limits.min;
    limits.max = activeIdx + 1 < rs.length ? rs[activeIdx + 1].min : limits.max;
  } else {
    for (i = 0; i < rs.length; i++) {
      if (rs[i].min <= vStart && vStart <= rs[i].max) {
        activeIdx = i;
        limits.min = i ? rs[i - 1].max : limits.min;
        limits.max = i + 1 < rs.length ? rs[i + 1].min : limits.max;
        break;
      } else if (vStart < rs[i].min) {
        limits.max = rs[i].min;
        limits.min = i ? rs[i - 1].max : limits.min;
        break;
      }
    }
    if (activeIdx === -1 && rs.length && i >= rs.length) {
      limits.min = rs[rs.length - 1].max;
    }
  }
  if (activeIdx === -1 && !state.multi) {
    tempState.ranges = [];
    limits.min = 0;
    limits.max = state.direction ? state.rect.width : state.rect.height;
  }
  let activeRange;
  if (activeIdx !== -1) {
    activeRange = {
      idx: activeIdx,
      start: rs[activeIdx].min,
      end: rs[activeIdx].max,
      limitLow: limits.min,
      limitHigh: limits.max,
      mode: 'move'
    };
    if (target && target.hasAttribute('data-other-value')) {
      tempState.start = parseFloat(target.getAttribute('data-other-value'));
      activeRange.mode = 'modify';
    } else {
      let pxStart = activeRange.start;
      let pxEnd = activeRange.end;
      if (Math.abs(startPoint - pxStart) <= targetSize) {
        tempState.start = activeRange.end;
        activeRange.mode = 'modify';
      } else if (Math.abs(startPoint - pxEnd) <= targetSize) {
        tempState.start = activeRange.start;
        activeRange.mode = 'modify';
      }
    }
  } else {
    activeRange = {
      idx: -1,
      start: vStart,
      end: v,
      limitLow: limits.min,
      limitHigh: limits.max,
      mode: 'current'
    };
  }
  tempState.active = activeRange;
  if (activeRange.mode !== 'modify' && state.targetRect && !testRectPoint(state.targetRect, {
    x: relX,
    y: relY
  })) ; else {
    Object.keys(tempState).forEach(key => state[key] = tempState[key]);
  }
}
function start(_ref2) {
  let {
    state,
    e,
    renderer,
    ranges,
    targetSize
  } = _ref2;
  if (state.started) {
    return;
  }
  state.edit = null;
  const x = e.center.x - e.deltaX;
  const y = e.center.y - e.deltaY;
  let target = document.elementFromPoint(x, y);
  if (!renderer.element().contains(target)) {
    target = null;
  }
  const tempState = {
    started: true
  };
  state.offset = extend$1({}, renderer.element().getBoundingClientRect());
  const relX = x - state.offset.left; // coordinate relative renderer
  const relY = y - state.offset.top;
  state.offset.left += state.targetRect ? state.targetRect.x : 0; // make offset relative to targetRect
  state.offset.top += state.targetRect ? state.targetRect.y : 0;
  state.ranges = ranges(state, state.fauxBrushInstance || state.brushInstance);
  const startPoint = e.center[state.cssCoord.coord] - e[state.cssCoord.pos] - state.offset[state.cssCoord.offset];
  const relStart = e.center[state.cssCoord.coord] - state.offset[state.cssCoord.offset];
  tempState.current = state.scale.normInvert(relStart / state.size);
  tempState.start = state.scale.normInvert(startPoint / state.size);
  let rs = state.ranges;
  const limits = rangelimits(state);
  let i;
  let activeIdx = -1;
  if (target && target.hasAttribute('data-idx')) {
    activeIdx = parseInt(target.getAttribute('data-idx'), 10);
    limits.min = activeIdx > 0 ? rs[activeIdx - 1].max : limits.min;
    limits.max = activeIdx + 1 < rs.length ? rs[activeIdx + 1].min : limits.max;
  } else {
    for (i = 0; i < rs.length; i++) {
      if (rs[i].min <= tempState.start && tempState.start <= rs[i].max) {
        activeIdx = i;
        limits.min = i ? rs[i - 1].max : limits.min;
        limits.max = i + 1 < rs.length ? rs[i + 1].min : limits.max;
        break;
      } else if (tempState.start < rs[i].min) {
        limits.max = rs[i].min;
        limits.min = i ? rs[i - 1].max : limits.min;
        break;
      }
    }
    if (activeIdx === -1 && rs.length && i >= rs.length) {
      limits.min = rs[rs.length - 1].max;
    }
  }
  if (activeIdx === -1 && !state.multi) {
    tempState.ranges = [];
    limits.min = state.scale.min();
    limits.max = state.scale.max();
  }
  let activeRange;
  if (activeIdx !== -1) {
    activeRange = {
      idx: activeIdx,
      start: rs[activeIdx].min,
      end: rs[activeIdx].max,
      limitLow: limits.min,
      limitHigh: limits.max,
      mode: 'move'
    };
    if (target && target.hasAttribute('data-other-value')) {
      tempState.start = parseFloat(target.getAttribute('data-other-value'));
      activeRange.mode = 'modify';
    } else {
      let pxStart = state.scale.norm(activeRange.start) * state.size;
      let pxEnd = state.scale.norm(activeRange.end) * state.size;
      if (Math.abs(startPoint - pxStart) <= targetSize) {
        tempState.start = activeRange.end;
        activeRange.mode = 'modify';
      } else if (Math.abs(startPoint - pxEnd) <= targetSize) {
        tempState.start = activeRange.start;
        activeRange.mode = 'modify';
      }
    }
  } else {
    activeRange = {
      idx: -1,
      start: tempState.start,
      end: tempState.current,
      limitLow: limits.min,
      limitHigh: limits.max,
      mode: 'current'
    };
  }
  tempState.active = activeRange;
  if (activeRange.mode !== 'modify' && state.targetRect && !testRectPoint(state.targetRect, {
    x: relX,
    y: relY
  })) ; else {
    Object.keys(tempState).forEach(key => state[key] = tempState[key]);
  }
}
function end(state, ranges) {
  state.started = false;
  state.ranges = ranges(state, state.fauxBrushInstance || state.brushInstance);
  const limits = rangelimits(state);
  findActive(state, state.current, limits);
}
function endArea(state, ranges) {
  state.started = false;
  state.ranges = ranges(state);
  const limits = areaLimits(state);
  findActive(state, state.current, limits);
}
function move(state, e) {
  const relY = e.center[state.cssCoord.coord] - state.offset[state.cssCoord.offset];
  const rel = relY / state.size;
  const v = state.scale.normInvert(rel);
  state.current = Math.max(Math.min(v, state.active.limitHigh), state.active.limitLow);
}
function moveArea(state, e) {
  const rel = e.center[state.cssCoord.coord] - state.offset[state.cssCoord.offset];
  state.current = Math.max(Math.min(rel, state.active.limitHigh), state.active.limitLow);
}

function render$c(state) {
  state.renderer.render(nodes(state));
}
function ranges$2(state, brush) {
  if (!brush || !brush.isActive()) {
    return [];
  }
  const sourceData = state.scale.data();
  const sourceFields = sourceData ? sourceData.fields || [] : [];
  const sources = sourceFields.map(field => field.id());
  const rangeBrush = brush.brushes().filter(f => f.type === 'range' && sources.indexOf(f.id) !== -1)[0];
  if (!rangeBrush) {
    return [];
  }
  return rangeBrush.brush.ranges();
}
function setRanges$1(state) {
  let rs = state.ranges.map(r => ({
    min: r.min,
    max: r.max
  }));
  if (state.active.idx !== -1) {
    if (state.active.mode === 'modify') {
      rs[state.active.idx].min = Math.min(state.start, state.current);
      rs[state.active.idx].max = Math.max(state.start, state.current);
    } else {
      const delta = getMoveDelta(state);
      rs[state.active.idx].min += delta;
      rs[state.active.idx].max += delta;
    }
  } else {
    rs.push({
      min: Math.min(state.start, state.current),
      max: Math.max(state.start, state.current)
    });
  }
  const scaleData = state.scale.data();
  if (scaleData && scaleData.fields) {
    scaleData.fields.forEach(field => {
      if (state.fauxBrushInstance) {
        let ordRS = ranges$2(state, state.fauxBrushInstance);
        let oldValues = state.findValues(ordRS);
        let values = state.findValues(rs);
        let addedValues = values.filter(v => oldValues.indexOf(v) === -1);
        let removedValues = oldValues.filter(v => values.indexOf(v) === -1);
        let addItems = addedValues.map(v => ({
          key: field.id(),
          value: v
        }));
        let removeItems = removedValues.map(v => ({
          key: field.id(),
          value: v
        }));
        state.brushInstance.addAndRemoveValues(addItems, removeItems);
        state.fauxBrushInstance.setRange(field.id(), rs);
      } else {
        state.brushInstance.setRange(field.id(), rs);
      }
    });
  }
}
function setEditedRanges(state, idx, startValue, endValue) {
  let rs = state.ranges.map(r => ({
    min: r.min,
    max: r.max
  }));
  const limitMin = state.scale.min();
  const limitMax = state.scale.max();
  rs[idx] = {
    min: Math.max(limitMin, Math.min(startValue, endValue)),
    max: Math.min(limitMax, Math.max(startValue, endValue))
  };
  state.ranges[idx] = _objectSpread2({}, rs[idx]);
  const scaleData = state.scale.data();
  if (scaleData && scaleData.fields) {
    scaleData.fields.forEach(field => {
      if (!state.fauxBrushInstance) {
        state.brushInstance.setRange(field.id(), rs);
      }
    });
  }
}
function findClosest(value, scale) {
  let name;
  let minDist = Infinity;
  const domain = scale.domain();
  const halfBandwidth = scale.bandwidth() / 2;
  for (let i = 0; i < domain.length; ++i) {
    const d = Math.abs(value - halfBandwidth - scale(domain[i]));
    if (d < minDist) {
      minDist = d;
      name = domain[i];
    }
  }
  return name;
}
function findClosestLabel(value, scale) {
  const ticks = scale.ticks();
  const idx = scale.domain().indexOf(findClosest(value, scale));
  return idx !== -1 ? ticks[idx].label : '-';
}
function rangesOverlap(r1, r2) {
  return Math.min(...r1) <= Math.max(...r2) && Math.max(...r1) >= Math.min(...r2);
}
function findValues(rangesValues, scale) {
  const domain = scale.domain();
  const scaleRange = scale.range();
  const values = [];
  rangesValues.forEach(range => {
    if (!rangesOverlap(scaleRange, [range.min, range.max])) {
      return;
    }
    const startIdx = domain.indexOf(findClosest(range.min, scale));
    const endIdx = domain.indexOf(findClosest(range.max, scale));
    values.push.apply(values, domain.slice(Math.min(startIdx, endIdx), Math.max(startIdx, endIdx) + 1)); /* eslint prefer-spread:0 */
  });
  return values;
}
function resolveNodeBounds(targetNodes) {
  const points = targetNodes.reduce((ary, node) => {
    ary.push(...rectToPoints(node.bounds));
    return ary;
  }, []);
  return pointsToRect(points);
}
function resolveTarget(ctx) {
  const resolved = {
    targetRect: null,
    targetFillRect: null,
    scale: null,
    size: null
  };
  const stngs = ctx.settings.settings;
  const targets = stngs.target && (stngs.target.components || (stngs.target.component ? [stngs.target.component] : [])).map(c => ctx.chart.component(c)).filter(c => !!c && !!c.rect);
  const targetNodes = stngs.target && stngs.target.selector ? ctx.chart.findShapes(stngs.target.selector) : [];
  const targetFillNodes = stngs.target && stngs.target.fillSelector ? ctx.chart.findShapes(stngs.target.fillSelector) : [];
  if (targetNodes.length > 0) {
    const bounds = resolveNodeBounds(targetNodes);
    resolved.size = bounds[ctx.state.direction === VERTICAL ? 'height' : 'width'];
    resolved.scale = scaleWithSize(ctx.chart.scale(stngs.scale), resolved.size);
    resolved.targetRect = bounds;
    if (targetFillNodes.length > 0) {
      const fillBounds = resolveNodeBounds(targetFillNodes);
      resolved.targetFillRect = fillBounds;
    }
  } else if (targets && targets.length > 0) {
    const targetRect = targets.slice(1).reduce((prev, curr) => ({
      x0: Math.min(prev.x0, curr.rect.computedInner.x),
      y0: Math.min(prev.y0, curr.rect.computedInner.y),
      x1: Math.max(prev.x1, curr.rect.computedInner.x + curr.rect.computedInner.width),
      y1: Math.max(prev.y1, curr.rect.computedInner.y + curr.rect.computedInner.height)
    }), {
      x0: targets[0].rect.computedInner.x,
      y0: targets[0].rect.computedInner.y,
      x1: targets[0].rect.computedInner.x + targets[0].rect.computedInner.width,
      y1: targets[0].rect.computedInner.y + targets[0].rect.computedInner.height
    });
    resolved.targetRect = {
      x: targetRect.x0 - ctx.state.rect.x,
      y: targetRect.y0 - ctx.state.rect.y,
      width: targetRect.x1 - targetRect.x0,
      height: targetRect.y1 - targetRect.y0
    };
  }
  return resolved;
}

/**
 * @typedef {object} ComponentBrushRange.settings
 * @property {string|object} brush - Brush context to apply changes to
 * @property {string} scale - Scale to extract data from
 * @property {string} [direction=vertical] - Rendering direction [horizontal|vertical]
 * @property {object} [bubbles]
 * @property {boolean} [bubbles.show=true] - True to show label bubble, false otherwise
 * @property {string} [bubbles.align=start] - Where to anchor bubble [start|end]
 * @property {function} [bubbles.label] - Callback function for the labels
 * @property {object} [target]
 * @property {string[]} [target.components] - Render matching overlay on target components
 * @property {string} [target.selector] - Instead of targeting a component, target one or more shapes
 * @property {string} [target.fillSelector] - Target a subset of the selector as fill area. Only applicable if `selector` property is set
 */

/**
 * @private
 * @typedef {object} ComponentBrushRangeStyle
 * @property {object} [bubble]
 * @property {string} [bubble.fontSize]
 * @property {string} [bubble.fontFamily]
 * @property {string} [bubble.fill]
 * @property {string} [bubble.color]
 * @property {string} [bubble.stroke]
 * @property {number} [bubble.strokeWidth]
 * @property {number} [bubble.borderRadius]
 * @property {object} [line]
 * @property {string} [line.stroke]
 * @property {number} [line.strokeWidth]
 * @property {object} [target]
 * @property {string} [target.fill]
 * @property {number} [target.strokeWidth]
 * @property {number} [target.opacity]
 */

const brushRangeComponent = {
  require: ['chart', 'settings', 'renderer'],
  defaultSettings: {
    settings: {
      bubbles: {
        show: true,
        align: 'start'
      }
    },
    style: {
      bubble: '$label-overlay',
      line: '$shape-guide--inverted',
      target: '$selection-area-target'
    }
  },
  renderer: 'dom',
  on: {
    rangeStart(e) {
      this.start(e);
    },
    rangeMove(e) {
      this.move(e);
    },
    rangeEnd(e) {
      this.end(e);
    },
    rangeClear(e) {
      this.clear(e);
    },
    bubbleStart(e) {
      this.bubbleStart(e);
    }
  },
  created() {
    this.state = {
      key: this.settings.key || 'brush-range'
    };
  },
  beforeRender(opts) {
    this.state.rect = opts.size.computedInner;
  },
  renderRanges() {
    if (!this.state.started) {
      this.state.ranges = ranges$2(this.state, this.state.brushInstance);
      this.state.active = null;
      render$c(this.state);
    }
  },
  render(h) {
    const stngs = this.settings.settings;
    this.state.direction = stngs.direction === 'vertical' ? VERTICAL : HORIZONTAL;
    const offset = this.renderer.element().getBoundingClientRect();
    const size = this.state.rect[this.state.direction === VERTICAL ? 'height' : 'width'];
    let scale = scaleWithSize(this.chart.scale(stngs.scale), size);
    const target = resolveTarget(this);
    scale = target.scale ? target.scale : scale;
    this.state.targetRect = target.targetRect;
    this.state.targetFillRect = target.targetFillRect;
    this.state.size = target.size === null ? size : target.size;
    this.state.settings = stngs;
    this.state.style = this.style;
    this.state.offset = offset;
    this.state.brush = typeof stngs.brush === 'object' ? stngs.brush.context : stngs.brush;
    this.state.brushInstance = this.chart.brush(this.state.brush);
    this.state.renderer = this.renderer;
    this.state.multi = !!stngs.multiple;
    this.state.h = h;
    this.state.onEditConfirmed = (rangeIdx, value, otherValue) => {
      this.state.edit = null;
      setEditedRanges(this.state, rangeIdx, value, otherValue);
      this.emit('bubbleEnd');
      render$c(this.state);
    };
    this.state.onEditCanceled = () => {
      this.state.edit = null;
      render$c(this.state);
    };
    this.state.cssCoord = {
      offset: this.state.direction === VERTICAL ? 'top' : 'left',
      coord: this.state.direction === VERTICAL ? 'y' : 'x',
      pos: this.state.direction === VERTICAL ? 'deltaY' : 'deltaX'
    };
    this.state.format = typeof stngs.bubbles.label === 'function' ? (v, r) => stngs.bubbles.label.call(undefined, {
      datum: v,
      data: r,
      scale,
      resources: {
        scale: this.chart.scale,
        formatter: this.chart.formatter
      }
    }) : false;
    if (!{}.hasOwnProperty.call(scale, 'norm')) {
      // Non-linear scale if norm method is unavailable
      this.state.editable = false;
      this.state.scale = scaleLinear();
      this.state.scale.data = scale.data;
      if (!this.state.format) {
        this.state.format = (v, r) => {
          if (!rangesOverlap(scale.range(), r)) {
            return '-';
          }
          return findClosestLabel(v, scale);
        };
      }
      this.state.fauxBrushInstance = brush();
      this.state.findValues = valueRanges => findValues(valueRanges, scale);
    } else {
      this.state.editable = true;
      this.state.observeBrush = typeof stngs.brush === 'object' ? stngs.brush.observe : false;
      this.state.fauxBrushInstance = null;
      this.state.findValues = null;
      this.state.scale = scale;
      const scaleData = this.state.scale.data();
      if (!this.state.format && scaleData && scaleData.fields && scaleData.fields[0]) {
        this.state.format = scaleData.fields[0].formatter();
      }
    }
    this.state.ranges = ranges$2(this.state, this.state.brushInstance);
    return this.state.observeBrush || this.state.sourcedFromThisComponent ? [nodes(this.state)] : [];
  },
  mounted() {
    if (this.state.observeBrush && this.state.brushInstance) {
      this.state.brushInstance.on('update', this.renderRanges);
    }
  },
  beforeDestroy() {
    if (this.state.observeBrush && this.state.brushInstance) {
      this.state.brushInstance.removeListener('update', this.renderRanges);
    }
  },
  start(e) {
    start({
      e,
      state: this.state,
      renderer: this.renderer,
      ranges: ranges$2,
      targetSize: TARGET_SIZE
    });
  },
  end() {
    if (!this.state.started) {
      return;
    }
    end(this.state, ranges$2);
    render$c(this.state);
    this.state.sourcedFromThisComponent = true;
    this.state.active = null;
  },
  move(e) {
    if (!this.state.started) {
      return;
    }
    move(this.state, e);
    setRanges$1(this.state);
    render$c(this.state);
  },
  clear() {
    if (this.state.fauxBrushInstance) {
      this.state.fauxBrushInstance.clear();
    }
    this.state.renderer.render([]);
    this.state.started = false;
    this.state.active = null;
    this.state.sourcedFromThisComponent = false;
  },
  bubbleStart(e) {
    if (!this.state.editable) {
      return;
    }
    const ee = e.srcEvent || e;
    const target = ee.target;
    const ed = {
      rangeIdx: parseInt(target.getAttribute('data-idx'), 10),
      bubbleIdx: parseInt(target.getAttribute('data-bidx'), 10)
    };
    if (isNaN(ed.rangeIdx) || JSON.stringify(ed) === JSON.stringify(this.state.edit)) {
      return;
    }
    this.state.edit = ed;
    ee.stopPropagation();
    ee.stopImmediatePropagation();
    ee.preventDefault();
    const wrapper = target.parentNode;
    render$c(this.state);
    const inputEl = wrapper.querySelector('input');
    inputEl.focus();
    inputEl.select();
  }
};

function render$b(state) {
  state.renderer.render(nodes(state));
}
function ranges$1(state) {
  return state.rc.ranges();
}
function shapesFromRange(state, brushRange) {
  const shapeAt = {
    x: state.direction ? brushRange.min + state.rect.x : state.rect.x,
    y: state.direction ? state.rect.y : brushRange.min + state.rect.y,
    width: state.direction ? brushRange.max - brushRange.min : state.rect.width + state.rect.x,
    height: state.direction ? state.rect.height + state.rect.y : brushRange.max - brushRange.min
  };
  return state.chart.shapesAt(shapeAt, state.settings.brush);
}
function brushFromShape(state, newShapes) {
  state.chart.brushFromShapes(newShapes, state.settings.brush);
}
function setRanges(state) {
  const rs = state.ranges.map(r => ({
    min: r.min,
    max: r.max
  }));
  if (state.active.idx !== -1) {
    if (state.active.mode === 'modify') {
      rs[state.active.idx].min = Math.min(state.start, state.current);
      rs[state.active.idx].max = Math.max(state.start, state.current);
    } else {
      const delta = getMoveDelta(state);
      rs[state.active.idx].min = state.active.start + delta;
      rs[state.active.idx].max = state.active.end + delta;
    }
  } else {
    rs.push({
      min: Math.min(state.start, state.current),
      max: Math.max(state.start, state.current)
    });
  }
  state.rc.set(rs);
  let shapes = [];
  rs.forEach(range => {
    shapes = [...shapes, ...shapesFromRange(state, range)];
  });
  brushFromShape(state, shapes);
}
function getBubbleLabel(state, value, range) {
  const min = Math.min(...range);
  const max = Math.max(...range);
  const shapeAt = {
    x: state.direction ? min + state.rect.x : state.rect.x,
    y: state.direction ? state.rect.y : min + state.rect.y,
    width: state.direction ? max - min : state.rect.width + state.rect.x,
    height: state.direction ? state.rect.height + state.rect.y : max - min
  };
  const shapes = state.chart.shapesAt(shapeAt, state.settings.brush);
  if (shapes.length === 0) {
    return '-';
  }
  const labelShape = shapes.reduce((s0, s1) => {
    // Min value
    const bounds0 = s0.bounds;
    const bounds1 = s1.bounds;
    if (value === min) {
      if (bounds0[state.cssCoord.coord] <= bounds1[state.cssCoord.coord]) {
        return s0;
      }
      return s1;
    }

    // Max value
    if (bounds0[state.cssCoord.coord] + bounds0[state.cssCoord.area] >= bounds1[state.cssCoord.coord] + bounds1[state.cssCoord.area]) {
      return s0;
    }
    return s1;
  });
  const compConfig = state.settings.brush.components.reduce((c0, c1) => c0.key === labelShape.key ? c0 : c1);
  if (typeof state.settings.bubbles.label === 'function') {
    return state.settings.bubbles.label(labelShape.data);
  }
  if (Array.isArray(compConfig.data) && compConfig.data.length) {
    return labelShape.data[compConfig.data[0]].label;
  }
  return labelShape.data && labelShape.data.label ? labelShape.data.label : '-';
}

/**
 * @typedef {object} ComponentBrushAreaDir.settings
 * @property {object} brush
 * @property {BrushTargetConfig[]} brush.components
 * @property {string} [direction=vertical] - Rendering direction [horizontal|vertical]
 * @property {object} [bubbles]
 * @property {boolean} [bubbles.show=true] - True to show label bubble, false otherwise
 * @property {string} [bubbles.align=start] - Where to anchor bubble [start|end]
 * @property {function} [bubbles.label] - Callback function for the labels
 * @property {object} [target]
 * @property {string[]} [target.components] - Render matching overlay on target components
 */

/**
 * @private
 * @typedef {object} ComponentBrushAreaDirStyle
 * @property {object} [bubble]
 * @property {string} [bubble.fontSize]
 * @property {string} [bubble.fontFamily]
 * @property {string} [bubble.fill]
 * @property {string} [bubble.color]
 * @property {string} [bubble.stroke]
 * @property {number} [bubble.strokeWidth]
 * @property {number} [bubble.borderRadius]
 * @property {object} [line]
 * @property {string} [line.stroke]
 * @property {number} [line.strokeWidth]
 * @property {object} [target]
 * @property {string} [target.fill]
 * @property {number} [target.strokeWidth]
 * @property {number} [target.opacity]
 */

const brushAreaDirectionalComponent = {
  require: ['chart', 'settings', 'renderer'],
  defaultSettings: {
    settings: {
      bubbles: {
        show: true,
        align: 'start'
      }
    },
    style: {
      bubble: '$label-overlay',
      line: '$shape-guide--inverted',
      target: '$selection-area-target'
    }
  },
  renderer: 'dom',
  on: {
    areaStart(e) {
      this.start(e);
    },
    areaMove(e) {
      this.move(e);
    },
    areaEnd(e) {
      this.end(e);
    },
    areaClear(e) {
      this.clear(e);
    }
  },
  created() {
    this.state = {
      key: this.settings.key || 'brush-area-dir'
    };
  },
  render(h) {
    this.state.rect = this.rect;
    const stngs = this.settings.settings;
    const direction = stngs.direction === 'vertical' ? VERTICAL : HORIZONTAL;
    const size = this.state.rect[direction === VERTICAL ? 'height' : 'width'];
    const offset = this.renderer.element().getBoundingClientRect();
    const targets = (stngs.target ? stngs.target.components || [stngs.target.component] : []).map(c => this.chart.component(c)).filter(c => !!c && !!c.rect);
    const targetRect = targets[0] ? targets.slice(1).reduce((prev, curr) => ({
      x0: Math.min(prev.x0, curr.rect.x),
      y0: Math.min(prev.y0, curr.rect.y),
      x1: Math.max(prev.x1, curr.rect.x + curr.rect.width),
      y1: Math.max(prev.y1, curr.rect.y + curr.rect.height)
    }), {
      x0: targets[0].rect.x,
      y0: targets[0].rect.y,
      x1: targets[0].rect.x + targets[0].rect.width,
      y1: targets[0].rect.y + targets[0].rect.height
    }) : null;
    this.state.targetRect = targetRect ? {
      x: targetRect.x0 - this.rect.x,
      y: targetRect.y0 - this.rect.y,
      width: targetRect.x1 - targetRect.x0,
      height: targetRect.y1 - targetRect.y0
    } : null;
    this.state.style = this.style;
    this.state.chart = this.chart;
    this.state.direction = direction;
    this.state.settings = stngs;
    this.state.offset = offset;
    this.state.rc = rangeCollection();
    this.state.renderer = this.renderer;
    this.state.multi = !!stngs.multiple;
    this.state.h = h;
    this.state.size = size;
    this.state.cssCoord = {
      offset: this.state.direction === VERTICAL ? 'top' : 'left',
      coord: this.state.direction === VERTICAL ? 'y' : 'x',
      pos: this.state.direction === VERTICAL ? 'deltaY' : 'deltaX',
      area: this.state.direction === VERTICAL ? 'height' : 'width'
    };
    this.state.format = function getFormat(v, r) {
      return getBubbleLabel(this, v, r);
    };
    return [];
  },
  start(e) {
    startArea({
      e,
      state: this.state,
      renderer: this.renderer,
      ranges: ranges$1,
      targetSize: TARGET_SIZE
    });
  },
  end() {
    if (!this.state.started) {
      return;
    }
    endArea(this.state, ranges$1);
    render$b(this.state);
  },
  move(e) {
    if (!this.state.started) {
      return;
    }
    moveArea(this.state, e);
    setRanges(this.state);
    render$b(this.state);
  },
  clear() {
    if (this.state.rc) {
      this.state.rc.clear();
    }
    this.state.renderer.render([]);
  }
};

/**
 * @typedef {object} ComponentBrushAreaDir
 * @extends ComponentSettings
 * @property {'brush-area-dir'} type component type
 */

/**
 * @typedef {object} ComponentBrushRange
 * @extends ComponentSettings
 * @property {'brush-range'} type component type
 */

function rangeBrush$1(picasso) {
  picasso.component('brush-range', brushRangeComponent);
  picasso.component('brush-area-dir', brushAreaDirectionalComponent);
}

const FILL = '#ccc';
const OPACITY = 1;
function ranges(state) {
  const brush = state.brush;
  if (!brush || !brush.isActive()) {
    return [];
  }
  const sourceData = state.scale.data();
  const sourceFields = sourceData ? sourceData.fields || [] : [];
  const sources = sourceFields.map(field => field.id());
  const rangeBrush = brush.brushes().filter(f => f.type === 'range' && sources.indexOf(f.id) !== -1)[0];
  if (!rangeBrush) {
    return [];
  }
  return rangeBrush.brush.ranges();
}
function shapes(state) {
  const isVertical = state.direction === 'vertical';
  const size = state.rect[isVertical ? 'height' : 'width'];
  const otherSize = state.rect[isVertical ? 'width' : 'height'];
  return ranges(state).map(range => {
    const start = state.scale(range.min) * size;
    const end = state.scale(range.max) * size;
    const low = Math.min(start, end);
    const s = Math.abs(start - end);
    return {
      type: 'rect',
      fill: state.fill,
      opacity: state.opacity,
      x: isVertical ? 0 : low,
      width: isVertical ? otherSize : s,
      y: isVertical ? low : 0,
      height: isVertical ? s : otherSize
    };
  });
}
function onStart(state) {
  state.renderer.render(shapes(state));
}
function onUpdate(state) {
  state.renderer.render(shapes(state));
}
function onEnd(state) {
  state.renderer.render(shapes(state));
}
function setup(state, brush, scale, renderer) {
  state.brush = brush;
  if (!brush) {
    return;
  }
  function start() {
    onStart(state);
  }
  function update() {
    onUpdate(state);
  }
  function end() {
    onEnd(state);
  }
  brush.on('start', start);
  brush.on('update', update);
  brush.on('end', end);
  state.start = start;
  state.update = update;
  state.end = end;
  state.brush = brush;
  state.scale = scale;
  state.renderer = renderer;
}
function teardown(state) {
  if (state.brush) {
    state.brush.removeListener('start', state.start);
    state.brush.removeListener('update', state.update);
    state.brush.removeListener('end', state.end);
  }
  state.start = undefined;
  state.update = undefined;
  state.end = undefined;
  state.brush = undefined;
  state.scale = undefined;
  state.renderer = undefined;
}

/**
 * @private
 * @typedef {object} ComponentRange
 * @extends ComponentSettings
 */

/**
 * @typedef {object} ComponentRange.settings
 * @property {string} brush - Name of brush instance
 * @property {string} scale - Name of a scale
 * @property {string} [direction='horizontal'] - Direction of the brush
 * @property {string} [fill='#ccc'] - Fill color
 * @property {number} [opacity=1] - Layer opacity
 */

const rangeComponent = {
  require: ['chart', 'settings', 'renderer'],
  defaultSettings: {
    settings: {}
  },
  preferredSize: () => 50,
  created() {
    this.state = {};
  },
  render() {
    const stngs = this.settings.settings;
    const brush = this.chart.brush(stngs.brush);
    const direction = stngs.direction || 'horizontal';
    const distance = direction === 'horizontal' ? this.rect.width : this.rect.height;
    const scale = scaleWithSize(this.chart.scale(stngs.scale), distance);
    teardown(this.state);
    setup(this.state, brush, scale, this.renderer);
    this.state.rect = this.rect;
    this.state.fill = stngs.fill || FILL;
    this.state.opacity = typeof stngs.opacity !== 'undefined' ? stngs.opacity : OPACITY;
    this.state.direction = direction;
    return shapes(this.state);
  },
  beforeDestroy() {
    teardown(this.state);
  }
};

function rangeBrush(picasso) {
  picasso.component('range', rangeComponent);
}

function getPoint(rendererBounds, event) {
  const eventOffsetX = event.center.x;
  const eventOffsetY = event.center.y;
  return {
    x: eventOffsetX - rendererBounds.left,
    y: eventOffsetY - rendererBounds.top
  };
  // return {
  //   x: Math.min(Math.max(eventOffsetX - rendererBounds.left, 0), rendererBounds.width),
  //   y: Math.min(Math.max(eventOffsetY - rendererBounds.top, 0), rendererBounds.height)
  // };
}
function withinThreshold(p, state, settings) {
  const startPoint = state.points[0];
  const sqrDist = sqrDistance(p, startPoint);
  return sqrDist < settings.settings.snapIndicator.threshold ** 2;
}
function appendToPath(state, p) {
  if (state.path.d == null) {
    state.path.d = "M".concat(p.x, " ").concat(p.y, " ");
  } else {
    state.path.d += "L".concat(p.x, " ").concat(p.y, " ");
  }
  state.points.push(p);
}
function render$a(state, renderer) {
  const nodes = [state.startPoint, state.path, state.snapIndicator].filter(node => node.visible);
  renderer.render(nodes);
}
function setSnapIndictor(_ref) {
  let {
    state,
    start = null,
    end = null
  } = _ref;
  if (start !== null) {
    state.snapIndicator.x1 = start.x;
    state.snapIndicator.y1 = start.y;
  }
  if (end !== null) {
    state.snapIndicator.x2 = end.x;
    state.snapIndicator.y2 = end.y;
  }
}
function showSnapIndicator(state, show) {
  state.snapIndicator.visible = show;
}
function setStartPoint(state, p) {
  state.startPoint.cx = p.x;
  state.startPoint.cy = p.y;
}
function getComponentDelta(chart, rendererBounds) {
  const chartBounds = chart.element.getBoundingClientRect();
  return {
    x: rendererBounds.left - chartBounds.left,
    y: rendererBounds.top - chartBounds.top
  };
}
function doLineBrush(state, chart) {
  if (state.active) {
    const p1 = state.points[state.points.length - 2];
    const p2 = state.points[state.points.length - 1];
    state.lineBrushShape.x1 = p1.x + state.componentDelta.x;
    state.lineBrushShape.y1 = p1.y + state.componentDelta.y;
    state.lineBrushShape.x2 = p2.x + state.componentDelta.x;
    state.lineBrushShape.y2 = p2.y + state.componentDelta.y;
    const shapes = chart.shapesAt(state.lineBrushShape, {
      components: state.brushConfig
    });
    chart.brushFromShapes(shapes, {
      components: state.brushConfig
    });
  }
}
function doPolygonBrush(state, chart) {
  if (state.active) {
    const dx = state.componentDelta.x;
    const dy = state.componentDelta.y;
    const vertices = state.points.map(p => ({
      x: p.x + dx,
      y: p.y + dy
    }));
    const shapes = chart.shapesAt({
      vertices
    }, {
      components: state.brushConfig
    });
    chart.brushFromShapes(shapes, {
      components: state.brushConfig
    });
  }
}
function initPath(stgns) {
  return {
    visible: true,
    type: 'path',
    d: null,
    fill: stgns.fill,
    stroke: stgns.stroke,
    strokeWidth: stgns.strokeWidth,
    opacity: stgns.opacity,
    strokeDasharray: stgns.strokeDasharray,
    collider: {
      type: null
    }
  };
}
function initSnapIndicator(stgns) {
  return {
    visible: false,
    type: 'line',
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    strokeDasharray: stgns.strokeDasharray,
    stroke: stgns.stroke,
    strokeWidth: stgns.strokeWidth,
    opacity: stgns.opacity,
    collider: {
      type: null
    }
  };
}
function initStartPoint(stgns) {
  return {
    visible: true,
    type: 'circle',
    cx: 0,
    cy: 0,
    r: stgns.r,
    fill: stgns.fill,
    opacity: stgns.opacity,
    stroke: stgns.stroke,
    strokeWidth: stgns.strokeWidth,
    collider: {
      type: null
    }
  };
}
function getBrushConfig$1(settings) {
  return settings.settings.brush.components.map(b => ({
    key: b.key,
    contexts: b.contexts || ['lassoBrush'],
    data: b.data || [''],
    action: b.action || 'add'
  }));
}
function endBrush(state, chart) {
  state.brushConfig.forEach(config => {
    config.contexts.forEach(context => {
      chart.brush(context).end();
    });
  });
}
function resetState$1() {
  return {
    points: [],
    active: false,
    path: null,
    snapIndicator: null,
    startPoint: null,
    rendererBounds: null,
    componentDelta: null,
    brushConfig: null,
    lineBrushShape: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 0
    } // Keep a single shape instance to avoid instantiating a new object on each lookup
  };
}

/**
 * @typedef {object} ComponentBrushLasso
 * @extends ComponentSettings
 * @property {'brush-lasso'} type component type
 * @example
 * {
 *  type: 'brush-lasso',
 *  settings: {
 *    brush: {
 *      components: [{ key: '<target-component>', contexts: ['<brush-context>'] }]
 *    }
 *  },
 * }
 */

/**
 * Component settings
 * @typedef {object} ComponentBrushLasso.settings
 * @property {object} [lasso] - Lasso style settings
 * @property {string} [lasso.fill='transparent']
 * @property {string} [lasso.stroke='black']
 * @property {number} [lasso.strokeWidth=2]
 * @property {number} [lasso.opacity=0.7]
 * @property {number} [lasso.strokeDasharray]
 * @property {object} [snapIndicator] - Snap indicator settings
 * @property {number} [snapIndicator.threshold=75] - The distance in pixel to show the snap indicator, if less then threshold the indicator is dispalyed
 * @property {string} [snapIndicator.strokeDasharray='5, 5']
 * @property {string} [snapIndicator.stroke='black']
 * @property {number} [snapIndicator.strokeWidth=2]
 * @property {number} [snapIndicator.opacity=0.5]
 * @property {object} [startPoint] - Start point style settings
 * @property {number} [startPoint.r=10] - Circle radius
 * @property {string} [startPoint.stroke='green']
 * @property {number} [startPoint.strokeWidth=1]
 * @property {number} [startPoint.opacity=1]
 * @property {object} [brush]
 * @property {object[]} brush.components - Array of components to brush on.
 * @property {string} [brush.components[].component.key] - Component key
 * @property {string[]} [brush.components[].component.contexts=['brushLasso']] - Name of the brushing contexts to affect
 * @property {string[]} [brush.components[].component.data=['']] - The mapped data properties to add to the brush
 * @property {string} [brush.components[].component.action='add'] - Type of action to respond with
 */

const brushLassoComponent = {
  require: ['chart', 'renderer', 'settings'],
  defaultSettings: {
    layout: {
      displayOrder: 0
    },
    settings: {
      brush: {
        components: []
      },
      snapIndicator: {
        threshold: 75,
        strokeDasharray: '5, 5',
        stroke: 'black',
        strokeWidth: 2,
        opacity: 0.5
      },
      lasso: {
        fill: 'transparent',
        stroke: 'black',
        strokeWidth: 2,
        opacity: 0.7,
        strokeDasharray: '20, 10'
      },
      startPoint: {
        r: 10,
        fill: 'green',
        stroke: 'black',
        strokeWidth: 1,
        opacity: 1
      }
    }
  },
  on: {
    lassoStart(e) {
      this.start(e);
    },
    lassoEnd(e) {
      this.end(e);
    },
    lassoMove(e) {
      this.move(e);
    },
    lassoCancel() {
      this.cancel();
    }
  },
  created() {
    this.state = resetState$1();
  },
  start(e) {
    this.state.active = true;
    this.state.path = initPath(this.settings.settings.lasso);
    this.state.snapIndicator = initSnapIndicator(this.settings.settings.snapIndicator);
    this.state.startPoint = initStartPoint(this.settings.settings.startPoint);
    this.state.rendererBounds = this.renderer.element().getBoundingClientRect();
    this.state.componentDelta = getComponentDelta(this.chart, this.state.rendererBounds);
    this.state.brushConfig = getBrushConfig$1(this.settings);
    const p = getPoint(this.state.rendererBounds, e);
    appendToPath(this.state, p);
    setSnapIndictor({
      state: this.state,
      start: p
    });
    setStartPoint(this.state, p);
  },
  move(e) {
    if (!this.state.active) {
      return;
    }
    const p = getPoint(this.state.rendererBounds, e);
    if (withinThreshold(p, this.state, this.settings)) {
      showSnapIndicator(this.state, true);
    } else {
      showSnapIndicator(this.state, false);
    }
    appendToPath(this.state, p);
    setSnapIndictor({
      state: this.state,
      end: p
    });
    render$a(this.state, this.renderer);
    doLineBrush(this.state, this.chart);
  },
  end(e) {
    if (!this.state.active) {
      return;
    }
    showSnapIndicator(this.state, false);
    const p = getPoint(this.state.rendererBounds, e);
    const shouldSnap = withinThreshold(p, this.state, this.settings);
    if (shouldSnap) {
      doPolygonBrush(this.state, this.chart);
    }
    this.state = resetState$1();
    this.renderer.render([]);
  },
  cancel() {
    if (!this.state.active) {
      return;
    }
    endBrush(this.state, this.chart);
    this.state = resetState$1();
    this.renderer.render([]);
  },
  render() {
    // Do nothing
  }
};

function lassoBrush(picasso) {
  picasso.component('brush-lasso', brushLassoComponent);
}

/**
 * Using the basic example found here: https://en.wikipedia.org/wiki/Binary_search_algorithm
 *
 * Finds the first node that may intersect the label.
 * @private
 */
function binaryLeftSearch(labelBounds, ary, coord, side, extractBounds) {
  let left = 0;
  let right = ary.length - 1;
  let bounds;
  while (left < right) {
    let m = Math.floor((left + right) / 2);
    bounds = extractBounds(ary[m]);
    if (bounds[coord] + bounds[side] < labelBounds[coord]) {
      // label is on right side
      left = m + 1;
    } else {
      // label is on the left side
      right = m;
    }
  }
  return left;
}

/**
 * The purpose of this module is to act as a filtering function to remove any labels
 * that meets one of the following criterias:
 * -- The label is not fully inside the container, such that it would be fully or partially clipped if rendered
 * -- The label overlaps another label
 * -- The label overlaps another bar which is not the bar the label is originating from
 *
 * Assumes that the nodes are sorted from left/top to right/down, as that allows
 * some optimizations to be performed.
 * @private
 * @returns {function} Filter function, returns false if label be removed and true otherwise
 */
function filterOverlappingLabels(_ref) {
  let {
    orientation,
    targetNodes,
    labels,
    container
  } = _ref;
  let findLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : binaryLeftSearch;
  const renderLabels = [];
  const coord = orientation === 'v' ? 'x' : 'y';
  const side = orientation === 'v' ? 'width' : 'height';
  const getTextBounds = item => item.textBounds;
  const getNodeBounds = item => item.node.localBounds;
  return (doNotUse, labelIndex) => {
    const {
      textBounds: labelBounds,
      node: labelNode
    } = labels[labelIndex];

    // ### Test if label is not fully inside container based on the orientation ###
    if (labelBounds[coord] < container[coord] || labelBounds[coord] + labelBounds[side] > container[coord] + container[side]) {
      return false;
    }

    // ### Test label to label collision ###
    const leftStartLabel = findLeft(labelBounds, renderLabels, coord, side, getTextBounds);
    for (let i = leftStartLabel; i < renderLabels.length; i++) {
      if (testRectRect(labelBounds, renderLabels[i].textBounds)) {
        return false;
      }
    }

    // ### Test label to node collision ###
    const leftStartNode = findLeft(labelBounds, targetNodes, coord, side, getNodeBounds);
    const labelRightBoundary = labelBounds[coord] + labelBounds[side];
    for (let i = leftStartNode; i < targetNodes.length; i++) {
      const node = targetNodes[i].node;
      // Do not test beyond this node, as they are assumed to not collide with the label
      if (labelRightBoundary < node.localBounds[coord]) {
        break;
      }
      if (testRectRect(labelBounds, node.localBounds) && labelNode !== node) {
        return false;
      }
    }

    // No collision occured, allow the label to be rendered
    renderLabels.push(labels[labelIndex]);
    return true;
  };
}

const PADDING = 4;
// const DOUBLE_PADDING = PADDING * 2;

function cbContext$2(node, chart) {
  return {
    node,
    data: node.data,
    scale: chart.scale,
    formatter: chart.formatter,
    dataset: chart.dataset
  };
}
function isValidText(text) {
  const type = typeof text;
  return (type === 'string' || type === 'number') && text !== '';
}
function toBackground(label) {
  return _objectSpread2(_objectSpread2({
    type: 'rect',
    rx: 2,
    ry: 2,
    fill: label.backgroundColor
  }, label.backgroundBounds), {}, {
    data: "".concat(label.data, " ").concat(label.text),
    rotation: label.transform && label.transform.match(/rotate/gi) ? 'rotated' : 'horizontal'
  });
}
function isTextWidthInRectWidth(rect, label, rotate) {
  return rotate ? rect.width >= label.height : rect.width >= label.width;
}
function isTextHeightInRectHeight(rect, label, rotate) {
  return rotate ? rect.height >= label.width : rect.height >= label.height;
}
function isGoodPlacement(orientation, rect, label, fitsHorizontally, overflow) {
  let fitWidth;
  let fitHeight;
  if (orientation === 'v') {
    fitWidth = fitsHorizontally || overflow || isTextWidthInRectWidth(rect, label, true);
    fitHeight = isTextHeightInRectHeight(rect, label, !fitsHorizontally);
  } else {
    fitWidth = isTextWidthInRectWidth(rect, label);
    fitHeight = overflow || isTextHeightInRectHeight(rect, label, false);
  }
  return fitWidth && fitHeight;
}
function isTextInRect(rect, label, opts) {
  return isTextWidthInRectWidth(rect, label, opts.rotate) && isTextHeightInRectHeight(rect, label, opts.rotate);
}
function placeSegmentInSegment(majorSegmentPosition, majorSegmentSize, minorSegmentSize, align) {
  const majorSegmentCenter = majorSegmentPosition + majorSegmentSize * 0.5;
  const offset = (align - 0.5) * (majorSegmentSize - minorSegmentSize);
  const minorSegmentCenter = majorSegmentCenter + offset;
  const minorSegmentPosition = minorSegmentCenter - minorSegmentSize * 0.5;
  return minorSegmentPosition;
}
function placeTextInRect$2(rect, text, opts) {
  const label = {
    type: 'text',
    text,
    maxWidth: opts.rotate ? rect.height : rect.width,
    x: 0,
    y: rect.y,
    dx: 0,
    dy: 0,
    fill: opts.fill,
    anchor: opts.rotate ? 'end' : 'start',
    baseline: 'central',
    fontSize: "".concat(opts.fontSize, "px"),
    fontFamily: opts.fontFamily
  };
  const textMetrics = opts.textMetrics;
  if (!opts.overflow && !isTextInRect(rect, textMetrics, opts)) {
    return false;
  }
  const baseLineOffset = textMetrics.height * 0.5;
  if (opts.rotate) {
    label.x = placeSegmentInSegment(rect.x, rect.width, textMetrics.height, opts.align) + baseLineOffset;
    label.y = placeSegmentInSegment(rect.y, rect.height, textMetrics.width, opts.justify);
    if (opts.dock === 'right') {
      label.transform = "rotate(90, ".concat(label.x + label.dx, ", ").concat(label.y + label.dy, ") translate(").concat(textMetrics.width, ", 0)");
    } else {
      label.transform = "rotate(-90, ".concat(label.x + label.dx, ", ").concat(label.y + label.dy, ")");
    }
  } else {
    label.x = placeSegmentInSegment(rect.x, rect.width, textMetrics.width, opts.align);
    label.y = placeSegmentInSegment(rect.y, rect.height, textMetrics.height, opts.justify) + baseLineOffset;
  }
  return label;
}
function limitBounds(bounds, view) {
  const minY = Math.max(0, Math.min(bounds.y, view.height));
  const maxY = Math.max(0, Math.min(bounds.y + bounds.height, view.height));
  const minX = Math.max(0, Math.min(bounds.x, view.width));
  const maxX = Math.max(0, Math.min(bounds.x + bounds.width, view.width));
  bounds.x = minX;
  bounds.width = maxX - minX;
  bounds.y = minY;
  bounds.height = maxY - minY;
}
function pad$1(bounds, measured) {
  let padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    top = PADDING,
    bottom = PADDING,
    left = PADDING,
    right = PADDING
  } = padding;
  const leftPadding = typeof left === 'function' ? left(measured) : left;
  const rightPadding = typeof right === 'function' ? right(measured) : right;
  const topPadding = typeof top === 'function' ? top(measured) : top;
  const bottomPadding = typeof bottom === 'function' ? bottom(measured) : bottom;
  bounds.x += leftPadding;
  bounds.width -= leftPadding + rightPadding;
  bounds.y += topPadding;
  bounds.height -= topPadding + bottomPadding;
}
function getBarRect(_ref) {
  let {
    bar,
    view,
    direction,
    position,
    padding = PADDING,
    measured
  } = _ref;
  const bounds = {};
  extend$1(bounds, bar);
  if (!position || position === 'inside') ; else if (direction === 'up' || direction === 'down') {
    const start = Math.max(0, Math.min(bar.y, view.height));
    const end = Math.max(0, Math.min(bar.y + bar.height, view.height));
    if (position === 'outside' && direction === 'up' || position === 'opposite' && direction === 'down') {
      bounds.y = 0;
      bounds.height = start;
    } else if (position === 'outside' && direction === 'down' || position === 'opposite' && direction === 'up') {
      bounds.y = end;
      bounds.height = view.height - end;
    }
  } else {
    const start = Math.max(0, Math.min(bar.x, view.width));
    const end = Math.max(0, Math.min(bar.x + bar.width, view.width));
    if (position === 'outside' && direction === 'left' || position === 'opposite' && direction === 'right') {
      bounds.x = 0;
      bounds.width = start;
    } else if (position === 'outside' && direction === 'right' || position === 'opposite' && direction === 'left') {
      bounds.x = end;
      bounds.width = view.width - end;
    }
  }
  limitBounds(bounds, view);
  pad$1(bounds, measured, padding);
  return bounds;
}
function findBestPlacement$1(_ref2) {
  let {
    direction,
    fitsHorizontally,
    // lblStngs,
    measured,
    node,
    orientation,
    // placements,
    placementSettings,
    rect
  } = _ref2;
  let barRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getBarRect;
  let largest;
  let bounds;
  let placement;
  let testBounds;
  let p;
  const boundaries = [];
  const dimension = orientation === 'h' ? 'width' : 'height';
  for (p = 0; p < placementSettings.length; p++) {
    placement = placementSettings[p];
    testBounds = barRect({
      bar: node.localBounds,
      view: rect,
      direction,
      position: placement.position,
      padding: placement.padding,
      measured
    });
    boundaries.push(testBounds);
    largest = !p || testBounds[dimension] > largest[dimension] ? testBounds : largest;
    if (isGoodPlacement(orientation, testBounds, measured, fitsHorizontally, placement.overflow)) {
      bounds = testBounds;
      break;
    }
  }

  // fallback strategy - place the text in the largest rectangle
  if (!bounds) {
    bounds = largest;
    p = boundaries.indexOf(bounds);
  }
  placement = placementSettings[p];
  return {
    bounds,
    placement
  };
}
function approxTextBounds(label, textMetrics, rotated, rect) {
  let padding = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  const {
    top = PADDING,
    bottom = PADDING,
    left = PADDING,
    right = PADDING
  } = padding;
  const leftPadding = typeof left === 'function' ? left(textMetrics) : left;
  const rightPadding = typeof right === 'function' ? right(textMetrics) : right;
  const topPadding = typeof top === 'function' ? top(textMetrics) : top;
  const bottomPadding = typeof bottom === 'function' ? bottom(textMetrics) : bottom;
  const x0 = label.x + label.dx;
  const y0 = label.y + label.dy;
  const height = rotated ? Math.min(textMetrics.width, rect.height) : Math.min(textMetrics.height, rect.width);
  const width = rotated ? Math.min(textMetrics.height, rect.height) : Math.min(textMetrics.width, rect.width);
  const offset = textMetrics.height * 0.5;
  const PADDING_OFFSET = 1e-9; // Needed to support a case when multiple bars are on the same location
  const x = rotated ? x0 - offset : x0;
  const y = rotated ? y0 : y0 - offset;
  const bounds = {
    x: x - leftPadding - PADDING_OFFSET,
    y: y - topPadding - PADDING_OFFSET,
    width: width + (leftPadding + rightPadding) - PADDING_OFFSET,
    height: height + (topPadding + bottomPadding) - PADDING_OFFSET
  };
  return bounds;
}
function placeInBars(_ref3) {
  let {
    chart,
    targetNodes,
    rect,
    fitsHorizontally,
    collectiveOrientation
  } = _ref3;
  let findPlacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : findBestPlacement$1;
  let placer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : placeTextInRect$2;
  let postFilter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : filterOverlappingLabels;
  const labels = [];
  const postFilterContext = {
    container: rect,
    targetNodes,
    labels: [],
    orientation: collectiveOrientation
  };
  let label;
  let target;
  let node;
  let text;
  let justify;
  let bounds;
  let fill;
  let measured;
  let direction;
  let lblStngs;
  let placement;
  let placements;
  let arg;
  let orientation;
  for (let i = 0, len = targetNodes.length; i < len; i++) {
    bounds = null;
    target = targetNodes[i];
    node = target.node;
    arg = cbContext$2(node, chart);
    direction = target.direction;
    orientation = direction === 'left' || direction === 'right' ? 'h' : 'v';
    for (let j = 0; j < target.texts.length; j++) {
      text = target.texts[j];
      if (!isValidText(text)) {
        continue;
      }
      lblStngs = target.labelSettings[j];
      measured = target.measurements[j];
      placements = lblStngs.placements;
      const bestPlacement = findPlacement({
        direction,
        fitsHorizontally,
        lblStngs,
        measured,
        node,
        orientation,
        placements,
        placementSettings: target.placementSettings[j],
        rect
      });
      bounds = bestPlacement.bounds;
      placement = bestPlacement.placement;
      if (bounds && placement) {
        var _lblStngs$dock;
        justify = placement.justify;
        const linkData = typeof lblStngs.linkData === 'function' ? lblStngs.linkData(arg, i) : undefined;
        const overflow = typeof placement.overflow === 'function' ? placement.overflow(arg, i) : placement.overflow;
        if (direction === 'up') {
          justify = 1 - justify;
        }
        if (placement.position === 'opposite') {
          justify = 1 - justify;
        }
        if (direction === 'left') {
          justify = 1 - justify;
        }
        const isRotated = !(collectiveOrientation === 'h' || fitsHorizontally);
        label = placer(bounds, text, {
          justify: orientation === 'h' ? placement.align : justify,
          align: orientation === 'h' ? justify : placement.align,
          fontSize: lblStngs.fontSize,
          fontFamily: lblStngs.fontFamily,
          textMetrics: measured,
          rotate: isRotated,
          overflow: !!overflow,
          dock: (_lblStngs$dock = lblStngs.dock) !== null && _lblStngs$dock !== void 0 ? _lblStngs$dock : 'left'
        });
        if (label) {
          const textBounds = approxTextBounds(label, measured, isRotated, bounds, placement.padding);
          fill = typeof placement.fill === 'function' ? placement.fill(_objectSpread2(_objectSpread2({}, arg), {}, {
            textBounds
          }), i) : placement.fill;
          label.fill = fill;
          if (typeof linkData !== 'undefined') {
            label.data = linkData;
          }
          if (typeof placement.background === 'object') {
            label.backgroundColor = typeof placement.background.fill === 'function' ? placement.background.fill(_objectSpread2(_objectSpread2({}, arg), {}, {
              textBounds
            }), i) : placement.background.fill;
            if (typeof label.backgroundColor !== 'undefined') {
              label.backgroundBounds = approxTextBounds(label, measured, isRotated, bounds, placement.background.padding);
            }
          }
          labels.push(label);
          postFilterContext.labels.push({
            node,
            textBounds
          });
        }
      }
    }
  }
  const filteredLabels = labels.filter(postFilter(postFilterContext));
  const backgrounds = filteredLabels.filter(lb => typeof lb.backgroundBounds !== 'undefined').map(toBackground);
  return [...backgrounds, ...filteredLabels];
}
function precalculate(_ref4) {
  let {
    nodes,
    rect,
    chart,
    labelSettings,
    placementSettings,
    settings,
    renderer
  } = _ref4;
  const labelStruct = {};
  const targetNodes = [];
  let target;
  let fitsHorizontally = true;
  let hasHorizontalDirection = false;
  let node;
  let text;
  let bounds;
  let measured;
  let lblStng;
  let direction;
  for (let i = 0; i < nodes.length; i++) {
    node = nodes[i];
    bounds = node.localBounds;
    if (!testRectRect(bounds, rect)) {
      continue;
    }
    let arg = cbContext$2(node, chart);
    target = {
      node,
      texts: [],
      measurements: [],
      labelSettings: [],
      placementSettings: []
      // direction: 'up'
    };
    for (let j = 0; j < labelSettings.length; j++) {
      lblStng = labelSettings[j];
      text = typeof lblStng.label === 'function' ? lblStng.label(arg, i) : undefined;
      if (!isValidText(text)) {
        continue; // eslint-ignore-line
      }
      direction = typeof settings.direction === 'function' ? settings.direction(arg, i) : settings.direction || 'up';
      hasHorizontalDirection = hasHorizontalDirection || direction === 'left' || direction === 'right';
      labelStruct.fontFamily = lblStng.fontFamily;
      labelStruct.fontSize = "".concat(lblStng.fontSize, "px");
      labelStruct.text = text;
      measured = renderer.measureText(labelStruct);
      target.measurements.push(measured);
      target.texts.push(text);
      target.labelSettings.push(lblStng);
      target.placementSettings.push(placementSettings[j]);
      target.direction = direction;
      fitsHorizontally = fitsHorizontally && measured.width <= bounds.width - PADDING * 2;
    }
    targetNodes.push(target);
  }
  return {
    targetNodes,
    fitsHorizontally,
    hasHorizontalDirection
  };
}
function getOrientation(_ref5) {
  let {
    orientation = 'auto',
    defaultOrientation = 'h'
  } = _ref5;
  switch (orientation.toLocaleLowerCase()) {
    case 'vertical':
      return 'v';
    case 'horizontal':
      return 'h';
    default:
      return defaultOrientation;
  }
}

/**
 * @typedef {object} ComponentLabels~BarsLabelStrategy
 * @property {'bar'} type Name of strategy
 */

/**
 * Bars strategy settings
 * @typedef {object} ComponentLabels~BarsLabelStrategy.settings
 * @property {string|function} [direction='up'] - The direction in which the bars are growing: 'up', 'down', 'right' or 'left'.
 * @property {string} [orientation='auto'] - Orientation of text: 'auto', 'horizontal' or 'vertical'
 * @property {string} [fontFamily='Arial']
 * @property {number} [fontSize=12]
 * @property {Array<object>} labels
 * @property {string|function} labels[].label - The text value
 * @property {function} labels[].linkData - Link data to the label
 * @property {string} [labels[].dock='left'] - When orientation is vertical, the label can be docked to the left or right of the bar. 'left' | 'right'.
 * @property {Array<object>} labels[].placements
 * @property {string} labels[].placements[].position - 'inside' | 'outside' | 'opposite'
 * @property {number} [labels[].placements[].justify=0] - Placement of the label along the direction of the bar
 * @property {number} [labels[].placements[].align=0.5] - Placement of the label along the perpendicular direction of the bar
 * @property {string} [labels[].placements[].fill='#333'] - Color of the label
 * @property {boolean} [labels[].placements[].overflow=false] - True if the label is allowed to overflow the bar
 * @property {object} labels[].placements[].padding - Padding between the label and the bar
 * @property {number|function} [labels[].placements[].padding.top=4] - Padding-top between the label and the bar. Can be a function, text dimensions object {width, height} is exposed as argument.
 * @property {number|function} [labels[].placements[].padding.bottom=4] - Padding-bottom between the label and the bar. Can be a function, text dimensions object {width, height} is exposed as argument.
 * @property {number|function} [labels[].placements[].padding.left=4] - Padding-left between the label and the bar. Can be a function, text dimensions object {width, height} is exposed as argument.
 * @property {number|function} [labels[].placements[].padding.right=4] - Padding-right between the label and the bar. Can be a function, text dimensions object {width, height} is exposed as argument.
 * @property {object} labels[].placements[].background - Background of the label
 * @property {string|function} labels[].placements[].background.fill - Background color of the label
 * @property {object} labels[].placements[].background.padding - Padding between the label and the background
 * @property {number} [labels[].placements[].background.padding.top=4] - Padding-top between the label and the background
 * @property {number} [labels[].placements[].background.padding.bottom=4] - Padding-bottom between the label and the background
 * @property {number} [labels[].placements[].background.padding.left=4] - Padding-left between the label and the background
 * @property {number} [labels[].placements[].background.padding.right=4] - Padding-right between the label and the background
 */

function bars(_ref6) {
  let {
    settings,
    chart,
    nodes,
    rect,
    renderer,
    style
  } = _ref6;
  let placer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : placeInBars;
  const defaults = extend$1({
    fontSize: 12,
    fontFamily: 'Arial',
    align: 0.5,
    justify: 0,
    fill: '#333'
  }, style.label);
  defaults.fontSize = parseInt(defaults.fontSize, 10);
  const labelSettings = settings.labels.map(labelSetting => extend$1({}, defaults, settings, labelSetting));
  const placementSettings = settings.labels.map(labelSetting => labelSetting.placements.map(placement => extend$1({}, defaults, settings, labelSetting, placement)));
  const {
    fitsHorizontally,
    hasHorizontalDirection,
    targetNodes
  } = precalculate({
    nodes,
    chart,
    renderer,
    settings,
    rect,
    labelSettings,
    placementSettings
  });
  const orientation = getOrientation({
    orientation: settings.orientation,
    defaultOrientation: hasHorizontalDirection ? 'h' : 'v'
  });
  const coord = orientation === 'h' ? 'y' : 'x';
  const side = orientation === 'h' ? 'height' : 'width';
  targetNodes.sort((a, b) => a.node.localBounds[coord] + a.node.localBounds[side] - (b.node.localBounds[coord] + b.node.localBounds[side]));
  return placer({
    chart,
    targetNodes,
    stngs: settings,
    rect,
    fitsHorizontally,
    collectiveOrientation: orientation
  });
}

const LABEL_OVERLAP_THRESHOLD_X = 4;

// When a label is animated, the label rect width should be bit larger than the measured text width,
// otherwise the animated label will be ellipsed.
const LABEL_RECT_WIDTH_PADDING = 1;
function normalize(angle) {
  const PI2 = Math.PI * 2;
  return (angle % PI2 + PI2) % PI2; // normalize
}
function pad(bounds, padding) {
  bounds.x += padding;
  bounds.width -= padding * 2;
  bounds.y += padding;
  bounds.height -= padding * 2;
}
function getTopLeftBounds(bounds) {
  const x = bounds.x;
  const y = bounds.y - bounds.height / 2;
  return {
    x,
    y,
    width: bounds.width,
    height: bounds.height
  };
}

// assume 0 <= angle < (PI / 2)
function getLineCircleIntersection(radius, offset, angle) {
  let {
    x,
    y
  } = offset;
  if (x * x + y * y > radius * radius) {
    return null;
  }
  let dx = Math.sin(angle);
  let dy = Math.cos(angle);
  let D = x * dy - y * dx;
  let d = radius * radius - D * D;
  if (d < 0) {
    return null;
  }
  let sqrtD = Math.sqrt(d);
  return {
    x: D * dy + dx * sqrtD,
    y: -(D * dx) + dy * sqrtD
  };
}

// assume 0 <= angle < (PI * 2)
function getRectFromCircleIntersection(_ref) {
  let {
    radius,
    size,
    angle
  } = _ref;
  let {
    width,
    height
  } = size;
  let lineOffset = {
    x: width / 2,
    y: height / 2
  };
  let section = Math.floor(angle / (Math.PI / 2));
  let intersection;
  let offset;
  switch (section) {
    case 0:
      intersection = getLineCircleIntersection(radius, lineOffset, angle);
      if (!intersection) {
        return null;
      }
      intersection.y *= -1;
      offset = {
        x: -width,
        y: 0
      };
      break;
    case 1:
      intersection = getLineCircleIntersection(radius, lineOffset, Math.PI - angle);
      if (!intersection) {
        return null;
      }
      offset = {
        x: -width,
        y: -height
      };
      break;
    case 2:
      intersection = getLineCircleIntersection(radius, lineOffset, angle - Math.PI);
      if (!intersection) {
        return null;
      }
      intersection.x *= -1;
      offset = {
        x: 0,
        y: -height
      };
      break;
    case 3:
      intersection = getLineCircleIntersection(radius, lineOffset, 2 * Math.PI - angle);
      if (!intersection) {
        return null;
      }
      intersection.x *= -1;
      intersection.y *= -1;
      offset = {
        x: 0,
        y: 0
      };
      break;
    default:
      throw new Error('invalid angle');
  }
  let bounds = {
    x: intersection.x + offset.x,
    y: intersection.y + offset.y,
    width,
    height
  };
  return bounds;
}
function getHorizontalInsideSliceRect(_ref2) {
  let {
    slice,
    padding,
    measured,
    store
  } = _ref2;
  const {
    start,
    end,
    outerRadius
  } = slice;
  const middle = normalize((start + end) / 2);
  const size = {
    width: measured.width + padding * 2 + LABEL_RECT_WIDTH_PADDING,
    height: measured.height + padding * 2
  };
  let bounds = getRectFromCircleIntersection({
    radius: outerRadius,
    size,
    angle: middle
  });
  if (!bounds) {
    return null;
  }
  bounds.baseline = 'top';
  pad(bounds, padding);
  if (store.insideLabelBounds.some(rect => testRectRect(rect, bounds))) {
    return null;
  }
  store.insideLabelBounds.push({
    x: bounds.x - LABEL_OVERLAP_THRESHOLD_X,
    y: bounds.y,
    width: bounds.width + LABEL_OVERLAP_THRESHOLD_X * 2,
    height: bounds.height
  }); // Copy as bounds is mutated else where

  return bounds;
}
function getHorizontalIntoSliceRect(_ref3) {
  let {
    slice,
    padding,
    measured
  } = _ref3;
  let {
    start,
    end,
    innerRadius,
    outerRadius
  } = slice;
  const middle = normalize((start + end) / 2);
  let size = {
    width: measured.width + padding * 2 + LABEL_RECT_WIDTH_PADDING,
    height: measured.height + padding * 2
  };
  let bounds = getRectFromCircleIntersection({
    radius: outerRadius,
    size,
    angle: middle
  });
  if (!bounds) {
    return null;
  }
  bounds.baseline = 'top';
  let startLine = {
    x1: 0,
    y1: 0,
    x2: Math.sin(start) * outerRadius,
    y2: -Math.cos(start) * outerRadius
  };
  if (testRectLine(bounds, startLine)) {
    return null;
  }
  let endLine = {
    x1: 0,
    y1: 0,
    x2: Math.sin(end) * outerRadius,
    y2: -Math.cos(end) * outerRadius
  };
  if (testRectLine(bounds, endLine)) {
    return null;
  }
  let circle = {
    cx: 0,
    cy: 0,
    r: innerRadius
  };
  if (testCircleRect(circle, bounds)) {
    return null;
  }
  pad(bounds, padding);
  return bounds;
}

// TODO: this case can support a justify setting
function getRotatedInsideSliceRect(_ref4) {
  let {
    slice,
    measured,
    padding
  } = _ref4;
  let {
    start,
    end,
    innerRadius,
    outerRadius
  } = slice;
  let maxWidth = outerRadius - innerRadius - padding * 2;
  let size = end - start;
  if (size < Math.PI) {
    let x = (measured.height / 2 + padding) / Math.tan(size / 2);
    if (x > innerRadius) {
      maxWidth = outerRadius - x - padding * 2;
    }
  }
  if (maxWidth < 0 || maxWidth < measured.minReqWidth) {
    return null;
  }
  const middle = normalize((start + end) / 2);
  let r = outerRadius - padding;
  let bounds = {
    x: Math.sin(middle) * r,
    y: -Math.cos(middle) * r,
    width: maxWidth,
    height: measured.height
  };
  if (middle < Math.PI) {
    bounds.angle = middle - Math.PI / 2;
    bounds.anchor = 'end';
  } else {
    bounds.angle = middle + Math.PI / 2;
    bounds.anchor = 'start';
  }
  return bounds;
}
function getRotatedOusideSliceRect(_ref5) {
  let {
    slice,
    measured,
    padding,
    view
  } = _ref5;
  let {
    start,
    end,
    outerRadius,
    offset
  } = slice;
  let r = outerRadius + padding;
  let size = end - start;
  if (size < Math.PI) {
    let minR = (measured.height / 2 + padding) / Math.tan(size / 2);
    if (minR > r) {
      return null;
    }
  }
  const middle = normalize((start + end) / 2);
  let x = Math.sin(middle) * r;
  let y = -Math.cos(middle) * r;
  let maxWidth = measured.width + LABEL_RECT_WIDTH_PADDING;
  let v = middle % Math.PI;
  if (v > Math.PI / 2) {
    v = Math.PI - v;
  }
  if (Math.cos(v) > 0.001) {
    let edge = y < 0 ? view.y : view.y + view.height;
    let d = Math.abs(edge - offset.y);
    let w = d / Math.cos(v) - Math.tan(v) * (measured.height / 2) - padding * 2 - outerRadius;
    if (w < maxWidth) {
      maxWidth = w;
    }
  }
  if (Math.sin(v) > 0.001) {
    let edge = x < 0 ? view.x : view.x + view.width;
    let d = Math.abs(edge - offset.x);
    let w = d / Math.sin(v) - measured.height / 2 / Math.tan(v) - padding * 2 - outerRadius;
    if (w < maxWidth) {
      maxWidth = w;
    }
  }
  if (maxWidth <= 0 || maxWidth < measured.minReqWidth) {
    return null;
  }
  let bounds = {
    x,
    y,
    width: maxWidth,
    height: measured.height
  };
  if (middle < Math.PI) {
    bounds.angle = middle - Math.PI / 2;
    bounds.anchor = 'start';
  } else {
    bounds.angle = middle + Math.PI / 2;
    bounds.anchor = 'end';
  }
  return bounds;
}
function outOfSpace(context, section, view) {
  switch (section) {
    case 0:
      return context.q1maxY < 0;
    case 1:
      return context.q2minY > view.height;
    case 2:
      return context.q3minY > view.height;
    case 3:
      return context.q4maxY < 0;
    default:
      return true;
  }
}
function adjustBounds(bounds, context, slice) {
  const LINE_PADDING = 2;
  const LIMIT = 1;
  const {
    start,
    end,
    offset,
    outerRadius
  } = slice;
  const middle = normalize((start + end) / 2);
  let section = Math.floor(middle / (Math.PI / 2));
  switch (section) {
    case 0:
      if (context.q1maxY !== undefined) {
        let y = Math.min(bounds.y, context.q1maxY - bounds.height);
        let dy = bounds.y - y;
        bounds.y = y;
        if (dy > LIMIT) {
          let r = outerRadius + LINE_PADDING;
          bounds.line = {
            type: 'line',
            x1: bounds.x - LINE_PADDING,
            y1: bounds.y + LINE_PADDING,
            x2: offset.x + Math.sin(middle) * r,
            y2: offset.y - Math.cos(middle) * r,
            strokeWidth: 1
          };
        }
      }
      break;
    case 1:
      if (context.q2minY !== undefined) {
        let y = Math.max(bounds.y, context.q2minY);
        let dy = y - bounds.y;
        bounds.y = y;
        if (dy > LIMIT) {
          let r = outerRadius + LINE_PADDING;
          bounds.line = {
            type: 'line',
            x1: bounds.x - LINE_PADDING,
            y1: bounds.y - LINE_PADDING,
            x2: offset.x + Math.sin(middle) * r,
            y2: offset.y - Math.cos(middle) * r,
            strokeWidth: 1
          };
        }
      }
      break;
    case 2:
      if (context.q3minY !== undefined) {
        let y = Math.max(bounds.y, context.q3minY);
        let dy = y - bounds.y;
        bounds.y = y;
        if (dy > LIMIT) {
          let r = outerRadius + LINE_PADDING;
          bounds.line = {
            type: 'line',
            x1: bounds.x + LINE_PADDING,
            y1: bounds.y - LINE_PADDING,
            x2: offset.x + Math.sin(middle) * r,
            y2: offset.y - Math.cos(middle) * r,
            strokeWidth: 1
          };
        }
      }
      break;
    case 3:
      if (context.q4maxY !== undefined) {
        let y = Math.min(bounds.y, context.q4maxY - bounds.height);
        let dy = bounds.y - y;
        bounds.y = y;
        if (dy > LIMIT) {
          let r = outerRadius + LINE_PADDING;
          bounds.line = {
            type: 'line',
            x1: bounds.x + LINE_PADDING,
            y1: bounds.y + LINE_PADDING,
            x2: offset.x + Math.sin(middle) * r,
            y2: offset.y - Math.cos(middle) * r,
            strokeWidth: 1
          };
        }
      }
      break;
  }
}
function updateContext(_ref6) {
  let {
    context,
    node,
    bounds
  } = _ref6;
  const PADDING = 2;
  let {
    start,
    end
  } = node.desc.slice;
  const middle = normalize((start + end) / 2);
  let section = Math.floor(middle / (Math.PI / 2));
  switch (section) {
    case 0:
      context.q1maxY = bounds.y - PADDING;
      if (context.q2minY === undefined) {
        context.q2minY = bounds.y + bounds.height + PADDING;
      }
      break;
    case 1:
      context.q2minY = bounds.y + bounds.height + PADDING;
      break;
    case 2:
      context.q3minY = bounds.y + bounds.height + PADDING;
      break;
    case 3:
      context.q4maxY = bounds.y - PADDING;
      if (context.q3minY === undefined) {
        context.q3minY = bounds.y + bounds.height + PADDING;
      }
      break;
  }
}
function getHorizontalOusideSliceRect(_ref7) {
  let {
    slice,
    measured,
    padding,
    view,
    context
  } = _ref7;
  let {
    start,
    end,
    outerRadius,
    offset
  } = slice;
  const middle = normalize((start + end) / 2);
  let section = Math.floor(middle / (Math.PI / 2));
  if (outOfSpace(context, section, view)) {
    return null;
  }
  let r = outerRadius + padding + measured.height / 2;
  let x = Math.sin(middle) * r;
  let y = -Math.cos(middle) * r;
  let maxWidth = measured.width + LABEL_RECT_WIDTH_PADDING;
  if (middle < Math.PI) {
    let w = Math.abs(view.x + view.width - (x + offset.x));
    if (w < maxWidth) {
      maxWidth = w;
    }
  } else {
    let w = Math.abs(view.x - (x + offset.x));
    if (w < maxWidth) {
      maxWidth = w;
    }
  }
  if (maxWidth < measured.minReqWidth) {
    return null;
  }
  let bounds = {
    x,
    y,
    width: maxWidth,
    height: measured.height
  };
  if (middle < Math.PI) {
    bounds.anchor = 'start';
  } else {
    bounds.anchor = 'end';
  }
  return bounds;
}
function cbContext$1(node, chart) {
  return {
    node,
    data: node.data,
    scale: chart.scale,
    formatter: chart.formatter,
    dataset: chart.dataset
  };
}
function placeTextOnPoint(rect, text, opts) {
  const label = {
    type: 'text',
    text,
    maxWidth: rect.width,
    x: rect.x,
    y: rect.y + (rect.baseline === 'top' ? rect.height / 2 : 0),
    fill: opts.fill,
    anchor: rect.anchor || 'start',
    baseline: 'middle',
    fontSize: "".concat(opts.fontSize, "px"),
    fontFamily: opts.fontFamily
  };
  if (!isNaN(rect.angle)) {
    let angle = rect.angle * (360 / (Math.PI * 2));
    label.transform = "rotate(".concat(angle, ", ").concat(label.x, ", ").concat(label.y, ")");
  }
  return label;
}
function getSliceRect(_ref8) {
  let {
    slice,
    direction,
    position,
    padding,
    measured,
    view,
    context,
    store
  } = _ref8;
  let {
    start,
    end,
    innerRadius,
    offset
  } = slice;
  let bounds;
  let s;
  switch (position) {
    case 'into':
      if (direction === 'rotate') {
        bounds = getRotatedInsideSliceRect({
          slice,
          measured,
          padding
        });
      } else {
        bounds = getHorizontalIntoSliceRect({
          slice,
          measured,
          padding
        });
      }
      break;
    case 'inside':
      s = {
        start,
        end,
        innerRadius: 0,
        outerRadius: innerRadius
      };
      if (direction === 'rotate') {
        bounds = getRotatedInsideSliceRect({
          slice: s,
          measured,
          padding
        });
      } else {
        bounds = getHorizontalInsideSliceRect({
          slice: s,
          measured,
          padding,
          store
        });
      }
      break;
    case 'outside':
      if (direction === 'rotate') {
        bounds = getRotatedOusideSliceRect({
          slice,
          measured,
          padding,
          view
        });
      } else {
        bounds = getHorizontalOusideSliceRect({
          slice,
          measured,
          padding,
          view,
          context
        });
      }
      break;
    default:
      throw new Error('not implemented');
  }
  if (bounds) {
    bounds.x += offset.x;
    bounds.y += offset.y;
    if (position === 'outside' && direction !== 'rotate') {
      adjustBounds(bounds, context, slice);
    }
  }
  return bounds;
}
function findBestPlacement(_ref9) {
  let {
    context,
    direction,
    measured,
    node,
    placementSettings,
    rect,
    store
  } = _ref9;
  let sliceRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSliceRect;
  for (let p = 0; p < placementSettings.length; p++) {
    let placement = placementSettings[p];
    let bounds = sliceRect({
      context,
      slice: node.desc.slice,
      view: rect,
      direction,
      position: placement.position,
      measured,
      padding: placement.padding,
      store
    });
    if (!bounds) {
      continue;
    }
    return {
      bounds,
      placement
    };
  }
  return {
    bounds: null,
    placement: null
  };
}

/*
 * Sorts the nodes so that
 *   in each quarter sort nodes from the center (in y) outwards
 *   first quarter before the second
 *   forth quarter before the third
 */
function sortNodes(nodes) {
  const q1 = [];
  const q2 = [];
  const q3 = [];
  const q4 = [];
  for (let i = 0; i < nodes.length; ++i) {
    const {
      start,
      end
    } = nodes[i].desc.slice;
    const middle = normalize((start + end) / 2);
    let section = Math.floor(middle / (Math.PI / 2));
    switch (section) {
      case 0:
        q1.push(nodes[i]);
        break;
      case 1:
        q2.push(nodes[i]);
        break;
      case 2:
        q3.push(nodes[i]);
        break;
      case 3:
        q4.push(nodes[i]);
        break;
    }
  }
  const sortFn = (a, b) => {
    const middleA = normalize((a.desc.slice.start + a.desc.slice.end) / 2);
    const middleB = normalize((b.desc.slice.start + b.desc.slice.end) / 2);
    return middleA - middleB;
  };
  const reverseSortFn = (a, b) => sortFn(b, a);
  q1.sort(reverseSortFn);
  q2.sort(sortFn);
  q3.sort(reverseSortFn);
  q4.sort(sortFn);
  return q1.concat(q2, q4, q3);
}
function measureText$1(text, stgns, renderer) {
  const fontFamily = stgns.fontFamily;
  const fontSize = "".concat(stgns.fontSize, "px");
  const metrics = renderer.measureText({
    text,
    fontFamily,
    fontSize
  });
  metrics.minReqWidth = Math.min(metrics.width, renderer.measureText({
    text: "".concat(text[0], "\u2026"),
    fontFamily,
    fontSize
  }).width);
  return metrics;
}

/**
 * @typedef {object} ComponentLabels~SlicesLabelStrategy
 * @property {'slice'} type Name of strategy
 */

/**
 * Slices strategy settings
 * @typedef {object} ComponentLabels~SlicesLabelStrategy.settings
 * @property {string|function} [direction='horizontal'] - The direction of the text: 'horizontal' or 'rotate'.
 * @property {string} [fontFamily='Arial']
 * @property {number} [fontSize=12]
 * @property {Array<object>} labels
 * @property {string|function} labels[].label - The text value
 * @property {function} labels[].linkData - Link data to the label
 * @property {Array<object>} labels[].placements
 * @property {string} [labels[].placements[].position='into'] - 'inside' | 'into' | 'outside' (outside is not implmented yet)
 * @property {string} [labels[].placements[].fill='#333'] - Color of the label
 */

function slices(_ref10) {
  let {
    settings,
    chart,
    nodes,
    rect,
    renderer,
    style
  } = _ref10;
  let findPlacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : findBestPlacement;
  let placer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : placeTextOnPoint;
  const defaults = extend$1({
    fontSize: 12,
    fontFamily: 'Arial',
    fill: '#333',
    padding: 4,
    position: 'into'
  }, style.label);
  defaults.fontSize = parseInt(defaults.fontSize, 10);
  const labelSettings = settings.labels.map(labelSetting => extend$1({}, defaults, settings, labelSetting));
  const placementSettings = settings.labels.map(labelSetting => labelSetting.placements.map(placement => extend$1({}, defaults, settings, labelSetting, placement)));
  const labels = [];
  const store = {
    insideLabelBounds: []
  };
  nodes = sortNodes(nodes);
  const context = {};
  for (let i = 0, len = nodes.length; i < len; i++) {
    const node = nodes[i];
    const arg = cbContext$1(node, chart);
    for (let j = 0; j < labelSettings.length; j++) {
      const lblStngs = labelSettings[j];
      const text = typeof lblStngs.label === 'function' ? lblStngs.label(arg, i) : '';
      if (!text) {
        continue;
      }
      const direction = typeof lblStngs.direction === 'function' ? lblStngs.direction(arg, i) : lblStngs.direction || 'horizontal';
      const linkData = typeof lblStngs.linkData === 'function' ? lblStngs.linkData(arg, i) : undefined;
      const measured = measureText$1(text, lblStngs, renderer);
      const bestPlacement = findPlacement({
        context,
        direction,
        lblStngs,
        measured,
        node,
        placementSettings: placementSettings[j],
        rect,
        store
      });
      const bounds = bestPlacement.bounds;
      const placement = bestPlacement.placement;
      if (bounds && placement) {
        if (placement.position === 'outside' && direction !== 'rotate') {
          updateContext({
            context,
            node,
            bounds
          });
          const topLeftBounds = getTopLeftBounds(bounds);
          if (!rectContainsRect(topLeftBounds, rect)) {
            continue;
          }
        }
        const fill = typeof placement.fill === 'function' ? placement.fill(arg, i) : placement.fill;
        const label = placer(bounds, text, {
          fill,
          fontSize: lblStngs.fontSize,
          fontFamily: lblStngs.fontFamily,
          textMetrics: measured
        });
        if (label) {
          if (typeof linkData !== 'undefined') {
            label.data = linkData;
          }
          labels.push(label);
          if (bounds.line) {
            bounds.line.stroke = fill;
            labels.push(bounds.line);
          }
        }
      }
    }
  }
  return labels;
}

const LINEBREAK_REGEX = /\n+|\r+|\r\n/;
const WHITESPACE_REGEX = /\s/;
const HYPHEN_REGEX = /[a-zA-Z\u00C0-\u00F6\u00F8-\u00FF\u00AD]/;
const NO_BREAK = 0;
const MANDATORY = 1;
const BREAK_ALLOWED = 2;
function includesLineBreak(c) {
  if (typeof c === 'string') {
    return c.search(LINEBREAK_REGEX) !== -1;
  }
  return String(c).search(LINEBREAK_REGEX) !== -1;
}
function includesWhiteSpace(c) {
  return c.search(WHITESPACE_REGEX) !== -1;
}
function hyphenationAllowed(c) {
  /* Latin character set. Excluding numbers, sign and symbol characters, but including soft hyphen */
  return c.search(HYPHEN_REGEX) !== -1;
}
function resolveBreakOpportunity(chunk, i, chunks, mandatory, noBreakAllowed) {
  if (mandatory.some(fn => fn(chunk, i, chunks))) {
    return MANDATORY;
  }
  if (noBreakAllowed.some(fn => fn(chunk, i, chunks))) {
    return NO_BREAK;
  }
  return BREAK_ALLOWED;
}
function cleanEmptyChunks(chunks) {
  if (chunks[0] === '') {
    chunks.shift();
  }
  if (chunks[chunks.length - 1] === '') {
    chunks.pop();
  }
}
function clamp(val, min, max) {
  return Math.max(min, Math.min(max, val));
}
function stringTokenizer() {
  let {
    string,
    separator = '',
    reverse = false,
    measureText = text => ({
      width: text.length,
      height: 1
    }),
    mandatoryBreakIdentifiers = [includesLineBreak],
    noBreakAllowedIdentifiers = [],
    suppressIdentifier = [includesWhiteSpace, includesLineBreak, chunk => chunk === ''],
    hyphenationIdentifiers = [hyphenationAllowed]
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const chunks = String(string).split(separator);
  cleanEmptyChunks(chunks);
  const length = chunks.length;
  const isNotDone = reverse ? p => p >= 0 : p => p < length;
  let position = reverse ? length : -1; // Set init position 1 step before or after to make first next call go to first position

  function peek(peekAt) {
    const i = clamp(peekAt, 0, length - 1);
    const chunk = chunks[i];
    const textMeasure = measureText(chunk);
    const opportunity = resolveBreakOpportunity(chunk, i, chunks, mandatoryBreakIdentifiers, noBreakAllowedIdentifiers);
    return {
      index: i,
      value: chunk,
      breakOpportunity: opportunity,
      suppress: suppressIdentifier.some(fn => fn(chunk, i, chunks)),
      hyphenation: hyphenationIdentifiers.some(fn => fn(chunk, i, chunks)),
      width: textMeasure.width,
      height: textMeasure.height,
      done: false
    };
  }
  function next(jumpToPosition) {
    if (isNaN(jumpToPosition)) {
      if (reverse) {
        position--;
      } else {
        position++;
      }
    } else {
      position = clamp(jumpToPosition, 0, length - 1);
    }
    if (isNotDone(position)) {
      return peek(position);
    }
    return {
      done: true
    };
  }
  return {
    next,
    peek,
    length
  };
}

const HYPHENS_CHAR = '\u2010';
const ELLIPSIS_CHAR = '…';

const BASE = 24;
const PAD = 4;
const BUMP = 1e-12;
const DEFAULT_FONT_HEIGHT = 16;
const DEFAULT_LINE_HEIGHT = 1.2;
const TEXT_REGEX = /^\s*\d+(\.\d+)?px\s*$/i;
function isValidFontSize(val) {
  const type = typeof val;
  if (type === 'string') {
    return TEXT_REGEX.test(val);
  }
  return false;
}
function fontSizeToHeight(fontSize) {
  if (isValidFontSize(fontSize)) {
    const size = parseFloat(fontSize);
    const m = PAD * Math.ceil((size + BUMP) / BASE);
    return size + m;
  }
  return DEFAULT_FONT_HEIGHT;
}
function fontSizeToLineHeight(node) {
  const fontSize = node['font-size'] || node.fontSize;
  if (isValidFontSize(fontSize)) {
    return parseFloat(fontSize) * Math.max(isNaN(node.lineHeight) ? DEFAULT_LINE_HEIGHT : node.lineHeight, 0);
  }
  return DEFAULT_FONT_HEIGHT * DEFAULT_LINE_HEIGHT;
}

function resolveMaxAllowedLines(node) {
  const maxHeight = node.maxHeight;
  const maxLines = Math.max(node.maxLines, 1) || Infinity;
  if (isNaN(maxHeight)) {
    return maxLines;
  }
  const computedLineHeight = fontSizeToLineHeight(node);
  return Math.max(1, Math.min(Math.floor(maxHeight / computedLineHeight), maxLines));
}
function initState$1(node, measureText) {
  return {
    lines: [],
    line: '',
    width: 0,
    maxLines: resolveMaxAllowedLines(node),
    maxWidth: node.maxWidth,
    hyphens: {
      enabled: node.hyphens === 'auto',
      char: HYPHENS_CHAR,
      metrics: measureText(HYPHENS_CHAR)
    }
  };
}
function newLine(state) {
  state.lines.push(state.line);
  state.line = '';
  state.width = 0;
}
function appendToLine(state, token) {
  state.line += token.value;
  state.width += token.width;
}
function insertHyphenAndJump(state, token, iterator) {
  if (token.width > state.maxWidth) {
    return token;
  }
  const startIndex = token.index;
  for (let i = 1; i < 5; i++) {
    const pairToken = iterator.peek(token.index - 1);
    if (!token.hyphenation || !pairToken.hyphenation || token.index === 0) {
      return token;
    }
    if (state.width + state.hyphens.metrics.width <= state.maxWidth) {
      state.line += state.hyphens.char;
      return token;
    }
    if (state.line.length === 1) {
      return token;
    }
    token = iterator.next(startIndex - i);
    state.line = state.line.slice(0, -1);
    state.width -= token.width;
  }
  return token;
}
function breakSequence(state, token, measureText) {
  const charTokenIterator = stringTokenizer({
    string: token.value,
    measureText
  });
  while (state.lines.length < state.maxLines) {
    let charToken = charTokenIterator.next();
    if (charToken.done) {
      break;
    } else if (state.width + charToken.width > state.maxWidth && charToken.breakOpportunity === BREAK_ALLOWED && state.line.length > 0) {
      charToken = state.hyphens.enabled ? insertHyphenAndJump(state, charToken, charTokenIterator) : charToken;
      newLine(state);
      appendToLine(state, charToken);
    } else {
      appendToLine(state, charToken);
    }
  }
}
function breakAll(node, measureText) {
  const text = node.text;
  const iterator = stringTokenizer({
    string: text,
    separator: '',
    measureText,
    noBreakAllowedIdentifiers: [(chunk, i) => i === 0]
  });
  const state = initState$1(node, measureText);
  let reduced = true;
  while (state.lines.length < state.maxLines) {
    let token = iterator.next();
    if (token.done) {
      newLine(state);
      reduced = false;
      break;
    } else if (token.breakOpportunity === MANDATORY) {
      newLine(state);
    } else if (state.width + token.width > state.maxWidth && token.breakOpportunity === BREAK_ALLOWED) {
      if (token.suppress) {
        // Token is suppressable and can be ignored
        state.width += token.width;
      } else {
        token = state.hyphens.enabled ? insertHyphenAndJump(state, token, iterator) : token;
        newLine(state);
        appendToLine(state, token);
      }
    } else {
      appendToLine(state, token);
    }
  }
  return {
    lines: state.lines,
    reduced
  };
}
function breakWord(node, measureText) {
  const text = node.text;
  const iterator = stringTokenizer({
    string: text,
    separator: /(\s|-|\u2010)/,
    measureText
  });
  const state = initState$1(node, measureText);
  let reduced = true;
  while (state.lines.length < state.maxLines) {
    let token = iterator.next();
    if (token.done) {
      newLine(state);
      reduced = false;
      break;
    } else if (token.breakOpportunity === MANDATORY) {
      newLine(state);
    } else if (state.width + token.width > state.maxWidth && token.breakOpportunity === BREAK_ALLOWED) {
      if (token.suppress) {
        // Token is suppressable and can be ignored
        newLine(state);
      } else if (token.width > state.maxWidth) {
        // Single sequence is wider then maxWidth, break sequence into multiple lines
        breakSequence(state, token, measureText);
      } else {
        newLine(state);
        appendToLine(state, token);
      }
    } else {
      appendToLine(state, token);
    }
  }
  return {
    lines: state.lines,
    reduced
  };
}

function generateLineNodes(result, item, halfLead, height) {
  const container = {
    type: 'container',
    children: []
  };
  if (typeof item.id !== 'undefined') {
    // TODO also inherit data attribute and more?
    container.id = item.id;
  }
  let currentY = 0;
  result.lines.forEach((line, i) => {
    const node = extend$1({}, item);
    node.text = line;
    node._lineBreak = true; // Flag node as processed to avoid duplicate linebreak run
    currentY += halfLead; // leading height above

    if (result.reduced && i === result.lines.length - 1) {
      node.text += ELLIPSIS_CHAR;
    } else {
      delete node.maxWidth;
    }
    node.dy = isNaN(node.dy) ? currentY : node.dy + currentY;
    currentY += height;
    currentY += halfLead; // Leading height below
    container.children.push(node);
  });
  return container;
}
function shouldLineBreak(item) {
  // If type text and not already broken into lines
  return item.type === 'text' && !item._lineBreak;
}
function wrappedMeasureText(node, measureText) {
  return text => measureText({
    text,
    fontSize: node.fontSize,
    fontFamily: node.fontFamily
  });
}
function resolveLineBreakAlgorithm(node) {
  const WORDBREAK = {
    'break-all': breakAll,
    'break-word': breakWord
  };
  return WORDBREAK[node.wordBreak];
}

/**
 * Apply wordBreak rules to text nodes.
 * @ignore
 * @param {function} measureText
 * @returns {function} Event function to convert a text node into multiple nodes
 */
function onLineBreak(measureText) {
  return state => {
    const item = state.node;
    if (shouldLineBreak(item)) {
      const wordBreakFn = resolveLineBreakAlgorithm(item);
      if (!wordBreakFn) {
        return;
      }
      const tm = measureText(item);
      if (tm.width > item.maxWidth || includesLineBreak(item.text)) {
        const diff = fontSizeToLineHeight(item) - tm.height;
        const halfLead = diff / 2;
        const result = wordBreakFn(item, wrappedMeasureText(item, measureText));
        state.node = generateLineNodes(result, item, halfLead, tm.height); // Convert node to container
      }
    }
  };
}

function ellipsText(label, measureText) {
  // eslint-disable-line import/prefer-default-export
  const fontFamily = label['font-family'] || label.fontFamily;
  const fontSize = label['font-size'] || label.fontSize;
  const text = typeof label.text === 'string' ? label.text : "".concat(label.text);
  const {
    maxWidth
  } = label;
  if (maxWidth === undefined) {
    return text;
  }
  let textWidth = measureText({
    text,
    fontSize,
    fontFamily
  }).width;
  if (textWidth <= maxWidth) {
    return text;
  }
  let min = 0;
  let max = text.length - 1;
  while (min <= max) {
    let reduceIndex = Math.floor((min + max) / 2);
    let reduceText = text.substr(0, reduceIndex) + ELLIPSIS_CHAR;
    textWidth = measureText({
      text: reduceText,
      fontSize,
      fontFamily
    }).width;
    if (textWidth <= maxWidth) {
      min = reduceIndex + 1;
    } else {
      // textWidth > maxWidth
      max = reduceIndex - 1;
    }
  }
  return text.substr(0, max) + ELLIPSIS_CHAR;
}

/**
 * Currently some browsers, IE11 and Edge confirmed, doesn't support the dominant-baseline svg-attribute and
 * the browser that does, have different implementations. Thus giving an unpredictable result when rendering'
 * text and predicting it's position (ex. in collision detection).
 *
 * To supplement and the aid in aligning/positioning text with various items, this function can be used
 * to follow a common heuristic across supported renderers.
 * @ignore
 * @param {object} textNode
 * @param {string|number} [textNode['font-size']=0] - String in px format or number
 * @param {string} [textNode['dominant-baseline']] - If baseline is omitted dominant-baseline is used
 * @param {string} [textNode.baseline]
 * @returns {number} Delta-y required to adjust for baseline
 */
function baselineHeuristic(textNode) {
  const baseline = textNode.baseline || textNode['dominant-baseline'];
  let dy = 0;
  const fontSize = parseInt(textNode.fontSize || textNode['font-size'], 10) || 0;
  switch (baseline) {
    case 'hanging':
      dy = fontSize * 0.75;
      break;
    case 'text-before-edge':
      dy = fontSize * 0.85;
      break;
    case 'middle':
      dy = fontSize * 0.25;
      break;
    case 'central':
      dy = fontSize * 0.35;
      break;
    case 'mathemetical':
      dy = fontSize / 2;
      break;
    case 'text-after-edge':
    case 'ideographic':
      dy = -fontSize * 0.2;
      break;
    default:
      dy = 0;
      break;
  }
  return dy;
}

const heightCache = {};
const widthCache = {};
const contextCache = {
  fontSize: undefined,
  fontFamily: undefined
};
let context;
function setContext() {
  context = context || document.createElement('canvas').getContext('2d');
}
function isEqual(s1, s2) {
  return !s1 && !s2 || s1 === s2;
}
function setFont(_ref) {
  let {
    fontWeight,
    fontSize,
    fontFamily
  } = _ref;
  if (isEqual(contextCache.fontWeight, fontWeight) && isEqual(contextCache.fontSize, fontSize) && isEqual(contextCache.fontFamily, fontFamily)) {
    return;
  }
  context.font = [fontWeight, fontSize, fontFamily].filter(value => !!value).join(' '); // eslint-disable-line
  contextCache.fontWeight = fontWeight;
  contextCache.fontSize = fontSize;
  contextCache.fontFamily = fontFamily;
}
function measureTextWidth(_ref2) {
  let {
    text,
    fontWeight,
    fontSize,
    fontFamily
  } = _ref2;
  const key = "".concat(text, " ").concat(fontWeight, " ").concat(fontSize, " ").concat(fontFamily);
  if (typeof widthCache[key] !== 'number') {
    setContext();
    setFont({
      fontWeight,
      fontSize,
      fontFamily
    });
    widthCache[key] = context.measureText(text).width;
  }
  return widthCache[key];
}
function measureTextHeight(fontSize) {
  if (typeof heightCache[fontSize] !== 'number') {
    heightCache[fontSize] = fontSizeToHeight(fontSize);
  }
  return heightCache[fontSize];
}

/**
 * @private
 * @param {object} opts
 * @param {string} opts.text - Text to measure
 * @param {string} opts.fontWeight - Font weight, e.g. 'bold'
 * @param {string} opts.fontSize - Font size with a unit definition, ex. 'px' or 'em'
 * @param {string} opts.fontFamily - Font family
 * @return {object} Width and height of text in pixels
 * @example
 * measureText({
 *  text: 'my text',
 *  fontSize: '12px',
 *  fontFamily: 'Arial'
 * }); // returns { width: 20, height: 12 }
 */
function measureText(_ref3) {
  let {
    text,
    fontWeight,
    fontSize,
    fontFamily
  } = _ref3;
  const w = measureTextWidth({
    text,
    fontWeight,
    fontSize,
    fontFamily
  });
  const h = measureTextHeight(fontSize);
  return {
    width: w,
    height: h
  };
}

/**
 * Calculates the bounding rectangle of a text node.
 * The bounding rectangle is a approximate of the "em square" seen here (http://www.w3resource.com/html5-canvas/html5-canvas-text.php)
 * @ignore
 * @param {object} attrs - Text node definition
 * @param {number} [attrs.x] - X-coordinate
 * @param {number} [attrs.y] - Y-coordinate
 * @param {number} [attrs.dx] - Delta x-coordinate
 * @param {number} [attrs.dy] - Delta y-coordinate
 * @param {string} [attrs.anchor] - Text anchor
 * @param {number} [attrs.maxWidth] - Maximum allowed text width
 * @return {object} The bounding rectangle
 */
function calcTextBounds(attrs) {
  let measureFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : measureText;
  const fontSize = attrs['font-size'] || attrs.fontSize;
  const fontFamily = attrs['font-family'] || attrs.fontFamily;
  const textMeasure = measureFn({
    text: attrs.text,
    fontFamily,
    fontSize
  });
  const calWidth = Math.min(attrs.maxWidth || textMeasure.width, textMeasure.width); // Use actual value if max is not set
  const x = attrs.x || 0;
  const y = attrs.y || 0;
  const dx = attrs.dx || 0;
  const dy = (attrs.dy || 0) + baselineHeuristic(attrs);
  const boundingRect = {
    x: 0,
    y: y + dy - textMeasure.height * 0.75,
    // Magic number for alphabetical baseline
    width: calWidth,
    height: textMeasure.height
  };
  const anchor = attrs['text-anchor'] || attrs.anchor;
  if (anchor === 'middle') {
    boundingRect.x = x + dx - calWidth / 2;
  } else if (anchor === 'end') {
    boundingRect.x = x + dx - calWidth;
  } else {
    boundingRect.x = x + dx;
  }
  return boundingRect;
}

/**
 * Calculates the bounding rectangle of a text node. Including any line breaks.
 * @ignore
 * @param {object} node
 * @param {string} node.text - Text to measure
 * @param {number} [node.x=0] - X-coordinate
 * @param {number} [node.y=0] - Y-coordinate
 * @param {number} [node.dx=0] - Delta x-coordinate
 * @param {number} [node.dy=0] - Delta y-coordinate
 * @param {string} [node.anchor='start'] - Text anchor
 * @param {string} [node.fontSize] - Font size
 * @param {string} [node.fontFamily] - Font family
 * @param {string} [node['font-size']] - Font size
 * @param {string} [node['font-family']] - Font family
 * @param {string} [node.wordBreak] - Word-break option
 * @param {number} [node.maxWidth] - Maximum allowed text width
 * @param {number} [node.maxHeight] - Maximum allowed text height. If both maxLines and maxHeight are set, the property that results in the fewest number of lines is used
 * @param {number} [node.maxLines] - Maximum number of lines allowed.
 * @param {number} [node.lineHeight=1.2] - Line height
 * @param {function} [measureFn] - Optional text measure function
 * @return {object} The bounding rectangle
 */
function textBounds(node) {
  let measureFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : measureText;
  const lineBreakFn = resolveLineBreakAlgorithm(node);
  const fontSize = node['font-size'] || node.fontSize;
  const fontFamily = node['font-family'] || node.fontFamily;
  const tm = measureFn({
    text: node.text,
    fontFamily,
    fontSize
  });
  if (lineBreakFn && (tm.width > node.maxWidth || includesLineBreak(node.text))) {
    const resolvedLineBreaks = lineBreakFn(node, text => measureFn({
      text,
      fontFamily,
      fontSize
    }));
    const nodeCopy = extend$1({}, node);
    let maxWidth = 0;
    let widestLine = '';
    for (let i = 0, len = resolvedLineBreaks.lines.length; i < len; i++) {
      let line = resolvedLineBreaks.lines[i];
      line += i === len - 1 && resolvedLineBreaks.reduced ? ELLIPSIS_CHAR : '';
      const width = measureFn({
        text: line,
        fontSize,
        fontFamily
      }).width;
      if (width >= maxWidth) {
        maxWidth = width;
        widestLine = line;
      }
    }
    nodeCopy.text = widestLine;
    const bounds = calcTextBounds(nodeCopy, measureFn);
    bounds.height = fontSizeToLineHeight(node) * resolvedLineBreaks.lines.length;
    return bounds;
  }
  return calcTextBounds(node, measureFn);
}

const LINE_HEIGHT = 1.2;
const CIRCLE_FACTOR = 0.9;
function cbContext(node, chart) {
  return {
    node,
    data: node.data,
    scale: chart.scale,
    formatter: chart.formatter,
    dataset: chart.dataset
  };
}
function placeTextInRect$1(rect, text, opts) {
  const label = {
    type: 'text',
    text,
    maxWidth: rect.width,
    x: 0,
    y: rect.y,
    dx: 0,
    dy: 0,
    fill: opts.fill,
    anchor: 'start',
    baseline: 'alphabetical',
    fontSize: "".concat(opts.fontSize, "px"),
    fontFamily: opts.fontFamily
  };
  const textMetrics = opts.textMetrics;
  if (rect.width < opts.fontSize) {
    return false;
  }
  const wiggleWidth = Math.max(0, rect.width - textMetrics.width);
  label.x = rect.x + opts.align * wiggleWidth;
  label.y = rect.y + textMetrics.height / LINE_HEIGHT;
  return label;
}
function getRectFromCircle(_ref) {
  let {
    cx,
    cy,
    r
  } = _ref;
  return {
    type: 'circle',
    bounds: {
      cx,
      cy,
      r
    }
  };
}
function getSliceBounds(slice) {
  const EPSILON = 1e-12;
  let {
    start,
    end,
    innerRadius,
    outerRadius,
    offset
  } = slice;
  if (Math.abs(start + 2 * Math.PI - end) > EPSILON) {
    return {
      type: null,
      bounds: null
    };
  }
  let r = innerRadius !== 0 ? innerRadius : outerRadius;
  return getRectFromCircle({
    cx: offset.x,
    cy: offset.y,
    r
  });
}
function getBounds(node) {
  if (node.desc && node.desc.slice) {
    return getSliceBounds(node.desc.slice);
  }
  if (node.type === 'circle') {
    return getRectFromCircle(node.attrs);
  }
  if (node.type === 'rect') {
    return {
      type: 'rect',
      bounds: node.bounds
    };
  }
  // defualt to node.bounds ?
  return {
    type: null,
    bounds: null
  };
}

/**
 * @typedef {object} ComponentLabels~RowsLabelStrategy
 * @property {'rows'} type Name of strategy
 */

/**
 * Rows strategy settings
 * @typedef {object} ComponentLabels~RowsLabelStrategy.settings
 * @property {string} [fontFamily='Arial']
 * @property {number} [fontSize=12]
 * @property {number} [justify=0.5]
 * @property {number} [padding=4]
 * @property {Array<object>} labels
 * @property {string|function} labels[].label - The text value
 * @property {function} labels[].linkData - Link data to the label
 * @property {number} [labels[].align=0.5]
 * @property {string|function} [labels[].fill='#333']
 */

function rows(_ref2) {
  let {
    settings,
    chart,
    nodes,
    renderer,
    style
  } = _ref2;
  let placer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : placeTextInRect$1;
  const defaults = extend$1({
    fontSize: 12,
    fontFamily: 'Arial',
    fill: '#333',
    padding: 4,
    align: 0.5,
    justify: 0.5
  }, style.label);
  defaults.fontSize = parseInt(defaults.fontSize, 10);
  const rowSettings = extend$1({}, defaults, settings);
  const labelSettings = settings.labels.map(labelSetting => extend$1({}, rowSettings, labelSetting));
  const labelStruct = {};
  const labels = [];
  for (let i = 0, len = nodes.length; i < len; i++) {
    let node = nodes[i];
    let arg = cbContext(node, chart);
    let {
      type,
      bounds
    } = getBounds(node);
    if (!bounds) {
      continue;
    }
    let totalHeight = 0;
    let measurements = [];
    let texts = [];
    let maxHeight = type === 'circle' ? 2 * bounds.r * CIRCLE_FACTOR : bounds.height;
    totalHeight += rowSettings.padding;
    let j;
    for (j = 0; j < labelSettings.length; j++) {
      let lblStngs = labelSettings[j];
      let text = typeof lblStngs.label === 'function' ? lblStngs.label(arg, i) : '';
      labelStruct.fontFamily = lblStngs.fontFamily;
      labelStruct.fontSize = "".concat(lblStngs.fontSize, "px");
      labelStruct.text = text;
      let measured = renderer.measureText(labelStruct);
      totalHeight += measured.height + lblStngs.padding;
      if (totalHeight > maxHeight) {
        break;
      }
      texts.push(text);
      measurements.push(measured);
    }
    const labelCount = j;
    const wiggleHeight = Math.max(0, maxHeight - totalHeight);
    let currentY;
    if (type === 'circle') {
      currentY = bounds.cy - bounds.r * CIRCLE_FACTOR;
    } else {
      currentY = bounds.y;
    }
    currentY += rowSettings.justify * wiggleHeight + rowSettings.padding;
    for (j = 0; j < labelCount; j++) {
      let lblStngs = labelSettings[j];
      let rect;
      if (type === 'circle') {
        let maxYDistToCenter = Math.max(Math.abs(currentY - bounds.cy), Math.abs(currentY + measurements[j].height - bounds.cy));
        let halfWidth = Math.sqrt(bounds.r * bounds.r - maxYDistToCenter * maxYDistToCenter);
        rect = {
          x: bounds.cx - halfWidth + rowSettings.padding,
          y: currentY,
          width: 2 * halfWidth - 2 * rowSettings.padding,
          height: measurements[j].height
        };
      } else {
        rect = {
          x: bounds.x + rowSettings.padding,
          y: currentY,
          width: bounds.width - 2 * rowSettings.padding,
          height: measurements[j].height
        };
      }
      currentY += measurements[j].height + rowSettings.padding;
      let fill = typeof lblStngs.fill === 'function' ? lblStngs.fill(arg, i) : lblStngs.fill;
      const linkData = typeof lblStngs.linkData === 'function' ? lblStngs.linkData(arg, i) : undefined;
      let label = placer(rect, texts[j], {
        fill,
        align: lblStngs.align,
        fontSize: lblStngs.fontSize,
        fontFamily: lblStngs.fontFamily,
        textMetrics: measurements[j]
      });
      if (label) {
        if (label.text && label.text !== ELLIPSIS_CHAR) {
          const ellipsed = ellipsText(label, renderer.measureText);
          if (ELLIPSIS_CHAR === ellipsed) {
            // don't include label if it's only an ellipsis
            continue;
          }
          label.ellipsed = ellipsed;
        }
        if (typeof linkData !== 'undefined') {
          label.data = linkData;
        }
        labels.push(label);
      }
    }
  }
  return labels;
}

var strategies = {
  bar: bars,
  slice: slices,
  rows
};

/**
 * @typedef {object} ComponentLabels
 * @extends ComponentSettings
 * @property {'labels'} type component type
 * @example
{
  type: 'labels',
  settings: {
    sources: [
      {
        component: 'bars',
        selector: 'rect', // select all 'rect' shapes from the 'bars' component
        strategy: {
          type: 'bar', // the strategy type
          settings: {
            labels: [
              {
                label({ data }) {
                  return data ? data.end.label : '';
                },
                placements: [
                  // label placements in prio order. Label will be placed in the first place it fits into
                  { position: 'inside', fill: '#fff' },
                  { position: 'outside', fill: '#666' },
                ],
              },
            ],
          },
        },
      },
    ],
  },
}
 */

/**
 * Component settings
 * @typedef {object} ComponentLabels.settings
 * @property {Array<ComponentLabels~Source>} sources Source settings
 */

/**
 * @typedef {object} ComponentLabels~Source
 * @property {string} component Key of target component
 * @property {string} selector Shape selector
 * @property {ComponentLabels~BarsLabelStrategy|ComponentLabels~RowsLabelStrategy|ComponentLabels~SlicesLabelStrategy} strategy Strategy settings
 */

function strategy(_ref, fn) {
  let {
    chart,
    source,
    rect,
    renderer,
    style
  } = _ref;
  const component = chart.component(source.component);
  if (!component) {
    return [];
  }
  const nodes = chart.findShapes(source.selector).filter(n => n.key === source.component);
  return fn({
    chart,
    settings: source.strategy.settings,
    nodes,
    rect: {
      x: 0,
      y: 0,
      width: rect.width,
      height: rect.height
    },
    renderer,
    style
  });
}
const labelsComponent = {
  require: ['chart', 'renderer', 'settings'],
  defaultSettings: {
    settings: {},
    style: {
      label: '$label'
    }
  },
  render() {
    const stngs = this.settings.settings;
    const labels = [];
    (stngs.sources || []).forEach(source => {
      if (source.strategy && strategies[source.strategy.type] && source.component) {
        labels.push(...strategy({
          chart: this.chart,
          rect: this.rect,
          renderer: this.renderer,
          source,
          style: this.style
        }, strategies[source.strategy.type]));
      }
    });
    return labels;
  }
};

function labels(picasso) {
  picasso.component('labels', labelsComponent);
}

/**
 * Component settings
 * @typedef {object=}
 * @alias ComponentLegendCat.settings
 */
const DEFAULT_SETTINGS$2 = {
  /**
   * @typedef {object=}
   */
  layout: {
    /**
     * Maximum number of columns (vertical) or rows (horizontal)
     * @type {number=}
     */
    size: 1,
    /**
     * Layout direction. Either `'ltr'` or `'rtl'`
     * @type {string=}
     */
    direction: 'ltr',
    /** Initial scroll offset
     * @type {number=} */
    scrollOffset: 0
  },
  /**
   * Settings applied per item
   * @typedef {object=}
   */
  item: {
    /** Whether to show the current item
     * @type {boolean=} */
    show: true,
    /** Justify item
     * @type {number=} */
    justify: 0.5,
    /** Align item
     * @type {number=} */
    align: 0.5,
    /**
     * @typedef {object=} */
    label: {
      /** Font size in pixels
       * @type {string=} */
      fontSize: '12px',
      /** Font family
       * @type {string=} */
      fontFamily: 'Arial',
      fill: '#595959',
      /** Word break rule, how to apply line break if label text overflows its maxWidth property. Either `'break-word'` or `'break-all'`
       * @type {string=} */
      wordBreak: 'none',
      /** Max number of lines allowed if label is broken into multiple lines (only applicable with wordBreak)
       * @type {number=} */
      maxLines: 2,
      /** Maximum width of label, in px
       * @type {number=} */
      maxWidth: 136,
      /** Line height as a multiple of the font size
       * @type {number=} */
      lineHeight: 1.2
    },
    /**
     * @typedef {object=} */
    shape: {
      /**
       * Type of shape
       * @type {string=} */
      type: 'square',
      /**
       * Size of shape in pixels
       * @type {number=} */
      size: 12
    }
  },
  /**
   * @typedef {object=} */
  title: {
    /** Whether to show the title
     * @type {boolean=} */
    show: true,
    /** Title text. Defaults to the title of the provided data field
     * @type {string=} */
    text: undefined,
    /** Horizontal alignment of the text. Allowed values are `'start'`, `'middle'` and `'end'`
     * @type {string}
     */
    anchor: 'start',
    /** Font size in pixels
     * @type {string=} */
    fontSize: '16px',
    /** Font family
     * @type {string=} */
    fontFamily: 'Arial',
    /** Title color
     * @type {string=} */
    fill: '#595959',
    /** Word break rule, how to apply line break if label text overflows its maxWidth property. Either `'break-word'` or `'break-all'`
     * @type {string=} */
    wordBreak: 'none',
    /** Max number of lines allowed if label is broken into multiple lines, is only appled when `wordBreak` is not set to `'none'`
     * @type {number=} */
    maxLines: 2,
    /** Maximum width of title, in px
     * @type {number=} */
    maxWidth: 156,
    /** Line height as a multiple of the font size
     * @type {number=} */
    lineHeight: 1.25
  },
  /**
   * @typedef {object=} */
  navigation: {
    /**
     * @typedef {object=} */
    button: {
      /**
       * @type {object<string, boolean>=} */
      class: undefined,
      /**
       * @type {function} */
      content: undefined,
      /**
       * @type {number=} */
      tabIndex: undefined
    },
    /** Whether the button should be disabled or not
     * @type {boolean=} */
    disabled: false
  }
};

/**
 * Resolve settings based on input, defaults, and data
 *
 * @ignore
 * @param {legendComponent} comp - The component instance
 */
function resolveSettings(comp) {
  const domain = comp.scale.domain();
  let data = {
    items: []
  };
  const dock = comp.settings.layout.dock;
  if (comp.scale.type === 'threshold-color') {
    const fields = comp.scale.data().fields;
    const sourceField = fields[0];
    let formatter = v => String(v);
    if (comp.settings.formatter) {
      formatter = comp.chart.formatter(comp.settings.formatter);
    } else if (sourceField) {
      formatter = sourceField.formatter();
    }
    for (let i = 0; i < domain.length - 1; i++) {
      const it = {
        value: domain[i],
        label: "".concat(formatter(domain[i]), " - < ").concat(formatter(domain[i + 1]))
      };
      if (sourceField) {
        it.source = {
          field: sourceField.id()
        };
      }
      data.items.push(it);
    }
    const orientation = dock === 'top' || dock === 'bottom' ? 'horizontal' : 'vertical';
    if (orientation === 'vertical') {
      data.items.reverse();
    }
  } else {
    const labels = comp.scale.labels ? comp.scale.labels() : null;
    data.items = domain.map((d, idx) => {
      const datum = comp.scale.datum ? extend$1({}, comp.scale.datum(d)) : {
        value: d
      };
      datum.value = d;
      if (comp.scale.label) {
        datum.label = comp.scale.label(d);
      } else if (labels) {
        datum.label = labels[idx];
      }
      return datum;
    });
  }
  const title = comp.resolver.resolve({
    data: {
      fields: comp.scale.data().fields
    },
    defaults: extend$1(true, {}, DEFAULT_SETTINGS$2.title, comp.style.title),
    settings: comp.settings.settings.title
  });
  const layout = comp.resolver.resolve({
    data: {
      fields: comp.scale.data().fields
    },
    defaults: DEFAULT_SETTINGS$2.layout,
    settings: comp.settings.settings.layout
  });
  const labels = comp.resolver.resolve({
    data,
    defaults: extend$1(true, {}, DEFAULT_SETTINGS$2.item.label, comp.style.item.label),
    settings: (comp.settings.settings.item || {}).label
  });
  const shapeSettings = extend$1(true, {}, (comp.settings.settings.item || {}).shape);
  if (typeof shapeSettings.fill === 'undefined' && comp.settings.scale) {
    shapeSettings.fill = {
      scale: comp.settings.scale
    };
  }
  const symbols = comp.resolver.resolve({
    data,
    defaults: extend$1(true, {}, DEFAULT_SETTINGS$2.item.shape, comp.style.item.shape),
    settings: shapeSettings
  });
  const items = comp.resolver.resolve({
    data,
    defaults: extend$1(true, {}, {
      show: DEFAULT_SETTINGS$2.item.show
    }),
    settings: {
      show: (comp.settings.settings.item || {}).show
    }
  });
  function range(item, i) {
    let v = item.data.value;
    let next = domain[i + 1];
    item.data.value = [v, next];
  }
  if (comp.scale.type === 'threshold-color') {
    const orientation = dock === 'top' || dock === 'bottom' ? 'horizontal' : 'vertical';
    if (orientation === 'vertical') {
      items.items.reverse().forEach(range);
      items.items.reverse();
    } else {
      items.items.forEach(range);
    }
  }
  return {
    title,
    labels,
    symbols,
    items,
    layout
  };
}

/* eslint no-mixed-operators:0 */

function placeTextInRect(rect, label, opts) {
  const textMetrics = opts.textMetrics;
  if (rect.height < textMetrics.height) {
    return false;
  }
  const wiggleWidth = Math.max(0, rect.width - textMetrics.width);
  label.baseline = 'text-before-edge';
  const wiggleHeight = Math.max(0, rect.height - textMetrics.height);
  label.x = rect.x + opts.align * wiggleWidth;
  label.y = rect.y + opts.justify * wiggleHeight + parseInt(label.fontSize, 10) * 0.175; // 0.175 - basline offset

  return label;
}
function wiggleSymbol(container, size, opts) {
  const wiggleWidth = Math.max(0, container.width - size);
  const wiggleHeight = Math.max(0, container.height - size);
  return {
    x: container.x + size / 2 + opts.align * wiggleWidth,
    y: container.y + size / 2 + opts.justify * wiggleHeight
  };
}
function createRenderItem(_ref) {
  let {
    x = 0,
    y,
    item,
    globalMetrics,
    createSymbol,
    direction = 'ltr'
  } = _ref;
  let label = item.label.displayObject;
  let labelBounds = item.label.bounds;
  let symbolItem = item.symbol.meta;
  const rtl = direction === 'rtl';
  let labelRect = {
    x: rtl ? x + globalMetrics.maxLabelBounds.width : x + globalMetrics.maxSymbolSize + globalMetrics.spacing,
    y,
    width: globalMetrics.maxLabelBounds.width,
    height: Math.max(globalMetrics.maxSymbolSize, globalMetrics.maxLabelBounds.height)
  };
  let wiggled = wiggleSymbol({
    x: rtl ? x + globalMetrics.maxLabelBounds.width + globalMetrics.spacing : x,
    y,
    width: globalMetrics.maxSymbolSize,
    height: labelRect.height
  }, symbolItem.size, {
    align: typeof symbolItem.align === 'undefined' ? 0.5 : symbolItem.align,
    justify: typeof symbolItem.justify === 'undefined' ? 0.5 : symbolItem.justify
  });
  const symbol = createSymbol(extend$1({}, symbolItem, wiggled));
  delete symbol.collider;
  label.anchor = rtl ? 'end' : 'start';
  placeTextInRect(labelRect, label, {
    textMetrics: labelBounds,
    fontSize: parseInt(label.fontSize, 10),
    align: 0.0,
    justify: 0.5
  });
  let container = {
    type: 'container',
    data: item.label.displayObject.data,
    children: [symbol, label],
    collider: {
      type: 'rect',
      x,
      y,
      width: globalMetrics.maxItemBounds.width,
      height: globalMetrics.maxItemBounds.height
    }
  };
  return {
    item: container,
    metrics: labelRect
  };
}
function getItemsToRender(_ref2, rect, _ref3) {
  let {
    viewRect
  } = _ref2;
  let {
    itemized,
    create = createRenderItem,
    parallels,
    createSymbol
  } = _ref3;
  const direction = itemized.layout.direction;
  const globalMetrics = itemized.globalMetrics;
  const legendItems = itemized.items;
  const isHorizontal = itemized.layout.orientation === 'horizontal';
  let s = 0;
  const renderItems = [];
  const fixedHeight = globalMetrics.maxItemBounds.height;
  const fixedWidth = globalMetrics.maxItemBounds.width;
  const rowHeight = itemized.layout.margin.vertical + fixedHeight;
  const columnWidth = itemized.layout.margin.horizontal + fixedWidth;
  let x = rect.x;
  let y = rect.y;
  let shift = viewRect.x - rect.x;
  for (let i = 0; i < legendItems.length; i++) {
    let renderItem = create({
      y,
      x: direction === 'rtl' ? viewRect.x + shift + viewRect.width - fixedWidth - (x - rect.x) : x,
      item: legendItems[i],
      globalMetrics,
      direction,
      createSymbol
    });
    if (isHorizontal && x >= viewRect.x - fixedWidth || !isHorizontal && y >= viewRect.y - fixedHeight) {
      renderItems.push(renderItem.item);
    }
    s++;
    if (s >= parallels) {
      s = 0;
      if (isHorizontal) {
        x += columnWidth; // next column
        y = rect.y; // reset y to first row
      } else {
        y += rowHeight; // next row
        x = rect.x; // reset x to first column
      }
    } else if (isHorizontal) {
      y += rowHeight; // next row
    } else {
      x += columnWidth; // next column
    }
    if (!isHorizontal && y > viewRect.y + viewRect.height) {
      break;
    } else if (isHorizontal && x > viewRect.x + viewRect.width) {
      break;
    }
  }
  return renderItems;
}
function itemize$2(_ref4, renderer) {
  let {
    resolved,
    dock
  } = _ref4;
  let label;
  let items = [];
  let item;
  let sourceItems = resolved.items.items;
  let sourceSymbols = resolved.symbols.items;
  let sourceLabels = resolved.labels.items;
  let maxSymbolSize = 0;
  let maxLabelWidth = 0;
  let maxLabelHeight = 0;
  for (let i = 0; i < sourceItems.length; i++) {
    if (sourceItems[i].show === false) {
      continue;
    }
    const text = typeof sourceLabels[i].text !== 'undefined' ? sourceLabels[i].text : sourceLabels[i].data.label || '';
    label = extend$1({}, sourceLabels[i], {
      // create the displayObject here in order to measure it
      type: 'text',
      fontSize: "".concat(parseInt(sourceLabels[i].fontSize, 10), "px"),
      text,
      title: text
    });
    item = {
      symbol: {
        // can't create a displayObject here due to need to wiggle the center position of the symbol later on,
        // just store the object needed later on
        meta: sourceSymbols[i]
      },
      label: {
        displayObject: label,
        bounds: renderer.textBounds(label)
      }
    };
    items.push(item);
    maxSymbolSize = Math.max(sourceSymbols[i].size, maxSymbolSize);
    maxLabelWidth = Math.max(item.label.bounds.width, maxLabelWidth);
    maxLabelHeight = Math.max(item.label.bounds.height, maxLabelHeight);
  }
  return {
    items,
    globalMetrics: {
      spacing: 8,
      maxSymbolSize,
      maxItemBounds: {
        height: Math.max(maxSymbolSize, maxLabelHeight),
        width: maxSymbolSize + 8 + maxLabelWidth
      },
      maxLabelBounds: {
        width: maxLabelWidth,
        height: maxLabelHeight
      }
    },
    layout: {
      margin: {
        vertical: typeof resolved.layout.item.vertical !== 'undefined' ? resolved.layout.item.vertical : 4,
        horizontal: typeof resolved.layout.item.horizontal !== 'undefined' ? resolved.layout.item.horizontal : 4
      },
      mode: resolved.layout.item.mode,
      size: resolved.layout.item.size,
      orientation: dock === 'top' || dock === 'bottom' ? 'horizontal' : 'vertical',
      direction: resolved.layout.item.direction,
      scrollOffset: resolved.layout.item.scrollOffset
    }
  };
}
function extent(itemized, parallels) {
  const count = itemized.items.length;
  const size = Math.ceil(count / parallels);
  const property = itemized.layout.orientation === 'horizontal' ? 'width' : 'height';
  const margin = property === 'width' ? 'horizontal' : 'vertical';
  return itemized.globalMetrics.maxItemBounds[property] * size + (size - 1) * itemized.layout.margin[margin];
}
function spread(itemized, parallels) {
  const size = parallels;
  const property = itemized.layout.orientation === 'horizontal' ? 'height' : 'width';
  const margin = property === 'width' ? 'horizontal' : 'vertical';
  return itemized.globalMetrics.maxItemBounds[property] * size +
  // expected vertical size of items
  (size - 1) * itemized.layout.margin[margin]; // expected spacing between items
}
function parallelize(availableExtent, availableSpread, itemized) {
  const count = itemized.items.length;
  const extentProperty = itemized.layout.orientation === 'horizontal' ? 'width' : 'height';
  const margin = extentProperty === 'width' ? 'horizontal' : 'vertical';
  const extentInPx = itemized.globalMetrics.maxItemBounds[extentProperty] * count + (count - 1) * itemized.layout.margin[margin];
  let numNeeded = Math.ceil(extentInPx / availableExtent);
  if (availableSpread != null) {
    const spreadProperty = itemized.layout.orientation === 'horizontal' ? 'height' : 'width';
    const spreadMargin = spreadProperty === 'width' ? 'horizontal' : 'vertical';
    const spreadMarginSize = itemized.layout.margin[spreadMargin] || 4;
    const numAllowed = Math.floor((availableSpread + spreadMarginSize) / (spreadMarginSize + itemized.globalMetrics.maxItemBounds[spreadProperty]));
    numNeeded = Math.min(numNeeded, numAllowed);
  }
  const numInput = isNaN(itemized.layout.size) ? 1 : itemized.layout.size;
  return Math.max(1, Math.min(numNeeded, numInput));
}
function itemRenderer(legend, _ref5) {
  let {
    onScroll = () => {}
  } = _ref5;
  let itemized;
  let parallels;
  let viewRect;
  let containerRect;
  let offset = null;
  let overflow = 0;
  const api = {
    itemize: obj => {
      itemized = itemize$2(obj, legend.renderer);
      offset = !isNaN(itemized.layout.scrollOffset) ? itemized.layout.scrollOffset : offset; // Set the initial offset
    },
    getItemsToRender: obj => {
      viewRect = obj.viewRect;
      overflow = api.getContentOverflow(viewRect);
      const ext = api.extent();
      offset = Math.max(0, Math.min(offset, overflow));
      containerRect = extend$1({}, viewRect);
      const offsetProperty = api.orientation() === 'horizontal' ? 'x' : 'y';
      containerRect[offsetProperty] -= offset;
      containerRect[offsetProperty === 'x' ? 'width' : 'height'] = ext;
      return getItemsToRender(obj, containerRect, {
        itemized,
        parallels,
        createSymbol: legend.symbol
      });
    },
    parallelize: (availableExtent, availableSpread) => {
      parallels = parallelize(availableExtent, availableSpread, itemized);
      return parallels;
    },
    hasContentOverflow: () => {
      const property = itemized.layout.orientation === 'horizontal' ? 'width' : 'height';
      return extent(itemized, parallels) > viewRect[property];
    },
    getContentOverflow: function () {
      let rect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : viewRect;
      const property = itemized.layout.orientation === 'horizontal' ? 'width' : 'height';
      return Math.max(0, extent(itemized, parallels) - rect[property]);
    },
    getNextSize: () => {
      // TODO - calculate the actual size to next item to ensure alignment
      const property = itemized.layout.orientation === 'horizontal' ? 'width' : 'height';
      const margin = property === 'width' ? 'horizontal' : 'vertical';
      return itemized.globalMetrics.maxItemBounds[property] + itemized.layout.margin[margin];
    },
    getPrevSize: () => {
      // TODO - calculate the actual size to next item to ensure alignment
      const property = itemized.layout.orientation === 'horizontal' ? 'width' : 'height';
      const margin = property === 'width' ? 'horizontal' : 'vertical';
      return itemized.globalMetrics.maxItemBounds[property] + itemized.layout.margin[margin];
    },
    hasNext: () => {
      if (api.orientation() === 'horizontal') {
        return viewRect.x + viewRect.width < containerRect.x + containerRect.width;
      }
      return viewRect.y + viewRect.height < containerRect.y + containerRect.height;
    },
    hasPrev: () => {
      if (api.orientation() === 'horizontal') {
        return containerRect.x < viewRect.x;
      }
      return containerRect.y < viewRect.y;
    },
    next: () => {
      api.scroll(-api.getNextSize());
    },
    prev: () => {
      api.scroll(api.getPrevSize());
    },
    scroll: delta => {
      const current = Math.max(0, Math.min(overflow, offset - delta));
      if (current === offset) {
        return;
      }
      offset = current;
      onScroll();
    },
    offset: () => offset,
    orientation: () => itemized.layout.orientation,
    direction: () => itemized.layout.direction,
    extent: () => extent(itemized, parallels),
    // total amount of space along orientation
    spread: () => spread(itemized, parallels) // total amount of space perpendicular to orientation
  };
  return api;
}

/**
 * Concatenate object keys into a space separated string. Use for transforming a 'class name map' into a class string
 * @private
 * @param  {Object} classMap Object with class names as keys and true or false values depending on if they should be in the returned class string or not
 * @return {String} Space separated string with class names
 */
function classString(classMap) {
  return Object.keys(classMap).filter(className => classMap[className]).join(' ');
}

const DIR = {
  up: '\u25B2',
  right: '\u25B6',
  down: '\u25BC',
  left: '\u25C0'
};
function itemize$1(_ref) {
  let {
    // resolved,
    dock,
    navigation
  } = _ref;
  return {
    layout: {
      orientation: dock === 'top' || dock === 'bottom' ? 'vertical' : 'horizontal'
    },
    navigation
  };
}
function btn(h, _ref2) {
  let {
    size,
    isActive,
    direction,
    nav,
    attrs
  } = _ref2;
  let c = {};
  let content = '';
  const attrsMerged = attrs;
  if (nav && nav.button) {
    if (typeof nav.button.class === 'function') {
      c = nav.button.class({
        direction
      });
    } else if (nav.button.class) {
      c = nav.button.class;
    }
    if (typeof nav.button.content === 'function') {
      content = nav.button.content(h, {
        direction
      });
    }
    if (nav.button.tabIndex !== undefined) {
      attrsMerged.tabindex = nav.button.tabIndex;
    }
  }
  const style = {
    width: "".concat(size, "px"),
    minWidth: "".concat(size, "px"),
    height: "".concat(size, "px")
  };
  if (!Object.keys(c).length) {
    // if no classes are set, add some basic styling
    style.border = '0';
    style.background = 'none';
  }
  if (!isActive || nav && nav.disabled) {
    attrsMerged.disabled = 'disabled';
  }
  return h('button', extend$1({
    class: classString(c),
    style
  }, attrsMerged), [content || h('span', {
    style: {
      pointerEvents: 'none'
    }
  }, [DIR[direction]])]);
}
function render$9(renderer, _ref3, itemized, legend) {
  let {
    rect,
    itemRenderer
  } = _ref3;
  if (!renderer || !renderer.renderArgs) {
    return;
  }
  renderer.size(rect);
  const h = renderer.renderArgs[0];
  const isVertical = itemized.layout.orientation === 'vertical'; // orientation of the navigation (not the legend)
  const isRtl = itemRenderer.direction() === 'rtl';
  const hasNext = itemRenderer.hasNext();
  const hasPrev = itemRenderer.hasPrev();
  if (!hasPrev && !hasNext) {
    renderer.render([]);
    return;
  }
  const buttonSize = 32;
  const order = isVertical ? ['right', 'left'] : ['down', 'up'];
  if (isRtl && isVertical) {
    order.reverse();
  }
  const nodes = [h('div', {
    style: {
      position: 'relative',
      display: 'flex',
      'flex-direction': isVertical ? 'column' : 'row',
      'justify-content': 'center',
      height: '100%',
      pointerEvents: 'auto'
    },
    dir: isRtl && !isVertical ? 'rtl' : 'ltr'
  }, [btn(h, {
    size: buttonSize,
    isActive: hasNext,
    direction: order[0],
    attrs: {
      'data-action': 'next',
      'data-component-key': legend.settings.key
    },
    nav: itemized.navigation
  }), btn(h, {
    size: buttonSize,
    isActive: hasPrev,
    direction: order[1],
    attrs: {
      'data-action': 'prev',
      'data-component-key': legend.settings.key
    },
    nav: itemized.navigation
  })])];
  renderer.render(nodes);
}
function navRenderer(legend) {
  let itemized;
  const nav = {
    itemize: obj => {
      itemized = itemize$1(obj);
    },
    render: obj => render$9(nav.renderer, obj, itemized, legend),
    extent: () => 32,
    spread: () => 64
  };
  return nav;
}

function itemize(_ref, legend) {
  let {
    resolved
  } = _ref;
  if (resolved.title.item.show === false) {
    return null;
  }
  const t = extend$1({}, resolved.title.item, {
    type: 'text'
  });
  if (resolved.layout.item.direction === 'rtl') {
    if (!t.anchor || t.anchor === 'start') {
      t.anchor = 'end';
    } else if (t.anchor === 'end') {
      t.anchor = 'start';
    }
  }
  if (typeof resolved.title.settings.text === 'undefined') {
    const fields = legend.scale.data().fields;
    t.text = fields && fields[0] ? fields[0].title() : '';
  }
  return {
    displayObject: t,
    bounds: legend.renderer.textBounds(t)
  };
}
function render$8(_ref2, renderer, itemized) {
  let {
    rect
  } = _ref2;
  if (!renderer) {
    return;
  }
  const nodes = [];
  renderer.size(rect);
  if (itemized) {
    const align = {
      start: 0,
      end: rect.width,
      middle: rect.width / 2
    };
    nodes.push(extend$1({}, itemized.displayObject, {
      x: align[itemized.displayObject.anchor] || 0,
      y: 0,
      baseline: 'text-before-edge',
      title: itemized.displayObject.text
    }));
  }
  renderer.render(nodes);
}
function titleRenderer(legend) {
  let itemized;
  const api = {
    itemize: obj => {
      itemized = itemize(obj, legend);
    },
    render: obj => {
      render$8(obj, api.renderer, itemized);
    },
    spread: () => itemized ? itemized.bounds.height : 0,
    extent: () => itemized ? itemized.bounds.width : 0
  };
  return api;
}

/* eslint no-mixed-operators:0 */

function layout(rect, display, orientation, _ref) {
  let {
    itemRenderer,
    navigationRenderer,
    titleRenderer,
    isPreliminary = false
  } = _ref;
  let title;
  let content;
  let navigation;
  let preferredSize = 0;
  const paddedRect = {
    x: display.spacing,
    y: display.spacing,
    width: rect.width - 2 * display.spacing,
    height: rect.height - 2 * display.spacing
  };
  title = {
    x: paddedRect.x,
    y: paddedRect.y,
    width: paddedRect.width,
    height: titleRenderer.spread()
  };
  if (orientation === 'horizontal') {
    // const titleAtTop = false;
    // if (titleAtTop) { // this might be a nicer layout sometimes
    //   // |------------------|
    //   // |title             |
    //   // |------------|-----|
    //   // |content     | nav |
    //   // |------------|-----|

    //   // available space for items without navigation UI
    //   const availableExtentForItems = paddedRect.width;
    //   const availableSpreadForItems = paddedRect.height - (title.y + title.height) + 8;
    //   const isRtl = itemRenderer.direction() === 'rtl';
    //   itemRenderer.parallelize(availableExtentForItems, isPreliminary ? undefined : availableSpreadForItems);

    //   const navigationSize = itemRenderer.extent() > availableExtentForItems ? navigationRenderer.extent() : 0;
    //   content = {
    //     x: paddedRect.x,
    //     y: title.y + title.height,
    //     width: paddedRect.width - navigationSize,
    //     height: availableSpreadForItems
    //   };
    //   navigation = {
    //     x: content.x + content.width,
    //     y: title.y + title.height,
    //     width: navigationSize,
    //     height: paddedRect.height - (title.y + title.height) + 8
    //   };

    //   if (isRtl) { // switch navigation and content
    //     navigation.x = content.x;
    //     content.x = navigation.x + navigation.width;
    //     // totalContent.x = navigation.x;
    //   }
    //   preferredSize = title.height + Math.max(navigationRenderer.spread(), itemRenderer.spread());
    // } else {
    // |-----|------------|-----|
    // |title|content     | nav |
    // |-----|------------|-----|

    title = {
      x: paddedRect.x,
      y: paddedRect.y,
      width: titleRenderer.extent(),
      height: titleRenderer.spread()
    };

    // available space for items without navigation UI
    const availableExtentForItems = paddedRect.width - title.width - (title.width ? display.spacing : 0);
    const availableSpreadForItems = paddedRect.height;
    itemRenderer.parallelize(availableExtentForItems, isPreliminary ? undefined : availableSpreadForItems);
    const navigationSize = itemRenderer.extent() > availableExtentForItems ? navigationRenderer.extent() : 0;
    const spread = itemRenderer.spread();
    const navigationSpread = navigationSize ? navigationRenderer.spread() : 0;
    content = {
      x: title.x + title.width + (title.width ? display.spacing : 0),
      y: paddedRect.y + Math.max(0, (navigationSpread - spread) / 2),
      width: paddedRect.width - navigationSize - title.width - (navigationSize ? display.spacing : 0) - (title.width ? display.spacing : 0),
      height: availableSpreadForItems
    };
    navigation = {
      x: content.x + content.width + (navigationSize ? display.spacing : 0),
      y: paddedRect.y,
      width: navigationSize,
      height: paddedRect.height
    };
    title.y = content.y;
    const isRtl = itemRenderer.direction() === 'rtl';
    if (isRtl) {
      // switch title, content and navigation
      navigation.x = paddedRect.x;
      content.x = navigation.x + navigation.width + (navigation.width ? display.spacing : 0);
      title.x = content.x + content.width + (title.width ? display.spacing : 0);
    }
    preferredSize = Math.max(title.height, navigationSpread, itemRenderer.spread());
    // }
  } else {
    // |------------|
    // |title       |
    // |------------|
    // |content     |
    // |------------|
    // |navigation  |
    // |------------|

    const availableExtentForItems = paddedRect.height - title.height - (title.height ? display.spacing : 0);
    const availableSpreadForItems = paddedRect.width;
    itemRenderer.parallelize(availableExtentForItems, isPreliminary ? undefined : availableSpreadForItems);
    const navigationSize = itemRenderer.extent() > availableExtentForItems ? navigationRenderer.extent() : 0;
    navigation = {
      x: paddedRect.x,
      y: paddedRect.y + paddedRect.height - navigationSize,
      width: paddedRect.width,
      height: navigationSize
    };
    content = {
      x: paddedRect.x,
      y: title.y + title.height + (title.height ? display.spacing : 0),
      width: paddedRect.width,
      height: paddedRect.height - title.height - (title.height ? display.spacing : 0) - navigation.height - (navigation.height ? display.spacing : 0)
    };
    preferredSize = Math.max(titleRenderer.extent(), navigationSize ? navigationRenderer.spread() : 0, itemRenderer.spread());
  }
  content = extend$1({}, rect, {
    x: rect.x + content.x,
    y: rect.y + content.y,
    width: content.width,
    height: content.height
  });
  navigation.x += rect.x;
  navigation.y += rect.y;
  title.x += rect.x;
  title.y += rect.y;
  return {
    title: extend$1({}, rect, title),
    content: extend$1({}, rect, content),
    navigation: extend$1({}, rect, navigation),
    orientation,
    preferredSize
  };
}

function update(comp) {
  comp.state.resolved = resolveSettings(comp);
  comp.titleRenderer.itemize({
    resolved: comp.state.resolved,
    dock: comp.settings.layout.dock || 'center'
  });
  comp.itemRenderer.itemize({
    resolved: comp.state.resolved,
    dock: comp.settings.layout.dock || 'center'
  });
  comp.navigationRenderer.itemize({
    resolved: comp.state.resolved,
    dock: comp.settings.layout.dock || 'center',
    navigation: comp.settings.settings.navigation
  });
  comp.state.display = {
    spacing: 8
  };
}
function preferredSize(comp, size) {
  let s = 0;
  const dock = comp.settings.layout.dock || 'center';
  const orientation = dock === 'top' || dock === 'bottom' ? 'horizontal' : 'vertical';
  const d = comp.state.display;
  const tempLayout = layout(size.inner, d, orientation, {
    itemRenderer: comp.itemRenderer,
    navigationRenderer: comp.navigationRenderer,
    titleRenderer: comp.titleRenderer,
    isPreliminary: true
  });
  s += d.spacing; // start padding in both vertical and horizontal mode
  s += tempLayout.preferredSize;
  s += d.spacing; // end padding in both vertical and horizontal mode
  return s;
}
function render$7(legend) {
  const {
    rect,
    settings,
    state,
    itemRenderer,
    navigationRenderer,
    titleRenderer
  } = legend;
  const dock = settings.layout.dock;
  const orientation = dock === 'top' || dock === 'bottom' ? 'horizontal' : 'vertical';
  const l = layout(rect, state.display, orientation, {
    itemRenderer,
    navigationRenderer,
    titleRenderer
  });
  legend.renderer.size(l.content);

  // l.content.x = 0;
  // l.content.y = 0;

  // l.navigation.x += rect.x;
  // l.navigation.y += rect.y;

  // l.title.x += rect.x;
  // l.title.y += rect.y;

  let contentItems = itemRenderer.getItemsToRender({
    viewRect: extend$1({}, l.content, {
      x: 0,
      y: 0
    })
  });
  navigationRenderer.render({
    rect: l.navigation,
    itemRenderer
  });
  titleRenderer.render({
    rect: l.title
  });
  legend.state.views = {
    layout: l
  };
  return contentItems;
}
const component$1 = {
  require: ['chart', 'settings', 'renderer', 'update', 'resolver', 'registries', 'symbol'],
  defaultSettings: {
    settings: {},
    style: {
      item: {
        label: '$label',
        shape: '$shape'
      },
      title: '$title'
    }
  },
  mounted(renderElement) {
    if (renderElement && renderElement.parentNode) {
      this.navigationRenderer.renderer.appendTo(renderElement.parentNode);
      this.titleRenderer.renderer.appendTo(renderElement.parentNode);
      renderElement.parentNode.insertBefore(this.navigationRenderer.renderer.element(), renderElement);
      renderElement.parentNode.insertBefore(this.titleRenderer.renderer.element(), renderElement);
    }
    this.navigationRenderer.render({
      rect: this.state.views.layout.navigation,
      itemRenderer: this.itemRenderer
    });
    this.titleRenderer.render({
      rect: this.state.views.layout.title
    });
  },
  beforeUnmount() {
    this.navigationRenderer.renderer.clear();
    this.titleRenderer.renderer.clear();
  },
  on: {
    panstart() {
      if (this.state.interaction.started) {
        return;
      }
      const contentOverflow = this.itemRenderer.getContentOverflow();
      if (!contentOverflow) {
        return;
      }
      this.state.interaction.started = true;
      this.state.interaction.delta = 0;
    },
    panmove(e) {
      if (!this.state.interaction.started) {
        return;
      }
      const delta = this.itemRenderer.orientation() === 'horizontal' ? (this.itemRenderer.direction() === 'rtl' ? -1 : 1) * e.deltaX : e.deltaY;
      this.itemRenderer.scroll(delta - this.state.interaction.delta);
      this.state.interaction.delta = delta;
    },
    panend() {
      this.state.interaction.started = false;
    },
    scroll(delta) {
      this.itemRenderer.scroll(-delta);
    },
    next() {
      this.itemRenderer.next();
    },
    prev() {
      this.itemRenderer.prev();
    }
  },
  created() {
    this.state = {
      interaction: {}
    };
    this.onScroll = () => {
      const items = render$7(this);
      this.update(items);
    };
    this.itemRenderer = itemRenderer(this, {
      onScroll: this.onScroll
    });
    this.navigationRenderer = navRenderer(this);
    this.titleRenderer = titleRenderer(this);
    this.navigationRenderer.renderer = this.registries.renderer('dom')();
    this.titleRenderer.renderer = this.registries.renderer(this.settings.renderer)();
    update(this);
  },
  preferredSize(obj) {
    return preferredSize(this, obj);
  },
  beforeUpdate() {
    update(this);
  },
  render() {
    return render$7(this);
  },
  beforeDestroy() {
    this.navigationRenderer.renderer.destroy();
    this.titleRenderer.renderer.destroy();
  },
  additionalElements() {
    return [this.titleRenderer.renderer.element(), this.navigationRenderer.renderer.element()];
  },
  _DO_NOT_USE_getInfo() {
    return {
      offset: this.itemRenderer.offset()
    };
  }
};

/**
 * @typedef {object} ComponentLegendCat
 * @extends ComponentSettings
 * @property {'legend-cat'} type component type
 * @property {string} scale Reference to categorical color scale
 * @example
{
  type: 'legend-cat',
  scale: '<categorical-color-scale>',
}
 */

const type$1 = 'legend-cat';
function categoricalLegend(picasso) {
  picasso.component(type$1, component$1);
}

function applyAlignJustify(ctx, node) {
  let wiggle = 0;
  const cmd = {
    type: ctx.state.isVertical ? 'justify' : 'align',
    coord: ctx.state.isVertical ? 'y' : 'x',
    pos: ctx.state.isVertical ? 'height' : 'width',
    fn: ctx.state.isVertical ? 'requiredHeight' : 'requiredWidth'
  };
  wiggle = ctx.state.rect[cmd.pos] - ctx.state.legend.length() - ctx.state.title[cmd.fn]();
  wiggle *= Math.min(1, Math.max(ctx.stgns[cmd.type], 0));
  node[cmd.coord] += wiggle;
}
function generateStopNodes(ctx) {
  const fillScale = ctx.state.legend.fillScale;
  const majorScale = ctx.state.legend.majorScale;
  const stops = fillScale.domain().map(d => ({
    type: 'stop',
    color: fillScale(d),
    offset: Math.min(1, Math.max(0, majorScale.norm(d)))
  }));
  return stops.sort((a, b) => a.offset - b.offset);
}
function createTitleNode(ctx) {
  const state = ctx.state;
  const settings = ctx.stgns;
  const isTickLeft = state.ticks.anchor === 'left';
  const isTickTop = state.ticks.anchor === 'top';
  let x = state.rect.x;
  let y = state.rect.y;
  let textAnchor = 'start';
  if (state.title.anchor === 'left') {
    x += state.title.requiredWidth() - settings.title.padding;
    y += state.title.textMetrics.height;
    y += isTickTop ? state.rect.height - state.title.textBounds.height : 0;
    textAnchor = 'end';
  } else if (state.title.anchor === 'right') {
    x += state.legend.length();
    x += settings.title.padding;
    y += state.title.textMetrics.height;
    y += isTickTop ? state.rect.height - state.title.textBounds.height : 0;
  } else if (state.title.anchor === 'top') {
    x += isTickLeft ? state.rect.width : 0;
    y += state.title.textMetrics.height;
    textAnchor = isTickLeft ? 'end' : 'start';
  }
  const node = {
    tag: 'legend-title',
    type: 'text',
    x,
    y: Math.min(y, state.rect.y + state.rect.height),
    text: settings.title.text,
    fill: settings.title.fill,
    fontSize: settings.title.fontSize,
    fontFamily: settings.title.fontFamily,
    maxWidth: settings.title.maxLengthPx,
    maxLines: settings.title.maxLines,
    wordBreak: settings.title.wordBreak,
    hyphens: settings.title.hyphens,
    lineHeight: settings.title.lineHeight,
    anchor: textAnchor,
    title: settings.title.text
  };
  applyAlignJustify(ctx, node);
  return node;
}
function createLegendRectNode(ctx, stops) {
  const state = ctx.state;
  const settings = ctx.stgns;
  const container = state.rect;
  let x = container.x;
  let y = container.y;
  let width = state.isVertical ? settings.size : state.legend.length();
  let height = state.isVertical ? state.legend.length() : settings.size;
  if (state.ticks.anchor === 'left') {
    x += state.rect.width - settings.size;
  } else if (state.ticks.anchor === 'top') {
    y += state.rect.height - settings.size;
  }
  if (state.title.anchor === 'top') {
    y += state.title.requiredHeight();
  } else if (state.title.anchor === 'left') {
    x += state.title.requiredWidth();
  }
  const node = {
    type: 'rect',
    x,
    y,
    width,
    height,
    fill: {
      type: 'gradient',
      stops,
      degree: state.isVertical ? 90 : 180
    }
  };
  applyAlignJustify(ctx, node);
  return node;
}
function createTickNodes(ctx, legendNode) {
  const state = ctx.state;
  const settings = ctx.stgns;
  let anchor = 'start';
  const rangeSelectorRect = {
    type: 'rect',
    x: legendNode.x,
    y: legendNode.y,
    width: state.isVertical ? 0 : legendNode.width,
    height: state.isVertical ? legendNode.height : 0,
    fill: 'transparent'
  };
  const nodes = state.ticks.values.map(tick => {
    let x = 0;
    let y = 0;
    let dx = 0;
    let dy = 0;
    let baseline = 'alphabetical';
    if (state.isVertical) {
      y = legendNode.y + legendNode.height * tick.pos;
      baseline = tick.pos === 0 ? 'text-before-edge' : 'text-after-edge';
    } else {
      x = legendNode.x + legendNode.width * tick.pos;
    }
    if (state.ticks.anchor === 'right') {
      x = legendNode.x + settings.size + settings.tick.padding;
      rangeSelectorRect.x = legendNode.x + legendNode.width;
    } else if (state.ticks.anchor === 'left') {
      x = legendNode.x - settings.tick.padding;
      anchor = 'end';
    } else if (state.ticks.anchor === 'top') {
      y = legendNode.y - settings.tick.padding;
      dy -= tick.textMetrics.height * 0.25;
      anchor = tick.pos === 0 ? 'start' : 'end';
    } else if (state.ticks.anchor === 'bottom') {
      y = legendNode.y + legendNode.height + settings.tick.padding;
      dy = tick.textMetrics.height * 0.8;
      anchor = tick.pos === 0 ? 'start' : 'end';
      rangeSelectorRect.y = legendNode.y + legendNode.height;
    }
    const node = {
      type: 'text',
      x,
      y,
      dx,
      dy,
      text: tick.label,
      fontSize: settings.tick.fontSize,
      fontFamily: settings.tick.fontFamily,
      fill: settings.tick.fill,
      maxWidth: state.isVertical ? settings.tick.maxLengthPx : Math.min(settings.tick.maxLengthPx, state.legend.length() / 2),
      anchor,
      textBoundsFn: ctx.renderer.textBounds,
      title: tick.label,
      baseline
    };
    return node;
  });
  return {
    type: 'container',
    id: 'legend-seq-ticks',
    children: [...nodes, rangeSelectorRect]
  };
}

function resolveAnchor(dock, anchor, map) {
  const mapped = map[dock];
  if (typeof mapped === 'object') {
    if (mapped.valid.indexOf(anchor) !== -1) {
      return anchor;
    }
    return mapped.default;
  }
  return map.default;
}
function resolveTickAnchor(settings) {
  const dock = settings.layout.dock;
  const anchor = settings.settings.tick.anchor;
  const dockAnchorMap = {
    left: {
      valid: ['left', 'right'],
      default: 'left'
    },
    right: {
      valid: ['left', 'right'],
      default: 'right'
    },
    top: {
      valid: ['top', 'bottom'],
      default: 'top'
    },
    bottom: {
      valid: ['top', 'bottom'],
      default: 'bottom'
    },
    default: 'right'
  };
  return resolveAnchor(dock, anchor, dockAnchorMap);
}
function resolveTitleAnchor(settings) {
  const dockAnchorMap = {
    left: {
      valid: ['top'],
      default: 'top'
    },
    right: {
      valid: ['top'],
      default: 'top'
    },
    top: {
      valid: ['left', 'right'],
      default: 'left'
    },
    bottom: {
      valid: ['left', 'right'],
      default: 'left'
    },
    default: 'top'
  };
  const dock = settings.layout.dock;
  const anchor = settings.settings.title.anchor;
  return resolveAnchor(dock, anchor, dockAnchorMap);
}
function initRect(ctx, size) {
  const rect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  const padding = ctx.stgns.padding;
  rect.x = padding.left;
  rect.y = padding.top;
  rect.width = size.width - padding.left - padding.right;
  rect.height = size.height - padding.top - padding.bottom;
  return rect;
}
function getTicks(ctx, majorScale) {
  const values = majorScale.domain();
  let labels = values;
  let labelFn = ctx.stgns.tick.label;
  if (!labelFn && ctx.formatter) {
    labelFn = ctx.formatter;
  } else if (!labelFn && majorScale.data().fields) {
    labelFn = majorScale.data().fields[0].formatter();
  }
  if (typeof labelFn === 'function') {
    labels = values.map(labelFn).map(String);
  }
  const ticks = values.map((value, i) => {
    const label = labels[i];
    return {
      value,
      label,
      pos: majorScale.norm(parseFloat(value, 10)),
      textMetrics: ctx.renderer.measureText({
        text: label,
        fontSize: ctx.stgns.tick.fontSize,
        fontFamily: ctx.stgns.tick.fontFamily
      })
    };
  });
  return ticks;
}
function initState(ctx) {
  const isVertical = ctx.settings.layout.dock !== 'top' && ctx.settings.layout.dock !== 'bottom';
  const titleStgns = ctx.stgns.title;
  const fillScale = ctx.chart.scale(ctx.stgns.fill);
  const majorScale = ctx.chart.scale(ctx.stgns.major);
  const tickValues = getTicks(ctx, majorScale);
  const tickAnchor = resolveTickAnchor(ctx.settings);
  if (typeof titleStgns.text === 'undefined') {
    const fields = majorScale.data().fields;
    titleStgns.text = fields && fields[0] ? fields[0].title() : '';
  }
  const titleTextMetrics = ctx.renderer.measureText({
    text: titleStgns.text,
    fontSize: titleStgns.fontSize,
    fontFamily: titleStgns.fontFamily
  });
  const titleTextBounds = ctx.renderer.textBounds({
    text: titleStgns.text,
    fontSize: titleStgns.fontSize,
    fontFamily: titleStgns.fontFamily,
    maxLines: titleStgns.maxLines,
    maxWidth: titleStgns.maxLengthPx,
    wordBreak: titleStgns.wordBreak,
    hyphens: titleStgns.hyphens,
    lineHeight: titleStgns.lineHeight
  });
  const state = {
    isVertical,
    nodes: [],
    title: {
      anchor: resolveTitleAnchor(ctx.settings),
      textMetrics: titleTextMetrics,
      textBounds: titleTextBounds,
      requiredWidth: () => {
        if (!titleStgns.show) {
          return 0;
        }
        let w = titleTextBounds.width;
        let mw = titleStgns.maxLengthPx;
        if (!isVertical) {
          w += titleStgns.padding;
          mw += titleStgns.padding;
        }
        return Math.min(w, mw, state.rect.width);
      },
      requiredHeight: () => {
        if (!titleStgns.show) {
          return 0;
        }
        let h = titleTextBounds.height;
        if (isVertical) {
          h += titleStgns.padding;
        }
        return Math.min(h, state.rect.height);
      }
    },
    ticks: {
      values: tickValues,
      anchor: tickAnchor,
      length: Math.min(Math.max(...tickValues.map(t => t.textMetrics.width)), ctx.stgns.tick.maxLengthPx),
      requiredHeight: () => tickAnchor === 'top' ? Math.max(...state.ticks.values.map(t => t.textMetrics.height)) + ctx.stgns.tick.padding : 0,
      height: Math.max(...tickValues.map(t => t.textMetrics.height))
    },
    legend: {
      fillScale,
      majorScale,
      length: () => {
        const pos = isVertical ? 'height' : 'width';
        const fnPos = isVertical ? 'requiredHeight' : 'requiredWidth';
        const len = Math.min(state.rect[pos], state.rect[pos] * ctx.stgns.length) - state.title[fnPos]();
        return Math.max(0, Math.min(len, ctx.stgns.maxLengthPx));
      }
    }
  };
  return state;
}

/**
 * Component settings
 * @typedef {object} ComponentLegendSeq.settings
 * @property {string} fill - Reference to definition of sequential color scale
 * @property {string} major - Reference to definition of linear scale
 * @property {number} [size=15] - Size in pixels of the legend, if vertical is the width and height otherwise
 * @property {number} [length=1] - A value in the range 0-1 indicating the length of the legend node
 * @property {number} [maxLengthPx=250] - Max length in pixels
 * @property {number} [align=0.5] - A value in the range 0-1 indicating horizontal alignment of the legend's content. 0 aligns to the left, 1 to the right.
 * @property {number} [justify=0] - A value in the range 0-1 indicating vertical alignment of the legend's content. 0 aligns to the top, 1 to the bottom.
 * @property {object} [padding]
 * @property {number} [padding.left=5] - Size in pixels
 * @property {number} [padding.right=5] - Size in pixels
 * @property {number} [padding.top=5] - Size in pixels
 * @property {number} [padding.bottom=5] - Size in pixels
 * @property {object} [tick]
 * @property {function} [tick.label] - Function applied to all tick values. Return value should be a string and is used as label
 * @property {string} [tick.fill='#595959'] - Tick color
 * @property {string} [tick.fontSize='12px'] - Font size in pixels
 * @property {string} [tick.fontFamily='Arial'] - Font family
 * @property {number} [tick.maxLengthPx=150] - Max length in pixels
 * @property {string} [tick.anchor=''] - Where to anchor the tick in relation to the legend node, supported values are [top, bottom, left and right] or empty string to auto anchor
 * @property {number} [tick.padding=5] - padding in pixels to the legend node
 * @property {object} [title] - Title settings
 * @property {boolean} [title.show=true] - Toggle title on/off
 * @property {string} [title.text=''] - Title text. Defaults to the title of the provided data field
 * @property {string} [title.fill='#595959'] - Title color
 * @property {string} [title.fontSize='12px'] - Font size in pixels
 * @property {string} [title.fontFamily='Arial'] - Font family
 * @property {number} [title.maxLengthPx=100] - Max length in pixels
 * @property {number} [title.padding=5] - padding in pixels to the legend node
 * @property {string} [title.anchor=''] - Where to anchor the title in relation to the legend node, supported values are [top, left and right] or empty string to auto anchor
 * @property {string} [title.wordBreak='none'] - How overflowing title is handled, if it should insert line breaks at word boundries (break-word) or character boundries (break-all)
 * @property {string} [title.hyphens='auto'] - How words should be hyphenated when text wraps across multiple lines (only applicable with wordBreak)
 * @property {number} [title.maxLines=2] - Number of allowed lines if title contains line breaks (only applicable with wordBreak)
 * @property {number} [title.lineHeight=1.2] - A multiplier defining the distance between lines (only applicable with wordBreak)
 */

const legendDef = {
  require: ['chart', 'settings', 'renderer'],
  defaultSettings: {
    layout: {
      displayOrder: 0,
      dock: 'right'
    },
    settings: {
      size: 15,
      length: 0.5,
      maxLengthPx: 250,
      align: 0.5,
      justify: 0,
      padding: {
        left: 5,
        right: 5,
        top: 5,
        bottom: 5
      },
      tick: {
        label: null,
        fill: '#595959',
        fontSize: '12px',
        fontFamily: 'Arial',
        maxLengthPx: 100,
        anchor: null,
        // Use default based on dock
        padding: 5
      },
      title: {
        show: true,
        text: undefined,
        fill: '#595959',
        fontSize: '12px',
        fontFamily: 'Arial',
        maxLengthPx: 100,
        padding: 5,
        maxLines: 2,
        wordBreak: 'none',
        lineHeight: 1.2,
        hyphens: 'auto',
        anchor: null // Use default based on dock
      }
    }
  },
  preferredSize(opts) {
    const state = this.state;
    state.rect = initRect(this, opts.inner);

    // Init with size of legend
    let prefSize = this.stgns.size;

    // Append paddings
    const paddings = state.isVertical ? this.stgns.padding.left + this.stgns.padding.right : this.stgns.padding.top + this.stgns.padding.bottom;
    prefSize += paddings;

    // Append tick size
    const maxSize = Math.max(opts.inner.width, opts.inner.height);
    if (state.ticks.anchor === 'left' || state.ticks.anchor === 'right') {
      const tHeight = state.ticks.values.reduce((sum, t) => sum + t.textMetrics.height, 0);
      if (tHeight > this.state.legend.length()) {
        return maxSize;
      }
      prefSize += state.ticks.length;
    } else {
      const tWidth = state.ticks.length;
      if (tWidth > this.state.legend.length()) {
        return maxSize;
      }
      prefSize += Math.max(...state.ticks.values.map(t => t.textMetrics.height));
    }
    prefSize += this.stgns.tick.padding;

    // Append or use title size
    if (this.stgns.title.show) {
      if (state.title.anchor === 'left' || state.title.anchor === 'right') {
        prefSize = Math.max(state.title.textBounds.height + paddings, prefSize);
      } else {
        prefSize = Math.max(prefSize, state.title.requiredWidth() + paddings);
      }
    }
    this.state.preferredSize = prefSize;
    return prefSize;
  },
  created() {
    this.stgns = this.settings.settings;
    this.state = initState(this);
  },
  beforeUpdate(opts) {
    this.stgns = opts.settings.settings;
    this.state = initState(this);
  },
  beforeRender(opts) {
    this.state.nodes = [];
    this.state.rect = initRect(this, opts.size);
    if (this.stgns.title.show) {
      const titleNode = createTitleNode(this);
      this.state.nodes.push(titleNode);
    }
    const stopNodes = generateStopNodes(this);
    const rectNode = createLegendRectNode(this, stopNodes);
    const tickNodes = createTickNodes(this, rectNode);
    const targetNode = {
      // The target node enables range selection component to limit its range to a specific area
      id: 'legend-seq-target',
      type: 'container',
      children: [rectNode, tickNodes]
    };
    this.state.nodes.push(targetNode);
  },
  render() {
    return this.state.nodes;
  }
};

/**
 * @typedef {object} ComponentLegendSeq
 * @extends ComponentSettings
 * @property {'legend-seq'} type component type
 * @example
{
  type: 'legend-seq',
  settings: {
    fill: '<sequential-color-scale>',
    major: '<linear-scale>',
  }
}
 */

function sequentialLegend(picasso) {
  picasso.component('legend-seq', legendDef);
}

/**
 * Callback function for layer sort
 * @callback ComponentLine~LayerSort
 * @param {object} a
 * @param {string} a.id
 * @param {Array<DatumExtract>} a.data
 * @param {object} b
 * @param {string} b.id
 * @param {Array<DatumExtract>} b.data
 */

/**
 * Component settings
 * @typedef {object}
 * @alias ComponentLine.settings
 */
const SETTINGS = {
  /**
   * @typedef {object}
   */
  coordinates: {
    /**
     * @type {number} */
    minor: 0.5,
    /**
     * @type {number} */
    major: 0.5,
    /**
     * @type {number=} */
    layerId: 0,
    /**
     * @type {DatumBoolean=} */
    defined: true
  },
  /**
   * @type {boolean=} */
  connect: false,
  /**
   * @type {string=} */
  orientation: 'horizontal',
  /**
   * @typedef {object} */
  layers: {
    /**
     * @type {string=} */
    curve: 'linear',
    /**
     * @type {boolean=} */
    show: true,
    /**
     * @type {ComponentLine~LayerSort=} */
    sort: undefined,
    /**
     * @typedef {object} */
    line: {
      /**
       * @type {string=} */
      stroke: '#ccc',
      /**
       * @type {number=} */
      strokeWidth: 1,
      /**
       * @type {string=} */
      strokeLinejoin: 'miter',
      /**
       * @type {string=} */
      strokeDasharray: undefined,
      /**
       * @type {number=} */
      opacity: 1,
      /**
       * @type {boolean=} */
      show: true,
      /**
       * @type {boolean=} */
      showMinor0: true
    },
    /**
     * @typedef {object} */
    area: {
      /**
       * @type {string=} */
      fill: '#ccc',
      /**
       * @type {number=} */
      opacity: 0.8,
      /**
       * @type {boolean=} */
      show: true
    }
  }
};
function createDisplayLayer(points, _ref) {
  let {
    generatorType,
    item,
    data,
    major,
    minor,
    layerObj,
    stngs
  } = _ref;
  let fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const d = {
    type: 'path',
    points,
    generatorType,
    major,
    minor,
    layerObj,
    stngs,
    opacity: item.opacity,
    stroke: item.stroke,
    strokeWidth: item.strokeWidth,
    strokeLinejoin: item.strokeLinejoin,
    fill: fill || item.fill,
    data
  };
  if (item.strokeDasharray) {
    d.strokeDasharray = item.strokeDasharray;
  }
  return d;
}
function createDisplayLayers(layers, _ref2) {
  let {
    width,
    height,
    missingMinor0,
    stngs
  } = _ref2;
  const nodes = [];
  const layerStngs = stngs.layers || {};
  layers.forEach(layer => {
    const {
      lineObj,
      layerObj,
      areaObj,
      points
    } = layer;
    let minor = {
      size: height,
      p: 'y'
    };
    let major = {
      size: width,
      p: 'x'
    };
    if (stngs.orientation === 'vertical') {
      const temp = extend$1(true, {}, major);
      major = extend$1(true, {}, minor);
      minor = extend$1(true, {}, temp);
    }

    // area layer
    if (layerStngs.area && areaObj.show !== false) {
      nodes.push(createDisplayLayer(points, {
        data: layer.consumableData,
        item: areaObj,
        generatorType: 'area',
        major,
        minor,
        layerObj,
        stngs
      }));
    }

    // main line layer
    if (lineObj && lineObj.show !== false) {
      nodes.push(createDisplayLayer(points, {
        data: layer.consumableData,
        item: lineObj,
        generatorType: "line".concat(minor.p.toUpperCase(), "1"),
        major,
        minor,
        layerObj,
        stngs
      }, 'none'));

      // secondary line layer, used only when rendering area
      if (!missingMinor0 && layerStngs.area && areaObj.show !== false && lineObj.showMinor0 !== false) {
        nodes.push(createDisplayLayer(points, {
          data: layer.consumableData,
          item: lineObj,
          generatorType: "line".concat(minor.p.toUpperCase(), "0"),
          major,
          minor,
          layerObj,
          stngs
        }, 'none'));
      }
    }
  });
  return nodes;
}
function resolve(_ref3) {
  let {
    data,
    stngs,
    rect,
    resolver,
    style,
    domain
  } = _ref3;
  const {
    width,
    height
  } = rect;
  const coordinates = resolver.resolve({
    data,
    defaults: SETTINGS.coordinates,
    settings: stngs.coordinates || {},
    scaled: {
      major: stngs.orientation === 'vertical' ? height : width,
      minor: stngs.orientation === 'vertical' ? width : height
    }
  });

  // there are two cases when a line should be interrupted:
  // 1. When the minor value is undefined (this case is easily handled by the lineGenerator.defined).
  // 2. When a line is moving over a domain that may not coincide with the domain on the major scale.
  // For the second case, dummy points need to be injected in order to create values which will cause gaps as they fulfill the first case.
  // These dummy points need to be injected only when: the domain is discrete, connect !== false and multiple layers are defined
  const injectDummy = !stngs.connect && domain.length > 2 && (typeof stngs.coordinates.layerId === 'function' || typeof stngs.coordinates.layerId === 'object');

  // collect points into layers
  const layerIds = {};
  let numLines = 0;
  for (let i = 0; i < coordinates.items.length; i++) {
    let p = coordinates.items[i];
    let lid = p.layerId;
    if (injectDummy) {
      // inject dummy if the previous point on the major domain is not the same as the prev point on the line's domain.
      // this works only if a datum's value property is the same primitive as in the domain.
      const lastItem = layerIds[lid] ? layerIds[lid].items[layerIds[lid].items.length - 1] : null;
      const lastOrderIdx = lastItem ? domain.indexOf(lastItem.data.major ? lastItem.data.major.value : lastItem.data.value) : null;
      if (lastItem && domain.indexOf(p.data.major ? p.data.major.value : p.data.value) - 1 !== lastOrderIdx) {
        layerIds[lid].items.push({
          dummy: true
        });
      }
    }
    layerIds[lid] = layerIds[lid] || {
      order: numLines++,
      id: lid,
      items: [],
      dataItems: [],
      consumableData: {}
    };
    layerIds[lid].dataItems.push(p.data);
    layerIds[lid].items.push(p);
  }
  const metaLayers = Object.keys(layerIds).map(lid => {
    layerIds[lid].consumableData = _objectSpread2({
      points: layerIds[lid].dataItems
    }, layerIds[lid].dataItems[0]);
    return layerIds[lid];
  });
  const layersData = {
    items: metaLayers.map(layer => layer.consumableData)
  };
  const layerStngs = stngs.layers || {};
  const layersResolved = resolver.resolve({
    data: layersData,
    defaults: {
      curve: SETTINGS.layers.curve,
      show: SETTINGS.layers.show
    },
    settings: {
      curve: layerStngs.curve,
      show: layerStngs.show
    }
  });
  const linesResolved = resolver.resolve({
    data: layersData,
    defaults: extend$1({}, SETTINGS.layers.line, style.line),
    settings: layerStngs.line
  });
  const areasResolved = resolver.resolve({
    data: layersData,
    defaults: extend$1({}, SETTINGS.layers.area, style.area),
    settings: layerStngs.area
  });
  return {
    coordinates,
    metaLayers,
    layers: layersResolved,
    lines: linesResolved,
    areas: areasResolved
  };
}
function calculateVisibleLayers(opts) {
  const {
    metaLayers,
    coordinates,
    layers,
    lines,
    areas
  } = resolve(opts);
  const visibleLayers = [];
  metaLayers.forEach((layer, ix) => {
    const layerObj = layers.items[ix];
    if (layerObj.show === false) {
      return;
    }

    // layerObj.points = [];
    layerObj.datum = layerObj.data;
    layerObj.data = [];
    layerObj.id = layer.id;
    const values = [];
    const points = [];
    let point;
    let pData;
    for (let i = 0; i < layer.items.length; i++) {
      point = layer.items[i];
      pData = point.data;
      if (!point.dummy) {
        if (isNaN(point.major)) {
          continue;
        }
        if (opts.missingMinor0) {
          point.minor0 = coordinates.settings.minor.scale ? coordinates.settings.minor.scale(pData.minor0 ? pData.minor0.value : 0) : 0;
        }
        if (!isNaN(point.minor)) {
          values.push(point.minor);
        }
        layerObj.data.push(point.data);
      }
      points.push(point);
    }
    const median = values.sort((a, b) => a - b)[Math.floor((values.length - 1) / 2)];
    visibleLayers.push({
      layerObj,
      lineObj: lines.items[ix],
      areaObj: areas.items[ix],
      median,
      points,
      consumableData: layer.consumableData
    });
  });
  return visibleLayers;
}
const lineMarkerComponent = {
  require: ['chart', 'resolver'],
  defaultSettings: {
    style: {
      area: '$shape',
      line: '$shape-outline'
    }
  },
  created() {},
  render(_ref4) {
    let {
      data
    } = _ref4;
    // console.log("DATA", data);
    const {
      width,
      height
    } = this.rect;
    this.stngs = this.settings.settings || {};
    const missingMinor0 = !this.stngs.coordinates || typeof this.stngs.coordinates.minor0 === 'undefined';
    const visibleLayers = calculateVisibleLayers({
      data,
      stngs: this.stngs,
      rect: this.rect,
      resolver: this.resolver,
      style: this.style,
      missingMinor0,
      domain: this.stngs.coordinates && this.stngs.coordinates.major && this.stngs.coordinates.major.scale ? this.chart.scale(this.stngs.coordinates.major.scale).domain() : []
    });
    if (this.stngs.layers && this.stngs.layers.sort) {
      const sortable = visibleLayers.map(v => ({
        id: v.layerObj.id,
        data: v.layerObj.data
      })).sort(this.stngs.layers.sort).map(s => s.id);
      visibleLayers.sort((a, b) => sortable.indexOf(a.layerObj.id) - sortable.indexOf(b.layerObj.id));
    } else {
      visibleLayers.sort((a, b) => a.median - b.median);
    }

    // generate visuals
    return createDisplayLayers(visibleLayers, {
      width,
      height,
      missingMinor0,
      stngs: this.stngs
    });
  }
};

/**
 * @typedef {object} ComponentLine
 * @extends ComponentSettings
 * @property {'line'} type component type
 * @example
{
  type: "line",
  data: {
    extract: {
      field: "Year",
      props: {
        sales: { field: "Sales" },
      },
    },
  },
  settings: {
    coordinates: {
      major: { scale: "t" },
      minor: { scale: "y", ref: "sales" },
    },
  },
}
 */

const type = 'line';
function line(picasso) {
  picasso.component(type, lineMarkerComponent);
}

/**
 * @typedef {object}
 * @alias ComponentBrushArea.settings
 */
const DEFAULT_SETTINGS$1 = {
  /**
   * @type {object}
   */
  brush: {
    /**
     * @type {Array<BrushTargetConfig>}
     */
    components: []
  }
};

/**
 * Transform the incoming event into point in the local coordinate system. That is the coordinate system of the component.
 * @private
 * @param {object} ctx - Context
 * @param {object} event - Incoming event, either native event or hammer event
 * @param {boolean} clamp - True to clamp the point inside the component bounds
 * @returns {point}
 */
function getLocalPoint(ctx, event) {
  let clamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let x;
  let y;
  if (typeof event.center === 'object') {
    x = event.center.x;
    y = event.center.y;
  } else {
    x = event.clientX;
    y = event.clientY;
  }
  const localX = x - ctx.state.boundingRect.left;
  const localY = y - ctx.state.boundingRect.top;
  return {
    x: clamp ? Math.max(0, Math.min(localX, ctx.rect.width)) : localX,
    y: clamp ? Math.max(0, Math.min(localY, ctx.rect.height)) : localY
  };
}

/**
 * Transform a local point into a point in the chart coordinate system.
 * @private
 * @param {object} ctx - Context
 * @param {object} p - Point to transform
 * @returns {point}
 */
function localToChartPoint(ctx, p) {
  return {
    x: p.x + ctx.rect.x,
    y: p.y + ctx.rect.y
  };
}

/**
 * Extract and apply default brush configuration.
 * @private
 * @param {object} settings
 * @returns {object[]} An Array of brush configurations
 */
function getBrushConfig(settings) {
  return settings.settings.brush.components.map(b => ({
    key: b.key,
    contexts: b.contexts,
    data: b.data,
    action: b.action || 'set'
  }));
}

/**
 * End all active brush contexts.
 * @private
 * @param {oject} state
 * @param {object} chart - Chart instance
 */
function doEndBrush(state, chart) {
  state.brushConfig.forEach(config => {
    if (Array.isArray(config.contexts)) {
      config.contexts.forEach(context => {
        chart.brush(context).end();
      });
    }
  });
}

/**
 * Convert two points into a rectangle.
 * @private
 * @param {Point} p0
 * @param {Point} p1
 * @returns {Rect}
 */
function toRect(p0, p1) {
  const xMin = Math.min(p0.x, p1.x);
  const yMin = Math.min(p0.y, p1.y);
  const xMax = Math.max(p0.x, p1.x);
  const yMax = Math.max(p0.y, p1.y);
  return {
    x: xMin,
    y: yMin,
    width: xMax - xMin,
    height: yMax - yMin
  };
}

/**
 * Perform a brush on the given area.
 * @private
 * @param {object} ctx
 */
function doAreaBrush(ctx) {
  if (ctx.state.active) {
    const start = localToChartPoint(ctx, ctx.state.start);
    const end = localToChartPoint(ctx, ctx.state.end);
    const shapes = ctx.chart.shapesAt(toRect(start, end), {
      components: ctx.state.brushConfig
    });
    ctx.chart.brushFromShapes(shapes, {
      components: ctx.state.brushConfig
    });
  }
}
function render$6(ctx) {
  ctx.renderer.render([extend$1({
    type: 'rect'
  }, toRect(ctx.state.start, ctx.state.end), ctx.style.area)]);
}
function resetState() {
  return {
    start: {
      x: 0,
      y: 0
    },
    end: {
      x: 0,
      y: 0
    },
    active: false
  };
}
const definition = {
  require: ['chart', 'renderer'],
  defaultSettings: {
    layout: {
      displayOrder: 99
    },
    settings: DEFAULT_SETTINGS$1,
    style: {
      area: '$selection-area-target'
    }
  },
  on: {
    areaStart(e) {
      this.start(e);
    },
    areaMove(e) {
      this.move(e);
    },
    areaEnd(e) {
      this.end(e);
    },
    areaCancel() {
      this.cancel();
    }
  },
  created() {
    this.state = resetState();
  },
  preferredSize() {
    return 0;
  },
  render() {},
  start(e) {
    this.state.boundingRect = this.renderer.element().getBoundingClientRect();
    const p = getLocalPoint(this, e, false);

    // Require event to be inside the component bounds
    if (!testRectPoint({
      x: 0,
      y: 0,
      width: this.rect.width,
      height: this.rect.height
    }, p)) {
      return;
    }
    this.state.brushConfig = getBrushConfig(this.settings);
    this.state.start = getLocalPoint(this, e);
    this.state.active = true;
  },
  move(e) {
    if (!this.state.active) {
      return;
    }
    this.state.end = getLocalPoint(this, e);
    doAreaBrush(this);
    render$6(this);
  },
  end() {
    if (!this.state.active) {
      return;
    }
    this.state = resetState();
    this.renderer.render([]);
  },
  cancel() {
    if (!this.state.active) {
      return;
    }
    doEndBrush(this.state, this.chart);
    this.state = resetState();
    this.renderer.render([]);
  }
};

/**
 * A component that can brush a rectangular area
 * @typedef {object} ComponentBrushArea
 * @extends ComponentSettings
 * @property {'brush-area'} type component type
 * @example
 * {
 *  type: 'brush-area',
 *  brush: {
 *    components: [{ key: '<target-component>', contexts: ['highlight'] }]
 *  }
 * }
 */

function areaBrush(picasso) {
  picasso.component('brush-area', definition);
}

function extractor(nodes, _ref) {
  let {
    chart,
    scale,
    props,
    h
  } = _ref;
  const dataCtx = {
    resources: {
      dataset: chart.dataset,
      scale: chart.scale,
      formatter: chart.formatter
    },
    scale,
    h
  };
  const data = [];
  nodes.forEach(node => {
    if (typeof props.extract === 'function') {
      const ctx = extend$1({
        node
      }, dataCtx);
      data.push(props.extract(ctx));
    }
  });
  return data;
}

function resolveClasses(props, opts) {
  return {
    tooltip: typeof props.tooltipClass === 'function' ? props.tooltipClass({
      dock: opts.dock
    }) : props.tooltipClass,
    content: typeof props.contentClass === 'function' ? props.contentClass({
      dock: opts.dock
    }) : props.contentClass,
    arrow: typeof props.arrowClass === 'function' ? props.arrowClass({
      dock: opts.dock
    }) : props.arrowClass
  };
}
function resolveContent(h, data, style, props) {
  return props.content({
    h,
    style,
    data
  });
}
function render$5(data, placement, _ref) {
  let {
    renderer,
    style,
    props,
    h
  } = _ref;
  const classes = resolveClasses(props, placement);
  const content = resolveContent(h, data, style, props);
  const tooltipDefaultStyle = {
    position: 'relative',
    display: 'inline-block'
  };
  const tooltipNode = h("div", {
    dir: props.direction,
    class: classString(extend$1({
      'pic-tooltip': true
    }, classes.tooltip)),
    style: extend$1(tooltipDefaultStyle, placement.computedTooltipStyle)
  }, h("div", {
    style: style.content,
    class: classString(extend$1({
      'pic-tooltip-content': true
    }, classes.content))
  }, content), h("div", {
    class: classString(extend$1({
      'pic-tooltip-arrow': true
    }, classes.arrow)),
    style: extend$1({}, style.arrow, style["arrow-".concat(placement.dock)], placement.computedArrowStyle)
  }));
  renderer.render(tooltipNode);
  return renderer.element().children[0];
}

// Successfull flow: pending -> active -> fulfilled (only with duration)
// Cancelled flow: pending -> active -> cancelled
// Rejected flow: pending -> rejected
// Debounced flow: pending -> debounced -> pending -> [rejected|fulfilled]
function dispatcherState() {
  const fn = function fn() {};
  const on = {
    pending: [],
    debounced: [],
    active: [],
    cancelled: [],
    rejected: [],
    fulfilled: []
  };
  let state;
  fn.set = s => {
    state = s;
    on[state].forEach(event => event(s));
  };
  fn.on = (key, event) => {
    if (Array.isArray(key)) {
      key.forEach(k => on[k].push(event));
    } else {
      on[key].push(event);
    }
  };
  fn.destroy = () => {
    Object.keys(on).forEach(key => {
      on[key].length = 0;
    });
  };

  // fn.on(['pending', 'debounced', 'active', 'cancelled', 'rejected', 'fulfilled'], (e) => {
  //   console.log(e);
  // });

  return fn;
}
function timeSpanDispatcher(_ref) {
  let {
    defaultDuration,
    defaultDelay
  } = _ref;
  let actionId = null;
  let fulfilledId = null;
  let isActive = false;
  const state = dispatcherState();
  const fn = function fn() {};
  const fulfilled = () => {
    actionId = null;
    fulfilledId = null;
    isActive = false;
    state.set('fulfilled');
  };
  fn.invoke = function (action) {
    let duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDuration;
    let delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultDelay;
    if (actionId) {
      clearTimeout(actionId);
      state.set('debounced');
    }
    state.set('pending');
    actionId = setTimeout(() => {
      action();
      isActive = true;
      actionId = null;
      state.set('active');
    }, delay);
    if (duration > 0) {
      if (fulfilledId) {
        clearTimeout(fulfilledId);
      }
      fulfilledId = setTimeout(fulfilled, duration + Math.max(delay, 0));
    }
  };
  fn.clear = () => {
    if (isActive) {
      state.set('cancelled');
    } else if (actionId) {
      clearTimeout(actionId);
      state.set('rejected');
    }
    if (fulfilledId) {
      clearTimeout(fulfilledId);
    }
    actionId = null;
    fulfilledId = null;
    isActive = false;
  };
  fn.on = (key, event) => {
    state.on(key, event);
  };
  fn.destroy = () => {
    fn.clear();
    state.destroy();
  };
  return fn;
}

function getDockTransform() {
  let offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    left: "translate(-100%,-50%) translateX(".concat(-offset, "px)"),
    right: "translate(".concat(offset, "px, -50%)"),
    top: "translate(-50%, -100%) translateY(".concat(-offset, "px)"),
    bottom: "translate(-50%, ".concat(offset, "px)"),
    inside: "translate(-50%, -50%)"
  };
}
function getDockOffset(width, height) {
  let offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return {
    left: {
      x: -width - offset,
      y: -height / 2
    },
    right: {
      x: offset,
      y: -height / 2
    },
    top: {
      x: -width / 2,
      y: -height - offset
    },
    bottom: {
      x: -width / 2,
      y: offset
    },
    inside: {
      x: -width / 2,
      y: -height / 2
    }
  };
}
function getTooltipLeft(_ref) {
  let {
    options,
    docks,
    dockOffsets,
    targetBounds,
    area,
    width,
    height
  } = _ref;
  const dock = 'top';
  const vx = options.area === 'target' ? docks[dock].x : targetBounds.left + docks[dock].x;
  const vy = options.area === 'target' ? docks[dock].y : targetBounds.top + docks[dock].y;
  const offset = dockOffsets[dock];
  const rect = {
    x: vx + offset.x,
    y: vy + offset.y,
    width,
    height
  };
  let left = docks.top.x;
  if (rect.x < 0 && rect.x + rect.width > area.width) {
    return left;
  }
  if (rect.x < 0) {
    left -= rect.x;
  } else if (rect.x + rect.width > area.width) {
    left -= rect.x + rect.width - area.width;
  }
  return left;
}
function getComputedArrowStyle(offset, borderWidth) {
  const sign = offset > 0 ? '-' : '+';
  offset = Math.abs(offset);
  if (borderWidth === undefined) {
    borderWidth = offset;
  }
  return {
    left: {
      left: '100%',
      top: "calc(50% ".concat(sign, " ").concat(offset, "px)"),
      borderWidth: "".concat(borderWidth, "px")
    },
    right: {
      left: "".concat(-offset * 2, "px"),
      top: "calc(50% ".concat(sign, " ").concat(offset, "px)"),
      borderWidth: "".concat(borderWidth, "px")
    },
    top: {
      left: "calc(50% ".concat(sign, " ").concat(offset, "px)"),
      top: '100%',
      borderWidth: "".concat(borderWidth, "px")
    },
    bottom: {
      left: "calc(50% ".concat(sign, " ").concat(offset, "px)"),
      top: "".concat(-offset * 2, "px"),
      borderWidth: "".concat(borderWidth, "px")
    },
    inside: {
      left: '0px',
      top: '0px',
      borderWidth: '0px'
    }
  };
}
function isInsideArea(area, vx, vy, width, height, offset) {
  const rect = {
    x: vx + offset.x,
    y: vy + offset.y,
    width,
    height
  };
  if (rect.x < 0 || rect.y < 0) {
    return false;
  }
  if (rect.x + rect.width > area.width || rect.y + rect.height > area.height) {
    return false;
  }
  return true;
}

/**
 * @private
 * @param {vx} vx X-coordinate realative to the area
 * @param {vy} vy Y-coordinate realative to the area
 */
function calcOffset(_ref2) {
  let {
    area,
    vx,
    vy,
    width,
    height,
    offset
  } = _ref2;
  const rect = {
    x: vx + offset.x,
    y: vy + offset.y,
    width,
    height
  };
  let offsetX = rect.x < 0 ? -rect.x : 0;
  let offsetY = rect.y < 0 ? -rect.y : 0;
  offsetX += rect.x + rect.width > area.width ? -(rect.x + rect.width - area.width) : 0;
  offsetY += rect.y + rect.height > area.height ? -(rect.y + rect.height - area.height) : 0;
  return {
    x: offsetX,
    y: offsetY
  };
}
function alignToBounds(_ref3) {
  let {
    resources,
    nodes,
    pointer,
    width: elmWidth,
    height: elmHeight,
    options
  } = _ref3;
  const {
    targetBounds
  } = pointer;
  const {
    x,
    y,
    width,
    height
  } = resources.getNodeBoundsRelativeToTarget(nodes[0]);
  const docks = {
    left: {
      x,
      y: y + height / 2
    },
    right: {
      x: x + width,
      y: y + height / 2
    },
    top: {
      x: x + width / 2,
      y
    },
    bottom: {
      x: x + width / 2,
      y: y + height
    },
    inside: {
      x: x + width / 2,
      y: y + height / 2
    }
  };

  // Check if explicit dock
  const dockTransforms = getDockTransform(options.offset);
  const transform = dockTransforms[options.dock];
  if (transform) {
    return {
      computedTooltipStyle: {
        left: "".concat(docks[options.dock].x, "px"),
        top: "".concat(docks[options.dock].y, "px"),
        transform
      },
      computedArrowStyle: getComputedArrowStyle(options.offset)[options.dock],
      dock: options.dock
    };
  }
  const area = {
    width: options.area === 'target' ? targetBounds.width : window.innerWidth,
    height: options.area === 'target' ? targetBounds.height : window.innerHeight
  };
  const dockOffsets = getDockOffset(elmWidth, elmHeight, options.offset);
  const dockOrder = ['top', 'left', 'right', 'bottom', 'inside'];
  for (let i = 0; i < dockOrder.length; i += 1) {
    const dock = dockOrder[i];
    const vx = options.area === 'target' ? docks[dock].x : targetBounds.left + docks[dock].x;
    const vy = options.area === 'target' ? docks[dock].y : targetBounds.top + docks[dock].y;
    if (isInsideArea(area, vx, vy, elmWidth, elmHeight, dockOffsets[dock])) {
      return {
        computedTooltipStyle: {
          left: "".concat(docks[dock].x, "px"),
          top: "".concat(docks[dock].y, "px"),
          transform: dockTransforms[dock]
        },
        computedArrowStyle: getComputedArrowStyle(options.offset)[dock],
        dock
      };
    }
  }
  const left = getTooltipLeft({
    options,
    docks,
    dockOffsets,
    targetBounds,
    area,
    width: elmWidth,
    height: elmHeight
  });
  return {
    computedTooltipStyle: {
      left: "".concat(left, "px"),
      top: "".concat(docks.top.y, "px"),
      transform: dockTransforms.top
    },
    computedArrowStyle: getComputedArrowStyle(options.offset + left - docks.top.x, options.offset).top,
    dock: 'top'
  };
}
function alignToPoint(_ref4) {
  let {
    options,
    pointer,
    width,
    height,
    dockOrder,
    x,
    y
  } = _ref4;
  const {
    targetBounds
  } = pointer;

  // Check if explicit dock
  const dockTransforms = getDockTransform(options.offset);
  const transform = dockTransforms[options.dock];
  if (transform) {
    return {
      computedTooltipStyle: {
        left: "".concat(x, "px"),
        top: "".concat(y, "px"),
        transform
      },
      computedArrowStyle: getComputedArrowStyle(options.offset)[options.dock],
      dock: options.dock
    };
  }
  const area = {
    width: options.area === 'target' ? targetBounds.width : window.innerWidth,
    height: options.area === 'target' ? targetBounds.height : window.innerHeight
  };
  const dockOffsets = getDockOffset(width, height, options.offset);
  const results = [];
  const edgeMargin = 20;
  const vx = options.area === 'target' ? x : targetBounds.left + x;
  const vy = options.area === 'target' ? y : targetBounds.top + y;
  for (let i = 0; i < dockOrder.length; i += 1) {
    const dock = dockOrder[i];
    const offset = calcOffset({
      area,
      vx,
      vy,
      width,
      height,
      offset: dockOffsets[dock]
    });
    const computedTooltipStyle = {
      left: "".concat(x, "px"),
      top: "".concat(y, "px"),
      transform: dockTransforms[dock]
    };
    const computedArrowStyle = getComputedArrowStyle(options.offset)[dock];
    if (offset.x !== 0) {
      computedTooltipStyle.width = "".concat(width - edgeMargin - Math.abs(offset.x), "px");
      if (dock === 'top' || dock === 'bottom') {
        computedTooltipStyle.left = "".concat(x + offset.x, "px");
        computedArrowStyle.left = "calc(50% ".concat(offset.x > 0 ? '-' : '+', " ").concat(Math.abs(offset.x), "px)");
      }
    }
    const result = {
      computedTooltipStyle,
      computedArrowStyle,
      dock,
      rect: {
        width,
        height
      }
    };
    if (offset.x === 0 && offset.y === 0) {
      return result;
    }
    result.offset = offset;
    results.push(result);
  }
  results.sort((a, b) => Math.abs(a.offset.x) - Math.abs(b.offset.x));
  return results[0];
}
function alignToPointer(_ref5) {
  let {
    options,
    pointer,
    width,
    height
  } = _ref5;
  const {
    x,
    y
  } = pointer;
  return alignToPoint({
    x,
    y,
    pointer,
    width,
    height,
    options,
    dockOrder: ['top', 'left', 'right', 'bottom']
  });
}
function alignToSlice(_ref6) {
  let {
    options,
    pointer,
    width,
    height,
    nodes,
    resources
  } = _ref6;
  const node = nodes[0];
  const {
    dx,
    dy
  } = pointer;
  const componentBounds = resources.getComponentBoundsFromNode(node);

  // cx and cy relative to targetBounds
  const center = {
    x: dx + componentBounds.x + componentBounds.width / 2,
    y: dy + componentBounds.y + componentBounds.height / 2
  };
  const {
    start,
    end,
    outerRadius
  } = node.desc.slice;

  // Node origin is at 12 o clock, clockwise, but Math uses 3 a clock, so it's transformed to origin at 3 a clock
  const middle = (start + end) / 2 - Math.PI / 2;
  const PI2 = Math.PI * 2;
  const radians = (middle % PI2 + PI2) % PI2;
  let dockOrder = ['top', 'left', 'right', 'bottom'];
  if (options.dock === 'auto') {
    if (radians <= Math.PI / 4 || radians >= Math.PI * 7 / 4) {
      dockOrder = ['right', 'top', 'bottom', 'left'];
    } else if (radians <= Math.PI * 3 / 4) {
      dockOrder = ['bottom', 'left', 'right', 'top'];
    } else if (radians <= Math.PI * 5 / 4) {
      dockOrder = ['left', 'top', 'bottom', 'right'];
    } else {
      dockOrder = ['top', 'left', 'right', 'bottom'];
    }
  }
  return alignToPoint({
    x: center.x + outerRadius * componentBounds.scaleRatio.x * Math.cos(radians),
    y: center.y + outerRadius * componentBounds.scaleRatio.y * Math.sin(radians),
    pointer,
    width,
    height,
    options,
    dockOrder
  });
}
function getComponentBoundsFromNode(node, pointer, chart) {
  const comp = node.key ? chart.component(node.key) : chart.componentsFromPoint({
    x: pointer.clientX,
    y: pointer.clientY
  })[0];
  if (!comp) {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      scaleRatio: {
        x: 1,
        y: 1
      }
    };
  }
  const componentSize = comp.rect;
  return extend$1({
    scaleRatio: componentSize.scaleRatio
  }, componentSize.computedInner);
}
function getNodeBoundsRelativeToTarget(node, pointer, chart) {
  const componentBounds = getComponentBoundsFromNode(node, pointer, chart);
  const bounds = node.bounds;
  return {
    x: componentBounds.x + pointer.dx + bounds.x,
    y: componentBounds.y + pointer.dy + bounds.y,
    width: bounds.width,
    height: bounds.height
  };
}
const STRATEGIES = {
  bounds: alignToBounds,
  pointer: alignToPointer,
  slice: alignToSlice
};
function placement(_ref7, _ref8) {
  let {
    width,
    height
  } = _ref7;
  let {
    chart,
    state,
    props
  } = _ref8;
  const propCtx = {
    resources: {
      formatter: chart.formatter,
      scale: chart.scale,
      component: chart.component,
      getComponentBoundsFromNode: node => getComponentBoundsFromNode(node, state.pointer, chart),
      getNodeBoundsRelativeToTarget: node => getNodeBoundsRelativeToTarget(node, state.pointer, chart)
    },
    nodes: state.activeNodes,
    pointer: state.pointer,
    width,
    height
  };
  const type = typeof props.placement;
  if (type === 'object' && typeof props.placement.fn === 'function') {
    // Custom placement strategy function
    return props.placement.fn(propCtx);
  }
  let opts = {
    type: 'pointer',
    offset: 8,
    dock: 'auto',
    area: 'viewport'
  };
  if (type === 'function') {
    // Custom placement function
    opts = extend$1(opts, props.placement(propCtx));
  }
  if (type === 'object' && STRATEGIES[props.placement.type]) {
    // Predefined placement function with options
    opts = extend$1(opts, props.placement);
  } else if (type === 'string' && STRATEGIES[props.placement]) {
    // Predefined placement function without options
    opts = extend$1(opts, {
      type: props.placement
    });
  }
  propCtx.options = opts;
  const plcm = STRATEGIES[opts.type](propCtx);
  let {
    x: minX,
    y: minY,
    width: maxX,
    height: maxY
  } = propCtx.resources.getComponentBoundsFromNode(propCtx.nodes[0]);
  minX += propCtx.pointer.dx;
  maxX += minX;
  minY += propCtx.pointer.dy;
  maxY += minY;

  // Clamp tooltip position
  plcm.computedTooltipStyle.left = "".concat(Math.min(Math.max(0, minX, parseFloat(plcm.computedTooltipStyle.left)), maxX), "px");
  plcm.computedTooltipStyle.top = "".concat(Math.min(Math.max(0, minY, parseFloat(plcm.computedTooltipStyle.top)), maxY), "px");
  return plcm;
}

let instance;
function setActive(action) {
  instance = action;
}
function removeActive(action) {
  if (instance === action) {
    instance = null;
    return true;
  }
  return false;
}
function cancelActive(a) {
  if (instance && instance !== a) {
    instance();
  }
}
function remove() {
  instance = null;
}

/**
 * @typedef {object}
 * @alias ComponentTooltip.settings
 */
const DEFAULT_SETTINGS = {
  /**
   * How long the tooltip is visible, in milliseconds
   * @type {number=}
   */
  duration: 8000,
  /**
   * Delay before the tooltip is rendered, in milliseconds
   * @type {number=}
   */
  delay: 500,
  /**
   * Callback function to filter incoming nodes to only a set of applicable nodes. Is called as a part of the `show` event.
   *
   * Should return an array of SceneNodes.
   * @type {function=}
   * @callback
   * @param {SceneNode[]} nodes Array of SceneNodes
   * @returns {SceneNode[]} An array of SceneNodes
   * @example
   * filter: (nodes) => nodes.filter((node) => node.data && typeof node.data.value !== 'undefined')
   */
  filter: nodes => nodes.filter(node => node.data && typeof node.data.value !== 'undefined'),
  /**
   * Callback function called for each node to extract data. Can return any type.
   * @type {function=}
   * @callback
   * @param {object} ctx Callback context
   * @param {SceneNode} ctx.node Node
   * @returns {any} Return data
   * @example
   * (ctx) => ctx.node.data.value
   */
  extract: ctx => ctx.node.data.value,
  /**
   * Callback function to generate content. Should return an array of Virtual DOM Elements.
   * @type {function=}
   * @callback
   * @param {object} ctx Callback context
   * @param {any[]} ctx.data An array of data generated from the `extract` function
   * @param {object} ctx.h A function for creating Virtual DOM Elements. See API reference for preactjs `h` function
   * @returns {object[]} An array of Virtual DOM Elements
   * @example
   * ({ h, data }) => data.map((datum) => h('div', {}, datum))
   */
  content: _ref => {
    let {
      h,
      data
    } = _ref;
    return data.map(datum => h('div', {}, datum));
  },
  /**
   * Comparison function. If evaluted to true, the incoming nodes in the `show` event are ignored. If evaluated to false, any active tooltip is cleared and a new tooltip is queued.
   *
   * The function gets two parameters, the first is the currently active set of nodes, if any, and the second is the incoming set of nodes. By default the two set of nodes are considered equal if their data attributes are the same.
   * @type {function=}
   * @callback
   * @param {SceneNode[]} prev Previous array of SceneNodes
   * @param {SceneNode[]} curr Current array of SceneNodes
   * @returns {boolean}
   */
  isEqual: (prev, curr) => prev.length && prev.length === curr.length && prev.every((p, i) => curr[i] && JSON.stringify(p.data) === JSON.stringify(curr[i].data)),
  /**
   * @typedef {object=}
   */
  placement: {
    /**
     * Available types: [pointer | bounds | slice]
     * @type {string=}
     */
    type: 'pointer',
    /**
     * Docking position of the tooltip. Available positions: [left | right | top | bottom | auto]
     * @type {string=}
     */
    dock: 'auto',
    /**
     * Distance from the content area to the tooltip position, in px.
     * @type {number=}
     */
    offset: 8,
    /**
     * Specify the limiting area, where target is the component area unless the appendTo property is set, in which case it referes to the appendTo element. Viewport is the browser viewport.
     *
     * Available options are: [viewport | target]
     * @type {number=}
     */
    area: 'viewport'
  },
  /**
   * Set tooltip class.
   * @type {object<string, boolean>=}
   */
  tooltipClass: {},
  /**
   * Set content class.
   * @type {object<string, boolean>=}
   */
  contentClass: {},
  /**
   * Set arrow class.
   * @type {object<string, boolean>=}
   */
  arrowClass: {},
  /**
   * Content direction [ltr | rtl]
   * @type {string=}
   */
  direction: 'ltr',
  /**
   * Explicitly set a target element. This allows the tooltip to attach itself outside the picasso container.
   * @type {HTMLElement=}
   */
  appendTo: undefined,
  /**
   * Component lifecycle hook. Called before the tooltip is displayed.
   * @type {function=}
   * @callback
   */
  beforeShow: undefined,
  /**
   * Component lifecycle hook. Called after the tooltip have been displayed.
   * @type {function=}
   * @callback
   */
  afterShow: undefined,
  /**
   * Component lifecycle hook. Called before the tooltip is hidden.
   * @type {function=}
   * @callback
   * @param {object} ctx Callback paramater
   * @param {HTMLElement} ctx.element The element the tooltip is appended to
   */
  beforeHide: undefined,
  /**
   * Component lifecycle hook. Called when the toolip is hidden. By default this deletes the tooltip element.
   * @type {function=}
   * @callback
   * @param {object} ctx Callback paramater
   * @param {HTMLElement} ctx.element The element the tooltip is appended to
   */
  onHide: undefined,
  /**
   * Component lifecycle hook. Called after the tooltip is hidden.
   * @type {function=}
   * @callback
   */
  afterHide: undefined
};
const DEFAULT_STYLE = {
  tooltip: {},
  content: {
    backgroundColor: '$gray-25',
    color: '$font-color--inverted',
    fontFamily: '$font-family',
    fontSize: '$font-size',
    lineHeight: '$line-height',
    borderRadius: '4px',
    padding: '8px',
    opacity: 0.9
  },
  arrow: {
    position: 'absolute',
    width: '0px',
    height: '0px',
    borderStyle: 'solid',
    color: '$gray-25',
    opacity: 0.9
  },
  'arrow-bottom': {
    borderTopColor: 'transparent',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent'
  },
  'arrow-top': {
    borderBottomColor: 'transparent',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent'
  },
  'arrow-right': {
    borderTopColor: 'transparent',
    borderLeftColor: 'transparent',
    borderBottomColor: 'transparent'
  },
  'arrow-left': {
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    borderRightColor: 'transparent'
  }
};
function toPoint(event, _ref2) {
  let {
    chart,
    state
  } = _ref2;
  let x = 0;
  let y = 0;
  if (event.center) {
    x += event.center.x;
    y += event.center.y;
  } else {
    x += event.clientX;
    y += event.clientY;
  }
  // TODO Don't do getBoundingClientRect lookup here. It's performance heavy.
  const chartBounds = chart.element.getBoundingClientRect();
  const targetBounds = state.targetElement.getBoundingClientRect();
  const clientX = x;
  const clientY = y;
  const dx = chartBounds.left - targetBounds.left;
  const dy = chartBounds.top - targetBounds.top;
  const cx = x - chartBounds.left;
  const cy = y - chartBounds.top;
  x -= targetBounds.left;
  y -= targetBounds.top;
  return {
    x,
    // Target point relative to the target bounds
    y,
    dx,
    // Delta from target bounds to the chart bounds
    dy,
    cx,
    // Target point relative to the chart bounds
    cy,
    clientX,
    clientY,
    targetBounds,
    // Target bounding rect
    chartBounds // Chart bounding rect
  };
}
const component = {
  require: ['chart', 'renderer'],
  defaultSettings: {
    settings: DEFAULT_SETTINGS,
    style: DEFAULT_STYLE
  },
  renderer: 'dom',
  on: {
    hide() {
      this.hide();
    },
    show(event) {
      let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.show(event, opts);
    },
    prevent(p) {
      this.prevent(p);
    }
  },
  hide() {
    this.dispatcher.clear();
    this.state.activeNodes = [];
    this.state.pointer = {};
  },
  show(event) {
    let {
      nodes,
      duration,
      delay
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.state.prevent || !this.state.targetElement) {
      return;
    }

    // Set pointer here to always expose latest pointer to invokeRenderer
    this.state.pointer = toPoint(event, this);
    let fNodes;
    if (Array.isArray(nodes)) {
      fNodes = this.props.filter(nodes);
    } else {
      fNodes = this.props.filter(this.chart.shapesAt({
        x: this.state.pointer.cx,
        y: this.state.pointer.cy
      }));
    }
    if (this.props.isEqual(this.state.activeNodes, fNodes)) {
      return;
    }
    this.dispatcher.clear();
    this.state.activeNodes = fNodes;
    if (this.state.activeNodes.length) {
      this.dispatcher.invoke(() => this.invokeRenderer(this.state.activeNodes), duration, delay);
    }
  },
  prevent(p) {
    this.state.prevent = !!p;
  },
  init(settings) {
    this.state = {
      activeNodes: [],
      pointer: {},
      targetElement: null,
      prevent: false
    };
    this.props = settings.settings;
    this.dispatcher = timeSpanDispatcher({
      defaultDuration: this.props.duration,
      defaultDelay: this.props.delay
    });
    const instanceId = this.dispatcher.clear;
    this.dispatcher.on('pending', () => {
      // Cancel only if the active is another instance
      cancelActive(instanceId);
      setActive(instanceId);
      if (typeof this.props.beforeShow === 'function') {
        this.props.beforeShow.call(undefined, {
          resources: {
            formatter: this.chart.formatter,
            scale: this.chart.scale
          }
        });
      }
    });
    this.dispatcher.on(['cancelled', 'fulfilled'], () => {
      const listenerCtx = {
        resources: {
          formatter: this.chart.formatter,
          scale: this.chart.scale
        }
      };
      if (typeof this.props.beforeHide === 'function') {
        this.props.beforeHide.call(undefined, extend$1({
          element: this.state.tooltipElm
        }, listenerCtx));
      }
      if (typeof this.props.onHide === 'function') {
        this.props.onHide.call(undefined, extend$1({
          element: this.state.tooltipElm
        }, listenerCtx));
      } else {
        this.renderer.clear([]); // Hide tooltip
      }
      if (typeof this.props.afterHide === 'function') {
        this.props.afterHide.call(undefined, listenerCtx);
      }
      removeActive(instanceId);
      this.state.tooltipElm = undefined;
    });
    this.dispatcher.on('active', () => {
      if (typeof this.props.afterShow === 'function') {
        this.props.afterShow.call(undefined, {
          element: this.state.tooltipElm,
          resources: {
            formatter: this.chart.formatter,
            scale: this.chart.scale
          }
        });
      }
    });
  },
  created() {
    this.init(this.settings);
  },
  beforeUpdate(_ref3) {
    let {
      settings
    } = _ref3;
    if (this.dispatcher) {
      this.dispatcher.destroy();
      remove();
    }
    this.init(settings);
  },
  render(h) {
    this.h = h;
    return []; // Nothing to render initially.
  },
  beforeDestroy() {
    this.dispatcher.destroy();
    remove();
  },
  appendTo() {
    if (this.props.appendTo) {
      this.state.targetElement = typeof this.props.appendTo === 'function' ? this.props.appendTo({
        resources: {
          formatter: this.chart.formatter,
          scale: this.chart.scale
        }
      }) : this.props.appendTo;
      const {
        width,
        height
      } = this.state.targetElement.getBoundingClientRect();
      this.renderer.destroy();
      this.renderer.size({
        width,
        height
      });
      this.renderer.appendTo(this.state.targetElement);
    } else {
      this.state.targetElement = this.renderer.element();
    }
  },
  mounted() {
    this.appendTo();
  },
  updated() {
    // Append here to, otherwise the picasso displayOrder logic screw things up
    this.appendTo();
  },
  invokeRenderer(nodes) {
    const items = extractor(nodes, this);
    const pseudoElement = render$5(items, {
      style: {
        left: '0px',
        top: '0px',
        visibility: 'hidden'
      }
    }, this);
    const pos = placement(pseudoElement.getBoundingClientRect(), this);
    this.state.tooltipElm = render$5(items, pos, this);
  }
};

/**
 * @typedef {object} ComponentTooltip
 * @extends ComponentSettings
 * @property {'tooltip'} type component type
 * @example
 * picasso.chart({
  settings: {
    interactions: [{
      type: 'native',
      events: {
        mousemove(e) {
          const tooltip = this.chart.component('<tooltip-key>');
          tooltip.emit('show', e);
        },
        mouseleave(e) {
          const tooltip = this.chart.component('<tooltip-key>');
          tooltip.emit('hide');
        }
      }
    }],
    components: [
      {
        key: '<tooltip-key>',
        type: 'tooltip'
      }
    ]
  },
  ...
});
 */

function addTooltip(picasso) {
  picasso.component('tooltip', component);
}

const debugColliderDef = {
  require: ['renderer', 'chart'],
  defaultSettings: {
    settings: {
      target: '',
      selector: '*',
      fill: 'rgba(0, 255, 0, 0.1)',
      stroke: 'lime',
      opacity: 1,
      useOuterRect: false
    }
  },
  on: {
    update() {
      this.draw();
    }
  },
  draw() {
    const shapes = this.chart.findShapes(this.props.selector).filter(s => s.key === this.props.target); // Find all shapes
    const colliders = shapes.filter(s => s.collider).map(s => s.collider);
    colliders.forEach(c => {
      c.fill = this.props.fill;
      c.stroke = this.props.stroke;
      c.opacity = this.props.opacity;
      c.collider = {
        type: null
      };
    });
    this.renderer.render(colliders);
  },
  created() {
    this.props = this.settings.settings;
  },
  resize(_ref) {
    let {
      outer,
      inner
    } = _ref;
    if (this.props.useOuterRect) {
      return outer;
    }
    return inner;
  },
  render() {},
  mounted() {
    this.draw();
  },
  updated() {
    this.props = this.settings.settings;
    this.draw();
  }
};

// src/parse-path.ts
var ARG_LENGTH = {
  a: 7,
  c: 6,
  h: 1,
  l: 2,
  m: 2,
  q: 4,
  s: 4,
  t: 2,
  v: 1,
  z: 0
};
var SEGMENT_PATTERN = /([astvzqmhlc])([^astvzqmhlc]*)/gi;
var NUMBER = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
function parseValues(args) {
  const numbers = args.match(NUMBER);
  return numbers ? numbers.map(Number) : [];
}
function parsePath(path) {
  const data = [];
  const p = String(path).trim();
  if (p[0] !== "M" && p[0] !== "m") {
    return data;
  }
  p.replace(SEGMENT_PATTERN, (_, command, args) => {
    const theArgs = parseValues(args);
    let type = command.toLowerCase();
    let theCommand = command;
    if (type === "m" && theArgs.length > 2) {
      data.push([theCommand, ...theArgs.splice(0, 2)]);
      type = "l";
      theCommand = theCommand === "m" ? "l" : "L";
    }
    if (theArgs.length < ARG_LENGTH[type]) {
      return "";
    }
    data.push([theCommand, ...theArgs.splice(0, ARG_LENGTH[type])]);
    while (theArgs.length >= ARG_LENGTH[type] && theArgs.length && ARG_LENGTH[type]) {
      data.push([theCommand, ...theArgs.splice(0, ARG_LENGTH[type])]);
    }
    return "";
  });
  return data;
}

const PI_X2 = Math.PI * 2;

/**
 * Implementation of F.6.5 https://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
 * @ignore
 * @param {number} rx - Arc x-radius
 * @param {number} ry - Arc y-radius
 * @param {number} rotation - Arc rotation in degrees (0-360)
 * @param {boolean} largeArcFlag
 * @param {boolean} sweepFlag
 * @param {number} endX - X-coordinate for end of arc
 * @param {number} endY - Y-coordinate for end of arc
 * @param {number} startX - X-coordinate for start of arc
 * @param {number} startY - Y-coordinate for start of arc
 * @returns {object}
 */
function arcToCenter(rx, ry, rotation, largeArcFlag, sweepFlag, endX, endY, startX, startY) {
  let startAngle;
  let endAngle;
  let sweepAngle;
  let cx;
  let cy;
  let radiusRatio;
  const rad = toRadians(rotation % 360);

  // F.6.5.1
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const hdx = (startX - endX) / 2;
  const hdy = (startY - endY) / 2;
  const x1d = cos * hdx + sin * hdy;
  const y1d = cos * hdy - sin * hdx;

  // F.6.6
  rx = Math.abs(rx);
  ry = Math.abs(ry);
  radiusRatio = x1d ** 2 / rx ** 2 + y1d ** 2 / ry ** 2;
  if (radiusRatio > 1) {
    radiusRatio = Math.sqrt(radiusRatio);
    rx *= radiusRatio;
    ry *= radiusRatio;
  }

  // F.6.5.2
  const rxry = rx * ry;
  const rxy1d = rx * y1d;
  const ryx1d = ry * x1d;
  const den = rxy1d ** 2 + ryx1d ** 2;
  const num = rxry ** 2 - den;
  let frac = Math.sqrt(Math.max(num / den, 0));
  if (largeArcFlag === sweepFlag) {
    frac = -frac;
  }
  const cxd = frac * (rxy1d / ry);
  const cyd = frac * -(ryx1d / rx);

  // F.6.5.3
  const mx = (startX + endX) / 2;
  const my = (startY + endY) / 2;
  cx = cos * cxd - sin * cyd + mx;
  cy = sin * cxd + cos * cyd + my;

  // F.6.5.6 clockwise angle
  const ux = (x1d - cxd) / rx;
  const uy = (y1d - cyd) / ry;
  const vx = (-x1d - cxd) / rx;
  const vy = (-y1d - cyd) / ry;
  startAngle = Math.atan2(uy, ux);
  startAngle += startAngle < 0 ? PI_X2 : 0;
  endAngle = Math.atan2(vy, vx);
  endAngle += endAngle < 0 ? PI_X2 : 0;
  sweepAngle = endAngle - startAngle;
  if (!sweepFlag && startAngle < endAngle) {
    sweepAngle -= PI_X2;
  } else if (sweepFlag && endAngle < startAngle) {
    sweepAngle += PI_X2;
  }
  sweepAngle %= PI_X2;
  return {
    startAngle,
    sweepAngle,
    cx,
    cy,
    rx,
    ry
  };
}

/**
 * Measure the flatnass of a cubic bezier curve
 * @ignore
 * @param {Point} s - Start point
 * @param {Point} cp1 - First control point
 * @param {Point} cp2 - Second control point
 * @param {Point} e - End point
 */
function flatness(s, cp1, cp2, e) {
  const ux = Math.abs(s.x + cp2.x - (cp1.x + cp1.x));
  const uy = Math.abs(s.y + cp2.y - (cp1.y + cp1.y));
  const vx = Math.abs(cp1.x + e.x - (cp2.x + cp2.x));
  const vy = Math.abs(cp1.y + e.y - (cp2.y + cp2.y));
  return ux + uy + vx + vy;
}

function mid(p0, p1) {
  return {
    x: (p0.x + p1.x) * 0.5,
    y: (p0.y + p1.y) * 0.5
  };
}
function interpolate(t, s, cp1, cp2, e) {
  const td = 1 - t;
  const t0 = td ** 3 * s;
  const t1 = 3 * td ** 2 * t * cp1;
  const t2 = 3 * td * t ** 2 * cp2;
  const t3 = t ** 3 * e;
  return t0 + t1 + t2 + t3;
}

/**
 * Recursive subdivision of a curve using de Casteljau algorithm.
 * Splits the curve into multiple line segments where each segments is choosen based on a level of flatness.
 *
 * At most it will be able to generate 2**maxNbrOfSplits + 1 = 257 points
 * @ignore
 * @param {Point} s - Start point
 * @param {Point} cp1 - First control point
 * @param {Point} cp2 - Second control point
 * @param {Point} e - End point
 * @param {array} points - Initial set of points
 * @returns {point[]} Array of points
 */
function toPoints$1(s, cp1, cp2, e) {
  let points = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  let maxNbrOfSplits = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 8;
  if (maxNbrOfSplits < 1 || flatness(s, cp1, cp2, e) <= 10) {
    if (points[points.length - 1] !== s) {
      points.push(s);
    }
    points.push(e);
    return points;
  }
  const t = 0.5;
  const m0 = mid(s, cp1);
  const m1 = mid(cp1, cp2);
  const m2 = mid(cp2, e);
  const b = {
    // Split curve at point
    x: interpolate(t, s.x, cp1.x, cp2.x, e.x),
    y: interpolate(t, s.y, cp1.y, cp2.y, e.y)
  };
  const q0 = mid(m0, m1); // New cp2 for left curve
  const q1 = mid(m1, m2); // New cp1 for right curve

  toPoints$1(s, m0, q0, b, points, maxNbrOfSplits - 1); // left curve
  toPoints$1(b, q1, m2, e, points, maxNbrOfSplits - 1); // Right curve

  return points;
}

function toCubic(s, cp, e) {
  const cp1x = s.x + 2 / 3 * (cp.x - s.x);
  const cp1y = s.y + 2 / 3 * (cp.y - s.y);
  const cp2x = e.x + 2 / 3 * (cp.x - e.x);
  const cp2y = e.y + 2 / 3 * (cp.y - e.y);
  const cp1 = {
    x: cp1x,
    y: cp1y
  };
  const cp2 = {
    x: cp2x,
    y: cp2y
  };
  return {
    cp1,
    cp2
  };
}

/**
 * Recursive subdivision of a curve using de Casteljau algorithm.
 * Splits the curve into multiple line segments where each segments is choosen based on a level of flatness.
 * @ignore
 * @param {Point} s - Start point
 * @param {Point} cp - Control point
 * @param {Point} e - End point
 * @returns {Point[]} Array of points
 */
function toPoints(s, cp, e) {
  const {
    cp1,
    cp2
  } = toCubic(s, cp, e);
  return toPoints$1(s, cp1, cp2, e);
}

const EPSILON$1 = 1e-12;
function removeDuplicates$2(points) {
  for (let i = 0; i < points.length - 1; i++) {
    const p0 = points[i];
    const p1 = points[i + 1];
    if (Math.abs(p0.x - p1.x) < EPSILON$1 && Math.abs(p0.y - p1.y) < EPSILON$1) {
      points.splice(i, 1);
      i--;
    }
  }
}

/**
 * Transform an arc to a set of points a long the arc.
 * Specifiction F.6 (https://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes)
 * @ignore
 * @param {array} s - Segments
 * @param {number} startX - X-coordinate for start of arc
 * @param {number} startY - Y-coordinate for start of arc
 */
function arcToPoints(s, startX, startY) {
  const points = [];
  const largeArcFlag = !!s[4]; // F.6.3
  const sweepFlag = !!s[5]; // F.6.3
  const rotation = s[3];
  let endX = s[6];
  let endY = s[7];
  let rx = s[1];
  let ry = s[2];
  let cx;
  let cy;
  let sweepAngle;
  let startAngle;
  if (s[0] === 'a') {
    endX += startX;
    endY += startY;
  }

  // F.6.2
  if (startX === endY && startY === endY) {
    return points;
  }

  // Given no radius, threat as lineTo command
  if (!rx || !ry) {
    points.push({
      x: endX,
      y: endY
    });
    return points;
  }
  ({
    cx,
    cy,
    rx,
    ry,
    sweepAngle,
    startAngle
  } = arcToCenter(rx, ry, rotation, largeArcFlag, sweepFlag, endX, endY, startX, startY));

  // Approximation of perimeter
  const p = Math.abs(sweepAngle * Math.sqrt((rx ** 2 + ry ** 2) / 2));

  // Generate a point every 10th pixel. Scaling of the node should probably be included in this calculation
  const res = Math.ceil(p / 10);
  const resAngle = sweepAngle / res;
  for (let k = 1; k <= res; k++) {
    const deltaAngle = resAngle * k;
    const radians = (startAngle + deltaAngle) % PI_X2;
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);
    // F.6.3 https://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
    points.push({
      x: cx + cos * rx + -sin * cos,
      y: cy + sin * ry + cos * sin
    });
  }

  // points.push({ x: cx, y: cy });

  return points;
}

/**
 * Converts a SVG path data string into a set of points.
 * @ignore
 * @param {string} path
 * @returns {Array<point[]>} Array of points
 */
function pathToPoints(path) {
  const commands = parsePath(path);
  const segments = [];
  const points = [];
  let x = 0; // Current point
  let y = 0;
  let cpx = null; // Last control point on a cubic curve
  let cpy = null;
  let qcpx = null; // Last control point on a quad curve
  let qcpy = null;
  for (let i = 0; i < commands.length; ++i) {
    const cmd = commands[i];
    const pathType = cmd[0];

    // Reset control point if command is not cubic
    if (pathType !== 'S' && pathType !== 's' && pathType !== 'C' && pathType !== 'c') {
      cpx = null;
      cpy = null;
    }
    if (pathType !== 'T' && pathType !== 't' && pathType !== 'Q' && pathType !== 'q') {
      qcpx = null;
      qcpy = null;
    }
    switch (pathType) {
      case 'm':
        if (points.length) {
          segments.push(points.splice(0));
        }
      // Fall through
      case 'l':
        // eslint-disable-line no-fallthrough
        x += cmd[1];
        y += cmd[2];
        points.push({
          x,
          y
        });
        break;
      case 'M':
        if (points.length) {
          segments.push(points.splice(0));
        }
      // Fall through
      case 'L':
        // eslint-disable-line no-fallthrough
        x = cmd[1];
        y = cmd[2];
        points.push({
          x,
          y
        });
        break;
      case 'H':
        x = cmd[1];
        points.push({
          x,
          y
        });
        break;
      case 'h':
        x += cmd[1];
        points.push({
          x,
          y
        });
        break;
      case 'V':
        y = cmd[1];
        points.push({
          x,
          y
        });
        break;
      case 'v':
        y += cmd[1];
        points.push({
          x,
          y
        });
        break;
      case 'a':
        points.push(...arcToPoints(cmd, x, y));
        x += cmd[6];
        y += cmd[7];
        break;
      case 'A':
        points.push(...arcToPoints(cmd, x, y));
        x = cmd[6];
        y = cmd[7];
        break;
      case 'c':
        points.push(...toPoints$1({
          x,
          y
        }, {
          x: cmd[1] + x,
          y: cmd[2] + y
        }, {
          x: cmd[3] + x,
          y: cmd[4] + y
        }, {
          x: cmd[5] + x,
          y: cmd[6] + y
        }));
        cpx = cmd[3] + x; // Last control point
        cpy = cmd[4] + y;
        x += cmd[5];
        y += cmd[6];
        break;
      case 'C':
        points.push(...toPoints$1({
          x,
          y
        }, {
          x: cmd[1],
          y: cmd[2]
        }, {
          x: cmd[3],
          y: cmd[4]
        }, {
          x: cmd[5],
          y: cmd[6]
        }));
        cpx = cmd[3]; // Last control point
        cpy = cmd[4];
        x = cmd[5];
        y = cmd[6];
        break;
      case 's':
        if (cpx === null || cpx === null) {
          cpx = x;
          cpy = y;
        }
        points.push(...toPoints$1({
          x,
          y
        }, {
          x: 2 * x - cpx,
          y: 2 * y - cpy
        }, {
          x: cmd[1] + x,
          y: cmd[2] + y
        }, {
          x: cmd[3] + x,
          y: cmd[4] + y
        }));
        cpx = cmd[1] + x; // last control point
        cpy = cmd[2] + y;
        x += cmd[3];
        y += cmd[4];
        break;
      case 'S':
        if (cpx === null || cpx === null) {
          cpx = x;
          cpy = y;
        }
        points.push(...toPoints$1({
          x,
          y
        }, {
          x: 2 * x - cpx,
          y: 2 * y - cpy
        }, {
          x: cmd[1],
          y: cmd[2]
        }, {
          x: cmd[3],
          y: cmd[4]
        }));
        cpx = cmd[1]; // last control point
        cpy = cmd[2];
        x = cmd[3];
        y = cmd[4];
        break;
      case 'Q':
        points.push(...toPoints({
          x,
          y
        }, {
          x: cmd[1],
          y: cmd[2]
        }, {
          x: cmd[3],
          y: cmd[4]
        }));
        qcpx = cmd[1]; // last control point
        qcpy = cmd[2];
        x = cmd[3];
        y = cmd[4];
        break;
      case 'q':
        points.push(...toPoints({
          x,
          y
        }, {
          x: cmd[1] + x,
          y: cmd[2] + y
        }, {
          x: cmd[3] + x,
          y: cmd[4] + y
        }));
        qcpx = cmd[1] + x; // last control point
        qcpy = cmd[2] + y;
        x += cmd[3];
        y += cmd[4];
        break;
      case 'T':
        if (qcpx === null || qcpx === null) {
          qcpx = x;
          qcpy = y;
        }
        qcpx = 2 * x - qcpx; // last control point
        qcpy = 2 * y - qcpy;
        points.push(...toPoints({
          x,
          y
        }, {
          x: qcpx,
          y: qcpy
        }, {
          x: cmd[1],
          y: cmd[2]
        }));
        x = cmd[1];
        y = cmd[2];
        break;
      case 't':
        if (qcpx === null || qcpx === null) {
          qcpx = x;
          qcpy = y;
        }
        qcpx = 2 * x - qcpx; // last control point
        qcpy = 2 * y - qcpy;
        points.push(...toPoints({
          x,
          y
        }, {
          x: qcpx,
          y: qcpy
        }, {
          x: cmd[1] + x,
          y: cmd[2] + y
        }));
        x += cmd[1];
        y += cmd[2];
        break;
      case 'z':
      case 'Z':
        if (points.length) {
          points.push({
            x: points[0].x,
            y: points[0].y
          });
        }
        break;
      // Do nothing
    }
  }
  removeDuplicates$2(points);
  segments.push(points.splice(0));
  return segments;
}

const debugPathToPointsDef = {
  require: ['renderer', 'chart'],
  defaultSettings: {
    settings: {
      target: '',
      fill: 'transparent',
      stroke: 'lime',
      opacity: 1,
      radius: 2,
      useOuterRect: false
    }
  },
  on: {
    update() {
      this.draw();
    }
  },
  draw() {
    const shapes = this.chart.findShapes('path').filter(s => s.key === this.props.target); // Find all shapes

    const circles = [];
    shapes.forEach(s => {
      pathToPoints(s.attrs.d).forEach(segment => {
        segment.forEach(p => {
          circles.push({
            type: 'circle',
            cx: p.x,
            cy: p.y,
            r: this.props.radius,
            fill: this.props.fill,
            stroke: this.props.stroke,
            opacity: this.props.opacity,
            collider: {
              type: null
            }
          });
        });
      });
    });
    this.renderer.render(circles);
  },
  created() {
    this.props = this.settings.settings;
  },
  resize(_ref) {
    let {
      outer,
      inner
    } = _ref;
    if (this.props.useOuterRect) {
      return outer;
    }
    return inner;
  },
  render() {},
  mounted() {
    this.draw();
  },
  updated() {
    this.props = this.settings.settings;
    this.draw();
  }
};

function debugCollider(picasso) {
  picasso.component('debug-collider', debugColliderDef);
}
function debugPathToPoints(picasso) {
  picasso.component('debug-path-to-points', debugPathToPointsDef);
}

var components = [box, pointMarker, pie, gridLine, refLine, axis, container, text, scrollbar, rangeBrush$1, rangeBrush, lassoBrush, labels, categoricalLegend, sequentialLegend, line, areaBrush, addTooltip, debugCollider, debugPathToPoints];

class Node {
  /**
   * @private
   */
  constructor(type) {
    this._parent = null;
    this._children = [];
    this._ancestors = null;
    this.type = type;
    this.data = null;
  }

  /**
   * Detaches this node from its parent, if such exists.
   * @returns {Node}
   */
  detach() {
    if (this._parent) {
      this._parent.removeChild(this);
    }
    return this;
  }

  /**
   * Parent of this node.
   * @readonly
   * @type {Node}
   */
  get parent() {
    return this._parent;
  }

  /**
   * Checks whether this node is a branch.
   *
   * True if this node has children, false otherwise.
   * @readonly
   * @type {Boolean}
   */
  get isBranch() {
    return this._children && this._children.length;
  }

  /**
   * Children of this node.
   * @readonly
   * @type {Node[]}
   */
  get children() {
    return this._children;
  }

  /**
   * Ancestors of this node, including parent.
   * @readonly
   * @type {Node[]}
   */
  get ancestors() {
    if (!this._ancestors) {
      this._ancestors = [];
      if (this.parent) {
        this._ancestors.push(this.parent, ...this.parent.ancestors);
      }
    }
    return this._ancestors;
  }

  /**
   * Descendants of this node.
   * @readonly
   * @type {Node[]}
   */
  get descendants() {
    let r = [];
    const len = this.children.length;
    let i;
    let c;
    for (i = 0, len; i < len; i++) {
      c = this.children[i];
      r.push(c);
      if (c.children.length) {
        r = [...r, ...c.descendants];
      }
    }
    return r;
  }

  /**
   *
   * @returns {Boolean}
   */
  equals(n) {
    const children = this.children;
    const nChildren = n.children;
    if (children.length !== nChildren.length) {
      return false;
    }
    // Requires deterministic child order
    for (let i = 0; i < children.length; i++) {
      if (!children[i].equals(nChildren[i])) {
        return false;
      }
    }
    return true;
  }
  toJSON() {
    return {
      type: this.type,
      children: this.children.map(ch => ch.toJSON())
    };
  }
}

/**
 * Construct a new GeoRect instance
 * @private
 */
class GeoRect {
  constructor() {
    let {
      x = 0,
      y = 0,
      width = 0,
      height = 0,
      minWidth = 0,
      minHeight = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.set({
      x,
      y,
      width,
      height,
      minWidth,
      minHeight
    });
  }
  set() {
    let {
      x = 0,
      y = 0,
      width = 0,
      height = 0,
      minWidth = 0,
      minHeight = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = 'rect';
    if (width >= 0) {
      this.x = x;
      this.width = Math.max(width, minWidth);
    } else {
      this.x = x + Math.min(width, -minWidth);
      this.width = -Math.min(width, -minWidth);
    }
    if (height >= 0) {
      this.y = y;
      this.height = Math.max(height, minHeight);
    } else {
      this.y = y + Math.min(height, -minHeight);
      this.height = -Math.min(height, -minHeight);
    }
  }

  /**
   * @param {Point} p
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  containsPoint(p) {
    return testRectPoint(this, p);
  }

  /**
   * @param {Point[]} points - Line start and end point as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsLine(points) {
    const line = pointsToLine(points);
    return testRectLine(this, line);
  }

  /**
   * @param {Point[]} points - Rect vertices as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsRect(points) {
    const rect = pointsToRect(points);
    return testRectRect(this, rect);
  }

  /**
   * @param {Circle} c
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsCircle(c) {
    return testCircleRect(c, this);
  }

  /**
   * @param {Polygon} polygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsPolygon(polygon) {
    return testPolygonRect(polygon, this);
  }

  /**
   * @param {Geopolygon} geopolygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsGeoPolygon(geopolygon) {
    return testGeoPolygonRect(geopolygon, this);
  }

  /**
   * Get the points
   * @returns {Point[]}
   */
  points() {
    return [{
      x: this.x,
      y: this.y
    }, {
      x: this.x + this.width,
      y: this.y
    }, {
      x: this.x + this.width,
      y: this.y + this.height
    }, {
      x: this.x,
      y: this.y + this.height
    }];
  }
}
function create$k() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return new GeoRect(...args);
}

/**
 * Construct a new GeoCircle instance
 * @private
 */
class GeoCircle {
  constructor() {
    let {
      cx = 0,
      cy = 0,
      r = 0,
      minRadius = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.set({
      cx,
      cy,
      r,
      minRadius
    });
  }
  set() {
    let {
      cx = 0,
      cy = 0,
      r = 0,
      minRadius = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = 'circle';
    this.cx = cx;
    this.cy = cy;
    this.r = Math.max(r, minRadius);
    this.vector = {
      x: this.cx,
      y: this.cy
    };
  }

  /**
   * @param {Point} p
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  containsPoint(p) {
    return testCirclePoint(this, p);
  }

  /**
   * @param {Point[]} points - Line start and end point as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsLine(points) {
    const line = pointsToLine(points);
    return testCircleLine(this, line);
  }

  /**
   * @param {Point[]} points - Rect vertices as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsRect(points) {
    const rect = pointsToRect(points);
    return testCircleRect(this, rect);
  }

  /**
   * @param {Circle} c
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsCircle(c) {
    return testCircleCircle(this, c);
  }

  /**
   * @param {Polygon} polygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsPolygon(polygon) {
    return testCirclePolygon(this, polygon);
  }

  /**
   * @param {Geopolygon} geopolygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsGeoPolygon(geopolygon) {
    return testCircleGeoPolygon(this, geopolygon);
  }

  /**
   * Get the points
   * @returns {Point[]}
   */
  points() {
    return [{
      x: this.cx,
      y: this.cy
    }];
  }
}
function create$j() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return new GeoCircle(...args);
}

/**
 * Construct a new GeoLine instance
 * @private
 */
class GeoLine {
  constructor() {
    let {
      x1 = 0,
      y1 = 0,
      x2 = 0,
      y2 = 0,
      tolerance = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.set({
      x1,
      y1,
      x2,
      y2,
      tolerance
    });
  }
  set() {
    let {
      x1 = 0,
      y1 = 0,
      x2 = 0,
      y2 = 0,
      tolerance = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = 'line';
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
    this.tolerance = Math.max(0, Math.round(tolerance));
    this.vectors = this.points();
    this.zeroSize = x1 === x2 && y1 === y2;
  }

  /**
   * @param {Point} p
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  containsPoint(p) {
    if (this.tolerance > 0) {
      const c = {
        cx: p.x,
        cy: p.y,
        r: this.tolerance
      };
      return testCircleLine(c, this);
    }
    return testLinePoint(this, p);
  }

  /**
   * @param {Point[]} points - Line start and end point as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsLine(points) {
    const line = pointsToLine(points);
    return testLineLine(this, line);
  }

  /**
   * @param {Point[]} points - Rect vertices as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsRect(points) {
    const rect = pointsToRect(points);
    return testRectLine(rect, this);
  }

  /**
   * @param {Circle} c
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsCircle(c) {
    return testCircleLine(c, this);
  }

  /**
   * @param {Polygon} polygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsPolygon(polygon) {
    return testPolygonLine(polygon, this);
  }

  /**
   * @param {Geopolygon} geopolygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsGeoPolygon(geopolygon) {
    return testGeoPolygonLine(geopolygon, this);
  }

  /**
   * Get the points
   * @returns {Point[]}
   */
  points() {
    return [{
      x: this.x1,
      y: this.y1
    }, {
      x: this.x2,
      y: this.y2
    }];
  }
}
function create$i() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return new GeoLine(...args);
}

function close$1(vertices) {
  const first = vertices[0];
  const last = vertices[vertices.length - 1];
  if (first.x !== last.x || first.y !== last.y) {
    vertices.push(first);
  }
}
function removeDuplicates$1(vertices) {
  for (let i = 0; i < vertices.length - 1; i++) {
    const v0 = vertices[i];
    const v1 = vertices[i + 1];
    if (v0.x === v1.x && v0.y === v1.y) {
      vertices.splice(i, 1);
      i--;
    }
  }
}

/**
 * Construct a new Polygon instance
 * Added ignore flag as the name collide with definition in index.js
 * @private
 */
class Polygon {
  constructor() {
    let {
      vertices = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.set({
      vertices
    });
  }

  /**
   * Set the vertices.
   * If vertices doesn't close the polygon, a closing vertice is appended.
   * @ignore
   * @param {object} input An object with a vertices property
   * @param {Point[]} [input.vertices=[]] Vertices are represented as an array of points.
   */
  set() {
    let {
      vertices = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = 'polygon';
    this.vertices = vertices.slice();
    this.edges = [];
    removeDuplicates$1(this.vertices);
    if (this.vertices.length <= 2) {
      return;
    }
    close$1(this.vertices);
    this.xMin = NaN;
    this.yMin = NaN;
    this.xMax = NaN;
    this.yMax = NaN;
    for (let i = 0; i < this.vertices.length; i++) {
      if (i < this.vertices.length - 1) {
        this.edges.push([this.vertices[i], this.vertices[i + 1]]);
      }
      this.xMin = isNaN(this.xMin) ? this.vertices[i].x : Math.min(this.xMin, this.vertices[i].x);
      this.xMax = isNaN(this.xMax) ? this.vertices[i].x : Math.max(this.xMax, this.vertices[i].x);
      this.yMin = isNaN(this.yMin) ? this.vertices[i].y : Math.min(this.yMin, this.vertices[i].y);
      this.yMax = isNaN(this.yMax) ? this.vertices[i].y : Math.max(this.yMax, this.vertices[i].y);
    }
    this._bounds = null;
    this._boundingRect = null;
  }

  /**
   * Check if a point is inside the area of the polygon.
   * Supports convex, concave and self-intersecting polygons (filled area).
   * @ignore
   * @param {Point} point
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  containsPoint(point) {
    return testPolygonPoint(this, point);
  }

  /**
   * Check if circle is inside the area of the polygon.
   * Supports convex, concave and self-intersecting polygons (filled area).
   * @ignore
   * @param {Circle} circle
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsCircle(circle) {
    return testCirclePolygon(circle, this);
  }

  /**
   * @ignore
   * @param {Point[]} points - Line start and end point as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsLine(points) {
    return testPolygonLine(this, pointsToLine(points));
  }

  /**
   * @ignore
   * @param {Point[]} points - Rect vertices as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsRect(points) {
    return testPolygonRect(this, pointsToRect(points));
  }

  /**
   * Check if polygon intersects another polygon.
   * Supports convex, concave and self-intersecting polygons (filled area).
   * @ignore
   * @param {Polygon} polygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsPolygon(polygon) {
    return testPolygonPolygon(this, polygon);
  }

  /**
   * Check if polygon intersects a geopolygon.
   * @ignore
   * @param {Geopolygon} geopolygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsGeoPolygon(geopolygon) {
    return testGeoPolygonPolygon(geopolygon, this);
  }

  /**
   * Get the points
   * @ignore
   * @returns {Point[]}
   */
  points() {
    return this.vertices;
  }

  /**
   * Get the bounds of the polygon, as an array of points
   * @ignore
   * @returns {Point[]}
   */
  bounds() {
    if (!this._bounds) {
      this._bounds = [{
        x: this.xMin,
        y: this.yMin
      }, {
        x: this.xMax,
        y: this.yMin
      }, {
        x: this.xMax,
        y: this.yMax
      }, {
        x: this.xMin,
        y: this.yMax
      }];
    }
    return this._bounds;
  }

  /**
   * Get the bounding rect of the polygon
   * @ignore
   * @returns {Rect}
   */
  boundingRect() {
    if (!this._boundingRect) {
      this._boundingRect = {
        x: this.xMin,
        y: this.yMin,
        width: this.xMax - this.xMin,
        height: this.yMax - this.yMin
      };
    }
    return this._boundingRect;
  }
}
function create$h() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }
  return new Polygon(...a);
}

function close(vertices) {
  const first = vertices[0];
  const last = vertices[vertices.length - 1];
  if (first.x !== last.x || first.y !== last.y) {
    vertices.push(first);
  }
}
function removeDuplicates(vertices) {
  for (let i = 0; i < vertices.length - 1; i++) {
    const v0 = vertices[i];
    const v1 = vertices[i + 1];
    if (v0.x === v1.x && v0.y === v1.y) {
      vertices.splice(i, 1);
      i--;
    }
  }
}

/**
 * A geo-polygon is a polygon which is similar to a polygon in GeoJson. A typical geopolygon is an array of polygons where the first polygon is an outer polygon and the rest are inner polygons
 * @private
 */
class GeoPolygon {
  constructor() {
    let {
      vertices = [[]]
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.set({
      vertices
    });
  }

  /**
   * Set the vertices.
   * If vertices doesn't close the polygon, a closing vertice is appended.
   * @param {object} input An object with a vertices property
   * @param {Array} [input.vertices=[]] Vertices are represented as an array of arrays of points.
   */
  set() {
    let {
      vertices = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = 'geopolygon';
    this.vertices = vertices.slice();
    this.numPolygons = this.vertices.length;
    this.polygons = [];
    this.xMin = NaN;
    this.yMin = NaN;
    this.xMax = NaN;
    this.yMax = NaN;
    for (let i = 0; i < this.numPolygons; i++) {
      removeDuplicates(this.vertices[i]);
      if (this.vertices[i].length > 2) {
        close(this.vertices[i]);
      }
      this.polygons[i] = create$h({
        vertices: this.vertices[i]
      });
      this.xMin = isNaN(this.xMin) ? this.polygons[i].xMin : Math.min(this.xMin, this.polygons[i].xMin);
      this.xMax = isNaN(this.xMax) ? this.polygons[i].xMax : Math.max(this.xMax, this.polygons[i].xMax);
      this.yMin = isNaN(this.yMin) ? this.polygons[i].yMin : Math.min(this.yMin, this.polygons[i].yMin);
      this.yMax = isNaN(this.yMax) ? this.polygons[i].yMax : Math.max(this.yMax, this.polygons[i].yMax);
    }
    this._bounds = null;
    this._boundingRect = null;
  }

  /**
   * Check if a point is inside the area of the geopolygon.
   * Supports convex, concave and self-intersecting polygons (filled area).
   * @param {Point} point
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  containsPoint(point) {
    return testGeoPolygonPoint(this, point);
  }

  /**
   * Check if circle is inside the area of the polygon.
   * Supports convex, concave and self-intersecting polygons (filled area).
   * @param {Circle} circle
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsCircle(circle) {
    return testCircleGeoPolygon(circle, this);
  }

  /**
   * @param {Point[]} points - Line start and end point as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsLine(points) {
    return testGeoPolygonLine(this, pointsToLine(points));
  }

  /**
   * @param {Point[]} points - Rect vertices as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsRect(points) {
    return testGeoPolygonRect(this, pointsToRect(points));
  }

  /**
   * Check if geopolygon intersects another polygon.
   * Supports convex, concave and self-intersecting polygons (filled area).
   * @param {Polygon} polygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsPolygon(polygon) {
    return testGeoPolygonPolygon(this, polygon);
  }

  /**
   * Check if geopolygon intersects another geopolygon.
   * Supports convex, concave and self-intersecting polygons (filled area).
   * @param {Geopolygon} geopolygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsGeoPolygon(geopolygon) {
    return testGeoPolygonGeoPolygon(this, geopolygon);
  }

  /**
   * Get the points
   * @returns {Point[]}
   */
  points() {
    return this.vertices;
  }

  /**
   * Get the bounds of the polygon, as an array of points
   * @ignore
   * @returns {Point[]}
   */
  bounds() {
    if (!this._bounds) {
      this._bounds = [{
        x: this.xMin,
        y: this.yMin
      }, {
        x: this.xMax,
        y: this.yMin
      }, {
        x: this.xMax,
        y: this.yMax
      }, {
        x: this.xMin,
        y: this.yMax
      }];
    }
    return this._bounds;
  }

  /**
   * Get the bounding rect of the polygon
   * @ignore
   * @returns {Rect}
   */
  boundingRect() {
    if (!this._boundingRect) {
      this._boundingRect = {
        x: this.xMin,
        y: this.yMin,
        width: this.xMax - this.xMin,
        height: this.yMax - this.yMin
      };
    }
    return this._boundingRect;
  }
}
function create$g() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }
  return new GeoPolygon(...a);
}

function pointsAreNotEqual(p0, p1) {
  return p0.x !== p1.x || p0.y !== p1.y;
}

/**
 * Construct a new GeoPolyline instance
 * @private
 */
class GeoPolyline {
  constructor() {
    let {
      points = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.set({
      points
    });
  }
  set() {
    let {
      points = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = 'polyline';
    this.segments = [];
    this._points = points.slice();
    if (this._points.length > 1) {
      for (let i = 0, len = this._points.length - 1; i < len; i++) {
        if (pointsAreNotEqual(this._points[i], this._points[i + 1])) {
          this.segments.push({
            x1: this._points[i].x,
            y1: this._points[i].y,
            x2: this._points[i + 1].x,
            y2: this._points[i + 1].y
          });
        }
      }
    }
  }

  /**
   * @param {Point} point
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  containsPoint(point) {
    return this.segments.some(line => testLinePoint(line, point));
  }

  /**
   * @param {Circle} circle
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsCircle(circle) {
    return this.segments.some(line => testCircleLine(circle, line));
  }

  /**
   * @param {Point[]} points - Line start and end point as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsLine(points) {
    const testLine = pointsToLine(points);
    return this.segments.some(line => testLineLine(line, testLine));
  }

  /**
   * @param {Point[]} points - Rect vertices as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsRect(points) {
    const rect = pointsToRect(points);
    return this.segments.some(line => testRectLine(rect, line));
  }

  /**
   * @param {Polygon} polygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsPolygon(polygon) {
    // This is a unoptimized solution and should be replaced by a more efficient algorithm.
    return this.segments.some(line => testPolygonLine(polygon, line));
  }

  /**
   * @param {Geopolygon} geopolygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsGeoPolygon(geopolygon) {
    // This is a unoptimized solution and should be replaced by a more efficient algorithm.
    return this.segments.some(line => testGeoPolygonLine(geopolygon, line));
  }

  /**
   * Get the points
   * @returns {Point[]}
   */
  points() {
    return this._points;
  }
}
function create$f() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }
  return new GeoPolyline(...a);
}

const reg$2 = registryFactory();
reg$2.add('rect', create$k);
reg$2.add('circle', create$j);
reg$2.add('line', create$i);
reg$2.add('polygon', create$h);
reg$2.add('geopolygon', create$g);
reg$2.add('polyline', create$f);

/* eslint-disable import/prefer-default-export */
function create$e(type, input) {
  return reg$2.get(type)(input);
}
/* eslint-enable import/prefer-default-export */

/**
 * @typedef {object} Rect
 * @property {number} x - X-coordinate
 * @property {number} y - Y-coordinate
 * @property {number} width - Width
 * @property {number} height - Height
 */

/**
 * @typedef {object} Line
 * @property {number} x1 - Start x-coordinate
 * @property {number} y1 - Start y-coordinate
 * @property {number} x2 - End x-coordinate
 * @property {number} y2 - End y-coordinate
 */

/**
 * @typedef {object} Point
 * @property {number} x - X-coordinate
 * @property {number} y - Y-coordinate
 */

/**
 * @typedef {object} Circle
 * @property {number} cx - Center x-coordinate
 * @property {number} cy - Center y-coordinate
 * @property {number} r - Circle radius
 */

/**
 * @typedef {object} Polygon
 * @property {Array<Point>} points - Array of connected points
 */

/**
 * @typedef {object} Geopolygon
 * @property {Array<Polygon>} polygons - Array of polygons
 */

/**
 * @typedef {object} Polyline
 * @property {Array<Point>} points - Array of connected points
 */

/**
 * @typedef {object} Path
 * @property {string} d - Path definition
 */

/**
 * Construct a new GeometryCollection instance
 * @private
 */
class GeometryCollection {
  constructor() {
    let collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this.set(collection);
  }
  set() {
    let collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this.geometries = [];
    collection.forEach(geo => {
      const geoInstance = create$e(geo.type, geo);
      if (geoInstance) {
        this.geometries.push(geoInstance);
      }
    });
  }

  /**
   * @param {Point} p
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  containsPoint(p) {
    return this.geometries.some(geo => geo.containsPoint(p));
  }

  /**
   * @param {Point[]} points - Line start and end point as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsLine(points) {
    return this.geometries.some(geo => geo.intersectsLine(points));
  }

  /**
   * @param {Point[]} points - Rect vertices as an array of points
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsRect(points) {
    return this.geometries.some(geo => geo.intersectsRect(points));
  }

  /**
   * @param {Circle} c
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsCircle(c) {
    return this.geometries.some(geo => geo.intersectsCircle(c));
  }

  /**
   * @param {Polygon} polygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsPolygon(polygon) {
    return this.geometries.some(geo => geo.intersectsPolygon(polygon));
  }

  /**
   * @param {Geopolygon} geopolygon
   * @returns {boolean} True if there is an intersection, false otherwise
   */
  intersectsGeoPolygon(geopolygon) {
    return this.geometries.some(geo => geo.intersectsGeoPolygon(geopolygon));
  }
}
function create$d() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return new GeometryCollection(...args);
}

class Matrix {
  /**
   * Creates a matrix with identity values.
   * @private
   */
  constructor() {
    this._elements = [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
    this._stack = [];
  }

  /**
   * Creates a new matrix with a copy of the current values.
   */
  clone() {
    const mt = new Matrix();
    return mt.multiply(this);
  }

  /**
   * Sets the matrix values
   * @param {Number[][]} arr A 3x3 array.
   */
  set(arr) {
    this._elements = arr;
    return this;
  }

  /**
   * Saves the current matrix values to a stack.
   */
  save() {
    this._stack.push(this.elements);
    return this;
  }

  /**
   * Sets the current matrix values to the last ones saved on to the stack.
   */
  restore() {
    if (this._stack.length) {
      this._elements = this._stack.pop(); // TODO - use a copy instead
    }
    return this;
  }

  /**
   * Adds a scalar value to each element in the matrix.
   * @param {Number} value
   */
  add(value) {
    // assume scalar
    let i, j;
    for (i = 0; i < this._elements.length; i++) {
      for (j = 0; j < this._elements[i].length; j++) {
        this._elements[i][j] += value;
      }
    }
    return this;
  }

  /**
   * Translates the current matrix along the x and y axis.
   * @param {Number} x
   * @param {Number} y
   */
  translate(x, y) {
    this.multiply([[1, 0, x], [0, 1, y], [0, 0, 1]]);
    return this;
  }

  /**
   * Rotates the current matrix.
   * @param {Number} radianAngle Angle in radians.
   */
  rotate(radianAngle) {
    let cos = Math.cos(-radianAngle),
      sin = Math.sin(-radianAngle);
    this.multiply([[cos, sin, 0], [-sin, cos, 0], [0, 0, 1]]);
    return this;
  }

  /**
   *
   * If value is a number; multiplies each element in the matrix by the given value.
   * If value is a matrix; multiplies the two matrices.
   * @param {Number|Array|Matrix} value
   */
  multiply(value) {
    let i, j, m, k;
    if (value instanceof Matrix) {
      value = value._elements;
    }
    if (Array.isArray(value)) {
      // matrix multiplication
      m = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
      for (i = 0; i < this._elements.length; i++) {
        // row
        for (j = 0; j < this._elements[i].length; j++) {
          // column
          for (k = 0; k < 3; k++) {
            // row
            m[i][j] += this._elements[i][k] * value[k][j];
          }
        }
      }
      this._elements = m;
    } else {
      // scalar multiplication
      for (i = 0; i < this._elements.length; i++) {
        for (j = 0; j < this._elements[i].length; j++) {
          this._elements[i][j] *= value;
        }
      }
    }
    return this;
  }

  /**
   * Scales the matrix along x and y axis.
   * @param {Number} x The value to scale the matrix with along the x direction
   * @param {Number} [y=x] The value to scale the matrix with along the y direction.
   */
  scale(x) {
    let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    // if ( arguments.length < 2 || typeof y === "undefined" ) {
    //  y = x;
    // }

    this.multiply([[x, 0, 0], [0, y, 0], [0, 0, 1]]);
    return this;
  }

  /**
   * Multiples the matrix with the supplied transformation values
   * @param {Number} a Horizontal scaling
   * @param {Number} b Horizontal skewing
   * @param {Number} c Vertical skewing
   * @param {Number} d Vertical scaling
   * @param {Number} e Horizontal moving
   * @param {Number} f Vertical scaling
   */
  transform(a, b, c, d, e, f) {
    this.multiply([[a, c, e], [b, d, f], [0, 0, 1]]);
    return this;
  }

  /**
   * Gets the value of the determinant.
   * @return {Number}
   */
  determinant() {
    let a = this._elements[0][0],
      b = this._elements[0][1],
      c = this._elements[0][2],
      d = this._elements[1][0],
      e = this._elements[1][1],
      f = this._elements[1][2],
      g = this._elements[2][0],
      h = this._elements[2][1],
      i = this._elements[2][2],
      p = 0;
    p = a * e * i + b * f * g + c * d * h - c * e * g - b * d * i - a * f * h;
    return p;
  }

  /**
   * Inverts the matrix.
   */
  invert() {
    let dt = this.determinant(),
      a = this._elements[0][0],
      b = this._elements[0][1],
      c = this._elements[0][2],
      d = this._elements[1][0],
      e = this._elements[1][1],
      f = this._elements[1][2],
      g = this._elements[2][0],
      h = this._elements[2][1],
      k = this._elements[2][2];
    this._elements = [[e * k - f * h, c * h - b * k, b * f - c * e], [f * g - d * k, a * k - c * g, c * d - a * f], [d * h - e * g, g * b - a * h, a * e - b * d]];
    this.multiply(1 / dt); // TODO - handle when dt === 0 ?
    return this;
  }

  /**
   * Transposes the elements of the matrix.
   */
  transpose() {
    const m = Object.create(this._elements); // ?
    this._elements = [[m[0][0], m[1][0], m[2][0]], [m[0][1], m[1][1], m[2][1]], [m[0][2], m[1][2], m[2][2]]];
    return this;
  }

  /**
   * Resets the inner elements of the matrix to identity values.
   */
  identity() {
    this._elements = [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
    return this;
  }
  toString() {
    return "".concat(this._elements.map(r => r.join('\t')).join('\n'));
  }
  isIdentity() {
    const m = this._elements;
    return m[0][0] === 1 && m[0][1] === 0 && m[0][2] === 0 && m[1][0] === 0 && m[1][1] === 1 && m[1][2] === 0 && m[2][0] === 0 && m[2][1] === 0 && m[2][2] === 1;
  }

  /**
   * Transforms the given point by this matrix and returns a new point
   */
  transformPoint(p) {
    let vec = [p.x, p.y, 1],
      i,
      j,
      e = this._elements,
      m = [0, 0, 0];
    for (i = 0; i < this._elements.length; i++) {
      // row
      for (j = 0; j < this._elements[i].length; j++) {
        // column
        m[i] += vec[j] * e[i][j];
      }
    }
    return {
      x: m[0],
      y: m[1]
    };
  }

  /**
   * Transforms the given points by this matrix and returns the new points
   */
  transformPoints(array) {
    let vec,
      i,
      j,
      k,
      m,
      e = this._elements,
      ret = [];
    for (k = 0; k < array.length; k++) {
      vec = [array[k].x, array[k].y, 1];
      m = [0, 0, 0];
      for (i = 0; i < this._elements.length; i++) {
        // row
        for (j = 0; j < this._elements[i].length; j++) {
          // column
          m[i] += vec[j] * e[i][j];
        }
      }
      ret.push({
        x: m[0],
        y: m[1]
      });
    }
    return ret;
  }
  get elements() {
    const m = this._elements;
    return [[m[0][0], m[0][1], m[0][2]], [m[1][0], m[1][1], m[1][2]], [m[2][0], m[2][1], m[2][2]]];
  }
}

const transformRegEx = /(translate|scale|rotate|matrix)\(([0-9,.eE+-\s]+)(?:,|\s?)+\)/g;
function parseTransform(transform) {
  let m,
    commands = [];
  /* eslint-disable no-cond-assign */
  while ((m = transformRegEx.exec(transform)) !== null) {
    const argsStr = m[2].trim();
    const args = argsStr.indexOf(',') === -1 ? argsStr.split(' ') : argsStr.split(',');
    commands.push({
      cmd: m[1],
      args: args.filter(a => a.trim().length > 0).map(a => Number(a))
    });
  }
  /* eslint-enable no-cond-assign */

  return commands;
}
function resolveRotateCmd(matrix, transform) {
  const radians = transform.args[0] * (Math.PI / 180);
  if (transform.args.length > 2) {
    const x = transform.args[1];
    const y = transform.args[2];
    matrix.translate(x, y);
    matrix.rotate(radians);
    matrix.translate(-x, -y);
  } else if (transform.args.length === 1) {
    matrix.rotate(radians);
  }
}
function resolveScaleCmd(matrix, transform) {
  const x = transform.args[0];
  const y = isNaN(transform.args[1]) ? transform.args[0] : transform.args[1];
  matrix.scale(x, y);
}
function resolveTranslateCmd(matrix, transform) {
  const x = transform.args[0];
  const y = isNaN(transform.args[1]) ? 0 : transform.args[1];
  matrix.translate(x, y);
}
function resolveMatrixCmd(matrix, transform) {
  if (transform.args.length >= 6) {
    matrix.transform(...transform.args);
  }
}
function resolveTransform(t, matrix) {
  const transforms = parseTransform(t);
  let transform;
  for (let i = 0, len = transforms.length; i < len; i++) {
    transform = transforms[i];
    if (transform.cmd === 'rotate') {
      resolveRotateCmd(matrix, transform);
    } else if (transform.cmd === 'scale') {
      resolveScaleCmd(matrix, transform);
    } else if (transform.cmd === 'matrix') {
      resolveMatrixCmd(matrix, transform);
    } else if (transform.cmd === 'translate') {
      resolveTranslateCmd(matrix, transform);
    }
  }
}

/* eslint-disable no-useless-escape */

const SELECTOR_MAPS = {
  type: /^\w[\w-]+/,
  attr: /^\[\w(?:[\w\._-]+)?(?:[!]?=['\"][\w\s*#_-]*['\"])?\]/,
  universal: /^(\*)/,
  tag: /^\.(\w+)/
};
const FILTERS = {
  type: (c, objects) =>
  // eslint-disable-line arrow-body-style
  objects.filter(o => {
    const type = o.type;
    if (type) {
      return type.toLowerCase() === c.toLowerCase();
    }
    return false;
  }),
  attr: (attr, operator, value, objects) =>
  // eslint-disable-line arrow-body-style
  objects.filter(o => {
    const v = o.attrs[attr];
    if (!operator) {
      // TODO handle undefined differently for != operator? As display object may very well have a default rendering color
      return typeof v !== 'undefined';
    }
    if (typeof v === 'undefined') {
      return false;
    }
    switch (operator) {
      case '=':
        return value === String(v);
      case '!=':
        return value !== String(v);
      default:
        return false;
    }
  }),
  universal: objects => objects,
  tag: (selector, objects) =>
  // eslint-disable-line arrow-body-style
  objects.filter(o => {
    const tag = o.tag;
    if (tag) {
      return tag.trim().split(/\s+/).indexOf(selector.replace('.', '')) !== -1;
    }
    return false;
  })
};

/**
 * Filters out objects of given type and value
 * @ignore
 * @example
 * filter(
 *   {type:'type', value:'Circle'},
 *   [new Circle(), new Rectangle()]
 * )
 * // [Circle]
 * @param {Object} token
 * @param {Array} objects
 * @returns {Object[]} Objects that fulfill the type and value
 */
function filter(token, objects) {
  if (!objects || !objects.length || !token || typeof FILTERS[token.type] !== 'function') {
    return [];
  }
  switch (token.type) {
    case 'type':
      return FILTERS[token.type](token.value, objects);
    case 'attr':
      return FILTERS[token.type](token.attribute, token.operator, token.attributeValue, objects);
    case 'universal':
      return FILTERS[token.type](objects);
    case 'tag':
      return FILTERS[token.type](token.value, objects);
    default:
      return [];
  }
}

/**
 * Tokenizes a string into supported selectors
 * @ignore
 *
 * @example
 * tokenize("Circle[color='red']")
 *
 * @param {String} s
 */
function tokenize(s) {
  const groups = [];
  let sub;
  let info;
  let match;
  let validSelector;
  s.split(/\s*,\s*/).forEach(group => {
    group = group.trim();
    sub = [];
    const selectorMapsIterator = key => {
      match = group.match(SELECTOR_MAPS[key]);
      if (match) {
        validSelector = true;
        group = group.slice(match[0].length);
        info = {
          type: key,
          value: match[0]
        };
        if (key === 'attr') {
          // extract parts of attribute from e.g. [color='red'] => (color, =, red)
          match = match[0].match(/\[(\w[\w\._-]+)?(?:([!]?=)['\"]([\w\s#_-]*)['\"])?\]/);
          info.attribute = match[1];
          info.operator = match[2];
          info.attributeValue = match[3];
        }
        sub.push(info);
      }
    };
    while (group) {
      validSelector = false;
      match = group.match(/^\s*([>+~]|\s)\s*/);
      if (match) {
        validSelector = true;
        sub.push({
          type: ' ',
          value: match[0]
        });
        group = group.slice(match[0].length);
      }
      Object.keys(SELECTOR_MAPS).forEach(selectorMapsIterator);
      if (sub && sub.length && groups.indexOf(sub) < 0) {
        groups.push(sub);
      }
      if (!validSelector) {
        break;
      }
    }
  });
  return groups;
}
function find(s, object) {
  const result = [];
  const groupResults = [];
  let groups;
  let descendants;
  if (object.isBranch) {
    groups = tokenize(s);
    descendants = object.descendants;
    let tokens;
    for (let gi = 0, glen = groups.length; gi < glen; gi++) {
      tokens = groups[gi];
      const levels = [];
      let filtered = descendants.slice();
      let hasRemainder = false;
      tokens.reverse().forEach(token => {
        if (token.type === ' ') {
          levels.push(filtered);
          filtered = descendants.slice();
          hasRemainder = false;
          return;
        }
        filtered = filter(token, filtered);
        hasRemainder = true;
      });
      if (hasRemainder) {
        levels.push(filtered);
      }
      const selected = levels[0].filter(node => {
        let ancestor = node.parent;
        let idx;
        for (let i = 1; i < levels.length; i++) {
          idx = levels[i].indexOf(ancestor);
          while (ancestor && idx < 0) {
            ancestor = ancestor.parent;
            idx = levels[i].indexOf(ancestor);
          }
          if (idx < 0) {
            return false;
          }
        }
        return true;
      });
      groupResults.push(selected);
    }
    for (let i = 0, len = groupResults.length; i < len; i++) {
      for (let ni = 0, nlen = groupResults[i].length; ni < nlen; ni++) {
        if (result.indexOf(groupResults[i][ni]) < 0) {
          result.push(groupResults[i][ni]);
        }
      }
    }
  }
  return result || [];
}
var nodeSelector = {
  find
};

function appendDpi(points, dpi) {
  for (let i = 0, len = points.length; i < len; i++) {
    points[i].x /= dpi;
    points[i].y /= dpi;
  }
}
function geometryToDef(geometry, dpi, mvm) {
  const type = geometry.type;
  let points = geometry.points();
  if (mvm) {
    if (points.every(item => Array.isArray(item))) {
      points = points.map(item => mvm.transformPoints(item));
    } else {
      points = mvm.transformPoints(points);
    }
  }
  appendDpi(points, dpi);
  let def = null;
  if (type === 'rect' || type === 'bounds') {
    def = pointsToRect(points);
    def.type = type;
  } else if (type === 'circle') {
    def = pointsToCircle(points, geometry.r);
    def.type = type;
  } else if (type === 'line') {
    def = pointsToLine(points);
    def.type = type;
  } else if (type === 'polygon' || type === 'polyline') {
    const path = pointsToPath(points, type === 'polygon');
    def = {
      type: 'path',
      d: path
    };
  } else if (type === 'geopolygon') {
    let path = '';
    for (let i = 0; i < points.length; i++) {
      path += pointsToPath(points[i], true);
    }
    def = {
      type: 'path',
      d: path
    };
  }
  return def;
}

/**
 * @ignore
 * @returns {object} Returns a node definition of the collider
 */
function colliderToShape(node, dpi) {
  if (node.collider) {
    const mvm = node.modelViewMatrix;
    const isCollection = node.colliderType === 'collection';
    if (isCollection) {
      const children = node.collider.geometries.map(geometry => geometryToDef(geometry, dpi, mvm));
      return {
        type: 'container',
        children
      };
    }
    return geometryToDef(node.collider, dpi, mvm);
  }
  return null;
}

/**
 * Read-only object representing a node on the scene.
 */
class SceneNode {
  constructor(node) {
    this._bounds = function () {
      let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const {
        x,
        y,
        width,
        height
      } = node.boundingRect ? node.boundingRect(includeTransform) : {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
      return {
        x,
        y,
        width,
        height
      };
    };
    this._attrs = node.attrs;
    this._type = node.type;
    this._data = node.data;
    this._dpi = node.stage ? node.stage.dpi : 1;
    this._collider = () => colliderToShape(node, this._dpi);
    this._desc = node.desc;
    this._tag = node.tag;
    this._children = () => node.children.map(n => new SceneNode(n));
    this._parent = () => node.parent ? new SceneNode(node.parent) : null;
    this._cache = {
      elementBoundingRect: null
    };
    this._getElementBoundingRect = () => {
      if (!this._cache.elementBoundingRect && this.element) {
        this._cache.elementBoundingRect = this.element.getBoundingClientRect();
      }
      return this._cache.elementBoundingRect || {
        left: 0,
        top: 0
      };
    };
  }

  /**
   * Get child nodes
   * @type {SceneNode[]}
   */
  get children() {
    return this._children();
  }

  /**
   * Get parent node
   * @type {SceneNode}
   */
  get parent() {
    return this._parent();
  }

  /**
   * Node type
   * @type {string}
   */
  get type() {
    return this._type;
  }

  /**
   * Get the associated data
   * @type {any}
   */
  get data() {
    return this._data;
  }

  /**
   * Node attributes
   * @type {object}
   */
  get attrs() {
    return this._attrs;
  }

  /**
   * Element the scene is attached to
   * @type {HTMLElement}
   * @private
   */
  set element(e) {
    this._cache.elementBoundingRect = null;
    this._element = e;
  }

  /**
   * Element the scene is attached to
   * @type {HTMLElement}
   */
  get element() {
    return this._element;
  }

  /**
   * Key of the component this shape belongs to
   * @type {string}
   * @private
   */
  set key(k) {
    this._key = k;
  }

  /**
   * Key of the component this shape belongs to
   * @type {string}
   */
  get key() {
    return this._key;
  }

  /**
   * Bounding rectangle of the node. After any transform has been applied, if any, but excluding scaling transform related to devicePixelRatio.
   * Origin is in the top-left corner of the scene element.
   * @type {Rect}
   */
  get bounds() {
    const bounds = this._bounds();
    bounds.x /= this._dpi;
    bounds.y /= this._dpi;
    bounds.width /= this._dpi;
    bounds.height /= this._dpi;
    return bounds;
  }

  /**
   * Bounding rectangle of the node within its local coordinate system.
   * Origin is in the top-left corner of the scene element.
   * @type {Rect}
   */
  get localBounds() {
    const bounds = this._bounds(false);
    return bounds;
  }

  /**
   * Bounding rectangle of the node, relative a target.
   *
   * If target is an HTMLElement, the bounds are relative to the HTMLElement.
   * Any other target type will return the bounds relative to the viewport of the browser.
   *
   * @param {HTMLElement|any} target
   * @param {boolean} includeTransform - Whether to include any applied transforms on the node
   * @returns {Rect}
   * @example
   *
   * node.boundsRelativeTo($('div'));
   * node.boundsRelativeTo('viewport');
   */
  boundsRelativeTo(target) {
    let includeTransform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const type = typeof target;
    const bounds = includeTransform ? this.bounds : this.localBounds;
    const selfRect = this._getElementBoundingRect();
    let dx = selfRect.left;
    let dy = selfRect.top;
    if (type === 'object' && target !== null && typeof target.getBoundingClientRect === 'function') {
      const {
        left = 0,
        top = 0
      } = target.getBoundingClientRect();
      dx -= left;
      dy -= top;
    }
    bounds.x += dx;
    bounds.y += dy;
    return bounds;
  }

  /**
   * Collider of the node. Transform on the node has been applied to the collider shape, if any, but excluding scaling transform related to devicePixelRatio.
   * Origin is in the top-left corner of the scene element.
   *
   * If node has no collider, null is returned.
   * @type {Line|Rect|Circle|Path}
   */
  get collider() {
    return this._collider();
  }

  /**
   * Node description
   * @type {object}
   */
  get desc() {
    return this._desc;
  }

  /**
   * Node tag
   * @type {string}
   */
  get tag() {
    return this._tag;
  }
}
function create$c() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }
  return new SceneNode(...a);
}

class Collision {
  constructor(node) {
    this._node = create$c(node);
    this._parent = null;
    this._input = null;
  }
  get node() {
    return this._node;
  }
  set parent(p) {
    this._parent = p;
  }
  get parent() {
    return this._parent;
  }
  set input(i) {
    this._input = i;
  }
  get input() {
    return this._input;
  }
}
function create$b() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }
  return new Collision(...a);
}

function appendParentNode(node, collision) {
  const p = node.parent;
  if (p && p.type !== 'stage') {
    collision.parent = create$b(p);
    const pp = p.parent;
    if (pp && pp.type !== 'stage') {
      appendParentNode(pp, collision.parent);
    }
  }
}
function appendInputShape(shape, collisions) {
  for (let i = 0, len = collisions.length; i < len; i++) {
    collisions[i].input = shape;
  }
}
function resolveFrontChildCollision(node, type, input) {
  const num = node.descendants.length;
  for (let i = num - 1; i >= 0; i--) {
    const desc = node.descendants[i];
    if (desc.collider === null) {
      continue;
    }
    if (desc.collider[type](input)) {
      const collision = create$b(desc);
      appendParentNode(desc, collision);
      return collision;
    }
  }
  return null;
}
function resolveGeometryCollision(node, type, input) {
  if (node.collider[type](input)) {
    const c = create$b(node);
    appendParentNode(node, c);
    return c;
  }
  return null;
}
function inverseTransform(node, input) {
  let transformedInput = {};
  if (node.modelViewMatrix) {
    if (Array.isArray(input)) {
      // Rect or Line
      transformedInput = node.inverseModelViewMatrix.transformPoints(input);
    } else if (!isNaN(input.r)) {
      // Circle
      const p = {
        x: input.cx,
        y: input.cy
      };
      ({
        x: transformedInput.cx,
        y: transformedInput.cy
      } = node.inverseModelViewMatrix.transformPoint(p));
      transformedInput.r = input.r;
    } else if (Array.isArray(input.vertices)) {
      // Polygon
      transformedInput.vertices = node.inverseModelViewMatrix.transformPoints(input.vertices);
    } else {
      // Point
      transformedInput = node.inverseModelViewMatrix.transformPoint(input);
    }
  } else {
    transformedInput = input;
  }
  if (Array.isArray(transformedInput.vertices)) {
    if (transformedInput.vertices.every(item => Array.isArray(item))) {
      transformedInput = create$g(transformedInput);
    } else {
      transformedInput = create$h(transformedInput); // TODO Shouldn't have to do this here, currently its beacause a collision algorithm optimization, i.e. caching of polygon bounds
    }
  }
  return transformedInput;
}
function resolveCollision(node, intersectionType, input) {
  if (node.colliderType === null) {
    return null;
  }
  const transformedInput = inverseTransform(node, input);
  if (node.colliderType === 'frontChild') {
    return resolveFrontChildCollision(node, intersectionType, transformedInput);
  }
  return resolveGeometryCollision(node, intersectionType, transformedInput);
}
function findAllCollisions(nodes, intersectionType, ary, input) {
  const num = nodes.length;
  for (let i = 0; i < num; i++) {
    const node = nodes[i];
    const collision = resolveCollision(node, intersectionType, input);
    if (collision) {
      ary.push(collision);
    }

    // Only traverse children if no match is found on parent and it doesnt have any custom collider
    if (node.children && !collision && !node.collider) {
      findAllCollisions(node.children, intersectionType, ary, input);
    }
  }
}
function hasCollision(nodes, intersectionType, input) {
  const num = nodes.length;
  for (let i = 0; i < num; i++) {
    const node = nodes[i];
    const collision = resolveCollision(node, intersectionType, input);
    if (collision !== null) {
      return true;
    }
    if (node.children && !node.collider) {
      return hasCollision(node.children, intersectionType, input);
    }
  }
  return false;
}
function resolveShape(shape) {
  let ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const type = getShapeType(shape);
  let _shape = {};
  switch (type) {
    case 'circle':
      _shape.cx = shape.cx * ratio;
      _shape.cy = shape.cy * ratio;
      _shape.r = shape.r;
      return ['intersectsCircle', _shape];
    case 'rect':
      _shape = rectToPoints(shape).map(p => scalarMultiply(p, ratio));
      return ['intersectsRect', _shape];
    case 'line':
      _shape = lineToPoints(shape).map(p => scalarMultiply(p, ratio));
      return ['intersectsLine', _shape];
    case 'point':
      _shape = scalarMultiply(shape, ratio);
      return ['containsPoint', _shape];
    case 'polygon':
      _shape.vertices = shape.vertices.map(vertex => scalarMultiply(vertex, ratio));
      return ['intersectsPolygon', _shape];
    case 'geopolygon':
      _shape.vertices = shape.vertices.map(vertices => vertices.map(vertex => scalarMultiply(vertex, ratio)));
      return ['intersectsGeoPolygon', _shape];
    default:
      return [];
  }
}
function resolveCollionsOnNode(node, shape) {
  const [intersectionType, _shape] = resolveShape(shape, node.dpi);
  const collisions = [];
  if (intersectionType) {
    findAllCollisions([node], intersectionType, collisions, _shape);
    appendInputShape(shape, collisions);
  }
  return collisions;
}
function hasCollisionOnNode(node, shape) {
  const [intersectionType, _shape] = resolveShape(shape, node.dpi);
  return hasCollision([node], intersectionType, _shape);
}

/**
 * @private
 * @typedef {object} DisplayObject
 * @property {string} type
 * @property {string|GradientNode|PatternNode} [fill] - {@link https://www.w3.org/TR/fill-stroke-3/#fill-shorthand}
 * @property {string|GradientNode|PatternNode} [stroke] - {@link https://www.w3.org/TR/fill-stroke-3/#propdef-stroke}
 * @property {number} [strokeWidth] - {@link https://www.w3.org/TR/fill-stroke-3/#propdef-stroke-width}
 * @property {string|number[]} [strokeDasharray] - {@link https://www.w3.org/TR/fill-stroke-3/#propdef-stroke-dasharray}
 * @property {number} [opacity] - {@link https://www.w3.org/TR/css-color-4/#propdef-opacity}
 * @property {string} [transform] - {@link https://www.w3.org/TR/SVG/coords.html#TransformAttribute}
 * @property {object} [data] - Data object, may contain any properties
 * @property {object} [desc] - Meta-data object, may contain any properties
 * @property {string} [tag] - White-space seperated list of tags
 * @property {string} [id] - Unique identifier of the node
 * @property {object} [collider]
 */

class DisplayObject extends Node {
  constructor(type) {
    super(type);
    this._stage = null;
    this._collider = {
      type: null,
      definition: null,
      fn: null
    };
    this._attrs = {};
    this._node = null;
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.node = v;
    const {
      data,
      desc,
      tag,
      strokeReference,
      fillReference
    } = v;
    assignMappedAttribute(this.attrs, v);
    if (typeof data !== 'undefined') {
      this.data = data;
    }
    if (typeof desc === 'object') {
      this.desc = extend$1(true, {}, desc);
    }
    if (typeof tag === 'string') {
      this.tag = tag;
    }
    if (typeof strokeReference === 'string') {
      this.strokeReference = strokeReference;
    }
    if (typeof fillReference === 'string') {
      this.fillReference = fillReference;
    }
  }
  findShapes(selector) {
    return nodeSelector.find(selector, this).map(node => create$c(node));
  }
  getItemsFrom(shape) {
    return resolveCollionsOnNode(this, shape);
  }
  containsPoint(p) {
    return hasCollisionOnNode(this, p);
  }
  intersectsLine(line) {
    return hasCollisionOnNode(this, line);
  }
  intersectsRect(rect) {
    return hasCollisionOnNode(this, rect);
  }
  intersectsCircle(circle) {
    return hasCollisionOnNode(this, circle);
  }
  intersectsPolygon(polygon) {
    return hasCollisionOnNode(this, polygon);
  }
  intersectsGeoPolygon(geopolygon) {
    return hasCollisionOnNode(this, geopolygon);
  }
  resolveLocalTransform() {
    let m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Matrix();
    if (typeof this.attrs.transform !== 'undefined') {
      resolveTransform(this.attrs.transform, m);
    }
    this.modelViewMatrix = m.clone();
  }
  resolveGlobalTransform() {
    let m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Matrix();
    const a = this.ancestors;
    if (a.length > 0) {
      for (let i = a.length - 1; i >= 0; i--) {
        a[i].resolveLocalTransform(m);
        m = a[i].modelViewMatrix;
      }
    }
    this.resolveLocalTransform(m);
  }

  /**
   * Returns the value of attribute a.
   * @private
   * @param a
   * @returns {*} The value of attribute a.
   */
  attr(a) {
    return this.attrs[a];
  }
  equals(d) {
    const attrs = this.attrs;
    const attrKeys = Object.keys(attrs);
    const dAttrs = d.attrs;
    const dAttrKeys = Object.keys(dAttrs);
    if (attrKeys.length !== dAttrKeys.length) {
      return false;
    }
    for (let i = 0; i < attrKeys.length; i++) {
      const key = attrKeys[i];
      if (!Object.hasOwnProperty.call(dAttrs, key)) {
        return false;
      }
      if (attrs[key] !== dAttrs[key]) {
        return false;
      }
    }
    return super.equals(d);
  }
  toJSON() {
    const json = super.toJSON();
    json.attrs = this.attrs;
    return json;
  }
  get attrs() {
    return this._attrs;
  }
  get stage() {
    if (this._parent && !this._stage) {
      // lazy evaluation
      this._stage = this._parent.stage;
    } else if (!this._parent && this._stage !== this) {
      this._stage = null;
    }
    return this._stage;
  }
  set modelViewMatrix(m) {
    this._mvm = m;
    this._imvm = null;
  }
  get modelViewMatrix() {
    return this._mvm;
  }
  get inverseModelViewMatrix() {
    this._imvm = this._imvm ? this._imvm : this._mvm.clone().invert();
    return this._imvm;
  }
  set node(n) {
    this._node = n;
  }
  get node() {
    return this._node;
  }
  set collider(definition) {
    const type = Array.isArray(definition) ? 'collection' : definition && definition.type;
    if (typeof type !== 'string') {
      // Non string type definition resets the collider
      this._collider.type = null;
      this._collider.definition = null;
      this._collider.fn = null;
      return;
    }

    // Check if a collider of the same type is already defined, if so, do an update
    if (this._collider !== null && this._collider.type === type && this._collider.fn !== null) {
      this._collider.fn.set(definition);
      this._collider.definition = definition;
      return;
    }

    // Store the definition so that it can be lazy evaluated
    this._collider.type = type;
    this._collider.definition = definition;
  }
  get collider() {
    // Resolve geometry function from cache
    if (this._collider.fn !== null) {
      return this._collider.fn;
    }

    // Resolve geometry function and store it in cache
    switch (this._collider.type) {
      case 'collection':
        this._collider.fn = create$d(this._collider.definition);
        break;
      case 'frontChild':
        // TODO Deprecate
        // Front child is not resolved by a function on this node, but instead on one of its child nodes
        return true;
      case 'bounds':
        this._collider.fn = create$e('rect', this.boundingRect());
        break;
      case 'line':
      case 'rect':
      case 'circle':
      case 'polygon':
      case 'geopolygon':
      case 'polyline':
        this._collider.fn = create$e(this._collider.type, this._collider.definition);
        break;
      default:
        return null;
    }
    return this._collider.fn;
  }
  get colliderType() {
    return this._collider.type;
  }
}

class NodeContainer extends Node {
  addChild(c) {
    if (!c || !(c instanceof Node)) {
      throw new TypeError("Expecting a Node as argument, but got ".concat(c));
    }
    if (c === this) {
      throw new Error('Can not add itself as child!');
    }
    if (c._children && c._children.length && this.ancestors.indexOf(c) >= 0) {
      throw new Error('Can not add an ancestor as child!');
    }
    if (c._parent && c._parent !== this) {
      c._parent.removeChild(c);
    }
    this._children.push(c);
    c._parent = this;
    c._ancestors = null;
    return this;
  }
  addChildren(children) {
    let i,
      num = children ? children.length : 0;
    for (i = 0; i < num; i++) {
      this.addChild(children[i]);
    }
    return this;
  }

  /**
   * Removes given child node from this node.
   * @private
   * @param {Node} c
   * @returns {Node} This object, for chaining purposes.
   */
  removeChild(c) {
    const indx = this._children.indexOf(c);
    if (indx >= 0) {
      this._children.splice(indx, 1);
      c._parent = null;
      c._ancestors = null;
    }
    return this;
  }
  removeChildren(children) {
    let i, num;
    if (!this._children) {
      return this;
    }
    if (children) {
      num = children.length;
      for (i = 0; i < num; i++) {
        this.removeChild(children[i]);
      }
    } else {
      while (this._children.length) {
        this.removeChild(this._children[0]);
      }
    }
    return this;
  }
}

/**
 * @private
 * @extends DisplayObject
 * @typedef {object} ContainerNode
 * @property {DisplayObject[]} children - Array of child nodes
 */

const NC$2 = NodeContainer.prototype;
class Container extends DisplayObject {
  constructor() {
    let s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      type = 'container'
    } = s;
    super(type);
    this.set(s);
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super.set(v);
    const {
      collider
    } = v;
    const opts = extend$1({
      type: null
    }, collider);
    this.collider = opts;
    this.__boundingRect = {
      true: null,
      false: null
    };
    this.__bounds = {
      true: null,
      false: null
    };
  }
  appendChildRect(child, includeTransform) {
    if (typeof child.bounds !== 'undefined') {
      const rect = this.__boundingRect[includeTransform] || {};
      const [p0,, p2] = child.bounds(includeTransform);
      const {
        x: xMin,
        y: yMin
      } = p0;
      const {
        x: xMax,
        y: yMax
      } = p2;
      const _xMax = isNaN(rect.width) ? xMax : Math.max(xMax, rect.width + rect.x);
      const _yMax = isNaN(rect.height) ? yMax : Math.max(yMax, rect.height + rect.y);
      rect.x = isNaN(rect.x) ? xMin : Math.min(xMin, rect.x);
      rect.y = isNaN(rect.y) ? yMin : Math.min(yMin, rect.y);
      rect.width = _xMax - rect.x;
      rect.height = _yMax - rect.y;
      this.__boundingRect[includeTransform] = rect;
    }
  }
  boundingRect() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__boundingRect[includeTransform] !== null) {
      return this.__boundingRect[includeTransform];
    }
    const num = this.children.length;
    for (let i = 0; i < num; i++) {
      this.appendChildRect(this.children[i], includeTransform);
    }
    this.__boundingRect[includeTransform] = extend$1({
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }, this.__boundingRect[includeTransform]);
    return this.__boundingRect[includeTransform];
  }
  bounds() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__bounds[includeTransform] !== null) {
      return this.__bounds[includeTransform];
    }
    const rect = this.boundingRect(includeTransform);
    this.__bounds[includeTransform] = [{
      x: rect.x,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y + rect.height
    }, {
      x: rect.x,
      y: rect.y + rect.height
    }];
    return this.__bounds[includeTransform];
  }
  addChild(c) {
    const r = NC$2.addChild.call(this, c);
    if (this._collider && this._collider.type === 'bounds') {
      this.appendChildRect(c, true);
      const opts = extend$1({
        type: 'bounds',
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, this.__boundingRect.true);
      this.collider = opts;
    }
    return r;
  }
  addChildren(children) {
    const r = NC$2.addChildren.call(this, children);
    const num = children.length;
    if (this._collider && this._collider.type === 'bounds' && num > 0) {
      for (let i = 0; i < num; i++) {
        this.appendChildRect(children[i], true);
      }
      const opts = extend$1({
        type: 'bounds',
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, this.__boundingRect.true);
      this.collider = opts;
    }
    return r;
  }
  removeChild(c) {
    c._stage = null;
    let desc = c.descendants,
      num = desc ? desc.length : 0,
      i;
    // remove reference to stage from all descendants
    for (i = 0; i < num; i++) {
      desc[i]._stage = null;
    }
    NC$2.removeChild.call(this, c);
    if (this._collider && this._collider.type === 'bounds') {
      this.__boundingRect = {
        true: null,
        false: null
      };
      this.__bounds = {
        true: null,
        false: null
      };
      const opts = extend$1(this.boundingRect(true), {
        type: 'bounds'
      });
      this.collider = opts;
    }
    return this;
  }
  removeChildren(children) {
    NC$2.removeChildren.call(this, children);
    if (this._collider && this._collider.type === 'bounds') {
      this.__boundingRect = {
        true: null,
        false: null
      };
      this.__bounds = {
        true: null,
        false: null
      };
      const opts = extend$1(this.boundingRect(true), {
        type: 'bounds'
      });
      this.collider = opts;
    }
    return this;
  }
}
function create$a() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new Container(...s);
}

class Stage extends Container {
  constructor(dpi) {
    super('stage');
    this._stage = this;
    this._dpiRatio = dpi || 1;
  }
  get dpi() {
    return this._dpiRatio;
  }
}
function create$9() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }
  return new Stage(...a);
}

/**
 * @private
 * @typedef {object} GradientNode
 * @property {string} type
 * @property {object[]} stops
 * @property {string} [stops[].type=linearGradient] - radialGradient|linearGradient|conicGradient
 * @property {string} stops[].color - {@link https://www.w3.org/TR/SVG/types.html#DataTypeColor}
 * @property {string} [stops[].opacity=1] - {@link https://www.w3.org/TR/css-color-4/#propdef-opacity}
 * @property {number} stops[].offset - {@link https://www.w3.org/TR/SVG/pservers.html#StopElementOffsetAttribute}
 * @property {number} [degree] - Gradient rotation angle
 */

/**
 * @private
 * @typedef {object} GradientItemNode
 * @property {string} id - Gradient identifier
 * @property {number} x1 - {@link https://www.w3.org/TR/SVG/pservers.html#LinearGradientElementX1Attribute}
 * @property {number} y1 - {@link https://www.w3.org/TR/SVG/pservers.html#LinearGradientElementY1Attribute}
 * @property {number} x2 - {@link https://www.w3.org/TR/SVG/pservers.html#LinearGradientElementX2Attribute}
 * @property {number} y2 - {@link https://www.w3.org/TR/SVG/pservers.html#LinearGradientElementY2Attribute}
 * @property {number} offset - {@link https://www.w3.org/TR/SVG/pservers.html#StopElementOffsetAttribute}
 * @property {object} style - {@link https://www.w3.org/TR/SVG/styling.html#StyleAttribute}
 */

const NC$1 = NodeContainer.prototype;
const allowedAttrs$1 = ['x1', 'x2', 'y1', 'y2', 'id', 'offset', 'style'];
class GradientItem extends DisplayObject {
  constructor() {
    let s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      type = 'container'
    } = s;
    super(type);
    this.set(s);
    this._boundingRect = {};
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super.set(v);
    const attrs = this.attrs;
    let attrKey = '';
    for (let i = 0, len = allowedAttrs$1.length; i !== len; i++) {
      attrKey = allowedAttrs$1[i];
      if (typeof v[attrKey] !== 'undefined') {
        attrs[attrKey] = v[attrKey];
      }
    }
  }
  addChild(c) {
    const r = NC$1.addChild.call(this, c);
    return r;
  }
  addChildren(children) {
    const r = NC$1.addChildren.call(this, children);
    return r;
  }
  removeChild(c) {
    c._stage = null;
    let desc = c.descendants,
      num = desc ? desc.length : 0,
      i;
    // remove reference to stage from all descendants
    for (i = 0; i < num; i++) {
      desc[i]._stage = null;
    }
    NC$1.removeChild.call(this, c);
    return this;
  }
  removeChildren(children) {
    NC$1.removeChildren.call(this, children);
    return this;
  }
}
function create$8() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new GradientItem(...s);
}

/**
 * @private
 * @experimental
 * @typedef {object} PatternNode
 * @property {string} [type='pattern']
 * @property {string} fill
 * @property {number} width
 * @property {number} height
 * @property {object[]} shapes
 * @example
 * // Stripe pattern
 * {
 *   type: 'pattern',
 *   fill: 'red',
 *   width: 4,
 *   height: 4,
 *   shapes: [
 *     { type: 'rect', x: 3, y: 0, width: 1, height: 1 },
 *     { type: 'rect', x: 2, y: 1, width: 1, height: 1 },
 *     { type: 'rect', x: 1, y: 2, width: 1, height: 1 },
 *     { type: 'rect', x: 0, y: 3, width: 1, height: 1 },
 *   ]
 * }
 */

const NC = NodeContainer.prototype;
const allowedAttrs = ['patternUnits', 'x', 'y', 'width', 'height', 'id'];
class PatternItem extends DisplayObject {
  constructor() {
    let s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      type = 'container'
    } = s;
    super(type);
    this.set(s);
    this._boundingRect = {};
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super.set(v);
    const attrs = this.attrs;
    let attrKey = '';
    for (let i = 0, len = allowedAttrs.length; i !== len; i++) {
      attrKey = allowedAttrs[i];
      if (typeof v[attrKey] !== 'undefined') {
        attrs[attrKey] = v[attrKey];
      }
    }
  }
  addChild(c) {
    const r = NC.addChild.call(this, c);
    return r;
  }
  addChildren(children) {
    const r = NC.addChildren.call(this, children);
    return r;
  }
  removeChild(c) {
    c._stage = null;
    let desc = c.descendants,
      num = desc ? desc.length : 0,
      i;
    // remove reference to stage from all descendants
    for (i = 0; i < num; i++) {
      desc[i]._stage = null;
    }
    NC.removeChild.call(this, c);
    return this;
  }
  removeChildren(children) {
    NC.removeChildren.call(this, children);
    return this;
  }
}
function create$7() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new PatternItem(...s);
}

/**
 * @private
 * @extends DisplayObject
 * @typedef {object} RectNode
 * @property {number} x - X coordinate
 * @property {number} y - Y coordinate
 * @property {number} width - Width
 * @property {number} height- Height
 */

class Rect extends DisplayObject {
  constructor() {
    super('rect');
    this.set(...arguments);
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      x = 0,
      y = 0,
      width = 0,
      height = 0,
      rx = 0,
      ry = 0,
      collider
    } = v;
    const opts = extend$1({
      type: 'rect',
      x,
      y,
      width,
      height
    }, collider);
    super.set(v);
    if (width >= 0) {
      this.attrs.x = x;
      this.attrs.width = width;
    } else {
      this.attrs.x = x + width;
      this.attrs.width = -width;
    }
    if (height >= 0) {
      this.attrs.y = y;
      this.attrs.height = height;
    } else {
      this.attrs.y = y + height;
      this.attrs.height = -height;
    }
    if (rx > 0) {
      this.attrs.rx = rx;
    }
    if (ry > 0) {
      this.attrs.ry = ry;
    }
    this.collider = opts;
    this.__boundingRect = {
      true: null,
      false: null
    };
    this.__bounds = {
      true: null,
      false: null
    };
  }
  boundingRect() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__boundingRect[includeTransform] !== null) {
      return this.__boundingRect[includeTransform];
    }
    const p = rectToPoints(this.attrs);
    const pt = includeTransform && this.modelViewMatrix ? this.modelViewMatrix.transformPoints(p) : p;
    const [xMin, yMin, xMax, yMax] = getMinMax$1(pt);
    this.__boundingRect[includeTransform] = {
      x: xMin,
      y: yMin,
      width: xMax - xMin,
      height: yMax - yMin
    };
    return this.__boundingRect[includeTransform];
  }
  bounds() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__bounds[includeTransform] !== null) {
      return this.__bounds[includeTransform];
    }
    const rect = this.boundingRect(includeTransform);
    this.__bounds[includeTransform] = [{
      x: rect.x,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y + rect.height
    }, {
      x: rect.x,
      y: rect.y + rect.height
    }];
    return this.__bounds[includeTransform];
  }
}
function create$6() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new Rect(...s);
}

/**
 * @private
 * @extends DisplayObject
 * @typedef {object} CircleNode
 * @property {number} cx - {@link https://www.w3.org/TR/SVG/shapes.html#CircleElementCXAttribute}
 * @property {number} cy - {@link https://www.w3.org/TR/SVG/shapes.html#CircleElementCYAttribute}
 * @property {number} r - {@link https://www.w3.org/TR/SVG/shapes.html#CircleElementRAttribute}
 */

class Circle extends DisplayObject {
  constructor() {
    super('circle');
    this.set(...arguments);
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      cx = 0,
      cy = 0,
      r = 0,
      collider
    } = v;
    const opts = extend$1({
      type: 'circle',
      cx,
      cy,
      r
    }, collider);
    super.set(v);
    this.attrs.cx = cx;
    this.attrs.cy = cy;
    this.attrs.r = r;
    this.collider = opts;
    this.__boundingRect = {
      true: null,
      false: null
    };
    this.__bounds = {
      true: null,
      false: null
    };
  }
  boundingRect() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__boundingRect[includeTransform] !== null) {
      return this.__boundingRect[includeTransform];
    }
    // TODO Handle Circle bounds correctly for a circle transformed to an non axis aligned ellipse/circle
    // Current solution only rotate the bounds, giving a larger boundingRect if rotated
    const p = this.bounds(includeTransform);
    this.__boundingRect[includeTransform] = {
      x: p[0].x,
      y: p[0].y,
      width: p[2].x - p[0].x,
      height: p[2].y - p[0].y
    };
    return this.__boundingRect[includeTransform];
  }
  bounds() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__bounds[includeTransform] !== null) {
      return this.__bounds[includeTransform];
    }
    // TODO Handle Circle bounds correctly for a circle transformed to an non axis aligned ellipse/circle
    const {
      cx,
      cy,
      r: rX,
      r: rY
    } = this.attrs;
    const x = cx - rX;
    const y = cy - rY;
    let w = rX * 2;
    let h = rY * 2;
    let p = [{
      x,
      y
    }, {
      x: x + w,
      y
    }, {
      x: x + w,
      y: y + h
    }, {
      x,
      y: y + h
    }];
    if (includeTransform && this.modelViewMatrix) {
      p = this.modelViewMatrix.transformPoints(p);
      const [xMin, yMin, xMax, yMax] = getMinMax$1(p);
      w = xMax - xMin;
      h = yMax - yMin;
      this.__bounds[includeTransform] = [{
        x: xMin,
        y: yMin
      }, {
        x: xMin + w,
        y: yMin
      }, {
        x: xMin + w,
        y: yMin + h
      }, {
        x: xMin,
        y: yMin + h
      }];
    } else {
      this.__bounds[includeTransform] = p;
    }
    return this.__bounds[includeTransform];
  }
}
function create$5() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new Circle(...s);
}

/**
 * @private
 * @extends DisplayObject
 * @typedef {object} LineNode
 * @property {number} x1 - {@link https://www.w3.org/TR/SVG/shapes.html#LineElementX1Attribute}
 * @property {number} y1 - {@link https://www.w3.org/TR/SVG/shapes.html#LineElementY1Attribute}
 * @property {number} x2 - {@link https://www.w3.org/TR/SVG/shapes.html#LineElementX2Attribute}
 * @property {number} y2 - {@link https://www.w3.org/TR/SVG/shapes.html#LineElementY2Attribute}
 */

class Line extends DisplayObject {
  constructor() {
    super('line');
    this.set(...arguments);
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      x1 = 0,
      y1 = 0,
      x2 = 0,
      y2 = 0,
      collider
    } = v;
    super.set(v);
    this.attrs.x1 = x1;
    this.attrs.y1 = y1;
    this.attrs.x2 = x2;
    this.attrs.y2 = y2;
    const defaultCollider = {
      type: 'line',
      x1,
      y1,
      x2,
      y2
    };
    this.collider = extend$1(defaultCollider, collider);
    this.__boundingRect = {
      true: null,
      false: null
    };
    this.__bounds = {
      true: null,
      false: null
    };
  }
  boundingRect() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__boundingRect[includeTransform] !== null) {
      return this.__boundingRect[includeTransform];
    }
    let p = lineToPoints(this.attrs);
    if (includeTransform && this.modelViewMatrix) {
      p = this.modelViewMatrix.transformPoints(p);
    }
    const [xMin, yMin, xMax, yMax] = getMinMax$1(p);
    const hasSize = xMin !== xMax || yMin !== yMax;
    this.__boundingRect[includeTransform] = {
      x: xMin,
      y: yMin,
      width: hasSize ? Math.max(1, xMax - xMin) : 0,
      height: hasSize ? Math.max(1, yMax - yMin) : 0
    };
    return this.__boundingRect[includeTransform];
  }
  bounds() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__bounds[includeTransform] !== null) {
      return this.__bounds[includeTransform];
    }
    const rect = this.boundingRect(includeTransform);
    this.__bounds[includeTransform] = [{
      x: rect.x,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y + rect.height
    }, {
      x: rect.x,
      y: rect.y + rect.height
    }];
    return this.__bounds[includeTransform];
  }
}
function create$4() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new Line(...s);
}

const PI_2 = Math.PI / 2;
function lineAngle(p0, p1) {
  const t = Math.atan2(p1.y - p0.y, p1.x - p0.x);
  return t < 0 ? t + Math.PI * 2 : t;
}

// TODO Find a more accurate method to find the open and closed points
function rotatePoint(p, angle, radius) {
  return {
    x: p.x + Math.cos(angle) * radius,
    y: p.y + Math.sin(angle) * radius
  };
}
function polylineToPolygonCollider(points, radius) {
  let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const open = [];
  const close = [];

  // TODO handle case if points.length === 2

  if (opts.forceOrientation === 'h') {
    const start = points[0].x < points[1].x ? -1 : 1;
    const end = points[points.length - 1].x > points[points.length - 2].x ? 1 : -1;
    points.unshift({
      x: points[0].x + start,
      y: points[0].y
    });
    points.push({
      x: points[points.length - 1].x + end,
      y: points[points.length - 1].y
    });
  } else if (opts.forceOrientation === 'v') {
    const start = points[0].y < points[1].y ? -1 : 1;
    const end = points[points.length - 1].y > points[points.length - 2].y ? 1 : -1;
    points.unshift({
      x: points[0].x,
      y: points[0].y + start
    });
    points.push({
      x: points[points.length - 1].x,
      y: points[points.length - 1].y + end
    });
  }
  const len = points.length - 1;
  for (let i = 1; i < len; i++) {
    const prev = points[i - 1];
    const curr = points[i];
    const next = points[i + 1];
    const currToPrev = lineAngle(curr, prev);
    const currToNext = lineAngle(curr, next);
    const openAngle = (currToPrev + currToNext) / 2;
    const closeAngle = openAngle + Math.PI;
    const maxAngle = Math.max(openAngle, closeAngle);
    const minAngle = Math.min(openAngle, closeAngle);
    const openClose = currToPrev > currToNext;
    if (i === 1) {
      const prevToCurr = lineAngle(prev, curr);
      open.push(rotatePoint(prev, prevToCurr - PI_2, radius));
      close.unshift(rotatePoint(prev, prevToCurr + PI_2, radius));
    }
    const opened = openClose ? maxAngle : minAngle;
    const closed = openClose ? minAngle : maxAngle;
    open.push(rotatePoint(curr, opened, radius));
    close.unshift(rotatePoint(curr, closed, radius));
    if (i === len - 1) {
      const nextToCurr = lineAngle(next, curr);
      open.push(rotatePoint(next, nextToCurr + PI_2, radius));
      close.unshift(rotatePoint(next, nextToCurr - PI_2, radius));
    }
  }
  return {
    type: 'polygon',
    vertices: [...open, ...close]
  };
}

function flatten2d(ary) {
  const newAry = [];
  let a;
  let len = ary.length;
  for (let i = 0; i < len; i++) {
    a = ary[i];
    for (let k = 0; k < a.length; k++) {
      newAry.push(a[k]);
    }
  }
  return newAry;
}

const EPSILON = 1e-12;
const CURVES = {
  step: curveStep,
  stepAfter: stepAfter,
  stepBefore: stepBefore,
  linear: curveLinear,
  basis: curveBasis,
  cardinal: curveCardinal.tension(0),
  catmullRom: curveCatmullRom,
  monotonex: monotoneX,
  monotoney: monotoneY,
  natural: curveNatural
};

/**
 * @private
 * @extends DisplayObject
 * @typedef {object} PathNode
 * @property {string} d - {@link https://www.w3.org/TR/SVG/paths.html#DAttribute}
 */

function isClosed(points) {
  if (points.length < 2) {
    return false;
  }
  const p0 = points[0];
  const p1 = points[points.length - 1];
  return Math.abs(p0.x - p1.x) < EPSILON && Math.abs(p0.y - p1.y) < EPSILON;
}
class Path extends DisplayObject {
  constructor() {
    super('path');
    this.set(...arguments);
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super.set(v);
    this.segments = [];
    this.points = [];
    if (v.arcDatum) {
      const arcGen = arc();
      arcGen.innerRadius(v.desc.slice.innerRadius);
      arcGen.outerRadius(v.desc.slice.outerRadius);
      arcGen.cornerRadius(v.desc.slice.cornerRadius);
      const d = arcGen(v.arcDatum);
      this.attrs.d = d;
    } else if (v.points) {
      const {
        major,
        minor,
        layerObj,
        points,
        stngs,
        generatorType
      } = v;
      const areaGenerator = area();
      const defined = stngs.coordinates ? stngs.coordinates.defined : null;
      areaGenerator[major.p](d => d.major * major.size) // eslint-disable-line no-unexpected-multiline
      ["".concat(minor.p, "1")](d => d.minor * minor.size) // eslint-disable-line no-unexpected-multiline
      ["".concat(minor.p, "0")](d => d.minor0 * minor.size) // eslint-disable-line no-unexpected-multiline
      .curve(CURVES[layerObj.curve === 'monotone' ? "monotone".concat(major.p) : layerObj.curve]);
      if (defined) {
        areaGenerator.defined(d => !d.dummy && typeof d.minor === 'number' && !isNaN(d.minor) && d.defined);
      } else {
        areaGenerator.defined(d => !d.dummy && typeof d.minor === 'number' && !isNaN(d.minor));
      }
      const filteredPoints = stngs.connect ? points.filter(areaGenerator.defined()) : points;
      const generator = generatorType === 'area' ? areaGenerator : areaGenerator[generatorType]();
      const d = generator(filteredPoints);
      this.attrs.d = d;
    } else if (v.d) {
      this.attrs.d = v.d;
    }
    this.__boundingRect = {
      true: null,
      false: null
    };
    this.__bounds = {
      true: null,
      false: null
    };
    if (Array.isArray(v.collider) || typeof v.collider === 'object' && typeof v.collider.type !== 'undefined') {
      this.collider = v.collider;
    } else if (this.attrs.d) {
      this.segments = pathToPoints(this.attrs.d);
      if (this.segments.length > 1 && this.segments.every(segment => isClosed(segment))) {
        this.collider = extend$1({
          type: 'geopolygon',
          vertices: this.segments
        }, v.collider);
        return;
      }
      this.segments.forEach(segment => {
        if (segment.length <= 1) ; else if (isClosed(segment)) {
          this.collider = extend$1({
            type: 'polygon',
            vertices: segment
          }, v.collider);
        } else if (typeof v.collider === 'object' && v.collider.visual) {
          const size = this.attrs['stroke-width'] / 2;
          this.collider = polylineToPolygonCollider(segment, size, v.collider);
        } else {
          this.collider = extend$1({
            type: 'polyline',
            points: segment
          }, v.collider);
        }
      });
    }
  }
  boundingRect() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__boundingRect[includeTransform] !== null) {
      return this.__boundingRect[includeTransform];
    }
    if (!this.points.length) {
      this.segments = this.segments.length ? this.segments : pathToPoints(this.attrs.d);
      this.points = flatten2d(this.segments);
    }
    const pt = includeTransform && this.modelViewMatrix ? this.modelViewMatrix.transformPoints(this.points) : this.points;
    const [xMin, yMin, xMax, yMax] = getMinMax$1(pt);
    this.__boundingRect[includeTransform] = {
      x: xMin || 0,
      y: yMin || 0,
      width: xMax - xMin || 0,
      height: yMax - yMin || 0
    };
    return this.__boundingRect[includeTransform];
  }
  bounds() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__bounds[includeTransform] !== null) {
      return this.__bounds[includeTransform];
    }
    const rect = this.boundingRect(includeTransform);
    this.__bounds[includeTransform] = [{
      x: rect.x,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y + rect.height
    }, {
      x: rect.x,
      y: rect.y + rect.height
    }];
    return this.__bounds[includeTransform];
  }
}
function create$3() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new Path(...s);
}

function hasData$1(_ref) {
  let {
    data,
    _boundingRect,
    _textBoundsFn
  } = _ref;
  return typeof data !== 'undefined' && data !== null && (_boundingRect || _textBoundsFn);
}

/**
 * @private
 * @extends DisplayObject
 * @typedef {object} TextNode
 * @property {string} text
 * @property {number} x - {@link https://www.w3.org/TR/SVG/text.html#TextElementXAttribute}
 * @property {number} y - {@link https://www.w3.org/TR/SVG/text.html#TextElementYAttribute}
 * @property {number} [dx] - {@link https://www.w3.org/TR/SVG/text.html#TextElementDXAttribute}
 * @property {number} [dy] - {@link https://www.w3.org/TR/SVG/text.html#TextElementDYAttribute}
 * @property {string} [fontSize] - {@link https://www.w3.org/TR/SVG/text.html#FontPropertiesUsedBySVG}
 * @property {string} [fontFamily] - {@link https://www.w3.org/TR/SVG/text.html#FontPropertiesUsedBySVG}
 * @property {Rect} [boundingRect] - Explicitly set the bounding rectangle of the node. Has predence over textBoundsFn
 * @property {function} [textBoundsFn] - Implicitly set the bounding rectangle of the node, the function must return an object with x, y, width and height attributes
 * @property {string} [baseline] - Alias for dominantBaseline
 * @property {string} [dominantBaseline] - {@link https://www.w3.org/TR/SVG/text.html#BaselineAlignmentProperties}
 * @property {string} [anchor] - Alias for textAnchor
 * @property {string} [textAnchor] - {@link https://www.w3.org/TR/SVG/text.html#TextAnchorProperty}
 * @property {string} [wordBreak] - Word-break option
 * @property {number} [maxWidth] - Maximum allowed text width
 * @property {number} [maxHeight] - Maximum allowed text height. If both maxLines and maxHeight are set, the property that results in the fewest number of lines is used
 * @property {number} [maxLines] - Maximum number of lines allowed
 * @property {number} [lineHeight=1.2] - Line height
 */

class Text extends DisplayObject {
  constructor() {
    super('text');
    this.set(...arguments);
  }
  set() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      x = 0,
      y = 0,
      dx = 0,
      dy = 0,
      textBoundsFn,
      text,
      title,
      collider,
      boundingRect,
      ellipsed
    } = v;
    super.set(v);
    this.attrs.x = x;
    this.attrs.y = y;
    this.attrs.dx = dx;
    this.attrs.dy = dy;
    this.attrs.text = text;
    if (typeof title !== 'undefined') {
      this.attrs.title = String(title);
    }
    if (typeof boundingRect === 'object') {
      this._textBoundsFn = () => boundingRect;
    } else if (typeof textBoundsFn === 'function') {
      this._textBoundsFn = textBoundsFn;
    }
    if (typeof ellipsed === 'string') {
      this.ellipsed = ellipsed;
    }
    this.collider = extend$1({
      type: hasData$1(this) ? 'bounds' : null
    }, collider);
    this.__boundingRect = {
      true: null,
      false: null
    };
    this.__bounds = {
      true: null,
      false: null
    };
  }
  boundingRect() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__boundingRect[includeTransform] !== null) {
      return this.__boundingRect[includeTransform];
    }
    let rect;
    if (typeof this._textBoundsFn === 'function') {
      rect = this._textBoundsFn(this.attrs);
    } else {
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }
    const p = rectToPoints(rect);
    const pt = includeTransform && this.modelViewMatrix ? this.modelViewMatrix.transformPoints(p) : p;
    const [xMin, yMin, xMax, yMax] = getMinMax$1(pt);
    this.__boundingRect[includeTransform] = {
      x: xMin,
      y: yMin,
      width: xMax - xMin,
      height: yMax - yMin
    };
    return this.__boundingRect[includeTransform];
  }
  bounds() {
    let includeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.__bounds[includeTransform] !== null) {
      return this.__bounds[includeTransform];
    }
    const rect = this.boundingRect(includeTransform);
    this.__bounds[includeTransform] = [{
      x: rect.x,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y
    }, {
      x: rect.x + rect.width,
      y: rect.y + rect.height
    }, {
      x: rect.x,
      y: rect.y + rect.height
    }];
    return this.__bounds[includeTransform];
  }
}
function create$2() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  return new Text(...s);
}

const reg$1 = registryFactory();
reg$1.add('rect', create$6);
reg$1.add('circle', create$5);
reg$1.add('text', create$2);
reg$1.add('line', create$4);
reg$1.add('path', create$3);
reg$1.add('stage', create$9);
reg$1.add('container', create$a);
reg$1.add('defs', create$a);
reg$1.add('linearGradient', create$8);
reg$1.add('radialGradient', create$8);
reg$1.add('conicGradient', create$8);
reg$1.add('stop', create$8);
reg$1.add('pattern', create$7);

/* eslint-disable import/prefer-default-export */
function create$1(type, input) {
  return reg$1.get(type)(input);
}
/* eslint-enable import/prefer-default-export */

/**
 * Creates a context. Input an array of strings that should be inherited by the context.
 * @private
 *
 * @param  {Array}  [whitelist=[]]  An array of whitelisted string keys to inherit
 * @return {Function}               A context function
 */
function contextFactory() {
  let whitelist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const states = [{}];

  /**
   * Returns the current context as an object. The object is mutable.
   * @private
   *
   * @return {Object}   Current context
   */
  function context() {
    // Returns the current context, the last in the stack.
    const item = states[states.length - 1];
    return item;
  }

  /**
   * Call context.save() to save the current context and move down the stack.
   *
   * @param  {Object} [item={}]   Optional item to save.
   * @return {Object}             The current context, just as context()
   */
  context.save = function save() {
    let item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const current = context();
    const obj = {};
    let key = '';

    // Only inherit whitelisted properties
    for (let i = 0; i < whitelist.length; i++) {
      key = whitelist[i];
      if (typeof current[key] !== 'undefined') {
        obj[key] = current[key];
      }
    }

    // Extend the new object with the saved item
    extend$1(obj, item);

    // Push it to the stack
    states.push(obj);

    // Return the new current context
    return context();
  };

  /**
   * Restore the previous context. Returns the context.
   *
   * @return {Undefined}   Returns nothing
   */
  context.restore = function restore() {
    // Remove the last element from the stack
    states.splice(states.length - 1, 1);
  };
  return context;
}

const styleContext = contextFactory(['stroke', 'fill', 'strokeWidth', 'opacity', 'fontFamily', 'fontSize', 'baseline']);
function doEvent(state, listeners) {
  if (!Array.isArray(listeners)) {
    return;
  }
  for (let i = 0, len = listeners.length; i < len; i++) {
    listeners[i](state);
  }
}
function updateState(state, index, nodes) {
  state.node = nodes[index];
  state.index = index;
}
function traverse(items, parent, matrix, on) {
  let disabled = false;
  const state = {
    siblings: items,
    node: null,
    index: 0
  };
  for (let i = 0, len = items.length; i < len; i++) {
    updateState(state, i, items);
    doEvent(state, on.create);
    disabled = typeof state.node.disabled === 'function' ? state.node.disabled() : state.node.disabled;
    if (disabled) {
      continue;
    }

    // Save the current style context to be able to inherit styles
    state.node = styleContext.save(state.node);
    const displayNode = create$1(state.node.type, state.node);
    if (displayNode) {
      if (state.node.transform) {
        matrix.save();
        resolveTransform(state.node.transform, matrix);
      }
      if (!matrix.isIdentity()) {
        displayNode.modelViewMatrix = matrix.clone();
      }
      parent.addChild(displayNode);
      if (state.node.children) {
        traverse(state.node.children, displayNode, matrix, on);
      }
      if (state.node.transform) {
        matrix.restore();
      }
    }

    // Revert to previous style context
    styleContext.restore();
  }
}
function scene(_ref) {
  let {
    items,
    stage,
    dpi,
    on = {}
  } = _ref;
  if (!stage) {
    stage = create$1('stage', dpi);
  }
  traverse(items, stage, new Matrix(), on);
  return stage;
}

/**
 * Get or create a gradient
 * @ignore
 * @param  {Object} g        Canvas 2d context
 * @param  {Object} node    Current node (for width/height properties)
 * @param  {Object} gradient The gradient properties
 * @return {Object}          A canvas compatible radial or linear gradient object
 */
function createCanvasGradient(g, node, gradient) {
  const {
    orientation,
    degree,
    stops = []
  } = gradient;
  let newGradient = null;
  if (orientation === 'radial') {
    const bounds = node.boundingRect();
    newGradient = g.createRadialGradient(bounds.x + bounds.width / 2, bounds.y + bounds.height / 2, 1e-5, bounds.x + bounds.width / 2, bounds.y + bounds.height / 2, Math.max(bounds.width, bounds.height) / 2);
  } else if (orientation === 'conic') {
    const startAngle = gradient.startAngle || 0;
    const centerOffsetX = gradient.x || 0;
    const centerOffsetY = gradient.y || 0;
    newGradient = g.createConicGradient(startAngle, centerOffsetX, centerOffsetY);
  } else {
    const points = degreesToPoints(degree);
    ['x1', 'x2', 'y1', 'y2'].forEach(c => {
      if (c in gradient) {
        points[c] = gradient[c];
      }
    });
    const bounds = node.boundingRect();
    newGradient = g.createLinearGradient(bounds.x + points.x1 * bounds.width, bounds.y + points.y1 * bounds.height, bounds.x + points.x2 * bounds.width, bounds.y + points.y2 * bounds.height);
  }
  for (let i = 0, len = stops.length; i < len; i++) {
    let stop = stops[i];
    newGradient.addColorStop(stop.offset, stop.color);
  }
  return newGradient;
}

function getPattern(pattern, dummyCanvas, ctx) {
  dummyCanvas.width = pattern.width;
  dummyCanvas.height = pattern.height;
  ctx.save();
  ctx.fillStyle = pattern.fill;
  pattern.shapes.forEach(s => {
    switch (s.type) {
      case 'rect':
        ctx.rect(s.x, s.y, s.width, s.height);
        break;
    }
  });
  ctx.fill();
  ctx.restore();
  return ctx.createPattern(dummyCanvas, 'repeat');
}
function patternizer$1(document) {
  const dummyCanvas = document.createElement('canvas');
  const ctx = dummyCanvas.getContext('2d');
  let cache = {};
  return {
    create(pattern) {
      const key = pattern.key;
      if (key) {
        cache[key] = cache[key] || getPattern(pattern, dummyCanvas, ctx);
        return cache[key];
      }
      return getPattern(pattern, dummyCanvas, ctx);
    },
    clear() {
      cache = {};
    }
  };
}

/**
 * @typedef {object} Renderer~SizeDefinition
 * @property {number} [x] - x-coordinate
 * @property {number} [y] - y-coordinate
 * @property {number} [width] - Width
 * @property {number} [height] - Height
 * @property {object} [scaleRatio]
 * @property {number} [scaleRatio.x] - Scale ratio on x-axis
 * @property {number} [scaleRatio.y] - Scale ratio on y-axis
 * @property {object} [margin]
 * @property {number} [margin.left] - Left margin
 * @property {number} [margin.top] - Top margin
 */

/**
 * Create the renderer box
 * @private
 * @param {Renderer~SizeDefinition} [opts]
 * @returns {Renderer~SizeDefinition} A svg renderer instance
 */
function createRendererBox() {
  let {
    x,
    y,
    width,
    height,
    scaleRatio,
    margin,
    edgeBleed
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const box = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    scaleRatio: {
      x: 1,
      y: 1
    },
    margin: {
      left: 0,
      top: 0
    },
    edgeBleed: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      bool: false
    }
  };
  box.x = isNaN(x) ? box.x : x;
  box.y = isNaN(y) ? box.y : y;
  box.width = isNaN(width) ? box.width : width;
  box.height = isNaN(height) ? box.height : height;
  if (typeof scaleRatio !== 'undefined') {
    box.scaleRatio.x = isNaN(scaleRatio.x) ? box.scaleRatio.x : scaleRatio.x;
    box.scaleRatio.y = isNaN(scaleRatio.y) ? box.scaleRatio.y : scaleRatio.y;
  }
  if (typeof margin !== 'undefined') {
    box.margin.left = isNaN(margin.left) ? 0 : margin.left;
    box.margin.top = isNaN(margin.top) ? 0 : margin.top;
  }
  if (typeof edgeBleed === 'object') {
    ['left', 'right', 'top', 'bottom'].forEach(prop => {
      if (!isNaN(edgeBleed[prop]) && edgeBleed[prop] > 0) {
        box.edgeBleed[prop] = edgeBleed[prop];
        box.edgeBleed.bool = true;
      }
    });
  }
  box.computedPhysical = {
    x: Math.round(box.margin.left + (box.x - box.edgeBleed.left) * box.scaleRatio.x),
    y: Math.round(box.margin.top + (box.y - box.edgeBleed.top) * box.scaleRatio.y),
    width: Math.round((box.width + box.edgeBleed.left + box.edgeBleed.right) * box.scaleRatio.x),
    height: Math.round((box.height + box.edgeBleed.top + box.edgeBleed.bottom) * box.scaleRatio.y)
  };
  return box;
}

/**
 * Base renderer factory
 * @private
 */
function create() {
  /**
   * @interface
   * @alias Renderer
   */
  const renderer = {
    /**
     * Get the element this renderer is attached to
     * @returns {HTMLElement}
     */
    element: () => {},
    /**
     * Get the root element of the renderer
     * @returns {HTMLElement}
     */
    root: () => {},
    /**
     * Set or Get renderer settings
     * @param {object} [settings] Settings for the renderer
     */
    settings: () => {},
    /**
     * @param {HTMLElement} element - Element to attach renderer to
     * @returns {HTMLElement} Root element of the renderer
     */
    appendTo: () => {},
    /**
     * Get Scene based on provided nodes, constructed in the same way as in the render function.
     * Only the canvas and svg renderer uses scene nodes.
     * @private
     * @param {object[]} nodes - Nodes on which the scene will be constructed
     * @returns {Scene}
     */
    getScene: () => [],
    /**
     * @param {object[]} nodes - Nodes to render
     * @returns {boolean} True if the nodes were rendered, otherwise false
     */
    render: () => false,
    /**
     * Get nodes renderer at area
     * @param {Point|Circle|Rect|Line|Polygon|Geopolygon} geometry - Get nodes that intersects with geometry
     * @returns {SceneNode[]}
     */
    itemsAt: () => [],
    /**
     * Get all nodes matching the provided selector
     * @param {string} selector CSS selector [type, attribute, universal, class]
     * @returns {SceneNode[]} Array of objects containing matching nodes
     */
    findShapes: () => [],
    /**
     * Clear all child elements from the renderer root element
     * @returns {Renderer} The renderer instance
     */
    clear: () => {},
    /**
     * Remove the renderer root element from its parent element
     */
    destory: () => {},
    /**
     * Set or Get the size definition of the renderer container.
     * @param {Renderer~SizeDefinition} [opts] - Size definition
     * @returns {Renderer~SizeDefinition} The current size definition
     */
    size: () => {},
    /**
     * @function
     * @param {object} opts
     * @param {string} opts.text - Text to measure
     * @param {string} opts.fontSize - Font size
     * @param {string} opts.fontFamily - Font family
     * @returns {object} Width and height of text
     * @example
     * measureText({
     *  text: 'my text',
     *  fontSize: '12px',
     *  fontFamily: 'Arial'
     * }); // returns { width: 20, height: 12 }
     */
    measureText,
    /**
     * Calculates the bounding rectangle of a text node. Including any potential line breaks.
     * @function
     * @private
     * @param {TextNode} node
     * @return {Rect} The bounding rectangle
     */
    textBounds,
    setKey: key => {
      renderer.element().setAttribute('data-key', key);
    }
  };
  return renderer;
}

function hasData(data) {
  return typeof data !== 'undefined' && data !== null;
}
function injectTextBoundsFn(renderer) {
  return _ref => {
    let {
      node
    } = _ref;
    if (node.type === 'text' && hasData(node.data) && !node.textBoundsFn) {
      node.textBoundsFn = renderer.textBounds;
    }
  };
}

const DEFAULT_PADDING = {
  horizontal: 200,
  vertical: 200
};

/**
 * Creates a canvas element, preferrably larger than the target canvas.
 * This "buffer canvas" is detached from the DOM and allows rendering of shapes outside of the visible area.
 * Especially useful when applying transforms to target canvas.
 * @private
 */
class CanvasBuffer {
  constructor(targetCanvas) {
    this.targetCanvas = targetCanvas;
    this.bufferCanvas = targetCanvas.cloneNode();
  }

  /**
   * @param {object|function} [canvasBufferSize] object containing width and height or a function which returns it
   */
  updateSize(_ref) {
    let {
      rect,
      dpiRatio,
      canvasBufferSize
    } = _ref;
    let bufferSize;
    if (canvasBufferSize) {
      bufferSize = typeof canvasBufferSize === 'function' ? canvasBufferSize(rect) : canvasBufferSize;
    } else {
      bufferSize = {
        width: rect.computedPhysical.width + DEFAULT_PADDING.horizontal * 2,
        height: rect.computedPhysical.height + DEFAULT_PADDING.vertical * 2
      };
    }
    this.bufferCanvas.style.width = "".concat(bufferSize.width, "px");
    this.bufferCanvas.style.height = "".concat(bufferSize.height, "px");
    this.bufferCanvas.width = Math.round(bufferSize.width * dpiRatio);
    this.bufferCanvas.height = Math.round(bufferSize.height * dpiRatio);
  }

  /**
   * Draws buffer canvas on the target canvas.
   */
  apply() {
    const g = this.targetCanvas.getContext('2d');
    g.drawImage(this.bufferCanvas, 0, 0);
  }
  clear() {
    // clear canvas
    this.bufferCanvas.width = this.bufferCanvas.width; // eslint-disable-line
  }
  getContext() {
    return this.bufferCanvas.getContext('2d');
  }
}

const reg = registryFactory();
function toLineDash(p) {
  if (Array.isArray(p)) {
    return p;
  }
  if (typeof p === 'string') {
    if (p.indexOf(',') !== -1) {
      return p.split(',');
    }
    return p.split(' ');
  }
  return [];
}
function dpiScale(g) {
  const dpr = typeof window === 'undefined' ? 1 : window.devicePixelRatio || 1;
  const backingStorePixelRatio = g.webkitBackingStorePixelRatio || g.mozBackingStorePixelRatio || g.msBackingStorePixelRatio || g.oBackingStorePixelRatio || g.backingStorePixelRatio || 1;
  return dpr / backingStorePixelRatio;
}
function resolveMatrix(p, g) {
  g.setTransform(p[0][0], p[1][0], p[0][1], p[1][1], p[0][2], p[1][2]);
}
function applyContext(g, s, shapeToCanvasMap) {
  let computed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const computedKeys = Object.keys(computed);
  for (let i = 0, len = shapeToCanvasMap.length; i < len; i++) {
    let cmd = shapeToCanvasMap[i];
    const shapeCmd = cmd[0];
    const canvasCmd = cmd[1];
    const convertCmd = cmd[2];
    if (shapeCmd in s.attrs && !(canvasCmd in computed) && g[canvasCmd] !== s.attrs[shapeCmd]) {
      const val = convertCmd ? convertCmd(s.attrs[shapeCmd]) : s.attrs[shapeCmd];
      if (typeof g[canvasCmd] === 'function') {
        g[canvasCmd](val);
      } else {
        g[canvasCmd] = val;
      }
    }
  }
  for (let i = 0, len = computedKeys.length; i < len; i++) {
    const key = computedKeys[i];
    g[key] = computed[key];
  }
}
function renderShapes(shapes, g, shapeToCanvasMap, deps) {
  for (let i = 0, len = shapes.length; i < len; i++) {
    let shape = shapes[i];
    let computed = {};
    g.save();
    if (shape.attrs && (shape.attrs.fill || shape.attrs.stroke)) {
      if (shape.attrs.fill && typeof shape.attrs.fill === 'object' && shape.attrs.fill.type === 'gradient') {
        computed.fillStyle = createCanvasGradient(g, shape, shape.attrs.fill);
      } else if (shape.attrs.fill && typeof shape.attrs.fill === 'object' && shape.attrs.fill.type === 'pattern') {
        computed.fillStyle = deps.patterns.create(shape.attrs.fill);
      }
      if (shape.attrs.stroke && typeof shape.attrs.stroke === 'object' && shape.attrs.stroke.type === 'gradient') {
        computed.strokeStyle = createCanvasGradient(g, shape, shape.attrs.stroke);
      } else if (shape.attrs.stroke && typeof shape.attrs.stroke === 'object' && shape.attrs.stroke.type === 'pattern') {
        computed.strokeStyle = deps.patterns.create(shape.attrs.stroke);
      }
    }
    applyContext(g, shape, shapeToCanvasMap, computed);
    if (shape.modelViewMatrix) {
      resolveMatrix(shape.modelViewMatrix.elements, g);
    }
    if (reg.has(shape.type)) {
      reg.get(shape.type)(shape.attrs, {
        g,
        doFill: 'fill' in shape.attrs && shape.attrs.fill !== 'none',
        doStroke: 'stroke' in shape.attrs && shape.attrs['stroke-width'] !== 0,
        ellipsed: shape.ellipsed
      });
    }
    if (shape.children) {
      renderShapes(shape.children, g, shapeToCanvasMap, deps);
    }
    g.restore();
  }
}

/**
 * Sets transform on target element.
 * @param {Element} el Target canvas element
 * @param {number} dpiRatio
 * @param {TransformObject}
 * @private
 */
function applyTransform(_ref) {
  let {
    el,
    dpiRatio,
    transform
  } = _ref;
  if (typeof transform === 'object') {
    const adjustedTransform = [transform.horizontalScaling, transform.horizontalSkewing, transform.verticalSkewing, transform.verticalScaling, transform.horizontalMoving * dpiRatio, transform.verticalMoving * dpiRatio];
    const g = el.getContext('2d');
    g.setTransform(...adjustedTransform);
  }
}

/**
 * Create a new canvas renderer
 * @typedef {function} canvasRendererFactory
 * @param {function} [sceneFn] - Scene factory
 * @returns {Renderer} A canvas renderer instance
 */
function renderer$2() {
  let sceneFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : scene;
  let el;
  let buffer;
  const settings = {
    transform: undefined,
    canvasBufferSize: undefined,
    progressive: undefined
  };
  let scene$1;
  let hasChangedRect = false;
  let rect = createRendererBox();
  const shapeToCanvasMap = [['fill', 'fillStyle'], ['stroke', 'strokeStyle'], ['opacity', 'globalAlpha'], ['globalAlpha', 'globalAlpha'], ['stroke-width', 'lineWidth'], ['stroke-linejoin', 'lineJoin'], ['stroke-dasharray', 'setLineDash', toLineDash]];
  let patterns;
  const canvasRenderer = create();
  canvasRenderer.element = () => el;
  canvasRenderer.root = () => el;
  canvasRenderer.settings = rendererSettings => {
    if (rendererSettings) {
      Object.keys(settings).forEach(key => {
        if (rendererSettings[key] !== undefined) {
          settings[key] = rendererSettings[key];
        }
      });
    }
    return settings;
  };
  canvasRenderer.appendTo = element => {
    if (!el) {
      el = element.ownerDocument.createElement('canvas');
      el.style.position = 'absolute';
      el.style['-webkit-font-smoothing'] = 'antialiased';
      el.style['-moz-osx-font-smoothing'] = 'antialiased';
      el.style.pointerEvents = 'none';
    }
    if (typeof settings.transform === 'function' && !buffer) {
      buffer = new CanvasBuffer(el);
    }
    element.appendChild(el);
    return el;
  };
  canvasRenderer.getScene = shapes => {
    const g = buffer && buffer.getContext() || el.getContext('2d');
    const dpiRatio = dpiScale(g);
    const scaleX = rect.scaleRatio.x;
    const scaleY = rect.scaleRatio.y;
    const sceneContainer = {
      type: 'container',
      children: shapes,
      transform: rect.edgeBleed.bool ? "translate(".concat(rect.edgeBleed.left * dpiRatio * scaleX, ", ").concat(rect.edgeBleed.top * dpiRatio * scaleY, ")") : ''
    };
    if (dpiRatio !== 1 || scaleX !== 1 || scaleY !== 1) {
      sceneContainer.transform += "scale(".concat(dpiRatio * scaleX, ", ").concat(dpiRatio * scaleY, ")");
    }
    return sceneFn({
      items: [sceneContainer],
      dpi: dpiRatio,
      on: {
        create: [onLineBreak(canvasRenderer.measureText), injectTextBoundsFn(canvasRenderer)]
      }
    });
  };
  canvasRenderer.render = shapes => {
    if (!el) {
      return false;
    }
    if (!patterns) {
      patterns = patternizer$1(el.ownerDocument);
    }
    const g = buffer && buffer.getContext() || el.getContext('2d');
    const dpiRatio = dpiScale(g);
    const transform = buffer && settings.transform();
    if (transform) {
      // clear canvas
      el.width = el.width; // eslint-disable-line
      applyTransform({
        el,
        dpiRatio,
        transform
      });
      buffer.apply();
      return true;
    }
    if (hasChangedRect) {
      el.style.left = "".concat(rect.computedPhysical.x, "px");
      el.style.top = "".concat(rect.computedPhysical.y, "px");
      el.style.width = "".concat(rect.computedPhysical.width, "px");
      el.style.height = "".concat(rect.computedPhysical.height, "px");
      el.width = Math.round(rect.computedPhysical.width * dpiRatio);
      el.height = Math.round(rect.computedPhysical.height * dpiRatio);
      if (buffer) {
        buffer.updateSize({
          rect,
          dpiRatio,
          canvasBufferSize: settings.canvasBufferSize
        });
      }
    }
    const newScene = canvasRenderer.getScene(shapes);
    const hasChangedScene = scene$1 ? !newScene.equals(scene$1) : true;
    patterns.clear();
    const doRender = hasChangedRect || hasChangedScene;
    const progressive = typeof settings.progressive === 'function' && settings.progressive();
    if (doRender) {
      if (!progressive || progressive.isFirst) {
        canvasRenderer.clear();
      }
      renderShapes(newScene.children, g, shapeToCanvasMap, {
        patterns
      });
    }
    if (buffer) {
      // clear canvas
      el.width = el.width; // eslint-disable-line
      buffer.apply();
    }
    hasChangedRect = false;
    if (progressive && !progressive.isFirst) {
      newScene.children.unshift(...scene$1.children);
    }
    scene$1 = newScene;
    return doRender;
  };
  canvasRenderer.itemsAt = input => scene$1 ? scene$1.getItemsFrom(input) : [];
  canvasRenderer.findShapes = selector => scene$1 ? scene$1.findShapes(selector) : [];
  canvasRenderer.clear = () => {
    if (el) {
      el.width = el.width; // eslint-disable-line
    }
    if (buffer) {
      buffer.clear();
    }
    scene$1 = null;
    return canvasRenderer;
  };
  canvasRenderer.size = opts => {
    if (opts) {
      const newRect = createRendererBox(opts);
      if (JSON.stringify(rect) !== JSON.stringify(newRect)) {
        hasChangedRect = true;
        rect = newRect;
      }
    }
    return rect;
  };
  canvasRenderer.destroy = () => {
    if (el) {
      if (el.parentElement) {
        el.parentElement.removeChild(el);
      }
      el = null;
    }
    if (buffer) {
      buffer = null;
    }
    scene$1 = null;
  };
  return canvasRenderer;
}
function register(type, renderFn) {
  reg.add(type, renderFn);
}

function clampRadius(max, value) {
  return Math.max(0, Math.min(max, value));
}

/**
 * Implementation details follow rx/ry restrictions from https://svgwg.org/svg2-draft/geometry.html#RX
 *
 * Using Quadratic Bézier curve it's not possible accurately represent a circle or ellipse but should for the case of a rounded rectangle be sufficent.
 * @private
 */
function quadraticRoundedRect(g, x, y, width, height, rx, ry) {
  rx = clampRadius(width / 2, rx > 0 ? rx : ry);
  ry = clampRadius(height / 2, ry > 0 ? ry : rx);
  g.moveTo(x, y + ry);
  g.lineTo(x, y + height - ry);
  g.quadraticCurveTo(x, y + height, x + rx, y + height);
  g.lineTo(x + width - rx, y + height);
  g.quadraticCurveTo(x + width, y + height, x + width, y + height - ry);
  g.lineTo(x + width, y + ry);
  g.quadraticCurveTo(x + width, y, x + width - rx, y);
  g.lineTo(x + rx, y);
  g.quadraticCurveTo(x, y, x, y + ry);
}
function render$4(rect, _ref) {
  let {
    g,
    doFill,
    doStroke
  } = _ref;
  g.beginPath();
  if (rect.rx > 0 || rect.ry > 0) {
    quadraticRoundedRect(g, rect.x, rect.y, rect.width, rect.height, rect.rx, rect.ry);
  } else {
    g.rect(rect.x, rect.y, rect.width, rect.height);
  }
  if (doFill) {
    g.fill();
  }
  if (doStroke) {
    g.stroke();
  }
}

function render$3(circle, _ref) {
  let {
    g,
    doFill,
    doStroke
  } = _ref;
  g.beginPath();
  g.moveTo(circle.cx + circle.r, circle.cy);
  g.arc(circle.cx, circle.cy, circle.r, 0, Math.PI * 2, false);
  if (doFill) {
    g.fill();
  }
  if (doStroke) {
    g.stroke();
  }
}

function render$2(line, _ref) {
  let {
    g,
    doStroke
  } = _ref;
  g.beginPath();
  g.moveTo(line.x1, line.y1);
  g.lineTo(line.x2, line.y2);
  if (doStroke) {
    g.stroke();
  }
}

/* eslint no-misleading-character-class: 0 */
// Source: https://en.wikipedia.org/wiki/Bi-directional_text and http://www.unicode.org/Public/6.0.0/ucd/UnicodeData.txt
// 3 types of strong direction characters: L (strong left-to-right), R(strong right-to-left, Hebrew) and AL(strong right-to-left, Arabic language)
const rangesOfLChars = '[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u037D\u0386\u0388-\u03F5\u03F7-\u0482\u048A-\u0589\u0903-\u0939\u093B\u093D-\u0940\u0949-\u094C\u094E-\u0950\u0958-\u0961\u0964-\u097F\u0982-\u09B9\u09BD-\u09C0\u09C7-\u09CC\u09CE-\u09E1\u09E6-\u09F1\u09F4-\u09FA\u0A03-\u0A39\u0A3E-\u0A40\u0A59-\u0A6F\u0A72-\u0A74\u0A83-\u0AB9\u0ABD-\u0AC0\u0AC9-\u0ACC\u0AD0-\u0AE1\u0AE6-\u0AEF\u0B02-\u0B39\u0B3D-\u0B3E\u0B40\u0B47-\u0B4C\u0B57-\u0B61\u0B66-\u0B77\u0B83-\u0BBF\u0BC1-\u0BCC\u0BD0-\u0BF2\u0C01-\u0C3D\u0C41-\u0C44\u0C58-\u0C61\u0C66-\u0C6F\u0C7F-\u0CB9\u0CBD-\u0CCB\u0CD5-\u0CE1\u0CE6-\u0D40\u0D46-\u0D4C\u0D4E-\u0D61\u0D66-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0E30\u0E32-\u0E33\u0E40-\u0E46\u0E4F-\u0EB0\u0EB2-\u0EB3\u0EBD-\u0EC6\u0ED0-\u0F17\u0F1A-\u0F34\u0F36\u0F38\u0F3E-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C\u0FBE-\u0FC5\u0FC7-\u102C\u1031\u1038\u103B-\u103C\u103F-\u1057\u105A-\u105D\u1061-\u1070\u1075-\u1081\u1083-\u1084\u1087-\u108C\u108E-\u109C\u109E-\u135A\u1360-\u138F\u13A0-\u13F4\u1401-\u167F\u1681-\u169A\u16A0-\u1711\u1720-\u1731\u1735-\u1751\u1760-\u1770\u1780-\u17B6\u17BE-\u17C5\u17C7-\u17C8\u17D4-\u17DA\u17DC\u17E0-\u17E9\u1810-\u18A8\u18AA-\u191C\u1923-\u1926\u1929-\u1931\u1933-\u1938\u1946-\u19DA\u1A00-\u1A16\u1A19-\u1A55\u1A57\u1A61\u1A63-\u1A64\u1A6D-\u1A72\u1A80-\u1AAD\u1B04-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B6A\u1B74-\u1B7C\u1B82-\u1BA1\u1BA6-\u1BA7\u1BAA-\u1BE5\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2-\u1C2B\u1C34-\u1C35\u1C3B-\u1C7F\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1DBF\u1E00-\u1FBC\u1FBE\u1FC2-\u1FCC\u1FD0-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FFC\u200E\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E-\u214F\u2160-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF\u2C00-\u2CE4\u2CEB-\u2CEE\u2D00-\u2D70\u2D80-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u31BA\u31F0-\u321C\u3220-\u324F\u3260-\u327B\u327F-\u32B0\u32C0-\u32CB\u32D0-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5\u4E00-\uA48C\uA4D0-\uA60C\uA610-\uA66E\uA680-\uA6EF\uA6F2-\uA6F7\uA722-\uA787\uA789-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA824\uA827\uA830-\uA837\uA840-\uA873\uA880-\uA8C3\uA8CE-\uA8D9\uA8F2-\uA925\uA92E-\uA946\uA952-\uA97C\uA983-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uAA28\uAA2F-\uAA30\uAA33-\uAA34\uAA40-\uAA42\uAA44-\uAA4B\uAA4D-\uAAAF\uAAB1\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2-\uABE4\uABE6-\uABE7\uABE9-\uABEC\uABF0-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFDC]';
const rangesOfRChars = '[\u05BE\u05C0\u05C3\u05C6\u05D0-\u05F4\u07C0-\u07EA\u07F4-\u07F5\u07FA-\u0815\u081A\u0824\u0828\u0830-\u0858\u085E\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB4F]';
const rangesOfALChars = '[\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u070D\u0710\u0712-\u072F\u074D-\u07A5\u07B1\uFB50-\uFD3D\uFD50-\uFDFC\uFE70-\uFEFC]';
// let rangesOfNChars = '[\u0009-\u000D\u001C-\u0022\u0026-\u002A\u003B-\u0040\u005B-\u0060\u007B-\u007E\u0085\u00A1\u00A6-\u00A9\u00AB-\u00AC\u00AE-\u00AF\u00B4\u00B6-\u00B8\u00BB-\u00BF\u00D7\u00F7\u02B9-\u02BA\u02C2-\u02CF\u02D2-\u02DF\u02E5-\u02ED\u02EF-\u02FF\u0374-\u0375\u037E-\u0385\u0387\u03F6\u058A\u0606-\u0607\u060E-\u060F\u06DE\u06E9\u07F6-\u07F9\u0BF3-\u0BF8\u0BFA\u0C78-\u0C7E\u0F3A-\u0F3D\u1390-\u1399\u1400\u1680\u169B-\u169C\u17F0-\u180A\u180E\u1940-\u1945\u19DE-\u19FF\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD-\u200A\u2010-\u2029\u2035-\u2043\u2045-\u205F\u207C-\u207E\u208C-\u208E\u2100-\u2101\u2103-\u2106\u2108-\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u213A-\u213B\u2140-\u2144\u214A-\u214D\u2150-\u215F\u2189-\u2211\u2214-\u2335\u237B-\u2394\u2396-\u2487\u24EA-\u26AB\u26AD-\u27FF\u2900-\u2B59\u2CE5-\u2CEA\u2CF9-\u2CFF\u2E00-\u3004\u3008-\u3020\u3030\u3036-\u3037\u303D-\u303F\u309B-\u309C\u30A0\u30FB\u31C0-\u31E3\u321D-\u321E\u3250-\u325F\u327C-\u327E\u32B1-\u32BF\u32CC-\u32CF\u3377-\u337A\u33DE-\u33DF\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA60D-\uA60F\uA673\uA67E-\uA67F\uA700-\uA721\uA788\uA828-\uA82B\uA874-\uA877\uFD3E-\uFD3F\uFDFD\uFE10-\uFE19\uFE30-\uFE4F\uFE51\uFE54\uFE56-\uFE5E\uFE60-\uFE61\uFE64-\uFE68\uFE6B\uFF01-\uFF02\uFF06-\uFF0A\uFF1B-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE2-\uFFE4\uFFE8-\uFFFD]';
const rangesOfLRgExp = new RegExp(rangesOfLChars);
const rangesOfRRgExp = new RegExp(rangesOfRChars);
const rangesOfALRgExp = new RegExp(rangesOfALChars);
// let rangesOfNRgExp = new RegExp(rangesOfNChars);
// let lrm = String.fromCharCode(8206); // left-to-right marker
// let rlm = String.fromCharCode(8207); // right-to-left marker

function isLtrChar(c) {
  return rangesOfLRgExp.test(c);
}
function isRtlChar(c) {
  return rangesOfRRgExp.test(c) || rangesOfALRgExp.test(c);
}
function detectTextDirection(s) {
  let n = s ? s.length : 0,
    i,
    c;
  for (i = 0; i < n; i++) {
    c = s[i];
    if (isLtrChar(c)) {
      return 'ltr';
    }
    if (isRtlChar(c)) {
      return 'rtl';
    }
  }
  return 'ltr';
}
const textAnchorRTLMap = {
  start: 'end',
  end: 'start',
  center: 'center',
  middle: 'middle'
};

/* let flippedTextAnchor = true;
let detected = false;
export function detectRtlSvgSupport(ns, ownerDoc) {
  if (!detected) {
    const body = ownerDoc.body;
    if (body) {
      const rtlTestSVG = ownerDoc.createElementNS(ns, 'svg');
      const textNode = ownerDoc.createElementNS(ns, 'text');
      const group = ownerDoc.createElementNS(ns, 'g');

      rtlTestSVG.setAttribute('xmlns', ns);
      rtlTestSVG.setAttribute('style', 'position: absolute; width: 100px; height: 100px; top: -100px; left: 0px');

      textNode.setAttribute('text-anchor', 'start');
      textNode.setAttribute('direction', 'rtl');
      textNode.setAttribute('font-size', '14px');
      textNode.setAttribute('x', 50);
      textNode.setAttribute('y', 50);
      textNode.textContent = 'ثعبان';

      group.appendChild(textNode);
      rtlTestSVG.appendChild(group);
      body.appendChild(rtlTestSVG);

      flippedTextAnchor = textNode.getBoundingClientRect().left < 50;
      body.removeChild(rtlTestSVG);
    }
  }
  detected = true;
} */

function flipTextAnchor(value, dir) {
  if (dir === 'rtl') {
    return textAnchorRTLMap[value];
  }
  return value;
}

function render$1(t, _ref) {
  let {
    g,
    ellipsed,
    doStroke
  } = _ref;
  const text = ellipsed || ellipsText(t, measureText);
  g.font = [t['font-style'], t['font-weight'], t['font-size'], t['font-family']].filter(v => !!v).join(' ');
  const dir = detectTextDirection(t.text);
  if (g.canvas.dir !== dir) {
    g.canvas.dir = dir;
  }
  const textAnchor = t['text-anchor'] === 'middle' ? 'center' : t['text-anchor'];
  const textAlign = flipTextAnchor(textAnchor, g.canvas.dir);
  if (textAlign && g.textAlign !== textAlign) {
    g.textAlign = textAlign;
  }
  const bdy = baselineHeuristic(t);
  g.fillText(text, t.x + t.dx, t.y + t.dy + bdy);
  if (doStroke) {
    g.strokeText(text, t.x + t.dx, t.y + t.dy + bdy);
  }
}

function render(path, _ref) {
  let {
    g,
    doStroke,
    doFill
  } = _ref;
  const p = new Path2D(path.d);
  if (doFill) {
    g.fill(p);
  }
  if (doStroke) {
    g.stroke(p);
  }
}

register('rect', render$4);
register('circle', render$3);
register('line', render$2);
register('path', render);
register('text', render$1);
function rendererComponent$2(picasso) {
  picasso.renderer('canvas', renderer$2);
}

function diff(from, to) {
  const added = [];
  let items;
  const removed = [];
  const updatedNew = [];
  const updatedOld = [];
  let fromIds;
  let toIds;
  const idMapper = a => a.id;
  const nodeMapper = (node, i) => {
    let id;
    if (typeof node === 'object') {
      if ('id' in node) {
        id = node.id;
      } else {
        id = i;
      }
    } else {
      id = node;
    }
    return {
      content: node,
      id: "".concat(id, "__").concat(node.type || '')
    };
  };
  if (!from.isTree) {
    from = from.map(nodeMapper);
  }
  to = to.map(nodeMapper);
  fromIds = from.map(idMapper);
  toIds = to.map(idMapper);
  // TODO - handle duplicate values

  // added = to.filter( v => fromIds.indexOf( v.id ) < 0 );
  // updatedNew = to.filter( v => fromIds.indexOf( v.id ) >= 0 );
  // removed = from.filter( v => toIds.indexOf( v.id ) < 0 );
  // updatedOld = from.filter( v => toIds.indexOf( v.id ) >= 0 );

  for (let i = 0, len = to.length; i < len; i++) {
    const idx = fromIds.indexOf(to[i].id);
    if (idx === -1) {
      added.push(to[i]);
    } else {
      updatedNew.push(to[i]);
    }
  }
  for (let i = 0, len = from.length; i < len; i++) {
    const idx = toIds.indexOf(from[i].id);
    if (idx === -1) {
      removed.push(from[i]);
    } else {
      updatedOld.push(from[i]);
    }
  }
  for (let i = 0, len = added.length; i < len; i++) {
    if (added[i].content.children) {
      added[i].diff = diff([], added[i].content.children);
      added[i].children = added[i].diff.updatedNew.concat(added[i].diff.added);
      added[i].children.isTree = true;
    }
  }
  for (let i = 0, len = updatedNew.length; i < len; i++) {
    updatedNew[i].diff = diff(updatedOld[i].children || [], updatedNew[i].content.children || []);
    updatedNew[i].object = updatedOld[i].object;
    updatedNew[i].children = updatedNew[i].diff.items;
  }
  items = updatedNew.concat(added);
  added.isTree = true;
  removed.isTree = true;
  updatedNew.isTree = true;
  updatedOld.isTree = true;
  items.isTree = true;
  return {
    added,
    updatedNew,
    updatedOld,
    removed,
    items
  };
}
function createNodes(nodes, parent, create) {
  for (let i = 0, len = nodes.length; i < len; i++) {
    nodes[i].object = create(nodes[i].content.type, parent);
  }
}
function destroyNodes(nodes, destroy) {
  for (let i = 0, len = nodes.length; i < len; i++) {
    if (nodes[i].object !== null && typeof nodes[i].object !== 'undefined') {
      destroy(nodes[i].object);
      nodes[i].object = null;
    }
  }
}
function updateNodes(nodes, creator, maintainer, destroyer) {
  let item;
  for (let i = 0, len = nodes.length; i < len; i++) {
    item = nodes[i];
    if (item.object !== null && typeof item.object !== 'undefined') {
      maintainer(item.object, item.content);
      if (item.diff) {
        createNodes(item.diff.added, item.object, creator);
        destroyNodes(item.diff.removed, destroyer);
        updateNodes(item.diff.items, creator, maintainer, destroyer);
      }
    }
  }
}
function createTree(oldItems, newItems, root, creator, maintainer, destroyer) {
  const d = diff(oldItems, newItems);
  createNodes(d.added, root, creator);
  destroyNodes(d.removed, destroyer);
  updateNodes(d.items, creator, maintainer, destroyer);
  return d.items;
}

const svgNs = 'http://www.w3.org/2000/svg';
// const badValues = ['', NaN, 'NaN', undefined, null, false, true];

const creator = (type, parent) => {
  if (!type || typeof type !== 'string') {
    throw new Error("Invalid type: ".concat(type));
  }
  const el = parent.ownerDocument.createElementNS(svgNs, type === 'container' ? 'g' : type);
  parent.appendChild(el);
  return el;
};
const destroyer = el => {
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
};

// isValid - is a way to bring a more consistent rendering behaviour between SVG and canvas.
// Where SVG would treat NaN values as 0, canvas would simple not render anything.
const isValid = item => {
  switch (item.type) {
    case 'circle':
      return !isNaN(item.attrs.cx) && !isNaN(item.attrs.cy) && !isNaN(item.attrs.r);
    case 'line':
      return !isNaN(item.attrs.x1) && !isNaN(item.attrs.y1) && !isNaN(item.attrs.x2) && !isNaN(item.attrs.y2);
    case 'rect':
      return !isNaN(item.attrs.x) && !isNaN(item.attrs.y) && !isNaN(item.attrs.width) && !isNaN(item.attrs.height);
    case 'text':
      return !isNaN(item.attrs.x) && !isNaN(item.attrs.y);
    default:
      return true;
  }
};
const maintainer = (element, item) => {
  if (isValid(item)) {
    for (const attr in item.attrs) {
      if (attr === 'stroke' && item.strokeReference) {
        element.setAttribute('stroke', item.strokeReference);
      } else if (attr === 'fill' && item.fillReference) {
        element.setAttribute('fill', item.fillReference);
      } else if (attr === 'text') {
        element.setAttribute('style', 'white-space: pre');
        element.textContent = item.ellipsed || ellipsText(item.attrs, measureText);
        const dir = detectTextDirection(item.attrs.text);
        if (dir === 'rtl') {
          element.setAttribute('direction', 'rtl');
          element.setAttribute('dir', 'rtl');
          element.setAttribute('text-anchor', flipTextAnchor(element.getAttribute('text-anchor'), dir));
        }
      } else if (item.type === 'text' && (attr === 'dy' || attr === 'dominant-baseline')) {
        const dy = +element.getAttribute(attr) || 0;
        let val = 0;
        if (attr === 'dominant-baseline') {
          val = baselineHeuristic(item.attrs);
        } else {
          val = item.attrs[attr];
        }
        element.setAttribute('dy', val + dy);
      } else if (item.type === 'text' && attr === 'title' && item.attrs.title) {
        const t = element.ownerDocument.createElementNS(svgNs, 'title');
        t.textContent = item.attrs.title;
        element.appendChild(t);
      } else {
        element.setAttribute(attr, item.attrs[attr]);
      }
    }
    if (typeof item.data === 'string' || typeof item.data === 'number' || typeof item.data === 'boolean') {
      element.setAttribute('data', item.data);
    } else if (typeof item.data === 'object' && item.data !== null) {
      for (const d in item.data) {
        if (typeof item.data[d] === 'string' || typeof item.data[d] === 'number' || typeof item.data[d] === 'boolean') {
          element.setAttribute("data-".concat(d), item.data[d]);
        }
      }
    }
  }
};

class TreeItemRenderer {
  /**
   * Constructor
   * @private
   * @param  {TreeCreator} treeCreator - Function used to create the DOM tree..
   * @param  {SVGCreator} nodeCreator - Function used to create nodes.
   * @param  {SVGMaintainer} nodeMaintainer - Function used to update nodes.
   * @param  {SVGDestroyer} nodeDestroyer - Function used to destroy nodes.
   */
  constructor(treeCreator, nodeCreator, nodeMaintainer, nodeDestroyer) {
    this.create = treeCreator;
    this.nodeCreator = nodeCreator;
    this.nodeMaintainer = nodeMaintainer;
    this.nodeDestroyer = nodeDestroyer;
  }
  render(newItems, root) {
    return this.create([], newItems, root, this.nodeCreator, this.nodeMaintainer, this.nodeDestroyer);
  }
}
function tree() {
  return new TreeItemRenderer(createTree, creator, maintainer, destroyer);
}

/**
 * Create an SVGElement and attach to parent.
 * @private
 * @callback SVGCreator
 * @param {String} type - The type of element to create.
 * @param {SVGElement} parent - The parent element to append the new element to.
 * @return {SVGElement} The created element
 */

/**
 * Update the element with content from item.
 * @private
 * @callback SVGMaintainer
 * @param {SVGElement} el - The element to update
 * @param {Object} item - The object to use as input for the update
 */

/**
 * Detach element from its parent.
 * @private
 * @callback SVGDestroyer
 * @param {SVGElement} el - Element to destroy.
 */

/**
 * Create, update and destroy nodes.
 * @private
 * @callback TreeCreator
 * @param {Object[]} existing - The existing items in the tree.
 * @param {Object[]} active - The new items to create the tree from.
 * @param {SVGCreator} creator - Function used to create nodes.
 * @param {SVGMaintainer} maintainer - Function used to update nodes.
 * @param {SVGDestroyer} destroyer - Function used to destroy nodes.
 */

/* eslint import/prefer-default-export: 0 */

/**
 * Hash an object
 * Modified version of Java's HashCode function
 * Source: {@link http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/}
 * @ignore
 *
 * @param  {Object} item Item to hash
 * @return {String}      Unique hash id
 */
function hashObject(item) {
  let hash = 0;
  let i;
  let chr;
  let len;
  item = JSON.stringify(item);
  if (item.length === 0) {
    return hash;
  }
  for (i = 0, len = item.length; i < len; i++) {
    chr = item.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash &= hash; // Convert to 32bit integer
  }
  return hash;
}

function gradienter(bucket) {
  let hasher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : hashObject;
  let cache = {};
  let uid = Date.now();
  const p = {
    getOrCreateGradient() {
      let item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fill';
      let url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      let gradientHash = hasher(item[attr]);
      let gradientId = "picasso-gradient-".concat(uid, "-").concat(gradientHash);
      if (!cache[gradientHash]) {
        let {
          orientation,
          degree,
          stops = []
        } = item[attr];
        let gradient = {};
        if (degree === undefined) {
          degree = 90;
        }

        // Default to linear
        if (orientation === 'radial') {
          gradient.type = 'radialGradient';
        } else {
          gradient = degreesToPoints(degree);
          ['x1', 'x2', 'y1', 'y2'].forEach(c => {
            if (c in item[attr]) {
              gradient[c] = item[attr][c];
            }
          });
          gradient.type = 'linearGradient';
        }
        gradient.id = gradientId;
        gradient.children = stops.map(_ref => {
          let {
            offset,
            color,
            opacity
          } = _ref;
          return {
            type: 'stop',
            offset: "".concat(offset * 100, "%"),
            style: "stop-color:".concat(color, ";stop-opacity:").concat(typeof opacity !== 'undefined' ? opacity : 1)
          };
        });
        bucket.push(gradient);
        cache[gradientHash] = gradientId;
      }
      return "url('".concat(url, "#").concat(gradientId, "')");
    },
    onCreate(state) {
      let url = '';
      if (typeof window !== 'undefined') {
        url = window.location.href.split('#')[0];
      }
      const item = state.node;
      if (item.fill && typeof item.fill === 'object' && item.fill.type === 'gradient') {
        item.fillReference = p.getOrCreateGradient(item, 'fill', url);
      }
      if (item.stroke && typeof item.stroke === 'object' && item.stroke.type === 'gradient') {
        item.strokeReference = p.getOrCreateGradient(item, 'stroke', url);
      }
    },
    clear() {
      cache = {};
    }
  };
  return p;
}

function patternizer(bucket) {
  let hasher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : hashObject;
  let cache = {};
  let uid = Date.now();
  const p = {
    onCreate(state) {
      let inputs = {};
      if (state.node && typeof state.node.fill === 'object' && state.node.fill.type === 'pattern' && state.node.fill.shapes) {
        inputs.fill = state.node.fill;
      }
      if (state.node && typeof state.node.stroke === 'object' && state.node.stroke.type === 'pattern' && state.node.stroke.shapes) {
        inputs.stroke = state.node.stroke;
      }
      Object.keys(inputs).forEach(key => {
        let url = '';
        const input = inputs[key];
        const patternHash = hasher(input);
        const pnid = "picasso-pattern-".concat(uid, "-").concat(patternHash);
        if (typeof window !== 'undefined') {
          url = window.location.href.split('#')[0];
        }
        if (!cache[patternHash]) {
          const pn = {
            patternUnits: 'userSpaceOnUse',
            x: 0,
            y: 0,
            width: input.width,
            height: input.height,
            type: 'pattern',
            id: pnid,
            children: [],
            fill: input.fill
          };
          input.shapes.forEach(s => {
            pn.children.push(s);
          });
          bucket.push(pn);
          cache[patternHash] = true;
        }
        state.node["".concat(key, "Reference")] = "url('".concat(url, "#").concat(pnid, "')");
      });
    },
    clear() {
      cache = {};
    }
  };
  return p;
}

/**
 * Create a new svg renderer
 * @typedef {function} svgRendererFactory
 * @param {function} [treeFactory] - Node tree factory
 * @param {string} [ns] - Namespace definition
 * @param {function} [sceneFn] - Scene factory
 * @returns {Renderer} A svg renderer instance
 */
function renderer$1() {
  let treeFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tree;
  let ns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : svgNs;
  let sceneFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : scene;
  const tree$1 = treeFn();
  let el;
  let group;
  let hasChangedRect = false;
  let rect = createRendererBox();
  let scene$1;
  const settings = {
    transform: undefined,
    disableScreenReader: false
  };
  const svg = create();
  const defs = {
    type: 'defs',
    children: []
  };
  const patterns = patternizer(defs.children);
  const gradients = gradienter(defs.children);
  svg.element = () => el;
  svg.root = () => group;
  svg.settings = rendererSettings => {
    if (rendererSettings) {
      Object.keys(settings).forEach(key => {
        if (rendererSettings[key] !== undefined) {
          settings[key] = rendererSettings[key];
        }
      });
    }
    return settings;
  };
  svg.appendTo = element => {
    if (!el) {
      el = element.ownerDocument.createElementNS(ns, 'svg');
      el.style.position = 'absolute';
      el.style['-webkit-font-smoothing'] = 'antialiased';
      el.style['-moz-osx-font-smoothing'] = 'antialiased';
      el.style.pointerEvents = 'none';
      el.setAttribute('xmlns', ns);
      group = element.ownerDocument.createElementNS(ns, 'g');
      group.style.pointerEvents = 'auto';
      el.appendChild(group);
    }
    element.appendChild(el);
    return el;
  };
  svg.getScene = nodes => {
    const scaleX = rect.scaleRatio.x;
    const scaleY = rect.scaleRatio.y;
    const sceneContainer = {
      type: 'container',
      children: Array.isArray(nodes) ? [...nodes, defs] : nodes,
      transform: rect.edgeBleed.bool ? "translate(".concat(rect.edgeBleed.left * scaleX, ", ").concat(rect.edgeBleed.top * scaleY, ")") : ''
    };
    if (scaleX !== 1 || scaleY !== 1) {
      sceneContainer.transform += "scale(".concat(scaleX, ", ").concat(scaleY, ")");
    }
    return sceneFn({
      items: [sceneContainer],
      on: {
        create: [state => {
          state.node.fillReference = undefined;
          state.node.strokeReference = undefined;
        }, gradients.onCreate, patterns.onCreate, onLineBreak(svg.measureText), injectTextBoundsFn(svg)]
      }
    });
  };
  svg.render = nodes => {
    if (!el) {
      return false;
    }
    const transformation = typeof settings.transform === 'function' && settings.transform();
    if (transformation) {
      const {
        horizontalScaling,
        horizontalSkewing,
        verticalSkewing,
        verticalScaling,
        horizontalMoving,
        verticalMoving
      } = transformation;
      group.style.transform = "matrix(".concat(horizontalScaling, ", ").concat(horizontalSkewing, ", ").concat(verticalSkewing, ", ").concat(verticalScaling, ", ").concat(horizontalMoving, ", ").concat(verticalMoving, ")");
      return true;
    }
    group.style.transform = '';
    const disableScreenReader = settings.disableScreenReader;
    if (disableScreenReader) {
      el.setAttribute('aria-hidden', true);
    }
    if (hasChangedRect) {
      el.style.left = "".concat(rect.computedPhysical.x, "px");
      el.style.top = "".concat(rect.computedPhysical.y, "px");
      el.setAttribute('width', rect.computedPhysical.width);
      el.setAttribute('height', rect.computedPhysical.height);
    }
    gradients.clear();
    patterns.clear();
    defs.children.length = 0;
    const newScene = svg.getScene(nodes);
    const hasChangedScene = scene$1 ? !newScene.equals(scene$1) : true;
    const doRender = hasChangedRect || hasChangedScene;
    if (doRender) {
      svg.clear();
      tree$1.render(newScene.children, group);
    }
    hasChangedRect = false;
    scene$1 = newScene;
    return doRender;
  };
  svg.itemsAt = input => scene$1 ? scene$1.getItemsFrom(input) : [];
  svg.findShapes = selector => scene$1 ? scene$1.findShapes(selector) : [];
  svg.clear = () => {
    if (!group) {
      return svg;
    }
    scene$1 = null;
    const g = group.cloneNode(false);
    el.replaceChild(g, group);
    group = g;
    return svg;
  };
  svg.destroy = () => {
    // parentElement is not supported in IE11 for SVGElement.
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
    el = null;
    group = null;
  };
  svg.size = opts => {
    if (opts) {
      const newRect = createRendererBox(opts);
      if (JSON.stringify(rect) !== JSON.stringify(newRect)) {
        hasChangedRect = true;
        rect = newRect;
      }
    }
    return rect;
  };
  return svg;
}
function rendererComponent$1(picasso) {
  picasso.renderer('svg', renderer$1);
}

var n,l,u,t,r,o,f,c={},s=[],a=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function h(n,l){for(var u in l)n[u]=l[u];return n}function v(n){var l=n.parentNode;l&&l.removeChild(n);}function y(l,u,i){var t,r,o,f={};for(o in u)"key"==o?t=u[o]:"ref"==o?r=u[o]:f[o]=u[o];if(arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):i),"function"==typeof l&&null!=l.defaultProps)for(o in l.defaultProps)void 0===f[o]&&(f[o]=l.defaultProps[o]);return p$1(l,f,t,r,null)}function p$1(n,i,t,r,o){var f={type:n,props:i,key:t,ref:r,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==o?++u:o};return null==o&&null!=l.vnode&&l.vnode(f),f}function _(n){return n.children}function k(n,l){this.props=n,this.context=l;}function b(n,l){if(null==l)return n.__?b(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?b(n):null}function g(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return g(n)}}function m(n){(!n.__d&&(n.__d=!0)&&t.push(n)&&!w.__r++||r!==l.debounceRendering)&&((r=l.debounceRendering)||o)(w);}function w(){var n,l,u,i,r,o,e,c;for(t.sort(f);n=t.shift();)n.__d&&(l=t.length,i=void 0,r=void 0,e=(o=(u=n).__v).__e,(c=u.__P)&&(i=[],(r=h({},o)).__v=o.__v+1,L(c,o,r,u.__n,void 0!==c.ownerSVGElement,null!=o.__h?[e]:null,i,null==e?b(o):e,o.__h),M(i,o),o.__e!=e&&g(o)),t.length>l&&t.sort(f));w.__r=0;}function x(n,l,u,i,t,r,o,f,e,a){var h,v,y,d,k,g,m,w=i&&i.__k||s,x=w.length;for(u.__k=[],h=0;h<l.length;h++)if(null!=(d=u.__k[h]=null==(d=l[h])||"boolean"==typeof d||"function"==typeof d?null:"string"==typeof d||"number"==typeof d||"bigint"==typeof d?p$1(null,d,null,null,d):Array.isArray(d)?p$1(_,{children:d},null,null,null):d.__b>0?p$1(d.type,d.props,d.key,d.ref?d.ref:null,d.__v):d)){if(d.__=u,d.__b=u.__b+1,null===(y=w[h])||y&&d.key==y.key&&d.type===y.type)w[h]=void 0;else for(v=0;v<x;v++){if((y=w[v])&&d.key==y.key&&d.type===y.type){w[v]=void 0;break}y=null;}L(n,d,y=y||c,t,r,o,f,e,a),k=d.__e,(v=d.ref)&&y.ref!=v&&(m||(m=[]),y.ref&&m.push(y.ref,null,d),m.push(v,d.__c||k,d)),null!=k?(null==g&&(g=k),"function"==typeof d.type&&d.__k===y.__k?d.__d=e=A(d,e,n):e=C(n,d,y,w,k,e),"function"==typeof u.type&&(u.__d=e)):e&&y.__e==e&&e.parentNode!=n&&(e=b(y));}for(u.__e=g,h=x;h--;)null!=w[h]&&("function"==typeof u.type&&null!=w[h].__e&&w[h].__e==u.__d&&(u.__d=$(i).nextSibling),S(w[h],w[h]));if(m)for(h=0;h<m.length;h++)O(m[h],m[++h],m[++h]);}function A(n,l,u){for(var i,t=n.__k,r=0;t&&r<t.length;r++)(i=t[r])&&(i.__=n,l="function"==typeof i.type?A(i,l,u):C(u,i,i,t,i.__e,l));return l}function C(n,l,u,i,t,r){var o,f,e;if(void 0!==l.__d)o=l.__d,l.__d=void 0;else if(null==u||t!=r||null==t.parentNode)n:if(null==r||r.parentNode!==n)n.appendChild(t),o=null;else {for(f=r,e=0;(f=f.nextSibling)&&e<i.length;e+=1)if(f==t)break n;n.insertBefore(t,r),o=r;}return void 0!==o?o:t.nextSibling}function $(n){var l,u,i;if(null==n.type||"string"==typeof n.type)return n.__e;if(n.__k)for(l=n.__k.length-1;l>=0;l--)if((u=n.__k[l])&&(i=$(u)))return i;return null}function H(n,l,u,i,t){var r;for(r in u)"children"===r||"key"===r||r in l||T(n,r,null,u[r],i);for(r in l)t&&"function"!=typeof l[r]||"children"===r||"key"===r||"value"===r||"checked"===r||u[r]===l[r]||T(n,r,l[r],u[r],i);}function I(n,l,u){"-"===l[0]?n.setProperty(l,null==u?"":u):n[l]=null==u?"":"number"!=typeof u||a.test(l)?u:u+"px";}function T(n,l,u,i,t){var r;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else {if("string"==typeof i&&(n.style.cssText=i=""),i)for(l in i)u&&l in u||I(n.style,l,"");if(u)for(l in u)i&&u[l]===i[l]||I(n.style,l,u[l]);}else if("o"===l[0]&&"n"===l[1])r=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+r]=u,u?i||n.addEventListener(l,r?z:j,r):n.removeEventListener(l,r?z:j,r);else if("dangerouslySetInnerHTML"!==l){if(t)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!==l&&"height"!==l&&"href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null==u||!1===u&&"-"!==l[4]?n.removeAttribute(l):n.setAttribute(l,u));}}function j(n){return this.l[n.type+!1](l.event?l.event(n):n)}function z(n){return this.l[n.type+!0](l.event?l.event(n):n)}function L(n,u,i,t,r,o,f,e,c){var s,a,v,y,p,d,b,g,m,w,A,P,C,$,H,I=u.type;if(void 0!==u.constructor)return null;null!=i.__h&&(c=i.__h,e=u.__e=i.__e,u.__h=null,o=[e]),(s=l.__b)&&s(u);try{n:if("function"==typeof I){if(g=u.props,m=(s=I.contextType)&&t[s.__c],w=s?m?m.props.value:s.__:t,i.__c?b=(a=u.__c=i.__c).__=a.__E:("prototype"in I&&I.prototype.render?u.__c=a=new I(g,w):(u.__c=a=new k(g,w),a.constructor=I,a.render=q),m&&m.sub(a),a.props=g,a.state||(a.state={}),a.context=w,a.__n=t,v=a.__d=!0,a.__h=[],a._sb=[]),null==a.__s&&(a.__s=a.state),null!=I.getDerivedStateFromProps&&(a.__s==a.state&&(a.__s=h({},a.__s)),h(a.__s,I.getDerivedStateFromProps(g,a.__s))),y=a.props,p=a.state,a.__v=u,v)null==I.getDerivedStateFromProps&&null!=a.componentWillMount&&a.componentWillMount(),null!=a.componentDidMount&&a.__h.push(a.componentDidMount);else {if(null==I.getDerivedStateFromProps&&g!==y&&null!=a.componentWillReceiveProps&&a.componentWillReceiveProps(g,w),!a.__e&&null!=a.shouldComponentUpdate&&!1===a.shouldComponentUpdate(g,a.__s,w)||u.__v===i.__v){for(u.__v!==i.__v&&(a.props=g,a.state=a.__s,a.__d=!1),a.__e=!1,u.__e=i.__e,u.__k=i.__k,u.__k.forEach(function(n){n&&(n.__=u);}),A=0;A<a._sb.length;A++)a.__h.push(a._sb[A]);a._sb=[],a.__h.length&&f.push(a);break n}null!=a.componentWillUpdate&&a.componentWillUpdate(g,a.__s,w),null!=a.componentDidUpdate&&a.__h.push(function(){a.componentDidUpdate(y,p,d);});}if(a.context=w,a.props=g,a.__P=n,P=l.__r,C=0,"prototype"in I&&I.prototype.render){for(a.state=a.__s,a.__d=!1,P&&P(u),s=a.render(a.props,a.state,a.context),$=0;$<a._sb.length;$++)a.__h.push(a._sb[$]);a._sb=[];}else do{a.__d=!1,P&&P(u),s=a.render(a.props,a.state,a.context),a.state=a.__s;}while(a.__d&&++C<25);a.state=a.__s,null!=a.getChildContext&&(t=h(h({},t),a.getChildContext())),v||null==a.getSnapshotBeforeUpdate||(d=a.getSnapshotBeforeUpdate(y,p)),H=null!=s&&s.type===_&&null==s.key?s.props.children:s,x(n,Array.isArray(H)?H:[H],u,i,t,r,o,f,e,c),a.base=u.__e,u.__h=null,a.__h.length&&f.push(a),b&&(a.__E=a.__=null),a.__e=!1;}else null==o&&u.__v===i.__v?(u.__k=i.__k,u.__e=i.__e):u.__e=N(i.__e,u,i,t,r,o,f,c);(s=l.diffed)&&s(u);}catch(n){u.__v=null,(c||null!=o)&&(u.__e=e,u.__h=!!c,o[o.indexOf(e)]=null),l.__e(n,u,i);}}function M(n,u){l.__c&&l.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u);});}catch(n){l.__e(n,u.__v);}});}function N(l,u,i,t,r,o,f,e){var s,a,h,y=i.props,p=u.props,d=u.type,_=0;if("svg"===d&&(r=!0),null!=o)for(;_<o.length;_++)if((s=o[_])&&"setAttribute"in s==!!d&&(d?s.localName===d:3===s.nodeType)){l=s,o[_]=null;break}if(null==l){if(null===d)return document.createTextNode(p);l=r?document.createElementNS("http://www.w3.org/2000/svg",d):document.createElement(d,p.is&&p),o=null,e=!1;}if(null===d)y===p||e&&l.data===p||(l.data=p);else {if(o=o&&n.call(l.childNodes),a=(y=i.props||c).dangerouslySetInnerHTML,h=p.dangerouslySetInnerHTML,!e){if(null!=o)for(y={},_=0;_<l.attributes.length;_++)y[l.attributes[_].name]=l.attributes[_].value;(h||a)&&(h&&(a&&h.__html==a.__html||h.__html===l.innerHTML)||(l.innerHTML=h&&h.__html||""));}if(H(l,p,y,r,e),h)u.__k=[];else if(_=u.props.children,x(l,Array.isArray(_)?_:[_],u,i,t,r&&"foreignObject"!==d,o,f,o?o[0]:i.__k&&b(i,0),e),null!=o)for(_=o.length;_--;)null!=o[_]&&v(o[_]);e||("value"in p&&void 0!==(_=p.value)&&(_!==l.value||"progress"===d&&!_||"option"===d&&_!==y.value)&&T(l,"value",_,y.value,!1),"checked"in p&&void 0!==(_=p.checked)&&_!==l.checked&&T(l,"checked",_,y.checked,!1));}return l}function O(n,u,i){try{"function"==typeof n?n(u):n.current=u;}catch(n){l.__e(n,i);}}function S(n,u,i){var t,r;if(l.unmount&&l.unmount(n),(t=n.ref)&&(t.current&&t.current!==n.__e||O(t,null,u)),null!=(t=n.__c)){if(t.componentWillUnmount)try{t.componentWillUnmount();}catch(n){l.__e(n,u);}t.base=t.__P=null,n.__c=void 0;}if(t=n.__k)for(r=0;r<t.length;r++)t[r]&&S(t[r],u,i||"function"!=typeof n.type);i||null==n.__e||v(n.__e),n.__=n.__e=n.__d=void 0;}function q(n,l,u){return this.constructor(n,u)}function B(u,i,t){var r,o,f;l.__&&l.__(u,i),o=(r="function"==typeof t)?null:t&&t.__k||i.__k,f=[],L(i,u=(!r&&t||i).__k=y(_,null,[u]),o||c,c,void 0!==i.ownerSVGElement,!r&&t?[t]:o?null:i.firstChild?n.call(i.childNodes):null,f,!r&&t?t:o?o.__e:i.firstChild,r),M(f,u);}n=s.slice,l={__e:function(n,l,u,i){for(var t,r,o;l=l.__;)if((t=l.__c)&&!t.__)try{if((r=t.constructor)&&null!=r.getDerivedStateFromError&&(t.setState(r.getDerivedStateFromError(n)),o=t.__d),null!=t.componentDidCatch&&(t.componentDidCatch(n,i||{}),o=t.__d),o)return t.__E=t}catch(l){n=l;}throw n}},u=0,k.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=h({},this.state),"function"==typeof n&&(n=n(h({},u),this.props)),n&&h(u,n),null!=n&&this.__v&&(l&&this._sb.push(l),m(this));},k.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),m(this));},k.prototype.render=_,t=[],o="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,f=function(n,l){return n.__v.__b-l.__v.__b},w.__r=0;

function renderer() {
  let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    createElement = document.createElement.bind(document)
  } = opts;
  let el;
  let rect = createRendererBox();
  let dNode;
  const settings = {
    transform: undefined,
    disableScreenReader: false
  };
  const dom = create();
  dom.element = () => el;
  dom.root = () => el;
  dom.settings = rendererSettings => {
    if (rendererSettings) {
      Object.keys(settings).forEach(key => {
        if (rendererSettings[key] !== undefined) {
          settings[key] = rendererSettings[key];
        }
      });
    }
    return settings;
  };
  dom.appendTo = element => {
    if (!el) {
      el = createElement('div');
      el.style.position = 'absolute';
      el.style['-webkit-font-smoothing'] = 'antialiased';
      el.style['-moz-osx-font-smoothing'] = 'antialiased';
      el.style.pointerEvents = 'none';
    }
    element.appendChild(el);
    return el;
  };
  dom.render = nodes => {
    if (!el) {
      return false;
    }
    const transformation = typeof settings.transform === 'function' && settings.transform();
    if (transformation) {
      const {
        horizontalScaling,
        horizontalSkewing,
        verticalSkewing,
        verticalScaling,
        horizontalMoving,
        verticalMoving
      } = transformation;
      el.style.transform = "matrix(".concat(horizontalScaling, ", ").concat(horizontalSkewing, ", ").concat(verticalSkewing, ", ").concat(verticalScaling, ", ").concat(horizontalMoving, ", ").concat(verticalMoving, ")");
      return true;
    }
    el.style.transform = '';
    const disableScreenReader = settings.disableScreenReader;
    if (disableScreenReader) {
      el.setAttribute('aria-hidden', true);
    }
    el.style.left = "".concat(rect.computedPhysical.x, "px");
    el.style.top = "".concat(rect.computedPhysical.y, "px");
    el.style.width = "".concat(rect.computedPhysical.width, "px");
    el.style.height = "".concat(rect.computedPhysical.height, "px");
    let vNode;
    if (Array.isArray(nodes)) {
      vNode = y("div", null, nodes);
    } else {
      vNode = nodes;
    }
    dNode = B(vNode, el, dNode);
    return true;
  };
  dom.renderArgs = [y]; // Arguments to render functions using the DOM renderer

  dom.clear = () => {
    if (el) {
      let first = el.firstChild;
      while (first) {
        el.removeChild(first);
        first = el.firstChild;
      }
      dNode = null;
    }
    return dom;
  };
  dom.destroy = () => {
    if (el && el.parentElement) {
      el.parentElement.removeChild(el);
    }
    el = null;
    dNode = null;
  };
  dom.size = inner => {
    if (inner) {
      rect = createRendererBox(inner);
    }
    return rect;
  };
  return dom;
}

function rendererComponent(picasso) {
  picasso.renderer('dom', renderer);
}

var renderers = [rendererComponent$1, rendererComponent$2, rendererComponent];

var scales = [];

const LOG_LEVEL = {
  OFF: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4
};
const loggerFn = function () {
  let {
    level = LOG_LEVEL.OFF,
    pipe = console
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let currentlevel = level;
  const LOG_FN = {
    [LOG_LEVEL.OFF]: () => {},
    [LOG_LEVEL.ERROR]: function () {
      return pipe.error(...arguments);
    },
    [LOG_LEVEL.WARN]: function () {
      return pipe.warn(...arguments);
    },
    [LOG_LEVEL.INFO]: function () {
      return pipe.info(...arguments);
    },
    [LOG_LEVEL.DEBUG]: function () {
      return pipe.log(...arguments);
    }
  };
  const log = function (lev) {
    if (!lev || currentlevel < lev) {
      return;
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    (LOG_FN[lev] || LOG_FN[LOG_LEVEL.DEBUG])(...args);
  };

  /**
   * @typedef {object} logger
   * @private
   */

  return /** @lends logger */{
    /**
     * Log a message
     * @param {number} lev - The log level
     * @param {...any} args
     * @kind function
     */
    log,
    /**
     * Log an error message
     * @param {...any} args
     */
    error: function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return log(LOG_LEVEL.ERROR, ...args);
    },
    /**
     * Log a warning message
     * @param {...any} args
     */
    warn: function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return log(LOG_LEVEL.WARN, ...args);
    },
    /**
     * Log an info message
     * @param {...any} args
     */
    info: function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return log(LOG_LEVEL.INFO, ...args);
    },
    /**
     * Log a debug message
     * @param {...any} args
     */
    debug: function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return log(LOG_LEVEL.DEBUG, ...args);
    },
    /**
     * Set the current log level
     * @param {number} lev - The log level
     */
    level: lev => {
      if (typeof lev === 'number') {
        currentlevel = lev;
      }
      return currentlevel;
    },
    LOG_LEVEL
  };
};

const palettes = [{
  key: 'categorical',
  colors: [['#a54343', '#d76c6c', '#ec983d', '#ecc43d', '#f9ec86', '#cbe989', '#70ba6e', '#578b60', '#79d69f', '#26a0a7', '#138185', '#65d3da'] // breeze colors
  ]
}, {
  key: 'diverging',
  colors: [['#3d52a1', '#3a89c9', '#77b7e5', '#b4ddf7', '#e6f5fe', '#ffe3aa', '#f9bd7e', '#ed875e', '#d24d3e', '#ae1c3e']]
}, {
  key: 'sequential',
  colors: [['rgb(180,221,212)', 'rgb(34, 83, 90)']]
}];

/* eslint quote-props: 0 */
const style = {
  // -- FOUNDATION --
  // fonts
  '$font-family': "'Source Sans Pro', Arial, sans-serif",
  '$font-size': '12px',
  '$line-height': '16px',
  '$font-size--l': '16px',
  '$font-weight': 'normal',
  // base grays
  '$gray-100': '#ffffff',
  '$gray-98': '#f9f9f9',
  '$gray-95': '#f2f2f2',
  '$gray-90': '#e6e6e6',
  '$gray-35': '#595959',
  '$gray-30': '#4d4d4d',
  '$gray-25': '#404040',
  '$gray-20': '#333333',
  // borders
  '$border-95': 'rgba(255, 255, 255, 0.05)',
  '$border-90': 'rgba(255, 255, 255, 0.1)',
  '$border-80': 'rgba(255, 255, 255, 0.2)',
  '$border-20': 'rgba(0, 0, 0, 0.2)',
  '$border-10': 'rgba(0, 0, 0, 0.1)',
  '$border-5': 'rgba(0, 0, 0, 0.05)',
  // primary colors
  '$primary-blue': '#3F8AB3',
  '$primary-green': '#6CB33F',
  '$primary-red': '#DC423F',
  '$primary-orange': '#EF960F',
  // spacing
  '$spacing--s': 4,
  $spacing: 8,
  '$spacing--l': 12,
  // -------------------------

  // -- ALIASES --
  '$font-color': '$gray-35',
  '$font-color--inverted': '$gray-90',
  '$guide-color': '$gray-90',
  '$guide-color--inverted': '$gray-35',
  $border: '$border-80',
  '$border--inverted': '$border-10',
  // -------------------------

  // -- MIXINS --
  // data points
  $shape: {
    // data shape
    fill: '$primary-blue',
    strokeWidth: 1,
    stroke: '$border'
  },
  '$shape-outline': {
    // data shape which usually does not have a fill, e.g. the line in a linechart
    stroke: '$primary-blue',
    strokeWidth: 2
  },
  '$shape-guide': {
    // lines that somehow belongs to a data shape, e.g. whiskers in a boxplot
    stroke: '$guide-color',
    strokeWidth: 1
  },
  '$shape-guide--inverted': {
    '@extend': '$shape-guide',
    stroke: '$guide-color--inverted'
  },
  $label: {
    fontSize: '$font-size',
    fontFamily: '$font-family',
    fill: '$font-color'
  },
  '$label--inverted': {
    $extend: '$label',
    fill: '$font-color--inverted'
  },
  // user interface
  '$label-overlay': {
    // e.g. selection range bubble
    fontSize: '$font-size--l',
    fontFamily: '$font-family',
    fill: '$gray-100',
    // background fill
    color: '$font-color',
    stroke: '$guide-color--inverted',
    strokeWidth: 1,
    borderRadius: 4
  },
  $title: {
    '@extend': '$label',
    fontSize: '$font-size--l',
    fontWeight: '$font-weight',
    stroke: '$guide-color--inverted',
    strokeWidth: 0
  },
  '$guide-line': {
    strokeWidth: 1,
    stroke: '$guide-color'
  },
  '$guide-line--minor': {
    strokeWidth: 1,
    stroke: '$gray-95' // needs alias
  },
  '$padding--s': {
    left: '$spacing--s',
    right: '$spacing--s',
    top: '$spacing--s',
    bottom: '$spacing--s'
  },
  $padding: {
    left: '$spacing',
    right: '$spacing',
    top: '$spacing',
    bottom: '$spacing'
  },
  '$selection-area-target': {
    fill: '$primary-green',
    strokeWidth: 0,
    opacity: 0.2
  }
};

function usePlugin(plugin) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let api = arguments.length > 2 ? arguments[2] : undefined;
  plugin(api, options);
}
function pic() {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let registries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const logger = loggerFn(config.logger);

  /**
   * @lends picassojs
   */
  const regis = {
    // -- registries --
    /**
     * Component registry
     * @type {registry}
     */
    component: registryFactory(registries.component, 'component', logger),
    /**
     * Data registry
     * @type {registry}
     */
    data: registryFactory(registries.data, 'data', logger),
    /**
     * Formatter registry
     * @type {registry}
     */
    formatter: registryFactory(registries.formatter, 'formatter', logger),
    /**
     * Interaction registry
     * @type {registry}
     */
    interaction: registryFactory(registries.interaction, 'interaction', logger),
    /**
     * Renderer registry
     * @type {registry}
     * @example
     * const svgFactory = picassojs.renderer('svg');
     * const svgRenderer = svgFactory();
     */
    renderer: rendererRegistry(registries.renderer),
    /**
     * Scale registry
     * @type {registry}
     */
    scale: registryFactory(registries.scale, 'scale', logger),
    /**
     * Symbol registry
     * @type {registry}
     * @private
     */
    symbol: registryFactory(registries.symbol, 'symbol', logger),
    // -- misc --
    /**
     * log some some stuff
     * @type {logger}
     * @private
     */
    logger
  };
  if (config.renderer && config.renderer.prio) {
    regis.renderer.default(config.renderer.prio[0]);
  }

  /**
   * picasso.js entry point
   * @entry
   * @alias picassojs
   * @param {object=} cfg
   * @param {object=} cfg.renderer
   * @param {Array<string>} cfg.renderer.prio
   * @param {object=} cfg.logger
   * @param {0|1|2|3|4} cfg.logger.level
   * @param {object=} cfg.style
   * @param {Array<object>=} cfg.palettes
   * @returns {picassojs}
   * @example
   * import picasso from 'picasso.js';
   *
   * const configuredPicasso = picasso({ renderer: { prio: ['canvas'] } }) // All components will render using the canvas renderer
   */
  function picassojs() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let cc = {
      palettes: config.palettes.concat(cfg.palettes || []),
      style: extend$1({}, config.style, cfg.style),
      logger: cfg.logger || config.logger,
      renderer: cfg.renderer || config.renderer
    };
    return pic(cc, regis);
  }

  /**
   * @typedef {object} Registries
   * @property {registry} component Component registry
   * @property {registry} data Data registry
   * @property {registry} formatter Formatter registry
   * @property {registry} interaction Interaction registry
   * @property {registry} renderer Renderer registry
   * @property {registry} scale Scale registry
   */

  /**
   * Callback function to register a plugin
   * @callback plugin
   * @param {Registries} registries
   * @param {object} options
   */

  /**
   * Plugin registry
   * @param {plugin} plugin
   * @param {object} [options]
   */
  picassojs.use = function (plugin) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return usePlugin(plugin, options, regis);
  };

  /**
   * @param {ChartDefinition} definition
   * @returns {Chart}
   * @example
   * picasso.chart({
    element: document.querySelector('#container'), // This is the element to render the chart in
    data: [
      {
        type: 'matrix',
        data: [
          ['Month', 'Sales', 'Margin'],
          ['Jan', 1106, 7],
          ['Feb', 5444, 53],
          ['Mar', 147, 64],
          ['Apr', 7499, 47],
          ['May', 430, 62],
          ['June', 9735, 13],
          ['July', 5832, 13],
          ['Aug', 7435, 15],
          ['Sep', 3467, 35],
          ['Oct', 3554, 78],
          ['Nov', 5633, 23],
          ['Dec', 6354, 63],
        ],
      },
    ],
    settings: {
      scales: {
        x: { data: { field: 'Margin' } },
        y: { data: { field: 'Sales' } },
      },
      components: [
        {
          // specify how to render the chart
          type: 'axis',
          scale: 'y',
          layout: {
            dock: 'left',
          },
        },
        {
          type: 'axis',
          scale: 'x',
          layout: {
            dock: 'bottom',
          },
        },
        {
          type: 'point',
          data: {
            extract: {
              field: 'Month',
              props: {
                x: { field: 'Margin' },
                y: { field: 'Sales' },
              },
            },
          },
          settings: {
            x: { scale: 'x' },
            y: { scale: 'y' },
            size: function () {
              return Math.random();
            },
          },
        },
      ],
    },
  });
   */
  picassojs.chart = definition => chartFn(definition, {
    registries: regis,
    logger,
    style: config.style,
    palettes: config.palettes
  });
  picassojs.config = () => config;
  Object.keys(regis).forEach(key => {
    picassojs[key] = regis[key];
  });

  /**
   * picasso.js version
   * @type {string}
   */
  picassojs.version = about.version;
  return picassojs;
}
const p = pic({
  renderer: {
    prio: ['svg', 'canvas']
  },
  logger: {
    level: 0
  },
  style,
  palettes
}, {
  component: componentRegistry,
  data: dataRegistry,
  formatter: formatterRegistry,
  interaction: reg$3,
  renderer: rendererRegistry(),
  scale: scaleRegistry,
  symbol: parentReg
});
components.forEach(p.use);
renderers.forEach(p.use);
scales.forEach(p.use);

export { p as default };
//# sourceMappingURL=picasso.esm.js.map
